module.exports = [
	"A yellow dressinggown, ungirdled, was sustained gently behind him on the mild morning air.",
	"He held the bowl aloft and intoned: Introibo ad altare Dei.",
	"Halted, he peered down the dark winding stairs and called out coarsely: Come up, Kinch!",
	"Come up, you fearful jesuit!",
	"Solemnly he came forward and mounted the round gunrest.",
	"He faced about and blessed gravely thrice the tower, the surrounding land and the awaking mountains.",
	"Buck Mulligan peeped an instant under the mirror and then covered the bowl smartly.",
	"Back to barracks!",
	"he said sternly.",
	"Slow music, please.",
	"Shut your eyes, gents.",
	"One moment.",
	"A little trouble about those white corpuscles.",
	"Silence, all.",
	"Chrysostomos.",
	"Two strong shrill whistles answered through the calm.",
	"Thanks, old chap, he cried briskly.",
	"That will do nicely.",
	"Switch off the current, will you?",
	"The plump shadowed face and sullen oval jowl recalled a prelate, patron of arts in the middle ages.",
	"A pleasant smile broke quietly over his lips.",
	"The mockery of it!",
	"he said gaily.",
	"Your absurd name, an ancient Greek!",
	"He pointed his finger in friendly jest and went over to the parapet, laughing to himself.",
	"Buck Mulligan’s gay voice went on.",
	"My name is absurd too: Malachi Mulligan, two dactyls.",
	"But it has a Hellenic ring, hasn’t it?",
	"Tripping and sunny like the buck himself.",
	"We must go to Athens.",
	"Will you come if I can get the aunt to fork out twenty quid?",
	"He laid the brush aside and, laughing with delight, cried: Will he come?",
	"The jejune jesuit!",
	"Ceasing, he began to shave with care.",
	"Tell me, Mulligan, Stephen said quietly.",
	"Yes, my love?",
	"How long is Haines going to stay in this tower?",
	"Buck Mulligan showed a shaven cheek over his right shoulder.",
	"God, isn’t he dreadful?",
	"he said frankly.",
	"A ponderous Saxon.",
	"He thinks you’re not a gentleman.",
	"God, these bloody English!",
	"Bursting with money and indigestion.",
	"Because he comes from Oxford.",
	"You know, Dedalus, you have the real Oxford manner.",
	"He can’t make you out.",
	"O, my name for you is the best: Kinch, the knife-blade.",
	"He shaved warily over his chin.",
	"He was raving all night about a black panther, Stephen said.",
	"Where is his guncase?",
	"A woful lunatic!",
	"Mulligan said.",
	"Were you in a funk?",
	"I was, Stephen said with energy and growing fear.",
	"You saved men from drowning.",
	"I’m not a hero, however.",
	"If he stays on here I am off.",
	"Buck Mulligan frowned at the lather on his razorblade.",
	"He hopped down from his perch and began to search his trouser pockets hastily.",
	"Scutter!",
	"he cried thickly.",
	"Stephen suffered him to pull out and hold up on show by its corner a dirty crumpled handkerchief.",
	"Buck Mulligan wiped the razorblade neatly.",
	"Then, gazing over the handkerchief, he said: The bard’s noserag!",
	"A new art colour for our Irish poets: snotgreen.",
	"You can almost taste it, can’t you?",
	"He mounted to the parapet again and gazed out over Dublin bay, his fair oakpale hair stirring slightly.",
	"God!",
	"he said quietly.",
	"Isn’t the sea what Algy calls it: a great sweet mother?",
	"The snotgreen sea.",
	"The scrotumtightening sea.",
	"Epi oinopa ponton.",
	"Ah, Dedalus, the Greeks!",
	"I must teach you.",
	"You must read them in the original.",
	"Thalatta!",
	"Thalatta!",
	"She is our great sweet mother.",
	"Come and look.",
	"Stephen stood up and went over to the parapet.",
	"Leaning on it he looked down on the water and on the mailboat clearing the harbourmouth of Kingstown.",
	"Our mighty mother!",
	"Buck Mulligan said.",
	"He turned abruptly his grey searching eyes from the sea to Stephen’s face.",
	"The aunt thinks you killed your mother, he said.",
	"That’s why she won’t let me have anything to do with you.",
	"Someone killed her, Stephen said gloomily.",
	"You could have knelt down, damn it, Kinch, when your dying mother asked you, Buck Mulligan said.",
	"I’m hyperborean as much as you.",
	"But to think of your mother begging you with her last breath to kneel down and pray for her.",
	"And you refused.",
	"There is something sinister in you....",
	"He broke off and lathered again lightly his farther cheek.",
	"A tolerant smile curled his lips.",
	"But a lovely mummer!",
	"he murmured to himself.",
	"Kinch, the loveliest mummer of them all!",
	"He shaved evenly and with care, in silence, seriously.",
	"Pain, that was not yet the pain of love, fretted his heart.",
	"The ring of bay and skyline held a dull green mass of liquid.",
	"Buck Mulligan wiped again his razorblade.",
	"Ah, poor dogsbody!",
	"he said in a kind voice.",
	"I must give you a shirt and a few noserags.",
	"How are the secondhand breeks?",
	"They fit well enough, Stephen answered.",
	"Buck Mulligan attacked the hollow beneath his underlip.",
	"The mockery of it, he said contentedly.",
	"Secondleg they should be.",
	"God knows what poxy bowsy left them off.",
	"I have a lovely pair with a hair stripe, grey.",
	"You’ll look spiffing in them.",
	"I’m not joking, Kinch.",
	"You look damn well when you’re dressed.",
	"Thanks, Stephen said.",
	"I can’t wear them if they are grey.",
	"He can’t wear them, Buck Mulligan told his face in the mirror.",
	"Etiquette is etiquette.",
	"He kills his mother but he can’t wear grey trousers.",
	"He folded his razor neatly and with stroking palps of fingers felt the smooth skin.",
	"Stephen turned his gaze from the sea and to the plump face with its smokeblue mobile eyes.",
	"General paralysis of the insane!",
	"His curling shaven lips laughed and the edges of his white glittering teeth.",
	"Laughter seized all his strong wellknit trunk.",
	"Look at yourself, he said, you dreadful bard!",
	"Stephen bent forward and peered at the mirror held out to him, cleft by a crooked crack.",
	"Hair on end.",
	"As he and others see me.",
	"Who chose this face for me?",
	"This dogsbody to rid of vermin.",
	"It asks me too.",
	"I pinched it out of the skivvy’s room, Buck Mulligan said.",
	"It does her all right.",
	"The aunt always keeps plainlooking servants for Malachi.",
	"Lead him not into temptation.",
	"And her name is Ursula.",
	"Laughing again, he brought the mirror away from Stephen’s peering eyes.",
	"The rage of Caliban at not seeing his face in a mirror, he said.",
	"If Wilde were only alive to see you!",
	"Drawing back and pointing, Stephen said with bitterness: It is a symbol of Irish art.",
	"The cracked lookingglass of a servant.",
	"It’s not fair to tease you like that, Kinch, is it?",
	"he said kindly.",
	"God knows you have more spirit than any of them.",
	"Parried again.",
	"He fears the lancet of my art as I fear that of his.",
	"The cold steel pen.",
	"Cracked lookingglass of a servant!",
	"Tell that to the oxy chap downstairs and touch him for a guinea.",
	"He’s stinking with money and thinks you’re not a gentleman.",
	"His old fellow made his tin by selling jalap to Zulus or some bloody swindle or other.",
	"God, Kinch, if you and I could only work together we might do something for the island.",
	"Hellenise it.",
	"Cranly’s arm.",
	"His arm.",
	"And to think of your having to beg from these swine.",
	"I’m the only one that knows what you are.",
	"Why don’t you trust me more?",
	"What have you up your nose against me?",
	"Is it Haines?",
	"Young shouts of moneyed voices in Clive Kempthorpe’s rooms.",
	"Palefaces: they hold their ribs with laughter, one clasping another.",
	"O, I shall expire!",
	"Break the news to her gently, Aubrey!",
	"I shall die!",
	"A scared calf’s face gilded with marmalade.",
	"I don’t want to be debagged!",
	"Don’t you play the giddy ox with me!",
	"Shouts from the open window startling evening in the quadrangle.",
	"To ourselves... new paganism... omphalos.",
	"Let him stay, Stephen said.",
	"There’s nothing wrong with him except at night.",
	"Then what is it?",
	"Buck Mulligan asked impatiently.",
	"Cough it up.",
	"I’m quite frank with you.",
	"What have you against me now?",
	"Stephen freed his arm quietly.",
	"Do you wish me to tell you?",
	"he asked.",
	"Yes, what is it?",
	"Buck Mulligan answered.",
	"I don’t remember anything.",
	"He looked in Stephen’s face as he spoke.",
	"Buck Mulligan frowned quickly and said: What?",
	"Where?",
	"I can’t remember anything.",
	"I remember only ideas and sensations.",
	"Why?",
	"What happened in the name of God?",
	"You were making tea, Stephen said, and went across the landing to get more hot water.",
	"Your mother and some visitor came out of the drawingroom.",
	"She asked you who was in your room.",
	"Yes?",
	"Buck Mulligan said.",
	"What did I say?",
	"I forget.",
	"You said, Stephen answered, O, it’s only Dedalus whose mother is beastly dead.",
	"A flush which made him seem younger and more engaging rose to Buck Mulligan’s cheek.",
	"Did I say that?",
	"he asked.",
	"Well?",
	"What harm is that?",
	"He shook his constraint from him nervously.",
	"And what is death, he asked, your mother’s or yours or my own?",
	"You saw only your mother die.",
	"It’s a beastly thing and nothing else.",
	"It simply doesn’t matter.",
	"You wouldn’t kneel down to pray for your mother on her deathbed when she asked you.",
	"Why?",
	"Because you have the cursed jesuit strain in you, only it’s injected the wrong way.",
	"To me it’s all a mockery and beastly.",
	"Her cerebral lobes are not functioning.",
	"She calls the doctor sir Peter Teazle and picks buttercups off the quilt.",
	"Humour her till it’s over.",
	"Absurd!",
	"I suppose I did say it.",
	"I didn’t mean to offend the memory of your mother.",
	"He had spoken himself into boldness.",
	"Of what then?",
	"Buck Mulligan asked.",
	"Of the offence to me, Stephen answered.",
	"Buck Mulligan swung round on his heel.",
	"O, an impossible person!",
	"he exclaimed.",
	"He walked off quickly round the parapet.",
	"Stephen stood at his post, gazing over the calm sea towards the headland.",
	"Sea and headland now grew dim.",
	"Pulses were beating in his eyes, veiling their sight, and he felt the fever of his cheeks.",
	"A voice within the tower called loudly: Are you up there, Mulligan?",
	"I’m coming, Buck Mulligan answered.",
	"He turned towards Stephen and said: Look at the sea.",
	"What does it care about offences?",
	"Chuck Loyola, Kinch, and come on down.",
	"The Sassenach wants his morning rashers.",
	"I’m inconsequent.",
	"Give up the moody brooding.",
	"Woodshadows floated silently by through the morning peace from the stairhead seaward where he gazed.",
	"Inshore and farther out the mirror of water whitened, spurned by lightshod hurrying feet.",
	"White breast of the dim sea.",
	"The twining stresses, two by two.",
	"A hand plucking the harpstrings, merging their twining chords.",
	"Wavewhite wedded words shimmering on the dim tide.",
	"A cloud began to cover the sun slowly, wholly, shadowing the bay in deeper green.",
	"It lay beneath him, a bowl of bitter waters.",
	"Fergus’ song: I sang it alone in the house, holding down the long dark chords.",
	"Her door was open: she wanted to hear my music.",
	"Silent with awe and pity I went to her bedside.",
	"She was crying in her wretched bed.",
	"For those words, Stephen: love’s bitter mystery.",
	"Where now?",
	"Her secrets: old featherfans, tasselled dancecards, powdered with musk, a gaud of amber beads in her locked drawer.",
	"A birdcage hung in the sunny window of her house when she was a girl.",
	"Phantasmal mirth, folded away: muskperfumed.",
	"And no more turn aside and brood.",
	"Folded away in the memory of nature with her toys.",
	"Memories beset his brooding brain.",
	"Her glass of water from the kitchen tap when she had approached the sacrament.",
	"A cored apple, filled with brown sugar, roasting for her at the hob on a dark autumn evening.",
	"Her shapely fingernails reddened by the blood of squashed lice from the children’s shirts.",
	"Her glazing eyes, staring out of death, to shake and bend my soul.",
	"On me alone.",
	"The ghostcandle to light her agony.",
	"Ghostly light on the tortured face.",
	"Her hoarse loud breath rattling in horror, while all prayed on their knees.",
	"Her eyes on me to strike me down.",
	"Liliata rutilantium te confessorum turma circumdet: iubilantium te virginum chorus excipiat.",
	"Ghoul!",
	"Chewer of corpses!",
	"No, mother!",
	"Let me be and let me live.",
	"Kinch ahoy!",
	"Buck Mulligan’s voice sang from within the tower.",
	"It came nearer up the staircase, calling again.",
	"Stephen, still trembling at his soul’s cry, heard warm running sunlight and in the air behind him friendly words.",
	"Dedalus, come down, like a good mosey.",
	"Breakfast is ready.",
	"Haines is apologising for waking us last night.",
	"It’s all right.",
	"I’m coming, Stephen said, turning.",
	"Do, for Jesus’ sake, Buck Mulligan said.",
	"For my sake and for all our sakes.",
	"His head disappeared and reappeared.",
	"I told him your symbol of Irish art.",
	"He says it’s very clever.",
	"Touch him for a quid, will you?",
	"A guinea, I mean.",
	"I get paid this morning, Stephen said.",
	"The school kip?",
	"Buck Mulligan said.",
	"How much?",
	"Four quid?",
	"Lend us one.",
	"If you want it, Stephen said.",
	"Four shining sovereigns, Buck Mulligan cried with delight.",
	"We’ll have a glorious drunk to astonish the druidy druids.",
	"Four omnipotent sovereigns.",
	"On coronation, Coronation day!",
	"O, won’t we have a merry time On coronation day!",
	"Warm sunshine merrying over the sea.",
	"The nickel shavingbowl shone, forgotten, on the parapet.",
	"Why should I bring it down?",
	"Or leave it there all day, forgotten friendship?",
	"So I carried the boat of incense then at Clongowes.",
	"I am another now and yet the same.",
	"A servant too.",
	"A server of a servant.",
	"We’ll be choked, Buck Mulligan said.",
	"Haines, open that door, will you?",
	"Stephen laid the shavingbowl on the locker.",
	"Have you the key?",
	"a voice asked.",
	"Dedalus has it, Buck Mulligan said.",
	"Janey Mack, I’m choked!",
	"He howled, without looking up from the fire: Kinch!",
	"It’s in the lock, Stephen said, coming forward.",
	"Haines stood at the doorway, looking out.",
	"Stephen haled his upended valise to the table and sat down to wait.",
	"Buck Mulligan tossed the fry on to the dish beside him.",
	"I’m melting, he said, as the candle remarked when...",
	"But, hush!",
	"Not a word more on that subject!",
	"Kinch, wake up!",
	"Bread, butter, honey.",
	"Haines, come in.",
	"The grub is ready.",
	"Bless us, O Lord, and these thy gifts.",
	"Where’s the sugar?",
	"O, jay, there’s no milk.",
	"Stephen fetched the loaf and the pot of honey and the buttercooler from the locker.",
	"Buck Mulligan sat down in a sudden pet.",
	"What sort of a kip is this?",
	"he said.",
	"I told her to come after eight.",
	"We can drink it black, Stephen said thirstily.",
	"There’s a lemon in the locker.",
	"O, damn you and your Paris fads!",
	"Buck Mulligan said.",
	"I want Sandycove milk.",
	"Haines came in from the doorway and said quietly: That woman is coming up with the milk.",
	"The blessings of God on you!",
	"Buck Mulligan cried, jumping up from his chair.",
	"Sit down.",
	"Pour out the tea there.",
	"The sugar is in the bag.",
	"Here, I can’t go fumbling at the damned eggs.",
	"Haines sat down to pour out the tea.",
	"I’m giving you two lumps each, he said.",
	"But, I say, Mulligan, you do make strong tea, don’t you?",
	"And when I makes water I makes water.",
	"By Jove, it is tea, Haines said.",
	"Buck Mulligan went on hewing and wheedling: So I do, Mrs Cahill, says she.",
	"Begob, ma’am, says Mrs Cahill, God send you don’t make them in the one pot.",
	"He lunged towards his messmates in turn a thick slice of bread, impaled on his knife.",
	"That’s folk, he said very earnestly, for your book, Haines.",
	"Five lines of text and ten pages of notes about the folk and the fishgods of Dundrum.",
	"Printed by the weird sisters in the year of the big wind.",
	"I doubt it, said Stephen gravely.",
	"Do you now?",
	"Buck Mulligan said in the same tone.",
	"Your reasons, pray?",
	"I fancy, Stephen said as he ate, it did not exist in or out of the Mabinogion.",
	"Mother Grogan was, one imagines, a kinswoman of Mary Ann.",
	"Buck Mulligan’s face smiled with delight.",
	"Charming!",
	"he said in a finical sweet voice, showing his white teeth and blinking his eyes pleasantly.",
	"Do you think she was?",
	"Quite charming!",
	"But, hising up her petticoats...",
	"He crammed his mouth with fry and munched and droned.",
	"The doorway was darkened by an entering form.",
	"The milk, sir!",
	"Come in, ma’am, Mulligan said.",
	"Kinch, get the jug.",
	"An old woman came forward and stood by Stephen’s elbow.",
	"That’s a lovely morning, sir, she said.",
	"Glory be to God.",
	"To whom?",
	"Mulligan said, glancing at her.",
	"Ah, to be sure!",
	"Stephen reached back and took the milkjug from the locker.",
	"The islanders, Mulligan said to Haines casually, speak frequently of the collector of prepuces.",
	"How much, sir?",
	"asked the old woman.",
	"A quart, Stephen said.",
	"He watched her pour into the measure and thence into the jug rich white milk, not hers.",
	"Old shrunken paps.",
	"She poured again a measureful and a tilly.",
	"Old and secret she had entered from a morning world, maybe a messenger.",
	"She praised the goodness of the milk, pouring it out.",
	"They lowed about her whom they knew, dewsilky cattle.",
	"Silk of the kine and poor old woman, names given her in old times.",
	"To serve or to upbraid, whether he could not tell: but scorned to beg her favour.",
	"It is indeed, ma’am, Buck Mulligan said, pouring milk into their cups.",
	"Taste it, sir, she said.",
	"He drank at her bidding.",
	"Living in a bogswamp, eating cheap food and the streets paved with dust, horsedung and consumptives’ spits.",
	"Are you a medical student, sir?",
	"the old woman asked.",
	"I am, ma’am, Buck Mulligan answered.",
	"Look at that now, she said.",
	"Stephen listened in scornful silence.",
	"And to the loud voice that now bids her be silent with wondering unsteady eyes.",
	"Do you understand what he says?",
	"Stephen asked her.",
	"Is it French you are talking, sir?",
	"the old woman said to Haines.",
	"Haines spoke to her again a longer speech, confidently.",
	"Irish, Buck Mulligan said.",
	"Is there Gaelic on you?",
	"I thought it was Irish, she said, by the sound of it.",
	"Are you from the west, sir?",
	"I am an Englishman, Haines answered.",
	"He’s English, Buck Mulligan said, and he thinks we ought to speak Irish in Ireland.",
	"Sure we ought to, the old woman said, and I’m ashamed I don’t speak the language myself.",
	"I’m told it’s a grand language by them that knows.",
	"Grand is no name for it, said Buck Mulligan.",
	"Wonderful entirely.",
	"Fill us out some more tea, Kinch.",
	"Would you like a cup, ma’am?",
	"Haines said to her: Have you your bill?",
	"We had better pay her, Mulligan, hadn’t we?",
	"Stephen filled again the three cups.",
	"Bill, sir?",
	"she said, halting.",
	"That’s a shilling and one and two is two and two, sir.",
	"Pay up and look pleasant, Haines said to him, smiling.",
	"Stephen filled a third cup, a spoonful of tea colouring faintly the thick rich milk.",
	"Buck Mulligan brought up a florin, twisted it round in his fingers and cried: A miracle!",
	"He passed it along the table towards the old woman, saying: Ask nothing more of me, sweet.",
	"All I can give you I give.",
	"Stephen laid the coin in her uneager hand.",
	"We’ll owe twopence, he said.",
	"Time enough, sir, she said, taking the coin.",
	"Time enough.",
	"Good morning, sir.",
	"He turned to Stephen and said: Seriously, Dedalus.",
	"I’m stony.",
	"Hurry out to your school kip and bring us back some money.",
	"Today the bards must drink and junket.",
	"Ireland expects that every man this day will do his duty.",
	"That reminds me, Haines said, rising, that I have to visit your national library today.",
	"Our swim first, Buck Mulligan said.",
	"He turned to Stephen and asked blandly: Is this the day for your monthly wash, Kinch?",
	"Then he said to Haines: The unclean bard makes a point of washing once a month.",
	"Speaking to me.",
	"They wash and tub and scrub.",
	"Agenbite of inwit.",
	"Conscience.",
	"Yet here’s a spot.",
	"That one about the cracked lookingglass of a servant being the symbol of Irish art is deuced good.",
	"Well, I mean it, Haines said, still speaking to Stephen.",
	"I was just thinking of it when that poor old creature came in.",
	"Would I make any money by it?",
	"Stephen asked.",
	"He strolled out to the doorway.",
	"Buck Mulligan bent across to Stephen and said with coarse vigour: You put your hoof in it now.",
	"What did you say that for?",
	"Well?",
	"Stephen said.",
	"The problem is to get money.",
	"From whom?",
	"From the milkwoman or from him.",
	"It’s a toss up, I think.",
	"I see little hope, Stephen said, from her or from him.",
	"Buck Mulligan sighed tragically and laid his hand on Stephen’s arm.",
	"From me, Kinch, he said.",
	"In a suddenly changed tone he added: To tell you the God’s truth I think you’re right.",
	"Damn all else they are good for.",
	"Why don’t you play them as I do?",
	"To hell with them all.",
	"Let us get out of the kip.",
	"He stood up, gravely ungirdled and disrobed himself of his gown, saying resignedly: Mulligan is stripped of his garments.",
	"He emptied his pockets on to the table.",
	"There’s your snotrag, he said.",
	"His hands plunged and rummaged in his trunk while he called for a clean handkerchief.",
	"God, we’ll simply have to dress the character.",
	"I want puce gloves and green boots.",
	"Contradiction.",
	"Do I contradict myself?",
	"Very well then, I contradict myself.",
	"Mercurial Malachi.",
	"A limp black missile flew out of his talking hands.",
	"And there’s your Latin quarter hat, he said.",
	"Stephen picked it up and put it on.",
	"Haines called to them from the doorway: Are you coming, you fellows?",
	"I’m ready, Buck Mulligan answered, going towards the door.",
	"Come out, Kinch.",
	"You have eaten all we left, I suppose.",
	"Resigned he passed out with grave words and gait, saying, wellnigh with sorrow: And going forth he met Butterly.",
	"He put the huge key in his inner pocket.",
	"At the foot of the ladder Buck Mulligan asked: Did you bring the key?",
	"I have it, Stephen said, preceding them.",
	"He walked on.",
	"Behind him he heard Buck Mulligan club with his heavy bathtowel the leader shoots of ferns or grasses.",
	"Down, sir!",
	"How dare you, sir!",
	"Haines asked: Do you pay rent for this tower?",
	"Twelve quid, Buck Mulligan said.",
	"To the secretary of state for war, Stephen added over his shoulder.",
	"They halted while Haines surveyed the tower and said at last: Rather bleak in wintertime, I should say.",
	"Martello you call it?",
	"Billy Pitt had them built, Buck Mulligan said, when the French were on the sea.",
	"But ours is the omphalos.",
	"What is your idea of Hamlet?",
	"Haines asked Stephen.",
	"No, no, Buck Mulligan shouted in pain.",
	"I’m not equal to Thomas Aquinas and the fiftyfive reasons he has made out to prop it up.",
	"Wait till I have a few pints in me first.",
	"It has waited so long, Stephen said listlessly, it can wait longer.",
	"You pique my curiosity, Haines said amiably.",
	"Is it some paradox?",
	"Pooh!",
	"Buck Mulligan said.",
	"We have grown out of Wilde and paradoxes.",
	"It’s quite simple.",
	"What?",
	"Haines said, beginning to point at Stephen.",
	"He himself?",
	"Japhet in search of a father!",
	"We’re always tired in the morning, Stephen said to Haines.",
	"And it is rather long to tell.",
	"Buck Mulligan, walking forward again, raised his hands.",
	"The sacred pint alone can unbind the tongue of Dedalus, he said.",
	"That beetles o’er his base into the sea, isn’t it?",
	"Buck Mulligan turned suddenly for an instant towards Stephen but did not speak.",
	"In the bright silent instant Stephen saw his own image in cheap dusty mourning between their gay attires.",
	"It’s a wonderful tale, Haines said, bringing them to halt again.",
	"Eyes, pale as the sea the wind had freshened, paler, firm and prudent.",
	"I read a theological interpretation of it somewhere, he said bemused.",
	"The Father and the Son idea.",
	"The Son striving to be atoned with the Father.",
	"Buck Mulligan at once put on a blithe broadly smiling face.",
	"My mother’s a jew, my father’s a bird.",
	"With Joseph the joiner I cannot agree.",
	"So here’s to disciples and Calvary.",
	"He held up a forefinger of warning.",
	"Write down all I said And tell Tom, Dick and Harry I rose from the dead.",
	"What’s bred in the bone cannot fail me to fly And Olivet’s breezy... Goodbye, now, goodbye!",
	"Haines, who had been laughing guardedly, walked on beside Stephen and said: We oughtn’t to laugh, I suppose.",
	"He’s rather blasphemous.",
	"I’m not a believer myself, that is to say.",
	"Still his gaiety takes the harm out of it somehow, doesn’t it?",
	"What did he call it?",
	"Joseph the Joiner?",
	"The ballad of joking Jesus, Stephen answered.",
	"O, Haines said, you have heard it before?",
	"Three times a day, after meals, Stephen said drily.",
	"You’re not a believer, are you?",
	"Haines asked.",
	"I mean, a believer in the narrow sense of the word.",
	"Creation from nothing and miracles and a personal God.",
	"There’s only one sense of the word, it seems to me, Stephen said.",
	"Haines stopped to take out a smooth silver case in which twinkled a green stone.",
	"He sprang it open with his thumb and offered it.",
	"Thank you, Stephen said, taking a cigarette.",
	"Haines helped himself and snapped the case to.",
	"Yes, of course, he said, as they went on again.",
	"Either you believe or you don’t, isn’t it?",
	"Personally I couldn’t stomach that idea of a personal God.",
	"You don’t stand for that, I suppose?",
	"You behold in me, Stephen said with grim displeasure, a horrible example of free thought.",
	"He walked on, waiting to be spoken to, trailing his ashplant by his side.",
	"Its ferrule followed lightly on the path, squealing at his heels.",
	"My familiar, after me, calling, Steeeeeeeeeeeephen!",
	"A wavering line along the path.",
	"They will walk on it tonight, coming here in the dark.",
	"He wants that key.",
	"It is mine.",
	"I paid the rent.",
	"Now I eat his salt bread.",
	"Give him the key too.",
	"All.",
	"He will ask for it.",
	"That was in his eyes.",
	"After all, I should think you are able to free yourself.",
	"You are your own master, it seems to me.",
	"I am a servant of two masters, Stephen said, an English and an Italian.",
	"Italian?",
	"Haines said.",
	"A crazy queen, old and jealous.",
	"Kneel down before me.",
	"And a third, Stephen said, there is who wants me for odd jobs.",
	"Italian?",
	"Haines said again.",
	"What do you mean?",
	"The imperial British state, Stephen answered, his colour rising, and the holy Roman catholic and apostolic church.",
	"Haines detached from his underlip some fibres of tobacco before he spoke.",
	"I can quite understand that, he said calmly.",
	"An Irishman must think like that, I daresay.",
	"We feel in England that we have treated you rather unfairly.",
	"It seems history is to blame.",
	"Words Mulligan had spoken a moment since in mockery to the stranger.",
	"Idle mockery.",
	"Hear, hear!",
	"Prolonged applause.",
	"Zut!",
	"Nom de Dieu!",
	"Of course I’m a Britisher, Haines’s voice said, and I feel as one.",
	"I don’t want to see my country fall into the hands of German jews either.",
	"That’s our national problem, I’m afraid, just now.",
	"Two men stood at the verge of the cliff, watching: businessman, boatman.",
	"She’s making for Bullock harbour.",
	"The boatman nodded towards the north of the bay with some disdain.",
	"There’s five fathoms out there, he said.",
	"It’ll be swept up that way when the tide comes in about one.",
	"It’s nine days today.",
	"The man that was drowned.",
	"Here I am.",
	"They followed the winding path down to the creek.",
	"Buck Mulligan stood on a stone, in shirtsleeves, his unclipped tie rippling over his shoulder.",
	"Is the brother with you, Malachi?",
	"Down in Westmeath.",
	"With the Bannons.",
	"Still there?",
	"I got a card from Bannon.",
	"Says he found a sweet young thing down there.",
	"Photo girl he calls her.",
	"Snapshot, eh?",
	"Brief exposure.",
	"Buck Mulligan sat down to unlace his boots.",
	"An elderly man shot up near the spur of rock a blowing red face.",
	"Seymour’s back in town, the young man said, grasping again his spur of rock.",
	"Chucked medicine and going in for the army.",
	"Ah, go to God!",
	"Buck Mulligan said.",
	"Going over next week to stew.",
	"You know that red Carlisle girl, Lily?",
	"Yes.",
	"Spooning with him last night on the pier.",
	"The father is rotto with money.",
	"Is she up the pole?",
	"Better ask Seymour that.",
	"Seymour a bleeding officer!",
	"Buck Mulligan said.",
	"He broke off in alarm, feeling his side under his flapping shirt.",
	"My twelfth rib is gone, he cried.",
	"I’m the Übermensch.",
	"Toothless Kinch and I, the supermen.",
	"He struggled out of his shirt and flung it behind him to where his clothes lay.",
	"Are you going in here, Malachi?",
	"Yes.",
	"Make room in the bed.",
	"Haines sat down on a stone, smoking.",
	"Are you not coming in?",
	"Buck Mulligan asked.",
	"Later on, Haines said.",
	"Not on my breakfast.",
	"Stephen turned away.",
	"I’m going, Mulligan, he said.",
	"Give us that key, Kinch, Buck Mulligan said, to keep my chemise flat.",
	"Stephen handed him the key.",
	"Buck Mulligan laid it across his heaped clothes.",
	"And twopence, he said, for a pint.",
	"Throw it there.",
	"Stephen threw two pennies on the soft heap.",
	"Dressing, undressing.",
	"Thus spake Zarathustra.",
	"His plump body plunged.",
	"We’ll see you again, Haines said, turning as Stephen walked up the path and smiling at wild Irish.",
	"Horn of a bull, hoof of a horse, smile of a Saxon.",
	"The Ship, Buck Mulligan cried.",
	"Half twelve.",
	"Good, Stephen said.",
	"He walked along the upwardcurving path.",
	"Liliata rutilantium.",
	"Turma circumdet.",
	"Iubilantium te virginum.",
	"The priest’s grey nimbus in a niche where he dressed discreetly.",
	"I will not sleep here tonight.",
	"Home also I cannot go.",
	"A voice, sweettoned and sustained, called to him from the sea.",
	"Turning the curve he waved his hand.",
	"It called again.",
	"A sleek brown head, a seal’s, far out on the water, round.",
	"Usurper.",
	"[ 2 ] —You, Cochrane, what city sent for him?",
	"Tarentum, sir.",
	"Very good.",
	"Well?",
	"There was a battle, sir.",
	"Very good.",
	"Where?",
	"The boy’s blank face asked the blank window.",
	"Fabled by the daughters of memory.",
	"And yet it was in some way if not as memory fabled it.",
	"A phrase, then, of impatience, thud of Blake’s wings of excess.",
	"I hear the ruin of all space, shattered glass and toppling masonry, and time one livid final flame.",
	"What’s left us then?",
	"I forget the place, sir.",
	"279 B. C. —Asculum, Stephen said, glancing at the name and date in the gorescarred book.",
	"Yes, sir.",
	"And he said: Another victory like that and we are done for.",
	"That phrase the world had remembered.",
	"A dull ease of the mind.",
	"From a hill above a corpsestrewn plain a general speaking to his officers, leaned upon his spear.",
	"Any general to any officers.",
	"They lend ear.",
	"You, Armstrong, Stephen said.",
	"What was the end of Pyrrhus?",
	"End of Pyrrhus, sir?",
	"I know, sir.",
	"Ask me, sir, Comyn said.",
	"Wait.",
	"You, Armstrong.",
	"Do you know anything about Pyrrhus?",
	"A bag of figrolls lay snugly in Armstrong’s satchel.",
	"He curled them between his palms at whiles and swallowed them softly.",
	"Crumbs adhered to the tissue of his lips.",
	"A sweetened boy’s breath.",
	"Welloff people, proud that their eldest son was in the navy.",
	"Vico Road, Dalkey.",
	"Pyrrhus, sir?",
	"Pyrrhus, a pier.",
	"All laughed.",
	"Mirthless high malicious laughter.",
	"Armstrong looked round at his classmates, silly glee in profile.",
	"Tell me now, Stephen said, poking the boy’s shoulder with the book, what is a pier.",
	"A pier, sir, Armstrong said.",
	"A thing out in the water.",
	"A kind of a bridge.",
	"Kingstown pier, sir.",
	"Some laughed again: mirthless but with meaning.",
	"Two in the back bench whispered.",
	"Yes.",
	"They knew: had never learned nor ever been innocent.",
	"All.",
	"With envy he watched their faces: Edith, Ethel, Gerty, Lily.",
	"Their likes: their breaths, too, sweetened with tea and jam, their bracelets tittering in the struggle.",
	"Kingstown pier, Stephen said.",
	"Yes, a disappointed bridge.",
	"The words troubled their gaze.",
	"How, sir?",
	"Comyn asked.",
	"A bridge is across a river.",
	"For Haines’s chapbook.",
	"No-one here to hear.",
	"Tonight deftly amid wild drink and talk, to pierce the polished mail of his mind.",
	"What then?",
	"A jester at the court of his master, indulged and disesteemed, winning a clement master’s praise.",
	"Why had they chosen all that part?",
	"Not wholly for the smooth caress.",
	"For them too history was a tale like any other too often heard, their land a pawnshop.",
	"Had Pyrrhus not fallen by a beldam’s hand in Argos or Julius Caesar not been knifed to death.",
	"They are not to be thought away.",
	"Time has branded them and fettered they are lodged in the room of the infinite possibilities they have ousted.",
	"But can those have been possible seeing that they never were?",
	"Or was that only possible which came to pass?",
	"Weave, weaver of the wind.",
	"Tell us a story, sir.",
	"O, do, sir.",
	"A ghoststory.",
	"Where do you begin in this?",
	"Stephen asked, opening another book.",
	"Weep no more, Comyn said.",
	"Go on then, Talbot.",
	"And the story, sir?",
	"After, Stephen said.",
	"Go on, Talbot.",
	"A swarthy boy opened a book and propped it nimbly under the breastwork of his satchel.",
	"It must be a movement then, an actuality of the possible as possible.",
	"By his elbow a delicate Siamese conned a handbook of strategy.",
	"Thought is the thought of thought.",
	"Tranquil brightness.",
	"The soul is in a manner all that is: the soul is the form of forms.",
	"Tranquility sudden, vast, candescent: form of forms.",
	"I don’t see anything.",
	"What, sir?",
	"Talbot asked simply, bending forward.",
	"His hand turned the page over.",
	"He leaned back and went on again, having just remembered.",
	"Of him that walked the waves.",
	"Here also over these craven hearts his shadow lies and on the scoffer’s heart and lips and on mine.",
	"It lies upon their eager faces who offered him a coin of the tribute.",
	"To Caesar what is Caesar’s, to God what is God’s.",
	"A long look from dark eyes, a riddling sentence to be woven and woven on the church’s looms.",
	"Ay.",
	"Riddle me, riddle me, randy ro.",
	"My father gave me seeds to sow.",
	"Talbot slid his closed book into his satchel.",
	"Have I heard all?",
	"Stephen asked.",
	"Yes, sir.",
	"Hockey at ten, sir.",
	"Half day, sir.",
	"Thursday.",
	"Who can answer a riddle?",
	"Stephen asked.",
	"They bundled their books away, pencils clacking, pages rustling.",
	"Crowding together they strapped and buckled their satchels, all gabbling gaily: A riddle, sir?",
	"Ask me, sir.",
	"O, ask me, sir.",
	"A hard one, sir.",
	"‘Tis time for this poor soul To go to heaven.",
	"What is that?",
	"What, sir?",
	"Again, sir.",
	"We didn’t hear.",
	"Their eyes grew bigger as the lines were repeated.",
	"After a silence Cochrane said: What is it, sir?",
	"We give it up.",
	"Stephen, his throat itching, answered: The fox burying his grandmother under a hollybush.",
	"He stood up and gave a shout of nervous laughter to which their cries echoed dismay.",
	"A stick struck the door and a voice in the corridor called: Hockey!",
	"They broke asunder, sidling out of their benches, leaping them.",
	"Sargent who alone had lingered came forward slowly, showing an open copybook.",
	"He held out his copybook.",
	"The word Sums was written on the headline.",
	"Beneath were sloping figures and at the foot a crooked signature with blind loops and a blot.",
	"Cyril Sargent: his name and seal.",
	"Mr Deasy told me to write them out all again, he said, and show them to you, sir.",
	"Stephen touched the edges of the book.",
	"Futility.",
	"Do you understand how to do them now?",
	"he asked.",
	"Numbers eleven to fifteen, Sargent answered.",
	"Mr Deasy said I was to copy them off the board, sir.",
	"Can you do them yourself?",
	"Stephen asked.",
	"No, sir.",
	"Ugly and futile: lean neck and tangled hair and a stain of ink, a snail’s bed.",
	"Yet someone had loved him, borne him in her arms and in her heart.",
	"But for her the race of the world would have trampled him underfoot, a squashed boneless snail.",
	"She had loved his weak watery blood drained from her own.",
	"Was that then real?",
	"The only true thing in life?",
	"His mother’s prostrate body the fiery Columbanus in holy zeal bestrode.",
	"She had saved him from being trampled underfoot and had gone, scarcely having been.",
	"Sitting at his side Stephen solved out the problem.",
	"He proves by algebra that Shakespeare’s ghost is Hamlet’s grandfather.",
	"Sargent peered askance through his slanted glasses.",
	"Hockeysticks rattled in the lumberroom: the hollow knock of a ball and calls from the field.",
	"Give hands, traverse, bow to partner: so: imps of fancy of the Moors.",
	"Do you understand now?",
	"Can you work the second for yourself?",
	"Yes, sir.",
	"In long shaky strokes Sargent copied the data.",
	"Amor matris: subjective and objective genitive.",
	"Like him was I, these sloping shoulders, this gracelessness.",
	"My childhood bends beside me.",
	"Too far for me to lay a hand there once or lightly.",
	"Mine is far and his secret as our eyes.",
	"The sum was done.",
	"It is very simple, Stephen said as he stood up.",
	"Yes, sir.",
	"Thanks, Sargent answered.",
	"He dried the page with a sheet of thin blottingpaper and carried his copybook back to his bench.",
	"Yes, sir.",
	"In the corridor his name was heard, called from the playfield.",
	"Sargent!",
	"Run on, Stephen said.",
	"Mr Deasy is calling you.",
	"They were sorted in teams and Mr Deasy came away stepping over wisps of grass with gaitered feet.",
	"When he had reached the schoolhouse voices again contending called to him.",
	"He turned his angry white moustache.",
	"What is it now?",
	"he cried continually without listening.",
	"Cochrane and Halliday are on the same side, sir, Stephen said.",
	"Will you wait in my study for a moment, Mr Deasy said, till I restore order here.",
	"And as he stepped fussily back across the field his old man’s voice cried sternly: What is the matter?",
	"What is it now?",
	"Stale smoky air hung in the study with the smell of drab abraded leather of its chairs.",
	"As on the first day he bargained with me here.",
	"As it was in the beginning, is now.",
	"On the sideboard the tray of Stuart coins, base treasure of a bog: and ever shall be.",
	"A hasty step over the stone porch and in the corridor.",
	"Blowing out his rare moustache Mr Deasy halted at the table.",
	"First, our little financial settlement, he said.",
	"He brought out of his coat a pocketbook bound by a leather thong.",
	"Two, he said, strapping and stowing his pocketbook away.",
	"And now his strongroom for the gold.",
	"An old pilgrim’s hoard, dead treasure, hollow shells.",
	"A sovereign fell, bright and new, on the soft pile of the tablecloth.",
	"Three, Mr Deasy said, turning his little savingsbox about in his hand.",
	"These are handy things to have.",
	"See.",
	"This is for sovereigns.",
	"This is for shillings.",
	"Sixpences, halfcrowns.",
	"And here crowns.",
	"See.",
	"He shot from it two crowns and two shillings.",
	"Three twelve, he said.",
	"I think you’ll find that’s right.",
	"No thanks at all, Mr Deasy said.",
	"You have earned it.",
	"Stephen’s hand, free again, went back to the hollow shells.",
	"Symbols too of beauty and of power.",
	"A lump in my pocket: symbols soiled by greed and misery.",
	"Don’t carry it like that, Mr Deasy said.",
	"You’ll pull it out somewhere and lose it.",
	"You just buy one of these machines.",
	"You’ll find them very handy.",
	"Answer something.",
	"Mine would be often empty, Stephen said.",
	"The same room and hour, the same wisdom: and I the same.",
	"Three times now.",
	"Three nooses round me here.",
	"Well?",
	"I can break them in this instant if I will.",
	"Because you don’t save, Mr Deasy said, pointing his finger.",
	"You don’t know yet what money is.",
	"Money is power.",
	"When you have lived as long as I have.",
	"I know, I know.",
	"If youth but knew.",
	"But what does Shakespeare say?",
	"Put but money in thy purse.",
	"Iago, Stephen murmured.",
	"He lifted his gaze from the idle shells to the old man’s stare.",
	"He knew what money was, Mr Deasy said.",
	"He made money.",
	"A poet, yes, but an Englishman too.",
	"Do you know what is the pride of the English?",
	"Do you know what is the proudest word you will ever hear from an Englishman’s mouth?",
	"The seas’ ruler.",
	"That on his empire, Stephen said, the sun never sets.",
	"Ba!",
	"Mr Deasy cried.",
	"That’s not English.",
	"A French Celt said that.",
	"He tapped his savingsbox against his thumbnail.",
	"I will tell you, he said solemnly, what is his proudest boast.",
	"I paid my way.",
	"Good man, good man.",
	"I paid my way.",
	"I never borrowed a shilling in my life.",
	"Can you feel that?",
	"I owe nothing.",
	"Can you?",
	"Mulligan, nine pounds, three pairs of socks, one pair brogues, ties.",
	"Curran, ten guineas.",
	"McCann, one guinea.",
	"Fred Ryan, two shillings.",
	"Temple, two lunches.",
	"Russell, one guinea, Cousins, ten shillings, Bob Reynolds, half a guinea, Koehler, three guineas, Mrs MacKernan, five weeks’ board.",
	"The lump I have is useless.",
	"For the moment, no, Stephen answered.",
	"Mr Deasy laughed with rich delight, putting back his savingsbox.",
	"I knew you couldn’t, he said joyously.",
	"But one day you must feel it.",
	"We are a generous people but we must also be just.",
	"I fear those big words, Stephen said, which make us so unhappy.",
	"You think me an old fogey and an old tory, his thoughtful voice said.",
	"I saw three generations since O’Connell’s time.",
	"I remember the famine in ‘46.",
	"You fenians forget some things.",
	"Glorious, pious and immortal memory.",
	"The lodge of Diamond in Armagh the splendid behung with corpses of papishes.",
	"Hoarse, masked and armed, the planters’ covenant.",
	"The black north and true blue bible.",
	"Croppies lie down.",
	"Stephen sketched a brief gesture.",
	"I have rebel blood in me too, Mr Deasy said.",
	"On the spindle side.",
	"But I am descended from sir John Blackwood who voted for the union.",
	"We are all Irish, all kings’ sons.",
	"Alas, Stephen said.",
	"Per vias rectas, Mr Deasy said firmly, was his motto.",
	"Lal the ral the ra The rocky road to Dublin.",
	"A gruff squire on horseback with shiny topboots.",
	"Soft day, sir John!",
	"Soft day, your honour!...",
	"Day!...",
	"Day!...",
	"Two topboots jog dangling on to Dublin.",
	"Lal the ral the ra.",
	"Lal the ral the raddy.",
	"That reminds me, Mr Deasy said.",
	"You can do me a favour, Mr Dedalus, with some of your literary friends.",
	"I have a letter here for the press.",
	"Sit down a moment.",
	"I have just to copy the end.",
	"Sit down.",
	"Excuse me, he said over his shoulder, the dictates of common sense.",
	"Just a moment.",
	"Stephen seated himself noiselessly before the princely presence.",
	"Elfin riders sat them, watchful of a sign.",
	"He saw their speeds, backing king’s colours, and shouted with the shouts of vanished crowds.",
	"Full stop, Mr Deasy bade his keys.",
	"Even money Fair Rebel.",
	"Ten to one the field.",
	"Shouts rang shrill from the boys’ playfield and a whirring whistle.",
	"Again: a goal.",
	"I am among them, among their battling bodies in a medley, the joust of life.",
	"You mean that knockkneed mother’s darling who seems to be slightly crawsick?",
	"Jousts.",
	"Time shocked rebounds, shock by shock.",
	"Now then, Mr Deasy said, rising.",
	"He came to the table, pinning together his sheets.",
	"Stephen stood up.",
	"I have put the matter into a nutshell, Mr Deasy said.",
	"It’s about the foot and mouth disease.",
	"Just look through it.",
	"There can be no two opinions on the matter.",
	"May I trespass on your valuable space.",
	"That doctrine of laissez faire which so often in our history.",
	"Our cattle trade.",
	"The way of all our old industries.",
	"Liverpool ring which jockeyed the Galway harbour scheme.",
	"European conflagration.",
	"Grain supplies through the narrow waters of the channel.",
	"The pluterperfect imperturbability of the department of agriculture.",
	"Pardoned a classical allusion.",
	"Cassandra.",
	"By a woman who was no better than she should be.",
	"To come to the point at issue.",
	"I don’t mince words, do I?",
	"Mr Deasy asked as Stephen read on.",
	"Foot and mouth disease.",
	"Known as Koch’s preparation.",
	"Serum and virus.",
	"Percentage of salted horses.",
	"Rinderpest.",
	"Emperor’s horses at Mürzsteg, lower Austria.",
	"Veterinary surgeons.",
	"Mr Henry Blackwood Price.",
	"Courteous offer a fair trial.",
	"Dictates of common sense.",
	"Allimportant question.",
	"In every sense of the word take the bull by the horns.",
	"Thanking you for the hospitality of your columns.",
	"I want that to be printed and read, Mr Deasy said.",
	"You will see at the next outbreak they will put an embargo on Irish cattle.",
	"And it can be cured.",
	"It is cured.",
	"My cousin, Blackwood Price, writes to me it is regularly treated and cured in Austria by cattledoctors there.",
	"They offer to come over here.",
	"I am trying to work up influence with the department.",
	"Now I’m going to try publicity.",
	"I am surrounded by difficulties, by... intrigues by... backstairs influence by...",
	"He raised his forefinger and beat the air oldly before his voice spoke.",
	"Mark my words, Mr Dedalus, he said.",
	"England is in the hands of the jews.",
	"In all the highest places: her finance, her press.",
	"And they are the signs of a nation’s decay.",
	"Wherever they gather they eat up the nation’s vital strength.",
	"I have seen it coming these years.",
	"As sure as we are standing here the jew merchants are already at their work of destruction.",
	"Old England is dying.",
	"He stepped swiftly off, his eyes coming to blue life as they passed a broad sunbeam.",
	"He faced about and back again.",
	"Dying, he said again, if not dead by now.",
	"The harlot’s cry from street to street Shall weave old England’s windingsheet.",
	"His eyes open wide in vision stared sternly across the sunbeam in which he halted.",
	"A merchant, Stephen said, is one who buys cheap and sells dear, jew or gentile, is he not?",
	"They sinned against the light, Mr Deasy said gravely.",
	"And you can see the darkness in their eyes.",
	"And that is why they are wanderers on the earth to this day.",
	"On the steps of the Paris stock exchange the goldskinned men quoting prices on their gemmed fingers.",
	"Gabble of geese.",
	"They swarmed loud, uncouth about the temple, their heads thickplotting under maladroit silk hats.",
	"Not theirs: these clothes, this speech, these gestures.",
	"Vain patience to heap and hoard.",
	"Time surely would scatter all.",
	"A hoard heaped by the roadside: plundered and passing on.",
	"Their eyes knew their years of wandering and, patient, knew the dishonours of their flesh.",
	"Who has not?",
	"Stephen said.",
	"What do you mean?",
	"Mr Deasy asked.",
	"He came forward a pace and stood by the table.",
	"His underjaw fell sideways open uncertainly.",
	"Is this old wisdom?",
	"He waits to hear from me.",
	"History, Stephen said, is a nightmare from which I am trying to awake.",
	"From the playfield the boys raised a shout.",
	"A whirring whistle: goal.",
	"What if that nightmare gave you a back kick?",
	"The ways of the Creator are not our ways, Mr Deasy said.",
	"All human history moves towards one great goal, the manifestation of God.",
	"Stephen jerked his thumb towards the window, saying: That is God.",
	"Hooray!",
	"Ay!",
	"Whrrwhee!",
	"What?",
	"Mr Deasy asked.",
	"A shout in the street, Stephen answered, shrugging his shoulders.",
	"Mr Deasy looked down and held for awhile the wings of his nose tweaked between his fingers.",
	"Looking up again he set them free.",
	"I am happier than you are, he said.",
	"We have committed many errors and many sins.",
	"A woman brought sin into the world.",
	"A woman too brought Parnell low.",
	"Many errors, many failures but not the one sin.",
	"I am a struggler now at the end of my days.",
	"But I will fight for the right till the end.",
	"For Ulster will fight And Ulster will be right.",
	"Stephen raised the sheets in his hand.",
	"Well, sir, he began.",
	"I foresee, Mr Deasy said, that you will not remain here very long at this work.",
	"You were not born to be a teacher, I think.",
	"Perhaps I am wrong.",
	"A learner rather, Stephen said.",
	"And here what will you learn more?",
	"Mr Deasy shook his head.",
	"Who knows?",
	"he said.",
	"To learn one must be humble.",
	"But life is the great teacher.",
	"Stephen rustled the sheets again.",
	"As regards these, he began.",
	"Yes, Mr Deasy said.",
	"You have two copies there.",
	"If you can have them published at once.",
	"Telegraph.",
	"Irish Homestead.",
	"I will try, Stephen said, and let you know tomorrow.",
	"I know two editors slightly.",
	"That will do, Mr Deasy said briskly.",
	"I wrote last night to Mr Field, M.P.",
	"There is a meeting of the cattletraders’ association today at the City Arms hotel.",
	"I asked him to lay my letter before the meeting.",
	"You see if you can get it into your two papers.",
	"What are they?",
	"The Evening Telegraph... —That will do, Mr Deasy said.",
	"There is no time to lose.",
	"Now I have to answer that letter from my cousin.",
	"Good morning, sir, Stephen said, putting the sheets in his pocket.",
	"Thank you.",
	"Not at all, Mr Deasy said as he searched the papers on his desk.",
	"I like to break a lance with you, old as I am.",
	"Good morning, sir, Stephen said again, bowing to his bent back.",
	"The lions couchant on the pillars as he passed out through the gate: toothless terrors.",
	"Still I will help him in his fight.",
	"Mulligan will dub me a new name: the bullockbefriending bard.",
	"Mr Dedalus!",
	"Running after me.",
	"No more letters, I hope.",
	"Just one moment.",
	"Yes, sir, Stephen said, turning back at the gate.",
	"Mr Deasy halted, breathing hard and swallowing his breath.",
	"I just wanted to say, he said.",
	"Ireland, they say, has the honour of being the only country which never persecuted the jews.",
	"Do you know that?",
	"No.",
	"And do you know why?",
	"He frowned sternly on the bright air.",
	"Why, sir?",
	"Stephen asked, beginning to smile.",
	"Because she never let them in, Mr Deasy said solemnly.",
	"A coughball of laughter leaped from his throat dragging after it a rattling chain of phlegm.",
	"He turned back quickly, coughing, laughing, his lifted arms waving to the air.",
	"That’s why.",
	"On his wise shoulders through the checkerwork of leaves the sun flung spangles, dancing coins.",
	"[ 3 ] Ineluctable modality of the visible: at least that if no more, thought through my eyes.",
	"Signatures of all things I am here to read, seaspawn and seawrack, the nearing tide, that rusty boot.",
	"Snotgreen, bluesilver, rust: coloured signs.",
	"Limits of the diaphane.",
	"But he adds: in bodies.",
	"Then he was aware of them bodies before of them coloured.",
	"How?",
	"By knocking his sconce against them, sure.",
	"Go easy.",
	"Bald he was and a millionaire, maestro di color che sanno.",
	"Limit of the diaphane in.",
	"Why in?",
	"Diaphane, adiaphane.",
	"If you can put your five fingers through it it is a gate, if not a door.",
	"Shut your eyes and see.",
	"Stephen closed his eyes to hear his boots crush crackling wrack and shells.",
	"You are walking through it howsomever.",
	"I am, a stride at a time.",
	"A very short space of time through very short times of space.",
	"Five, six: the nacheinander.",
	"Exactly: and that is the ineluctable modality of the audible.",
	"Open your eyes.",
	"No.",
	"Jesus!",
	"If I fell over a cliff that beetles o’er his base, fell through the nebeneinander ineluctably!",
	"I am getting on nicely in the dark.",
	"My ash sword hangs at my side.",
	"Tap with it: they do.",
	"My two feet in his boots are at the ends of his legs, nebeneinander.",
	"Sounds solid: made by the mallet of Los Demiurgos.",
	"Am I walking into eternity along Sandymount strand?",
	"Crush, crack, crick, crick.",
	"Wild sea money.",
	"Dominie Deasy kens them a’.",
	"Won’t you come to Sandymount, Madeline the mare?",
	"Rhythm begins, you see.",
	"I hear.",
	"A catalectic tetrameter of iambs marching.",
	"No, agallop: deline the mare.",
	"Open your eyes now.",
	"I will.",
	"One moment.",
	"Has all vanished since?",
	"If I open and am for ever in the black adiaphane.",
	"Basta!",
	"I will see if I can see.",
	"See now.",
	"There all the time without you: and ever shall be, world without end.",
	"Like me, like Algy, coming down to our mighty mother.",
	"Number one swung lourdily her midwife’s bag, the other’s gamp poked in the beach.",
	"From the liberties, out for the day.",
	"Mrs Florence MacCabe, relict of the late Patk MacCabe, deeply lamented, of Bride Street.",
	"One of her sisterhood lugged me squealing into life.",
	"Creation from nothing.",
	"What has she in the bag?",
	"A misbirth with a trailing navelcord, hushed in ruddy wool.",
	"The cords of all link back, strandentwining cable of all flesh.",
	"That is why mystic monks.",
	"Will you be as gods?",
	"Gaze in your omphalos.",
	"Hello.",
	"Kinch here.",
	"Put me on to Edenville.",
	"Aleph, alpha: nought, nought, one.",
	"Spouse and helpmate of Adam Kadmon: Heva, naked Eve.",
	"She had no navel.",
	"Gaze.",
	"Womb of sin.",
	"Wombed in sin darkness I was too, made not begotten.",
	"By them, the man with my voice and my eyes and a ghostwoman with ashes on her breath.",
	"They clasped and sundered, did the coupler’s will.",
	"From before the ages He willed me and now may not will me away or ever.",
	"A lex eterna stays about Him.",
	"Is that then the divine substance wherein Father and Son are consubstantial?",
	"Where is poor dear Arius to try conclusions?",
	"Warring his life long upon the contransmagnificandjewbangtantiality.",
	"Illstarred heresiarch!",
	"In a Greek watercloset he breathed his last: euthanasia.",
	"Airs romped round him, nipping and eager airs.",
	"They are coming, waves.",
	"The whitemaned seahorses, champing, brightwindbridled, the steeds of Mananaan.",
	"I mustn’t forget his letter for the press.",
	"And after?",
	"The Ship, half twelve.",
	"By the way go easy with that money like a good young imbecile.",
	"Yes, I must.",
	"His pace slackened.",
	"Here.",
	"Am I going to aunt Sara’s or not?",
	"My consubstantial father’s voice.",
	"Did you see anything of your artist brother Stephen lately?",
	"No?",
	"Sure he’s not down in Strasburg terrace with his aunt Sally?",
	"Couldn’t he fly a bit higher than that, eh?",
	"And and and and tell us, Stephen, how is uncle Si?",
	"O, weeping God, the things I married into!",
	"De boys up in de hayloft.",
	"The drunken little costdrawer and his brother, the cornet player.",
	"Highly respectable gondoliers!",
	"And skeweyed Walter sirring his father, no less!",
	"Sir.",
	"Yes, sir.",
	"No, sir.",
	"Jesus wept: and no wonder, by Christ!",
	"I pull the wheezy bell of their shuttered cottage: and wait.",
	"They take me for a dun, peer out from a coign of vantage.",
	"It’s Stephen, sir.",
	"Let him in.",
	"Let Stephen in.",
	"A bolt drawn back and Walter welcomes me.",
	"We thought you were someone else.",
	"In his broad bed nuncle Richie, pillowed and blanketed, extends over the hillock of his knees a sturdy forearm.",
	"Cleanchested.",
	"He has washed the upper moiety.",
	"Morrow, nephew.",
	"A bogoak frame over his bald head: Wilde’s Requiescat.",
	"The drone of his misleading whistle brings Walter back.",
	"Yes, sir?",
	"Malt for Richie and Stephen, tell mother.",
	"Where is she?",
	"Bathing Crissie, sir.",
	"Papa’s little bedpal.",
	"Lump of love.",
	"No, uncle Richie... —Call me Richie.",
	"Damn your lithia water.",
	"It lowers.",
	"Whusky!",
	"Uncle Richie, really... —Sit down or by the law Harry I’ll knock you down.",
	"Walter squints vainly for a chair.",
	"He has nothing to sit down on, sir.",
	"He has nowhere to put it, you mug.",
	"Bring in our chippendale chair.",
	"Would you like a bite of something?",
	"None of your damned lawdeedaw airs here.",
	"The rich of a rasher fried with a herring?",
	"Sure?",
	"So much the better.",
	"We have nothing in the house but backache pills.",
	"All’erta!",
	"He drones bars of Ferrando’s aria di sortita.",
	"The grandest number, Stephen, in the whole opera.",
	"Listen.",
	"His tuneful whistle sounds again, finely shaded, with rushes of the air, his fists bigdrumming on his padded knees.",
	"This wind is sweeter.",
	"Houses of decay, mine, his and all.",
	"You told the Clongowes gentry you had an uncle a judge and an uncle a general in the army.",
	"Come out of them, Stephen.",
	"Beauty is not there.",
	"Nor in the stagnant bay of Marsh’s library where you read the fading prophecies of Joachim Abbas.",
	"For whom?",
	"The hundredheaded rabble of the cathedral close.",
	"Houyhnhnm, horsenostrilled.",
	"The oval equine faces, Temple, Buck Mulligan, Foxy Campbell, Lanternjaws.",
	"Abbas father, furious dean, what offence laid fire to their brains?",
	"Paff!",
	"Descende, calve, ut ne nimium decalveris.",
	"Get down, baldpoll!",
	"And at the same instant perhaps a priest round the corner is elevating it.",
	"Dringdring!",
	"And two streets off another locking it into a pyx.",
	"Dringadring!",
	"And in a ladychapel another taking housel all to his own cheek.",
	"Dringdring!",
	"Down, up, forward, back.",
	"Dan Occam thought of that, invincible doctor.",
	"A misty English morning the imp hypostasis tickled his brain.",
	"Cousin Stephen, you will never be a saint.",
	"Isle of saints.",
	"You were awfully holy, weren’t you?",
	"You prayed to the Blessed Virgin that you might not have a red nose.",
	"O si, certo!",
	"Sell your soul for that, do, dyed rags pinned round a squaw.",
	"More tell me, more still!",
	"On the top of the Howth tram alone crying to the rain: Naked women!",
	"Naked women!",
	"What about that, eh?",
	"What about what?",
	"What else were they invented for?",
	"Reading two pages apiece of seven books every night, eh?",
	"I was young.",
	"You bowed to yourself in the mirror, stepping forward to applause earnestly, striking face.",
	"Hurray for the Goddamned idiot!",
	"Hray!",
	"No-one saw: tell no-one.",
	"Books you were going to write with letters for titles.",
	"Have you read his F?",
	"O yes, but I prefer Q.",
	"Yes, but W is wonderful.",
	"Someone was to read them there after a few thousand years, a mahamanvantara.",
	"Pico della Mirandola like.",
	"Ay, very like a whale.",
	"The grainy sand had gone from under his feet.",
	"He coasted them, walking warily.",
	"A porterbottle stood up, stogged to its waist, in the cakey sand dough.",
	"A sentinel: isle of dreadful thirst.",
	"Ringsend: wigwams of brown steersmen and master mariners.",
	"Human shells.",
	"He halted.",
	"I have passed the way to aunt Sara’s.",
	"Am I not going there?",
	"Seems not.",
	"No-one about.",
	"He turned northeast and crossed the firmer sand towards the Pigeonhouse.",
	"Qui vous a mis dans cette fichue position?",
	"C’est le pigeon, Joseph.",
	"Patrice, home on furlough, lapped warm milk with me in the bar MacMahon.",
	"Son of the wild goose, Kevin Egan of Paris.",
	"My father’s a bird, he lapped the sweet lait chaud with pink young tongue, plump bunny’s face.",
	"Lap, lapin.",
	"He hopes to win in the gros lots.",
	"About the nature of women he read in Michelet.",
	"But he must send me La Vie de Jésus by M. Léo Taxil.",
	"Lent it to his friend.",
	"C’est tordant, vous savez.",
	"Moi, je suis socialiste.",
	"Je ne crois pas en l’existence de Dieu.",
	"Faut pas le dire à mon père.",
	"Il croit?",
	"Mon père, oui.",
	"Schluss.",
	"He laps.",
	"My Latin quarter hat.",
	"God, we simply must dress the character.",
	"I want puce gloves.",
	"You were a student, weren’t you?",
	"Of what in the other devil’s name?",
	"Paysayenn.",
	"P. C. N., you know: physiques, chimiques et naturelles.",
	"Aha.",
	"Eating your groatsworth of mou en civet, fleshpots of Egypt, elbowed by belching cabmen.",
	"Just say in the most natural tone: when I was in Paris; boul’ Mich’’, I used to.",
	"Yes, used to carry punched tickets to prove an alibi if they arrested you for murder somewhere.",
	"Justice.",
	"On the night of the seventeenth of February 1904 the prisoner was seen by two witnesses.",
	"Other fellow did it: other me.",
	"Hat, tie, overcoat, nose.",
	"Lui, c’est moi.",
	"You seem to have enjoyed yourself.",
	"Proudly walking.",
	"Whom were you trying to walk like?",
	"Forget: a dispossessed.",
	"Hunger toothache.",
	"Encore deux minutes.",
	"Look clock.",
	"Must get.",
	"Fermé.",
	"Hired dog!",
	"Shoot him to bloody bits with a bang shotgun, bits man spattered walls all brass buttons.",
	"Bits all khrrrrklak in place clack back.",
	"Not hurt?",
	"O, that’s all right.",
	"Shake hands.",
	"See what I meant, see?",
	"O, that’s all right.",
	"Shake a shake.",
	"O, that’s all only all right.",
	"You were going to do wonders, what?",
	"Missionary to Europe after fiery Columbanus.",
	"Fiacre and Scotus on their creepystools in heaven spilt from their pintpots, loudlatinlaughing: Euge!",
	"Euge!",
	"Pretending to speak broken English as you dragged your valise, porter threepence, across the slimy pier at Newhaven.",
	"Comment?",
	"The aunt thinks you killed your mother.",
	"That’s why she won’t.",
	"Then here’s a health to Mulligan’s aunt And I’ll tell you the reason why.",
	"She always kept things decent in The Hannigan famileye.",
	"His feet marched in sudden proud rhythm over the sand furrows, along by the boulders of the south wall.",
	"He stared at them proudly, piled stone mammoth skulls.",
	"Gold light on sea, on sand, on boulders.",
	"The sun is there, the slender trees, the lemon houses.",
	"Paris rawly waking, crude sunlight on her lemon streets.",
	"Moist pith of farls of bread, the froggreen wormwood, her matin incense, court the air.",
	"Faces of Paris men go by, their wellpleased pleasers, curled conquistadores.",
	"Noon slumbers.",
	"Kevin Egan rolls gunpowder cigarettes through fingers smeared with printer’s ink, sipping his green fairy as Patrice his white.",
	"About us gobblers fork spiced beans down their gullets.",
	"Un demi sétier!",
	"A jet of coffee steam from the burnished caldron.",
	"She serves me at his beck.",
	"Il est irlandais.",
	"Hollandais?",
	"Non fromage.",
	"Deux irlandais, nous, Irlande, vous savez ah, oui!",
	"She thought you wanted a cheese hollandais.",
	"Your postprandial, do you know that word?",
	"Postprandial.",
	"There was a fellow I knew once in Barcelona, queer fellow, used to call it his postprandial.",
	"Well: slainte!",
	"Around the slabbed tables the tangle of wined breaths and grumbling gorges.",
	"His breath hangs over our saucestained plates, the green fairy’s fang thrusting between his lips.",
	"Of Ireland, the Dalcassians, of hopes, conspiracies, of Arthur Griffith now, A E, pimander, good shepherd of men.",
	"To yoke me as his yokefellow, our crimes our common cause.",
	"You’re your father’s son.",
	"I know the voice.",
	"His fustian shirt, sanguineflowered, trembles its Spanish tassels at his secrets.",
	"M. Drumont, famous journalist, Drumont, know what he called queen Victoria?",
	"Old hag with the yellow teeth.",
	"Vieille ogresse with the dents jaunes.",
	"Maud Gonne, beautiful woman, La Patrie, M. Millevoye, Félix Faure, know how he died?",
	"Licentious men.",
	"The froeken, bonne à tout faire, who rubs male nakedness in the bath at Upsala.",
	"Moi faire, she said, Tous les messieurs.",
	"Not this Monsieur, I said.",
	"Most licentious custom.",
	"Bath a most private thing.",
	"I wouldn’t let my brother, not even my own brother, most lascivious thing.",
	"Green eyes, I see you.",
	"Fang, I feel.",
	"Lascivious people.",
	"The blue fuse burns deadly between hands and burns clear.",
	"Loose tobaccoshreds catch fire: a flame and acrid smoke light our corner.",
	"Raw facebones under his peep of day boy’s hat.",
	"How the head centre got away, authentic version.",
	"Got up as a young bride, man, veil, orangeblossoms, drove out the road to Malahide.",
	"Did, faith.",
	"Of lost leaders, the betrayed, wild escapes.",
	"Disguises, clutched at, gone, not here.",
	"Spurned lover.",
	"I was a strapping young gossoon at that time, I tell you.",
	"I’ll show you my likeness one day.",
	"I was, faith.",
	"Shattered glass and toppling masonry.",
	"In gay Paree he hides, Egan of Paris, unsought by any save by me.",
	"Loveless, landless, wifeless.",
	"She is quite nicey comfy without her outcast man, madame in rue Gît-le-Cœur, canary and two buck lodgers.",
	"Peachy cheeks, a zebra skirt, frisky as a young thing’s.",
	"Spurned and undespairing.",
	"Tell Pat you saw me, won’t you?",
	"I wanted to get poor Pat a job one time.",
	"Mon fils, soldier of France.",
	"I taught him to sing The boys of Kilkenny are stout roaring blades.",
	"Know that old lay?",
	"I taught Patrice that.",
	"Old Kilkenny: saint Canice, Strongbow’s castle on the Nore.",
	"Goes like this.",
	"O, O.",
	"He takes me, Napper Tandy, by the hand.",
	"O, O the boys of Kilkenny... Weak wasting hand on mine.",
	"They have forgotten Kevin Egan, not he them.",
	"Remembering thee, O Sion.",
	"He had come nearer the edge of the sea and wet sand slapped his boots.",
	"The new air greeted him, harping in wild nerves, wind of wild air of seeds of brightness.",
	"Here, I am not walking out to the Kish lightship, am I?",
	"He stood suddenly, his feet beginning to sink slowly in the quaking soil.",
	"Turn back.",
	"Turning, he scanned the shore south, his feet sinking again slowly in new sockets.",
	"The cold domed room of the tower waits.",
	"Blue dusk, nightfall, deep blue night.",
	"Who to clear it?",
	"He has the key.",
	"I will not sleep there when this night comes.",
	"A shut door of a silent tower, entombing their blind bodies, the panthersahib and his pointer.",
	"Call: no answer.",
	"He lifted his feet up from the suck and turned back by the mole of boulders.",
	"Take all, keep all.",
	"My soul walks with me, form of forms.",
	"So in the moon’s midwatches I pace the path above the rocks, in sable silvered, hearing Elsinore’s tempting flood.",
	"The flood is following me.",
	"I can watch it flow past from here.",
	"Get back then by the Poolbeg road to the strand there.",
	"A bloated carcass of a dog lay lolled on bladderwrack.",
	"Before him the gunwale of a boat, sunk in sand.",
	"Un coche ensablé Louis Veuillot called Gautier’s prose.",
	"These heavy sands are language tide and wind have silted here.",
	"And these, the stoneheaps of dead builders, a warren of weasel rats.",
	"Hide gold there.",
	"Try it.",
	"You have some.",
	"Sands and stones.",
	"Heavy of the past.",
	"Sir Lout’s toys.",
	"Mind you don’t get one bang on the ear.",
	"I’m the bloody well gigant rolls all them bloody well boulders, bones for my steppingstones.",
	"Feefawfum.",
	"I zmellz de bloodz odz an Iridzman.",
	"A point, live dog, grew into sight running across the sweep of sand.",
	"Lord, is he going to attack me?",
	"Respect his liberty.",
	"You will not be master of others or their slave.",
	"I have my stick.",
	"Sit tight.",
	"From farther away, walking shoreward across from the crested tide, figures, two.",
	"The two maries.",
	"They have tucked it safe mong the bulrushes.",
	"Peekaboo.",
	"I see you.",
	"No, the dog.",
	"He is running back to them.",
	"Who?",
	"Dane vikings, torcs of tomahawks aglitter on their breasts when Malachi wore the collar of gold.",
	"A school of turlehide whales stranded in hot noon, spouting, hobbling in the shallows.",
	"Famine, plague and slaughters.",
	"Their blood is in me, their lusts my waves.",
	"I moved among them on the frozen Liffey, that I, a changeling, among the spluttering resin fires.",
	"I spoke to no-one: none to me.",
	"The dog’s bark ran towards him, stopped, ran back.",
	"Dog of my enemy.",
	"I just simply stood pale, silent, bayed about.",
	"Terribilia meditans.",
	"A primrose doublet, fortune’s knave, smiled on my fear.",
	"For that are you pining, the bark of their applause?",
	"Pretenders: live their lives.",
	"All kings’ sons.",
	"Paradise of pretenders then and now.",
	"He saved men from drowning and you shake at a cur’s yelping.",
	"But the courtiers who mocked Guido in Or san Michele were in their own house.",
	"House of... We don’t want any of your medieval abstrusiosities.",
	"Would you do what he did?",
	"A boat would be near, a lifebuoy.",
	"Natürlich, put there for you.",
	"Would you or would you not?",
	"The man that was drowned nine days ago off Maiden’s rock.",
	"They are waiting for him now.",
	"The truth, spit it out.",
	"I would want to.",
	"I would try.",
	"I am not a strong swimmer.",
	"Water cold soft.",
	"When I put my face into it in the basin at Clongowes.",
	"Can’t see!",
	"Who’s behind me?",
	"Out quickly, quickly!",
	"Do you see the tide flowing quickly in on all sides, sheeting the lows of sand quickly, shellcocoacoloured?",
	"If I had land under my feet.",
	"I want his life still to be his, mine to be mine.",
	"A drowning man.",
	"His human eyes scream to me out of horror of his death.",
	"I... With him together down...",
	"I could not save her.",
	"Waters: bitter death: lost.",
	"A woman and a man.",
	"I see her skirties.",
	"Pinned up, I bet.",
	"Their dog ambled about a bank of dwindling sand, trotting, sniffing on all sides.",
	"Looking for something lost in a past life.",
	"Suddenly he made off like a bounding hare, ears flung back, chasing the shadow of a lowskimming gull.",
	"The man’s shrieked whistle struck his limp ears.",
	"He turned, bounded back, came nearer, trotted on twinkling shanks.",
	"On a field tenney a buck, trippant, proper, unattired.",
	"At the lacefringe of the tide he halted with stiff forehoofs, seawardpointed ears.",
	"His snout lifted barked at the wavenoise, herds of seamorse.",
	"Cocklepickers.",
	"They waded a little way in the water and, stooping, soused their bags and, lifting them again, waded out.",
	"His speckled body ambled ahead of them and then loped off at a calf’s gallop.",
	"The carcass lay on his path.",
	"Dogskull, dogsniff, eyes on the ground, moves to one great goal.",
	"Ah, poor dogsbody!",
	"Here lies poor dogsbody’s body.",
	"Tatters!",
	"Out of that, you mongrel!",
	"He slunk back in a curve.",
	"Doesn’t see me.",
	"He trotted forward and, lifting again his hindleg, pissed quick short at an unsmelt rock.",
	"The simple pleasures of the poor.",
	"His hindpaws then scattered the sand: then his forepaws dabbled and delved.",
	"Something he buried there, his grandmother.",
	"After he woke me last night same dream or was it?",
	"Wait.",
	"Open hallway.",
	"Street of harlots.",
	"Remember.",
	"Haroun al Raschid.",
	"I am almosting it.",
	"That man led me, spoke.",
	"I was not afraid.",
	"The melon he had he held against my face.",
	"Smiled: creamfruit smell.",
	"That was the rule, said.",
	"In.",
	"Come.",
	"Red carpet spread.",
	"You will see who.",
	"Shouldering their bags they trudged, the red Egyptians.",
	"His blued feet out of turnedup trousers slapped the clammy sand, a dull brick muffler strangling his unshaven neck.",
	"With woman steps she followed: the ruffian and his strolling mort.",
	"Spoils slung at her back.",
	"Loose sand and shellgrit crusted her bare feet.",
	"About her windraw face hair trailed.",
	"Behind her lord, his helpmate, bing awast to Romeville.",
	"When night hides her body’s flaws calling under her brown shawl from an archway where dogs have mired.",
	"Her fancyman is treating two Royal Dublins in O’Loughlin’s of Blackpitts.",
	"Buss her, wap in rogues’ rum lingo, for, O, my dimber wapping dell!",
	"A shefiend’s whiteness under her rancid rags.",
	"Fumbally’s lane that night: the tanyard smells.",
	"White thy fambles, red thy gan And thy quarrons dainty is.",
	"Couch a hogshead with me then.",
	"In the darkmans clip and kiss.",
	"Morose delectation Aquinas tunbelly calls this, frate porcospino.",
	"Unfallen Adam rode and not rutted.",
	"Call away let him: thy quarrons dainty is.",
	"Language no whit worse than his.",
	"Monkwords, marybeads jabber on their girdles: roguewords, tough nuggets patter in their pockets.",
	"Passing now.",
	"A side eye at my Hamlet hat.",
	"If I were suddenly naked here as I sit?",
	"I am not.",
	"She trudges, schlepps, trains, drags, trascines her load.",
	"A tide westering, moondrawn, in her wake.",
	"Tides, myriadislanded, within her, blood not mine, oinopa ponton, a winedark sea.",
	"Behold the handmaid of the moon.",
	"In sleep the wet sign calls her hour, bids her rise.",
	"Bridebed, childbed, bed of death, ghostcandled.",
	"Omnis caro ad te veniet.",
	"He comes, pale vampire, through storm his eyes, his bat sails bloodying the sea, mouth to her mouth’s kiss.",
	"Here.",
	"Put a pin in that chap, will you?",
	"My tablets.",
	"Mouth to her kiss.",
	"No.",
	"Must be two of em.",
	"Glue em well.",
	"Mouth to her mouth’s kiss.",
	"His lips lipped and mouthed fleshless lips of air: mouth to her moomb.",
	"Oomb, allwombing tomb.",
	"His mouth moulded issuing breath, unspeeched: ooeeehah: roar of cataractic planets, globed, blazing, roaring wayawayawayawayaway.",
	"Paper.",
	"The banknotes, blast them.",
	"Old Deasy’s letter.",
	"Here.",
	"Thanking you for the hospitality tear the blank end off.",
	"Turning his back to the sun he bent over far to a table of rock and scribbled words.",
	"That’s twice I forgot to take slips from the library counter.",
	"His shadow lay over the rocks as he bent, ending.",
	"Why not endless till the farthest star?",
	"Darkly they are there behind this light, darkness shining in the brightness, delta of Cassiopeia, worlds.",
	"I throw this ended shadow from me, manshape ineluctable, call it back.",
	"Endless, would it be mine, form of my form?",
	"Who watches me here?",
	"Who ever anywhere will read these written words?",
	"Signs on a white field.",
	"Somewhere to someone in your flutiest voice.",
	"Hold hard.",
	"Coloured on a flat: yes, that’s right.",
	"Flat I see, then think distance, near, far, flat I see, east, back.",
	"Ah, see now!",
	"Falls back suddenly, frozen in stereoscope.",
	"Click does the trick.",
	"You find my words dark.",
	"Darkness is in our souls do you not think?",
	"Flutier.",
	"She trusts me, her hand gentle, the longlashed eyes.",
	"Now where the blue hell am I bringing her beyond the veil?",
	"Into the ineluctable modality of the ineluctable visuality.",
	"She, she, she.",
	"What she?",
	"Keen glance you gave her.",
	"Wrist through the braided jesse of her sunshade.",
	"She lives in Leeson park with a grief and kickshaws, a lady of letters.",
	"Talk that to someone else, Stevie: a pickmeup.",
	"Bet she wears those curse of God stays suspenders and yellow stockings, darned with lumpy wool.",
	"Talk about apple dumplings, piuttosto.",
	"Where are your wits?",
	"Touch me.",
	"Soft eyes.",
	"Soft soft soft hand.",
	"I am lonely here.",
	"O, touch me soon, now.",
	"What is that word known to all men?",
	"I am quiet here alone.",
	"Sad too.",
	"Touch, touch me.",
	"That is Kevin Egan’s movement I made, nodding for his nap, sabbath sleep.",
	"Et vidit Deus.",
	"Et erant valde bona.",
	"Alo!",
	"Bonjour.",
	"Welcome as the flowers in May.",
	"Under its leaf he watched through peacocktwittering lashes the southing sun.",
	"I am caught in this burning scene.",
	"Pan’s hour, the faunal noon.",
	"Among gumheavy serpentplants, milkoozing fruits, where on the tawny waters leaves lie wide.",
	"Pain is far.",
	"And no more turn aside and brood.",
	"His gaze brooded on his broadtoed boots, a buck’s castoffs, nebeneinander.",
	"He counted the creases of rucked leather wherein another’s foot had nested warm.",
	"The foot that beat the ground in tripudium, foot I dislove.",
	"But you were delighted when Esther Osvalt’s shoe went on you: girl I knew in Paris.",
	"Tiens, quel petit pied!",
	"Staunch friend, a brother soul: Wilde’s love that dare not speak its name.",
	"His arm: Cranly’s arm.",
	"He now will leave me.",
	"And the blame?",
	"As I am.",
	"As I am.",
	"All or not at all.",
	"In long lassoes from the Cock lake the water flowed full, covering greengoldenly lagoons of sand, rising, flowing.",
	"My ashplant will float away.",
	"I shall wait.",
	"No, they will pass on, passing, chafing against the low rocks, swirling, passing.",
	"Better get this job over quick.",
	"Listen: a fourworded wavespeech: seesoo, hrss, rsseeiss, ooos.",
	"Vehement breath of waters amid seasnakes, rearing horses, rocks.",
	"In cups of rocks it slops: flop, slop, slap: bounded in barrels.",
	"And, spent, its speech ceases.",
	"It flows purling, widely flowing, floating foampool, flower unfurling.",
	"Day by day: night by night: lifted, flooded and let fall.",
	"Lord, they are weary; and, whispered to, they sigh.",
	"To no end gathered; vainly then released, forthflowing, wending back: loom of the moon.",
	"Five fathoms out there.",
	"Full fathom five thy father lies.",
	"At one, he said.",
	"Found drowned.",
	"High water at Dublin bar.",
	"Driving before it a loose drift of rubble, fanshoals of fishes, silly shells.",
	"A corpse rising saltwhite from the undertow, bobbing a pace a pace a porpoise landward.",
	"There he is.",
	"Hook it quick.",
	"Pull.",
	"Sunk though he be beneath the watery floor.",
	"We have him.",
	"Easy now.",
	"Bag of corpsegas sopping in foul brine.",
	"A quiver of minnows, fat of a spongy titbit, flash through the slits of his buttoned trouserfly.",
	"God becomes man becomes fish becomes barnacle goose becomes featherbed mountain.",
	"Dead breaths I living breathe, tread dead dust, devour a urinous offal from all dead.",
	"A seachange this, brown eyes saltblue.",
	"Seadeath, mildest of all deaths known to man.",
	"Old Father Ocean.",
	"Prix de Paris: beware of imitations.",
	"Just you give it a fair trial.",
	"We enjoyed ourselves immensely.",
	"Come.",
	"I thirst.",
	"Clouding over.",
	"No black clouds anywhere, are there?",
	"Thunderstorm.",
	"Allbright he falls, proud lightning of the intellect, Lucifer, dico, qui nescit occasum.",
	"No.",
	"My cockle hat and staff and hismy sandal shoon.",
	"Where?",
	"To evening lands.",
	"Evening will find itself.",
	"He took the hilt of his ashplant, lunging with it softly, dallying still.",
	"Yes, evening will find itself in me, without me.",
	"All days make their end.",
	"By the way next when is it Tuesday will be the longest day.",
	"Of all the glad new year, mother, the rum tum tiddledy tum.",
	"Lawn Tennyson, gentleman poet.",
	"Già.",
	"For the old hag with the yellow teeth.",
	"And Monsieur Drumont, gentleman journalist.",
	"Già.",
	"My teeth are very bad.",
	"Why, I wonder.",
	"Feel.",
	"That one is going too.",
	"Shells.",
	"Ought I go to a dentist, I wonder, with that money?",
	"That one.",
	"This.",
	"Toothless Kinch, the superman.",
	"Why is that, I wonder, or does it mean something perhaps?",
	"My handkerchief.",
	"He threw it.",
	"I remember.",
	"Did I not take it up?",
	"His hand groped vainly in his pockets.",
	"No, I didn’t.",
	"Better buy one.",
	"He laid the dry snot picked from his nostril on a ledge of rock, carefully.",
	"For the rest let look who will.",
	"Behind.",
	"Perhaps there is someone.",
	"He turned his face over a shoulder, rere regardant.",
	"II — [ 4 ] Mr Leopold Bloom ate with relish the inner organs of beasts and fowls.",
	"He liked thick giblet soup, nutty gizzards, a stuffed roast heart, liverslices fried with crustcrumbs, fried hencods’ roes.",
	"Gelid light and air were in the kitchen but out of doors gentle summer morning everywhere.",
	"Made him feel a bit peckish.",
	"The coals were reddening.",
	"Another slice of bread and butter: three, four: right.",
	"She didn’t like her plate full.",
	"Right.",
	"He turned from the tray, lifted the kettle off the hob and set it sideways on the fire.",
	"It sat there, dull and squat, its spout stuck out.",
	"Cup of tea soon.",
	"Good.",
	"Mouth dry.",
	"The cat walked stiffly round a leg of the table with tail on high.",
	"Mkgnao!",
	"O, there you are, Mr Bloom said, turning from the fire.",
	"The cat mewed in answer and stalked again stiffly round a leg of the table, mewing.",
	"Just how she stalks over my writingtable.",
	"Prr.",
	"Scratch my head.",
	"Prr.",
	"Mr Bloom watched curiously, kindly the lithe black form.",
	"He bent down to her, his hands on his knees.",
	"Milk for the pussens, he said.",
	"Mrkgnao!",
	"the cat cried.",
	"They call them stupid.",
	"They understand what we say better than we understand them.",
	"She understands all she wants to.",
	"Vindictive too.",
	"Cruel.",
	"Her nature.",
	"Curious mice never squeal.",
	"Seem to like it.",
	"Wonder what I look like to her.",
	"Height of a tower?",
	"No, she can jump me.",
	"Afraid of the chickens she is, he said mockingly.",
	"Afraid of the chookchooks.",
	"I never saw such a stupid pussens as the pussens.",
	"Mrkrgnao!",
	"the cat said loudly.",
	"She blinked up out of her avid shameclosing eyes, mewing plaintively and long, showing him her milkwhite teeth.",
	"He watched the dark eyeslits narrowing with greed till her eyes were green stones.",
	"Gurrhr!",
	"she cried, running to lap.",
	"He watched the bristles shining wirily in the weak light as she tipped three times and licked lightly.",
	"Wonder is it true if you clip them they can’t mouse after.",
	"Why?",
	"They shine in the dark, perhaps, the tips.",
	"Or kind of feelers in the dark, perhaps.",
	"He listened to her licking lap.",
	"Ham and eggs, no.",
	"No good eggs with this drouth.",
	"Want pure fresh water.",
	"Thursday: not a good day either for a mutton kidney at Buckley’s.",
	"Fried with butter, a shake of pepper.",
	"Better a pork kidney at Dlugacz’s.",
	"While the kettle is boiling.",
	"She lapped slower, then licking the saucer clean.",
	"Why are their tongues so rough?",
	"To lap better, all porous holes.",
	"Nothing she can eat?",
	"He glanced round him.",
	"No.",
	"On quietly creaky boots he went up the staircase to the hall, paused by the bedroom door.",
	"She might like something tasty.",
	"Thin bread and butter she likes in the morning.",
	"Still perhaps: once in a way.",
	"He said softly in the bare hall: I’m going round the corner.",
	"Be back in a minute.",
	"And when he had heard his voice say it he added: You don’t want anything for breakfast?",
	"A sleepy soft grunt answered: Mn.",
	"No.",
	"She didn’t want anything.",
	"Must get those settled really.",
	"Pity.",
	"All the way from Gibraltar.",
	"Forgotten any little Spanish she knew.",
	"Wonder what her father gave for it.",
	"Old style.",
	"Ah yes!",
	"of course.",
	"Bought it at the governor’s auction.",
	"Got a short knock.",
	"Hard as nails at a bargain, old Tweedy.",
	"Yes, sir.",
	"At Plevna that was.",
	"I rose from the ranks, sir, and I’m proud of it.",
	"Still he had brains enough to make that corner in stamps.",
	"Now that was farseeing.",
	"Stamps: stickyback pictures.",
	"Daresay lots of officers are in the swim too.",
	"Course they do.",
	"The sweated legend in the crown of his hat told him mutely: Plasto’s high grade ha.",
	"He peeped quickly inside the leather headband.",
	"White slip of paper.",
	"Quite safe.",
	"On the doorstep he felt in his hip pocket for the latchkey.",
	"Not there.",
	"In the trousers I left off.",
	"Must get it.",
	"Potato I have.",
	"Creaky wardrobe.",
	"No use disturbing her.",
	"She turned over sleepily that time.",
	"Looked shut.",
	"All right till I come back anyhow.",
	"He crossed to the bright side, avoiding the loose cellarflap of number seventyfive.",
	"The sun was nearing the steeple of George’s church.",
	"Be a warm day I fancy.",
	"Specially in these black clothes feel it more.",
	"Black conducts, reflects, (refracts is it?",
	"), the heat.",
	"But I couldn’t go in that light suit.",
	"Make a picnic of it.",
	"His eyelids sank quietly often as he walked in happy warmth.",
	"Boland’s breadvan delivering with trays our daily but she prefers yesterday’s loaves turnovers crisp crowns hot.",
	"Makes you feel young.",
	"Somewhere in the east: early morning: set off at dawn.",
	"Travel round in front of the sun, steal a day’s march on him.",
	"Keep it up for ever never grow a day older technically.",
	"Wander through awned streets.",
	"Turbaned faces going by.",
	"Dark caves of carpet shops, big man, Turko the terrible, seated crosslegged, smoking a coiled pipe.",
	"Cries of sellers in the streets.",
	"Drink water scented with fennel, sherbet.",
	"Dander along all day.",
	"Might meet a robber or two.",
	"Well, meet him.",
	"Getting on to sundown.",
	"The shadows of the mosques among the pillars: priest with a scroll rolled up.",
	"A shiver of the trees, signal, the evening wind.",
	"I pass on.",
	"Fading gold sky.",
	"A mother watches me from her doorway.",
	"She calls her children home in their dark language.",
	"High wall: beyond strings twanged.",
	"Night sky, moon, violet, colour of Molly’s new garters.",
	"Strings.",
	"Listen.",
	"A girl playing one of those instruments what do you call them: dulcimers.",
	"I pass.",
	"Probably not a bit like it really.",
	"Kind of stuff you read: in the track of the sun.",
	"Sunburst on the titlepage.",
	"He smiled, pleasing himself.",
	"He prolonged his pleased smile.",
	"Ikey touch that: homerule sun rising up in the northwest.",
	"He approached Larry O’Rourke’s.",
	"From the cellar grating floated up the flabby gush of porter.",
	"Through the open doorway the bar squirted out whiffs of ginger, teadust, biscuitmush.",
	"Good house, however: just the end of the city traffic.",
	"For instance M’Auley’s down there: n. g. as position.",
	"Baldhead over the blind.",
	"Cute old codger.",
	"No use canvassing him for an ad.",
	"Still he knows his own business best.",
	"Simon Dedalus takes him off to a tee with his eyes screwed up.",
	"Do you know what I’m going to tell you?",
	"What’s that, Mr O’Rourke?",
	"Do you know what?",
	"The Russians, they’d only be an eight o’clock breakfast for the Japanese.",
	"Stop and say a word: about the funeral perhaps.",
	"Sad thing about poor Dignam, Mr O’Rourke.",
	"Turning into Dorset street he said freshly in greeting through the doorway: Good day, Mr O’Rourke.",
	"Good day to you.",
	"Lovely weather, sir.",
	"‘Tis all that.",
	"Where do they get the money?",
	"Coming up redheaded curates from the county Leitrim, rinsing empties and old man in the cellar.",
	"Then, lo and behold, they blossom out as Adam Findlaters or Dan Tallons.",
	"Then think of the competition.",
	"General thirst.",
	"Good puzzle would be cross Dublin without passing a pub.",
	"Save it they can’t.",
	"Off the drunks perhaps.",
	"Put down three and carry five.",
	"What is that, a bob here and there, dribs and drabs.",
	"On the wholesale orders perhaps.",
	"Doing a double shuffle with the town travellers.",
	"Square it you with the boss and we’ll split the job, see?",
	"How much would that tot to off the porter in the month?",
	"Say ten barrels of stuff.",
	"Say he got ten per cent off.",
	"O more.",
	"Fifteen.",
	"He passed Saint Joseph’s National school.",
	"Brats’ clamour.",
	"Windows open.",
	"Fresh air helps memory.",
	"Or a lilt.",
	"Ahbeesee defeegee kelomen opeecue rustyouvee doubleyou.",
	"Boys are they?",
	"Yes.",
	"Inishturk.",
	"Inishark.",
	"Inishboffin.",
	"At their joggerfry.",
	"Mine.",
	"Slieve Bloom.",
	"He halted before Dlugacz’s window, staring at the hanks of sausages, polonies, black and white.",
	"Fifteen multiplied by.",
	"The figures whitened in his mind, unsolved: displeased, he let them fade.",
	"A kidney oozed bloodgouts on the willowpatterned dish: the last.",
	"He stood by the nextdoor girl at the counter.",
	"Would she buy it too, calling the items from a slip in her hand?",
	"Chapped: washingsoda.",
	"And a pound and a half of Denny’s sausages.",
	"His eyes rested on her vigorous hips.",
	"Woods his name is.",
	"Wonder what he does.",
	"Wife is oldish.",
	"New blood.",
	"No followers allowed.",
	"Strong pair of arms.",
	"Whacking a carpet on the clothesline.",
	"She does whack it, by George.",
	"The way her crooked skirt swings at each whack.",
	"The ferreteyed porkbutcher folded the sausages he had snipped off with blotchy fingers, sausagepink.",
	"Sound meat there: like a stallfed heifer.",
	"Can become ideal winter sanatorium.",
	"Moses Montefiore.",
	"I thought he was.",
	"Farmhouse, wall round it, blurred cattle cropping.",
	"He held the page from him: interesting: read it nearer, the title, the blurred cropping cattle, the page rustling.",
	"A young white heifer.",
	"He held the page aslant patiently, bending his senses and his will, his soft subject gaze at rest.",
	"The crooked skirt swinging, whack by whack by whack.",
	"The porkbutcher snapped two sheets from the pile, wrapped up her prime sausages and made a red grimace.",
	"Now, my miss, he said.",
	"She tendered a coin, smiling boldly, holding her thick wrist out.",
	"Thank you, my miss.",
	"And one shilling threepence change.",
	"For you, please?",
	"Mr Bloom pointed quickly.",
	"To catch up and walk behind her if she went slowly, behind her moving hams.",
	"Pleasant to see first thing in the morning.",
	"Hurry up, damn it.",
	"Make hay while the sun shines.",
	"She stood outside the shop in sunlight and sauntered lazily to the right.",
	"He sighed down his nose: they never understand.",
	"Sodachapped hands.",
	"Crusted toenails too.",
	"Brown scapulars in tatters, defending her both ways.",
	"The sting of disregard glowed to weak pleasure within his breast.",
	"For another: a constable off duty cuddling her in Eccles’ Lane.",
	"They like them sizeable.",
	"Prime sausage.",
	"O please, Mr Policeman, I’m lost in the wood.",
	"Threepence, please.",
	"His hand accepted the moist tender gland and slid it into a sidepocket.",
	"Then it fetched up three coins from his trousers’ pocket and laid them on the rubber prickles.",
	"They lay, were read quickly and quickly slid, disc by disc, into the till.",
	"Thank you, sir.",
	"Another time.",
	"A speck of eager fire from foxeyes thanked him.",
	"He withdrew his gaze after an instant.",
	"No: better not: another time.",
	"Good morning, he said, moving away.",
	"Good morning, sir.",
	"No sign.",
	"Gone.",
	"What matter?",
	"He walked back along Dorset street, reading gravely.",
	"Agendath Netaim: planters’ company.",
	"To purchase waste sandy tracts from Turkish government and plant with eucalyptus trees.",
	"Excellent for shade, fuel and construction.",
	"Orangegroves and immense melonfields north of Jaffa.",
	"You pay eighty marks and they plant a dunam of land for you with olives, oranges, almonds or citrons.",
	"Olives cheaper: oranges need artificial irrigation.",
	"Every year you get a sending of the crop.",
	"Your name entered for life as owner in the book of the union.",
	"Can pay ten down and the balance in yearly instalments.",
	"Bleibtreustrasse 34, Berlin, W. 15.",
	"Nothing doing.",
	"Still an idea behind it.",
	"He looked at the cattle, blurred in silver heat.",
	"Silverpowdered olivetrees.",
	"Quiet long days: pruning, ripening.",
	"Olives are packed in jars, eh?",
	"I have a few left from Andrews.",
	"Molly spitting them out.",
	"Knows the taste of them now.",
	"Oranges in tissue paper packed in crates.",
	"Citrons too.",
	"Wonder is poor Citron still in Saint Kevin’s parade.",
	"And Mastiansky with the old cither.",
	"Pleasant evenings we had then.",
	"Molly in Citron’s basketchair.",
	"Nice to hold, cool waxen fruit, hold in the hand, lift it to the nostrils and smell the perfume.",
	"Like that, heavy, sweet, wild perfume.",
	"Always the same, year after year.",
	"They fetched high prices too, Moisel told me.",
	"Arbutus place: Pleasants street: pleasant old times.",
	"Must be without a flaw, he said.",
	"Coming all that way: Spain, Gibraltar, Mediterranean, the Levant.",
	"There’s whatdoyoucallhim out of.",
	"How do you?",
	"Doesn’t see.",
	"Chap you know just to salute bit of a bore.",
	"His back is like that Norwegian captain’s.",
	"Wonder if I’ll meet him today.",
	"Watering cart.",
	"To provoke the rain.",
	"On earth as it is in heaven.",
	"A cloud began to cover the sun slowly, wholly.",
	"Grey.",
	"Far.",
	"No, not like that.",
	"A barren land, bare waste.",
	"Vulcanic lake, the dead sea: no fish, weedless, sunk deep in the earth.",
	"No wind could lift those waves, grey metal, poisonous foggy waters.",
	"Brimstone they called it raining down: the cities of the plain: Sodom, Gomorrah, Edom.",
	"All dead names.",
	"A dead sea in a dead land, grey and old.",
	"Old now.",
	"It bore the oldest, the first race.",
	"A bent hag crossed from Cassidy’s, clutching a naggin bottle by the neck.",
	"The oldest people.",
	"Wandered far away over all the earth, captivity to captivity, multiplying, dying, being born everywhere.",
	"It lay there now.",
	"Now it could bear no more.",
	"Dead: an old woman’s: the grey sunken cunt of the world.",
	"Desolation.",
	"Grey horror seared his flesh.",
	"Folding the page into his pocket he turned into Eccles street, hurrying homeward.",
	"Cold oils slid along his veins, chilling his blood: age crusting him with a salt cloak.",
	"Well, I am here now.",
	"Yes, I am here now.",
	"Morning mouth bad images.",
	"Got up wrong side of the bed.",
	"Must begin again those Sandow’s exercises.",
	"On the hands down.",
	"Blotchy brown brick houses.",
	"Number eighty still unlet.",
	"Why is that?",
	"Valuation is only twentyeight.",
	"Towers, Battersby, North, MacArthur: parlour windows plastered with bills.",
	"Plasters on a sore eye.",
	"To smell the gentle smoke of tea, fume of the pan, sizzling butter.",
	"Be near her ample bedwarmed flesh.",
	"Yes, yes.",
	"Quick warm sunlight came running from Berkeley road, swiftly, in slim sandals, along the brightening footpath.",
	"Runs, she runs to meet me, a girl with gold hair on the wind.",
	"Two letters and a card lay on the hallfloor.",
	"He stooped and gathered them.",
	"Mrs Marion Bloom.",
	"His quickened heart slowed at once.",
	"Bold hand.",
	"Mrs Marion.",
	"Poldy!",
	"Entering the bedroom he halfclosed his eyes and walked through warm yellow twilight towards her tousled head.",
	"Who are the letters for?",
	"He looked at them.",
	"Mullingar.",
	"Milly.",
	"A letter for me from Milly, he said carefully, and a card to you.",
	"And a letter for you.",
	"He laid her card and letter on the twill bedspread near the curve of her knees.",
	"Do you want the blind up?",
	"That do?",
	"he asked, turning.",
	"She was reading the card, propped on her elbow.",
	"She got the things, she said.",
	"He waited till she had laid the card aside and curled herself back slowly with a snug sigh.",
	"Hurry up with that tea, she said.",
	"I’m parched.",
	"The kettle is boiling, he said.",
	"As he went down the kitchen stairs she called: Poldy!",
	"What?",
	"Scald the teapot.",
	"On the boil sure enough: a plume of steam from the spout.",
	"While he unwrapped the kidney the cat mewed hungrily against him.",
	"Give her too much meat she won’t mouse.",
	"Say they won’t eat pork.",
	"Kosher.",
	"Here.",
	"He let the bloodsmeared paper fall to her and dropped the kidney amid the sizzling butter sauce.",
	"Pepper.",
	"He sprinkled it through his fingers ringwise from the chipped eggcup.",
	"Then he slit open his letter, glancing down the page and over.",
	"Thanks: new tam: Mr Coghlan: lough Owel picnic: young student: Blazes Boylan’s seaside girls.",
	"The tea was drawn.",
	"He filled his own moustachecup, sham crown Derby, smiling.",
	"Silly Milly’s birthday gift.",
	"Only five she was then.",
	"No, wait: four.",
	"I gave her the amberoid necklace she broke.",
	"Putting pieces of folded brown paper in the letterbox for her.",
	"He smiled, pouring.",
	"O, Milly Bloom, you are my darling.",
	"You are my lookingglass from night to morning.",
	"I’d rather have you without a farthing Than Katey Keogh with her ass and garden.",
	"Poor old professor Goodwin.",
	"Dreadful old case.",
	"Still he was a courteous old chap.",
	"Oldfashioned way he used to bow Molly off the platform.",
	"And the little mirror in his silk hat.",
	"The night Milly brought it into the parlour.",
	"O, look what I found in professor Goodwin’s hat!",
	"All we laughed.",
	"Sex breaking out even then.",
	"Pert little piece she was.",
	"He prodded a fork into the kidney and slapped it over: then fitted the teapot on the tray.",
	"Its hump bumped as he took it up.",
	"Everything on it?",
	"Bread and butter, four, sugar, spoon, her cream.",
	"Yes.",
	"He carried it upstairs, his thumb hooked in the teapot handle.",
	"What a time you were!",
	"she said.",
	"She set the brasses jingling as she raised herself briskly, an elbow on the pillow.",
	"The warmth of her couched body rose on the air, mingling with the fragrance of the tea she poured.",
	"A strip of torn envelope peeped from under the dimpled pillow.",
	"In the act of going he stayed to straighten the bedspread.",
	"Who was the letter from?",
	"he asked.",
	"Bold hand.",
	"Marion.",
	"O, Boylan, she said.",
	"He’s bringing the programme.",
	"What are you singing?",
	"Là ci darem with J. C. Doyle, she said, and Love’s Old Sweet Song.",
	"Her full lips, drinking, smiled.",
	"Rather stale smell that incense leaves next day.",
	"Like foul flowerwater.",
	"Would you like the window open a little?",
	"She doubled a slice of bread into her mouth, asking: What time is the funeral?",
	"Eleven, I think, he answered.",
	"I didn’t see the paper.",
	"Following the pointing of her finger he took up a leg of her soiled drawers from the bed.",
	"No?",
	"Then, a twisted grey garter looped round a stocking: rumpled, shiny sole.",
	"No: that book.",
	"Other stocking.",
	"Her petticoat.",
	"It must have fell down, she said.",
	"He felt here and there.",
	"Voglio e non vorrei.",
	"Wonder if she pronounces that right: voglio.",
	"Not in the bed.",
	"Must have slid down.",
	"He stooped and lifted the valance.",
	"The book, fallen, sprawled against the bulge of the orangekeyed chamberpot.",
	"Show here, she said.",
	"I put a mark in it.",
	"There’s a word I wanted to ask you.",
	"Met him what?",
	"he asked.",
	"Here, she said.",
	"What does that mean?",
	"He leaned downward and read near her polished thumbnail.",
	"Metempsychosis?",
	"Yes.",
	"Who’s he when he’s at home?",
	"Metempsychosis, he said, frowning.",
	"It’s Greek: from the Greek.",
	"That means the transmigration of souls.",
	"O, rocks!",
	"she said.",
	"Tell us in plain words.",
	"He smiled, glancing askance at her mocking eyes.",
	"The same young eyes.",
	"The first night after the charades.",
	"Dolphin’s Barn.",
	"He turned over the smudged pages.",
	"Ruby: the Pride of the Ring.",
	"Hello.",
	"Illustration.",
	"Fierce Italian with carriagewhip.",
	"Must be Ruby pride of the on the floor naked.",
	"Sheet kindly lent.",
	"The monster Maffei desisted and flung his victim from him with an oath.",
	"Cruelty behind it all.",
	"Doped animals.",
	"Trapeze at Hengler’s.",
	"Had to look the other way.",
	"Mob gaping.",
	"Break your neck and we’ll break our sides.",
	"Families of them.",
	"Bone them young so they metamspychosis.",
	"That we live after death.",
	"Our souls.",
	"That a man’s soul after he dies.",
	"Dignam’s soul... —Did you finish it?",
	"he asked.",
	"Yes, she said.",
	"There’s nothing smutty in it.",
	"Is she in love with the first fellow all the time?",
	"Never read it.",
	"Do you want another?",
	"Yes.",
	"Get another of Paul de Kock’s.",
	"Nice name he has.",
	"She poured more tea into her cup, watching it flow sideways.",
	"Must get that Capel street library book renewed or they’ll write to Kearney, my guarantor.",
	"Reincarnation: that’s the word.",
	"Some people believe, he said, that we go on living in another body after death, that we lived before.",
	"They call it reincarnation.",
	"That we all lived before on the earth thousands of years ago or some other planet.",
	"They say we have forgotten it.",
	"Some say they remember their past lives.",
	"The sluggish cream wound curdling spirals through her tea.",
	"Better remind her of the word: metempsychosis.",
	"An example would be better.",
	"An example?",
	"The Bath of the Nymph over the bed.",
	"Given away with the Easter number of Photo Bits: Splendid masterpiece in art colours.",
	"Tea before you put milk in.",
	"Not unlike her with her hair down: slimmer.",
	"Three and six I gave for the frame.",
	"She said it would look nice over the bed.",
	"Naked nymphs: Greece: and for instance all the people that lived then.",
	"He turned the pages back.",
	"Metempsychosis, he said, is what the ancient Greeks called it.",
	"They used to believe you could be changed into an animal or a tree, for instance.",
	"What they called nymphs, for example.",
	"Her spoon ceased to stir up the sugar.",
	"She gazed straight before her, inhaling through her arched nostrils.",
	"There’s a smell of burn, she said.",
	"Did you leave anything on the fire?",
	"The kidney!",
	"he cried suddenly.",
	"Pungent smoke shot up in an angry jet from a side of the pan.",
	"Only a little burnt.",
	"He tossed it off the pan on to a plate and let the scanty brown gravy trickle over it.",
	"Cup of tea now.",
	"He sat down, cut and buttered a slice of the loaf.",
	"He shore away the burnt flesh and flung it to the cat.",
	"Then he put a forkful into his mouth, chewing with discernment the toothsome pliant meat.",
	"Done to a turn.",
	"A mouthful of tea.",
	"Then he cut away dies of bread, sopped one in the gravy and put it in his mouth.",
	"What was that about some young student and a picnic?",
	"Dearest Papli Thanks ever so much for the lovely birthday present.",
	"It suits me splendid.",
	"Everyone says I am quite the belle in my new tam.",
	"I got mummy’s lovely box of creams and am writing.",
	"They are lovely.",
	"I am getting on swimming in the photo business now.",
	"Mr Coghlan took one of me and Mrs. Will send when developed.",
	"We did great biz yesterday.",
	"Fair day and all the beef to the heels were in.",
	"We are going to lough Owel on Monday with a few friends to make a scrap picnic.",
	"Give my love to mummy and to yourself a big kiss and thanks.",
	"I hear them at the piano downstairs.",
	"There is to be a concert in the Greville Arms on Saturday.",
	"Tell him silly Milly sends my best respects.",
	"I must now close with fondest love Your fond daughter Milly P. S. Excuse bad writing am in hurry.",
	"Byby.",
	"M. Fifteen yesterday.",
	"Curious, fifteenth of the month too.",
	"Her first birthday away from home.",
	"Separation.",
	"Remember the summer morning she was born, running to knock up Mrs Thornton in Denzille street.",
	"Jolly old woman.",
	"Lot of babies she must have helped into the world.",
	"She knew from the first poor little Rudy wouldn’t live.",
	"Well, God is good, sir.",
	"She knew at once.",
	"He would be eleven now if he had lived.",
	"His vacant face stared pityingly at the postscript.",
	"Excuse bad writing.",
	"Hurry.",
	"Piano downstairs.",
	"Coming out of her shell.",
	"Row with her in the XL Café about the bracelet.",
	"Wouldn’t eat her cakes or speak or look.",
	"Saucebox.",
	"He sopped other dies of bread in the gravy and ate piece after piece of kidney.",
	"Twelve and six a week.",
	"Not much.",
	"Still, she might do worse.",
	"Music hall stage.",
	"Young student.",
	"He drank a draught of cooler tea to wash down his meal.",
	"Then he read the letter again: twice.",
	"O, well: she knows how to mind herself.",
	"But if not?",
	"No, nothing has happened.",
	"Of course it might.",
	"Wait in any case till it does.",
	"A wild piece of goods.",
	"Her slim legs running up the staircase.",
	"Destiny.",
	"Ripening now.",
	"Vain: very.",
	"He smiled with troubled affection at the kitchen window.",
	"Day I caught her in the street pinching her cheeks to make them red.",
	"Anemic a little.",
	"Was given milk too long.",
	"On the Erin’s King that day round the Kish.",
	"Damned old tub pitching about.",
	"Not a bit funky.",
	"Her pale blue scarf loose in the wind with her hair.",
	"All dimpled cheeks and curls, Your head it simply swirls.",
	"Seaside girls.",
	"Torn envelope.",
	"Hands stuck in his trousers’ pockets, jarvey off for the day, singing.",
	"Friend of the family.",
	"Swurls, he says.",
	"Pier with lamps, summer evening, band.",
	"Those girls, those girls, Those lovely seaside girls.",
	"Milly too.",
	"Young kisses: the first.",
	"Far away now past.",
	"Mrs Marion.",
	"Reading, lying back now, counting the strands of her hair, smiling, braiding.",
	"A soft qualm, regret, flowed down his backbone, increasing.",
	"Will happen, yes.",
	"Prevent.",
	"Useless: can’t move.",
	"Girl’s sweet light lips.",
	"Will happen too.",
	"He felt the flowing qualm spread over him.",
	"Useless to move now.",
	"Lips kissed, kissing, kissed.",
	"Full gluey woman’s lips.",
	"Better where she is down there: away.",
	"Occupy her.",
	"Wanted a dog to pass the time.",
	"Might take a trip down there.",
	"August bank holiday, only two and six return.",
	"Six weeks off, however.",
	"Might work a press pass.",
	"Or through M’Coy.",
	"She looked back at him, mewing.",
	"Wants to go out.",
	"Wait before a door sometime it will open.",
	"Let her wait.",
	"Has the fidgets.",
	"Electric.",
	"Thunder in the air.",
	"Was washing at her ear with her back to the fire too.",
	"He felt heavy, full: then a gentle loosening of his bowels.",
	"He stood up, undoing the waistband of his trousers.",
	"The cat mewed to him.",
	"Miaow!",
	"he said in answer.",
	"Wait till I’m ready.",
	"Heaviness: hot day coming.",
	"Too much trouble to fag up the stairs to the landing.",
	"A paper.",
	"He liked to read at stool.",
	"Hope no ape comes knocking just as I’m.",
	"In the tabledrawer he found an old number of Titbits.",
	"He folded it under his armpit, went to the door and opened it.",
	"The cat went up in soft bounds.",
	"Ah, wanted to go upstairs, curl up in a ball on the bed.",
	"Listening, he heard her voice: Come, come, pussy.",
	"Come.",
	"He went out through the backdoor into the garden: stood to listen towards the next garden.",
	"No sound.",
	"Perhaps hanging clothes out to dry.",
	"The maid was in the garden.",
	"Fine morning.",
	"He bent down to regard a lean file of spearmint growing by the wall.",
	"Make a summerhouse here.",
	"Scarlet runners.",
	"Virginia creepers.",
	"Want to manure the whole place over, scabby soil.",
	"A coat of liver of sulphur.",
	"All soil like that without dung.",
	"Household slops.",
	"Loam, what is this that is?",
	"The hens in the next garden: their droppings are very good top dressing.",
	"Best of all though are the cattle, especially when they are fed on those oilcakes.",
	"Mulch of dung.",
	"Best thing to clean ladies’ kid gloves.",
	"Dirty cleans.",
	"Ashes too.",
	"Reclaim the whole place.",
	"Grow peas in that corner there.",
	"Lettuce.",
	"Always have fresh greens then.",
	"Still gardens have their drawbacks.",
	"That bee or bluebottle here Whitmonday.",
	"He walked on.",
	"Where is my hat, by the way?",
	"Must have put it back on the peg.",
	"Or hanging up on the floor.",
	"Funny I don’t remember that.",
	"Hallstand too full.",
	"Four umbrellas, her raincloak.",
	"Picking up the letters.",
	"Drago’s shopbell ringing.",
	"Queer I was just thinking that moment.",
	"Brown brillantined hair over his collar.",
	"Just had a wash and brushup.",
	"Wonder have I time for a bath this morning.",
	"Tara street.",
	"Chap in the paybox there got away James Stephens, they say.",
	"O’Brien.",
	"Deep voice that fellow Dlugacz has.",
	"Agendath what is it?",
	"Now, my miss.",
	"Enthusiast.",
	"He kicked open the crazy door of the jakes.",
	"Better be careful not to get these trousers dirty for the funeral.",
	"He went in, bowing his head under the low lintel.",
	"Leaving the door ajar, amid the stench of mouldy limewash and stale cobwebs he undid his braces.",
	"Before sitting down he peered through a chink up at the nextdoor windows.",
	"The king was in his countinghouse.",
	"Nobody.",
	"Asquat on the cuckstool he folded out his paper, turning its pages over on his bared knees.",
	"Something new and easy.",
	"No great hurry.",
	"Keep it a bit.",
	"Our prize titbit: Matcham’s Masterstroke.",
	"Written by Mr Philip Beaufoy, Playgoers’ Club, London.",
	"Payment at the rate of one guinea a column has been made to the writer.",
	"Three and a half.",
	"Three pounds three.",
	"Three pounds, thirteen and six.",
	"Quietly he read, restraining himself, the first column and, yielding but resisting, began the second.",
	"Hope it’s not too big bring on piles again.",
	"No, just right.",
	"So.",
	"Ah!",
	"Costive.",
	"One tabloid of cascara sagrada.",
	"Life might be so.",
	"It did not move or touch him but it was something quick and neat.",
	"Print anything now.",
	"Silly season.",
	"He read on, seated calm above his own rising smell.",
	"Neat certainly.",
	"Matcham often thinks of the masterstroke by which he won the laughing witch who now.",
	"Begins and ends morally.",
	"Hand in hand.",
	"Smart.",
	"Might manage a sketch.",
	"By Mr and Mrs L. M. Bloom.",
	"Invent a story for some proverb.",
	"Which?",
	"Time I used to try jotting down on my cuff what she said dressing.",
	"Dislike dressing together.",
	"Nicked myself shaving.",
	"Biting her nether lip, hooking the placket of her skirt.",
	"Timing her.",
	"9.15.",
	"Did Roberts pay you yet?",
	"9.20.",
	"What had Gretta Conroy on?",
	"9.23.",
	"What possessed me to buy this comb?",
	"9.24.",
	"I’m swelled after that cabbage.",
	"A speck of dust on the patent leather of her boot.",
	"Rubbing smartly in turn each welt against her stockinged calf.",
	"Morning after the bazaar dance when May’s band played Ponchielli’s dance of the hours.",
	"Explain that: morning hours, noon, then evening coming on, then night hours.",
	"Washing her teeth.",
	"That was the first night.",
	"Her head dancing.",
	"Her fansticks clicking.",
	"Is that Boylan well off?",
	"He has money.",
	"Why?",
	"I noticed he had a good rich smell off his breath dancing.",
	"No use humming then.",
	"Allude to it.",
	"Strange kind of music that last night.",
	"The mirror was in shadow.",
	"She rubbed her handglass briskly on her woollen vest against her full wagging bub.",
	"Peering into it.",
	"Lines in her eyes.",
	"It wouldn’t pan out somehow.",
	"Evening hours, girls in grey gauze.",
	"Night hours then: black with daggers and eyemasks.",
	"Poetical idea: pink, then golden, then grey, then black.",
	"Still, true to life also.",
	"Day: then the night.",
	"He tore away half the prize story sharply and wiped himself with it.",
	"Then he girded up his trousers, braced and buttoned himself.",
	"He pulled back the jerky shaky door of the jakes and came forth from the gloom into the air.",
	"What time is the funeral?",
	"Better find out in the paper.",
	"A creak and a dark whirr in the air high up.",
	"The bells of George’s church.",
	"They tolled the hour: loud dark iron.",
	"Heigho!",
	"Heigho!",
	"Heigho!",
	"Heigho!",
	"Heigho!",
	"Heigho!",
	"Quarter to.",
	"There again: the overtone following through the air.",
	"A third.",
	"Poor Dignam!",
	"Could have given that address too.",
	"And past the sailors’ home.",
	"He turned from the morning noises of the quayside and walked through Lime street.",
	"By Brady’s cottages a boy for the skins lolled, his bucket of offal linked, smoking a chewed fagbutt.",
	"A smaller girl with scars of eczema on her forehead eyed him, listlessly holding her battered caskhoop.",
	"Tell him if he smokes he won’t grow.",
	"O let him!",
	"His life isn’t such a bed of roses.",
	"Waiting outside pubs to bring da home.",
	"Come home to ma, da.",
	"Slack hour: won’t be many there.",
	"He crossed Townsend street, passed the frowning face of Bethel.",
	"El, yes: house of: Aleph, Beth.",
	"And past Nichols’ the undertaker.",
	"At eleven it is.",
	"Time enough.",
	"Daresay Corny Kelleher bagged the job for O’Neill’s.",
	"Singing with his eyes shut.",
	"Corny.",
	"Met her once in the park.",
	"In the dark.",
	"What a lark.",
	"Police tout.",
	"Her name and address she then told with my tooraloom tooraloom tay.",
	"O, surely he bagged it.",
	"Bury him cheap in a whatyoumaycall.",
	"With my tooraloom, tooraloom, tooraloom, tooraloom.",
	"Rather warm.",
	"Tea.",
	"Must get some from Tom Kernan.",
	"Couldn’t ask him at a funeral, though.",
	"Very warm morning.",
	"Under their dropped lids his eyes found the tiny bow of the leather headband inside his high grade ha.",
	"Just there.",
	"His right hand came down into the bowl of his hat.",
	"His fingers found quickly a card behind the headband and transferred it to his waistcoat pocket.",
	"So warm.",
	"His right hand once more more slowly went over his brow and hair.",
	"Then he put on his hat again, relieved: and read again: choice blend, made of the finest Ceylon brands.",
	"The far east.",
	"Wonder is it like that.",
	"Those Cinghalese lobbing about in the sun in dolce far niente, not doing a hand’s turn all day.",
	"Sleep six months out of twelve.",
	"Too hot to quarrel.",
	"Influence of the climate.",
	"Lethargy.",
	"Flowers of idleness.",
	"The air feeds most.",
	"Azotes.",
	"Hothouse in Botanic gardens.",
	"Sensitive plants.",
	"Waterlilies.",
	"Petals too tired to.",
	"Sleeping sickness in the air.",
	"Walk on roseleaves.",
	"Imagine trying to eat tripe and cowheel.",
	"Where was the chap I saw in that picture somewhere?",
	"Ah yes, in the dead sea floating on his back, reading a book with a parasol open.",
	"Couldn’t sink if you tried: so thick with salt.",
	"Or is it the volume is equal to the weight?",
	"It’s a law something like that.",
	"Vance in High school cracking his fingerjoints, teaching.",
	"The college curriculum.",
	"Cracking curriculum.",
	"What is weight really when you say the weight?",
	"Thirtytwo feet per second per second.",
	"Law of falling bodies: per second per second.",
	"They all fall to the ground.",
	"The earth.",
	"It’s the force of gravity of the earth is the weight.",
	"He turned away and sauntered across the road.",
	"How did she walk with her sausages?",
	"Like that something.",
	"Careless air: just drop in to see.",
	"Per second per second.",
	"Per second for every second it means.",
	"From the curbstone he darted a keen glance through the door of the postoffice.",
	"Too late box.",
	"Post here.",
	"No-one.",
	"In.",
	"He handed the card through the brass grill.",
	"Are there any letters for me?",
	"he asked.",
	"No answer probably.",
	"Went too far last time.",
	"The postmistress handed him back through the grill his card with a letter.",
	"He thanked her and glanced rapidly at the typed envelope.",
	"Henry Flower Esq, c/o P. O. Westland Row, City.",
	"Answered anyhow.",
	"He slipped card and letter into his sidepocket, reviewing again the soldiers on parade.",
	"Where’s old Tweedy’s regiment?",
	"Castoff soldier.",
	"There: bearskin cap and hackle plume.",
	"No, he’s a grenadier.",
	"Pointed cuffs.",
	"There he is: royal Dublin fusiliers.",
	"Redcoats.",
	"Too showy.",
	"That must be why the women go after them.",
	"Uniform.",
	"Easier to enlist and drill.",
	"Maud Gonne’s letter about taking them off O’Connell street at night: disgrace to our Irish capital.",
	"Griffith’s paper is on the same tack now: an army rotten with venereal disease: overseas or halfseasover empire.",
	"Half baked they look: hypnotised like.",
	"Eyes front.",
	"Mark time.",
	"Table: able.",
	"Bed: ed.",
	"The King’s own.",
	"Never see him dressed up as a fireman or a bobby.",
	"A mason, yes.",
	"He strolled out of the postoffice and turned to the right.",
	"Talk: as if that would mend matters.",
	"Women will pay a lot of heed, I don’t think.",
	"His fingers drew forth the letter the letter and crumpled the envelope in his pocket.",
	"Something pinned on: photo perhaps.",
	"Hair?",
	"No.",
	"M’Coy.",
	"Get rid of him quickly.",
	"Take me out of my way.",
	"Hate company when you.",
	"Hello, Bloom.",
	"Where are you off to?",
	"Hello, M’Coy.",
	"Nowhere in particular.",
	"How’s the body?",
	"Fine.",
	"How are you?",
	"Just keeping alive, M’Coy said.",
	"I see you’re... —O, no, Mr Bloom said.",
	"Poor Dignam, you know.",
	"The funeral is today.",
	"To be sure, poor fellow.",
	"So it is.",
	"What time?",
	"A photo it isn’t.",
	"A badge maybe.",
	"E...eleven, Mr Bloom answered.",
	"I must try to get out there, M’Coy said.",
	"Eleven, is it?",
	"I only heard it last night.",
	"Who was telling me?",
	"Holohan.",
	"You know Hoppy?",
	"I know.",
	"Mr Bloom gazed across the road at the outsider drawn up before the door of the Grosvenor.",
	"The porter hoisted the valise up on the well.",
	"She stood still, waiting, while the man, husband, brother, like her, searched his pockets for change.",
	"Stylish kind of coat with that roll collar, warm for a day like this, looks like blanketcloth.",
	"Careless stand of her with her hands in those patch pockets.",
	"Like that haughty creature at the polo match.",
	"Women all for caste till you touch the spot.",
	"Handsome is and handsome does.",
	"Reserved about to yield.",
	"The honourable Mrs and Brutus is an honourable man.",
	"Possess her once take the starch out of her.",
	"Just down there in Conway’s we were.",
	"Doran Lyons in Conway’s.",
	"She raised a gloved hand to her hair.",
	"In came Hoppy.",
	"Having a wet.",
	"Clearly I can see today.",
	"Moisture about gives long sight perhaps.",
	"Talking of one thing or another.",
	"Lady’s hand.",
	"Which side will she get up?",
	"And he said: Sad thing about our poor friend Paddy!",
	"What Paddy?",
	"I said.",
	"Poor little Paddy Dignam, he said.",
	"Off to the country: Broadstone probably.",
	"High brown boots with laces dangling.",
	"Wellturned foot.",
	"What is he foostering over that change for?",
	"Sees me looking.",
	"Eye out for other fellow always.",
	"Good fallback.",
	"Two strings to her bow.",
	"Why?",
	"I said.",
	"What’s wrong with him?",
	"I said.",
	"Proud: rich: silk stockings.",
	"Yes, Mr Bloom said.",
	"He moved a little to the side of M’Coy’s talking head.",
	"Getting up in a minute.",
	"What’s wrong with him?",
	"He said.",
	"He’s dead, he said.",
	"And, faith, he filled up.",
	"Is it Paddy Dignam?",
	"I said.",
	"I couldn’t believe it when I heard it.",
	"I was with him no later than Friday last or Thursday was it in the Arch.",
	"Yes, he said.",
	"He’s gone.",
	"He died on Monday, poor fellow.",
	"Watch!",
	"Watch!",
	"Silk flash rich stockings white.",
	"Watch!",
	"A heavy tramcar honking its gong slewed between.",
	"Lost it.",
	"Curse your noisy pugnose.",
	"Feels locked out of it.",
	"Paradise and the peri.",
	"Always happening like that.",
	"The very moment.",
	"Girl in Eustace street hallway Monday was it settling her garter.",
	"Her friend covering the display of.",
	"Esprit de corps.",
	"Well, what are you gaping at?",
	"Yes, yes, Mr Bloom said after a dull sigh.",
	"Another gone.",
	"One of the best, M’Coy said.",
	"The tram passed.",
	"They drove off towards the Loop Line bridge, her rich gloved hand on the steel grip.",
	"Flicker, flicker: the laceflare of her hat in the sun: flicker, flick.",
	"Wife well, I suppose?",
	"M’Coy’s changed voice said.",
	"O, yes, Mr Bloom said.",
	"Tiptop, thanks.",
	"He unrolled the newspaper baton idly and read idly: What is home without Plumtree’s Potted Meat?",
	"Incomplete.",
	"With it an abode of bliss.",
	"My missus has just got an engagement.",
	"At least it’s not settled yet.",
	"Valise tack again.",
	"By the way no harm.",
	"I’m off that, thanks.",
	"Mr Bloom turned his largelidded eyes with unhasty friendliness.",
	"My wife too, he said.",
	"She’s going to sing at a swagger affair in the Ulster Hall, Belfast, on the twentyfifth.",
	"That so?",
	"M’Coy said.",
	"Glad to hear that, old man.",
	"Who’s getting it up?",
	"Mrs Marion Bloom.",
	"Not up yet.",
	"Queen was in her bedroom eating bread and.",
	"No book.",
	"Blackened court cards laid along her thigh by sevens.",
	"Dark lady and fair man.",
	"Letter.",
	"Cat furry black ball.",
	"Torn strip of envelope.",
	"Sweeeet song.",
	"There’s a committee formed.",
	"Part shares and part profits.",
	"M’Coy nodded, picking at his moustache stubble.",
	"O, well, he said.",
	"That’s good news.",
	"He moved to go.",
	"Well, glad to see you looking fit, he said.",
	"Meet you knocking around.",
	"Yes, Mr Bloom said.",
	"Tell you what, M’Coy said.",
	"You might put down my name at the funeral, will you?",
	"I’d like to go but I mightn’t be able, you see.",
	"You just shove in my name if I’m not there, will you?",
	"I’ll do that, Mr Bloom said, moving to get off.",
	"That’ll be all right.",
	"Right, M’Coy said brightly.",
	"Thanks, old man.",
	"I’d go if I possibly could.",
	"Well, tolloll.",
	"Just C. P. M’Coy will do.",
	"That will be done, Mr Bloom answered firmly.",
	"Didn’t catch me napping that wheeze.",
	"The quick touch.",
	"Soft mark.",
	"I’d like my job.",
	"Valise I have a particular fancy for.",
	"Leather.",
	"Capped corners, rivetted edges, double action lever lock.",
	"Mr Bloom, strolling towards Brunswick street, smiled.",
	"My missus has just got an.",
	"Reedy freckled soprano.",
	"Cheeseparing nose.",
	"Nice enough in its way: for a little ballad.",
	"No guts in it.",
	"You and me, don’t you know: in the same boat.",
	"Softsoaping.",
	"Give you the needle that would.",
	"Can’t he hear the difference?",
	"Think he’s that way inclined a bit.",
	"Against my grain somehow.",
	"Thought that Belfast would fetch him.",
	"I hope that smallpox up there doesn’t get worse.",
	"Suppose she wouldn’t let herself be vaccinated again.",
	"Your wife and my wife.",
	"Wonder is he pimping after me?",
	"Mr Bloom stood at the corner, his eyes wandering over the multicoloured hoardings.",
	"Cantrell and Cochrane’s Ginger Ale (Aromatic).",
	"Clery’s Summer Sale.",
	"No, he’s going on straight.",
	"Hello.",
	"Leah tonight.",
	"Mrs Bandmann Palmer.",
	"Like to see her again in that.",
	"Hamlet she played last night.",
	"Male impersonator.",
	"Perhaps he was a woman.",
	"Why Ophelia committed suicide.",
	"Poor papa!",
	"How he used to talk of Kate Bateman in that.",
	"Outside the Adelphi in London waited all the afternoon to get in.",
	"Year before I was born that was: sixtyfive.",
	"And Ristori in Vienna.",
	"What is this the right name is?",
	"By Mosenthal it is.",
	"Rachel, is it?",
	"No.",
	"Nathan’s voice!",
	"His son’s voice!",
	"Every word is so deep, Leopold.",
	"Poor papa!",
	"Poor man!",
	"I’m glad I didn’t go into the room to look at his face.",
	"That day!",
	"O, dear!",
	"O, dear!",
	"Ffoo!",
	"Well, perhaps it was best for him.",
	"Mr Bloom went round the corner and passed the drooping nags of the hazard.",
	"No use thinking of it any more.",
	"Nosebag time.",
	"Wish I hadn’t met that M’Coy fellow.",
	"He came nearer and heard a crunching of gilded oats, the gently champing teeth.",
	"Their full buck eyes regarded him as he went by, amid the sweet oaten reek of horsepiss.",
	"Their Eldorado.",
	"Poor jugginses!",
	"Damn all they know or care about anything with their long noses stuck in nosebags.",
	"Too full for words.",
	"Still they get their feed all right and their doss.",
	"Gelded too: a stump of black guttapercha wagging limp between their haunches.",
	"Might be happy all the same that way.",
	"Good poor brutes they look.",
	"Still their neigh can be very irritating.",
	"He drew the letter from his pocket and folded it into the newspaper he carried.",
	"Might just walk into her here.",
	"The lane is safer.",
	"He passed the cabman’s shelter.",
	"Curious the life of drifting cabbies.",
	"All weathers, all places, time or setdown, no will of their own.",
	"Voglio e non.",
	"Like to give them an odd cigarette.",
	"Sociable.",
	"Shout a few flying syllables as they pass.",
	"He hummed: Là ci darem la mano La la lala la la.",
	"He turned into Cumberland street and, going on some paces, halted in the lee of the station wall.",
	"No-one.",
	"Meade’s timberyard.",
	"Piled balks.",
	"Ruins and tenements.",
	"With careful tread he passed over a hopscotch court with its forgotten pickeystone.",
	"Not a sinner.",
	"Near the timberyard a squatted child at marbles, alone, shooting the taw with a cunnythumb.",
	"A wise tabby, a blinking sphinx, watched from her warm sill.",
	"Pity to disturb them.",
	"Mohammed cut a piece out of his mantle not to wake her.",
	"Open it.",
	"And once I played marbles when I went to that old dame’s school.",
	"She liked mignonette.",
	"Mrs Ellis’s.",
	"And Mr?",
	"He opened the letter within the newspaper.",
	"A flower.",
	"I think it’s a.",
	"A yellow flower with flattened petals.",
	"Not annoyed then?",
	"What does she say?",
	"Dear Henry I got your last letter to me and thank you very much for it.",
	"I am sorry you did not like my last letter.",
	"Why did you enclose the stamps?",
	"I am awfully angry with you.",
	"I do wish I could punish you for that.",
	"I called you naughty boy because I do not like that other world.",
	"Please tell me what is the real meaning of that word?",
	"Are you not happy in your home you poor little naughty boy?",
	"I do wish I could do something for you.",
	"Please tell me what you think of poor me.",
	"I often think of the beautiful name you have.",
	"Dear Henry, when will we meet?",
	"I think of you so often you have no idea.",
	"I have never felt myself so much drawn to a man as you.",
	"I feel so bad about.",
	"Please write me a long letter and tell me more.",
	"Remember if you do not I will punish you.",
	"So now you know what I will do to you, you naughty boy, if you do not wrote.",
	"O how I long to meet you.",
	"Henry dear, do not deny my request before my patience are exhausted.",
	"Then I will tell you all.",
	"Goodbye now, naughty darling, I have such a bad headache.",
	"today.",
	"I want to know.",
	"Language of flowers.",
	"They like it because no-one can hear.",
	"Or a poison bouquet to strike him down.",
	"Then walking slowly forward he read the letter again, murmuring here and there a word.",
	"Having read it all he took it from the newspaper and put it back in his sidepocket.",
	"Weak joy opened his lips.",
	"Changed since the first letter.",
	"Wonder did she wrote it herself.",
	"Doing the indignant: a girl of good family like me, respectable character.",
	"Could meet one Sunday after the rosary.",
	"Thank you: not having any.",
	"Usual love scrimmage.",
	"Then running round corners.",
	"Bad as a row with Molly.",
	"Cigar has a cooling effect.",
	"Narcotic.",
	"Go further next time.",
	"Naughty boy: punish: afraid of words, of course.",
	"Brutal, why not?",
	"Try it anyhow.",
	"A bit at a time.",
	"Fingering still the letter in his pocket he drew the pin out of it.",
	"Common pin, eh?",
	"He threw it on the road.",
	"Out of her clothes somewhere: pinned together.",
	"Queer the number of pins they always have.",
	"No roses without thorns.",
	"Flat Dublin voices bawled in his head.",
	"Those two sluts that night in the Coombe, linked together in the rain.",
	"O, Mairy lost the pin of her drawers.",
	"She didn’t know what to do To keep it up, To keep it up.",
	"It?",
	"Them.",
	"Such a bad headache.",
	"Has her roses probably.",
	"Or sitting all day typing.",
	"Eyefocus bad for stomach nerves.",
	"What perfume does your wife use.",
	"Now could you make out a thing like that?",
	"To keep it up.",
	"Martha, Mary.",
	"I saw that picture somewhere I forget now old master or faked for money.",
	"He is sitting in their house, talking.",
	"Mysterious.",
	"Also the two sluts in the Coombe would listen.",
	"To keep it up.",
	"Nice kind of evening feeling.",
	"No more wandering about.",
	"Just loll there: quiet dusk: let everything rip.",
	"Forget.",
	"Tell about places you have been, strange customs.",
	"Must carry a paper goblet next time I go to the trottingmatches.",
	"She listens with big dark soft eyes.",
	"Tell her: more and more: all.",
	"Then a sigh: silence.",
	"Long long long rest.",
	"The shreds fluttered away, sank in the dank air: a white flutter, then all sank.",
	"Henry Flower.",
	"You could tear up a cheque for a hundred pounds in the same way.",
	"Simple bit of paper.",
	"Lord Iveagh once cashed a sevenfigure cheque for a million in the bank of Ireland.",
	"Shows you the money to be made out of porter.",
	"Still the other brother lord Ardilaun has to change his shirt four times a day, they say.",
	"Skin breeds lice or vermin.",
	"A million pounds, wait a moment.",
	"Twopence a pint, fourpence a quart, eightpence a gallon of porter, no, one and fourpence a gallon of porter.",
	"One and four into twenty: fifteen about.",
	"Yes, exactly.",
	"Fifteen millions of barrels of porter.",
	"What am I saying barrels?",
	"Gallons.",
	"About a million barrels all the same.",
	"An incoming train clanked heavily above his head, coach after coach.",
	"Barrels bumped in his head: dull porter slopped and churned inside.",
	"He had reached the open backdoor of All Hallows.",
	"Damn it.",
	"I might have tried to work M’Coy for a pass to Mullingar.",
	"Same notice on the door.",
	"Sermon by the very reverend John Conmee S. J. on saint Peter Claver S. J. and the African Mission.",
	"Prayers for the conversion of Gladstone they had too when he was almost unconscious.",
	"The protestants are the same.",
	"Convert Dr William J. Walsh D.D.",
	"to the true religion.",
	"Save China’s millions.",
	"Wonder how they explain it to the heathen Chinee.",
	"Prefer an ounce of opium.",
	"Celestials.",
	"Rank heresy for them.",
	"Buddha their god lying on his side in the museum.",
	"Taking it easy with hand under his cheek.",
	"Josssticks burning.",
	"Not like Ecce Homo.",
	"Crown of thorns and cross.",
	"Clever idea Saint Patrick the shamrock.",
	"Chopsticks?",
	"Conmee: Martin Cunningham knows him: distinguishedlooking.",
	"They’re taught that.",
	"He’s not going out in bluey specs with the sweat rolling off him to baptise blacks, is he?",
	"The glasses would take their fancy, flashing.",
	"Like to see them sitting round in a ring with blub lips, entranced, listening.",
	"Still life.",
	"Lap it up like milk, I suppose.",
	"The cold smell of sacred stone called him.",
	"He trod the worn steps, pushed the swingdoor and entered softly by the rere.",
	"Something going on: some sodality.",
	"Pity so empty.",
	"Nice discreet place to be next some girl.",
	"Who is my neighbour?",
	"Jammed by the hour to slow music.",
	"That woman at midnight mass.",
	"Seventh heaven.",
	"Women knelt in the benches with crimson halters round their necks, heads bowed.",
	"A batch knelt at the altarrails.",
	"The priest went along by them, murmuring, holding the thing in his hands.",
	"He stopped at each, took out a communion, shook a drop or two (are they in water?)",
	"off it and put it neatly into her mouth.",
	"Her hat and head sank.",
	"Then the next one.",
	"Her hat sank at once.",
	"Then the next one: a small old woman.",
	"The priest bent down to put it into her mouth, murmuring all the time.",
	"Latin.",
	"The next one.",
	"Shut your eyes and open your mouth.",
	"What?",
	"Corpus: body.",
	"Corpse.",
	"Good idea the Latin.",
	"Stupefies them first.",
	"Hospice for the dying.",
	"They don’t seem to chew it: only swallow it down.",
	"Rum idea: eating bits of a corpse.",
	"Why the cannibals cotton to it.",
	"He stood aside watching their blind masks pass down the aisle, one by one, and seek their places.",
	"He approached a bench and seated himself in its corner, nursing his hat and newspaper.",
	"These pots we have to wear.",
	"We ought to have hats modelled on our heads.",
	"Something like those mazzoth: it’s that sort of bread: unleavened shewbread.",
	"Look at them.",
	"Now I bet it makes them feel happy.",
	"Lollipop.",
	"It does.",
	"Yes, bread of angels it’s called.",
	"There’s a big idea behind it, kind of kingdom of God is within you feel.",
	"First communicants.",
	"Hokypoky penny a lump.",
	"Then feel all like one family party, same in the theatre, all in the same swim.",
	"They do.",
	"I’m sure of that.",
	"Not so lonely.",
	"In our confraternity.",
	"Then come out a bit spreeish.",
	"Let off steam.",
	"Thing is if you really believe in it.",
	"Lourdes cure, waters of oblivion, and the Knock apparition, statues bleeding.",
	"Old fellow asleep near that confessionbox.",
	"Hence those snores.",
	"Blind faith.",
	"Safe in the arms of kingdom come.",
	"Lulls all pain.",
	"Wake this time next year.",
	"Suppose he lost the pin of his.",
	"He wouldn’t know what to do to.",
	"Bald spot behind.",
	"Letters on his back: I.N.R.I?",
	"No: I.H.S.",
	"Molly told me one time I asked her.",
	"I have sinned: or no: I have suffered, it is.",
	"And the other one?",
	"Iron nails ran in.",
	"Meet one Sunday after the rosary.",
	"Do not deny my request.",
	"Turn up with a veil and black bag.",
	"Dusk and the light behind her.",
	"Their character.",
	"This very church.",
	"Peter Carey, yes.",
	"No, Peter Claver I am thinking of.",
	"Denis Carey.",
	"And just imagine that.",
	"Wife and six children at home.",
	"And plotting that murder all the time.",
	"Those crawthumpers, now that’s a good name for them, there’s always something shiftylooking about them.",
	"They’re not straight men of business either.",
	"O, no, she’s not here: the flower: no, no.",
	"By the way, did I tear up that envelope?",
	"Yes: under the bridge.",
	"The priest was rinsing out the chalice: then he tossed off the dregs smartly.",
	"Wine.",
	"Doesn’t give them any of it: shew wine: only the other.",
	"Cold comfort.",
	"Queer the whole atmosphere of the.",
	"Quite right.",
	"Perfectly right that is.",
	"Mr Bloom looked back towards the choir.",
	"Not going to be any music.",
	"Pity.",
	"Who has the organ here I wonder?",
	"Molly was in fine voice that day, the Stabat Mater of Rossini.",
	"Father Bernard Vaughan’s sermon first.",
	"Christ or Pilate?",
	"Christ, but don’t keep us all night over it.",
	"Music they wanted.",
	"Footdrill stopped.",
	"Could hear a pin drop.",
	"I told her to pitch her voice against that corner.",
	"I could feel the thrill in the air, the full, the people looking up: Quis est homo.",
	"Some of that old sacred music splendid.",
	"Mercadante: seven last words.",
	"Mozart’s twelfth mass: Gloria in that.",
	"Those old popes keen on music, on art and statues and pictures of all kinds.",
	"Palestrina for example too.",
	"They had a gay old time while it lasted.",
	"Healthy too, chanting, regular hours, then brew liqueurs.",
	"Benedictine.",
	"Green Chartreuse.",
	"Still, having eunuchs in their choir that was coming it a bit thick.",
	"What kind of voice is it?",
	"Must be curious to hear after their own strong basses.",
	"Connoisseurs.",
	"Suppose they wouldn’t feel anything after.",
	"Kind of a placid.",
	"No worry.",
	"Fall into flesh, don’t they?",
	"Gluttons, tall, long legs.",
	"Who knows?",
	"Eunuch.",
	"One way out of it.",
	"He saw the priest bend down and kiss the altar and then face about and bless all the people.",
	"All crossed themselves and stood up.",
	"Mr Bloom glanced about him and then stood up, looking over the risen hats.",
	"Stand up at the gospel of course.",
	"Then all settled down on their knees again and he sat back quietly in his bench.",
	"English.",
	"Throw them the bone.",
	"I remember slightly.",
	"How long since your last mass?",
	"Glorious and immaculate virgin.",
	"Joseph, her spouse.",
	"Peter and Paul.",
	"More interesting if you understood what it was all about.",
	"Wonderful organisation certainly, goes like clockwork.",
	"Confession.",
	"Everyone wants to.",
	"Then I will tell you all.",
	"Penance.",
	"Punish me, please.",
	"Great weapon in their hands.",
	"More than doctor or solicitor.",
	"Woman dying to.",
	"And I schschschschschsch.",
	"And did you chachachachacha?",
	"And why did you?",
	"Look down at her ring to find an excuse.",
	"Whispering gallery walls have ears.",
	"Husband learn to his surprise.",
	"God’s little joke.",
	"Then out she comes.",
	"Repentance skindeep.",
	"Lovely shame.",
	"Pray at an altar.",
	"Hail Mary and Holy Mary.",
	"Flowers, incense, candles melting.",
	"Hide her blushes.",
	"Salvation army blatant imitation.",
	"Reformed prostitute will address the meeting.",
	"How I found the Lord.",
	"Squareheaded chaps those must be in Rome: they work the whole show.",
	"And don’t they rake in the money too?",
	"Bequests also: to the P.P.",
	"for the time being in his absolute discretion.",
	"Masses for the repose of my soul to be said publicly with open doors.",
	"Monasteries and convents.",
	"The priest in that Fermanagh will case in the witnessbox.",
	"No browbeating him.",
	"He had his answer pat for everything.",
	"Liberty and exaltation of our holy mother the church.",
	"The doctors of the church: they mapped out the whole theology of it.",
	"The priest prayed: Blessed Michael, archangel, defend us in the hour of conflict.",
	"Be our safeguard against the wickedness and snares of the devil (may God restrain him, we humbly pray!",
	"The priest and the massboy stood up and walked off.",
	"All over.",
	"The women remained behind: thanksgiving.",
	"Better be shoving along.",
	"Brother Buzz.",
	"Come around with the plate perhaps.",
	"Pay your Easter duty.",
	"He stood up.",
	"Hello.",
	"Were those two buttons of my waistcoat open all the time?",
	"Women enjoy it.",
	"Never tell you.",
	"But we.",
	"Excuse, miss, there’s a (whh!)",
	"just a (whh!)",
	"fluff.",
	"Or their skirt behind, placket unhooked.",
	"Glimpses of the moon.",
	"Annoyed if you don’t.",
	"Why didn’t you tell me before.",
	"Still like you better untidy.",
	"Good job it wasn’t farther south.",
	"He passed, discreetly buttoning, down the aisle and out through the main door into the light.",
	"Trams: a car of Prescott’s dyeworks: a widow in her weeds.",
	"Notice because I’m in mourning myself.",
	"He covered himself.",
	"How goes the time?",
	"Quarter past.",
	"Time enough yet.",
	"Better get that lotion made up.",
	"Where is this?",
	"Ah yes, the last time.",
	"Sweny’s in Lincoln place.",
	"Chemists rarely move.",
	"Their green and gold beaconjars too heavy to stir.",
	"Hamilton Long’s, founded in the year of the flood.",
	"Huguenot churchyard near there.",
	"Visit some day.",
	"He walked southward along Westland row.",
	"But the recipe is in the other trousers.",
	"O, and I forgot that latchkey too.",
	"Bore this funeral affair.",
	"O well, poor fellow, it’s not his fault.",
	"When was it I got it made up last?",
	"Wait.",
	"I changed a sovereign I remember.",
	"First of the month it must have been or the second.",
	"O, he can look it up in the prescriptions book.",
	"The chemist turned back page after page.",
	"Sandy shrivelled smell he seems to have.",
	"Shrunken skull.",
	"And old.",
	"Quest for the philosopher’s stone.",
	"The alchemists.",
	"Drugs age you after mental excitement.",
	"Lethargy then.",
	"Why?",
	"Reaction.",
	"A lifetime in a night.",
	"Gradually changes your character.",
	"Living all the day among herbs, ointments, disinfectants.",
	"All his alabaster lilypots.",
	"Mortar and pestle.",
	"Aq.",
	"Dist.",
	"Fol.",
	"Laur.",
	"Te Virid.",
	"Smell almost cure you like the dentist’s doorbell.",
	"Doctor Whack.",
	"He ought to physic himself a bit.",
	"Electuary or emulsion.",
	"The first fellow that picked an herb to cure himself had a bit of pluck.",
	"Simples.",
	"Want to be careful.",
	"Enough stuff here to chloroform you.",
	"Test: turns blue litmus paper red.",
	"Chloroform.",
	"Overdose of laudanum.",
	"Sleeping draughts.",
	"Lovephiltres.",
	"Paragoric poppysyrup bad for cough.",
	"Clogs the pores or the phlegm.",
	"Poisons the only cures.",
	"Remedy where you least expect it.",
	"Clever of nature.",
	"About a fortnight ago, sir?",
	"Yes, Mr Bloom said.",
	"Lot of time taken up telling your aches and pains.",
	"Sweet almond oil and tincture of benzoin, Mr Bloom said, and then orangeflower water...",
	"It certainly did make her skin so delicate white like wax.",
	"And white wax also, he said.",
	"Brings out the darkness of her eyes.",
	"Skinfood.",
	"One of the old queen’s sons, duke of Albany was it?",
	"had only one skin.",
	"Leopold, yes.",
	"Three we have.",
	"Warts, bunions and pimples to make it worse.",
	"But you want a perfume too.",
	"What perfume does your?",
	"Peau d’Espagne.",
	"That orangeflower water is so fresh.",
	"Nice smell these soaps have.",
	"Pure curd soap.",
	"Time to get a bath round the corner.",
	"Hammam.",
	"Turkish.",
	"Massage.",
	"Dirt gets rolled up in your navel.",
	"Nicer if a nice girl did it.",
	"Also I think I.",
	"Yes I.",
	"Do it in the bath.",
	"Curious longing I.",
	"Water to water.",
	"Combine business with pleasure.",
	"Pity no time for massage.",
	"Feel fresh then all the day.",
	"Funeral be rather glum.",
	"Yes, sir, the chemist said.",
	"That was two and nine.",
	"Have you brought a bottle?",
	"No, Mr Bloom said.",
	"Make it up, please.",
	"I’ll call later in the day and I’ll take one of these soaps.",
	"How much are they?",
	"Fourpence, sir.",
	"Mr Bloom raised a cake to his nostrils.",
	"Sweet lemony wax.",
	"I’ll take this one, he said.",
	"That makes three and a penny.",
	"Yes, sir, the chemist said.",
	"You can pay all together, sir, when you come back.",
	"Good, Mr Bloom said.",
	"He strolled out of the shop, the newspaper baton under his armpit, the coolwrappered soap in his left hand.",
	"At his armpit Bantam Lyons’ voice and hand said: Hello, Bloom.",
	"What’s the best news?",
	"Is that today’s?",
	"Show us a minute.",
	"Shaved off his moustache again, by Jove!",
	"Long cold upper lip.",
	"To look younger.",
	"He does look balmy.",
	"Younger than I am.",
	"Bantam Lyons’s yellow blacknailed fingers unrolled the baton.",
	"Wants a wash too.",
	"Take off the rough dirt.",
	"Good morning, have you used Pears’ soap?",
	"Dandruff on his shoulders.",
	"Scalp wants oiling.",
	"I want to see about that French horse that’s running today, Bantam Lyons said.",
	"Where the bugger is it?",
	"He rustled the pleated pages, jerking his chin on his high collar.",
	"Barber’s itch.",
	"Tight collar he’ll lose his hair.",
	"Better leave him the paper and get shut of him.",
	"You can keep it, Mr Bloom said.",
	"Ascot.",
	"Gold cup.",
	"Wait, Bantam Lyons muttered.",
	"Half a mo.",
	"Maximum the second.",
	"I was just going to throw it away, Mr Bloom said.",
	"Bantam Lyons raised his eyes suddenly and leered weakly.",
	"What’s that?",
	"his sharp voice said.",
	"I say you can keep it, Mr Bloom answered.",
	"I was going to throw it away that moment.",
	"Bantam Lyons doubted an instant, leering: then thrust the outspread sheets back on Mr Bloom’s arms.",
	"I’ll risk it, he said.",
	"Here, thanks.",
	"He sped off towards Conway’s corner.",
	"God speed scut.",
	"Mr Bloom folded the sheets again to a neat square and lodged the soap in it, smiling.",
	"Silly lips of that chap.",
	"Betting.",
	"Regular hotbed of it lately.",
	"Messenger boys stealing to put on sixpence.",
	"Raffle for large tender turkey.",
	"Your Christmas dinner for threepence.",
	"Jack Fleming embezzling to gamble then smuggled off to America.",
	"Keeps a hotel now.",
	"They never come back.",
	"Fleshpots of Egypt.",
	"He walked cheerfully towards the mosque of the baths.",
	"Remind you of a mosque, redbaked bricks, the minarets.",
	"College sports today I see.",
	"Damn bad ad.",
	"Now if they had made it round like a wheel.",
	"Then the spokes: sports, sports, sports: and the hub big: college.",
	"Something to catch the eye.",
	"There’s Hornblower standing at the porter’s lodge.",
	"Keep him on hands: might take a turn in there on the nod.",
	"How do you do, Mr Hornblower?",
	"How do you do, sir?",
	"Heavenly weather really.",
	"If life was always like that.",
	"Cricket weather.",
	"Sit around under sunshades.",
	"Over after over.",
	"Out.",
	"They can’t play it here.",
	"Duck for six wickets.",
	"Still Captain Culler broke a window in the Kildare street club with a slog to square leg.",
	"Donnybrook fair more in their line.",
	"And the skulls we were acracking when M’Carthy took the floor.",
	"Heatwave.",
	"Won’t last.",
	"Always passing, the stream of life, which in the stream of life we trace is dearer than them all.",
	"Enjoy a bath now: clean trough of water, cool enamel, the gentle tepid stream.",
	"This is my body.",
	"[ 6 ] Martin Cunningham, first, poked his silkhatted head into the creaking carriage and, entering deftly, seated himself.",
	"Mr Power stepped in after him, curving his height with care.",
	"Come on, Simon.",
	"After you, Mr Bloom said.",
	"Mr Dedalus covered himself quickly and got in, saying: --Yes, yes.",
	"Are we all here now?",
	"Martin Cunningham asked.",
	"Come along, Bloom.",
	"Mr Bloom entered and sat in the vacant place.",
	"He pulled the door to after him and slammed it twice till it shut tight.",
	"One dragged aside: an old woman peeping.",
	"Nose whiteflattened against the pane.",
	"Thanking her stars she was passed over.",
	"Extraordinary the interest they take in a corpse.",
	"Glad to see us go we give them such trouble coming.",
	"Job seems to suit them.",
	"Huggermugger in corners.",
	"Slop about in slipperslappers for fear he’d wake.",
	"Then getting it ready.",
	"Laying it out.",
	"Molly and Mrs Fleming making the bed.",
	"Pull it more to your side.",
	"Our windingsheet.",
	"Never know who will touch you dead.",
	"Wash and shampoo.",
	"I believe they clip the nails and the hair.",
	"Keep a bit in an envelope.",
	"Grows all the same after.",
	"Unclean job.",
	"All waited.",
	"Nothing was said.",
	"Stowing in the wreaths probably.",
	"I am sitting on something hard.",
	"Ah, that soap: in my hip pocket.",
	"Better shift it out of that.",
	"Wait for an opportunity.",
	"All waited.",
	"Then wheels were heard from in front, turning: then nearer: then horses’ hoofs.",
	"A jolt.",
	"Their carriage began to move, creaking and swaying.",
	"Other hoofs and creaking wheels started behind.",
	"The blinds of the avenue passed and number nine with its craped knocker, door ajar.",
	"At walking pace.",
	"They waited still, their knees jogging, till they had turned and were passing along the tramtracks.",
	"Tritonville road.",
	"Quicker.",
	"The wheels rattled rolling over the cobbled causeway and the crazy glasses shook rattling in the doorframes.",
	"What way is he taking us?",
	"Mr Power asked through both windows.",
	"Irishtown, Martin Cunningham said.",
	"Ringsend.",
	"Brunswick street.",
	"Mr Dedalus nodded, looking out.",
	"That’s a fine old custom, he said.",
	"I am glad to see it has not died out.",
	"All watched awhile through their windows caps and hats lifted by passers.",
	"Respect.",
	"The carriage swerved from the tramtrack to the smoother road past Watery lane.",
	"Mr Bloom at gaze saw a lithe young man, clad in mourning, a wide hat.",
	"There’s a friend of yours gone by, Dedalus, he said.",
	"Who is that?",
	"Your son and heir.",
	"Where is he?",
	"Mr Dedalus said, stretching over across.",
	"Mr Dedalus fell back, saying: Was that Mulligan cad with him?",
	"His fidus Achates!",
	"No, Mr Bloom said.",
	"He was alone.",
	"Mr Bloom smiled joylessly on Ringsend road.",
	"Wallace Bros: the bottleworks: Dodder bridge.",
	"Richie Goulding and the legal bag.",
	"Goulding, Collis and Ward he calls the firm.",
	"His jokes are getting a bit damp.",
	"Great card he was.",
	"Waltzing in Stamer street with Ignatius Gallaher on a Sunday morning, the landlady’s two hats pinned on his head.",
	"Out on the rampage all night.",
	"Beginning to tell on him now: that backache of his, I fear.",
	"Wife ironing his back.",
	"Thinks he’ll cure it with pills.",
	"All breadcrumbs they are.",
	"About six hundred per cent profit.",
	"He’s in with a lowdown crowd, Mr Dedalus snarled.",
	"That Mulligan is a contaminated bloody doubledyed ruffian by all accounts.",
	"His name stinks all over Dublin.",
	"I’ll tickle his catastrophe, believe you me.",
	"He cried above the clatter of the wheels: I won’t have her bastard of a nephew ruin my son.",
	"A counterjumper’s son.",
	"Selling tapes in my cousin, Peter Paul M’Swiney’s.",
	"Not likely.",
	"He ceased.",
	"Noisy selfwilled man.",
	"Full of his son.",
	"He is right.",
	"Something to hand on.",
	"If little Rudy had lived.",
	"See him grow up.",
	"Hear his voice in the house.",
	"Walking beside Molly in an Eton suit.",
	"My son.",
	"Me in his eyes.",
	"Strange feeling it would be.",
	"From me.",
	"Just a chance.",
	"And the sergeant grinning up.",
	"She had that cream gown on with the rip she never stitched.",
	"Give us a touch, Poldy.",
	"God, I’m dying for it.",
	"How life begins.",
	"Got big then.",
	"Had to refuse the Greystones concert.",
	"My son inside her.",
	"I could have helped him on in life.",
	"I could.",
	"Make him independent.",
	"Learn German too.",
	"Are we late?",
	"Mr Power asked.",
	"Ten minutes, Martin Cunningham said, looking at his watch.",
	"Molly.",
	"Milly.",
	"Same thing watered down.",
	"Her tomboy oaths.",
	"O jumping Jupiter!",
	"Ye gods and little fishes!",
	"Still, she’s a dear girl.",
	"Soon be a woman.",
	"Mullingar.",
	"Dearest Papli.",
	"Young student.",
	"Yes, yes: a woman too.",
	"Life, life.",
	"The carriage heeled over and back, their four trunks swaying.",
	"Corny might have given us a more commodious yoke, Mr Power said.",
	"He might, Mr Dedalus said, if he hadn’t that squint troubling him.",
	"Do you follow me?",
	"He closed his left eye.",
	"Martin Cunningham began to brush away crustcrumbs from under his thighs.",
	"What is this, he said, in the name of God?",
	"Crumbs?",
	"Someone seems to have been making a picnic party here lately, Mr Power said.",
	"All raised their thighs and eyed with disfavour the mildewed buttonless leather of the seats.",
	"Mr Dedalus, twisting his nose, frowned downward and said: Unless I’m greatly mistaken.",
	"What do you think, Martin?",
	"It struck me too, Martin Cunningham said.",
	"Mr Bloom set his thigh down.",
	"Glad I took that bath.",
	"Feel my feet quite clean.",
	"But I wish Mrs Fleming had darned these socks better.",
	"Mr Dedalus sighed resignedly.",
	"After all, he said, it’s the most natural thing in the world.",
	"Did Tom Kernan turn up?",
	"Martin Cunningham asked, twirling the peak of his beard gently.",
	"Yes, Mr Bloom answered.",
	"He’s behind with Ned Lambert and Hynes.",
	"And Corny Kelleher himself?",
	"Mr Power asked.",
	"At the cemetery, Martin Cunningham said.",
	"I met M’Coy this morning, Mr Bloom said.",
	"He said he’d try to come.",
	"The carriage halted short.",
	"What’s wrong?",
	"We’re stopped.",
	"Where are we?",
	"Mr Bloom put his head out of the window.",
	"The grand canal, he said.",
	"Gasworks.",
	"Whooping cough they say it cures.",
	"Good job Milly never got it.",
	"Poor children!",
	"Doubles them up black and blue in convulsions.",
	"Shame really.",
	"Got off lightly with illnesses compared.",
	"Only measles.",
	"Flaxseed tea.",
	"Scarlatina, influenza epidemics.",
	"Canvassing for death.",
	"Don’t miss this chance.",
	"Dogs’ home over there.",
	"Poor old Athos!",
	"Be good to Athos, Leopold, is my last wish.",
	"Thy will be done.",
	"We obey them in the grave.",
	"A dying scrawl.",
	"He took it to heart, pined away.",
	"Quiet brute.",
	"Old men’s dogs usually are.",
	"A raindrop spat on his hat.",
	"He drew back and saw an instant of shower spray dots over the grey flags.",
	"Apart.",
	"Curious.",
	"Like through a colander.",
	"I thought it would.",
	"My boots were creaking I remember now.",
	"The weather is changing, he said quietly.",
	"A pity it did not keep up fine, Martin Cunningham said.",
	"Wanted for the country, Mr Power said.",
	"There’s the sun again coming out.",
	"Mr Dedalus, peering through his glasses towards the veiled sun, hurled a mute curse at the sky.",
	"It’s as uncertain as a child’s bottom, he said.",
	"We’re off again.",
	"The carriage turned again its stiff wheels and their trunks swayed gently.",
	"Martin Cunningham twirled more quickly the peak of his beard.",
	"Tom Kernan was immense last night, he said.",
	"And Paddy Leonard taking him off to his face.",
	"O, draw him out, Martin, Mr Power said eagerly.",
	"Wait till you hear him, Simon, on Ben Dollard’s singing of The Croppy Boy.",
	"Immense, Martin Cunningham said pompously.",
	"Trenchant, Mr Power said laughing.",
	"He’s dead nuts on that.",
	"And the retrospective arrangement.",
	"Did you read Dan Dawson’s speech?",
	"Martin Cunningham asked.",
	"I did not then, Mr Dedalus said.",
	"Where is it?",
	"In the paper this morning.",
	"Mr Bloom took the paper from his inside pocket.",
	"That book I must change for her.",
	"No, no, Mr Dedalus said quickly.",
	"Later on please.",
	"is it the chap was in Crosbie and Alleyne’s?",
	"no, Sexton, Urbright.",
	"Inked characters fast fading on the frayed breaking paper.",
	"Thanks to the Little Flower.",
	"Sadly missed.",
	"To the inexpressible grief of his.",
	"Aged 88 after a long and tedious illness.",
	"Month’s mind: Quinlan.",
	"On whose soul Sweet Jesus have mercy.",
	"I tore up the envelope?",
	"Yes.",
	"Where did I put her letter after I read it in the bath?",
	"He patted his waistcoatpocket.",
	"There all right.",
	"Dear Henry fled.",
	"Before my patience are exhausted.",
	"National school.",
	"Meade’s yard.",
	"The hazard.",
	"Only two there now.",
	"Nodding.",
	"Full as a tick.",
	"Too much bone in their skulls.",
	"The other trotting round with a fare.",
	"An hour ago I was passing there.",
	"The jarvies raised their hats.",
	"A pointsman’s back straightened itself upright suddenly against a tramway standard by Mr Bloom’s window.",
	"Couldn’t they invent something automatic so that the wheel itself much handier?",
	"Well but that fellow would lose his job then?",
	"Well but then another fellow would get a job making the new invention?",
	"Antient concert rooms.",
	"Nothing on there.",
	"A man in a buff suit with a crape armlet.",
	"Not much grief there.",
	"Quarter mourning.",
	"People in law perhaps.",
	"They went past the bleak pulpit of saint Mark’s, under the railway bridge, past the Queen’s theatre: in silence.",
	"Hoardings: Eugene Stratton, Mrs Bandmann Palmer.",
	"Could I go to see Leah tonight, I wonder.",
	"I said I.",
	"Or the Lily of Killarney?",
	"Elster Grimes Opera Company.",
	"Big powerful change.",
	"Wet bright bills for next week.",
	"Fun on the Bristol.",
	"Martin Cunningham could work a pass for the Gaiety.",
	"Have to stand a drink or two.",
	"As broad as it’s long.",
	"He’s coming in the afternoon.",
	"Her songs.",
	"Plasto’s.",
	"Sir Philip Crampton’s memorial fountain bust.",
	"Who was he?",
	"How do you do?",
	"Martin Cunningham said, raising his palm to his brow in salute.",
	"He doesn’t see us, Mr Power said.",
	"Yes, he does.",
	"How do you do?",
	"Who?",
	"Mr Dedalus asked.",
	"Blazes Boylan, Mr Power said.",
	"There he is airing his quiff.",
	"Just that moment I was thinking.",
	"Mr Dedalus bent across to salute.",
	"From the door of the Red Bank the white disc of a straw hat flashed reply: spruce figure: passed.",
	"Mr Bloom reviewed the nails of his left hand, then those of his right hand.",
	"The nails, yes.",
	"Is there anything more in him that they she sees?",
	"Fascination.",
	"Worst man in Dublin.",
	"That keeps him alive.",
	"They sometimes feel what a person is.",
	"Instinct.",
	"But a type like that.",
	"My nails.",
	"I am just looking at them: well pared.",
	"And after: thinking alone.",
	"Body getting a bit softy.",
	"I would notice that: from remembering.",
	"What causes that?",
	"I suppose the skin can’t contract quickly enough when the flesh falls off.",
	"But the shape is there.",
	"The shape is there still.",
	"Shoulders.",
	"Hips.",
	"Plump.",
	"Night of the dance dressing.",
	"Shift stuck between the cheeks behind.",
	"He clasped his hands between his knees and, satisfied, sent his vacant glance over their faces.",
	"Mr Power asked: How is the concert tour getting on, Bloom?",
	"O, very well, Mr Bloom said.",
	"I hear great accounts of it.",
	"It’s a good idea, you see... —Are you going yourself?",
	"Well no, Mr Bloom said.",
	"In point of fact I have to go down to the county Clare on some private business.",
	"You see the idea is to tour the chief towns.",
	"What you lose on one you can make up on the other.",
	"Quite so, Martin Cunningham said.",
	"Mary Anderson is up there now.",
	"Have you good artists?",
	"Louis Werner is touring her, Mr Bloom said.",
	"O yes, we’ll have all topnobbers.",
	"J. C. Doyle and John MacCormack I hope and.",
	"The best, in fact.",
	"And Madame, Mr Power said smiling.",
	"Last but not least.",
	"Mr Bloom unclasped his hands in a gesture of soft politeness and clasped them.",
	"Smith O’Brien.",
	"Someone has laid a bunch of flowers there.",
	"Woman.",
	"Must be his deathday.",
	"For many happy returns.",
	"The carriage wheeling by Farrell’s statue united noiselessly their unresisting knees.",
	"Oot: a dullgarbed old man from the curbstone tendered his wares, his mouth opening: oot.",
	"Four bootlaces for a penny.",
	"Wonder why he was struck off the rolls.",
	"Had his office in Hume street.",
	"Same house as Molly’s namesake, Tweedy, crown solicitor for Waterford.",
	"Has that silk hat ever since.",
	"Relics of old decency.",
	"Mourning too.",
	"Terrible comedown, poor wretch!",
	"Kicked about like snuff at a wake.",
	"O’Callaghan on his last legs.",
	"And Madame.",
	"Twenty past eleven.",
	"Up.",
	"Mrs Fleming is in to clean.",
	"Doing her hair, humming: voglio e non vorrei.",
	"No: vorrei e non.",
	"Looking at the tips of her hairs to see if they are split.",
	"Mi trema un poco il.",
	"Beautiful on that tre her voice is: weeping tone.",
	"A thrush.",
	"A throstle.",
	"There is a word throstle that expresses that.",
	"His eyes passed lightly over Mr Power’s goodlooking face.",
	"Greyish over the ears.",
	"Madame: smiling.",
	"I smiled back.",
	"A smile goes a long way.",
	"Only politeness perhaps.",
	"Nice fellow.",
	"Who knows is that true about the woman he keeps?",
	"Not pleasant for the wife.",
	"Yet they say, who was it told me, there is no carnal.",
	"You would imagine that would get played out pretty quick.",
	"Yes, it was Crofton met him one evening bringing her a pound of rumpsteak.",
	"What is this she was?",
	"Barmaid in Jury’s.",
	"Or the Moira, was it?",
	"They passed under the hugecloaked Liberator’s form.",
	"Martin Cunningham nudged Mr Power.",
	"Of the tribe of Reuben, he said.",
	"In all his pristine beauty, Mr Power said.",
	"Mr Dedalus looked after the stumping figure and said mildly: The devil break the hasp of your back!",
	"Mr Power, collapsing in laughter, shaded his face from the window as the carriage passed Gray’s statue.",
	"We have all been there, Martin Cunningham said broadly.",
	"His eyes met Mr Bloom’s eyes.",
	"He caressed his beard, adding: Well, nearly all of us.",
	"Mr Bloom began to speak with sudden eagerness to his companions’ faces.",
	"That’s an awfully good one that’s going the rounds about Reuben J and the son.",
	"About the boatman?",
	"Mr Power asked.",
	"Yes.",
	"Isn’t it awfully good?",
	"What is that?",
	"Mr Dedalus asked.",
	"I didn’t hear it.",
	"Mr Dedalus asked.",
	"That confirmed bloody hobbledehoy is it?",
	"Yes, Mr Bloom said.",
	"They were both on the way to the boat and he tried to drown..... —Drown Barabbas!",
	"Mr Dedalus cried.",
	"I wish to Christ he did!",
	"Mr Power sent a long laugh down his shaded nostrils.",
	"For God’s sake!",
	"Mr Dedalus exclaimed in fright.",
	"Is he dead?",
	"Dead!",
	"Martin Cunningham cried.",
	"Not he!",
	"Half the town was there.",
	"Yes, Mr Bloom said.",
	"A stifled sigh came from under Mr Power’s hand.",
	"O, he did, Martin Cunningham affirmed.",
	"Like a hero.",
	"A silver florin.",
	"Isn’t it awfully good?",
	"Mr Bloom said eagerly.",
	"One and eightpence too much, Mr Dedalus said drily.",
	"Mr Power’s choked laugh burst quietly in the carriage.",
	"Nelson’s pillar.",
	"Eight plums a penny!",
	"Eight for a penny!",
	"We had better look a little serious, Martin Cunningham said.",
	"Mr Dedalus sighed.",
	"Ah then indeed, he said, poor little Paddy wouldn’t grudge us a laugh.",
	"Many a good one he told himself.",
	"The Lord forgive me!",
	"Mr Power said, wiping his wet eyes with his fingers.",
	"Poor Paddy!",
	"He’s gone from us.",
	"As decent a little man as ever wore a hat, Mr Dedalus said.",
	"He went very suddenly.",
	"Breakdown, Martin Cunningham said.",
	"Heart.",
	"He tapped his chest sadly.",
	"Blazing face: redhot.",
	"Too much John Barleycorn.",
	"Cure for a red nose.",
	"Drink like the devil till it turns adelite.",
	"A lot of money he spent colouring it.",
	"Mr Power gazed at the passing houses with rueful apprehension.",
	"He had a sudden death, poor fellow, he said.",
	"The best death, Mr Bloom said.",
	"Their wide open eyes looked at him.",
	"No suffering, he said.",
	"A moment and all is over.",
	"Like dying in sleep.",
	"No-one spoke.",
	"Dead side of the street this.",
	"Why?",
	"Some reason.",
	"Sun or wind.",
	"At night too.",
	"Chummies and slaveys.",
	"Under the patronage of the late Father Mathew.",
	"Foundation stone for Parnell.",
	"Breakdown.",
	"Heart.",
	"White horses with white frontlet plumes came round the Rotunda corner, galloping.",
	"A tiny coffin flashed by.",
	"In a hurry to bury.",
	"A mourning coach.",
	"Unmarried.",
	"Black for the married.",
	"Piebald for bachelors.",
	"Dun for a nun.",
	"Sad, Martin Cunningham said.",
	"A child.",
	"A dwarf’s face, mauve and wrinkled like little Rudy’s was.",
	"Dwarf’s body, weak as putty, in a whitelined deal box.",
	"Burial friendly society pays.",
	"Penny a week for a sod of turf.",
	"Our.",
	"Little.",
	"Beggar.",
	"Baby.",
	"Meant nothing.",
	"Mistake of nature.",
	"If it’s healthy it’s from the mother.",
	"If not from the man.",
	"Better luck next time.",
	"Poor little thing, Mr Dedalus said.",
	"It’s well out of it.",
	"The carriage climbed more slowly the hill of Rutland square.",
	"Rattle his bones.",
	"Over the stones.",
	"Only a pauper.",
	"Nobody owns.",
	"In the midst of life, Martin Cunningham said.",
	"But the worst of all, Mr Power said, is the man who takes his own life.",
	"Martin Cunningham drew out his watch briskly, coughed and put it back.",
	"The greatest disgrace to have in the family, Mr Power added.",
	"Temporary insanity, of course, Martin Cunningham said decisively.",
	"We must take a charitable view of it.",
	"They say a man who does it is a coward, Mr Dedalus said.",
	"It is not for us to judge, Martin Cunningham said.",
	"Mr Bloom, about to speak, closed his lips again.",
	"Martin Cunningham’s large eyes.",
	"Looking away now.",
	"Sympathetic human man he is.",
	"Intelligent.",
	"Like Shakespeare’s face.",
	"Always a good word to say.",
	"They have no mercy on that here or infanticide.",
	"Refuse christian burial.",
	"They used to drive a stake of wood through his heart in the grave.",
	"As if it wasn’t broken already.",
	"Yet sometimes they repent too late.",
	"Found in the riverbed clutching rushes.",
	"He looked at me.",
	"And that awful drunkard of a wife of his.",
	"Setting up house for her time after time and then pawning the furniture on him every Saturday almost.",
	"Leading him the life of the damned.",
	"Wear the heart out of a stone, that.",
	"Monday morning.",
	"Start afresh.",
	"Shoulder to the wheel.",
	"Lord, she must have looked a sight that night Dedalus told me he was in there.",
	"Drunk about the place and capering with Martin’s umbrella.",
	"And they call me the jewel of Asia, Of Asia, The geisha.",
	"He looked away from me.",
	"He knows.",
	"Rattle his bones.",
	"That afternoon of the inquest.",
	"The redlabelled bottle on the table.",
	"The room in the hotel with hunting pictures.",
	"Stuffy it was.",
	"Sunlight through the slats of the Venetian blind.",
	"The coroner’s sunlit ears, big and hairy.",
	"Boots giving evidence.",
	"Thought he was asleep first.",
	"Then saw like yellow streaks on his face.",
	"Had slipped down to the foot of the bed.",
	"Verdict: overdose.",
	"Death by misadventure.",
	"The letter.",
	"For my son Leopold.",
	"No more pain.",
	"Wake no more.",
	"Nobody owns.",
	"The carriage rattled swiftly along Blessington street.",
	"Over the stones.",
	"We are going the pace, I think, Martin Cunningham said.",
	"God grant he doesn’t upset us on the road, Mr Power said.",
	"I hope not, Martin Cunningham said.",
	"That will be a great race tomorrow in Germany.",
	"The Gordon Bennett.",
	"Yes, by Jove, Mr Dedalus said.",
	"That will be worth seeing, faith.",
	"Has anybody here seen Kelly?",
	"Kay ee double ell wy.",
	"Dead March from Saul.",
	"He’s as bad as old Antonio.",
	"He left me on my ownio.",
	"Pirouette!",
	"The Mater Misericordiae.",
	"Eccles street.",
	"My house down there.",
	"Big place.",
	"Ward for incurables there.",
	"Very encouraging.",
	"Our Lady’s Hospice for the dying.",
	"Deadhouse handy underneath.",
	"Where old Mrs Riordan died.",
	"They look terrible the women.",
	"Her feeding cup and rubbing her mouth with the spoon.",
	"Then the screen round her bed for her to die.",
	"Nice young student that was dressed that bite the bee gave me.",
	"He’s gone over to the lying-in hospital they told me.",
	"From one extreme to the other.",
	"The carriage galloped round a corner: stopped.",
	"What’s wrong now?",
	"Outside them and through them ran raddled sheep bleating their fear.",
	"Emigrants, Mr Power said.",
	"Huuuh!",
	"the drover’s voice cried, his switch sounding on their flanks.",
	"Huuuh!",
	"out of that!",
	"Thursday, of course.",
	"Tomorrow is killing day.",
	"Springers.",
	"Cuffe sold them about twentyseven quid each.",
	"For Liverpool probably.",
	"Roastbeef for old England.",
	"They buy up all the juicy ones.",
	"And then the fifth quarter lost: all that raw stuff, hide, hair, horns.",
	"Comes to a big thing in a year.",
	"Dead meat trade.",
	"Byproducts of the slaughterhouses for tanneries, soap, margarine.",
	"Wonder if that dodge works now getting dicky meat off the train at Clonsilla.",
	"The carriage moved on through the drove.",
	"All those animals could be taken in trucks down to the boats.",
	"Instead of blocking up the thoroughfare, Martin Cunningham said.",
	"Quite right.",
	"They ought to.",
	"Run the line out to the cemetery gates and have special trams, hearse and carriage and all.",
	"Don’t you see what I mean?",
	"O, that be damned for a story, Mr Dedalus said.",
	"Pullman car and saloon diningroom.",
	"A poor lookout for Corny, Mr Power added.",
	"Why?",
	"Mr Bloom asked, turning to Mr Dedalus.",
	"Wouldn’t it be more decent than galloping two abreast?",
	"Well, there’s something in that, Mr Dedalus granted.",
	"That was terrible, Mr Power’s shocked face said, and the corpse fell about the road.",
	"Terrible!",
	"First round Dunphy’s, Mr Dedalus said, nodding.",
	"Gordon Bennett cup.",
	"Praises be to God!",
	"Martin Cunningham said piously.",
	"Bom!",
	"Upset.",
	"A coffin bumped out on to the road.",
	"Burst open.",
	"Paddy Dignam shot out and rolling over stiff in the dust in a brown habit too large for him.",
	"Red face: grey now.",
	"Mouth fallen open.",
	"Asking what’s up now.",
	"Quite right to close it.",
	"Looks horrid open.",
	"Then the insides decompose quickly.",
	"Much better to close up all the orifices.",
	"Yes, also.",
	"With wax.",
	"The sphincter loose.",
	"Seal up all.",
	"Dunphy’s, Mr Power announced as the carriage turned right.",
	"Dunphy’s corner.",
	"Mourning coaches drawn up, drowning their grief.",
	"A pause by the wayside.",
	"Tiptop position for a pub.",
	"Expect we’ll pull up here on the way back to drink his health.",
	"Pass round the consolation.",
	"Elixir of life.",
	"But suppose now it did happen.",
	"Would he bleed if a nail say cut him in the knocking about?",
	"He would and he wouldn’t, I suppose.",
	"Depends on where.",
	"The circulation stops.",
	"Still some might ooze out of an artery.",
	"It would be better to bury them in red: a dark red.",
	"In silence they drove along Phibsborough road.",
	"An empty hearse trotted by, coming from the cemetery: looks relieved.",
	"Crossguns bridge: the royal canal.",
	"Water rushed roaring through the sluices.",
	"A man stood on his dropping barge, between clamps of turf.",
	"On the towpath by the lock a slacktethered horse.",
	"Aboard of the Bugabu.",
	"Their eyes watched him.",
	"Athlone, Mullingar, Moyvalley, I could make a walking tour to see Milly by the canal.",
	"Or cycle down.",
	"Hire some old crock, safety.",
	"Wren had one the other day at the auction but a lady’s.",
	"Developing waterways.",
	"James M’Cann’s hobby to row me o’er the ferry.",
	"Cheaper transit.",
	"By easy stages.",
	"Houseboats.",
	"Camping out.",
	"Also hearses.",
	"To heaven by water.",
	"Perhaps I will without writing.",
	"Come as a surprise, Leixlip, Clonsilla.",
	"Dropping down lock by lock to Dublin.",
	"With turf from the midland bogs.",
	"Salute.",
	"He lifted his brown straw hat, saluting Paddy Dignam.",
	"They drove on past Brian Boroimhe house.",
	"Near it now.",
	"I wonder how is our friend Fogarty getting on, Mr Power said.",
	"Better ask Tom Kernan, Mr Dedalus said.",
	"How is that?",
	"Martin Cunningham said.",
	"Left him weeping, I suppose?",
	"Though lost to sight, Mr Dedalus said, to memory dear.",
	"The carriage steered left for Finglas road.",
	"The stonecutter’s yard on the right.",
	"Last lap.",
	"Crowded on the spit of land silent shapes appeared, white, sorrowful, holding out calm hands, knelt in grief, pointing.",
	"Fragments of shapes, hewn.",
	"In white silence: appealing.",
	"The best obtainable.",
	"Thos.",
	"H. Dennany, monumental builder and sculptor.",
	"Passed.",
	"After life’s journey.",
	"Gloomy gardens then went by: one by one: gloomy houses.",
	"Mr Power pointed.",
	"That is where Childs was murdered, he said.",
	"The last house.",
	"So it is, Mr Dedalus said.",
	"A gruesome case.",
	"Seymour Bushe got him off.",
	"Murdered his brother.",
	"Or so they said.",
	"The crown had no evidence, Mr Power said.",
	"Only circumstantial, Martin Cunningham added.",
	"That’s the maxim of the law.",
	"Better for ninetynine guilty to escape than for one innocent person to be wrongfully condemned.",
	"They looked.",
	"Murderer’s ground.",
	"It passed darkly.",
	"Shuttered, tenantless, unweeded garden.",
	"Whole place gone to hell.",
	"Wrongfully condemned.",
	"Murder.",
	"The murderer’s image in the eye of the murdered.",
	"They love reading about it.",
	"Man’s head found in a garden.",
	"Her clothing consisted of.",
	"How she met her death.",
	"Recent outrage.",
	"The weapon used.",
	"Murderer is still at large.",
	"Clues.",
	"A shoelace.",
	"The body to be exhumed.",
	"Murder will out.",
	"Cramped in this carriage.",
	"She mightn’t like me to come that way without letting her know.",
	"Must be careful about women.",
	"Catch them once with their pants down.",
	"Never forgive you after.",
	"Fifteen.",
	"The high railings of Prospect rippled past their gaze.",
	"Dark poplars, rare white forms.",
	"The felly harshed against the curbstone: stopped.",
	"Martin Cunningham put out his arm and, wrenching back the handle, shoved the door open with his knee.",
	"He stepped out.",
	"Mr Power and Mr Dedalus followed.",
	"Change that soap now.",
	"Mr Bloom’s hand unbuttoned his hip pocket swiftly and transferred the paperstuck soap to his inner handkerchief pocket.",
	"He stepped out of the carriage, replacing the newspaper his other hand still held.",
	"Paltry funeral: coach and three carriages.",
	"It’s all the same.",
	"Pallbearers, gold reins, requiem mass, firing a volley.",
	"Pomp of death.",
	"Beyond the hind carriage a hawker stood by his barrow of cakes and fruit.",
	"Simnel cakes those are, stuck together: cakes for the dead.",
	"Dogbiscuits.",
	"Who ate them?",
	"Mourners coming out.",
	"He followed his companions.",
	"Mr Kernan and Ned Lambert followed, Hynes walking after them.",
	"Corny Kelleher stood by the opened hearse and took out the two wreaths.",
	"He handed one to the boy.",
	"Where is that child’s funeral disappeared to?",
	"The waggoner marching at their head saluted.",
	"Coffin now.",
	"Got here before us, dead as he is.",
	"Horse looking round at it with his plume skeowways.",
	"Dull eye: collar tight on his neck, pressing on a bloodvessel or something.",
	"Do they know what they cart out here every day?",
	"Must be twenty or thirty funerals every day.",
	"Then Mount Jerome for the protestants.",
	"Funerals all over the world everywhere every minute.",
	"Shovelling them under by the cartload doublequick.",
	"Thousands every hour.",
	"Too many in the world.",
	"Mourners came out through the gates: woman and a girl.",
	"Leanjawed harpy, hard woman at a bargain, her bonnet awry.",
	"Fish’s face, bloodless and livid.",
	"The mutes shouldered the coffin and bore it in through the gates.",
	"So much dead weight.",
	"Felt heavier myself stepping out of that bath.",
	"First the stiff: then the friends of the stiff.",
	"Corny Kelleher and the boy followed with their wreaths.",
	"Who is that beside them?",
	"Ah, the brother-in-law.",
	"All walked after.",
	"Martin Cunningham whispered: I was in mortal agony with you talking of suicide before Bloom.",
	"What?",
	"Mr Power whispered.",
	"How so?",
	"His father poisoned himself, Martin Cunningham whispered.",
	"Had the Queen’s hotel in Ennis.",
	"You heard him say he was going to Clare.",
	"Anniversary.",
	"O God!",
	"Mr Power whispered.",
	"First I heard of it.",
	"Poisoned himself?",
	"He glanced behind him to where a face with dark thinking eyes followed towards the cardinal’s mausoleum.",
	"Speaking.",
	"Was he insured?",
	"Mr Bloom asked.",
	"I believe so, Mr Kernan answered.",
	"But the policy was heavily mortgaged.",
	"Martin is trying to get the youngster into Artane.",
	"How many children did he leave?",
	"Five.",
	"Ned Lambert says he’ll try to get one of the girls into Todd’s.",
	"A sad case, Mr Bloom said gently.",
	"Five young children.",
	"A great blow to the poor wife, Mr Kernan added.",
	"Indeed yes, Mr Bloom agreed.",
	"Has the laugh at him now.",
	"He looked down at the boots he had blacked and polished.",
	"She had outlived him.",
	"Lost her husband.",
	"More dead for her than for me.",
	"One must outlive the other.",
	"Wise men say.",
	"There are more women than men in the world.",
	"Condole with her.",
	"Your terrible loss.",
	"I hope you’ll soon follow him.",
	"For Hindu widows only.",
	"She would marry another.",
	"Him?",
	"No.",
	"Yet who knows after.",
	"Widowhood not the thing since the old queen died.",
	"Drawn on a guncarriage.",
	"Victoria and Albert.",
	"Frogmore memorial mourning.",
	"But in the end she put a few violets in her bonnet.",
	"Vain in her heart of hearts.",
	"All for a shadow.",
	"Consort not even a king.",
	"Her son was the substance.",
	"Something new to hope for not like the past she wanted back, waiting.",
	"It never comes.",
	"One must go first: alone, under the ground: and lie no more in her warm bed.",
	"How are you, Simon?",
	"Ned Lambert said softly, clasping hands.",
	"Haven’t seen you for a month of Sundays.",
	"Never better.",
	"How are all in Cork’s own town?",
	"I was down there for the Cork park races on Easter Monday, Ned Lambert said.",
	"Same old six and eightpence.",
	"Stopped with Dick Tivy.",
	"And how is Dick, the solid man?",
	"Nothing between himself and heaven, Ned Lambert answered.",
	"By the holy Paul!",
	"Mr Dedalus said in subdued wonder.",
	"Dick Tivy bald?",
	"Martin is going to get up a whip for the youngsters, Ned Lambert said, pointing ahead.",
	"A few bob a skull.",
	"Just to keep them going till the insurance is cleared up.",
	"Yes, yes, Mr Dedalus said dubiously.",
	"Is that the eldest boy in front?",
	"Yes, Ned Lambert said, with the wife’s brother.",
	"John Henry Menton is behind.",
	"He put down his name for a quid.",
	"I’ll engage he did, Mr Dedalus said.",
	"I often told poor Paddy he ought to mind that job.",
	"John Henry is not the worst in the world.",
	"How did he lose it?",
	"Ned Lambert asked.",
	"Liquor, what?",
	"Many a good man’s fault, Mr Dedalus said with a sigh.",
	"They halted about the door of the mortuary chapel.",
	"Poor boy!",
	"Was he there when the father?",
	"Both unconscious.",
	"Lighten up at the last moment and recognise for the last time.",
	"All he might have done.",
	"I owe three shillings to O’Grady.",
	"Would he understand?",
	"The mutes bore the coffin into the chapel.",
	"Which end is his head?",
	"After a moment he followed the others in, blinking in the screened light.",
	"The coffin lay on its bier before the chancel, four tall yellow candles at its corners.",
	"Always in front of us.",
	"Corny Kelleher, laying a wreath at each fore corner, beckoned to the boy to kneel.",
	"The mourners knelt here and there in prayingdesks.",
	"He fitted his black hat gently on his left knee and, holding its brim, bent over piously.",
	"A server bearing a brass bucket with something in it came out through a door.",
	"Who’ll read the book?",
	"I, said the rook.",
	"They halted by the bier and the priest began to read out of his book with a fluent croak.",
	"Father Coffey.",
	"I knew his name was like a coffin.",
	"Dominenamine.",
	"Bully about the muzzle he looks.",
	"Bosses the show.",
	"Muscular christian.",
	"Woe betide anyone that looks crooked at him: priest.",
	"Thou art Peter.",
	"Burst sideways like a sheep in clover Dedalus says he will.",
	"With a belly on him like a poisoned pup.",
	"Most amusing expressions that man finds.",
	"Hhhn: burst sideways.",
	"Non intres in judicium cum servo tuo, Domine.",
	"Makes them feel more important to be prayed over in Latin.",
	"Requiem mass.",
	"Crape weepers.",
	"Blackedged notepaper.",
	"Your name on the altarlist.",
	"Chilly place this.",
	"Eyes of a toad too.",
	"What swells him up that way?",
	"Molly gets swelled after cabbage.",
	"Air of the place maybe.",
	"Looks full up of bad gas.",
	"Must be an infernal lot of bad gas round the place.",
	"Butchers, for instance: they get like raw beefsteaks.",
	"Who was telling me?",
	"Mervyn Browne.",
	"Out it rushes: blue.",
	"One whiff of that and you’re a goner.",
	"My kneecap is hurting me.",
	"Ow.",
	"That’s better.",
	"Then he walked to the other end and shook it again.",
	"Then he came back and put it back in the bucket.",
	"As you were before you rested.",
	"It’s all written down: he has to do it.",
	"Et ne nos inducas in tentationem.",
	"The server piped the answers in the treble.",
	"I often thought it would be better to have boy servants.",
	"Up to fifteen or so.",
	"After that, of course ... Holy water that was, I expect.",
	"Shaking sleep out of it.",
	"He must be fed up with that job, shaking that thing over all the corpses they trot up.",
	"What harm if he could see what he was shaking it over.",
	"On Dignam now.",
	"In paradisum.",
	"Said he was going to paradise or is in paradise.",
	"Says that over everybody.",
	"Tiresome kind of a job.",
	"But he has to say something.",
	"The priest closed his book and went off, followed by the server.",
	"Corny Kelleher gave one wreath to the boy and one to the brother-in-law.",
	"All followed them out of the sidedoors into the mild grey air.",
	"Mr Bloom came last folding his paper again into his pocket.",
	"He gazed gravely at the ground till the coffincart wheeled off to the left.",
	"The ree the ra the ree the ra the roo.",
	"Lord, I mustn’t lilt here.",
	"The O’Connell circle, Mr Dedalus said about him.",
	"Mr Power’s soft eyes went up to the apex of the lofty cone.",
	"He’s at rest, he said, in the middle of his people, old Dan O’.",
	"But his heart is buried in Rome.",
	"How many broken hearts are buried here, Simon!",
	"Her grave is over there, Jack, Mr Dedalus said.",
	"I’ll soon be stretched beside her.",
	"Let Him take me whenever He likes.",
	"Breaking down, he began to weep to himself quietly, stumbling a little in his walk.",
	"Mr Power took his arm.",
	"She’s better where she is, he said kindly.",
	"I suppose so, Mr Dedalus said with a weak gasp.",
	"I suppose she is in heaven if there is a heaven.",
	"Corny Kelleher stepped aside from his rank and allowed the mourners to plod by.",
	"Sad occasions, Mr Kernan began politely.",
	"Mr Bloom closed his eyes and sadly twice bowed his head.",
	"The others are putting on their hats, Mr Kernan said.",
	"I suppose we can do so too.",
	"We are the last.",
	"This cemetery is a treacherous place.",
	"They covered their heads.",
	"The reverend gentleman read the service too quickly, don’t you think?",
	"Mr Kernan said with reproof.",
	"Mr Bloom nodded gravely looking in the quick bloodshot eyes.",
	"Secret eyes, secretsearching.",
	"Mason, I think: not sure.",
	"Beside him again.",
	"We are the last.",
	"In the same boat.",
	"Hope he’ll say something else.",
	"Mr Bloom gave prudent assent.",
	"The language of course was another thing.",
	"Mr Kernan said with solemnity: I am the resurrection and the life.",
	"That touches a man’s inmost heart.",
	"It does, Mr Bloom said.",
	"No touching that.",
	"Seat of the affections.",
	"Broken heart.",
	"A pump after all, pumping thousands of gallons of blood every day.",
	"One fine day it gets bunged up: and there you are.",
	"Lots of them lying around here: lungs, hearts, livers.",
	"Old rusty pumps: damn the thing else.",
	"The resurrection and the life.",
	"Once you are dead you are dead.",
	"That last day idea.",
	"Knocking them all up out of their graves.",
	"Come forth, Lazarus!",
	"And he came fifth and lost the job.",
	"Get up!",
	"Last day!",
	"Then every fellow mousing around for his liver and his lights and the rest of his traps.",
	"Find damn all of himself that morning.",
	"Pennyweight of powder in a skull.",
	"Twelve grammes one pennyweight.",
	"Troy measure.",
	"Corny Kelleher fell into step at their side.",
	"Everything went off A1, he said.",
	"What?",
	"He looked on them from his drawling eye.",
	"Policeman’s shoulders.",
	"With your tooraloom tooraloom.",
	"As it should be, Mr Kernan said.",
	"What?",
	"Eh?",
	"Corny Kelleher said.",
	"Mr Kernan assured him.",
	"Who is that chap behind with Tom Kernan?",
	"John Henry Menton asked.",
	"I know his face.",
	"Ned Lambert glanced back.",
	"Bloom, he said, Madame Marion Tweedy that was, is, I mean, the soprano.",
	"She’s his wife.",
	"O, to be sure, John Henry Menton said.",
	"I haven’t seen her for some time.",
	"She was a finelooking woman.",
	"I danced with her, wait, fifteen seventeen golden years ago, at Mat Dillon’s in Roundtown.",
	"And a good armful she was.",
	"He looked behind through the others.",
	"What is he?",
	"he asked.",
	"What does he do?",
	"Wasn’t he in the stationery line?",
	"I fell foul of him one evening, I remember, at bowls.",
	"Ned Lambert smiled.",
	"Yes, he was, he said, in Wisdom Hely’s.",
	"A traveller for blottingpaper.",
	"In God’s name, John Henry Menton said, what did she marry a coon like that for?",
	"She had plenty of game in her then.",
	"Has still, Ned Lambert said.",
	"He does some canvassing for ads.",
	"John Henry Menton’s large eyes stared ahead.",
	"The barrow turned into a side lane.",
	"A portly man, ambushed among the grasses, raised his hat in homage.",
	"The gravediggers touched their caps.",
	"John O’Connell, Mr Power said pleased.",
	"He never forgets a friend.",
	"Mr O’Connell shook all their hands in silence.",
	"Mr Dedalus said: I am come to pay you another visit.",
	"My dear Simon, the caretaker answered in a low voice.",
	"I don’t want your custom at all.",
	"Did you hear that one, he asked them, about Mulcahy from the Coombe?",
	"I did not, Martin Cunningham said.",
	"They bent their silk hats in concert and Hynes inclined his ear.",
	"They asked for Mulcahy from the Coombe and were told where he was buried.",
	"After traipsing about in the fog they found the grave sure enough.",
	"One of the drunks spelt out the name: Terence Mulcahy.",
	"The other drunk was blinking up at a statue of Our Saviour the widow had got put up.",
	"The caretaker blinked up at one of the sepulchres they passed.",
	"He resumed: And, after blinking up at the sacred figure, Not a bloody bit like the man, says he.",
	"That’s not Mulcahy, says he, whoever done it.",
	"That’s all done with a purpose, Martin Cunningham explained to Hynes.",
	"I know, Hynes said.",
	"I know that.",
	"To cheer a fellow up, Martin Cunningham said.",
	"It’s pure goodheartedness: damn the thing else.",
	"Mr Bloom admired the caretaker’s prosperous bulk.",
	"All want to be on good terms with him.",
	"Decent fellow, John O’Connell, real good sort.",
	"Keys: like Keyes’s ad: no fear of anyone getting out.",
	"No passout checks.",
	"Habeas corpus.",
	"I must see about that ad after the funeral.",
	"Did I write Ballsbridge on the envelope I took to cover when she disturbed me writing to Martha?",
	"Hope it’s not chucked in the dead letter office.",
	"Be the better of a shave.",
	"Grey sprouting beard.",
	"That’s the first sign when the hairs come out grey.",
	"And temper getting cross.",
	"Silver threads among the grey.",
	"Fancy being his wife.",
	"Wonder he had the gumption to propose to any girl.",
	"Come out and live in the graveyard.",
	"Dangle that before her.",
	"It might thrill her first.",
	"Courting death.",
	"Shades of night hovering here with all the dead stretched about.",
	"Will o’ the wisp.",
	"Gas of graves.",
	"Want to keep her mind off it to conceive at all.",
	"Women especially are so touchy.",
	"Tell her a ghost story in bed to make her sleep.",
	"Have you ever seen a ghost?",
	"Well, I have.",
	"It was a pitchdark night.",
	"The clock was on the stroke of twelve.",
	"Still they’d kiss all right if properly keyed up.",
	"Whores in Turkish graveyards.",
	"Learn anything if taken young.",
	"You might pick up a young widow here.",
	"Men like that.",
	"Love among the tombstones.",
	"Romeo.",
	"Spice of pleasure.",
	"In the midst of death we are in life.",
	"Both ends meet.",
	"Tantalising for the poor dead.",
	"Smell of grilled beefsteaks to the starving.",
	"Gnawing their vitals.",
	"Desire to grig people.",
	"Molly wanting to do it at the window.",
	"Eight children he has anyway.",
	"He has seen a fair share go under in his time, lying around him field after field.",
	"Holy fields.",
	"More room if they buried them standing.",
	"Sitting or kneeling you couldn’t.",
	"Standing?",
	"His head might come up some day above ground in a landslip with his hand pointing.",
	"All honeycombed the ground must be: oblong cells.",
	"And very neat he keeps it too: trim grass and edgings.",
	"His garden Major Gamble calls Mount Jerome.",
	"Well, so it is.",
	"Ought to be flowers of sleep.",
	"Chinese cemeteries with giant poppies growing produce the best opium Mastiansky told me.",
	"The Botanic Gardens are just over there.",
	"It’s the blood sinking in the earth gives new life.",
	"Same idea those jews they said killed the christian boy.",
	"Every man his price.",
	"Well preserved fat corpse, gentleman, epicure, invaluable for fruit garden.",
	"A bargain.",
	"By carcass of William Wilkinson, auditor and accountant, lately deceased, three pounds thirteen and six.",
	"With thanks.",
	"I daresay the soil would be quite fat with corpsemanure, bones, flesh, nails.",
	"Charnelhouses.",
	"Dreadful.",
	"Turning green and pink decomposing.",
	"Rot quick in damp earth.",
	"The lean old ones tougher.",
	"Then a kind of a tallowy kind of a cheesy.",
	"Then begin to get black, black treacle oozing out of them.",
	"Then dried up.",
	"Deathmoths.",
	"Of course the cells or whatever they are go on living.",
	"Changing about.",
	"Live for ever practically.",
	"Nothing to feed on feed on themselves.",
	"But they must breed a devil of a lot of maggots.",
	"Soil must be simply swirling with them.",
	"Your head it simply swurls.",
	"Those pretty little seaside gurls.",
	"He looks cheerful enough over it.",
	"Gives him a sense of power seeing all the others go under first.",
	"Wonder how he looks at life.",
	"Cracking his jokes too: warms the cockles of his heart.",
	"The one about the bulletin.",
	"Spurgeon went to heaven 4 a.m. this morning.",
	"11 p.m. (closing time).",
	"Not arrived yet.",
	"Peter.",
	"A juicy pear or ladies’ punch, hot, strong and sweet.",
	"Keep out the damp.",
	"You must laugh sometimes so better do it that way.",
	"Gravediggers in Hamlet.",
	"Shows the profound knowledge of the human heart.",
	"Daren’t joke about the dead for two years at least.",
	"De mortuis nil nisi prius.",
	"Go out of mourning first.",
	"Hard to imagine his funeral.",
	"Seems a sort of a joke.",
	"Read your own obituary notice they say you live longer.",
	"Gives you second wind.",
	"New lease of life.",
	"How many have you for tomorrow?",
	"the caretaker asked.",
	"Two, Corny Kelleher said.",
	"Half ten and eleven.",
	"The caretaker put the papers in his pocket.",
	"The barrow had ceased to trundle.",
	"The mourners split and moved to each side of the hole, stepping with care round the graves.",
	"The gravediggers bore the coffin and set its nose on the brink, looping the bands round it.",
	"Burying him.",
	"We come to bury Cæsar.",
	"His ides of March or June.",
	"He doesn’t know who is here nor care.",
	"Now who is that lankylooking galoot over there in the macintosh?",
	"Now who is he I’d like to know?",
	"Now I’d give a trifle to know who he is.",
	"Always someone turns up you never dreamt of.",
	"A fellow could live on his lonesome all his life.",
	"Yes, he could.",
	"Still he’d have to get someone to sod him after he died though he could dig his own grave.",
	"We all do.",
	"Only man buries.",
	"No, ants too.",
	"First thing strikes anybody.",
	"Bury the dead.",
	"Say Robinson Crusoe was true to life.",
	"Well then Friday buried him.",
	"Every Friday buries a Thursday if you come to look at it.",
	"O, poor Robinson Crusoe!",
	"How could you possibly do so?",
	"Poor Dignam!",
	"His last lie on the earth in his box.",
	"When you think of them all it does seem a waste of wood.",
	"All gnawed through.",
	"They could invent a handsome bier with a kind of panel sliding, let it down that way.",
	"Ay but they might object to be buried out of another fellow’s.",
	"They’re so particular.",
	"Lay me in my native earth.",
	"Bit of clay from the holy land.",
	"Only a mother and deadborn child ever buried in the one coffin.",
	"I see what it means.",
	"I see.",
	"To protect him as long as possible even in the earth.",
	"The Irishman’s house is his coffin.",
	"Embalming in catacombs, mummies the same idea.",
	"Mr Bloom stood far back, his hat in his hand, counting the bared heads.",
	"Twelve.",
	"I’m thirteen.",
	"No.",
	"The chap in the macintosh is thirteen.",
	"Death’s number.",
	"Where the deuce did he pop out of?",
	"He wasn’t in the chapel, that I’ll swear.",
	"Silly superstition that about thirteen.",
	"Nice soft tweed Ned Lambert has in that suit.",
	"Tinge of purple.",
	"I had one like that when we lived in Lombard street west.",
	"Dressy fellow he was once.",
	"Used to change three suits in the day.",
	"Must get that grey suit of mine turned by Mesias.",
	"Hello.",
	"It’s dyed.",
	"His wife I forgot he’s not married or his landlady ought to have picked out those threads for him.",
	"The coffin dived out of sight, eased down by the men straddled on the gravetrestles.",
	"They struggled up and out: and all uncovered.",
	"Twenty.",
	"Pause.",
	"If we were all suddenly somebody else.",
	"Far away a donkey brayed.",
	"Rain.",
	"No such ass.",
	"Never see a dead one, they say.",
	"Shame of death.",
	"They hide.",
	"Also poor papa went away.",
	"Gentle sweet air blew round the bared heads in a whisper.",
	"Whisper.",
	"The boy by the gravehead held his wreath with both hands staring quietly in the black open space.",
	"Mr Bloom moved behind the portly kindly caretaker.",
	"Wellcut frockcoat.",
	"Weighing them up perhaps to see which will go next.",
	"Well, it is a long rest.",
	"Feel no more.",
	"It’s the moment you feel.",
	"Must be damned unpleasant.",
	"Can’t believe it at first.",
	"Mistake must be: someone else.",
	"Try the house opposite.",
	"Wait, I wanted to.",
	"I haven’t yet.",
	"Then darkened deathchamber.",
	"Light they want.",
	"Whispering around you.",
	"Would you like to see a priest?",
	"Then rambling and wandering.",
	"Delirium all you hid all your life.",
	"The death struggle.",
	"His sleep is not natural.",
	"Press his lower eyelid.",
	"Watching is his nose pointed is his jaw sinking are the soles of his feet yellow.",
	"Pull the pillow away and finish it off on the floor since he’s doomed.",
	"Devil in that picture of sinner’s death showing him a woman.",
	"Dying to embrace her in his shirt.",
	"Last act of Lucia.",
	"Shall I nevermore behold thee?",
	"Bam!",
	"He expires.",
	"Gone at last.",
	"People talk about you a bit: forget you.",
	"Don’t forget to pray for him.",
	"Remember him in your prayers.",
	"Even Parnell.",
	"Ivy day dying out.",
	"Then they follow: dropping into a hole, one after the other.",
	"We are praying now for the repose of his soul.",
	"Hoping you’re well and not in hell.",
	"Nice change of air.",
	"Out of the fryingpan of life into the fire of purgatory.",
	"Does he ever think of the hole waiting for himself?",
	"They say you do when you shiver in the sun.",
	"Someone walking over it.",
	"Callboy’s warning.",
	"Near you.",
	"Mine over there towards Finglas, the plot I bought.",
	"Mamma, poor mamma, and little Rudy.",
	"The gravediggers took up their spades and flung heavy clods of clay in on the coffin.",
	"Mr Bloom turned away his face.",
	"And if he was alive all the time?",
	"Whew!",
	"By jingo, that would be awful!",
	"No, no: he is dead, of course.",
	"Of course he is dead.",
	"Monday he died.",
	"Flag of distress.",
	"Three days.",
	"Rather long to keep them in summer.",
	"Just as well to get shut of them as soon as you are sure there’s no.",
	"The clay fell softer.",
	"Begin to be forgotten.",
	"Out of sight, out of mind.",
	"The caretaker moved away a few paces and put on his hat.",
	"Had enough of it.",
	"The mourners took heart of grace, one by one, covering themselves without show.",
	"Quietly, sure of his ground, he traversed the dismal fields.",
	"Hynes jotting down something in his notebook.",
	"Ah, the names.",
	"But he knows them all.",
	"No: coming to me.",
	"I am just taking the names, Hynes said below his breath.",
	"What is your christian name?",
	"I’m not sure.",
	"L, Mr Bloom said.",
	"Leopold.",
	"And you might put down M’Coy’s name too.",
	"He asked me to.",
	"Charley, Hynes said writing.",
	"I know.",
	"He was on the Freeman once.",
	"So he was before he got the job in the morgue under Louis Byrne.",
	"Good idea a postmortem for doctors.",
	"Find out what they imagine they know.",
	"He died of a Tuesday.",
	"Got the run.",
	"Levanted with the cash of a few ads.",
	"Charley, you’re my darling.",
	"That was why he asked me to.",
	"O well, does no harm.",
	"I saw to that, M’Coy.",
	"Thanks, old chap: much obliged.",
	"Leave him under an obligation: costs nothing.",
	"And tell us, Hynes said, do you know that fellow in the, fellow was over there in the...",
	"He looked around.",
	"Macintosh.",
	"Yes, I saw him, Mr Bloom said.",
	"Where is he now?",
	"M’Intosh, Hynes said scribbling.",
	"I don’t know who he is.",
	"Is that his name?",
	"He moved away, looking about him.",
	"No, Mr Bloom began, turning and stopping.",
	"I say, Hynes!",
	"Didn’t hear.",
	"What?",
	"Where has he disappeared to?",
	"Not a sign.",
	"Well of all the.",
	"Has anybody here seen?",
	"Kay ee double ell.",
	"Become invisible.",
	"Good Lord, what became of him?",
	"A seventh gravedigger came beside Mr Bloom to take up an idle spade.",
	"O, excuse me!",
	"He stepped aside nimbly.",
	"Clay, brown, damp, began to be seen in the hole.",
	"It rose.",
	"Nearly over.",
	"A mound of damp clods rose more, rose, and the gravediggers rested their spades.",
	"All uncovered again for a few instants.",
	"The boy propped his wreath against a corner: the brother-in-law his on a lump.",
	"The gravediggers put on their caps and carried their earthy spades towards the barrow.",
	"Then knocked the blades lightly on the turf: clean.",
	"One bent to pluck from the haft a long tuft of grass.",
	"One, leaving his mates, walked slowly on with shouldered weapon, its blade blueglancing.",
	"Silently at the gravehead another coiled the coffinband.",
	"His navelcord.",
	"The brother-in-law, turning away, placed something in his free hand.",
	"Thanks in silence.",
	"Sorry, sir: trouble.",
	"Headshake.",
	"I know that.",
	"For yourselves just.",
	"Let us go round by the chief’s grave, Hynes said.",
	"We have time.",
	"Let us, Mr Power said.",
	"They turned to the right, following their slow thoughts.",
	"With awe Mr Power’s blank voice spoke: Some say he is not in that grave at all.",
	"That the coffin was filled with stones.",
	"That one day he will come again.",
	"Hynes shook his head.",
	"Parnell will never come again, he said.",
	"He’s there, all that was mortal of him.",
	"Peace to his ashes.",
	"More sensible to spend the money on some charity for the living.",
	"Pray for the repose of the soul of.",
	"Does anybody really?",
	"Plant him and have done with him.",
	"Like down a coalshoot.",
	"Then lump them together to save time.",
	"All souls’ day.",
	"Twentyseventh I’ll be at his grave.",
	"Ten shillings for the gardener.",
	"He keeps it free of weeds.",
	"Old man himself.",
	"Bent down double with his shears clipping.",
	"Near death’s door.",
	"Who passed away.",
	"Who departed this life.",
	"As if they did it of their own accord.",
	"Got the shove, all of them.",
	"Who kicked the bucket.",
	"More interesting if they told you what they were.",
	"So and So, wheelwright.",
	"I travelled for cork lino.",
	"I paid five shillings in the pound.",
	"Or a woman’s with her saucepan.",
	"I cooked good Irish stew.",
	"Eulogy in a country churchyard it ought to be that poem of whose is it Wordsworth or Thomas Campbell.",
	"Entered into rest the protestants put it.",
	"Old Dr Murren’s.",
	"The great physician called him home.",
	"Well it’s God’s acre for them.",
	"Nice country residence.",
	"Newly plastered and painted.",
	"Ideal spot to have a quiet smoke and read the Church Times.",
	"Marriage ads they never try to beautify.",
	"Rusty wreaths hung on knobs, garlands of bronzefoil.",
	"Better value that for the money.",
	"Still, the flowers are more poetical.",
	"The other gets rather tiresome, never withering.",
	"Expresses nothing.",
	"Immortelles.",
	"A bird sat tamely perched on a poplar branch.",
	"Like stuffed.",
	"Like the wedding present alderman Hooper gave us.",
	"Hoo!",
	"Not a budge out of him.",
	"Knows there are no catapults to let fly at him.",
	"Dead animal even sadder.",
	"The Sacred Heart that is: showing it.",
	"Heart on his sleeve.",
	"Ought to be sideways and red it should be painted like a real heart.",
	"Ireland was dedicated to it or whatever that.",
	"Seems anything but pleased.",
	"Why this infliction?",
	"Apollo that was.",
	"How many!",
	"All these here once walked round Dublin.",
	"Faithful departed.",
	"As you are now so once were we.",
	"Besides how could you remember everybody?",
	"Eyes, walk, voice.",
	"Well, the voice, yes: gramophone.",
	"Have a gramophone in every grave or keep it in the house.",
	"After dinner on a Sunday.",
	"Put on poor old greatgrandfather.",
	"Kraahraark!",
	"Hellohellohello amawfullyglad kraark awfullygladaseeagain hellohello amawf krpthsth.",
	"Remind you of the voice like the photograph reminds you of the face.",
	"Otherwise you couldn’t remember the face after fifteen years, say.",
	"For instance who?",
	"For instance some fellow that died when I was in Wisdom Hely’s.",
	"Rtststr!",
	"A rattle of pebbles.",
	"Wait.",
	"Stop!",
	"He looked down intently into a stone crypt.",
	"Some animal.",
	"Wait.",
	"There he goes.",
	"An obese grey rat toddled along the side of the crypt, moving the pebbles.",
	"An old stager: greatgrandfather: he knows the ropes.",
	"The grey alive crushed itself in under the plinth, wriggled itself in under it.",
	"Good hidingplace for treasure.",
	"Who lives there?",
	"Are laid the remains of Robert Emery.",
	"Robert Emmet was buried here by torchlight, wasn’t he?",
	"Making his rounds.",
	"Tail gone now.",
	"One of those chaps would make short work of a fellow.",
	"Pick the bones clean no matter who it was.",
	"Ordinary meat for them.",
	"A corpse is meat gone bad.",
	"Well and what’s cheese?",
	"Corpse of milk.",
	"I read in that Voyages in China that the Chinese say a white man smells like a corpse.",
	"Cremation better.",
	"Priests dead against it.",
	"Devilling for the other firm.",
	"Wholesale burners and Dutch oven dealers.",
	"Time of the plague.",
	"Quicklime feverpits to eat them.",
	"Lethal chamber.",
	"Ashes to ashes.",
	"Or bury at sea.",
	"Where is that Parsee tower of silence?",
	"Eaten by birds.",
	"Earth, fire, water.",
	"Drowning they say is the pleasantest.",
	"See your whole life in a flash.",
	"But being brought back to life no.",
	"Can’t bury in the air however.",
	"Out of a flying machine.",
	"Wonder does the news go about whenever a fresh one is let down.",
	"Underground communication.",
	"We learned that from them.",
	"Wouldn’t be surprised.",
	"Regular square feed for them.",
	"Flies come before he’s well dead.",
	"Got wind of Dignam.",
	"They wouldn’t care about the smell of it.",
	"Saltwhite crumbling mush of corpse: smell, taste like raw white turnips.",
	"The gates glimmered in front: still open.",
	"Back to the world again.",
	"Enough of this place.",
	"Brings you a bit nearer every time.",
	"Last time I was here was Mrs Sinico’s funeral.",
	"Poor papa too.",
	"The love that kills.",
	"Give you the creeps after a bit.",
	"I will appear to you after death.",
	"You will see my ghost after death.",
	"My ghost will haunt you after death.",
	"There is another world after death named hell.",
	"I do not like that other world she wrote.",
	"No more do I.",
	"Plenty to see and hear and feel yet.",
	"Feel live warm beings near you.",
	"Let them sleep in their maggoty beds.",
	"They are not going to get me this innings.",
	"Warm beds: warm fullblooded life.",
	"Martin Cunningham emerged from a sidepath, talking gravely.",
	"Solicitor, I think.",
	"I know his face.",
	"Menton, John Henry, solicitor, commissioner for oaths and affidavits.",
	"Dignam used to be in his office.",
	"Mat Dillon’s long ago.",
	"Jolly Mat.",
	"Convivial evenings.",
	"Cold fowl, cigars, the Tantalus glasses.",
	"Heart of gold really.",
	"Yes, Menton.",
	"Got his rag out that evening on the bowlinggreen because I sailed inside him.",
	"Pure fluke of mine: the bias.",
	"Why he took such a rooted dislike to me.",
	"Hate at first sight.",
	"Molly and Floey Dillon linked under the lilactree, laughing.",
	"Fellow always like that, mortified if women are by.",
	"Got a dinge in the side of his hat.",
	"Carriage probably.",
	"Excuse me, sir, Mr Bloom said beside them.",
	"They stopped.",
	"Your hat is a little crushed, Mr Bloom said pointing.",
	"John Henry Menton stared at him for an instant without moving.",
	"There, Martin Cunningham helped, pointing also.",
	"He clapped the hat on his head again.",
	"It’s all right now, Martin Cunningham said.",
	"John Henry Menton jerked his head down in acknowledgment.",
	"Thank you, he said shortly.",
	"They walked on towards the gates.",
	"Mr Bloom, chapfallen, drew behind a few paces so as not to overhear.",
	"Martin laying down the law.",
	"Martin could wind a sappyhead like that round his little finger, without his seeing it.",
	"Oyster eyes.",
	"Never mind.",
	"Be sorry after perhaps when it dawns on him.",
	"Get the pull over him that way.",
	"Thank you.",
	"How grand we are this morning!",
	"The hoarse Dublin United Tramway Company’s timekeeper bawled them off: Rathgar and Terenure!",
	"Come on, Sandymount Green!",
	"Start, Palmerston Park!",
	"THE WEARER OF THE CROWN Under the porch of the general post office shoeblacks called and polished.",
	"On the brewery float bumped dullthudding barrels rolled by grossbooted draymen out of Prince’s stores.",
	"There it is, Red Murray said.",
	"Alexander Keyes.",
	"Just cut it out, will you?",
	"Mr Bloom said, and I’ll take it round to the Telegraph office.",
	"The door of Ruttledge’s office creaked again.",
	"Red Murray’s long shears sliced out the advertisement from the newspaper in four clean strokes.",
	"Scissors and paste.",
	"I’ll go through the printingworks, Mr Bloom said, taking the cut square.",
	"Right, Mr Bloom said with a nod.",
	"I’ll rub that in.",
	"We.",
	"WILLIAM BRAYDEN, ESQUIRE, OF OAKLANDS, SANDYMOUNT Red Murray touched Mr Bloom’s arm with the shears and whispered: Brayden.",
	"Dullthudding Guinness’s barrels.",
	"It passed statelily up the staircase, steered by an umbrella, a solemn beardframed face.",
	"The broadcloth back ascended each step: back.",
	"All his brains are in the nape of his neck, Simon Dedalus says.",
	"Welts of flesh behind on him.",
	"Fat folds of neck, fat, neck, fat, neck.",
	"Don’t you think his face is like Our Saviour?",
	"Red Murray whispered.",
	"The door of Ruttledge’s office whispered: ee: cree.",
	"They always build one door opposite another for the wind to.",
	"Way in.",
	"Way out.",
	"Our Saviour: beardframed oval face: talking in the dusk.",
	"Mary, Martha.",
	"Steered by an umbrella sword to the footlights: Mario the tenor.",
	"Or like Mario, Mr Bloom said.",
	"Yes, Red Murray agreed.",
	"But Mario was said to be the picture of Our Saviour.",
	"Jesusmario with rougy cheeks, doublet and spindle legs.",
	"Hand on his heart.",
	"In Martha.",
	"Co-ome thou lost one, Co-ome thou dear one!",
	"THE CROZIER AND THE PEN —His grace phoned down twice this morning, Red Murray said gravely.",
	"They watched the knees, legs, boots vanish.",
	"Neck.",
	"Mr Bloom said slowly: Well, he is one of our saviours also.",
	"But will he save the circulation?",
	"Thumping.",
	"Thumping.",
	"He pushed in the glass swingdoor and entered, stepping over strewn packing paper.",
	"Through a lane of clanking drums he made his way towards Nannetti’s reading closet.",
	"Thumping.",
	"Thump.",
	"This morning the remains of the late Mr Patrick Dignam.",
	"Machines.",
	"Smash a man to atoms if they got him caught.",
	"Rule the world today.",
	"His machineries are pegging away too.",
	"Like these, got out of hand: fermenting.",
	"Working away, tearing away.",
	"And that old grey rat tearing to get in.",
	"Strange he never saw his real country.",
	"Ireland my country.",
	"Member for College green.",
	"He boomed that workaday worker tack for all it was worth.",
	"It’s the ads and side features sell a weekly, not the stale news in the official gazette.",
	"Queen Anne is dead.",
	"Published by authority in the year one thousand and.",
	"Demesne situate in the townland of Rosenallis, barony of Tinnahinch.",
	"Nature notes.",
	"Cartoons.",
	"Phil Blake’s weekly Pat and Bull story.",
	"Uncle Toby’s page for tiny tots.",
	"Country bumpkin’s queries.",
	"Dear Mr Editor, what is a good cure for flatulence?",
	"I’d like that part.",
	"Learn a lot teaching others.",
	"The personal note.",
	"M. A. P. Mainly all pictures.",
	"Shapely bathers on golden strand.",
	"World’s biggest balloon.",
	"Double marriage of sisters celebrated.",
	"Two bridegrooms laughing heartily at each other.",
	"Cuprani too, printer.",
	"More Irish than the Irish.",
	"The machines clanked in threefour time.",
	"Thump, thump, thump.",
	"Monkeydoodle the whole thing.",
	"Want a cool head.",
	"Well, get it into the evening edition, councillor, Hynes said.",
	"Soon be calling him my lord mayor.",
	"Long John is backing him, they say.",
	"The foreman, without answering, scribbled press on a corner of the sheet and made a sign to a typesetter.",
	"He handed the sheet silently over the dirty glass screen.",
	"Right: thanks, Hynes said moving off.",
	"Mr Bloom stood in his way.",
	"If you want to draw the cashier is just going to lunch, he said, pointing backward with his thumb.",
	"Did you?",
	"Hynes asked.",
	"Mm, Mr Bloom said.",
	"Look sharp and you’ll catch him.",
	"Thanks, old man, Hynes said.",
	"I’ll tap him too.",
	"He hurried on eagerly towards the Freeman’s Journal.",
	"Three bob I lent him in Meagher’s.",
	"Three weeks.",
	"Third hint.",
	"WE SEE THE CANVASSER AT WORK Mr Bloom laid his cutting on Mr Nannetti’s desk.",
	"Excuse me, councillor, he said.",
	"This ad, you see.",
	"Keyes, you remember?",
	"Mr Nannetti considered the cutting awhile and nodded.",
	"He wants it in for July, Mr Bloom said.",
	"The foreman moved his pencil towards it.",
	"But wait, Mr Bloom said.",
	"He wants it changed.",
	"Keyes, you see.",
	"He wants two keys at the top.",
	"Hell of a racket they make.",
	"He doesn’t hear it.",
	"Nannan.",
	"Iron nerves.",
	"Maybe he understands what I.",
	"Like that, Mr Bloom said, crossing his forefingers at the top.",
	"Let him take that in first.",
	"Clank it.",
	"Clank it.",
	"Miles of it unreeled.",
	"What becomes of it after?",
	"O, wrap up meat, parcels: various uses, thousand and one things.",
	"Slipping his words deftly into the pauses of the clanking he drew swiftly on the scarred woodwork.",
	"HOUSE OF KEY(E)S —Like that, see.",
	"Two crossed keys here.",
	"A circle.",
	"Then here the name.",
	"Alexander Keyes, tea, wine and spirit merchant.",
	"So on.",
	"Better not teach him his own business.",
	"You know yourself, councillor, just what he wants.",
	"Then round the top in leaded: the house of keys.",
	"You see?",
	"Do you think that’s a good idea?",
	"The foreman moved his scratching hand to his lower ribs and scratched there quietly.",
	"The idea, Mr Bloom said, is the house of keys.",
	"You know, councillor, the Manx parliament.",
	"Innuendo of home rule.",
	"Tourists, you know, from the isle of Man.",
	"Catches the eye, you see.",
	"Can you do that?",
	"I could ask him perhaps about how to pronounce that voglio.",
	"But then if he didn’t know only make it awkward for him.",
	"Better not.",
	"We can do that, the foreman said.",
	"Have you the design?",
	"I can get it, Mr Bloom said.",
	"It was in a Kilkenny paper.",
	"He has a house there too.",
	"I’ll just run out and ask him.",
	"Well, you can do that and just a little par calling attention.",
	"You know the usual.",
	"Highclass licensed premises.",
	"Longfelt want.",
	"So on.",
	"The foreman thought for an instant.",
	"We can do that, he said.",
	"Let him give us a three months’ renewal.",
	"A typesetter brought him a limp galleypage.",
	"He began to check it silently.",
	"Mr Bloom stood by, hearing the loud throbs of cranks, watching the silent typesetters at their cases.",
	"ORTHOGRAPHICAL Want to be sure of his spelling.",
	"Proof fever.",
	"Martin Cunningham forgot to give us his spellingbee conundrum this morning.",
	"It is amusing to view the unpar one ar alleled embarra two ars is it?",
	"Silly, isn’t it?",
	"Cemetery put in of course on account of the symmetry.",
	"I should have said when he clapped on his topper.",
	"Thank you.",
	"I ought to have said something about an old hat or something.",
	"No.",
	"I could have said.",
	"Looks as good as new now.",
	"See his phiz then.",
	"Sllt.",
	"The nethermost deck of the first machine jogged forward its flyboard with sllt the first batch of quirefolded papers.",
	"Sllt.",
	"Almost human the way it sllt to call attention.",
	"Doing its level best to speak.",
	"That door too sllt creaking, asking to be shut.",
	"Everything speaks in its own way.",
	"Sllt.",
	"NOTED CHURCHMAN AN OCCASIONAL CONTRIBUTOR The foreman handed back the galleypage suddenly, saying: Wait.",
	"Where’s the archbishop’s letter?",
	"It’s to be repeated in the Telegraph.",
	"Where’s what’s his name?",
	"He looked about him round his loud unanswering machines.",
	"Monks, sir?",
	"a voice asked from the castingbox.",
	"Ay.",
	"Where’s Monks?",
	"Monks!",
	"Mr Bloom took up his cutting.",
	"Time to get out.",
	"Then I’ll get the design, Mr Nannetti, he said, and you’ll give it a good place I know.",
	"Monks!",
	"Yes, sir.",
	"Three months’ renewal.",
	"Want to get some wind off my chest first.",
	"Try it anyhow.",
	"Rub in August: good idea: horseshow month.",
	"Ballsbridge.",
	"Tourists over for the show.",
	"A DAYFATHER He walked on through the caseroom passing an old man, bowed, spectacled, aproned.",
	"Old Monks, the dayfather.",
	"Nearing the end of his tether now.",
	"Sober serious man with a bit in the savingsbank I’d say.",
	"Wife a good cook and washer.",
	"Daughter working the machine in the parlour.",
	"Plain Jane, no damn nonsense.",
	"Reads it backwards first.",
	"Quickly he does it.",
	"Must require some practice that.",
	"mangiD kcirtaP.",
	"Poor papa with his hagadah book, reading backwards with his finger to me.",
	"Pessach.",
	"Next year in Jerusalem.",
	"Dear, O dear!",
	"Shema Israel Adonai Elohenu.",
	"No, that’s the other.",
	"Then the twelve brothers, Jacob’s sons.",
	"And then the lamb and the cat and the dog and the stick and the water and the butcher.",
	"Sounds a bit silly till you come to look into it well.",
	"Justice it means but it’s everybody eating everyone else.",
	"That’s what life is after all.",
	"How quickly he does that job.",
	"Practice makes perfect.",
	"Seems to see with his fingers.",
	"Mr Bloom passed on out of the clanking noises through the gallery on to the landing.",
	"Now am I going to tram it out all the way and then catch him out perhaps.",
	"Better phone him up first.",
	"Number?",
	"Yes.",
	"Same as Citron’s house.",
	"Twentyeight.",
	"Twentyeight double four.",
	"ONLY ONCE MORE THAT SOAP He went down the house staircase.",
	"Who the deuce scrawled all over those walls with matches?",
	"Looks as if they did it for a bet.",
	"Heavy greasy smell there always is in those works.",
	"Lukewarm glue in Thom’s next door when I was there.",
	"He took out his handkerchief to dab his nose.",
	"Citronlemon?",
	"Ah, the soap I put there.",
	"Lose it out of that pocket.",
	"What perfume does your wife use?",
	"I could go home still: tram: something I forgot.",
	"Just to see: before: dressing.",
	"No.",
	"Here.",
	"No.",
	"A sudden screech of laughter came from the Evening Telegraph office.",
	"Know who that is.",
	"What’s up?",
	"Pop in a minute to phone.",
	"Ned Lambert it is.",
	"He entered softly.",
	"ERIN, GREEN GEM OF THE SILVER SEA —The ghost walks, professor MacHugh murmured softly, biscuitfully to the dusty windowpane.",
	"What about that, Simon?",
	"he asked over the fringe of his newspaper.",
	"How’s that for high?",
	"Changing his drink, Mr Dedalus said.",
	"Ned Lambert, laughing, struck the newspaper on his knees, repeating: The pensive bosom and the overarsing leafage.",
	"O boys!",
	"O boys!",
	"That will do, professor MacHugh cried from the window.",
	"I don’t want to hear any more of the stuff.",
	"High falutin stuff.",
	"Bladderbags.",
	"Ned Lambert is taking a day off I see.",
	"Rather upsets a man’s day, a funeral does.",
	"He has influence they say.",
	"Old Chatterton, the vicechancellor, is his granduncle or his greatgranduncle.",
	"Close on ninety they say.",
	"Subleader for his death written this long time perhaps.",
	"Living to spite them.",
	"Might go first himself.",
	"Johnny, make room for your uncle.",
	"The right honourable Hedges Eyre Chatterton.",
	"Daresay he writes him an odd shaky cheque or two on gale days.",
	"Windfall when he kicks out.",
	"Alleluia.",
	"Just another spasm, Ned Lambert said.",
	"What is it?",
	"Mr Bloom asked.",
	"A recently discovered fragment of Cicero, professor MacHugh answered with pomp of tone.",
	"Our lovely land.",
	"SHORT BUT TO THE POINT —Whose land?",
	"Mr Bloom said simply.",
	"Most pertinent question, the professor said between his chews.",
	"With an accent on the whose.",
	"Dan Dawson’s land Mr Dedalus said.",
	"Is it his speech last night?",
	"Mr Bloom asked.",
	"Ned Lambert nodded.",
	"But listen to this, he said.",
	"The doorknob hit Mr Bloom in the small of the back as the door was pushed in.",
	"Excuse me, J. J. O’Molloy said, entering.",
	"Mr Bloom moved nimbly aside.",
	"I beg yours, he said.",
	"Good day, Jack.",
	"Come in.",
	"Come in.",
	"Good day.",
	"How are you, Dedalus?",
	"Well.",
	"And yourself?",
	"J. J. O’Molloy shook his head.",
	"SAD Cleverest fellow at the junior bar he used to be.",
	"Decline, poor chap.",
	"That hectic flush spells finis for a man.",
	"Touch and go with him.",
	"What’s in the wind, I wonder.",
	"Money worry.",
	"Or again if we but climb the serried mountain peaks.",
	"You’re looking extra.",
	"Is the editor to be seen?",
	"J. J. O’Molloy asked, looking towards the inner door.",
	"Very much so, professor MacHugh said.",
	"To be seen and heard.",
	"He’s in his sanctum with Lenehan.",
	"J. J. O’Molloy strolled to the sloping desk and began to turn back the pink pages of the file.",
	"Practice dwindling.",
	"A mighthavebeen.",
	"Losing heart.",
	"Gambling.",
	"Debts of honour.",
	"Reaping the whirlwind.",
	"Used to get good retainers from D. and T. Fitzgerald.",
	"Their wigs to show the grey matter.",
	"Brains on their sleeve like the statue in Glasnevin.",
	"Believe he does some literary work for the Express with Gabriel Conroy.",
	"Wellread fellow.",
	"Myles Crawford began on the Independent.",
	"Funny the way those newspaper men veer about when they get wind of a new opening.",
	"Weathercocks.",
	"Hot and cold in the same breath.",
	"Wouldn’t know which to believe.",
	"One story good till you hear the next.",
	"Go for one another baldheaded in the papers and then all blows over.",
	"Hail fellow well met the next moment.",
	"Ah, listen to this for God’ sake, Ned Lambert pleaded.",
	"Or again if we but climb the serried mountain peaks... —Bombast!",
	"the professor broke in testily.",
	"Enough of the inflated windbag!",
	"Blessed and eternal God!",
	"Yes?",
	"Is he taking anything for it?",
	"He forgot Hamlet.",
	"Mr Dedalus cried, giving vent to a hopeless groan.",
	"Shite and onions!",
	"That’ll do, Ned.",
	"Life is too short.",
	"He took off his silk hat and, blowing out impatiently his bushy moustache, welshcombed his hair with raking fingers.",
	"Ned Lambert tossed the newspaper aside, chuckling with delight.",
	"An instant after a hoarse bark of laughter burst over professor MacHugh’s unshaven blackspectacled face.",
	"Doughy Daw!",
	"he cried.",
	"He was in the bakery line too, wasn’t he?",
	"Why they call him Doughy Daw.",
	"Feathered his nest well anyhow.",
	"Daughter engaged to that chap in the inland revenue office with the motor.",
	"Hooked that nicely.",
	"Entertainments.",
	"Open house.",
	"Big blowout.",
	"Wetherup always said that.",
	"Get a grip of them by the stomach.",
	"The bold blue eyes stared about them and the harsh voice asked: What is it?",
	"And here comes the sham squire himself!",
	"professor MacHugh said grandly.",
	"Getonouthat, you bloody old pedagogue!",
	"the editor said in recognition.",
	"Come, Ned, Mr Dedalus said, putting on his hat.",
	"I must get a drink after that.",
	"Drink!",
	"the editor cried.",
	"No drinks served before mass.",
	"Quite right too, Mr Dedalus said, going out.",
	"Come on, Ned.",
	"Ned Lambert sidled down from the table.",
	"The editor’s blue eyes roved towards Mr Bloom’s face, shadowed by a smile.",
	"Will you join us, Myles?",
	"Ned Lambert asked.",
	"MEMORABLE BATTLES RECALLED —North Cork militia!",
	"the editor cried, striding to the mantelpiece.",
	"We won every time!",
	"North Cork and Spanish officers!",
	"Where was that, Myles?",
	"Ned Lambert asked with a reflective glance at his toecaps.",
	"In Ohio!",
	"the editor shouted.",
	"So it was, begad, Ned Lambert agreed.",
	"Passing out he whispered to J. J. O’Molloy: Incipient jigs.",
	"Sad case.",
	"Ohio!",
	"the editor crowed in high treble from his uplifted scarlet face.",
	"My Ohio!",
	"A perfect cretic!",
	"the professor said.",
	"Long, short and long.",
	"O, HARP EOLIAN!",
	"Bingbang, bangbang.",
	"Mr Bloom, seeing the coast clear, made for the inner door.",
	"Just a moment, Mr Crawford, he said.",
	"I just want to phone about an ad.",
	"He went in.",
	"What about that leader this evening?",
	"professor MacHugh asked, coming to the editor and laying a firm hand on his shoulder.",
	"That’ll be all right, Myles Crawford said more calmly.",
	"Never you fret.",
	"Hello, Jack.",
	"That’s all right.",
	"Good day, Myles, J. J. O’Molloy said, letting the pages he held slip limply back on the file.",
	"Is that Canada swindle case on today?",
	"The telephone whirred inside.",
	"Twentyeight... No, twenty...",
	"Double four...",
	"Yes.",
	"SPOT THE WINNER Lenehan came out of the inner office with Sport’s tissues.",
	"Who wants a dead cert for the Gold cup?",
	"he asked.",
	"Sceptre with O. Madden up.",
	"He tossed the tissues on to the table.",
	"Screams of newsboys barefoot in the hall rushed near and the door was flung open.",
	"Hush, Lenehan said.",
	"I hear feetstoops.",
	"It wasn’t me, sir.",
	"It was the big fellow shoved me, sir.",
	"Throw him out and shut the door, the editor said.",
	"There’s a hurricane blowing.",
	"Lenehan began to paw the tissues up from the floor, grunting as he stooped twice.",
	"Waiting for the racing special, sir, the newsboy said.",
	"It was Pat Farrell shoved me, sir.",
	"He pointed to two faces peering in round the doorframe.",
	"Him, sir.",
	"Out of this with you, professor MacHugh said gruffly.",
	"He hustled the boy out and banged the door to.",
	"J. J. O’Molloy turned the files crackingly over, murmuring, seeking: Continued on page six, column four.",
	"Yes, Evening Telegraph here, Mr Bloom phoned from the inner office.",
	"Is the boss...?",
	"Yes, Telegraph... To where?",
	"Aha!",
	"Which auction rooms?...",
	"Aha!",
	"I see...",
	"Right.",
	"I’ll catch him.",
	"A COLLISION ENSUES The bell whirred again as he rang off.",
	"He came in quickly and bumped against Lenehan who was struggling up with the second tissue.",
	"Pardon, monsieur, Lenehan said, clutching him for an instant and making a grimace.",
	"My fault, Mr Bloom said, suffering his grip.",
	"Are you hurt?",
	"I’m in a hurry.",
	"Knee, Lenehan said.",
	"He made a comic face and whined, rubbing his knee: The accumulation of the anno Domini.",
	"Sorry, Mr Bloom said.",
	"He went to the door and, holding it ajar, paused.",
	"J. J. O’Molloy slapped the heavy pages over.",
	"EXIT BLOOM —I’m just running round to Bachelor’s walk, Mr Bloom said, about this ad of Keyes’s.",
	"Want to fix it up.",
	"They tell me he’s round there in Dillon’s.",
	"He looked indecisively for a moment at their faces.",
	"Begone!",
	"he said.",
	"The world is before you.",
	"Back in no time, Mr Bloom said, hurrying out.",
	"J. J. O’Molloy took the tissues from Lenehan’s hand and read them, blowing them apart gently, without comment.",
	"He’ll get that advertisement, the professor said, staring through his blackrimmed spectacles over the crossblind.",
	"Look at the young scamps after him.",
	"Show.",
	"Where?",
	"Lenehan cried, running to the window.",
	"Look at the young guttersnipe behind him hue and cry, Lenehan said, and you’ll kick.",
	"O, my rib risible!",
	"Taking off his flat spaugs and the walk.",
	"Small nines.",
	"Steal upon larks.",
	"What’s that?",
	"Myles Crawford said with a start.",
	"Where are the other two gone?",
	"Who?",
	"the professor said, turning.",
	"They’re gone round to the Oval for a drink.",
	"Paddy Hooper is there with Jack Hall.",
	"Came over last night.",
	"Come on then, Myles Crawford said.",
	"Where’s my hat?",
	"They jingled then in the air and against the wood as he locked his desk drawer.",
	"He’s pretty well on, professor MacHugh said in a low voice.",
	"Who has the most matches?",
	"THE CALUMET OF PEACE He offered a cigarette to the professor and took one himself.",
	"Lenehan promptly struck a match for them and lit their cigarettes in turn.",
	"J. J. O’Molloy opened his case again and offered it.",
	"Thanky vous, Lenehan said, helping himself.",
	"The editor came from the inner office, a straw hat awry on his brow.",
	"The professor grinned, locking his long lips.",
	"Eh?",
	"You bloody old Roman empire?",
	"Myles Crawford said.",
	"He took a cigarette from the open case.",
	"Lenehan, lighting it for him with quick grace, said: Silence for my brandnew riddle!",
	"Imperium romanum, J. J. O’Molloy said gently.",
	"It sounds nobler than British or Brixton.",
	"The word reminds one somehow of fat in the fire.",
	"Myles Crawford blew his first puff violently towards the ceiling.",
	"That’s it, he said.",
	"We are the fat.",
	"You and I are the fat in the fire.",
	"We haven’t got the chance of a snowball in hell.",
	"THE GRANDEUR THAT WAS ROME —Wait a moment, professor MacHugh said, raising two quiet claws.",
	"We mustn’t be led away by words, by sounds of words.",
	"We think of Rome, imperial, imperious, imperative.",
	"He extended elocutionary arms from frayed stained shirtcuffs, pausing: What was their civilisation?",
	"Vast, I allow: but vile.",
	"Cloacae: sewers.",
	"The Jews in the wilderness and on the mountaintop said: It is meet to be here.",
	"Let us build an altar to Jehovah.",
	"He gazed about him in his toga and he said: It is meet to be here.",
	"Let us construct a watercloset.",
	"Which they accordingly did do, Lenehan said.",
	"Our old ancient ancestors, as we read in the first chapter of Guinness’s, were partial to the running stream.",
	"They were nature’s gentlemen, J. J. O’Molloy murmured.",
	"But we have also Roman law.",
	"And Pontius Pilate is its prophet, professor MacHugh responded.",
	"Do you know that story about chief baron Palles?",
	"J. J. O’Molloy asked.",
	"It was at the royal university dinner.",
	"Everything was going swimmingly ... —First my riddle, Lenehan said.",
	"Are you ready?",
	"Mr O’Madden Burke, tall in copious grey of Donegal tweed, came in from the hallway.",
	"Stephen Dedalus, behind him, uncovered as he entered.",
	"Entrez, mes enfants!",
	"Lenehan cried.",
	"I escort a suppliant, Mr O’Madden Burke said melodiously.",
	"Youth led by Experience visits Notoriety.",
	"How do you do?",
	"the editor said, holding out a hand.",
	"Come in.",
	"Your governor is just gone.",
	"???",
	"Lenehan said to all: Silence!",
	"What opera resembles a railwayline?",
	"Reflect, ponder, excogitate, reply.",
	"Stephen handed over the typed sheets, pointing to the title and signature.",
	"Who?",
	"the editor asked.",
	"Bit torn off.",
	"Mr Garrett Deasy, Stephen said.",
	"That old pelters, the editor said.",
	"Who tore it?",
	"Was he short taken?",
	"On swift sail flaming From storm and south He comes, pale vampire, Mouth to my mouth.",
	"Good day, Stephen, the professor said, coming to peer over their shoulders.",
	"Foot and mouth?",
	"Are you turned...?",
	"Bullockbefriending bard.",
	"SHINDY IN WELLKNOWN RESTAURANT —Good day, sir, Stephen answered blushing.",
	"The letter is not mine.",
	"Mr Garrett Deasy asked me to... —O, I know him, Myles Crawford said, and I knew his wife too.",
	"The bloodiest old tartar God ever made.",
	"By Jesus, she had the foot and mouth disease and no mistake!",
	"The night she threw the soup in the waiter’s face in the Star and Garter.",
	"Oho!",
	"A woman brought sin into the world.",
	"For Helen, the runaway wife of Menelaus, ten years the Greeks.",
	"O’Rourke, prince of Breffni.",
	"Is he a widower?",
	"Stephen asked.",
	"Ay, a grass one, Myles Crawford said, his eye running down the typescript.",
	"Emperor’s horses.",
	"Habsburg.",
	"An Irishman saved his life on the ramparts of Vienna.",
	"Don’t you forget!",
	"Maximilian Karl O’Donnell, graf von Tirconnell in Ireland.",
	"Sent his heir over to make the king an Austrian fieldmarshal now.",
	"Going to be trouble there one day.",
	"Wild geese.",
	"O yes, every time.",
	"Don’t you forget that!",
	"The moot point is did he forget it, J. J. O’Molloy said quietly, turning a horseshoe paperweight.",
	"Saving princes is a thank you job.",
	"Professor MacHugh turned on him.",
	"And if not?",
	"he said.",
	"I’ll tell you how it was, Myles Crawford began.",
	"Success for us is the death of the intellect and of the imagination.",
	"We were never loyal to the successful.",
	"We serve them.",
	"I teach the blatant Latin language.",
	"I speak the tongue of a race the acme of whose mentality is the maxim: time is money.",
	"Material domination.",
	"Dominus!",
	"Lord!",
	"Where is the spirituality?",
	"Lord Jesus?",
	"Lord Salisbury?",
	"A sofa in a westend club.",
	"But the Greek!",
	"KYRIE ELEISON!",
	"A smile of light brightened his darkrimmed eyes, lengthened his long lips.",
	"The Greek!",
	"he said again.",
	"Kyrios!",
	"Shining word!",
	"The vowels the Semite and the Saxon know not.",
	"Kyrie!",
	"The radiance of the intellect.",
	"I ought to profess Greek, the language of the mind.",
	"Kyrie eleison!",
	"The closetmaker and the cloacamaker will never be lords of our spirit.",
	"Yes, yes.",
	"They went under.",
	"Pyrrhus, misled by an oracle, made a last attempt to retrieve the fortunes of Greece.",
	"Loyal to a lost cause.",
	"He strode away from them towards the window.",
	"They went forth to battle, Mr O’Madden Burke said greyly, but they always fell.",
	"Boohoo!",
	"Lenehan wept with a little noise.",
	"Owing to a brick received in the latter half of the matinée.",
	"Poor, poor, poor Pyrrhus!",
	"He whispered then near Stephen’s ear: LENEHAN’S LIMERICK There’s a ponderous pundit MacHugh Who wears goggles of ebony hue.",
	"As he mostly sees double To wear them why trouble?",
	"I can’t see the Joe Miller.",
	"Can you?",
	"In mourning for Sallust, Mulligan says.",
	"Whose mother is beastly dead.",
	"Myles Crawford crammed the sheets into a sidepocket.",
	"That’ll be all right, he said.",
	"I’ll read the rest after.",
	"That’ll be all right.",
	"Lenehan extended his hands in protest.",
	"But my riddle!",
	"he said.",
	"What opera is like a railwayline?",
	"Opera?",
	"Mr O’Madden Burke’s sphinx face reriddled.",
	"Lenehan announced gladly: The Rose of Castile.",
	"See the wheeze?",
	"Rows of cast steel.",
	"Gee!",
	"He poked Mr O’Madden Burke mildly in the spleen.",
	"Mr O’Madden Burke fell back with grace on his umbrella, feigning a gasp.",
	"Help!",
	"he sighed.",
	"I feel a strong weakness.",
	"Lenehan, rising to tiptoe, fanned his face rapidly with the rustling tissues.",
	"The professor, returning by way of the files, swept his hand across Stephen’s and Mr O’Madden Burke’s loose ties.",
	"Paris, past and present, he said.",
	"You look like communards.",
	"Like fellows who had blown up the Bastile, J. J. O’Molloy said in quiet mockery.",
	"Or was it you shot the lord lieutenant of Finland between you?",
	"You look as though you had done the deed.",
	"General Bobrikoff.",
	"OMNIUM GATHERUM —We were only thinking about it, Stephen said.",
	"All the talents, Myles Crawford said.",
	"Law, the classics... —The turf, Lenehan put in.",
	"Literature, the press.",
	"If Bloom were here, the professor said.",
	"The gentle art of advertisement.",
	"And Madam Bloom, Mr O’Madden Burke added.",
	"The vocal muse.",
	"Dublin’s prime favourite.",
	"Lenehan gave a loud cough.",
	"Ahem!",
	"he said very softly.",
	"O, for a fresh of breath air!",
	"I caught a cold in the park.",
	"The gate was open.",
	"\"YOU CAN DO IT!” The editor laid a nervous hand on Stephen’s shoulder.",
	"I want you to write something for me, he said.",
	"Something with a bite in it.",
	"You can do it.",
	"I see it in your face.",
	"In the lexicon of youth ... See it in your face.",
	"See it in your eye.",
	"Lazy idle little schemer.",
	"Foot and mouth disease!",
	"the editor cried in scornful invective.",
	"Great nationalist meeting in Borris-in-Ossory.",
	"All balls!",
	"Bulldosing the public!",
	"Give them something with a bite in it.",
	"Put us all into it, damn its soul.",
	"Father, Son and Holy Ghost and Jakes M’Carthy.",
	"We can all supply mental pabulum, Mr O’Madden Burke said.",
	"Stephen raised his eyes to the bold unheeding stare.",
	"He wants you for the pressgang, J. J. O’Molloy said.",
	"THE GREAT GALLAHER —You can do it, Myles Crawford repeated, clenching his hand in emphasis.",
	"Wait a minute.",
	"Gallaher, that was a pressman for you.",
	"That was a pen.",
	"You know how he made his mark?",
	"I’ll tell you.",
	"That was the smartest piece of journalism ever known.",
	"I’ll show you.",
	"He pushed past them to the files.",
	"Look at here, he said turning.",
	"The New York World cabled for a special.",
	"Remember that time?",
	"Professor MacHugh nodded.",
	"New York World, the editor said, excitedly pushing back his straw hat.",
	"Where it took place.",
	"Tim Kelly, or Kavanagh I mean.",
	"Joe Brady and the rest of them.",
	"Where Skin-the-Goat drove the car.",
	"Whole route, see?",
	"Skin-the-Goat, Mr O’Madden Burke said.",
	"Fitzharris.",
	"He has that cabman’s shelter, they say, down there at Butt bridge.",
	"Holohan told me.",
	"You know Holohan?",
	"Hop and carry one, is it?",
	"Myles Crawford said.",
	"And poor Gumley is down there too, so he told me, minding stones for the corporation.",
	"A night watchman.",
	"Stephen turned in surprise.",
	"Gumley?",
	"he said.",
	"You don’t say so?",
	"A friend of my father’s, is it?",
	"Never mind Gumley, Myles Crawford cried angrily.",
	"Let Gumley mind the stones, see they don’t run away.",
	"Look at here.",
	"What did Ignatius Gallaher do?",
	"I’ll tell you.",
	"Inspiration of genius.",
	"Cabled right away.",
	"Have you Weekly Freeman of 17 March?",
	"Right.",
	"Have you got that?",
	"He flung back pages of the files and stuck his finger on a point.",
	"Take page four, advertisement for Bransome’s coffee, let us say.",
	"Have you got that?",
	"Right.",
	"The telephone whirred.",
	"A DISTANT VOICE —I’ll answer it, the professor said, going.",
	"B is parkgate.",
	"Good.",
	"His finger leaped and struck point after point, vibrating.",
	"T is viceregal lodge.",
	"C is where murder took place.",
	"K is Knockmaroon gate.",
	"The loose flesh of his neck shook like a cock’s wattles.",
	"An illstarched dicky jutted up and with a rude gesture he thrust it back into his waistcoat.",
	"Hello?",
	"Evening Telegraph here...",
	"Hello?...",
	"Who’s there?...",
	"Yes...",
	"Yes...",
	"Yes.",
	"F.A.B.P.",
	"Got that?",
	"X is Davy’s publichouse in upper Leeson street.",
	"The professor came to the inner door.",
	"Bloom is at the telephone, he said.",
	"Tell him go to hell, the editor said promptly.",
	"X is Davy’s publichouse, see?",
	"CLEVER, VERY —Clever, Lenehan said.",
	"Very.",
	"Gave it to them on a hot plate, Myles Crawford said, the whole bloody history.",
	"Nightmare from which you will never awake.",
	"I saw it, the editor said proudly.",
	"I was present.",
	"Dick Adams, the besthearted bloody Corkman the Lord ever put the breath of life in, and myself.",
	"Lenehan bowed to a shape of air, announcing: Madam, I’m Adam.",
	"And Able was I ere I saw Elba.",
	"History!",
	"Myles Crawford cried.",
	"The Old Woman of Prince’s street was there first.",
	"There was weeping and gnashing of teeth over that.",
	"Out of an advertisement.",
	"Gregor Grey made the design for it.",
	"That gave him the leg up.",
	"Then Paddy Hooper worked Tay Pay who took him on to the Star.",
	"Now he’s got in with Blumenfeld.",
	"That’s press.",
	"That’s talent.",
	"Pyatt!",
	"He was all their daddies!",
	"The father of scare journalism, Lenehan confirmed, and the brother-in-law of Chris Callinan.",
	"Hello?...",
	"Are you there?...",
	"Yes, he’s here still.",
	"Come across yourself.",
	"Where do you find a pressman like that now, eh?",
	"the editor cried.",
	"He flung the pages down.",
	"Clamn dever, Lenehan said to Mr O’Madden Burke.",
	"Very smart, Mr O’Madden Burke said.",
	"Professor MacHugh came from the inner office.",
	"And it turned out to be a commemoration postcard of Joe Brady or Number One or Skin-the-Goat.",
	"Right outside the viceregal lodge, imagine!",
	"They’re only in the hook and eye department, Myles Crawford said.",
	"Psha!",
	"Press and the bar!",
	"Eh?",
	"Ah, bloody nonsense.",
	"Psha!",
	"Only in the halfpenny place.",
	"His mouth continued to twitch unspeaking in nervous curls of disdain.",
	"Would anyone wish that mouth for her kiss?",
	"How do you know?",
	"Why did you write it then?",
	"RHYMES AND REASONS Mouth, south.",
	"Is the mouth south someway?",
	"Or the south a mouth?",
	"Must be some.",
	"South, pout, out, shout, drouth.",
	"Rhymes: two men dressed the same, looking the same, two by two.",
	"........................ la tua pace .................. che parlar ti piace Mentre che il vento, come fa, si tace.",
	"But I old men, penitent, leadenfooted, underdarkneath the night: mouth south: tomb womb.",
	"Speak up for yourself, Mr O’Madden Burke said.",
	"SUFFICIENT FOR THE DAY... J. J. O’Molloy, smiling palely, took up the gage.",
	"My dear Myles, he said, flinging his cigarette aside, you put a false construction on my words.",
	"Why not bring in Henry Grattan and Flood and Demosthenes and Edmund Burke?",
	"Why bring in a master of forensic eloquence like Whiteside?",
	"Sufficient for the day is the newspaper thereof.",
	"Irish volunteers.",
	"Where are you now?",
	"Established 1763.",
	"Dr Lucas.",
	"Who have you now like John Philpot Curran?",
	"Psha!",
	"Well, J. J. O’Molloy said, Bushe K.C., for example.",
	"Bushe?",
	"the editor said.",
	"Well, yes: Bushe, yes.",
	"He has a strain of it in his blood.",
	"Kendal Bushe or I mean Seymour Bushe.",
	"He would have been on the bench long ago, the professor said, only for ...",
	"But no matter.",
	"It was in that case of fratricide, the Childs murder case.",
	"Bushe defended him.",
	"And in the porches of mine ear did pour.",
	"By the way how did he find that out?",
	"He died in his sleep.",
	"Or the other story, beast with two backs?",
	"What was that?",
	"the professor asked.",
	"And he cited the Moses of Michelangelo in the vatican.",
	"Ha.",
	"A few wellchosen words, Lenehan prefaced.",
	"Silence!",
	"Pause.",
	"J. J. O’Molloy took out his cigarettecase.",
	"False lull.",
	"Something quite ordinary.",
	"Messenger took out his matchbox thoughtfully and lit his cigar.",
	"His slim hand with a wave graced echo and fall.",
	"Fine!",
	"Myles Crawford said at once.",
	"The divine afflatus, Mr O’Madden Burke said.",
	"You like it?",
	"J. J. O’Molloy asked Stephen.",
	"Stephen, his blood wooed by grace of language and gesture, blushed.",
	"He took a cigarette from the case.",
	"J. J. O’Molloy offered his case to Myles Crawford.",
	"Lenehan lit their cigarettes as before and took his trophy, saying: Muchibus thankibus.",
	"A MAN OF HIGH MORALE —Professor Magennis was speaking to me about you, J. J. O’Molloy said to Stephen.",
	"What do you think really of that hermetic crowd, the opal hush poets: A. E. the mastermystic?",
	"That Blavatsky woman started it.",
	"She was a nice old bag of tricks.",
	"Magennis thinks you must have been pulling A. E.‘s leg.",
	"He is a man of the very highest morale, Magennis.",
	"Speaking about me.",
	"What did he say?",
	"What did he say?",
	"What did he say about me?",
	"Don’t ask.",
	"No, thanks, professor MacHugh said, waving the cigarettecase aside.",
	"Wait a moment.",
	"Let me say one thing.",
	"He turned towards Myles Crawford and said: You know Gerald Fitzgibbon.",
	"Then you can imagine the style of his discourse.",
	"He is sitting with Tim Healy, J. J. O’Molloy said, rumour has it, on the Trinity college estates commission.",
	"He is sitting with a sweet thing, Myles Crawford said, in a child’s frock.",
	"Go on.",
	"Well?",
	"It was then a new movement.",
	"We were weak, therefore worthless.",
	"IMPROMPTU In ferial tone he addressed J. J. O’Molloy: Taylor had come there, you must know, from a sickbed.",
	"His dark lean face had a growth of shaggy beard round it.",
	"He wore a loose white silk neckcloth and altogether he looked (though he was not) a dying man.",
	"His unglazed linen collar appeared behind his bent head, soiled by his withering hair.",
	"Still seeking, he said: When Fitzgibbon’s speech had ended John F Taylor rose to reply.",
	"Briefly, as well as I can bring them to mind, his words were these.",
	"He raised his head firmly.",
	"His eyes bethought themselves once more.",
	"Witless shellfish swam in the gross lenses to and fro, seeking outlet.",
	"His listeners held their cigarettes poised to hear, their smokes ascending in frail stalks that flowered with his speech.",
	"And let our crooked smokes.",
	"Noble words coming.",
	"Look out.",
	"Could you try your hand at it yourself?",
	"I heard his words and their meaning was revealed to me.",
	"Ah, curse you!",
	"That’s saint Augustine.",
	"Why will you jews not accept our culture, our religion and our language?",
	"You are a tribe of nomad herdsmen: we are a mighty people.",
	"You have but emerged from primitive conditions: we have a literature, a priesthood, an agelong history and a polity.",
	"Nile.",
	"Child, man, effigy.",
	"By the Nilebank the babemaries kneel, cradle of bulrushes: a man supple in combat: stonehorned, stonebearded, heart of stone.",
	"Yours serfdom, awe and humbleness: ours thunder and the seas.",
	"Israel is weak and few are her children: Egypt is an host and terrible are her arms.",
	"Vagrants and daylabourers are you called: the world trembles at our name.",
	"A dumb belch of hunger cleft his speech.",
	"He ceased and looked at them, enjoying a silence.",
	"OMINOUS—FOR HIM!",
	"J. J. O’Molloy said not without regret: And yet he died without having entered the land of promise.",
	"A sudden—at—the—moment—though—from—lingering—illness—often— previously—expectorated—demise, Lenehan added.",
	"And with a great future behind him.",
	"The troop of bare feet was heard rushing along the hallway and pattering up the staircase.",
	"That is oratory, the professor said uncontradicted.",
	"Gone with the wind.",
	"Hosts at Mullaghmast and Tara of the kings.",
	"Miles of ears of porches.",
	"The tribune’s words, howled and scattered to the four winds.",
	"A people sheltered within his voice.",
	"Dead noise.",
	"Akasic records of all that ever anywhere wherever was.",
	"Love and laud him: me no more.",
	"I have money.",
	"Gentlemen, Stephen said.",
	"As the next motion on the agenda paper may I suggest that the house do now adjourn?",
	"You take my breath away.",
	"It is not perchance a French compliment?",
	"Mr O’Madden Burke asked.",
	"‘Tis the hour, methinks, when the winejug, metaphorically speaking, is most grateful in Ye ancient hostelry.",
	"That it be and hereby is resolutely resolved.",
	"All that are in favour say ay, Lenehan announced.",
	"The contrary no.",
	"I declare it carried.",
	"To which particular boosing shed...?",
	"My casting vote is: Mooney’s!",
	"He led the way, admonishing: We will sternly refuse to partake of strong waters, will we not?",
	"Yes, we will not.",
	"By no manner of means.",
	"Mr O’Madden Burke, following close, said with an ally’s lunge of his umbrella: Lay on, Macduff!",
	"Chip of the old block!",
	"the editor cried, clapping Stephen on the shoulder.",
	"Let us go.",
	"Where are those blasted keys?",
	"He fumbled in his pocket pulling out the crushed typesheets.",
	"Foot and mouth.",
	"I know.",
	"That’ll be all right.",
	"That’ll go in.",
	"Where are they?",
	"That’s all right.",
	"He thrust the sheets back and went into the inner office.",
	"Myles, one moment.",
	"He went into the inner office, closing the door behind him.",
	"Come along, Stephen, the professor said.",
	"That is fine, isn’t it?",
	"It has the prophetic vision.",
	"Fuit Ilium!",
	"The sack of windy Troy.",
	"Kingdoms of this world.",
	"The masters of the Mediterranean are fellaheen today.",
	"Dublin.",
	"I have much, much to learn.",
	"They turned to the left along Abbey street.",
	"I have a vision too, Stephen said.",
	"Yes?",
	"the professor said, skipping to get into step.",
	"Crawford will follow.",
	"Another newsboy shot past them, yelling as he ran: Racing special!",
	"DEAR DIRTY DUBLIN Dubliners.",
	"Two Dublin vestals, Stephen said, elderly and pious, have lived fifty and fiftythree years in Fumbally’s lane.",
	"Where is that?",
	"the professor asked.",
	"Off Blackpitts, Stephen said.",
	"Damp night reeking of hungry dough.",
	"Against the wall.",
	"Face glistering tallow under her fustian shawl.",
	"Frantic hearts.",
	"Akasic records.",
	"Quicker, darlint!",
	"On now.",
	"Dare it.",
	"Let there be life.",
	"They want to see the views of Dublin from the top of Nelson’s pillar.",
	"They save up three and tenpence in a red tin letterbox moneybox.",
	"They shake out the threepenny bits and sixpences and coax out the pennies with the blade of a knife.",
	"Two and three in silver and one and seven in coppers.",
	"Wise virgins, professor MacHugh said.",
	"Glory be to God.",
	"They had no idea it was that high.",
	"Their names are Anne Kearns and Florence MacCabe.",
	"Florence MacCabe takes a crubeen and a bottle of double X for supper every Saturday.",
	"Antithesis, the professor said nodding twice.",
	"Vestal virgins.",
	"I can see them.",
	"What’s keeping our friend?",
	"He turned.",
	"A bevy of scampering newsboys rushed down the steps, scattering in all directions, yelling, their white papers fluttering.",
	"Come along, the professor cried, waving his arm.",
	"He set off again to walk by Stephen’s side.",
	"RETURN OF BLOOM —Yes, he said.",
	"I see them.",
	"A moment!",
	"Telegraph!",
	"Racing special!",
	"What is it?",
	"Myles Crawford said, falling back a pace.",
	"A newsboy cried in Mr Bloom’s face: Terrible tragedy in Rathmines!",
	"A child bit by a bellows!",
	"I spoke with Mr Keyes just now.",
	"He’ll give a renewal for two months, he says.",
	"After he’ll see.",
	"But he wants a par to call attention in the Telegraph too, the Saturday pink.",
	"And he wants it copied if it’s not too late I told councillor Nannetti from the Kilkenny People.",
	"I can have access to it in the national library.",
	"House of keys, don’t you see?",
	"His name is Keyes.",
	"It’s a play on the name.",
	"But he practically promised he’d give the renewal.",
	"But he wants just a little puff.",
	"What will I tell him, Mr Crawford?",
	"K.M.A.",
	"Will you tell him he can kiss my arse?",
	"Myles Crawford said throwing out his arm for emphasis.",
	"Tell him that straight from the stable.",
	"A bit nervy.",
	"Look out for squalls.",
	"All off for a drink.",
	"Arm in arm.",
	"Lenehan’s yachting cap on the cadge beyond.",
	"Usual blarney.",
	"Wonder is that young Dedalus the moving spirit.",
	"Has a good pair of boots on him today.",
	"Last time I saw him he had his heels on view.",
	"Been walking in muck somewhere.",
	"Careless chap.",
	"What was he doing in Irishtown?",
	"He’d give the ad, I think.",
	"I’ll tell him... K.M.R.I.A.",
	"He can kiss my royal Irish arse, Myles Crawford cried loudly over his shoulder.",
	"Any time he likes, tell him.",
	"While Mr Bloom stood weighing the point and about to smile he strode on jerkily.",
	"RAISING THE WIND —Nulla bona, Jack, he said, raising his hand to his chin.",
	"I’m up to here.",
	"I’ve been through the hoop myself.",
	"I was looking for a fellow to back a bill for me no later than last week.",
	"Sorry, Jack.",
	"You must take the will for the deed.",
	"With a heart and a half if I could raise the wind anyhow.",
	"J. J. O’Molloy pulled a long face and walked on silently.",
	"They caught up on the others and walked abreast.",
	"Something for you, the professor explained to Myles Crawford.",
	"Two old Dublin women on the top of Nelson’s pillar.",
	"SOME COLUMN!—THAT’S WHAT WADDLER ONE SAID —That’s new, Myles Crawford said.",
	"That’s copy.",
	"Out for the waxies’ Dargle.",
	"Two old trickies, what?",
	"But they are afraid the pillar will fall, Stephen went on.",
	"No poetic licence.",
	"We’re in the archdiocese here.",
	"And settle down on their striped petticoats, peering up at the statue of the onehandled adulterer.",
	"Onehandled adulterer!",
	"the professor cried.",
	"I like that.",
	"I see the idea.",
	"I see what you mean.",
	"He gave a sudden loud young laugh as a close.",
	"Lenehan and Mr O’Madden Burke, hearing, turned, beckoned and led on across towards Mooney’s.",
	"Finished?",
	"Myles Crawford said.",
	"So long as they do no worse.",
	"SOPHIST WALLOPS HAUGHTY HELEN SQUARE ON PROBOSCIS.",
	"SPARTANS GNASH MOLARS.",
	"ITHACANS VOW PEN IS CHAMP.",
	"You remind me of Antisthenes, the professor said, a disciple of Gorgias, the sophist.",
	"It is said of him that none could tell if he were bitterer against others or against himself.",
	"He was the son of a noble and a bondwoman.",
	"Poor Penelope.",
	"Penelope Rich.",
	"They made ready to cross O’Connell street.",
	"HELLO THERE, CENTRAL!",
	"WHAT?—AND LIKEWISE—WHERE?",
	"But what do you call it?",
	"Myles Crawford asked.",
	"Where did they get the plums?",
	"VIRGILIAN, SAYS PEDAGOGUE.",
	"SOPHOMORE PLUMPS FOR OLD MAN MOSES.",
	"Call it, wait, the professor said, opening his long lips wide to reflect.",
	"Call it, let me see.",
	"Call it: deus nobis hæc otia fecit.",
	"No, Stephen said.",
	"I call it A Pisgah Sight of Palestine or The Parable of The Plums.",
	"I see, the professor said.",
	"He laughed richly.",
	"I see, he said again with new pleasure.",
	"Moses and the promised land.",
	"We gave him that idea, he added to J. J. O’Molloy.",
	"I see, the professor said.",
	"DIMINISHED DIGITS PROVE TOO TITILLATING FOR FRISKY FRUMPS.",
	"ANNE WIMBLES, FLO WANGLES—YET CAN YOU BLAME THEM?",
	"Onehandled adulterer, he said smiling grimly.",
	"That tickles me, I must say.",
	"Tickled the old ones too, Myles Crawford said, if the God Almighty’s truth was known.",
	"[ 8 ] Pineapple rock, lemon platt, butter scotch.",
	"A sugarsticky girl shovelling scoopfuls of creams for a christian brother.",
	"Some school treat.",
	"Bad for their tummies.",
	"Lozenge and comfit manufacturer to His Majesty the King.",
	"God.",
	"Save.",
	"Our.",
	"Sitting on his throne sucking red jujubes white.",
	"A sombre Y.M.C.A.",
	"Heart to heart talks.",
	"Bloo... Me?",
	"No.",
	"Blood of the Lamb.",
	"His slow feet walked him riverward, reading.",
	"Are you saved?",
	"All are washed in the blood of the lamb.",
	"God wants blood victim.",
	"Birth, hymen, martyr, war, foundation of a building, sacrifice, kidney burntoffering, druids’ altars.",
	"Elijah is coming.",
	"Dr John Alexander Dowie restorer of the church in Zion is coming.",
	"Is coming!",
	"Is coming!!",
	"Is coming!!!",
	"All heartily welcome.",
	"Paying game.",
	"Torry and Alexander last year.",
	"Polygamy.",
	"His wife will put the stopper on that.",
	"Where was that ad some Birmingham firm the luminous crucifix.",
	"Our Saviour.",
	"Wake up in the dead of night and see him on the wall, hanging.",
	"Pepper’s ghost idea.",
	"Iron Nails Ran In.",
	"Phosphorus it must be done with.",
	"If you leave a bit of codfish for instance.",
	"I could see the bluey silver over it.",
	"Night I went down to the pantry in the kitchen.",
	"Don’t like all the smells in it waiting to rush out.",
	"What was it she wanted?",
	"The Malaga raisins.",
	"Thinking of Spain.",
	"Before Rudy was born.",
	"The phosphorescence, that bluey greeny.",
	"Very good for the brain.",
	"From Butler’s monument house corner he glanced along Bachelor’s walk.",
	"Dedalus’ daughter there still outside Dillon’s auctionrooms.",
	"Must be selling off some old furniture.",
	"Knew her eyes at once from the father.",
	"Lobbing about waiting for him.",
	"Home always breaks up when the mother goes.",
	"Fifteen children he had.",
	"Birth every year almost.",
	"That’s in their theology or the priest won’t give the poor woman the confession, the absolution.",
	"Increase and multiply.",
	"Did you ever hear such an idea?",
	"Eat you out of house and home.",
	"No families themselves to feed.",
	"Living on the fat of the land.",
	"Their butteries and larders.",
	"I’d like to see them do the black fast Yom Kippur.",
	"Crossbuns.",
	"One meal and a collation for fear he’d collapse on the altar.",
	"A housekeeper of one of those fellows if you could pick it out of her.",
	"Never pick it out of her.",
	"Like getting £.",
	"s. d. out of him.",
	"Does himself well.",
	"No guests.",
	"All for number one.",
	"Watching his water.",
	"Bring your own bread and butter.",
	"His reverence: mum’s the word.",
	"Good Lord, that poor child’s dress is in flitters.",
	"Underfed she looks too.",
	"Potatoes and marge, marge and potatoes.",
	"It’s after they feel it.",
	"Proof of the pudding.",
	"Undermines the constitution.",
	"As he set foot on O’Connell bridge a puffball of smoke plumed up from the parapet.",
	"Brewery barge with export stout.",
	"England.",
	"Sea air sours it, I heard.",
	"Be interesting some day get a pass through Hancock to see the brewery.",
	"Regular world in itself.",
	"Vats of porter wonderful.",
	"Rats get in too.",
	"Drink themselves bloated as big as a collie floating.",
	"Dead drunk on the porter.",
	"Drink till they puke again like christians.",
	"Imagine drinking that!",
	"Rats: vats.",
	"Well, of course, if we knew all the things.",
	"Looking down he saw flapping strongly, wheeling between the gaunt quaywalls, gulls.",
	"Rough weather outside.",
	"If I threw myself down?",
	"Reuben J’s son must have swallowed a good bellyful of that sewage.",
	"One and eightpence too much.",
	"Hhhhm.",
	"It’s the droll way he comes out with the things.",
	"Knows how to tell a story too.",
	"They wheeled lower.",
	"Looking for grub.",
	"Wait.",
	"He threw down among them a crumpled paper ball.",
	"Elijah thirtytwo feet per sec is com.",
	"Not a bit.",
	"The ball bobbed unheeded on the wake of swells, floated under by the bridgepiers.",
	"Not such damn fools.",
	"Live by their wits.",
	"They wheeled, flapping.",
	"The hungry famished gull Flaps o’er the waters dull.",
	"That is how poets write, the similar sounds.",
	"But then Shakespeare has no rhymes: blank verse.",
	"The flow of the language it is.",
	"The thoughts.",
	"Solemn.",
	"Hamlet, I am thy father’s spirit Doomed for a certain time to walk the earth.",
	"Two apples a penny!",
	"Two for a penny!",
	"His gaze passed over the glazed apples serried on her stand.",
	"Australians they must be this time of year.",
	"Shiny peels: polishes them up with a rag or a handkerchief.",
	"Wait.",
	"Those poor birds.",
	"See that?",
	"The gulls swooped silently, two, then all from their heights, pouncing on prey.",
	"Gone.",
	"Every morsel.",
	"Aware of their greed and cunning he shook the powdery crumb from his hands.",
	"They never expected that.",
	"Manna.",
	"Live on fish, fishy flesh they have, all seabirds, gulls, seagoose.",
	"Swans from Anna Liffey swim down here sometimes to preen themselves.",
	"No accounting for tastes.",
	"Wonder what kind is swanmeat.",
	"Robinson Crusoe had to live on them.",
	"They wheeled flapping weakly.",
	"I’m not going to throw any more.",
	"Penny quite enough.",
	"Lot of thanks I get.",
	"Not even a caw.",
	"They spread foot and mouth disease too.",
	"If you cram a turkey say on chestnutmeal it tastes like that.",
	"Eat pig like pig.",
	"But then why is it that saltwater fish are not salty?",
	"How is that?",
	"Kino’s 11/- Trousers Good idea that.",
	"Wonder if he pays rent to the corporation.",
	"How can you own water really?",
	"It’s always flowing in a stream, never the same, which in the stream of life we trace.",
	"Because life is a stream.",
	"All kinds of places are good for ads.",
	"That quack doctor for the clap used to be stuck up in all the greenhouses.",
	"Never see it now.",
	"Strictly confidential.",
	"Dr Hy Franks.",
	"Didn’t cost him a red like Maginni the dancing master self advertisement.",
	"Flybynight.",
	"Just the place too.",
	"POST NO BILLS.",
	"POST 110 PILLS.",
	"Some chap with a dose burning him.",
	"If he...?",
	"O!",
	"Eh?",
	"No... No.",
	"No, no.",
	"I don’t believe it.",
	"He wouldn’t surely?",
	"No, no.",
	"Mr Bloom moved forward, raising his troubled eyes.",
	"Think no more about that.",
	"After one.",
	"Timeball on the ballastoffice is down.",
	"Dunsink time.",
	"Fascinating little book that is of sir Robert Ball’s.",
	"Parallax.",
	"I never exactly understood.",
	"There’s a priest.",
	"Could ask him.",
	"Par it’s Greek: parallel, parallax.",
	"Met him pike hoses she called it till I told her about the transmigration.",
	"O rocks!",
	"Mr Bloom smiled O rocks at two windows of the ballastoffice.",
	"She’s right after all.",
	"Only big words for ordinary things on account of the sound.",
	"She’s not exactly witty.",
	"Can be rude too.",
	"Blurt out what I was thinking.",
	"Still, I don’t know.",
	"She used to say Ben Dollard had a base barreltone voice.",
	"He has legs like barrels and you’d think he was singing into a barrel.",
	"Now, isn’t that wit.",
	"They used to call him big Ben.",
	"Not half as witty as calling him base barreltone.",
	"Appetite like an albatross.",
	"Get outside of a baron of beef.",
	"Powerful man he was at stowing away number one Bass.",
	"Barrel of Bass.",
	"See?",
	"It all works out.",
	"A procession of whitesmocked sandwichmen marched slowly towards him along the gutter, scarlet sashes across their boards.",
	"Bargains.",
	"Like that priest they are this morning: we have sinned: we have suffered.",
	"He read the scarlet letters on their five tall white hats: H. E. L. Y. S. Wisdom Hely’s.",
	"Our staple food.",
	"Three bob a day, walking along the gutters, street after street.",
	"Just keep skin and bone together, bread and skilly.",
	"They are not Boyl: no, M’Glade’s men.",
	"Doesn’t bring in any business either.",
	"I suggested to him about a transparent showcart with two smart girls sitting inside writing letters, copybooks, envelopes, blottingpaper.",
	"I bet that would have caught on.",
	"Smart girls writing something catch the eye at once.",
	"Everyone dying to know what she’s writing.",
	"Get twenty of them round you if you stare at nothing.",
	"Have a finger in the pie.",
	"Women too.",
	"Curiosity.",
	"Pillar of salt.",
	"Wouldn’t have it of course because he didn’t think of it himself first.",
	"Or the inkbottle I suggested with a false stain of black celluloid.",
	"His ideas for ads like Plumtree’s potted under the obituaries, cold meat department.",
	"You can’t lick ‘em.",
	"What?",
	"Our envelopes.",
	"Hello, Jones, where are you going?",
	"Well out of that ruck I am.",
	"Devil of a job it was collecting accounts of those convents.",
	"Tranquilla convent.",
	"That was a nice nun there, really sweet face.",
	"Wimple suited her small head.",
	"Sister?",
	"Sister?",
	"I am sure she was crossed in love by her eyes.",
	"Very hard to bargain with that sort of a woman.",
	"I disturbed her at her devotions that morning.",
	"But glad to communicate with the outside world.",
	"Our great day, she said.",
	"Feast of Our Lady of Mount Carmel.",
	"Sweet name too: caramel.",
	"She knew I, I think she knew by the way she.",
	"If she had married she would have changed.",
	"I suppose they really were short of money.",
	"Fried everything in the best butter all the same.",
	"No lard for them.",
	"My heart’s broke eating dripping.",
	"They like buttering themselves in and out.",
	"Molly tasting it, her veil up.",
	"Sister?",
	"Pat Claffey, the pawnbroker’s daughter.",
	"It was a nun they say invented barbed wire.",
	"He crossed Westmoreland street when apostrophe S had plodded by.",
	"Rover cycleshop.",
	"Those races are on today.",
	"How long ago is that?",
	"Year Phil Gilligan died.",
	"We were in Lombard street west.",
	"Wait: was in Thom’s.",
	"Got the job in Wisdom Hely’s year we married.",
	"Six years.",
	"Ten years ago: ninetyfour he died yes that’s right the big fire at Arnott’s.",
	"Val Dillon was lord mayor.",
	"The Glencree dinner.",
	"Alderman Robert O’Reilly emptying the port into his soup before the flag fell.",
	"Bobbob lapping it for the inner alderman.",
	"Couldn’t hear what the band played.",
	"For what we have already received may the Lord make us.",
	"Milly was a kiddy then.",
	"Molly had that elephantgrey dress with the braided frogs.",
	"Mantailored with selfcovered buttons.",
	"She didn’t like it because I sprained my ankle first day she wore choir picnic at the Sugarloaf.",
	"As if that.",
	"Old Goodwin’s tall hat done up with some sticky stuff.",
	"Flies’ picnic too.",
	"Never put a dress on her back like it.",
	"Fitted her like a glove, shoulders and hips.",
	"Just beginning to plump it out well.",
	"Rabbitpie we had that day.",
	"People looking after her.",
	"Happy.",
	"Happier then.",
	"Snug little room that was with the red wallpaper.",
	"Dockrell’s, one and ninepence a dozen.",
	"Milly’s tubbing night.",
	"American soap I bought: elderflower.",
	"Cosy smell of her bathwater.",
	"Funny she looked soaped all over.",
	"Shapely too.",
	"Now photography.",
	"Poor papa’s daguerreotype atelier he told me of.",
	"Hereditary taste.",
	"He walked along the curbstone.",
	"Stream of life.",
	"What was the name of that priestylooking chap was always squinting in when he passed?",
	"Weak eyes, woman.",
	"Stopped in Citron’s saint Kevin’s parade.",
	"Pen something.",
	"Pendennis?",
	"My memory is getting.",
	"Pen ...?",
	"Of course it’s years ago.",
	"Noise of the trams probably.",
	"Well, if he couldn’t remember the dayfather’s name that he sees every day.",
	"Bartell d’Arcy was the tenor, just coming out then.",
	"Seeing her home after practice.",
	"Conceited fellow with his waxedup moustache.",
	"Gave her that song Winds that blow from the south.",
	"He and I behind.",
	"Sheet of her music blew out of my hand against the High school railings.",
	"Lucky it didn’t.",
	"Thing like that spoils the effect of a night for her.",
	"Professor Goodwin linking her in front.",
	"Shaky on his pins, poor old sot.",
	"His farewell concerts.",
	"Positively last appearance on any stage.",
	"May be for months and may be for never.",
	"Remember her laughing at the wind, her blizzard collar up.",
	"Corner of Harcourt road remember that gust.",
	"Brrfoo!",
	"Blew up all her skirts and her boa nearly smothered old Goodwin.",
	"She did get flushed in the wind.",
	"And the mulled rum.",
	"Could see her in the bedroom from the hearth unclamping the busk of her stays: white.",
	"Swish and soft flop her stays made on the bed.",
	"Always warm from her.",
	"Always liked to let her self out.",
	"Sitting there after till near two taking out her hairpins.",
	"Milly tucked up in beddyhouse.",
	"Happy.",
	"Happy.",
	"That was the night... —O, Mr Bloom, how do you do?",
	"O, how do you do, Mrs Breen?",
	"No use complaining.",
	"How is Molly those times?",
	"Haven’t seen her for ages.",
	"In the pink, Mr Bloom said gaily.",
	"Milly has a position down in Mullingar, you know.",
	"Go away!",
	"Isn’t that grand for her?",
	"Yes.",
	"In a photographer’s there.",
	"Getting on like a house on fire.",
	"How are all your charges?",
	"All on the baker’s list, Mrs Breen said.",
	"How many has she?",
	"No other in sight.",
	"You’re in black, I see.",
	"You have no... —No, Mr Bloom said.",
	"I have just come from a funeral.",
	"Going to crop up all day, I foresee.",
	"Who’s dead, when and what did he die of?",
	"Turn up like a bad penny.",
	"O, dear me, Mrs Breen said.",
	"I hope it wasn’t any near relation.",
	"May as well get her sympathy.",
	"Dignam, Mr Bloom said.",
	"An old friend of mine.",
	"He died quite suddenly, poor fellow.",
	"Heart trouble, I believe.",
	"Funeral was this morning.",
	"Your funeral’s tomorrow While you’re coming through the rye.",
	"Diddlediddle dumdum Diddlediddle... —Sad to lose the old friends, Mrs Breen’s womaneyes said melancholily.",
	"Now that’s quite enough about that.",
	"Just: quietly: husband.",
	"And your lord and master?",
	"Mrs Breen turned up her two large eyes.",
	"Hasn’t lost them anyhow.",
	"O, don’t be talking!",
	"she said.",
	"He’s a caution to rattlesnakes.",
	"He’s in there now with his lawbooks finding out the law of libel.",
	"He has me heartscalded.",
	"Wait till I show you.",
	"Hot mockturtle vapour and steam of newbaked jampuffs rolypoly poured out from Harrison’s.",
	"The heavy noonreek tickled the top of Mr Bloom’s gullet.",
	"Want to make good pastry, butter, best flour, Demerara sugar, or they’d taste it with the hot tea.",
	"Or is it from her?",
	"A barefoot arab stood over the grating, breathing in the fumes.",
	"Deaden the gnaw of hunger that way.",
	"Pleasure or pain is it?",
	"Penny dinner.",
	"Knife and fork chained to the table.",
	"Opening her handbag, chipped leather.",
	"Hatpin: ought to have a guard on those things.",
	"Stick it in a chap’s eye in the tram.",
	"Rummaging.",
	"Open.",
	"Money.",
	"Please take one.",
	"Devils if they lose sixpence.",
	"Raise Cain.",
	"Husband barging.",
	"Where’s the ten shillings I gave you on Monday?",
	"Are you feeding your little brother’s family?",
	"Soiled handkerchief: medicinebottle.",
	"Pastille that was fell.",
	"What is she?...",
	"There must be a new moon out, she said.",
	"He’s always bad then.",
	"Do you know what he did last night?",
	"Her hand ceased to rummage.",
	"Her eyes fixed themselves on him, wide in alarm, yet smiling.",
	"What?",
	"Mr Bloom asked.",
	"Let her speak.",
	"Look straight in her eyes.",
	"I believe you.",
	"Trust me.",
	"Woke me up in the night, she said.",
	"Dream he had, a nightmare.",
	"Indiges.",
	"Said the ace of spades was walking up the stairs.",
	"The ace of spades!",
	"Mr Bloom said.",
	"She took a folded postcard from her handbag.",
	"Read that, she said.",
	"He got it this morning.",
	"What is it?",
	"Mr Bloom asked, taking the card.",
	"U.P.?",
	"U.P.",
	": up, she said.",
	"Someone taking a rise out of him.",
	"It’s a great shame for them whoever he is.",
	"Indeed it is, Mr Bloom said.",
	"She took back the card, sighing.",
	"And now he’s going round to Mr Menton’s office.",
	"He’s going to take an action for ten thousand pounds, he says.",
	"She folded the card into her untidy bag and snapped the catch.",
	"Same blue serge dress she had two years ago, the nap bleaching.",
	"Seen its best days.",
	"Wispish hair over her ears.",
	"And that dowdy toque: three old grapes to take the harm out of it.",
	"Shabby genteel.",
	"She used to be a tasty dresser.",
	"Lines round her mouth.",
	"Only a year or so older than Molly.",
	"See the eye that woman gave her, passing.",
	"Cruel.",
	"The unfair sex.",
	"He looked still at her, holding back behind his look his discontent.",
	"Pungent mockturtle oxtail mulligatawny.",
	"I’m hungry too.",
	"Flakes of pastry on the gusset of her dress: daub of sugary flour stuck to her cheek.",
	"Rhubarb tart with liberal fillings, rich fruit interior.",
	"Josie Powell that was.",
	"In Luke Doyle’s long ago.",
	"Dolphin’s Barn, the charades.",
	"U.P.",
	": up.",
	"Change the subject.",
	"Do you ever see anything of Mrs Beaufoy?",
	"Mr Bloom asked.",
	"Mina Purefoy?",
	"she said.",
	"Philip Beaufoy I was thinking.",
	"Playgoers’ Club.",
	"Matcham often thinks of the masterstroke.",
	"Did I pull the chain?",
	"Yes.",
	"The last act.",
	"Yes.",
	"I just called to ask on the way in is she over it.",
	"She’s in the lying-in hospital in Holles street.",
	"Dr Horne got her in.",
	"She’s three days bad now.",
	"O, Mr Bloom said.",
	"I’m sorry to hear that.",
	"Yes, Mrs Breen said.",
	"And a houseful of kids at home.",
	"It’s a very stiff birth, the nurse told me.",
	"O, Mr Bloom said.",
	"His heavy pitying gaze absorbed her news.",
	"His tongue clacked in compassion.",
	"Dth!",
	"Dth!",
	"I’m sorry to hear that, he said.",
	"Poor thing!",
	"Three days!",
	"That’s terrible for her.",
	"Mrs Breen nodded.",
	"She was taken bad on the Tuesday... Mr Bloom touched her funnybone gently, warning her: Mind!",
	"Let this man pass.",
	"Tight as a skullpiece a tiny hat gripped his head.",
	"From his arm a folded dustcoat, a stick and an umbrella dangled to his stride.",
	"Watch him, Mr Bloom said.",
	"He always walks outside the lampposts.",
	"Watch!",
	"Who is he if it’s a fair question?",
	"Mrs Breen asked.",
	"Is he dotty?",
	"His name is Cashel Boyle O’Connor Fitzmaurice Tisdall Farrell, Mr Bloom said smiling.",
	"Watch!",
	"He has enough of them, she said.",
	"Denis will be like that one of these days.",
	"She broke off suddenly.",
	"There he is, she said.",
	"I must go after him.",
	"Goodbye.",
	"Remember me to Molly, won’t you?",
	"I will, Mr Bloom said.",
	"He watched her dodge through passers towards the shopfronts.",
	"Blown in from the bay.",
	"Like old times.",
	"Meshuggah.",
	"Off his chump.",
	"Mr Bloom walked on again easily, seeing ahead of him in sunlight the tight skullpiece, the dangling stickumbrelladustcoat.",
	"Going the two days.",
	"Watch him!",
	"Out he goes again.",
	"One way of getting on in the world.",
	"And that other old mosey lunatic in those duds.",
	"Hard time she must have with him.",
	"U.P.",
	": up.",
	"I’ll take my oath that’s Alf Bergan or Richie Goulding.",
	"Wrote it for a lark in the Scotch house I bet anything.",
	"Round to Menton’s office.",
	"His oyster eyes staring at the postcard.",
	"Be a feast for the gods.",
	"He passed the Irish Times.",
	"There might be other answers Iying there.",
	"Like to answer them all.",
	"Good system for criminals.",
	"Code.",
	"At their lunch now.",
	"Clerk with the glasses there doesn’t know me.",
	"O, leave them there to simmer.",
	"Enough bother wading through fortyfour of them.",
	"Wanted, smart lady typist to aid gentleman in literary work.",
	"I called you naughty darling because I do not like that other world.",
	"Please tell me what is the meaning.",
	"Please tell me what perfume does your wife.",
	"Tell me who made the world.",
	"The way they spring those questions on you.",
	"And the other one Lizzie Twigg.",
	"Russell).",
	"No time to do her hair drinking sloppy tea with a book of poetry.",
	"Best paper by long chalks for a small ad.",
	"Got the provinces now.",
	"Cook and general, exc.",
	"cuisine, housemaid kept.",
	"Wanted live man for spirit counter.",
	"Resp.",
	"girl (R.C.)",
	"wishes to hear of post in fruit or pork shop.",
	"James Carlisle made that.",
	"Six and a half per cent dividend.",
	"Made a big deal on Coates’s shares.",
	"Ca’ canny.",
	"Cunning old Scotch hunks.",
	"All the toady news.",
	"Our gracious and popular vicereine.",
	"Bought the Irish Field now.",
	"Uneatable fox.",
	"Pothunters too.",
	"Fear injects juices make it tender enough for them.",
	"Riding astride.",
	"Sit her horse like a man.",
	"Weightcarrying huntress.",
	"No sidesaddle or pillion for her, not for Joe.",
	"First to the meet and in at the death.",
	"Strong as a brood mare some of those horsey women.",
	"Swagger around livery stables.",
	"Toss off a glass of brandy neat while you’d say knife.",
	"That one at the Grosvenor this morning.",
	"Up with her on the car: wishswish.",
	"Stonewall or fivebarred gate put her mount to it.",
	"Think that pugnosed driver did it out of spite.",
	"Who is this she was like?",
	"O yes!",
	"Mrs Miriam Dandrade that sold me her old wraps and black underclothes in the Shelbourne hotel.",
	"Divorced Spanish American.",
	"Didn’t take a feather out of her my handling them.",
	"As if I was her clotheshorse.",
	"Saw her in the viceregal party when Stubbs the park ranger got me in with Whelan of the Express.",
	"Scavenging what the quality left.",
	"High tea.",
	"Mayonnaise I poured on the plums thinking it was custard.",
	"Her ears ought to have tingled for a few weeks after.",
	"Want to be a bull for her.",
	"Born courtesan.",
	"No nursery work for her, thanks.",
	"Poor Mrs Purefoy!",
	"Methodist husband.",
	"Method in his madness.",
	"Saffron bun and milk and soda lunch in the educational dairy.",
	"Y. M. C. A.",
	"Eating with a stopwatch, thirtytwo chews to the minute.",
	"And still his muttonchop whiskers grew.",
	"Supposed to be well connected.",
	"Theodore’s cousin in Dublin Castle.",
	"One tony relative in every family.",
	"Hardy annuals he presents her with.",
	"The squallers.",
	"Poor thing!",
	"Then having to give the breast year after year all hours of the night.",
	"Selfish those t.t’s are.",
	"Dog in the manger.",
	"Only one lump of sugar in my tea, if you please.",
	"He stood at Fleet street crossing.",
	"Luncheon interval.",
	"A sixpenny at Rowe’s?",
	"Must look up that ad in the national library.",
	"An eightpenny in the Burton.",
	"Better.",
	"On my way.",
	"He walked on past Bolton’s Westmoreland house.",
	"Tea.",
	"Tea.",
	"Tea.",
	"I forgot to tap Tom Kernan.",
	"Sss.",
	"Dth, dth, dth!",
	"Three days imagine groaning on a bed with a vinegared handkerchief round her forehead, her belly swollen out.",
	"Phew!",
	"Dreadful simply!",
	"Child’s head too big: forceps.",
	"Doubled up inside her trying to butt its way out blindly, groping for the way out.",
	"Kill me that would.",
	"Lucky Molly got over hers lightly.",
	"They ought to invent something to stop that.",
	"Life with hard labour.",
	"Twilight sleep idea: queen Victoria was given that.",
	"Nine she had.",
	"A good layer.",
	"Old woman that lived in a shoe she had so many children.",
	"Suppose he was consumptive.",
	"Flapdoodle to feed fools on.",
	"Not stillborn of course.",
	"They are not even registered.",
	"Trouble for nothing.",
	"Funny sight two of them together, their bellies out.",
	"Molly and Mrs Moisel.",
	"Mothers’ meeting.",
	"Phthisis retires for the time being, then returns.",
	"How flat they look all of a sudden after.",
	"Peaceful eyes.",
	"Weight off their mind.",
	"Old Mrs Thornton was a jolly old soul.",
	"All my babies, she said.",
	"The spoon of pap in her mouth before she fed them.",
	"O, that’s nyumnyum.",
	"Got her hand crushed by old Tom Wall’s son.",
	"His first bow to the public.",
	"Head like a prize pumpkin.",
	"Snuffy Dr Murren.",
	"People knocking them up at all hours.",
	"For God’ sake, doctor.",
	"Wife in her throes.",
	"Then keep them waiting months for their fee.",
	"To attendance on your wife.",
	"No gratitude in people.",
	"Humane doctors, most of them.",
	"Before the huge high door of the Irish house of parliament a flock of pigeons flew.",
	"Their little frolic after meals.",
	"Who will we do it on?",
	"I pick the fellow in black.",
	"Here goes.",
	"Here’s good luck.",
	"Must be thrilling from the air.",
	"Apjohn, myself and Owen Goldberg up in the trees near Goose green playing the monkeys.",
	"Mackerel they called me.",
	"A squad of constables debouched from College street, marching in Indian file.",
	"Goosestep.",
	"Foodheated faces, sweating helmets, patting their truncheons.",
	"After their feed with a good load of fat soup under their belts.",
	"Policeman’s lot is oft a happy one.",
	"They split up in groups and scattered, saluting, towards their beats.",
	"Let out to graze.",
	"Best moment to attack one in pudding time.",
	"A punch in his dinner.",
	"A squad of others, marching irregularly, rounded Trinity railings making for the station.",
	"Bound for their troughs.",
	"Prepare to receive cavalry.",
	"Prepare to receive soup.",
	"He crossed under Tommy Moore’s roguish finger.",
	"They did right to put him up over a urinal: meeting of the waters.",
	"Ought to be places for women.",
	"Running into cakeshops.",
	"Settle my hat straight.",
	"There is not in this wide world a vallee.",
	"Great song of Julia Morkan’s.",
	"Kept her voice up to the very last.",
	"Pupil of Michael Balfe’s, wasn’t she?",
	"He gazed after the last broad tunic.",
	"Nasty customers to tackle.",
	"Jack Power could a tale unfold: father a G man.",
	"If a fellow gave them trouble being lagged they let him have it hot and heavy in the bridewell.",
	"Can’t blame them after all with the job they have especially the young hornies.",
	"That horsepoliceman the day Joe Chamberlain was given his degree in Trinity he got a run for his money.",
	"My word he did!",
	"His horse’s hoofs clattering after us down Abbey street.",
	"Lucky I had the presence of mind to dive into Manning’s or I was souped.",
	"He did come a wallop, by George.",
	"Must have cracked his skull on the cobblestones.",
	"I oughtn’t to have got myself swept along with those medicals.",
	"And the Trinity jibs in their mortarboards.",
	"Looking for trouble.",
	"Wheels within wheels.",
	"Police whistle in my ears still.",
	"All skedaddled.",
	"Why he fixed on me.",
	"Give me in charge.",
	"Right here it began.",
	"Up the Boers!",
	"Three cheers for De Wet!",
	"We’ll hang Joe Chamberlain on a sourapple tree.",
	"Silly billies: mob of young cubs yelling their guts out.",
	"Vinegar hill.",
	"The Butter exchange band.",
	"Few years’ time half of them magistrates and civil servants.",
	"War comes on: into the army helterskelter: same fellows used to.",
	"Whether on the scaffold high.",
	"Never know who you’re talking to.",
	"Corny Kelleher he has Harvey Duff in his eye.",
	"Like that Peter or Denis or James Carey that blew the gaff on the invincibles.",
	"Member of the corporation too.",
	"Egging raw youths on to get in the know all the time drawing secret service pay from the castle.",
	"Drop him like a hot potato.",
	"Why those plainclothes men are always courting slaveys.",
	"Easily twig a man used to uniform.",
	"Squarepushing up against a backdoor.",
	"Maul her a bit.",
	"Then the next thing on the menu.",
	"And who is the gentleman does be visiting there?",
	"Was the young master saying anything?",
	"Peeping Tom through the keyhole.",
	"Decoy duck.",
	"Hotblooded young student fooling round her fat arms ironing.",
	"Are those yours, Mary?",
	"I don’t wear such things... Stop or I’ll tell the missus on you.",
	"Out half the night.",
	"There are great times coming, Mary.",
	"Wait till you see.",
	"Ah, gelong with your great times coming.",
	"Barmaids too.",
	"Tobaccoshopgirls.",
	"James Stephens’ idea was the best.",
	"He knew them.",
	"Circles of ten so that a fellow couldn’t round on more than his own ring.",
	"Sinn Fein.",
	"Back out you get the knife.",
	"Hidden hand.",
	"Stay in.",
	"The firing squad.",
	"Turnkey’s daughter got him out of Richmond, off from Lusk.",
	"Putting up in the Buckingham Palace hotel under their very noses.",
	"Garibaldi.",
	"You must have a certain fascination: Parnell.",
	"Arthur Griffith is a squareheaded fellow but he has no go in him for the mob.",
	"Or gas about our lovely land.",
	"Gammon and spinach.",
	"Dublin Bakery Company’s tearoom.",
	"Debating societies.",
	"That republicanism is the best form of government.",
	"That the language question should take precedence of the economic question.",
	"Have your daughters inveigling them to your house.",
	"Stuff them up with meat and drink.",
	"Michaelmas goose.",
	"Here’s a good lump of thyme seasoning under the apron for you.",
	"Have another quart of goosegrease before it gets too cold.",
	"Halffed enthusiasts.",
	"Penny roll and a walk with the band.",
	"No grace for the carver.",
	"The thought that the other chap pays best sauce in the world.",
	"Make themselves thoroughly at home.",
	"Show us over those apricots, meaning peaches.",
	"The not far distant day.",
	"Homerule sun rising up in the northwest.",
	"His smile faded as he walked, a heavy cloud hiding the sun slowly, shadowing Trinity’s surly front.",
	"Trams passed one another, ingoing, outgoing, clanging.",
	"Useless words.",
	"Things go on same, day after day: squads of police marching out, back: trams in, out.",
	"Those two loonies mooching about.",
	"Dignam carted off.",
	"Mina Purefoy swollen belly on a bed groaning to have a child tugged out of her.",
	"One born every second somewhere.",
	"Other dying every second.",
	"Since I fed the birds five minutes.",
	"Three hundred kicked the bucket.",
	"Other three hundred born, washing the blood off, all are washed in the blood of the lamb, bawling maaaaaa.",
	"Cityful passing away, other cityful coming, passing away too: other coming on, passing on.",
	"Houses, lines of houses, streets, miles of pavements, piledup bricks, stones.",
	"Changing hands.",
	"This owner, that.",
	"Landlord never dies they say.",
	"Other steps into his shoes when he gets his notice to quit.",
	"They buy the place up with gold and still they have all the gold.",
	"Swindle in it somewhere.",
	"Piled up in cities, worn away age after age.",
	"Pyramids in sand.",
	"Built on bread and onions.",
	"Slaves Chinese wall.",
	"Babylon.",
	"Big stones left.",
	"Round towers.",
	"Rest rubble, sprawling suburbs, jerrybuilt.",
	"Kerwan’s mushroom houses built of breeze.",
	"Shelter, for the night.",
	"No-one is anything.",
	"This is the very worst hour of the day.",
	"Vitality.",
	"Dull, gloomy: hate this hour.",
	"Feel as if I had been eaten and spewed.",
	"Provost’s house.",
	"The reverend Dr Salmon: tinned salmon.",
	"Well tinned in there.",
	"Like a mortuary chapel.",
	"Wouldn’t live in it if they paid me.",
	"Hope they have liver and bacon today.",
	"Nature abhors a vacuum.",
	"There he is: the brother.",
	"Image of him.",
	"Haunting face.",
	"Now that’s a coincidence.",
	"Course hundreds of times you think of a person and don’t meet him.",
	"Like a man walking in his sleep.",
	"No-one knows him.",
	"Must be a corporation meeting today.",
	"They say he never put on the city marshal’s uniform since he got the job.",
	"Charley Kavanagh used to come out on his high horse, cocked hat, puffed, powdered and shaved.",
	"Look at the woebegone walk of him.",
	"Eaten a bad egg.",
	"Poached eyes on ghost.",
	"I have a pain.",
	"Great man’s brother: his brother’s brother.",
	"He’d look nice on the city charger.",
	"Drop into the D.B.C.",
	"probably for his coffee, play chess there.",
	"His brother used men as pawns.",
	"Let them all go to pot.",
	"Afraid to pass a remark on him.",
	"Freeze them up with that eye of his.",
	"That’s the fascination: the name.",
	"All a bit touched.",
	"Mad Fanny and his other sister Mrs Dickinson driving about with scarlet harness.",
	"Bolt upright like surgeon M’Ardle.",
	"Still David Sheehy beat him for south Meath.",
	"Apply for the Chiltern Hundreds and retire into public life.",
	"The patriot’s banquet.",
	"Eating orangepeels in the park.",
	"The tentacles...",
	"They passed from behind Mr Bloom along the curbstone.",
	"Beard and bicycle.",
	"Young woman.",
	"And there he is too.",
	"Now that’s really a coincidence: second time.",
	"Coming events cast their shadows before.",
	"With the approval of the eminent poet, Mr Geo.",
	"Russell.",
	"That might be Lizzie Twigg with him.",
	"A. E.: what does that mean?",
	"Initials perhaps.",
	"Albert Edward, Arthur Edmund, Alphonsus Eb Ed El Esquire.",
	"What was he saying?",
	"The ends of the world with a Scotch accent.",
	"Tentacles: octopus.",
	"Something occult: symbolism.",
	"Holding forth.",
	"She’s taking it all in.",
	"Not saying a word.",
	"To aid gentleman in literary work.",
	"His eyes followed the high figure in homespun, beard and bicycle, a listening woman at his side.",
	"Coming from the vegetarian.",
	"Only weggebobbles and fruit.",
	"Don’t eat a beefsteak.",
	"If you do the eyes of that cow will pursue you through all eternity.",
	"They say it’s healthier.",
	"Windandwatery though.",
	"Tried it.",
	"Keep you on the run all day.",
	"Bad as a bloater.",
	"Dreams all night.",
	"Why do they call that thing they gave me nutsteak?",
	"Nutarians.",
	"Fruitarians.",
	"To give you the idea you are eating rumpsteak.",
	"Absurd.",
	"Salty too.",
	"They cook in soda.",
	"Keep you sitting by the tap all night.",
	"Her stockings are loose over her ankles.",
	"I detest that: so tasteless.",
	"Those literary etherial people they are all.",
	"Dreamy, cloudy, symbolistic.",
	"Esthetes they are.",
	"Don’t know what poetry is even.",
	"Must be in a certain mood.",
	"The dreamy cloudy gull Waves o’er the waters dull.",
	"He crossed at Nassau street corner and stood before the window of Yeates and Son, pricing the fieldglasses.",
	"Or will I drop into old Harris’s and have a chat with young Sinclair?",
	"Wellmannered fellow.",
	"Probably at his lunch.",
	"Must get those old glasses of mine set right.",
	"Goerz lenses six guineas.",
	"Germans making their way everywhere.",
	"Sell on easy terms to capture trade.",
	"Undercutting.",
	"Might chance on a pair in the railway lost property office.",
	"Astonishing the things people leave behind them in trains and cloakrooms.",
	"What do they be thinking about?",
	"Women too.",
	"Incredible.",
	"Unclaimed money too.",
	"There’s a little watch up there on the roof of the bank to test those glasses by.",
	"His lids came down on the lower rims of his irides.",
	"Can’t see it.",
	"If you imagine it’s there you can almost see it.",
	"Can’t see it.",
	"He faced about and, standing between the awnings, held out his right hand at arm’s length towards the sun.",
	"Wanted to try that often.",
	"Yes: completely.",
	"The tip of his little finger blotted out the sun’s disk.",
	"Must be the focus where the rays cross.",
	"If I had black glasses.",
	"Interesting.",
	"There was a lot of talk about those sunspots when we were in Lombard street west.",
	"Looking up from the back garden.",
	"Terrific explosions they are.",
	"There will be a total eclipse this year: autumn some time.",
	"Now that I come to think of it that ball falls at Greenwich time.",
	"It’s the clock is worked by an electric wire from Dunsink.",
	"Must go out there some first Saturday of the month.",
	"If I could get an introduction to professor Joly or learn up something about his family.",
	"That would do to: man always feels complimented.",
	"Flattery where least expected.",
	"Nobleman proud to be descended from some king’s mistress.",
	"His foremother.",
	"Lay it on with a trowel.",
	"Cap in hand goes through the land.",
	"Not go in and blurt out what you know you’re not to: what’s parallax?",
	"Show this gentleman the door.",
	"Ah.",
	"His hand fell to his side again.",
	"Never know anything about it.",
	"Waste of time.",
	"Gasballs spinning about, crossing each other, passing.",
	"Same old dingdong always.",
	"Gas: then solid: then world: then cold: then dead shell drifting around, frozen rock, like that pineapple rock.",
	"The moon.",
	"Must be a new moon out, she said.",
	"I believe there is.",
	"He went on by la maison Claire.",
	"Wait.",
	"The full moon was the night we were Sunday fortnight exactly there is a new moon.",
	"Walking down by the Tolka.",
	"Not bad for a Fairview moon.",
	"She was humming.",
	"The young May moon she’s beaming, love.",
	"He other side of her.",
	"Elbow, arm.",
	"He.",
	"Glowworm’s la-amp is gleaming, love.",
	"Touch.",
	"Fingers.",
	"Asking.",
	"Answer.",
	"Yes.",
	"Stop.",
	"Stop.",
	"If it was it was.",
	"Must.",
	"Mr Bloom, quickbreathing, slowlier walking passed Adam court.",
	"On his annual bend, M’Coy said.",
	"They drink in order to say or do something or cherchez la femme.",
	"Up in the Coombe with chummies and streetwalkers and then the rest of the year sober as a judge.",
	"Yes.",
	"Thought so.",
	"Sloping into the Empire.",
	"Gone.",
	"Plain soda would do him good.",
	"Where Pat Kinsella had his Harp theatre before Whitbred ran the Queen’s.",
	"Broth of a boy.",
	"Dion Boucicault business with his harvestmoon face in a poky bonnet.",
	"Three Purty Maids from School.",
	"How time flies, eh?",
	"Showing long red pantaloons under his skirts.",
	"Drinkers, drinking, laughed spluttering, their drink against their breath.",
	"More power, Pat.",
	"Coarse red: fun for drunkards: guffaw and smoke.",
	"Take off that white hat.",
	"His parboiled eyes.",
	"Where is he now?",
	"Beggar somewhere.",
	"The harp that once did starve us all.",
	"I was happier then.",
	"Or was that I?",
	"Or am I now I?",
	"Twentyeight I was.",
	"She twentythree.",
	"When we left Lombard street west something changed.",
	"Could never like it again after Rudy.",
	"Can’t bring back time.",
	"Like holding water in your hand.",
	"Would you go back to then?",
	"Just beginning then.",
	"Would you?",
	"Are you not happy in your home you poor little naughty boy?",
	"Wants to sew on buttons for me.",
	"I must answer.",
	"Write it in the library.",
	"Grafton street gay with housed awnings lured his senses.",
	"Muslin prints, silkdames and dowagers, jingle of harnesses, hoofthuds lowringing in the baking causeway.",
	"Thick feet that woman has in the white stockings.",
	"Hope the rain mucks them up on her.",
	"Countrybred chawbacon.",
	"All the beef to the heels were in.",
	"Always gives a woman clumsy feet.",
	"Molly looks out of plumb.",
	"He passed, dallying, the windows of Brown Thomas, silk mercers.",
	"Cascades of ribbons.",
	"Flimsy China silks.",
	"A tilted urn poured from its mouth a flood of bloodhued poplin: lustrous blood.",
	"The huguenots brought that here.",
	"La causa è santa!",
	"Tara tara.",
	"Great chorus that.",
	"Taree tara.",
	"Must be washed in rainwater.",
	"Meyerbeer.",
	"Tara: bom bom bom.",
	"Pincushions.",
	"I’m a long time threatening to buy one.",
	"Sticking them all over the place.",
	"Needles in window curtains.",
	"He bared slightly his left forearm.",
	"Scrape: nearly gone.",
	"Not today anyhow.",
	"Must go back for that lotion.",
	"For her birthday perhaps.",
	"Junejulyaugseptember eighth.",
	"Nearly three months off.",
	"Then she mightn’t like it.",
	"Women won’t pick up pins.",
	"Say it cuts lo.",
	"Gleaming silks, petticoats on slim brass rails, rays of flat silk stockings.",
	"Useless to go back.",
	"Had to be.",
	"Tell me all.",
	"High voices.",
	"Sunwarm silk.",
	"Jingling harnesses.",
	"All for a woman, home and houses, silkwebs, silver, rich fruits spicy from Jaffa.",
	"Agendath Netaim.",
	"Wealth of the world.",
	"A warm human plumpness settled down on his brain.",
	"His brain yielded.",
	"Perfume of embraces all him assailed.",
	"With hungered flesh obscurely, he mutely craved to adore.",
	"Duke street.",
	"Here we are.",
	"Must eat.",
	"The Burton.",
	"Feel better then.",
	"He turned Combridge’s corner, still pursued.",
	"Jingling, hoofthuds.",
	"Perfumed bodies, warm, full.",
	"All kissed, yielded: in deep summer fields, tangled pressed grass, in trickling hallways of tenements, along sofas, creaking beds.",
	"Jack, love!",
	"Darling!",
	"Kiss me, Reggy!",
	"My boy!",
	"Love!",
	"His heart astir he pushed in the door of the Burton restaurant.",
	"Stink gripped his trembling breath: pungent meatjuice, slush of greens.",
	"See the animals feed.",
	"Men, men, men.",
	"A pallid suetfaced young man polished his tumbler knife fork and spoon with his napkin.",
	"New set of microbes.",
	"A man with an infant’s saucestained napkin tucked round him shovelled gurgling soup down his gullet.",
	"A man spitting back on his plate: halfmasticated gristle: gums: no teeth to chewchewchew it.",
	"Chump chop from the grill.",
	"Bolting to get it over.",
	"Sad booser’s eyes.",
	"Bitten off more than he can chew.",
	"Am I like that?",
	"See ourselves as others see us.",
	"Hungry man is an angry man.",
	"Working tooth and jaw.",
	"Don’t!",
	"O!",
	"A bone!",
	"That last pagan king of Ireland Cormac in the schoolpoem choked himself at Sletty southward of the Boyne.",
	"Wonder what he was eating.",
	"Something galoptious.",
	"Saint Patrick converted him to Christianity.",
	"Couldn’t swallow it all however.",
	"Roast beef and cabbage.",
	"One stew.",
	"Smells of men.",
	"Spat-on sawdust, sweetish warmish cigarettesmoke, reek of plug, spilt beer, men’s beery piss, the stale of ferment.",
	"His gorge rose.",
	"Couldn’t eat a morsel here.",
	"Fellow sharpening knife and fork to eat all before him, old chap picking his tootles.",
	"Slight spasm, full, chewing the cud.",
	"Before and after.",
	"Grace after meals.",
	"Look on this picture then on that.",
	"Scoffing up stewgravy with sopping sippets of bread.",
	"Lick it off the plate, man!",
	"Get out of this.",
	"He gazed round the stooled and tabled eaters, tightening the wings of his nose.",
	"Two stouts here.",
	"One corned and cabbage.",
	"That fellow ramming a knifeful of cabbage down as if his life depended on it.",
	"Good stroke.",
	"Give me the fidgets to look.",
	"Safer to eat from his three hands.",
	"Tear it limb from limb.",
	"Second nature to him.",
	"Born with a silver knife in his mouth.",
	"That’s witty, I think.",
	"Or no.",
	"Silver means born rich.",
	"Born with a knife.",
	"But then the allusion is lost.",
	"An illgirt server gathered sticky clattering plates.",
	"Rock, the head bailiff, standing at the bar blew the foamy crown from his tankard.",
	"Well up: it splashed yellow near his boot.",
	"Other chap telling him something with his mouth full.",
	"Sympathetic listener.",
	"Table talk.",
	"I munched hum un thu Unchster Bunk un Munchday.",
	"Ha?",
	"Did you, faith?",
	"Mr Bloom raised two fingers doubtfully to his lips.",
	"His eyes said: Not here.",
	"Don’t see him.",
	"Out.",
	"I hate dirty eaters.",
	"He backed towards the door.",
	"Get a light snack in Davy Byrne’s.",
	"Stopgap.",
	"Keep me going.",
	"Had a good breakfast.",
	"Roast and mashed here.",
	"Pint of stout.",
	"Every fellow for his own, tooth and nail.",
	"Gulp.",
	"Grub.",
	"Gulp.",
	"Gobstuff.",
	"He came out into clearer air and turned back towards Grafton street.",
	"Eat or be eaten.",
	"Kill!",
	"Kill!",
	"Suppose that communal kitchen years to come perhaps.",
	"All trotting down with porringers and tommycans to be filled.",
	"Devour contents in the street.",
	"My plate’s empty.",
	"After you with our incorporated drinkingcup.",
	"Like sir Philip Crampton’s fountain.",
	"Rub off the microbes with your handkerchief.",
	"Next chap rubs on a new batch with his.",
	"Father O’Flynn would make hares of them all.",
	"Have rows all the same.",
	"All for number one.",
	"Children fighting for the scrapings of the pot.",
	"Want a souppot as big as the Phoenix park.",
	"Harpooning flitches and hindquarters out of it.",
	"Hate people all round you.",
	"City Arms hotel table d’hôte she called it.",
	"Soup, joint and sweet.",
	"Never know whose thoughts you’re chewing.",
	"Then who’d wash up all the plates and forks?",
	"Might be all feeding on tabloids that time.",
	"Teeth getting worse and worse.",
	"Pain to the animal too.",
	"Pluck and draw fowl.",
	"Wretched brutes there at the cattlemarket waiting for the poleaxe to split their skulls open.",
	"Moo.",
	"Poor trembling calves.",
	"Meh.",
	"Staggering bob.",
	"Bubble and squeak.",
	"Butchers’ buckets wobbly lights.",
	"Give us that brisket off the hook.",
	"Plup.",
	"Rawhead and bloody bones.",
	"Flayed glasseyed sheep hung from their haunches, sheepsnouts bloodypapered snivelling nosejam on sawdust.",
	"Top and lashers going out.",
	"Don’t maul them pieces, young one.",
	"Hot fresh blood they prescribe for decline.",
	"Blood always needed.",
	"Insidious.",
	"Lick it up smokinghot, thick sugary.",
	"Famished ghosts.",
	"Ah, I’m hungry.",
	"He entered Davy Byrne’s.",
	"Moral pub.",
	"He doesn’t chat.",
	"Stands a drink now and then.",
	"But in leapyear once in four.",
	"Cashed a cheque for me once.",
	"What will I take now?",
	"He drew his watch.",
	"Let me see now.",
	"Shandygaff?",
	"Hello, Bloom, Nosey Flynn said from his nook.",
	"Hello, Flynn.",
	"How’s things?",
	"Tiptop... Let me see.",
	"I’ll take a glass of burgundy and... let me see.",
	"Sardines on the shelves.",
	"Almost taste them by looking.",
	"Sandwich?",
	"Ham and his descendants musterred and bred there.",
	"Potted meats.",
	"What is home without Plumtree’s potted meat?",
	"Incomplete.",
	"What a stupid ad!",
	"Under the obituary notices they stuck it.",
	"All up a plumtree.",
	"Dignam’s potted meat.",
	"Cannibals would with lemon and rice.",
	"White missionary too salty.",
	"Like pickled pork.",
	"Expect the chief consumes the parts of honour.",
	"Ought to be tough from exercise.",
	"His wives in a row to watch the effect.",
	"There was a right royal old nigger.",
	"Who ate or something the somethings of the reverend Mr MacTrigger.",
	"With it an abode of bliss.",
	"Lord knows what concoction.",
	"Cauls mouldy tripes windpipes faked and minced up.",
	"Puzzle find the meat.",
	"Kosher.",
	"No meat and milk together.",
	"Hygiene that was what they call now.",
	"Yom Kippur fast spring cleaning of inside.",
	"Peace and war depend on some fellow’s digestion.",
	"Religions.",
	"Christmas turkeys and geese.",
	"Slaughter of innocents.",
	"Eat drink and be merry.",
	"Then casual wards full after.",
	"Heads bandaged.",
	"Cheese digests all but itself.",
	"Mity cheese.",
	"Have you a cheese sandwich?",
	"Yes, sir.",
	"Like a few olives too if they had them.",
	"Italian I prefer.",
	"Good glass of burgundy take away that.",
	"Lubricate.",
	"A nice salad, cool as a cucumber, Tom Kernan can dress.",
	"Puts gusto into it.",
	"Pure olive oil.",
	"Milly served me that cutlet with a sprig of parsley.",
	"Take one Spanish onion.",
	"God made food, the devil the cooks.",
	"Devilled crab.",
	"Wife well?",
	"Quite well, thanks... A cheese sandwich, then.",
	"Gorgonzola, have you?",
	"Yes, sir.",
	"Nosey Flynn sipped his grog.",
	"Doing any singing those times?",
	"Look at his mouth.",
	"Could whistle in his own ear.",
	"Flap ears to match.",
	"Music.",
	"Knows as much about it as my coachman.",
	"Still better tell him.",
	"Does no harm.",
	"Free ad.",
	"She’s engaged for a big tour end of this month.",
	"You may have heard perhaps.",
	"No.",
	"O, that’s the style.",
	"Who’s getting it up?",
	"The curate served.",
	"How much is that?",
	"Seven d., sir...",
	"Thank you, sir.",
	"Mr Bloom cut his sandwich into slender strips.",
	"Mr MacTrigger.",
	"Easier than the dreamy creamy stuff.",
	"His five hundred wives.",
	"Had the time of their lives.",
	"Mustard, sir?",
	"Thank you.",
	"He studded under each lifted strip yellow blobs.",
	"Their lives.",
	"I have it.",
	"It grew bigger and bigger and bigger.",
	"Getting it up?",
	"he said.",
	"Well, it’s like a company idea, you see.",
	"Part shares and part profits.",
	"Ay, now I remember, Nosey Flynn said, putting his hand in his pocket to scratch his groin.",
	"Who is this was telling me?",
	"Isn’t Blazes Boylan mixed up in it?",
	"A warm shock of air heat of mustard hanched on Mr Bloom’s heart.",
	"He raised his eyes and met the stare of a bilious clock.",
	"Two.",
	"Pub clock five minutes fast.",
	"Time going on.",
	"Hands moving.",
	"Two.",
	"Not yet.",
	"His midriff yearned then upward, sank within him, yearned more longly, longingly.",
	"Wine.",
	"He smellsipped the cordial juice and, bidding his throat strongly to speed it, set his wineglass delicately down.",
	"Yes, he said.",
	"He’s the organiser in point of fact.",
	"No fear: no brains.",
	"Nosey Flynn snuffled and scratched.",
	"Flea having a good square meal.",
	"No, snuffled it up.",
	"For near a month, man, before it came off.",
	"Sucking duck eggs by God till further orders.",
	"Keep him off the boose, see?",
	"O, by God, Blazes is a hairy chap.",
	"Davy Byrne came forward from the hindbar in tuckstitched shirtsleeves, cleaning his lips with two wipes of his napkin.",
	"Herring’s blush.",
	"Whose smile upon each feature plays with such and such replete.",
	"Too much fat on the parsnips.",
	"And here’s himself and pepper on him, Nosey Flynn said.",
	"Can you give us a good one for the Gold cup?",
	"I’m off that, Mr Flynn, Davy Byrne answered.",
	"I never put anything on a horse.",
	"You’re right there, Nosey Flynn said.",
	"Sips of his wine soothed his palate.",
	"Not logwood that.",
	"Tastes fuller this weather with the chill off.",
	"Nice quiet bar.",
	"Nice piece of wood in that counter.",
	"Nicely planed.",
	"Like the way it curves there.",
	"I wouldn’t do anything at all in that line, Davy Byrne said.",
	"It ruined many a man, the same horses.",
	"Vintners’ sweepstake.",
	"Licensed for the sale of beer, wine and spirits for consumption on the premises.",
	"Heads I win tails you lose.",
	"True for you, Nosey Flynn said.",
	"Unless you’re in the know.",
	"There’s no straight sport going now.",
	"Lenehan gets some good ones.",
	"He’s giving Sceptre today.",
	"Zinfandel’s the favourite, Lord Howard de Walden’s, won at Epsom.",
	"Morny Cannon is riding him.",
	"I could have got seven to one against Saint Amant a fortnight before.",
	"That so?",
	"Davy Byrne said...",
	"He went towards the window and, taking up the pettycash book, scanned its pages.",
	"I could, faith, Nosey Flynn said, snuffling.",
	"That was a rare bit of horseflesh.",
	"Saint Frusquin was her sire.",
	"She won in a thunderstorm, Rothschild’s filly, with wadding in her ears.",
	"Blue jacket and yellow cap.",
	"Bad luck to big Ben Dollard and his John O’Gaunt.",
	"He put me off it.",
	"Ay.",
	"He drank resignedly from his tumbler, running his fingers down the flutes.",
	"Ay, he said, sighing.",
	"Mr Bloom, champing, standing, looked upon his sigh.",
	"Nosey numbskull.",
	"Will I tell him that horse Lenehan?",
	"He knows already.",
	"Better let him forget.",
	"Go and lose more.",
	"Fool and his money.",
	"Dewdrop coming down again.",
	"Cold nose he’d have kissing a woman.",
	"Still they might like.",
	"Prickly beards they like.",
	"Dogs’ cold noses.",
	"Old Mrs Riordan with the rumbling stomach’s Skye terrier in the City Arms hotel.",
	"Molly fondling him in her lap.",
	"O, the big doggybowwowsywowsy!",
	"Wine soaked and softened rolled pith of bread mustard a moment mawkish cheese.",
	"Nice wine it is.",
	"Taste it better because I’m not thirsty.",
	"Bath of course does that.",
	"Just a bite or two.",
	"Then about six o’clock I can.",
	"Six.",
	"Six.",
	"Time will be gone then.",
	"She...",
	"Mild fire of wine kindled his veins.",
	"I wanted that badly.",
	"Felt so off colour.",
	"His eyes unhungrily saw shelves of tins: sardines, gaudy lobsters’ claws.",
	"All the odd things people pick up for food.",
	"Silly fish learn nothing in a thousand years.",
	"If you didn’t know risky putting anything into your mouth.",
	"Poisonous berries.",
	"Johnny Magories.",
	"Roundness you think good.",
	"Gaudy colour warns you off.",
	"One fellow told another and so on.",
	"Try it on the dog first.",
	"Led on by the smell or the look.",
	"Tempting fruit.",
	"Ice cones.",
	"Cream.",
	"Instinct.",
	"Orangegroves for instance.",
	"Need artificial irrigation.",
	"Bleibtreustrasse.",
	"Yes but what about oysters.",
	"Unsightly like a clot of phlegm.",
	"Filthy shells.",
	"Devil to open them too.",
	"Who found them out?",
	"Garbage, sewage they feed on.",
	"Fizz and Red bank oysters.",
	"Effect on the sexual.",
	"Aphrodis.",
	"He was in the Red Bank this morning.",
	"But there are people like things high.",
	"Tainted game.",
	"Jugged hare.",
	"First catch your hare.",
	"Chinese eating eggs fifty years old, blue and green again.",
	"Dinner of thirty courses.",
	"Each dish harmless might mix inside.",
	"Idea for a poison mystery.",
	"That archduke Leopold was it no yes or was it Otto one of those Habsburgs?",
	"Or who was it used to eat the scruff off his own head?",
	"Cheapest lunch in town.",
	"Of course aristocrats, then the others copy to be in the fashion.",
	"Milly too rock oil and flour.",
	"Raw pastry I like myself.",
	"Half the catch of oysters they throw back in the sea to keep up the price.",
	"Cheap no-one would buy.",
	"Caviare.",
	"Do the grand.",
	"Hock in green glasses.",
	"Swell blowout.",
	"Lady this.",
	"Powdered bosom pearls.",
	"The élite.",
	"Crème de la crème.",
	"They want special dishes to pretend they’re.",
	"Hermit with a platter of pulse keep down the stings of the flesh.",
	"Know me come eat with me.",
	"Royal sturgeon high sheriff, Coffey, the butcher, right to venisons of the forest from his ex.",
	"Send him back the half of a cow.",
	"Spread I saw down in the Master of the Rolls’ kitchen area.",
	"Whitehatted chef like a rabbi.",
	"Combustible duck.",
	"Curly cabbage à la duchesse de Parme.",
	"Just as well to write it on the bill of fare so you can know what you’ve eaten.",
	"Too many drugs spoil the broth.",
	"I know it myself.",
	"Dosing it with Edwards’ desiccated soup.",
	"Geese stuffed silly for them.",
	"Lobsters boiled alive.",
	"Do ptake some ptarmigan.",
	"Wouldn’t mind being a waiter in a swell hotel.",
	"Tips, evening dress, halfnaked ladies.",
	"May I tempt you to a little more filleted lemon sole, miss Dubedat?",
	"Yes, do bedad.",
	"And she did bedad.",
	"Huguenot name I expect that.",
	"A miss Dubedat lived in Killiney, I remember.",
	"Du de la is French.",
	"Moooikill A Aitcha Ha ignorant as a kish of brogues, worth fifty thousand pounds.",
	"Stuck on the pane two flies buzzed, stuck.",
	"Glowing wine on his palate lingered swallowed.",
	"Crushing in the winepress grapes of Burgundy.",
	"Sun’s heat it is.",
	"Seems to a secret touch telling me memory.",
	"Touched his sense moistened remembered.",
	"Hidden under wild ferns on Howth below us bay sleeping: sky.",
	"No sound.",
	"The sky.",
	"The bay purple by the Lion’s head.",
	"Green by Drumleck.",
	"Yellowgreen towards Sutton.",
	"Fields of undersea, the lines faint brown in grass, buried cities.",
	"O wonder!",
	"Coolsoft with ointments her hand touched me, caressed: her eyes upon me did not turn away.",
	"Ravished over her I lay, full lips full open, kissed her mouth.",
	"Yum.",
	"Softly she gave me in my mouth the seedcake warm and chewed.",
	"Mawkish pulp her mouth had mumbled sweetsour of her spittle.",
	"Joy: I ate it: joy.",
	"Young life, her lips that gave me pouting.",
	"Soft warm sticky gumjelly lips.",
	"Flowers her eyes were, take me, willing eyes.",
	"Pebbles fell.",
	"She lay still.",
	"A goat.",
	"No-one.",
	"High on Ben Howth rhododendrons a nannygoat walking surefooted, dropping currants.",
	"Screened under ferns she laughed warmfolded.",
	"Hot I tongued her.",
	"She kissed me.",
	"I was kissed.",
	"All yielding she tossed my hair.",
	"Kissed, she kissed me.",
	"Me.",
	"And me now.",
	"Stuck, the flies buzzed.",
	"His downcast eyes followed the silent veining of the oaken slab.",
	"Beauty: it curves: curves are beauty.",
	"Shapely goddesses, Venus, Juno: curves the world admires.",
	"Can see them library museum standing in the round hall, naked goddesses.",
	"Aids to digestion.",
	"They don’t care what man looks.",
	"All to see.",
	"Never speaking.",
	"I mean to say to fellows like Flynn.",
	"Suppose she did Pygmalion and Galatea what would she say first?",
	"Mortal!",
	"Put you in your proper place.",
	"Quaffing nectar at mess with gods golden dishes, all ambrosial.",
	"Not like a tanner lunch we have, boiled mutton, carrots and turnips, bottle of Allsop.",
	"Nectar imagine it drinking electricity: gods’ food.",
	"Lovely forms of women sculped Junonian.",
	"Immortal lovely.",
	"They have no.",
	"Never looked.",
	"I’ll look today.",
	"Keeper won’t see.",
	"Bend down let something fall see if she.",
	"Dribbling a quiet message from his bladder came to go to do not to do there to do.",
	"When the sound of his boots had ceased Davy Byrne said from his book: What is this he is?",
	"Isn’t he in the insurance line?",
	"He’s out of that long ago, Nosey Flynn said.",
	"He does canvassing for the Freeman.",
	"I know him well to see, Davy Byrne said.",
	"Is he in trouble?",
	"Trouble?",
	"Nosey Flynn said.",
	"Not that I heard of.",
	"Why?",
	"I noticed he was in mourning.",
	"Was he?",
	"Nosey Flynn said.",
	"So he was, faith.",
	"I asked him how was all at home.",
	"You’re right, by God.",
	"So he was.",
	"I never broach the subject, Davy Byrne said humanely, if I see a gentleman is in trouble that way.",
	"It only brings it up fresh in their minds.",
	"It’s not the wife anyhow, Nosey Flynn said.",
	"She’s well nourished, I tell you.",
	"Plovers on toast.",
	"And is he doing for the Freeman?",
	"Davy Byrne said.",
	"Nosey Flynn pursed his lips.",
	"He doesn’t buy cream on the ads he picks up.",
	"You can make bacon of that.",
	"How so?",
	"Davy Byrne asked, coming from his book.",
	"Nosey Flynn made swift passes in the air with juggling fingers.",
	"He winked.",
	"He’s in the craft, he said.",
	"Do you tell me so?",
	"Davy Byrne said.",
	"Very much so, Nosey Flynn said.",
	"Ancient free and accepted order.",
	"He’s an excellent brother.",
	"Light, life and love, by God.",
	"They give him a leg up.",
	"I was told that by a—well, I won’t say who.",
	"Is that a fact?",
	"O, it’s a fine order, Nosey Flynn said.",
	"They stick to you when you’re down.",
	"I know a fellow was trying to get into it.",
	"But they’re as close as damn it.",
	"By God they did right to keep the women out of it.",
	"Davy Byrne smiledyawnednodded all in one: Iiiiiichaaaaaaach!",
	"But be damned but they smelt her out and swore her in on the spot a master mason.",
	"That was one of the saint Legers of Doneraile.",
	"Davy Byrne, sated after his yawn, said with tearwashed eyes: And is that a fact?",
	"Decent quiet man he is.",
	"I often saw him in here and I never once saw him—you know, over the line.",
	"God Almighty couldn’t make him drunk, Nosey Flynn said firmly.",
	"Slips off when the fun gets too hot.",
	"Didn’t you see him look at his watch?",
	"Ah, you weren’t there.",
	"Declare to God he does.",
	"There are some like that, Davy Byrne said.",
	"He’s a safe man, I’d say.",
	"He’s not too bad, Nosey Flynn said, snuffling it up.",
	"He’s been known to put his hand down too to help a fellow.",
	"Give the devil his due.",
	"O, Bloom has his good points.",
	"But there’s one thing he’ll never do.",
	"His hand scrawled a dry pen signature beside his grog.",
	"I know, Davy Byrne said.",
	"Nothing in black and white, Nosey Flynn said.",
	"Paddy Leonard and Bantam Lyons came in.",
	"Tom Rochford followed frowning, a plaining hand on his claret waistcoat.",
	"Day, Mr Byrne.",
	"Day, gentlemen.",
	"They paused at the counter.",
	"Who’s standing?",
	"Paddy Leonard asked.",
	"I’m sitting anyhow, Nosey Flynn answered.",
	"Well, what’ll it be?",
	"Paddy Leonard asked.",
	"I’ll take a stone ginger, Bantam Lyons said.",
	"How much?",
	"Paddy Leonard cried.",
	"Since when, for God’ sake?",
	"What’s yours, Tom?",
	"How is the main drainage?",
	"Nosey Flynn asked, sipping.",
	"For answer Tom Rochford pressed his hand to his breastbone and hiccupped.",
	"Would I trouble you for a glass of fresh water, Mr Byrne?",
	"he said.",
	"Certainly, sir.",
	"Paddy Leonard eyed his alemates.",
	"Lord love a duck, he said.",
	"Look at what I’m standing drinks to!",
	"Cold water and gingerpop!",
	"Two fellows that would suck whisky off a sore leg.",
	"He has some bloody horse up his sleeve for the Gold cup.",
	"A dead snip.",
	"Zinfandel is it?",
	"Nosey Flynn asked.",
	"Tom Rochford spilt powder from a twisted paper into the water set before him.",
	"That cursed dyspepsia, he said before drinking.",
	"Breadsoda is very good, Davy Byrne said.",
	"Tom Rochford nodded and drank.",
	"Is it Zinfandel?",
	"Say nothing!",
	"Bantam Lyons winked.",
	"I’m going to plunge five bob on my own.",
	"Tell us if you’re worth your salt and be damned to you, Paddy Leonard said.",
	"Who gave it to you?",
	"Mr Bloom on his way out raised three fingers in greeting.",
	"So long!",
	"Nosey Flynn said.",
	"The others turned.",
	"That’s the man now that gave it to me, Bantam Lyons whispered.",
	"Prrwht!",
	"Paddy Leonard said with scorn.",
	"Ay, Paddy Leonard said.",
	"A suckingbottle for the baby.",
	"Mr Bloom walked towards Dawson street, his tongue brushing his teeth smooth.",
	"Something green it would have to be: spinach, say.",
	"Then with those Röntgen rays searchlight you could.",
	"Surfeit.",
	"Returned with thanks having fully digested the contents.",
	"First sweet then savoury.",
	"Mr Bloom coasted warily.",
	"Ruminants.",
	"His second course.",
	"Their upper jaw they move.",
	"Wonder if Tom Rochford will do anything with that invention of his?",
	"Wasting time explaining it to Flynn’s mouth.",
	"Lean people long mouths.",
	"Ought to be a hall or a place where inventors could go in and invent free.",
	"Course then you’d have all the cranks pestering.",
	"He hummed, prolonging in solemn echo the closes of the bars: Don Giovanni, a cenar teco M’invitasti.",
	"Feel better.",
	"Burgundy.",
	"Good pick me up.",
	"Who distilled first?",
	"Some chap in the blues.",
	"Dutch courage.",
	"That Kilkenny People in the national library now I must.",
	"Bare clean closestools waiting in the window of William Miller, plumber, turned back his thoughts.",
	"But the poor buffer would have to stand all the time with his insides entrails on show.",
	"Science.",
	"A cenar teco.",
	"What does that teco mean?",
	"Tonight perhaps.",
	"Don Giovanni, thou hast me invited To come to supper tonight, The rum the rumdum.",
	"Doesn’t go properly.",
	"Keyes: two months if I get Nannetti to.",
	"That’ll be two pounds ten about two pounds eight.",
	"Three Hynes owes me.",
	"Two eleven.",
	"Prescott’s dyeworks van over there.",
	"If I get Billy Prescott’s ad: two fifteen.",
	"Five guineas about.",
	"On the pig’s back.",
	"Could buy one of those silk petticoats for Molly, colour of her new garters.",
	"Today.",
	"Today.",
	"Not think.",
	"Tour the south then.",
	"What about English wateringplaces?",
	"Brighton, Margate.",
	"Piers by moonlight.",
	"Her voice floating out.",
	"Those lovely seaside girls.",
	"Against John Long’s a drowsing loafer lounged in heavy thought, gnawing a crusted knuckle.",
	"Handy man wants job.",
	"Small wages.",
	"Will eat anything.",
	"Mr Bloom turned at Gray’s confectioner’s window of unbought tarts and passed the reverend Thomas Connellan’s bookstore.",
	"Why I left the church of Rome?",
	"Birds’ Nest.",
	"Women run him.",
	"Society over the way papa went to for the conversion of poor jews.",
	"Same bait.",
	"Why we left the church of Rome.",
	"A blind stripling stood tapping the curbstone with his slender cane.",
	"No tram in sight.",
	"Wants to cross.",
	"Do you want to cross?",
	"Mr Bloom asked.",
	"The blind stripling did not answer.",
	"His wallface frowned weakly.",
	"He moved his head uncertainly.",
	"You’re in Dawson street, Mr Bloom said.",
	"Molesworth street is opposite.",
	"Do you want to cross?",
	"There’s nothing in the way.",
	"The cane moved out trembling to the left.",
	"Mr Bloom’s eye followed its line and saw again the dyeworks’ van drawn up before Drago’s.",
	"Where I saw his brillantined hair just when I was.",
	"Horse drooping.",
	"Driver in John Long’s.",
	"Slaking his drouth.",
	"There’s a van there, Mr Bloom said, but it’s not moving.",
	"I’ll see you across.",
	"Do you want to go to Molesworth street?",
	"Yes, the stripling answered.",
	"South Frederick street.",
	"Come, Mr Bloom said.",
	"He touched the thin elbow gently: then took the limp seeing hand to guide it forward.",
	"Say something to him.",
	"Better not do the condescending.",
	"They mistrust what you tell them.",
	"Pass a common remark.",
	"The rain kept off.",
	"No answer.",
	"Stains on his coat.",
	"Slobbers his food, I suppose.",
	"Tastes all different for him.",
	"Have to be spoonfed first.",
	"Like a child’s hand, his hand.",
	"Like Milly’s was.",
	"Sensitive.",
	"Sizing me up I daresay from my hand.",
	"Wonder if he has a name.",
	"Van.",
	"Keep his cane clear of the horse’s legs: tired drudge get his doze.",
	"That’s right.",
	"Clear.",
	"Behind a bull: in front of a horse.",
	"Thanks, sir.",
	"Knows I’m a man.",
	"Voice.",
	"Right now?",
	"First turn to the left.",
	"The blind stripling tapped the curbstone and went on his way, drawing his cane back, feeling again.",
	"Mr Bloom walked behind the eyeless feet, a flatcut suit of herringbone tweed.",
	"Poor young fellow!",
	"How on earth did he know that van was there?",
	"Must have felt it.",
	"See things in their forehead perhaps: kind of sense of volume.",
	"Weight or size of it, something blacker than the dark.",
	"Wonder would he feel it if something was removed.",
	"Feel a gap.",
	"Queer idea of Dublin he must have, tapping his way round by the stones.",
	"Could he walk in a beeline if he hadn’t that cane?",
	"Bloodless pious face like a fellow going in to be a priest.",
	"Penrose!",
	"That was that chap’s name.",
	"Look at all the things they can learn to do.",
	"Read with their fingers.",
	"Tune pianos.",
	"Or we are surprised they have any brains.",
	"Why we think a deformed person or a hunchback clever if he says something we might say.",
	"Of course the other senses are more.",
	"Embroider.",
	"Plait baskets.",
	"People ought to help.",
	"Workbasket I could buy for Molly’s birthday.",
	"Hates sewing.",
	"Might take an objection.",
	"Dark men they call them.",
	"Sense of smell must be stronger too.",
	"Smells on all sides, bunched together.",
	"Each street different smell.",
	"Each person too.",
	"Then the spring, the summer: smells.",
	"Tastes?",
	"They say you can’t taste wines with your eyes shut or a cold in the head.",
	"Also smoke in the dark they say get no pleasure.",
	"And with a woman, for instance.",
	"More shameless not seeing.",
	"That girl passing the Stewart institution, head in the air.",
	"Look at me.",
	"I have them all on.",
	"Must be strange not to see her.",
	"Kind of a form in his mind’s eye.",
	"The voice, temperatures: when he touches her with his fingers must almost see the lines, the curves.",
	"His hands on her hair, for instance.",
	"Say it was black, for instance.",
	"Good.",
	"We call it black.",
	"Then passing over her white skin.",
	"Different feel perhaps.",
	"Feeling of white.",
	"Postoffice.",
	"Must answer.",
	"Fag today.",
	"Send her a postal order two shillings, half a crown.",
	"Accept my little present.",
	"Stationer’s just here too.",
	"Wait.",
	"Think over it.",
	"With a gentle finger he felt ever so slowly the hair combed back above his ears.",
	"Again.",
	"Fibres of fine fine straw.",
	"Then gently his finger felt the skin of his right cheek.",
	"Downy hair there too.",
	"Not smooth enough.",
	"The belly is the smoothest.",
	"No-one about.",
	"There he goes into Frederick street.",
	"Perhaps to Levenston’s dancing academy piano.",
	"Might be settling my braces.",
	"But I know it’s whitey yellow.",
	"Want to try in the dark to see.",
	"He withdrew his hand and pulled his dress to.",
	"Poor fellow!",
	"Quite a boy.",
	"Terrible.",
	"Really terrible.",
	"What dreams would he have, not seeing?",
	"Life a dream for him.",
	"Where is the justice being born that way?",
	"All those women and children excursion beanfeast burned and drowned in New York.",
	"Holocaust.",
	"Karma they call that transmigration for sins you did in a past life the reincarnation met him pike hoses.",
	"Dear, dear, dear.",
	"Pity, of course: but somehow you can’t cotton on to them someway.",
	"Sir Frederick Falkiner going into the freemasons’ hall.",
	"Solemn as Troy.",
	"After his good lunch in Earlsfort terrace.",
	"Old legal cronies cracking a magnum.",
	"Tales of the bench and assizes and annals of the bluecoat school.",
	"I sentenced him to ten years.",
	"I suppose he’d turn up his nose at that stuff I drank.",
	"Vintage wine for them, the year marked on a dusty bottle.",
	"Has his own ideas of justice in the recorder’s court.",
	"Wellmeaning old man.",
	"Police chargesheets crammed with cases get their percentage manufacturing crime.",
	"Sends them to the rightabout.",
	"The devil on moneylenders.",
	"Gave Reuben J a great strawcalling.",
	"Now he’s really what they call a dirty jew.",
	"Power those judges have.",
	"Crusty old topers in wigs.",
	"Bear with a sore paw.",
	"And may the Lord have mercy on your soul.",
	"Hello, placard.",
	"Mirus bazaar.",
	"His Excellency the lord lieutenant.",
	"Sixteenth.",
	"Today it is.",
	"In aid of funds for Mercer’s hospital.",
	"The Messiah was first given for that.",
	"Yes.",
	"Handel.",
	"What about going out there: Ballsbridge.",
	"Drop in on Keyes.",
	"No use sticking to him like a leech.",
	"Wear out my welcome.",
	"Sure to know someone on the gate.",
	"Mr Bloom came to Kildare street.",
	"First I must.",
	"Library.",
	"Straw hat in sunlight.",
	"Tan shoes.",
	"Turnedup trousers.",
	"It is.",
	"It is.",
	"His heart quopped softly.",
	"To the right.",
	"Museum.",
	"Goddesses.",
	"He swerved to the right.",
	"Is it?",
	"Almost certain.",
	"Won’t look.",
	"Wine in my face.",
	"Why did I?",
	"Too heady.",
	"Yes, it is.",
	"The walk.",
	"Not see.",
	"Get on.",
	"Making for the museum gate with long windy steps he lifted his eyes.",
	"Handsome building.",
	"Sir Thomas Deane designed.",
	"Not following me?",
	"Didn’t see me perhaps.",
	"Light in his eyes.",
	"The flutter of his breath came forth in short sighs.",
	"Quick.",
	"Cold statues: quiet there.",
	"Safe in a minute.",
	"No.",
	"Didn’t see me.",
	"After two.",
	"Just at the gate.",
	"My heart!",
	"His eyes beating looked steadfastly at cream curves of stone.",
	"Sir Thomas Deane was the Greek architecture.",
	"Look for something I.",
	"His hasty hand went quick into a pocket, took out, read unfolded Agendath Netaim.",
	"Where did I?",
	"Busy looking.",
	"He thrust back quick Agendath.",
	"Afternoon she said.",
	"I am looking for that.",
	"Yes, that.",
	"Try all pockets.",
	"Handker.",
	"Freeman.",
	"Where did I?",
	"Ah, yes.",
	"Trousers.",
	"Potato.",
	"Purse.",
	"Where?",
	"Hurry.",
	"Walk quietly.",
	"Moment more.",
	"My heart.",
	"Ah soap there I yes.",
	"Gate.",
	"Safe!",
	"A great poet on a great brother poet.",
	"A noiseless attendant setting open the door but slightly made him a noiseless beck.",
	"Directly, said he, creaking to go, albeit lingering.",
	"The beautiful ineffectual dreamer who comes to grief against hard facts.",
	"One always feels that Goethe’s judgments are so true.",
	"True in the larger analysis.",
	"Twicreakingly analysis he corantoed off.",
	"Two left.",
	"Monsieur de la Palice, Stephen sneered, was alive fifteen minutes before his death.",
	"The Sorrows of Satan he calls it.",
	"Smile.",
	"Smile Cranly’s smile.",
	"Seven is dear to the mystic mind.",
	"The shining seven W.B.",
	"calls them.",
	"Glittereyed his rufous skull close to his greencapped desklamp sought the face bearded amid darkgreener shadow, an ollav, holyeyed.",
	"He laughed low: a sizar’s laugh of Trinity: unanswered.",
	"Orchestral Satan, weeping many a rood Tears such as angels weep.",
	"Ed egli avea del cul fatto trombetta.",
	"He holds my follies hostage.",
	"Cranly’s eleven true Wicklowmen to free their sireland.",
	"Gaptoothed Kathleen, her four beautiful green fields, the stranger in her house.",
	"And one more to hail him: ave, rabbi: the Tinahely twelve.",
	"In the shadow of the glen he cooees for them.",
	"My soul’s youth I gave him, night by night.",
	"God speed.",
	"Good hunting.",
	"Mulligan has my telegram.",
	"Folly.",
	"Persist.",
	"All these questions are purely academic, Russell oracled out of his shadow.",
	"I mean, whether Hamlet is Shakespeare or James I or Essex.",
	"Clergymen’s discussions of the historicity of Jesus.",
	"Art has to reveal to us ideas, formless spiritual essences.",
	"The supreme question about a work of art is out of how deep a life does it spring.",
	"The painting of Gustave Moreau is the painting of ideas.",
	"All the rest is the speculation of schoolboys for schoolboys.",
	"A. E. has been telling some yankee interviewer.",
	"Wall, tarnation strike me!",
	"The schoolmen were schoolboys first, Stephen said superpolitely.",
	"Aristotle was once Plato’s schoolboy.",
	"And has remained so, one should hope, John Eglinton sedately said.",
	"One can see him, a model schoolboy with his diploma under his arm.",
	"He laughed again at the now smiling bearded face.",
	"Formless spiritual.",
	"Father, Word and Holy Breath.",
	"Allfather, the heavenly man.",
	"Hiesos Kristos, magician of the beautiful, the Logos who suffers in us at every moment.",
	"This verily is that.",
	"I am the fire upon the altar.",
	"I am the sacrificial butter.",
	"Brothers of the great white lodge always watching to see if they can help.",
	"The life esoteric is not for ordinary person.",
	"O.P.",
	"must work off bad karma first.",
	"Mrs Cooper Oakley once glimpsed our very illustrious sister H.P.B.‘s elemental.",
	"O, fie!",
	"Out on’t!",
	"Pfuiteufel!",
	"You naughtn’t to look, missus, so you naughtn’t when a lady’s ashowing of her elemental.",
	"Mr Best entered, tall, young, mild, light.",
	"He bore in his hand with grace a notebook, new, large, clean, bright.",
	"Which of the two, Stephen asked, would have banished me from his commonwealth?",
	"Unsheathe your dagger definitions.",
	"Horseness is the whatness of allhorse.",
	"Streams of tendency and eons they worship.",
	"God: noise in the street: very peripatetic.",
	"Space: what you damn well have to see.",
	"Hold to the now, the here, through which all future plunges to the past.",
	"Mr Best came forward, amiable, towards his colleague.",
	"Haines is gone, he said.",
	"Is he?",
	"I was showing him Jubainville’s book.",
	"He’s quite enthusiastic, don’t you know, about Hyde’s Lovesongs of Connacht.",
	"I couldn’t bring him in to hear the discussion.",
	"He’s gone to Gill’s to buy it.",
	"Bound thee forth, my booklet, quick To greet the callous public.",
	"Writ, I ween, ‘twas not my wish In lean unlovely English.",
	"The peatsmoke is going to his head, John Eglinton opined.",
	"We feel in England.",
	"Penitent thief.",
	"Gone.",
	"I smoked his baccy.",
	"Green twinkling stone.",
	"An emerald set in the ring of the sea.",
	"People do not know how dangerous lovesongs can be, the auric egg of Russell warned occultly.",
	"For them the earth is not an exploitable ground but the living mother.",
	"The rarefied air of the academy and the arena produce the sixshilling novel, the musichall song.",
	"From these words Mr Best turned an unoffending face to Stephen.",
	"The one about Hamlet.",
	"He says: il se promène, lisant au livre de lui-même, don’t you know, reading the book of himself.",
	"He describes Hamlet given in a French town, don’t you know, a provincial town.",
	"They advertised it.",
	"His free hand graciously wrote tiny signs in air.",
	"It’s so French.",
	"The French point of view.",
	"Hamlet ou... —The absentminded beggar, Stephen ended.",
	"John Eglinton laughed.",
	"Yes, I suppose it would be, he said.",
	"Excellent people, no doubt, but distressingly shortsighted in some matters.",
	"Sumptuous and stagnant exaggeration of murder.",
	"A deathsman of the soul Robert Greene called him, Stephen said.",
	"Not for nothing was he a butcher’s son, wielding the sledded poleaxe and spitting in his palms.",
	"Nine lives are taken off for his father’s one.",
	"Our Father who art in purgatory.",
	"Khaki Hamlets don’t hesitate to shoot.",
	"The bloodboltered shambles in act five is a forecast of the concentration camp sung by Mr Swinburne.",
	"Cranly, I his mute orderly, following battles from afar.",
	"Whelps and dams of murderous foes whom none But we had spared...",
	"Between the Saxon smile and yankee yawp.",
	"The devil and the deep sea.",
	"He will have it that Hamlet is a ghoststory, John Eglinton said for Mr Best’s behoof.",
	"Like the fat boy in Pickwick he wants to make our flesh creep.",
	"List!",
	"List!",
	"O List!",
	"My flesh hears him: creeping, hears.",
	"If thou didst ever... —What is a ghost?",
	"Stephen said with tingling energy.",
	"One who has faded into impalpability through death, through absence, through change of manners.",
	"Elizabethan London lay as far from Stratford as corrupt Paris lies from virgin Dublin.",
	"Who is the ghost from limbo patrum, returning to the world that has forgotten him?",
	"Who is King Hamlet?",
	"John Eglinton shifted his spare body, leaning back to judge.",
	"Lifted.",
	"It is this hour of a day in mid June, Stephen said, begging with a swift glance their hearing.",
	"The flag is up on the playhouse by the bankside.",
	"The bear Sackerson growls in the pit near it, Paris garden.",
	"Canvasclimbers who sailed with Drake chew their sausages among the groundlings.",
	"Local colour.",
	"Work in all you know.",
	"Make them accomplices.",
	"Shakespeare has left the huguenot’s house in Silver street and walks by the swanmews along the riverbank.",
	"But he does not stay to feed the pen chivying her game of cygnets towards the rushes.",
	"The swan of Avon has other thoughts.",
	"Composition of place.",
	"Ignatius Loyola, make haste to help me!",
	"The play begins.",
	"But this prying into the family life of a great man, Russell began impatiently.",
	"Art thou there, truepenny?",
	"Interesting only to the parish clerk.",
	"I mean, we have the plays.",
	"I mean when we read the poetry of King Lear what is it to us how the poet lived?",
	"As for living our servants can do that for us, Villiers de l’Isle has said.",
	"Peeping and prying into greenroom gossip of the day, the poet’s drinking, the poet’s debts.",
	"We have King Lear: and it is immortal.",
	"Mr Best’s face, appealed to, agreed.",
	"Marry, I wanted it.",
	"Take thou this noble.",
	"Go to!",
	"You spent most of it in Georgina Johnson’s bed, clergyman’s daughter.",
	"Agenbite of inwit.",
	"Do you intend to pay it back?",
	"O, yes.",
	"When?",
	"Now?",
	"Well... No.",
	"When, then?",
	"I paid my way.",
	"I paid my way.",
	"Steady on.",
	"He’s from beyant Boyne water.",
	"The northeast corner.",
	"You owe it.",
	"Wait.",
	"Five months.",
	"Molecules all change.",
	"I am other I now.",
	"Other I got pound.",
	"Buzz.",
	"Buzz.",
	"But I, entelechy, form of forms, am I by memory because under everchanging forms.",
	"I that sinned and prayed and fasted.",
	"A child Conmee saved from pandies.",
	"I, I and I. I. A.E.I.O.U.",
	"Do you mean to fly in the face of the tradition of three centuries?",
	"John Eglinton’s carping voice asked.",
	"Her ghost at least has been laid for ever.",
	"She died, for literature at least, before she was born.",
	"She died, Stephen retorted, sixtyseven years after she was born.",
	"She saw him into and out of the world.",
	"She took his first embraces.",
	"Mother’s deathbed.",
	"Candle.",
	"The sheeted mirror.",
	"Who brought me into this world lies there, bronzelidded, under few cheap flowers.",
	"Liliata rutilantium.",
	"I wept alone.",
	"John Eglinton looked in the tangled glowworm of his lamp.",
	"Bosh!",
	"Stephen said rudely.",
	"A man of genius makes no mistakes.",
	"His errors are volitional and are the portals of discovery.",
	"Portals of discovery opened to let in the quaker librarian, softcreakfooted, bald, eared and assiduous.",
	"A shrew, John Eglinton said shrewdly, is not a useful portal of discovery, one should imagine.",
	"What useful discovery did Socrates learn from Xanthippe?",
	"Dialectic, Stephen answered: and from his mother how to bring thoughts into the world.",
	"What he learnt from his other wife Myrto (absit nomen!",
	"), Socratididion’s Epipsychidion, no man, not a woman, will ever know.",
	"But Ann Hathaway?",
	"Mr Best’s quiet voice said forgetfully.",
	"Yes, we seem to be forgetting her as Shakespeare himself forgot her.",
	"He had a good groatsworth of wit, Stephen said, and no truant memory.",
	"He carried a memory in his wallet as he trudged to Romeville whistling The girl I left behind me.",
	"That memory, Venus and Adonis, lay in the bedchamber of every light-of-love in London.",
	"Is Katharine the shrew illfavoured?",
	"Hortensio calls her young and beautiful.",
	"Good: he left her and gained the world of men.",
	"But his boywomen are the women of a boy.",
	"Their life, thought, speech are lent them by males.",
	"He chose badly?",
	"He was chosen, it seems to me.",
	"If others have their will Ann hath a way.",
	"By cock, she was to blame.",
	"She put the comether on him, sweet and twentysix.",
	"And my turn?",
	"When?",
	"Come!",
	"Ryefield, Mr Best said brightly, gladly, raising his new book, gladly, brightly.",
	"He murmured then with blond delight for all: Between the acres of the rye These pretty countryfolk would lie.",
	"Paris: the wellpleased pleaser.",
	"A tall figure in bearded homespun rose from shadow and unveiled its cooperative watch.",
	"I am afraid I am due at the Homestead.",
	"Whither away?",
	"Exploitable ground.",
	"Are you going?",
	"John Eglinton’s active eyebrows asked.",
	"Shall we see you at Moore’s tonight?",
	"Piper is coming.",
	"Piper!",
	"Mr Best piped.",
	"Is Piper back?",
	"Peter Piper pecked a peck of pick of peck of pickled pepper.",
	"I don’t know if I can.",
	"Thursday.",
	"We have our meeting.",
	"If I can get away in time.",
	"Yogibogeybox in Dawson chambers.",
	"Isis Unveiled.",
	"Their Pali book we tried to pawn.",
	"Crosslegged under an umbrel umbershoot he thrones an Aztec logos, functioning on astral levels, their oversoul, mahamahatma.",
	"The faithful hermetists await the light, ripe for chelaship, ringroundabout him.",
	"Louis H. Victory.",
	"T. Caulfield Irwin.",
	"Lotus ladies tend them i’the eyes, their pineal glands aglow.",
	"Filled with his god, he thrones, Buddh under plantain.",
	"Gulfer of souls, engulfer.",
	"Hesouls, shesouls, shoals of souls.",
	"Engulfed with wailing creecries, whirled, whirling, they bewail.",
	"In quintessential triviality For years in this fleshcase a shesoul dwelt.",
	"They say we are to have a literary surprise, the quaker librarian said, friendly and earnest.",
	"Mr Russell, rumour has it, is gathering together a sheaf of our younger poets’ verses.",
	"We are all looking forward anxiously.",
	"Anxiously he glanced in the cone of lamplight where three faces, lighted, shone.",
	"See this.",
	"Remember.",
	"Stephen looked down on a wide headless caubeen, hung on his ashplanthandle over his knee.",
	"My casque and sword.",
	"Touch lightly with two index fingers.",
	"Aristotle’s experiment.",
	"One or two?",
	"Necessity is that in virtue of which it is impossible that one can be otherwise.",
	"Argal, one hat is one hat.",
	"Listen.",
	"Young Colum and Starkey.",
	"George Roberts is doing the commercial part.",
	"Longworth will give it a good puff in the Express.",
	"O, will he?",
	"I liked Colum’s Drover.",
	"Yes, I think he has that queer thing genius.",
	"Do you think he has genius really?",
	"Yeats admired his line: As in wild earth a Grecian vase.",
	"Did he?",
	"I hope you’ll be able to come tonight.",
	"Malachi Mulligan is coming too.",
	"Moore asked him to bring Haines.",
	"Did you hear Miss Mitchell’s joke about Moore and Martyn?",
	"That Moore is Martyn’s wild oats?",
	"Awfully clever, isn’t it?",
	"They remind one of Don Quixote and Sancho Panza.",
	"Our national epic has yet to be written, Dr Sigerson says.",
	"Moore is the man for it.",
	"A knight of the rueful countenance here in Dublin.",
	"With a saffron kilt?",
	"O’Neill Russell?",
	"O, yes, he must speak the grand old tongue.",
	"And his Dulcinea?",
	"James Stephens is doing some clever sketches.",
	"We are becoming important, it seems.",
	"Cordelia.",
	"Cordoglio.",
	"Lir’s loneliest daughter.",
	"Nookshotten.",
	"Now your best French polish.",
	"Thank you very much, Mr Russell, Stephen said, rising.",
	"If you will be so kind as to give the letter to Mr Norman... —O, yes.",
	"If he considers it important it will go in.",
	"We have so much correspondence.",
	"I understand, Stephen said.",
	"Thanks.",
	"God ild you.",
	"The pigs’ paper.",
	"Bullockbefriending.",
	"Synge has promised me an article for Dana too.",
	"Are we going to be read?",
	"I feel we are.",
	"The Gaelic league wants something in Irish.",
	"I hope you will come round tonight.",
	"Bring Starkey.",
	"Stephen sat down.",
	"The quaker librarian came from the leavetakers.",
	"Blushing, his mask said: Mr Dedalus, your views are most illuminating.",
	"Alarmed face asks me.",
	"Why did he come?",
	"Courtesy or an inward light?",
	"Where there is a reconciliation, Stephen said, there must have been first a sundering.",
	"Yes.",
	"Christfox in leather trews, hiding, a runaway in blighted treeforks, from hue and cry.",
	"Knowing no vixen, walking lonely in the chase.",
	"Women he won to him, tender people, a whore of Babylon, ladies of justices, bully tapsters’ wives.",
	"Fox and geese.",
	"Yes.",
	"So you think...",
	"The door closed behind the outgoer.",
	"Rest suddenly possessed the discreet vaulted cell, rest of warm and brooding air.",
	"A vestal’s lamp.",
	"Coffined thoughts around me, in mummycases, embalmed in spice of words.",
	"Thoth, god of libraries, a birdgod, moonycrowned.",
	"And I heard the voice of that Egyptian highpriest.",
	"In painted chambers loaded with tilebooks.",
	"They are still.",
	"Once quick in the brains of men.",
	"Certainly, John Eglinton mused, of all great men he is the most enigmatic.",
	"We know nothing but that he lived and suffered.",
	"Not even so much.",
	"Others abide our question.",
	"A shadow hangs over all the rest.",
	"But Hamlet is so personal, isn’t it?",
	"Mr Best pleaded.",
	"I mean, a kind of private paper, don’t you know, of his private life.",
	"I mean, I don’t care a button, don’t you know, who is killed or who is guilty...",
	"He rested an innocent book on the edge of the desk, smiling his defiance.",
	"His private papers in the original.",
	"Ta an bad ar an tir.",
	"Taim in mo shagart.",
	"Put beurla on it, littlejohn.",
	"Bear with me.",
	"Stephen withstood the bane of miscreant eyes glinting stern under wrinkled brows.",
	"A basilisk.",
	"E quando vede l’uomo l’attosca.",
	"Messer Brunetto, I thank thee for the word.",
	"Drummond of Hawthornden helped you at that stile.",
	"Yes, Mr Best said youngly.",
	"I feel Hamlet quite young.",
	"The bitterness might be from the father but the passages with Ophelia are surely from the son.",
	"Has the wrong sow by the lug.",
	"He is in my father.",
	"I am in his son.",
	"That mole is the last to go, Stephen said, laughing.",
	"John Eglinton made a nothing pleasing mow.",
	"If that were the birthmark of genius, he said, genius would be a drug in the market.",
	"The plays of Shakespeare’s later years which Renan admired so much breathe another spirit.",
	"The spirit of reconciliation, the quaker librarian breathed.",
	"There can be no reconciliation, Stephen said, if there has not been a sundering.",
	"Said that.",
	"What softens the heart of a man, shipwrecked in storms dire, Tried, like another Ulysses, Pericles, prince of Tyre?",
	"Head, redconecapped, buffeted, brineblinded.",
	"A child, a girl, placed in his arms, Marina.",
	"The leaning of sophists towards the bypaths of apocrypha is a constant quantity, John Eglinton detected.",
	"The highroads are dreary but they lead to the town.",
	"Good Bacon: gone musty.",
	"Shakespeare Bacon’s wild oats.",
	"Cypherjugglers going the highroads.",
	"Seekers on the great quest.",
	"What town, good masters?",
	"Mummed in names: A. E., eon: Magee, John Eglinton.",
	"East of the sun, west of the moon: Tir na n-og.",
	"Booted the twain and staved.",
	"How many miles to Dublin?",
	"Three score and ten, sir.",
	"Will we be there by candlelight?",
	"Mr Brandes accepts it, Stephen said, as the first play of the closing period.",
	"Does he?",
	"What does Mr Sidney Lee, or Mr Simon Lazarus as some aver his name is, say of it?",
	"Marina, Stephen said, a child of storm, Miranda, a wonder, Perdita, that which was lost.",
	"What was lost is given back to him: his daughter’s child.",
	"My dearest wife, Pericles says, was like this maid.",
	"Will any man love the daughter if he has not loved the mother?",
	"The art of being a grandfather, Mr Best gan murmur.",
	"Do you know what you are talking about?",
	"Love, yes.",
	"Word known to all men.",
	"Such an appeal will touch him.",
	"The images of other males of his blood will repel him.",
	"He will see in them grotesque attempts of nature to foretell or to repeat himself.",
	"The benign forehead of the quaker librarian enkindled rosily with hope.",
	"I hope Mr Dedalus will work out his theory for the enlightenment of the public.",
	"And we ought to mention another Irish commentator, Mr George Bernard Shaw.",
	"Nor should we forget Mr Frank Harris.",
	"His articles on Shakespeare in the Saturday Review were surely brilliant.",
	"Oddly enough he too draws for us an unhappy relation with the dark lady of the sonnets.",
	"The favoured rival is William Herbert, earl of Pembroke.",
	"Felicitously he ceased and held a meek head among them, auk’s egg, prize of their fray.",
	"He thous and thees her with grave husbandwords.",
	"Dost love, Miriam?",
	"Dost love thy man?",
	"That may be too, Stephen said.",
	"There’s a saying of Goethe’s which Mr Magee likes to quote.",
	"Beware of what you wish for in youth because you will get it in middle life.",
	"Why?",
	"Belief in himself has been untimely killed.",
	"Assumed dongiovannism will not save him.",
	"No later undoing will undo the first undoing.",
	"The tusk of the boar has wounded him there where love lies ableeding.",
	"If the shrew is worsted yet there remains to her woman’s invisible weapon.",
	"A like fate awaits him and the two rages commingle in a whirlpool.",
	"They list.",
	"And in the porches of their ears I pour.",
	"The soul has been before stricken mortally, a poison poured in the porch of a sleeping ear.",
	"That is why the speech (his lean unlovely English) is always turned elsewhere, backward.",
	"His beaver is up.",
	"Amen!",
	"was responded from the doorway.",
	"Hast thou found me, O mine enemy?",
	"Entr’acte.",
	"My telegram.",
	"You were speaking of the gaseous vertebrate, if I mistake not?",
	"he asked of Stephen.",
	"Primrosevested he greeted gaily with his doffed Panama as with a bauble.",
	"They make him welcome.",
	"Was Du verlachst wirst Du noch dienen.",
	"Brood of mockers: Photius, pseudomalachi, Johann Most.",
	"Glo—o—ri—a in ex—cel—sis De—o.",
	"He lifts his hands.",
	"Veils fall.",
	"O, flowers!",
	"Bells with bells with bells aquiring.",
	"Yes, indeed, the quaker librarian said.",
	"A most instructive discussion.",
	"Mr Mulligan, I’ll be bound, has his theory too of the play and of Shakespeare.",
	"All sides of life should be represented.",
	"He smiled on all sides equally.",
	"Buck Mulligan thought, puzzled: Shakespeare?",
	"he said.",
	"I seem to know the name.",
	"A flying sunny smile rayed in his loose features.",
	"To be sure, he said, remembering brightly.",
	"The chap that writes like Synge.",
	"Mr Best turned to him.",
	"Haines missed you, he said.",
	"Did you meet him?",
	"He’ll see you after at the D. B. C. He’s gone to Gill’s to buy Hyde’s Lovesongs of Connacht.",
	"I came through the museum, Buck Mulligan said.",
	"Was he here?",
	"The bard’s fellowcountrymen, John Eglinton answered, are rather tired perhaps of our brilliancies of theorising.",
	"I hear that an actress played Hamlet for the fourhundredandeighth time last night in Dublin.",
	"Vining held that the prince was a woman.",
	"Has no-one made him out to be an Irishman?",
	"Judge Barton, I believe, is searching for some clues.",
	"He swears (His Highness not His Lordship) by saint Patrick.",
	"The most brilliant of all is that story of Wilde’s, Mr Best said, lifting his brilliant notebook.",
	"For Willie Hughes, is it not?",
	"the quaker librarian asked.",
	"Or Hughie Wills?",
	"Mr William Himself.",
	"W. H.: who am I?",
	"I mean, for Willie Hughes, Mr Best said, amending his gloss easily.",
	"It’s the very essence of Wilde, don’t you know.",
	"The light touch.",
	"His glance touched their faces lightly as he smiled, a blond ephebe.",
	"Tame essence of Wilde.",
	"You’re darned witty.",
	"Three drams of usquebaugh you drank with Dan Deasy’s ducats.",
	"How much did I spend?",
	"O, a few shillings.",
	"For a plump of pressmen.",
	"Humour wet and dry.",
	"Wit.",
	"You would give your five wits for youth’s proud livery he pranks in.",
	"Lineaments of gratified desire.",
	"There be many mo.",
	"Take her for me.",
	"In pairing time.",
	"Jove, a cool ruttime send them.",
	"Yea, turtledove her.",
	"Eve.",
	"Naked wheatbellied sin.",
	"A snake coils her, fang in’s kiss.",
	"Do you think it is only a paradox?",
	"the quaker librarian was asking.",
	"The mocker is never taken seriously when he is most serious.",
	"They talked seriously of mocker’s seriousness.",
	"Buck Mulligan’s again heavy face eyed Stephen awhile.",
	"Then, his head wagging, he came near, drew a folded telegram from his pocket.",
	"His mobile lips read, smiling with new delight.",
	"Telegram!",
	"he said.",
	"Wonderful inspiration!",
	"Telegram!",
	"A papal bull!",
	"Signed: Dedalus.",
	"Where did you launch it from?",
	"The kips?",
	"No.",
	"College Green.",
	"Have you drunk the four quid?",
	"The aunt is going to call on your unsubstantial father.",
	"Telegram!",
	"Malachi Mulligan, The Ship, lower Abbey street.",
	"O, you peerless mummer!",
	"O, you priestified Kinchite!",
	"‘Twas murmur we did for a gallus potion would rouse a friar, I’m thinking, and he limp with leching.",
	"And we one hour and two hours and three hours in Connery’s sitting civil waiting for pints apiece.",
	"Stephen laughed.",
	"Quickly, warningfully Buck Mulligan bent down.",
	"The tramper Synge is looking for you, he said, to murder you.",
	"He heard you pissed on his halldoor in Glasthule.",
	"He’s out in pampooties to murder you.",
	"Me!",
	"Stephen exclaimed.",
	"That was your contribution to literature.",
	"Buck Mulligan gleefully bent back, laughing to the dark eavesdropping ceiling.",
	"Murder you!",
	"he laughed.",
	"Harsh gargoyle face that warred against me over our mess of hash of lights in rue Saint-André-des-Arts.",
	"In words of words for words, palabras.",
	"Oisin with Patrick.",
	"Faunman he met in Clamart woods, brandishing a winebottle.",
	"C’est vendredi saint!",
	"Murthering Irish.",
	"His image, wandering, he met.",
	"I mine.",
	"I met a fool i’the forest.",
	"Mr Lyster, an attendant said from the door ajar.",
	"... in which everyone can find his own.",
	"So Mr Justice Madden in his Diary of Master William Silence has found the hunting terms...",
	"Yes?",
	"What is it?",
	"There’s a gentleman here, sir, the attendant said, coming forward and offering a card.",
	"From the Freeman.",
	"He wants to see the files of the Kilkenny People for last year.",
	"Certainly, certainly, certainly.",
	"Is the gentleman?...",
	"He took the eager card, glanced, not saw, laid down unglanced, looked, asked, creaked, asked: Is he?...",
	"O, there!",
	"Brisk in a galliard he was off, out.",
	"This gentleman?",
	"Freeman’s Journal?",
	"Kilkenny People?",
	"To be sure.",
	"Good day, sir.",
	"Kilkenny... We have certainly... A patient silhouette waited, listening.",
	"All the leading provincial... Northern Whig, Cork Examiner, Enniscorthy Guardian, 1903... Will you please?...",
	"Evans, conduct this gentleman...",
	"If you just follow the atten... Or, please allow me...",
	"This way...",
	"The door closed.",
	"The sheeny!",
	"Buck Mulligan cried.",
	"He jumped up and snatched the card.",
	"What’s his name?",
	"Ikey Moses?",
	"Bloom.",
	"He rattled on: Jehovah, collector of prepuces, is no more.",
	"I found him over in the museum where I went to hail the foamborn Aphrodite.",
	"The Greek mouth that has never been twisted in prayer.",
	"Every day we must do homage to her.",
	"Life of life, thy lips enkindle.",
	"Suddenly he turned to Stephen: He knows you.",
	"He knows your old fellow.",
	"O, I fear me, he is Greeker than the Greeks.",
	"His pale Galilean eyes were upon her mesial groove.",
	"Venus Kallipyge.",
	"O, the thunder of those loins!",
	"The god pursuing the maiden hid.",
	"We want to hear more, John Eglinton decided with Mr Best’s approval.",
	"His life was rich.",
	"His art, more than the art of feudalism as Walt Whitman called it, is the art of surfeit.",
	"Hot herringpies, green mugs of sack, honeysauces, sugar of roses, marchpane, gooseberried pigeons, ringocandies.",
	"The gombeenwoman Eliza Tudor had underlinen enough to vie with her of Sheba.",
	"Twenty years he dallied there between conjugial love and its chaste delights and scortatory love and its foul pleasures.",
	"Cours la Reine.",
	"Encore vingt sous.",
	"Nous ferons de petites cochonneries.",
	"Minette?",
	"Tu veux?",
	"The height of fine society.",
	"And sir William Davenant of Oxford’s mother with her cup of canary for any cockcanary.",
	"Buck Mulligan, his pious eyes upturned, prayed: Blessed Margaret Mary Anycock!",
	"And Harry of six wives’ daughter.",
	"And other lady friends from neighbour seats as Lawn Tennyson, gentleman poet, sings.",
	"But all those twenty years what do you suppose poor Penelope in Stratford was doing behind the diamond panes?",
	"Do and do.",
	"Thing done.",
	"In a rosery of Fetter lane of Gerard, herbalist, he walks, greyedauburn.",
	"An azured harebell like her veins.",
	"Lids of Juno’s eyes, violets.",
	"He walks.",
	"One life is all.",
	"One body.",
	"Do.",
	"But do.",
	"Afar, in a reek of lust and squalor, hands are laid on whiteness.",
	"Buck Mulligan rapped John Eglinton’s desk sharply.",
	"Whom do you suspect?",
	"he challenged.",
	"Say that he is the spurned lover in the sonnets.",
	"Once spurned twice spurned.",
	"But the court wanton spurned him for a lord, his dearmylove.",
	"Love that dare not speak its name.",
	"As an Englishman, you mean, John sturdy Eglinton put in, he loved a lord.",
	"Old wall where sudden lizards flash.",
	"At Charenton I watched them.",
	"Maybe, like Socrates, he had a midwife to mother as he had a shrew to wife.",
	"But she, the giglot wanton, did not break a bedvow.",
	"Sweet Ann, I take it, was hot in the blood.",
	"Once a wooer, twice a wooer.",
	"Stephen turned boldly in his chair.",
	"The burden of proof is with you not with me, he said frowning.",
	"O, yes, mention there is.",
	"Explain you then.",
	"Explain the swansong too wherein he has commended her to posterity.",
	"He faced their silence.",
	"To whom thus Eglinton: You mean the will.",
	"But that has been explained, I believe, by jurists.",
	"She was entitled to her widow’s dower At common law.",
	"His legal knowledge was great Our judges tell us.",
	"And therefore when he was urged, As I believe, to name her He left her his Secondbest Bed.",
	"Punkt.",
	"Leftherhis Secondbest Leftherhis Bestabed Secabest Leftabed.",
	"Woa!",
	"It is clear that there were two beds, a best and a secondbest, Mr Secondbest Best said finely.",
	"Separatio a mensa et a thalamo, bettered Buck Mulligan and was smiled on.",
	"Antiquity mentions famous beds, Second Eglinton puckered, bedsmiling.",
	"Let me think.",
	"Do you mean he died so?",
	"Mr Best asked with slight concern.",
	"I mean... —He died dead drunk, Buck Mulligan capped.",
	"A quart of ale is a dish for a king.",
	"O, I must tell you what Dowden said!",
	"What?",
	"asked Besteglinton.",
	"William Shakespeare and company, limited.",
	"The people’s William.",
	"For terms apply: E. Dowden, Highfield house... —Lovely!",
	"Buck Mulligan suspired amorously.",
	"I asked him what he thought of the charge of pederasty brought against the bard.",
	"He lifted his hands and said: All we can say is that life ran very high in those days.",
	"Lovely!",
	"Catamite.",
	"The sense of beauty leads us astray, said beautifulinsadness Best to ugling Eglinton.",
	"Steadfast John replied severe: The doctor can tell us what those words mean.",
	"You cannot eat your cake and have it.",
	"Sayest thou so?",
	"Will they wrest from us, from me, the palm of beauty?",
	"And the sense of property, Stephen said.",
	"He drew Shylock out of his own long pocket.",
	"His borrowers are no doubt those divers of worship mentioned by Chettle Falstaff who reported his uprightness of dealing.",
	"How else could Aubrey’s ostler and callboy get rich quick?",
	"All events brought grist to his mill.",
	"The lost armada is his jeer in Love’s Labour Lost.",
	"His pageants, the histories, sail fullbellied on a tide of Mafeking enthusiasm.",
	"Warwickshire jesuits are tried and we have a porter’s theory of equivocation.",
	"The sugared sonnets follow Sidney’s.",
	"I think you’re getting on very nicely.",
	"Just mix up a mixture of theolologicophilolological.",
	"Mingo, minxi, mictum, mingere.",
	"Prove that he was a jew, John Eglinton dared, expectantly.",
	"Your dean of studies holds he was a holy Roman.",
	"Sufflaminandus sum.",
	"He was made in Germany, Stephen replied, as the champion French polisher of Italian scandals.",
	"A myriadminded man, Mr Best reminded.",
	"Coleridge called him myriadminded.",
	"Amplius.",
	"In societate humana hoc est maxime necessarium ut sit amicitia inter multos.",
	"Saint Thomas, Stephen began... —Ora pro nobis, Monk Mulligan groaned, sinking to a chair.",
	"There he keened a wailing rune.",
	"Pogue mahone!",
	"Acushla machree!",
	"It’s destroyed we are from this day!",
	"It’s destroyed we are surely!",
	"All smiled their smiles.",
	"Jews, whom christians tax with avarice, are of all races the most given to intermarriage.",
	"Accusations are made in anger.",
	"Whether these be sins or virtues old Nobodaddy will tell us at doomsday leet.",
	"Or his jennyass, Buck Mulligan antiphoned.",
	"Gentle Will is being roughly handled, gentle Mr Best said gently.",
	"Which will?",
	"gagged sweetly Buck Mulligan.",
	"We are getting mixed.",
	"The will to live, John Eglinton philosophised, for poor Ann, Will’s widow, is the will to die.",
	"Requiescat!",
	"Stephen prayed.",
	"What of all the will to do?",
	"Venus has twisted her lips in prayer.",
	"Agenbite of inwit: remorse of conscience.",
	"It is an age of exhausted whoredom groping for its god.",
	"History shows that to be true, inquit Eglintonus Chronolologos.",
	"The ages succeed one another.",
	"I feel that Russell is right.",
	"What do we care for his wife or father?",
	"I should say that only family poets have family lives.",
	"Falstaff was not a family man.",
	"I feel that the fat knight is his supreme creation.",
	"Lean, he lay back.",
	"Shy, deny thy kindred, the unco guid.",
	"Shy, supping with the godless, he sneaks the cup.",
	"A sire in Ultonian Antrim bade it him.",
	"Visits him here on quarter days.",
	"Mr Magee, sir, there’s a gentleman to see you.",
	"Me?",
	"Says he’s your father, sir.",
	"Give me my Wordsworth.",
	"Your own?",
	"He knows your old fellow.",
	"The widower.",
	"Hurrying to her squalid deathlair from gay Paris on the quayside I touched his hand.",
	"The voice, new warmth, speaking.",
	"Dr Bob Kenny is attending her.",
	"The eyes that wish me well.",
	"But do not know me.",
	"A father, Stephen said, battling against hopelessness, is a necessary evil.",
	"He wrote the play in the months that followed his father’s death.",
	"No.",
	"The corpse of John Shakespeare does not walk the night.",
	"From hour to hour it rots and rots.",
	"He rests, disarmed of fatherhood, having devised that mystical estate upon his son.",
	"Boccaccio’s Calandrino was the first and last man who felt himself with child.",
	"Fatherhood, in the sense of conscious begetting, is unknown to man.",
	"It is a mystical estate, an apostolic succession, from only begetter to only begotten.",
	"Upon incertitude, upon unlikelihood.",
	"Amor matris, subjective and objective genitive, may be the only true thing in life.",
	"Paternity may be a legal fiction.",
	"Who is the father of any son that any son should love him or he any son?",
	"What the hell are you driving at?",
	"I know.",
	"Shut up.",
	"Blast you.",
	"I have reasons.",
	"Amplius.",
	"Adhuc.",
	"Iterum.",
	"Postea.",
	"Are you condemned to do this?",
	"The son unborn mars beauty: born, he brings pain, divides affection, increases care.",
	"In rue Monsieur-le-Prince I thought it.",
	"What links them in nature?",
	"An instant of blind rut.",
	"Am I a father?",
	"If I were?",
	"Shrunken uncertain hand.",
	"The bulldog of Aquin, with whom no word shall be impossible, refutes him.",
	"Eglintoneyes, quick with pleasure, looked up shybrightly.",
	"Gladly glancing, a merry puritan, through the twisted eglantine.",
	"Flatter.",
	"Rarely.",
	"But flatter.",
	"Himself his own father, Sonmulligan told himself.",
	"Wait.",
	"I am big with child.",
	"I have an unborn child in my brain.",
	"Pallas Athena!",
	"A play!",
	"The play’s the thing!",
	"Let me parturiate!",
	"He clasped his paunchbrow with both birthaiding hands.",
	"As for his family, Stephen said, his mother’s name lives in the forest of Arden.",
	"Her death brought from him the scene with Volumnia in Coriolanus.",
	"His boyson’s death is the deathscene of young Arthur in King John.",
	"Hamlet, the black prince, is Hamnet Shakespeare.",
	"Who the girls in The Tempest, in Pericles, in Winter’s Tale are we know.",
	"Who Cleopatra, fleshpot of Egypt, and Cressid and Venus are we may guess.",
	"But there is another member of his family who is recorded.",
	"The plot thickens, John Eglinton said.",
	"The quaker librarian, quaking, tiptoed in, quake, his mask, quake, with haste, quake, quack.",
	"Door closed.",
	"Cell.",
	"Day.",
	"They list.",
	"Three.",
	"They.",
	"I you he they.",
	"Come, mess.",
	"STEPHEN: He had three brothers, Gilbert, Edmund, Richard.",
	"The playhouse sausage filled Gilbert’s soul.",
	"He is nowhere: but an Edmund and a Richard are recorded in the works of sweet William.",
	"MAGEEGLINJOHN: Names!",
	"What’s in a name?",
	"BEST: That is my name, Richard, don’t you know.",
	"I hope you are going to say a good word for Richard, don’t you know, for my sake.",
	"Nay, that last play was written or being written while his brother Edmund lay dying in Southwark.",
	"BEST: I hope Edmund is going to catch it.",
	"He has revealed it in the sonnets where there is Will in overplus.",
	"What’s in a name?",
	"That is what we ask ourselves in childhood when we write the name that we are told is ours.",
	"A star, a daystar, a firedrake, rose at his birth.",
	"Both satisfied.",
	"I too.",
	"Don’t tell them he was nine years old when it was quenched.",
	"And from her arms.",
	"Wait to be wooed and won.",
	"Ay, meacock.",
	"Who will woo you?",
	"Read the skies.",
	"Autontimorumenos.",
	"Bous Stephanoumenos.",
	"Where’s your configuration?",
	"Stephen, Stephen, cut the bread even.",
	"S. D: sua donna.",
	"Già: di lui.",
	"Gelindo risolve di non amare S. D. —What is that, Mr Dedalus?",
	"the quaker librarian asked.",
	"Was it a celestial phenomenon?",
	"A star by night, Stephen said.",
	"A pillar of the cloud by day.",
	"What more’s to speak?",
	"Stephen looked on his hat, his stick, his boots.",
	"Stephanos, my crown.",
	"My sword.",
	"His boots are spoiling the shape of my feet.",
	"Buy a pair.",
	"Holes in my socks.",
	"Handkerchief too.",
	"You make good use of the name, John Eglinton allowed.",
	"Your own name is strange enough.",
	"I suppose it explains your fantastical humour.",
	"Me, Magee and Mulligan.",
	"Fabulous artificer.",
	"The hawklike man.",
	"You flew.",
	"Whereto?",
	"Newhaven-Dieppe, steerage passenger.",
	"Paris and back.",
	"Lapwing.",
	"Icarus.",
	"Pater, ait.",
	"Seabedabbled, fallen, weltering.",
	"Lapwing you are.",
	"Lapwing be.",
	"Just what you say.",
	"The three brothers Shakespeare.",
	"In Grimm too, don’t you know, the fairytales.",
	"The third brother that always marries the sleeping beauty and wins the best prize.",
	"Best of Best brothers.",
	"Good, better, best.",
	"The quaker librarian springhalted near.",
	"I should like to know, he said, which brother you...",
	"I understand you to suggest there was misconduct with one of the brothers...",
	"But perhaps I am anticipating?",
	"He caught himself in the act: looked at all: refrained.",
	"An attendant from the doorway called: Mr Lyster!",
	"Father Dineen wants... —O, Father Dineen!",
	"Directly.",
	"Swiftly rectly creaking rectly rectly he was rectly gone.",
	"John Eglinton touched the foil.",
	"Come, he said.",
	"Let us hear what you have to say of Richard and Edmund.",
	"You kept them for the last, didn’t you?",
	"A brother is as easily forgotten as an umbrella.",
	"Lapwing.",
	"Where is your brother?",
	"Apothecaries’ hall.",
	"My whetstone.",
	"Him, then Cranly, Mulligan: now these.",
	"Speech, speech.",
	"But act.",
	"Act speech.",
	"They mock to try you.",
	"Act.",
	"Be acted on.",
	"Lapwing.",
	"I am tired of my voice, the voice of Esau.",
	"My kingdom for a drink.",
	"On.",
	"You will say those names were already in the chronicles from which he took the stuff of his plays.",
	"Why did he take them rather than others?",
	"Richard, a whoreson crookback, misbegotten, makes love to a widowed Ann (what’s in a name?",
	"), woos and wins her, a whoreson merry widow.",
	"Richard the conqueror, third brother, came after William the conquered.",
	"The other four acts of that play hang limply from that first.",
	"Of all his kings Richard is the only king unshielded by Shakespeare’s reverence, the angel of the world.",
	"That was Will’s way, John Eglinton defended.",
	"We should not now combine a Norse saga with an excerpt from a novel by George Meredith.",
	"Que voulez-vous?",
	"Moore would say.",
	"He puts Bohemia on the seacoast and makes Ulysses quote Aristotle.",
	"Why?",
	"Stephen answered himself.",
	"It doubles itself in the middle of his life, reflects itself in another, repeats itself, protasis, epitasis, catastasis, catastrophe.",
	"The words are those of my lords bishops of Maynooth.",
	"An original sin and, like original sin, committed by another in whose sin he too has sinned.",
	"Age has not withered it.",
	"Beauty and peace have not done it away.",
	"He laughed to free his mind from his mind’s bondage.",
	"Judge Eglinton summed up.",
	"The truth is midway, he affirmed.",
	"He is the ghost and the prince.",
	"He is all in all.",
	"He is, Stephen said.",
	"The boy of act one is the mature man of act five.",
	"All in all.",
	"In Cymbeline, in Othello he is bawd and cuckold.",
	"He acts and is acted on.",
	"Lover of an ideal or a perversion, like José he kills the real Carmen.",
	"His unremitting intellect is the hornmad Iago ceaselessly willing that the moor in him shall suffer.",
	"Cuckoo!",
	"Cuckoo!",
	"Cuck Mulligan clucked lewdly.",
	"O word of fear!",
	"Dark dome received, reverbed.",
	"And what a character is Iago!",
	"undaunted John Eglinton exclaimed.",
	"When all is said Dumas fils (or is it Dumas père?)",
	"is right.",
	"After God Shakespeare has created most.",
	"Man delights him not nor woman neither, Stephen said.",
	"Then dies.",
	"The motion is ended.",
	"Gravediggers bury Hamlet père and Hamlet fils.",
	"A king and a prince at last in death, with incidental music.",
	"Strong curtain.",
	"He found in the world without as actual what was in his world within as possible.",
	"Maeterlinck says: If Socrates leave his house today he will find the sage seated on his doorstep.",
	"If Judas go forth tonight it is to Judas his steps will tend.",
	"Every life is many days, day after day.",
	"We walk through ourselves, meeting robbers, ghosts, giants, old men, young men, wives, widows, brothers-in-love, but always meeting ourselves.",
	"Eureka!",
	"Buck Mulligan cried.",
	"Eureka!",
	"Suddenly happied he jumped up and reached in a stride John Eglinton’s desk.",
	"May I?",
	"he said.",
	"The Lord has spoken to Malachi.",
	"He began to scribble on a slip of paper.",
	"Take some slips from the counter going out.",
	"Those who are married, Mr Best, douce herald, said, all save one, shall live.",
	"The rest shall keep as they are.",
	"He laughed, unmarried, at Eglinton Johannes, of arts a bachelor.",
	"Unwed, unfancied, ware of wiles, they fingerponder nightly each his variorum edition of The Taming of the Shrew.",
	"You are a delusion, said roundly John Eglinton to Stephen.",
	"You have brought us all this way to show us a French triangle.",
	"Do you believe your own theory?",
	"No, Stephen said promptly.",
	"Are you going to write it?",
	"Mr Best asked.",
	"You ought to make it a dialogue, don’t you know, like the Platonic dialogues Wilde wrote.",
	"John Eclecticon doubly smiled.",
	"Dowden believes there is some mystery in Hamlet but will say no more.",
	"It will come as a surprise to his grace.",
	"But he believes his theory.",
	"I believe, O Lord, help my unbelief.",
	"That is, help me to believe or help me to unbelieve?",
	"Who helps to believe?",
	"Egomen.",
	"Who to unbelieve?",
	"Other chap.",
	"You are the only contributor to Dana who asks for pieces of silver.",
	"Then I don’t know about the next number.",
	"Fred Ryan wants space for an article on economics.",
	"Fraidrine.",
	"Two pieces of silver he lent me.",
	"Tide you over.",
	"Economics.",
	"For a guinea, Stephen said, you can publish this interview.",
	"He broke away.",
	"Come, Kinch.",
	"Come, wandering Ængus of the birds.",
	"Come, Kinch.",
	"You have eaten all we left.",
	"Ay.",
	"I will serve you your orts and offals.",
	"Stephen rose.",
	"Life is many days.",
	"This will end.",
	"We shall see you tonight, John Eglinton said.",
	"Notre ami Moore says Malachi Mulligan must be there.",
	"Buck Mulligan flaunted his slip and panama.",
	"Monsieur Moore, he said, lecturer on French letters to the youth of Ireland.",
	"I’ll be there.",
	"Come, Kinch, the bards must drink.",
	"Can you walk straight?",
	"Laughing, he... Swill till eleven.",
	"Irish nights entertainment.",
	"Lubber... Stephen followed a lubber... One day in the national library we had a discussion.",
	"Shakes.",
	"After.",
	"His lub back: I followed.",
	"I gall his kibe.",
	"What have I learned?",
	"Of them?",
	"Of me?",
	"Walk like Haines now.",
	"The constant readers’ room.",
	"In the readers’ book Cashel Boyle O’Connor Fitzmaurice Tisdall Farrell parafes his polysyllables.",
	"Item: was Hamlet mad?",
	"The quaker’s pate godlily with a priesteen in booktalk.",
	"O please do, sir...",
	"I shall be most pleased...",
	"Amused Buck Mulligan mused in pleasant murmur with himself, selfnodding: A pleased bottom.",
	"The turnstile.",
	"Is that?...",
	"Blueribboned hat... Idly writing... What?",
	"Looked?...",
	"The curving balustrade: smoothsliding Mincius.",
	"He spluttered to the air: O, the chinless Chinaman!",
	"Chin Chon Eg Lin Ton.",
	"We went over to their playbox, Haines and I, the plumbers’ hall.",
	"Our players are creating a new art for Europe like the Greeks or M. Maeterlinck.",
	"Abbey Theatre!",
	"I smell the pubic sweat of monks.",
	"He spat blank.",
	"Forgot: any more than he forgot the whipping lousy Lucy gave him.",
	"And left the femme de trente ans.",
	"And why no other children born?",
	"And his first child a girl?",
	"Afterwit.",
	"Go back.",
	"Eh...",
	"I just eh... wanted...",
	"Being afraid to marry on earth They masturbated for all they were worth.",
	"Jest on.",
	"Know thyself.",
	"Halted, below me, a quizzer looks at me.",
	"I halt.",
	"Mournful mummer, Buck Mulligan moaned.",
	"Synge has left off wearing black to be like nature.",
	"Only crows, priests and English coal are black.",
	"A laugh tripped over his lips.",
	"Longworth is awfully sick, he said, after what you wrote about that old hake Gregory.",
	"O you inquisitional drunken jewjesuit!",
	"She gets you a job on the paper and then you go and slate her drivel to Jaysus.",
	"Couldn’t you do the Yeats touch?",
	"One thinks of Homer.",
	"He stopped at the stairfoot.",
	"I have conceived a play for the mummers, he said solemnly.",
	"The pillared Moorish hall, shadows entwined.",
	"Gone the nine men’s morrice with caps of indices.",
	"He turned a happy patch’s smirk to Stephen, saying: The disguise, I fear, is thin.",
	"But listen.",
	"The most innocent son of Erin, Stephen said, for whom they ever lifted them.",
	"About to pass through the doorway, feeling one behind, he stood aside.",
	"Part.",
	"The moment is now.",
	"Where then?",
	"If Socrates leave his house today, if Judas go forth tonight.",
	"Why?",
	"That lies in space which I in time must come to, ineluctably.",
	"My will: his will that fronts me.",
	"Seas between.",
	"A man passed out between them, bowing, greeting.",
	"Good day again, Buck Mulligan said.",
	"The portico.",
	"Here I watched the birds for augury.",
	"Ængus of the birds.",
	"They go, they come.",
	"Last night I flew.",
	"Easily flew.",
	"Men wondered.",
	"Street of harlots after.",
	"A creamfruit melon he held to me.",
	"In.",
	"You will see.",
	"The wandering jew, Buck Mulligan whispered with clown’s awe.",
	"Did you see his eye?",
	"He looked upon you to lust after you.",
	"I fear thee, ancient mariner.",
	"O, Kinch, thou art in peril.",
	"Get thee a breechpad.",
	"Manner of Oxenford.",
	"Day.",
	"Wheelbarrow sun over arch of bridge.",
	"A dark back went before them, step of a pard, down, out by the gateway, under portcullis barbs.",
	"They followed.",
	"Offend me still.",
	"Speak on.",
	"Kind air defined the coigns of houses in Kildare street.",
	"No birds.",
	"Frail from the housetops two plumes of smoke ascended, pluming, and in a flaw of softness softly were blown.",
	"Cease to strive.",
	"Peace of the druid priests of Cymbeline: hierophantic: from wide earth an altar.",
	"Laud we the gods And let our crooked smokes climb to their nostrils From our bless’d altars.",
	"Five to three.",
	"Just nice time to walk to Artane.",
	"What was that boy’s name again?",
	"Dignam.",
	"Yes.",
	"Vere dignum et iustum est.",
	"Brother Swan was the person to see.",
	"Mr Cunningham’s letter.",
	"Yes.",
	"Oblige him, if possible.",
	"Good practical catholic: useful at mission time.",
	"A onelegged sailor, swinging himself onward by lazy jerks of his crutches, growled some notes.",
	"Father Conmee blessed him in the sun for his purse held, he knew, one silver crown.",
	"Father Conmee crossed to Mountjoy square.",
	"He walked by the treeshade of sunnywinking leaves: and towards him came the wife of Mr David Sheehy M.P.",
	"Very well, indeed, father.",
	"And you, father?",
	"Father Conmee was wonderfully well indeed.",
	"He would go to Buxton probably for the waters.",
	"And her boys, were they getting on well at Belvedere?",
	"Was that so?",
	"Father Conmee was very glad indeed to hear that.",
	"And Mr Sheehy himself?",
	"Still in London.",
	"The house was still sitting, to be sure it was.",
	"Beautiful weather it was, delightful indeed.",
	"Yes, it was very probable that Father Bernard Vaughan would come again to preach.",
	"O, yes: a very great success.",
	"A wonderful man really.",
	"Father Conmee was very glad to see the wife of Mr David Sheehy M.P.",
	"Iooking so well and he begged to be remembered to Mr David Sheehy M.P.",
	"Yes, he would certainly call.",
	"Good afternoon, Mrs Sheehy.",
	"And smiled yet again, in going.",
	"He had cleaned his teeth, he knew, with arecanut paste.",
	"Father Conmee walked and, walking, smiled for he thought on Father Bernard Vaughan’s droll eyes and cockney voice.",
	"Pilate!",
	"Wy don’t you old back that owlin mob?",
	"A zealous man, however.",
	"Really he was.",
	"And really did great good in his way.",
	"Beyond a doubt.",
	"He loved Ireland, he said, and he loved the Irish.",
	"Of good family too would one think it?",
	"Welsh, were they not?",
	"O, lest he forget.",
	"That letter to father provincial.",
	"Father Conmee stopped three little schoolboys at the corner of Mountjoy square.",
	"Yes: they were from Belvedere.",
	"The little house.",
	"Aha.",
	"And were they good boys at school?",
	"O.",
	"That was very good now.",
	"And what was his name?",
	"Jack Sohan.",
	"And his name?",
	"Ger.",
	"Gallaher.",
	"And the other little man?",
	"His name was Brunny Lynam.",
	"O, that was a very nice name to have.",
	"But mind you don’t post yourself into the box, little man, he said.",
	"The boys sixeyed Father Conmee and laughed: O, sir.",
	"Well, let me see if you can post a letter, Father Conmee said.",
	"Father Conmee smiled and nodded and smiled and walked along Mountjoy square east.",
	"Was that not Mrs M’Guinness?",
	"Mrs M’Guinness, stately, silverhaired, bowed to Father Conmee from the farther footpath along which she sailed.",
	"And Father Conmee smiled and saluted.",
	"How did she do?",
	"A fine carriage she had.",
	"Like Mary, queen of Scots, something.",
	"And to think that she was a pawnbroker!",
	"Well, now!",
	"Such a... what should he say?...",
	"such a queenly mien.",
	"Father Conmee walked down Great Charles street and glanced at the shutup free church on his left.",
	"The reverend T. R. Greene B.A.",
	"will (D.V.)",
	"speak.",
	"The incumbent they called him.",
	"He felt it incumbent on him to say a few words.",
	"But one should be charitable.",
	"Invincible ignorance.",
	"They acted according to their lights.",
	"Father Conmee turned the corner and walked along the North Circular road.",
	"It was a wonder that there was not a tramline in such an important thoroughfare.",
	"Surely, there ought to be.",
	"A band of satchelled schoolboys crossed from Richmond street.",
	"All raised untidy caps.",
	"Father Conmee greeted them more than once benignly.",
	"Christian brother boys.",
	"Father Conmee smelt incense on his right hand as he walked.",
	"Saint Joseph’s church, Portland row.",
	"For aged and virtuous females.",
	"Father Conmee raised his hat to the Blessed Sacrament.",
	"Virtuous: but occasionally they were also badtempered.",
	"Near Aldborough house Father Conmee thought of that spendthrift nobleman.",
	"And now it was an office or something.",
	"Father Conmee saluted Mr William Gallagher and perceived the odours that came from baconflitches and ample cools of butter.",
	"He passed Grogan’s the Tobacconist against which newsboards leaned and told of a dreadful catastrophe in New York.",
	"In America those things were continually happening.",
	"Unfortunate people to die like that, unprepared.",
	"Still, an act of perfect contrition.",
	"Father Conmee went by Daniel Bergin’s publichouse against the window of which two unlabouring men lounged.",
	"They saluted him and were saluted.",
	"A constable on his beat saluted Father Conmee and Father Conmee saluted the constable.",
	"In Youkstetter’s, the porkbutcher’s, Father Conmee observed pig’s puddings, white and black and red, lie neatly curled in tubes.",
	"Father Conmee liked cheerful decorum.",
	"It was a peaceful day.",
	"The gentleman with the glasses opposite Father Conmee had finished explaining and looked down.",
	"His wife, Father Conmee supposed.",
	"A tiny yawn opened the mouth of the wife of the gentleman with the glasses.",
	"Father Conmee perceived her perfume in the car.",
	"The conductor pulled the bellstrap to stay the car for her.",
	"But they had so many worries in life, so many cares, poor creatures.",
	"From the hoardings Mr Eugene Stratton grimaced with thick niggerlips at Father Conmee.",
	"That book by the Belgian jesuit, Le Nombre des Élus, seemed to Father Conmee a reasonable plea.",
	"been brought.",
	"But they were God’s souls, created by God.",
	"It seemed to Father Conmee a pity that they should all be lost, a waste, if one might say.",
	"At the Howth road stop Father Conmee alighted, was saluted by the conductor and saluted in his turn.",
	"The Malahide road was quiet.",
	"It pleased Father Conmee, road and name.",
	"The joybells were ringing in gay Malahide.",
	"Lord Talbot de Malahide, immediate hereditary lord admiral of Malahide and the seas adjoining.",
	"Then came the call to arms and she was maid, wife and widow in one day.",
	"Those were old worldish days, loyal times in joyous townlands, old times in the barony.",
	"Who could know the truth?",
	"She would half confess if she had not all sinned as women did.",
	"Only God knew and she and he, her husband’s brother.",
	"Don John Conmee walked and moved in times of yore.",
	"He was humane and honoured there.",
	"And the hands of a bride and of a bridegroom, noble to noble, were impalmed by Don John Conmee.",
	"It was a charming day.",
	"The lychgate of a field showed Father Conmee breadths of cabbages, curtseying to him with ample underleaves.",
	"The sky showed him a flock of small white clouds going slowly down the wind.",
	"Moutonner, the French said.",
	"A just and homely word.",
	"Father Conmee, reading his office, watched a flock of muttoning clouds over Rathcoffey.",
	"His thinsocked ankles were tickled by the stubble of Clongowes field.",
	"He was their rector: his reign was mild.",
	"Father Conmee drew off his gloves and took his rededged breviary out.",
	"An ivory bookmark told him the page.",
	"Nones.",
	"He should have read that before lunch.",
	"But lady Maxwell had come.",
	"Father Conmee read in secret Pater and Ave and crossed his breast.",
	"Deus in adiutorium.",
	"Father Conmee blessed both gravely and turned a thin page of his breviary.",
	"Sin: Principes persecuti sunt me gratis: et a verbis tuis formidavit cor meum.",
	"He pulled himself erect, went to it and, spinning it on its axle, viewed its shape and brass furnishings.",
	"Chewing his blade of hay he laid the coffinlid by and came to the doorway.",
	"There he tilted his hatbrim to give shade to his eyes and leaned against the doorcase, looking idly out.",
	"Father John Conmee stepped into the Dollymount tram on Newcomen bridge.",
	"Corny Kelleher locked his largefooted boots and gazed, his hat downtilted, chewing his blade of hay.",
	"Constable 57C, on his beat, stood to pass the time of day.",
	"That’s a fine day, Mr Kelleher.",
	"Ay, Corny Kelleher said.",
	"It’s very close, the constable said.",
	"What’s the best news?",
	"he asked.",
	"I seen that particular party last evening, the constable said with bated breath.",
	"A onelegged sailor crutched himself round MacConnell’s corner, skirting Rabaiotti’s icecream car, and jerked himself up Eccles street.",
	"Towards Larry O’Rourke, in shirtsleeves in his doorway, he growled unamiably: For England...",
	"He swung himself violently forward past Katey and Boody Dedalus, halted and growled: home and beauty.",
	"J. J. O’Molloy’s white careworn face was told that Mr Lambert was in the warehouse with a visitor.",
	"The sailor grumbled thanks, glanced sourly at the unheeding windows, sank his head and swung himself forward four strides.",
	"The gay sweet chirping whistling within went on a bar or two, ceased.",
	"The blind of the window was drawn aside.",
	"A card Unfurnished Apartments slipped from the sash and fell.",
	"A plump bare generous arm shone, was seen, held forth from a white petticoatbodice and taut shiftstraps.",
	"A woman’s hand flung forth a coin over the area railings.",
	"It fell on the path.",
	"Katey and Boody Dedalus shoved in the door of the closesteaming kitchen.",
	"Did you put in the books?",
	"Boody asked.",
	"They wouldn’t give anything on them, she said.",
	"Father Conmee walked through Clongowes fields, his thinsocked ankles tickled by stubble.",
	"Where did you try?",
	"Boody asked.",
	"M’Guinness’s.",
	"Boody stamped her foot and threw her satchel on the table.",
	"Bad cess to her big face!",
	"she cried.",
	"Katey went to the range and peered with squinting eyes.",
	"What’s in the pot?",
	"she asked.",
	"Shirts, Maggy said.",
	"Boody cried angrily: Crickey, is there nothing for us to eat?",
	"Katey, lifting the kettlelid in a pad of her stained skirt, asked: And what’s in this?",
	"A heavy fume gushed in answer.",
	"Peasoup, Maggy said.",
	"Where did you get it?",
	"Katey asked.",
	"Sister Mary Patrick, Maggy said.",
	"The lacquey rang his bell.",
	"Barang!",
	"Boody sat down at the table and said hungrily: Give us it here.",
	"Maggy poured yellow thick soup from the kettle into a bowl.",
	"Where’s Dilly?",
	"Gone to meet father, Maggy said.",
	"Boody, breaking big chunks of bread into the yellow soup, added: Our father who art not in heaven.",
	"Maggy, pouring yellow soup in Katey’s bowl, exclaimed: Boody!",
	"For shame!",
	"The blond girl in Thornton’s bedded the wicker basket with rustling fibre.",
	"Blazes Boylan handed her the bottle swathed in pink tissue paper and a small jar.",
	"Put these in first, will you?",
	"he said.",
	"Yes, sir, the blond girl said.",
	"And the fruit on top.",
	"That’ll do, game ball, Blazes Boylan said.",
	"She bestowed fat pears neatly, head by tail, and among them ripe shamefaced peaches.",
	"H. E. L. Y.‘S filed before him, tallwhitehatted, past Tangier lane, plodding towards their goal.",
	"Can you send them by tram?",
	"Now?",
	"A darkbacked figure under Merchants’ arch scanned books on the hawker’s cart.",
	"Certainly, sir.",
	"Is it in the city?",
	"O, yes, Blazes Boylan said.",
	"Ten minutes.",
	"The blond girl handed him a docket and pencil.",
	"Will you write the address, sir?",
	"Blazes Boylan at the counter wrote and pushed the docket to her.",
	"Send it at once, will you?",
	"he said.",
	"It’s for an invalid.",
	"Yes, sir.",
	"I will, sir.",
	"Blazes Boylan rattled merry money in his trousers’ pocket.",
	"What’s the damage?",
	"he asked.",
	"The blond girl’s slim fingers reckoned the fruits.",
	"Blazes Boylan looked into the cut of her blouse.",
	"A young pullet.",
	"He took a red carnation from the tall stemglass.",
	"This for me?",
	"he asked gallantly.",
	"The blond girl glanced sideways at him, got up regardless, with his tie a bit crooked, blushing.",
	"Yes, sir, she said.",
	"Bending archly she reckoned again fat pears and blushing peaches.",
	"Blazes Boylan looked in her blouse with more favour, the stalk of the red flower between his smiling teeth.",
	"May I say a word to your telephone, missy?",
	"he asked roguishly.",
	"Ma!",
	"Almidano Artifoni said.",
	"He gazed over Stephen’s shoulder at Goldsmith’s knobby poll.",
	"Two carfuls of tourists passed slowly, their women sitting fore, gripping the handrests.",
	"Palefaces.",
	"Men’s arms frankly round their stunted forms.",
	"They looked from Trinity to the blind columned porch of the bank of Ireland where pigeons roocoocooed.",
	"Anch’io ho avuto di queste idee, Almidano Artifoni said, quand’ ero giovine come Lei.",
	"Eppoi mi sono convinto che il mondo è una bestia.",
	"È peccato.",
	"Perchè la sua voce... sarebbe un cespite di rendita, via.",
	"Invece, Lei si sacrifica.",
	"Sacrifizio incruento, Stephen said smiling, swaying his ashplant in slow swingswong from its midpoint, lightly.",
	"Speriamo, the round mustachioed face said pleasantly.",
	"Ma, dia retta a me.",
	"Ci rifletta.",
	"By the stern stone hand of Grattan, bidding halt, an Inchicore tram unloaded straggling Highland soldiers of a band.",
	"Ci rifletterò, Stephen said, glancing down the solid trouserleg.",
	"Ma, sul serio, eh?",
	"Almidano Artifoni said.",
	"His heavy hand took Stephen’s firmly.",
	"Human eyes.",
	"They gazed curiously an instant and turned quickly towards a Dalkey tram.",
	"Eccolo, Almidano Artifoni said in friendly haste.",
	"Venga a trovarmi e ci pensi.",
	"Addio, caro.",
	"Arrivederla, maestro, Stephen said, raising his hat when his hand was freed.",
	"E grazie.",
	"Di che?",
	"Almidano Artifoni said.",
	"Scusi, eh?",
	"Tante belle cose!",
	"Too much mystery business in it.",
	"Is he in love with that one, Marion?",
	"Change it and get another by Mary Cecil Haye.",
	"The disk shot down the groove, wobbled a while, ceased and ogled them: six.",
	"Miss Dunne clicked on the keyboard: 16 June 1904.",
	"Mustard hair and dauby cheeks.",
	"She’s not nicelooking, is she?",
	"The way she’s holding up her bit of a skirt.",
	"Wonder will that fellow be at the band tonight.",
	"If I could get that dressmaker to make a concertina skirt like Susy Nagle’s.",
	"They kick out grand.",
	"Shannon and all the boatclub swells never took his eyes off her.",
	"Hope to goodness he won’t keep me here till seven.",
	"The telephone rang rudely by her ear.",
	"Hello.",
	"Yes, sir.",
	"No, sir.",
	"Yes, sir.",
	"I’ll ring them up after five.",
	"Only those two, sir, for Belfast and Liverpool.",
	"All right, sir.",
	"Then I can go after six if you’re not back.",
	"A quarter after.",
	"Yes, sir.",
	"Twentyseven and six.",
	"I’ll tell him.",
	"Yes: one, seven, six.",
	"She scribbled three figures on an envelope.",
	"Mr Boylan!",
	"Hello!",
	"That gentleman from Sport was in looking for you.",
	"Mr Lenehan, yes.",
	"He said he’ll be in the Ormond at four.",
	"No, sir.",
	"Yes, sir.",
	"I’ll ring them up after five.",
	"Two pink faces turned in the flare of the tiny torch.",
	"Who’s that?",
	"Ned Lambert asked.",
	"Is that Crotty?",
	"Ringabella and Crosshaven, a voice replied groping for foothold.",
	"Hello, Jack, is that yourself?",
	"Ned Lambert said, raising in salute his pliant lath among the flickering arches.",
	"Come on.",
	"Mind your steps there.",
	"The vesta in the clergyman’s uplifted hand consumed itself in a long soft flame and was let fall.",
	"At their feet its red speck died: and mouldy air closed round them.",
	"How interesting!",
	"a refined accent said in the gloom.",
	"Yes, sir, Ned Lambert said heartily.",
	"This is the most historic spot in all Dublin.",
	"O’Madden Burke is going to write something about it one of these days.",
	"You were never here before, Jack, were you?",
	"No, Ned.",
	"He rode down through Dame walk, the refined accent said, if my memory serves me.",
	"The mansion of the Kildares was in Thomas court.",
	"That’s right, Ned Lambert said.",
	"That’s quite right, sir.",
	"Bring the camera whenever you like.",
	"I’ll get those bags cleared away from the windows.",
	"You can take it from here or from here.",
	"From a long face a beard and gaze hung on a chessboard.",
	"I’m deeply obliged, Mr Lambert, the clergyman said.",
	"I won’t trespass on your valuable time... —You’re welcome, sir, Ned Lambert said.",
	"Drop in whenever you like.",
	"Next week, say.",
	"Can you see?",
	"Yes, yes.",
	"Good afternoon, Mr Lambert.",
	"Very pleased to have met you.",
	"Pleasure is mine, sir, Ned Lambert answered.",
	"He followed his guest to the outlet and then whirled his lath away among the pillars.",
	"He stood to read the card in his hand.",
	"The reverend Hugh C. Love, Rathcoffey.",
	"Present address: Saint Michael’s, Sallins.",
	"Nice young chap he is.",
	"He’s writing a book about the Fitzgeralds he told me.",
	"He’s well up in history, faith.",
	"The young woman with slow care detached from her light skirt a clinging twig.",
	"I thought you were at a new gunpowder plot, J. J. O’Molloy said.",
	"Ned Lambert cracked his fingers in the air.",
	"God!",
	"he cried.",
	"I forgot to tell him that one about the earl of Kildare after he set fire to Cashel cathedral.",
	"You know that one?",
	"I’m bloody sorry I did it, says he, but I declare to God I thought the archbishop was inside.",
	"He mightn’t like it, though.",
	"What?",
	"God, I’ll tell him anyhow.",
	"That was the great earl, the Fitzgerald Mor.",
	"Hot members they were all of them, the Geraldines.",
	"The horses he passed started nervously under their slack harness.",
	"He slapped a piebald haunch quivering near him and cried: Woa, sonny!",
	"He turned to J. J. O’Molloy and asked: Well, Jack.",
	"What is it?",
	"What’s the trouble?",
	"Wait awhile.",
	"Hold hard.",
	"With gaping mouth and head far back he stood still and, after an instant, sneezed loudly.",
	"Chow!",
	"he said.",
	"Blast you!",
	"The dust from those sacks, J. J. O’Molloy said politely.",
	"Chow!...",
	"Mother of Moses!",
	"Tom Rochford took the top disk from the pile he clasped against his claret waistcoat.",
	"See?",
	"he said.",
	"Say it’s turn six.",
	"In here, see.",
	"Turn Now On.",
	"He slid it into the left slot for them.",
	"It shot down the groove, wobbled a while, ceased, ogling them: six.",
	"See?",
	"he said.",
	"See now the last one I put in is over here: Turns Over.",
	"The impact.",
	"Leverage, see?",
	"He showed them the rising column of disks on the right.",
	"Smart idea, Nosey Flynn said, snuffling.",
	"So a fellow coming in late can see what turn is on and what turns are over.",
	"See?",
	"Tom Rochford said.",
	"He slid in a disk for himself: and watched it shoot, wobble, ogle, stop: four.",
	"Turn Now On.",
	"I’ll see him now in the Ormond, Lenehan said, and sound him.",
	"One good turn deserves another.",
	"Do, Tom Rochford said.",
	"Tell him I’m Boylan with impatience.",
	"Goodnight, M’Coy said abruptly.",
	"When you two begin... Nosey Flynn stooped towards the lever, snuffling at it.",
	"But how does it work here, Tommy?",
	"he asked.",
	"Tooraloo, Lenehan said.",
	"See you later.",
	"He followed M’Coy out across the tiny square of Crampton court.",
	"He’s a hero, he said simply.",
	"I know, M’Coy said.",
	"The drain, you mean.",
	"Drain?",
	"Lenehan said.",
	"It was down a manhole.",
	"They passed Dan Lowry’s musichall where Marie Kendall, charming soubrette, smiled on them from a poster a dauby smile.",
	"Going down the path of Sycamore street beside the Empire musichall Lenehan showed M’Coy how the whole thing was.",
	"Down went Tom Rochford anyhow, booky’s vest and all, with the rope round him.",
	"And be damned but he got the rope round the poor devil and the two were hauled up.",
	"The act of a hero, he said.",
	"At the Dolphin they halted to allow the ambulance car to gallop past them for Jervis street.",
	"This way, he said, walking to the right.",
	"I want to pop into Lynam’s to see Sceptre’s starting price.",
	"What’s the time by your gold watch and chain?",
	"M’Coy peered into Marcus Tertius Moses’ sombre office, then at O’Neill’s clock.",
	"After three, he said.",
	"Who’s riding her?",
	"O.",
	"Madden, Lenehan said.",
	"And a game filly she is.",
	"Fellow might damn easy get a nasty fall there coming along tight in the dark.",
	"The gates of the drive opened wide to give egress to the viceregal cavalcade.",
	"Even money, Lenehan said returning.",
	"Through here.",
	"They went up the steps and under Merchants’ arch.",
	"A darkbacked figure scanned books on the hawker’s cart.",
	"There he is, Lenehan said.",
	"Wonder what he’s buying, M’Coy said, glancing behind.",
	"Leopoldo or the Bloom is on the Rye, Lenehan said.",
	"He’s dead nuts on sales, M’Coy said.",
	"Astronomy it was about.",
	"Lenehan laughed.",
	"I’ll tell you a damn good one about comets’ tails, he said.",
	"Come over in the sun.",
	"They crossed to the metal bridge and went along Wellington quay by the riverwall.",
	"Master Patrick Aloysius Dignam came out of Mangan’s, late Fehrenbach’s, carrying a pound and a half of porksteaks.",
	"There was a long spread out at Glencree reformatory, Lenehan said eagerly.",
	"The annual dinner, you know.",
	"Boiled shirt affair.",
	"Bartell d’Arcy sang and Benjamin Dollard... —I know, M’Coy broke in.",
	"My missus sang there once.",
	"Did she?",
	"Lenehan said.",
	"A card Unfurnished Apartments reappeared on the windowsash of number 7 Eccles street.",
	"He checked his tale a moment but broke out in a wheezy laugh.",
	"But wait till I tell you, he said.",
	"Delahunt of Camden street had the catering and yours truly was chief bottlewasher.",
	"Bloom and the wife were there.",
	"Lashings of stuff we put up: port wine and sherry and curacao to which we did ample justice.",
	"Fast and furious it was.",
	"After liquids came solids.",
	"Cold joints galore and mince pies... —I know, M’Coy said.",
	"The year the missus was there... Lenehan linked his arm warmly.",
	"But wait till I tell you, he said.",
	"Coming home it was a gorgeous winter’s night on the Featherbed Mountain.",
	"We started singing glees and duets: Lo, the early beam of morning.",
	"She was well primed with a good load of Delahunt’s port under her bellyband.",
	"Every jolt the bloody car gave I had her bumping up against me.",
	"Hell’s delights!",
	"She has a fine pair, God bless her.",
	"Like that.",
	"Know what I mean?",
	"His hands moulded ample curves of air.",
	"He shut his eyes tight in delight, his body shrinking, and blew a sweet chirp from his lips.",
	"The lad stood to attention anyhow, he said with a sigh.",
	"She’s a gamey mare and no mistake.",
	"But, by God, I was lost, so to speak, in the milky way.",
	"He knows them all, faith.",
	"At last she spotted a weeny weeshy one miles away.",
	"And what star is that, Poldy?",
	"says she.",
	"By God, she had Bloom cornered.",
	"That one, is it?",
	"says Chris Callinan, sure that’s only what you might call a pinprick.",
	"By God, he wasn’t far wide of the mark.",
	"Lenehan stopped and leaned on the riverwall, panting with soft laughter.",
	"I’m weak, he gasped.",
	"M’Coy’s white face smiled about it at instants and grew grave.",
	"Lenehan walked on again.",
	"He lifted his yachtingcap and scratched his hindhead rapidly.",
	"He glanced sideways in the sunlight at M’Coy.",
	"He’s a cultured allroundman, Bloom is, he said seriously.",
	"He’s not one of your common or garden... you know... There’s a touch of the artist about old Bloom.",
	"Mr Bloom turned over idly pages of The Awful Disclosures of Maria Monk, then of Aristotle’s Masterpiece.",
	"Crooked botched print.",
	"Plates: infants cuddled in a ball in bloodred wombs like livers of slaughtered cows.",
	"Lots of them like that at this moment all over the world.",
	"All butting with their skulls to get out of it.",
	"Child born every minute somewhere.",
	"Mrs Purefoy.",
	"He laid both books aside and glanced at the third: Tales of the Ghetto by Leopold von Sacher Masoch.",
	"That I had, he said, pushing it by.",
	"The shopman let two volumes fall on the counter.",
	"Them are two good ones, he said.",
	"Onions of his breath came across the counter out of his ruined mouth.",
	"Fair Tyrants by James Lovebirch.",
	"Know the kind that is.",
	"Had it?",
	"Yes.",
	"He opened it.",
	"Thought so.",
	"A woman’s voice behind the dingy curtain.",
	"Listen: the man.",
	"No: she wouldn’t like that much.",
	"Got her it once.",
	"He read the other title: Sweets of Sin.",
	"More in her line.",
	"Let us see.",
	"He read where his finger opened.",
	"All the dollarbills her husband gave her were spent in the stores on wondrous gowns and costliest frillies.",
	"For him!",
	"For Raoul!",
	"Yes.",
	"This.",
	"Here.",
	"Try.",
	"Yes.",
	"Take this.",
	"The end.",
	"You are late, he spoke hoarsely, eying her with a suspicious glare.",
	"The beautiful woman threw off her sabletrimmed wrap, displaying her queenly shoulders and heaving embonpoint.",
	"An imperceptible smile played round her perfect lips as she turned to him calmly.",
	"Mr Bloom read again: The beautiful woman.",
	"Warmth showered gently over him, cowing his flesh.",
	"Flesh yielded amply amid rumpled clothes: whites of eyes swooning up.",
	"His nostrils arched themselves for prey.",
	"Melting breast ointments (for him!",
	"For Raoul!).",
	"Armpits’ oniony sweat.",
	"Fishgluey slime (her heaving embonpoint!).",
	"Feel!",
	"Press!",
	"Crished!",
	"Sulphur dung of lions!",
	"Young!",
	"Young!",
	"Phlegmy coughs shook the air of the bookshop, bulging out the dingy curtains.",
	"The shopman’s uncombed grey head came out and his unshaven reddened face, coughing.",
	"He raked his throat rudely, puked phlegm on the floor.",
	"Mr Bloom beheld it.",
	"Mastering his troubled breath, he said: I’ll take this one.",
	"The shopman lifted eyes bleared with old rheum.",
	"Sweets of Sin, he said, tapping on it.",
	"That’s a good one.",
	"Dilly Dedalus, loitering by the curbstone, heard the beats of the bell, the cries of the auctioneer within.",
	"Four and nine.",
	"Those lovely curtains.",
	"Five shillings.",
	"Cosy curtains.",
	"Selling new at two guineas.",
	"Any advance on five shillings?",
	"Going for five shillings.",
	"The lacquey lifted his handbell and shook it: Barang!",
	"Bang of the lastlap bell spurred the halfmile wheelmen to their sprint.",
	"J.",
	"Mr Dedalus, tugging a long moustache, came round from Williams’s row.",
	"He halted near his daughter.",
	"It’s time for you, she said.",
	"Stand up straight for the love of the lord Jesus, Mr Dedalus said.",
	"Are you trying to imitate your uncle John, the cornetplayer, head upon shoulder?",
	"Melancholy God!",
	"Dilly shrugged her shoulders.",
	"Mr Dedalus placed his hands on them and held them back.",
	"Stand up straight, girl, he said.",
	"You’ll get curvature of the spine.",
	"Do you know what you look like?",
	"He let his head sink suddenly down and forward, hunching his shoulders and dropping his underjaw.",
	"Give it up, father, Dilly said.",
	"All the people are looking at you.",
	"Mr Dedalus drew himself upright and tugged again at his moustache.",
	"Did you get any money?",
	"Dilly asked.",
	"Where would I get money?",
	"Mr Dedalus said.",
	"There is no-one in Dublin would lend me fourpence.",
	"You got some, Dilly said, looking in his eyes.",
	"How do you know that?",
	"Mr Dedalus asked, his tongue in his cheek.",
	"Mr Kernan, pleased with the order he had booked, walked boldly along James’s street.",
	"I know you did, Dilly answered.",
	"Were you in the Scotch house now?",
	"I was not, then, Mr Dedalus said, smiling.",
	"Was it the little nuns taught you to be so saucy?",
	"Here.",
	"He handed her a shilling.",
	"See if you can do anything with that, he said.",
	"I suppose you got five, Dilly said.",
	"Give me more than that.",
	"Wait awhile, Mr Dedalus said threateningly.",
	"You’re like the rest of them, are you?",
	"An insolent pack of little bitches since your poor mother died.",
	"But wait awhile.",
	"You’ll all get a short shrift and a long day from me.",
	"Low blackguardism!",
	"I’m going to get rid of you.",
	"Wouldn’t care if I was stretched out stiff.",
	"He’s dead.",
	"The man upstairs is dead.",
	"He left her and walked on.",
	"Dilly followed quickly and pulled his coat.",
	"Well, what is it?",
	"he said, stopping.",
	"The lacquey rang his bell behind their backs.",
	"Barang!",
	"Curse your bloody blatant soul, Mr Dedalus cried, turning on him.",
	"The lacquey, aware of comment, shook the lolling clapper of his bell but feebly: Bang!",
	"Mr Dedalus stared at him.",
	"Watch him, he said.",
	"It’s instructive.",
	"I wonder will he allow us to talk.",
	"You got more than that, father, Dilly said.",
	"I’m going to show you a little trick, Mr Dedalus said.",
	"I’ll leave you all where Jesus left the jews.",
	"Look, there’s all I have.",
	"I got two shillings from Jack Power and I spent twopence for a shave for the funeral.",
	"He drew forth a handful of copper coins, nervously.",
	"Can’t you look for some money somewhere?",
	"Dilly said.",
	"Mr Dedalus thought and nodded.",
	"I will, he said gravely.",
	"I looked all along the gutter in O’Connell street.",
	"I’ll try this one now.",
	"You’re very funny, Dilly said, grinning.",
	"Here, Mr Dedalus said, handing her two pennies.",
	"Get a glass of milk for yourself and a bun or a something.",
	"I’ll be home shortly.",
	"He put the other coins in his pocket and started to walk on.",
	"The viceregal cavalcade passed, greeted by obsequious policemen, out of Parkgate.",
	"I’m sure you have another shilling, Dilly said.",
	"The lacquey banged loudly.",
	"Mr Dedalus amid the din walked off, murmuring to himself with a pursing mincing mouth gently: The little nuns!",
	"Nice little things!",
	"O, sure they wouldn’t do anything!",
	"O, sure they wouldn’t really!",
	"Is it little sister Monica!",
	"Got round him all right.",
	"How do you do, Mr Crimmins?",
	"First rate, sir.",
	"I was afraid you might be up in your other establishment in Pimlico.",
	"How are things going?",
	"Just keeping alive.",
	"Lovely weather we’re having.",
	"Yes, indeed.",
	"Good for the country.",
	"Those farmers are always grumbling.",
	"I’ll just take a thimbleful of your best gin, Mr Crimmins.",
	"A small gin, sir.",
	"Yes, sir.",
	"Terrible affair that General Slocum explosion.",
	"Terrible, terrible!",
	"A thousand casualties.",
	"And heartrending scenes.",
	"Men trampling down women and children.",
	"Most brutal thing.",
	"What do they say was the cause?",
	"Spontaneous combustion.",
	"Most scandalous revelation.",
	"Not a single lifeboat would float and the firehose all burst.",
	"You know why?",
	"Palm oil.",
	"Is that a fact?",
	"Without a doubt.",
	"Well now, look at that.",
	"And America they say is the land of the free.",
	"I thought we were bad here.",
	"I smiled at him.",
	"America, I said quietly, just like that.",
	"What is it?",
	"The sweepings of every country including our own.",
	"Isn’t that true?",
	"That’s a fact.",
	"Graft, my dear sir.",
	"Well, of course, where there’s money going there’s always someone to pick it up.",
	"Saw him looking at my frockcoat.",
	"Dress does it.",
	"Nothing like a dressy appearance.",
	"Bowls them over.",
	"Hello, Simon, Father Cowley said.",
	"How are things?",
	"Hello, Bob, old man, Mr Dedalus answered, stopping.",
	"Mr Kernan halted and preened himself before the sloping mirror of Peter Kennedy, hairdresser.",
	"Stylish coat, beyond a doubt.",
	"Scott of Dawson street.",
	"Well worth the half sovereign I gave Neary for it.",
	"Never built under three guineas.",
	"Fits me down to the ground.",
	"Some Kildare street club toff had it probably.",
	"Aham!",
	"Must dress the character for those fellows.",
	"Knight of the road.",
	"Gentleman.",
	"And now, Mr Crimmins, may we have the honour of your custom again, sir.",
	"The cup that cheers but not inebriates, as the old saying has it.",
	"Mr Kernan glanced in farewell at his image.",
	"High colour, of course.",
	"Grizzled moustache.",
	"Returned Indian officer.",
	"Bravely he bore his stumpy body forward on spatted feet, squaring his shoulders.",
	"Is that Ned Lambert’s brother over the way, Sam?",
	"What?",
	"Yes.",
	"He’s as like it as damn it.",
	"No.",
	"The windscreen of that motorcar in the sun there.",
	"Just a flash like that.",
	"Damn like him.",
	"Aham!",
	"Hot spirit of juniper juice warmed his vitals and his breath.",
	"Good drop of gin, that was.",
	"His frocktails winked in bright sunshine to his fat strut.",
	"Down there Emmet was hanged, drawn and quartered.",
	"Greasy black rope.",
	"Dogs licking the blood off the street when the lord lieutenant’s wife drove by in her noddy.",
	"Bad times those were.",
	"Well, well.",
	"Over and done with.",
	"Great topers too.",
	"Fourbottle men.",
	"Let me see.",
	"Is he buried in saint Michan’s?",
	"Or no, there was a midnight burial in Glasnevin.",
	"Corpse brought in through a secret door in the wall.",
	"Dignam is there now.",
	"Went out in a puff.",
	"Well, well.",
	"Better turn down here.",
	"Make a detour.",
	"Mr Kernan turned and walked down the slope of Watling street by the corner of Guinness’s visitors’ waitingroom.",
	"Damn dangerous thing.",
	"Some Tipperary bosthoon endangering the lives of the citizens.",
	"Runaway horse.",
	"Mr Kernan approached Island street.",
	"Times of the troubles.",
	"Must ask Ned Lambert to lend me those reminiscences of sir Jonah Barrington.",
	"When you look back on it all now in a kind of retrospective arrangement.",
	"Gaming at Daly’s.",
	"No cardsharping then.",
	"One of those fellows got his hand nailed to the table by a dagger.",
	"Somewhere here lord Edward Fitzgerald escaped from major Sirr.",
	"Stables behind Moira house.",
	"Damn good gin that was.",
	"Fine dashing young nobleman.",
	"Good stock, of course.",
	"That ruffian, that sham squire, with his violet gloves gave him away.",
	"Course they were on the wrong side.",
	"They rose in dark and evil days.",
	"Fine poem that is: Ingram.",
	"They were gentlemen.",
	"Ben Dollard does sing that ballad touchingly.",
	"Masterly rendition.",
	"At the siege of Ross did my father fall.",
	"A cavalcade in easy trot along Pembroke quay passed, outriders leaping, leaping in their, in their saddles.",
	"Frockcoats.",
	"Cream sunshades.",
	"Mr Kernan hurried forward, blowing pursily.",
	"His Excellency!",
	"Too bad!",
	"Just missed that by a hair.",
	"Damn it!",
	"What a pity!",
	"Stephen Dedalus watched through the webbed window the lapidary’s fingers prove a timedulled chain.",
	"Dust webbed the window and the showtrays.",
	"Dust darkened the toiling fingers with their vulture nails.",
	"Dust slept on dull coils of bronze and silver, lozenges of cinnabar, on rubies, leprous and winedark stones.",
	"Born all in the dark wormy earth, cold specks of fire, evil, lights shining in the darkness.",
	"Where fallen archangels flung the stars of their brows.",
	"Muddy swinesnouts, hands, root and root, gripe and wrest them.",
	"She dances in a foul gloom where gum bums with garlic.",
	"A sailorman, rustbearded, sips from a beaker rum and eyes her.",
	"A long and seafed silent rut.",
	"She dances, capers, wagging her sowish haunches and her hips, on her gross belly flapping a ruby egg.",
	"Grandfather ape gloating on a stolen hoard.",
	"And you who wrest old images from the burial earth?",
	"The brainsick words of sophists: Antisthenes.",
	"A lore of drugs.",
	"Orient and immortal wheat standing from everlasting to everlasting.",
	"The whirr of flapping leathern bands and hum of dynamos from the powerhouse urged Stephen to be on.",
	"Beingless beings.",
	"Stop!",
	"Throb always without you and the throb always within.",
	"Your heart you sing of.",
	"I between them.",
	"Where?",
	"Between two roaring worlds where they swirl, I. Shatter them, one and both.",
	"But stun myself too in the blow.",
	"Shatter me you who can.",
	"Bawd and butcher were the words.",
	"I say!",
	"Not yet awhile.",
	"A look around.",
	"Yes, quite true.",
	"Very large and wonderful and keeps famous time.",
	"You say right, sir.",
	"A Monday morning, ‘twas so, indeed.",
	"Stephen went down Bedford row, the handle of the ash clacking against his shoulderblade.",
	"In Clohissey’s window a faded 1860 print of Heenan boxing Sayers held his eye.",
	"Staring backers with square hats stood round the roped prizering.",
	"The heavyweights in tight loincloths proposed gently each to other his bulbous fists.",
	"And they are throbbing: heroes’ hearts.",
	"He turned and halted by the slanted bookcart.",
	"Twopence each, the huckster said.",
	"Four for sixpence.",
	"Tattered pages.",
	"The Irish Beekeeper.",
	"Life and Miracles of the Curé of Ars.",
	"Pocket Guide to Killarney.",
	"I might find here one of my pawned schoolprizes.",
	"Stephano Dedalo, alumno optimo, palmam ferenti.",
	"Father Conmee, having read his little hours, walked through the hamlet of Donnycarney, murmuring vespers.",
	"Binding too good probably.",
	"What is this?",
	"Eighth and ninth book of Moses.",
	"Secret of all secrets.",
	"Seal of King David.",
	"Thumbed pages: read and read.",
	"Who has passed here before me?",
	"How to soften chapped hands.",
	"Recipe for white wine vinegar.",
	"How to win a woman’s love.",
	"For me this.",
	"Say the following talisman three times with hands folded: Se el yilo nebrakada femininum!",
	"Amor me solo!",
	"Sanktus!",
	"Amen.",
	"Who wrote this?",
	"Charms and invocations of the most blessed abbot Peter Salanka to all true believers divulged.",
	"As good as any other abbot’s charms, as mumbling Joachim’s.",
	"Down, baldynoddle, or we’ll wool your wool.",
	"What are you doing here, Stephen?",
	"Dilly’s high shoulders and shabby dress.",
	"Shut the book quick.",
	"Don’t let see.",
	"What are you doing?",
	"Stephen said.",
	"A Stuart face of nonesuch Charles, lank locks falling at its sides.",
	"It glowed as she crouched feeding the fire with broken boots.",
	"I told her of Paris.",
	"Late lieabed under a quilt of old overcoats, fingering a pinchbeck bracelet, Dan Kelly’s token.",
	"Nebrakada femininum.",
	"What have you there?",
	"Stephen asked.",
	"I bought it from the other cart for a penny, Dilly said, laughing nervously.",
	"Is it any good?",
	"My eyes they say she has.",
	"Do others see me so?",
	"Quick, far and daring.",
	"Shadow of my mind.",
	"He took the coverless book from her hand.",
	"Chardenal’s French primer.",
	"What did you buy that for?",
	"he asked.",
	"To learn French?",
	"She nodded, reddening and closing tight her lips.",
	"Show no surprise.",
	"Quite natural.",
	"Here, Stephen said.",
	"It’s all right.",
	"Mind Maggy doesn’t pawn it on you.",
	"I suppose all my books are gone.",
	"Some, Dilly said.",
	"We had to.",
	"She is drowning.",
	"Agenbite.",
	"Save her.",
	"Agenbite.",
	"All against us.",
	"She will drown me with her, eyes and hair.",
	"Lank coils of seaweed hair around me, my heart, my soul.",
	"Salt green death.",
	"We.",
	"Agenbite of inwit.",
	"Inwit’s agenbite.",
	"Misery!",
	"Misery!",
	"Hello, Simon, Father Cowley said.",
	"How are things?",
	"Hello, Bob, old man, Mr Dedalus answered, stopping.",
	"They clasped hands loudly outside Reddy and Daughter’s.",
	"Father Cowley brushed his moustache often downward with a scooping hand.",
	"What’s the best news?",
	"Mr Dedalus said.",
	"Why then not much, Father Cowley said.",
	"I’m barricaded up, Simon, with two men prowling around the house trying to effect an entrance.",
	"Jolly, Mr Dedalus said.",
	"Who is it?",
	"O, Father Cowley said.",
	"A certain gombeen man of our acquaintance.",
	"With a broken back, is it?",
	"Mr Dedalus asked.",
	"The same, Simon, Father Cowley answered.",
	"Reuben of that ilk.",
	"I’m just waiting for Ben Dollard.",
	"He’s going to say a word to long John to get him to take those two men off.",
	"All I want is a little time.",
	"He looked with vague hope up and down the quay, a big apple bulging in his neck.",
	"I know, Mr Dedalus said, nodding.",
	"Poor old bockedy Ben!",
	"He’s always doing a good turn for someone.",
	"Hold hard!",
	"He put on his glasses and gazed towards the metal bridge an instant.",
	"There he is, by God, he said, arse and pockets.",
	"He came towards them at an amble, scratching actively behind his coattails.",
	"As he came near Mr Dedalus greeted: Hold that fellow with the bad trousers.",
	"Hold him now, Ben Dollard said.",
	"Mr Dedalus eyed with cold wandering scorn various points of Ben Dollard’s figure.",
	"Bad luck to the jewman that made them, Ben Dollard said.",
	"Thanks be to God he’s not paid yet.",
	"And how is that basso profondo, Benjamin?",
	"Father Cowley asked.",
	"Cashel Boyle O’Connor Fitzmaurice Tisdall Farrell, murmuring, glassyeyed, strode past the Kildare street club.",
	"Ben Dollard frowned and, making suddenly a chanter’s mouth, gave forth a deep note.",
	"Aw!",
	"he said.",
	"That’s the style, Mr Dedalus said, nodding to its drone.",
	"What about that?",
	"Ben Dollard said.",
	"Not too dusty?",
	"What?",
	"He turned to both.",
	"That’ll do, Father Cowley said, nodding also.",
	"Ben Dollard with a heavy list towards the shopfronts led them forward, his joyful fingers in the air.",
	"Come along with me to the subsheriff’s office, he said.",
	"I want to show you the new beauty Rock has for a bailiff.",
	"He’s a cross between Lobengula and Lynchehaun.",
	"He’s well worth seeing, mind you.",
	"Come along.",
	"Wait awhile... We’re on the right lay, Bob, believe you me.",
	"For a few days tell him, Father Cowley said anxiously.",
	"What few days?",
	"he boomed.",
	"Hasn’t your landlord distrained for rent?",
	"He has, Father Cowley said.",
	"Then our friend’s writ is not worth the paper it’s printed on, Ben Dollard said.",
	"The landlord has the prior claim.",
	"I gave him all the particulars.",
	"29 Windsor avenue.",
	"Love is the name?",
	"That’s right, Father Cowley said.",
	"The reverend Mr Love.",
	"He’s a minister in the country somewhere.",
	"But are you sure of that?",
	"He led Father Cowley boldly forward, linked to his bulk.",
	"Filberts I believe they were, Mr Dedalus said, as he dropped his glasses on his coatfront, following them.",
	"The youngster will be all right, Martin Cunningham said, as they passed out of the Castleyard gate.",
	"The policeman touched his forehead.",
	"God bless you, Martin Cunningham said, cheerily.",
	"He signed to the waiting jarvey who chucked at the reins and set on towards Lord Edward street.",
	"Bronze by gold, Miss Kennedy’s head by Miss Douce’s head, appeared above the crossblind of the Ormond hotel.",
	"Yes, Martin Cunningham said, fingering his beard.",
	"I wrote to Father Conmee and laid the whole case before him.",
	"You could try our friend, Mr Power suggested backward.",
	"Boyd?",
	"Martin Cunningham said shortly.",
	"Touch me not.",
	"John Wyse Nolan, lagging behind, reading the list, came after them quickly down Cork hill.",
	"On the steps of the City hall Councillor Nannetti, descending, hailed Alderman Cowley and Councillor Abraham Lyon ascending.",
	"The castle car wheeled empty into upper Exchange street.",
	"Look here, Martin, John Wyse Nolan said, overtaking them at the Mail office.",
	"I see Bloom put his name down for five shillings.",
	"Quite right, Martin Cunningham said, taking the list.",
	"And put down the five shillings too.",
	"Without a second word either, Mr Power said.",
	"Strange but true, Martin Cunningham added.",
	"John Wyse Nolan opened wide eyes.",
	"I’ll say there is much kindness in the jew, he quoted, elegantly.",
	"They went down Parliament street.",
	"There’s Jimmy Henry, Mr Power said, just heading for Kavanagh’s.",
	"Righto, Martin Cunningham said.",
	"Here goes.",
	"Outside la Maison Claire Blazes Boylan waylaid Jack Mooney’s brother-in-law, humpy, tight, making for the liberties.",
	"The assistant town clerk’s corns are giving him some trouble, John Wyse Nolan told Mr Power.",
	"They followed round the corner towards James Kavanagh’s winerooms.",
	"The empty castle car fronted them at rest in Essex gate.",
	"Martin Cunningham, speaking always, showed often the list at which Jimmy Henry did not glance.",
	"And long John Fanning is here too, John Wyse Nolan said, as large as life.",
	"The tall form of long John Fanning filled the doorway where he stood.",
	"Good day, Mr Subsheriff, Martin Cunningham said, as all halted and greeted.",
	"Long John Fanning made no way for them.",
	"He removed his large Henry Clay decisively and his large fierce eyes scowled intelligently over all their faces.",
	"Are the conscript fathers pursuing their peaceful deliberations?",
	"he said with rich acrid utterance to the assistant town clerk.",
	"Hell open to christians they were having, Jimmy Henry said pettishly, about their damned Irish language.",
	"Where was the marshal, he wanted to know, to keep order in the council chamber.",
	"Damned Irish language, language of our forefathers.",
	"Long John Fanning blew a plume of smoke from his lips.",
	"What Dignam was that?",
	"long John Fanning asked.",
	"Jimmy Henry made a grimace and lifted his left foot.",
	"O, my corns!",
	"he said plaintively.",
	"Come upstairs for goodness’ sake till I sit down somewhere.",
	"Uff!",
	"Ooo!",
	"Mind!",
	"Testily he made room for himself beside long John Fanning’s flank and passed in and up the stairs.",
	"Come on up, Martin Cunningham said to the subsheriff.",
	"I don’t think you knew him or perhaps you did, though.",
	"With John Wyse Nolan Mr Power followed them in.",
	"Rather lowsized.",
	"Dignam of Menton’s office that was, Martin Cunningham said.",
	"Long John Fanning could not remember him.",
	"Clatter of horsehoofs sounded from the air.",
	"What’s that?",
	"Martin Cunningham said.",
	"All turned where they stood.",
	"John Wyse Nolan came down again.",
	"Gaily they went past before his cool unfriendly eyes, not quickly.",
	"In saddles of the leaders, leaping leaders, rode outriders.",
	"What was it?",
	"Martin Cunningham asked, as they went on up the staircase.",
	"The lord lieutenantgeneral and general governor of Ireland, John Wyse Nolan answered from the stairfoot.",
	"As they trod across the thick carpet Buck Mulligan whispered behind his Panama to Haines: Parnell’s brother.",
	"There in the corner.",
	"Is that he?",
	"Haines asked, twisting round in his seat.",
	"Yes, Mulligan said.",
	"That’s John Howard, his brother, our city marshal.",
	"I’ll take a mélange, Haines said to the waitress.",
	"Two mélanges, Buck Mulligan said.",
	"And bring us some scones and butter and some cakes as well.",
	"When she had gone he said, laughing: We call it D.B.C.",
	"because they have damn bad cakes.",
	"O, but you missed Dedalus on Hamlet.",
	"Haines opened his newbought book.",
	"I’m sorry, he said.",
	"Shakespeare is the happy huntingground of all minds that have lost their balance.",
	"You should see him, he said, when his body loses its balance.",
	"Wandering Ængus I call him.",
	"I am sure he has an idée fixe, Haines said, pinching his chin thoughtfully with thumb and forefinger.",
	"Now I am speculating what it would be likely to be.",
	"Such persons always have.",
	"Buck Mulligan bent across the table gravely.",
	"They drove his wits astray, he said, by visions of hell.",
	"He will never capture the Attic note.",
	"The note of Swinburne, of all poets, the white death and the ruddy birth.",
	"That is his tragedy.",
	"He can never be a poet.",
	"The joy of creation... —Eternal punishment, Haines said, nodding curtly.",
	"I see.",
	"I tackled him this morning on belief.",
	"There was something on his mind, I saw.",
	"It’s rather interesting because professor Pokorny of Vienna makes an interesting point out of that.",
	"Buck Mulligan’s watchful eyes saw the waitress come.",
	"He helped her to unload her tray.",
	"He can find no trace of hell in ancient Irish myth, Haines said, amid the cheerful cups.",
	"The moral idea seems lacking, the sense of destiny, of retribution.",
	"Rather strange he should have just that fixed idea.",
	"Does he write anything for your movement?",
	"He sank two lumps of sugar deftly longwise through the whipped cream.",
	"Buck Mulligan slit a steaming scone in two and plastered butter over its smoking pith.",
	"He bit off a soft piece hungrily.",
	"Ten years, he said, chewing and laughing.",
	"He is going to write something in ten years.",
	"Seems a long way off, Haines said, thoughtfully lifting his spoon.",
	"Still, I shouldn’t wonder if he did after all.",
	"He tasted a spoonful from the creamy cone of his cup.",
	"This is real Irish cream I take it, he said with forbearance.",
	"I don’t want to be imposed on.",
	"Almidano Artifoni walked past Holles street, past Sewell’s yard.",
	"Distantly behind him a blind stripling tapped his way by the wall of College park.",
	"His eyeglass flashed frowning in the sun.",
	"With ratsteeth bared he muttered: Coactus volui.",
	"He strode on for Clare street, grinding his fierce word.",
	"The blind stripling turned his sickly face after the striding form.",
	"God’s curse on you, he said sourly, whoever you are!",
	"You’re blinder nor I am, you bitch’s bastard!",
	"And they eating crumbs of the cottage fruitcake, jawing the whole blooming time and sighing.",
	"After Wicklow lane the window of Madame Doyle, courtdress milliner, stopped him.",
	"He stood looking in at the two puckers stripped to their pelts and putting up their props.",
	"From the sidemirrors two mourning Masters Dignam gaped silently.",
	"Myler Keogh, Dublin’s pet lamb, will meet sergeantmajor Bennett, the Portobello bruiser, for a purse of fifty sovereigns.",
	"Gob, that’d be a good pucking match to see.",
	"Myler Keogh, that’s the chap sparring out to him with the green sash.",
	"Two bar entrance, soldiers half price.",
	"I could easy do a bunk on ma.",
	"Master Dignam on his left turned as he turned.",
	"That’s me in mourning.",
	"When is it?",
	"May the twentysecond.",
	"Sure, the blooming thing is all over.",
	"He turned to the right and on his right Master Dignam turned, his cap awry, his collar sticking up.",
	"Buttoning it down, his chin lifted, he saw the image of Marie Kendall, charming soubrette, beside the two puckers.",
	"Master Dignam got his collar down and dawdled on.",
	"The best pucker going for strength was Fitzsimons.",
	"One puck in the wind from that fellow would knock you into the middle of next week, man.",
	"No Sandymount tram.",
	"Master Dignam walked along Nassau street, shifted the porksteaks to his other hand.",
	"His collar sprang up again and he tugged it down.",
	"The blooming stud was too small for the buttonhole of the shirt, blooming end to it.",
	"He met schoolboys with satchels.",
	"I’m not going tomorrow either, stay away till Monday.",
	"He met other schoolboys.",
	"Do they notice I’m in mourning?",
	"Uncle Barney said he’d get it into the paper tonight.",
	"Then they’ll all see it in the paper and read my name printed and pa’s name.",
	"A big coffin it was, and high and heavylooking.",
	"How was that?",
	"Never see him again.",
	"Death, that is.",
	"Pa is dead.",
	"My father is dead.",
	"He told me to be a good son to ma.",
	"Poor pa. That was Mr Dignam, my father.",
	"I hope he’s in purgatory now because he went to confession to Father Conroy on Saturday night.",
	"In the following carriage were the honourable Mrs Paget, Miss de Courcy and the honourable Gerald Ward A.D.C.",
	"in attendance.",
	"The viceroy was most cordially greeted on his way through the metropolis.",
	"At Bloody bridge Mr Thomas Kernan beyond the river greeted him vainly from afar.",
	"His Excellency graciously returned Mr Dedalus’ greeting.",
	"On Grattan bridge Lenehan and M’Coy, taking leave of each other, watched the carriages go by.",
	"Over against Dame gate Tom Rochford and Nosey Flynn watched the approach of the cavalcade.",
	"She shouted in his ear the tidings.",
	"Understanding, he shifted his tomes to his left breast and saluted the second carriage.",
	"The honourable Gerald Ward A.D.C., agreeably surprised, made haste to reply.",
	"Baraabum.",
	"Yet I’ve a sort of a Yorkshire relish for My little Yorkshire rose.",
	"Baraabum.",
	"Thither of the wall the quartermile flat handicappers, M. C. Green, H. Shrift, T. M. Patey, C. Scaife, J.",
	"B. Jeffs, G. N. Morphy, F. Stevenson, C. Adderly and W. C. Huggard, started in pursuit.",
	"Deep in Leinster street by Trinity’s postern a loyal king’s man, Hornblower, touched his tallyho cap.",
	"His collar too sprang up.",
	"He passed a blind stripling opposite Broadbent’s.",
	"[ 11 ] Bronze by gold heard the hoofirons, steelyringing.",
	"Imperthnthn thnthnthn.",
	"Chips, picking chips off rocky thumbnail, chips.",
	"Horrid!",
	"And gold flushed more.",
	"A husky fifenote blew.",
	"Blew.",
	"Blue bloom is on the.",
	"Goldpinnacled hair.",
	"A jumping rose on satiny breast of satin, rose of Castile.",
	"Trilling, trilling: Idolores.",
	"Peep!",
	"Who’s in the... peepofgold?",
	"Tink cried to bronze in pity.",
	"And a call, pure, long and throbbing.",
	"Longindying call.",
	"Decoy.",
	"Soft word.",
	"But look: the bright stars fade.",
	"Notes chirruping answer.",
	"O rose!",
	"Castile.",
	"The morn is breaking.",
	"Jingle jingle jaunted jingling.",
	"Coin rang.",
	"Clock clacked.",
	"Avowal.",
	"Sonnez.",
	"I could.",
	"Rebound of garter.",
	"Not leave thee.",
	"Smack.",
	"La cloche!",
	"Thigh smack.",
	"Avowal.",
	"Warm.",
	"Sweetheart, goodbye!",
	"Jingle.",
	"Bloo.",
	"Boomed crashing chords.",
	"When love absorbs.",
	"War!",
	"War!",
	"The tympanum.",
	"A sail!",
	"A veil awave upon the waves.",
	"Lost.",
	"Throstle fluted.",
	"All is lost now.",
	"Horn.",
	"Hawhorn.",
	"When first he saw.",
	"Alas!",
	"Full tup.",
	"Full throb.",
	"Warbling.",
	"Ah, lure!",
	"Alluring.",
	"Martha!",
	"Come!",
	"Clapclap.",
	"Clipclap.",
	"Clappyclap.",
	"Goodgod henev erheard inall.",
	"Deaf bald Pat brought pad knife took up.",
	"A moonlit nightcall: far, far.",
	"I feel so sad.",
	"P. S. So lonely blooming.",
	"Listen!",
	"The spiked and winding cold seahorn.",
	"Have you the?",
	"Each, and for other, plash and silent roar.",
	"Pearls: when she.",
	"Liszt’s rhapsodies.",
	"Hissss.",
	"You don’t?",
	"Did not: no, no: believe: Lidlyd.",
	"With a cock with a carra.",
	"Black.",
	"Deepsounding.",
	"Do, Ben, do.",
	"Wait while you wait.",
	"Hee hee.",
	"Wait while you hee.",
	"But wait!",
	"Low in dark middle earth.",
	"Embedded ore. Naminedamine.",
	"Preacher is he: All gone.",
	"All fallen.",
	"Tiny, her tremulous fernfoils of maidenhair.",
	"Amen!",
	"He gnashed in fury.",
	"Fro.",
	"To, fro.",
	"A baton cool protruding.",
	"Bronzelydia by Minagold.",
	"By bronze, by gold, in oceangreen of shadow.",
	"Bloom.",
	"Old Bloom.",
	"One rapped, one tapped, with a carra, with a cock.",
	"Pray for him!",
	"Pray, good people!",
	"His gouty fingers nakkering.",
	"Big Benaben.",
	"Big Benben.",
	"Last rose Castile of summer left bloom I feel so sad alone.",
	"Pwee!",
	"Little wind piped wee.",
	"True men.",
	"Lid Ker Cow De and Doll.",
	"Ay, ay.",
	"Like you men.",
	"Will lift your tschink with tschunk.",
	"Fff!",
	"Oo!",
	"Where bronze from anear?",
	"Where gold from afar?",
	"Where hoofs?",
	"Rrrpr.",
	"Kraa.",
	"Kraandl.",
	"Then not till then.",
	"My eppripfftaph.",
	"Be pfrwritt.",
	"Done.",
	"Begin!",
	"Is that her?",
	"asked miss Kennedy.",
	"Miss Douce said yes, sitting with his ex, pearl grey and eau de Nil.",
	"Exquisite contrast, miss Kennedy said.",
	"When all agog miss Douce said eagerly: Look at the fellow in the tall silk.",
	"Who?",
	"Where?",
	"gold asked more eagerly.",
	"In the second carriage, miss Douce’s wet lips said, laughing in the sun.",
	"He’s looking.",
	"Mind till I see.",
	"She darted, bronze, to the backmost corner, flattening her face against the pane in a halo of hurried breath.",
	"Her wet lips tittered: He’s killed looking back.",
	"She laughed: O wept!",
	"Aren’t men frightful idiots?",
	"With sadness.",
	"Miss Kennedy sauntered sadly from bright light, twining a loose hair behind an ear.",
	"Sauntering sadly, gold no more, she twisted twined a hair.",
	"Sadly she twined in sauntering gold hair behind a curving ear.",
	"It’s them has the fine times, sadly then she said.",
	"A man.",
	"The boots to them, them in the bar, them barmaids came.",
	"For them unheeding him he banged on the counter his tray of chattering china.",
	"And —There’s your teas, he said.",
	"Miss Kennedy with manners transposed the teatray down to an upturned lithia crate, safe from eyes, low.",
	"What is it?",
	"loud boots unmannerly asked.",
	"Find out, miss Douce retorted, leaving her spyingpoint.",
	"Your beau, is it?",
	"Imperthnthn thnthnthn, bootssnout sniffed rudely, as he retreated as she threatened as he had come.",
	"Bloom.",
	"On her flower frowning miss Douce said: Most aggravating that young brat is.",
	"If he doesn’t conduct himself I’ll wring his ear for him a yard long.",
	"Ladylike in exquisite contrast.",
	"Take no notice, miss Kennedy rejoined.",
	"She poured in a teacup tea, then back in the teapot tea.",
	"They cowered under their reef of counter, waiting on footstools, crates upturned, waiting for their teas to draw.",
	"Am I awfully sunburnt?",
	"Miss bronze unbloused her neck.",
	"No, said miss Kennedy.",
	"It gets brown after.",
	"Did you try the borax with the cherry laurel water?",
	"And leave it to my hands, she said.",
	"Try it with the glycerine, miss Kennedy advised.",
	"Bidding her neck and hands adieu miss Douce —Those things only bring out a rash, replied, reseated.",
	"I asked that old fogey in Boyd’s for something for my skin.",
	"Miss Kennedy, pouring now a fulldrawn tea, grimaced and prayed: O, don’t remind me of him for mercy’ sake!",
	"But wait till I tell you, miss Douce entreated.",
	"Sweet tea miss Kennedy having poured with milk plugged both two ears with little fingers.",
	"No, don’t, she cried.",
	"I won’t listen, she cried.",
	"But Bloom?",
	"Miss Douce grunted in snuffy fogey’s tone: For your what?",
	"says he.",
	"The hideous old wretch!",
	"That night in the Antient Concert Rooms.",
	"She sipped distastefully her brew, hot tea, a sip, sipped, sweet tea.",
	"Here he was, miss Douce said, cocking her bronze head three quarters, ruffling her nosewings.",
	"Hufa!",
	"Hufa!",
	"Shrill shriek of laughter sprang from miss Kennedy’s throat.",
	"Miss Douce huffed and snorted down her nostrils that quivered imperthnthn like a snout in quest.",
	"O!",
	"shrieking, miss Kennedy cried.",
	"Will you ever forget his goggle eye?",
	"Miss Douce chimed in in deep bronze laughter, shouting: And your other eye!",
	"Bloowhose dark eye read Aaron Figatner’s name.",
	"Why do I always think Figather?",
	"Gathering figs, I think.",
	"And Prosper Loré’s huguenot name.",
	"By Bassi’s blessed virgins Bloom’s dark eyes went by.",
	"Bluerobed, white under, come to me.",
	"God they believe she is: or goddess.",
	"Those today.",
	"I could not see.",
	"That fellow spoke.",
	"A student.",
	"After with Dedalus’ son.",
	"He might be Mulligan.",
	"All comely virgins.",
	"That brings those rakes of fellows in: her white.",
	"By went his eyes.",
	"The sweets of sin.",
	"Sweet are the sweets.",
	"Of sin.",
	"In a giggling peal young goldbronze voices blended, Douce with Kennedy your other eye.",
	"Ah, panting, sighing, sighing, ah, fordone, their mirth died down.",
	"Miss Kennedy lipped her cup again, raised, drank a sip and gigglegiggled.",
	"Miss Douce, bending over the teatray, ruffled again her nose and rolled droll fattened eyes.",
	"Imagine being married to a man like that!",
	"she cried.",
	"With his bit of beard!",
	"Douce gave full vent to a splendid yell, a full yell of full woman, delight, joy, indignation.",
	"Married to the greasy nose!",
	"she yelled.",
	"And then laughed more.",
	"Greasy I knows.",
	"Exhausted, breathless, their shaken heads they laid, braided and pinnacled by glossycombed, against the counterledge.",
	"All flushed (O!",
	"), panting, sweating (O!",
	"), all breathless.",
	"Married to Bloom, to greaseabloom.",
	"O saints above!",
	"miss Douce said, sighed above her jumping rose.",
	"I wished I hadn’t laughed so much.",
	"I feel all wet.",
	"O, miss Douce!",
	"miss Kennedy protested.",
	"You horrid thing!",
	"And flushed yet more (you horrid!",
	"), more goldenly.",
	"By Cantwell’s offices roved Greaseabloom, by Ceppi’s virgins, bright of their oils.",
	"Nannetti’s father hawked those things about, wheedling at doors as I.",
	"Religion pays.",
	"Must see him for that par.",
	"Eat first.",
	"I want.",
	"Not yet.",
	"At four, she said.",
	"Time ever passing.",
	"Clockhands turning.",
	"On.",
	"Where eat?",
	"The Clarence, Dolphin.",
	"On.",
	"For Raoul.",
	"Eat.",
	"If I net five guineas with those ads.",
	"The violet silk petticoats.",
	"Not yet.",
	"The sweets of sin.",
	"Flushed less, still less, goldenly paled.",
	"Into their bar strolled Mr Dedalus.",
	"Chips, picking chips off one of his rocky thumbnails.",
	"Chips.",
	"He strolled.",
	"O, welcome back, miss Douce.",
	"He held her hand.",
	"Enjoyed her holidays?",
	"Tiptop.",
	"He hoped she had nice weather in Rostrevor.",
	"Gorgeous, she said.",
	"Look at the holy show I am.",
	"Lying out on the strand all day.",
	"Bronze whiteness.",
	"That was exceedingly naughty of you, Mr Dedalus told her and pressed her hand indulgently.",
	"Tempting poor simple males.",
	"Miss Douce of satin douced her arm away.",
	"O go away!",
	"she said.",
	"You’re very simple, I don’t think.",
	"He was.",
	"Well now I am, he mused.",
	"I looked so simple in the cradle they christened me simple Simon.",
	"You must have been a doaty, miss Douce made answer.",
	"And what did the doctor order today?",
	"Well now, he mused, whatever you say yourself.",
	"I think I’ll trouble you for some fresh water and a half glass of whisky.",
	"Jingle.",
	"With the greatest alacrity, miss Douce agreed.",
	"With grace of alacrity towards the mirror gilt Cantrell and Cochrane’s she turned herself.",
	"With grace she tapped a measure of gold whisky from her crystal keg.",
	"Forth from the skirt of his coat Mr Dedalus brought pouch and pipe.",
	"Alacrity she served.",
	"He blew through the flue two husky fifenotes.",
	"By Jove, he mused, I often wanted to see the Mourne mountains.",
	"Must be a great tonic in the air down there.",
	"But a long threatening comes at last, they say.",
	"Yes.",
	"Yes.",
	"Yes.",
	"He fingered shreds of hair, her maidenhair, her mermaid’s, into the bowl.",
	"Chips.",
	"Shreds.",
	"Musing.",
	"Mute.",
	"None nought said nothing.",
	"Yes.",
	"Gaily miss Douce polished a tumbler, trilling: O, Idolores, queen of the eastern seas!",
	"Was Mr Lidwell in today?",
	"In came Lenehan.",
	"Round him peered Lenehan.",
	"Mr Bloom reached Essex bridge.",
	"Yes, Mr Bloom crossed bridge of Yessex.",
	"To Martha I must write.",
	"Buy paper.",
	"Daly’s.",
	"Girl there civil.",
	"Bloom.",
	"Old Bloom.",
	"Blue bloom is on the rye.",
	"He was in at lunchtime, miss Douce said.",
	"Lenehan came forward.",
	"Was Mr Boylan looking for me?",
	"He asked.",
	"She answered: Miss Kennedy, was Mr Boylan in while I was upstairs?",
	"She asked.",
	"Miss voice of Kennedy answered, a second teacup poised, her gaze upon a page: No.",
	"He was not.",
	"Miss gaze of Kennedy, heard, not seen, read on.",
	"Lenehan round the sandwichbell wound his round body round.",
	"Peep!",
	"Who’s in the corner?",
	"No glance of Kennedy rewarding him he yet made overtures.",
	"To mind her stops.",
	"To read only the black ones: round o and crooked ess.",
	"Jingle jaunty jingle.",
	"Girlgold she read and did not glance.",
	"Take no notice.",
	"He droned in vain.",
	"Miss Douce turned to her tea aside.",
	"He sighed aside: Ah me!",
	"O my!",
	"He greeted Mr Dedalus and got a nod.",
	"Greetings from the famous son of a famous father.",
	"Who may he be?",
	"Mr Dedalus asked.",
	"Lenehan opened most genial arms.",
	"Who?",
	"Who may he be?",
	"he asked.",
	"Can you ask?",
	"Stephen, the youthful bard.",
	"Dry.",
	"Mr Dedalus, famous father, laid by his dry filled pipe.",
	"I see, he said.",
	"I didn’t recognise him for the moment.",
	"I hear he is keeping very select company.",
	"Have you seen him lately?",
	"He had.",
	"I quaffed the nectarbowl with him this very day, said Lenehan.",
	"In Mooney’s en ville and in Mooney’s sur mer.",
	"He had received the rhino for the labour of his muse.",
	"He smiled at bronze’s teabathed lips, at listening lips and eyes: The élite of Erin hung upon his lips.",
	"After an interval Mr Dedalus raised his grog and —That must have been highly diverting, said he.",
	"I see.",
	"He see.",
	"He drank.",
	"With faraway mourning mountain eye.",
	"Set down his glass.",
	"He looked towards the saloon door.",
	"I see you have moved the piano.",
	"Is that a fact?",
	"Didn’t he, miss Kennedy?",
	"The real classical, you know.",
	"And blind too, poor fellow.",
	"Not twenty I’m sure he was.",
	"Is that a fact?",
	"Mr Dedalus said.",
	"He drank and strayed away.",
	"So sad to look at his face, miss Douce condoled.",
	"God’s curse on bitch’s bastard.",
	"Tink to her pity cried a diner’s bell.",
	"To the door of the bar and diningroom came bald Pat, came bothered Pat, came Pat, waiter of Ormond.",
	"Lager for diner.",
	"Lager without alacrity she served.",
	"With patience Lenehan waited for Boylan with impatience, for jinglejaunty blazes boy.",
	"Upholding the lid he (who?)",
	"gazed in the coffin (coffin?)",
	"at the oblique triple (piano!)",
	"wires.",
	"Are you not happy in your home?",
	"Flower to console me and a pin cuts lo.",
	"Means something, language of flow.",
	"Was it a daisy?",
	"Innocence that is.",
	"Respectable girl meet after mass.",
	"Thanks awfully muchly.",
	"Wise Bloom eyed on the door a poster, a swaying mermaid smoking mid nice waves.",
	"Smoke mermaids, coolest whiff of all.",
	"Hair streaming: lovelorn.",
	"For some man.",
	"For Raoul.",
	"He eyed and saw afar on Essex bridge a gay hat riding on a jaunting car.",
	"It is.",
	"Again.",
	"Third time.",
	"Coincidence.",
	"Jingling on supple rubbers it jaunted from the bridge to Ormond quay.",
	"Follow.",
	"Risk it.",
	"Go quick.",
	"At four.",
	"Near now.",
	"Out.",
	"Twopence, sir, the shopgirl dared to say.",
	"Aha...",
	"I was forgetting...",
	"Excuse... —And four.",
	"At four she.",
	"Winsomely she on Bloohimwhom smiled.",
	"Bloo smi qui go.",
	"Ternoon.",
	"Think you’re the only pebble on the beach?",
	"Does that to all.",
	"For men.",
	"In drowsy silence gold bent on her page.",
	"From the saloon a call came, long in dying.",
	"That was a tuningfork the tuner had that he forgot that he now struck.",
	"A call again.",
	"That he now poised that it now throbbed.",
	"You hear?",
	"It throbbed, pure, purer, softly and softlier, its buzzing prongs.",
	"Longer in dying call.",
	"The bright stars fade... A voiceless song sang from within, singing: ... the morn is breaking.",
	"A duodene of birdnotes chirruped bright treble answer under sensitive hands.",
	"The dewdrops pearl... Lenehan’s lips over the counter lisped a low whistle of decoy.",
	"But look this way, he said, rose of Castile.",
	"Jingle jaunted by the curb and stopped.",
	"She rose and closed her reading, rose of Castile: fretted, forlorn, dreamily rose.",
	"Did she fall or was she pushed?",
	"he asked her.",
	"She answered, slighting: Ask no questions and you’ll hear no lies.",
	"Like lady, ladylike.",
	"Blazes Boylan’s smart tan shoes creaked on the barfloor where he strode.",
	"Yes, gold from anear by bronze from afar.",
	"Lenehan heard and knew and hailed him: See the conquering hero comes.",
	"Between the car and window, warily walking, went Bloom, unconquered hero.",
	"See me he might.",
	"The seat he sat on: warm.",
	"Black wary hecat walked towards Richie Goulding’s legal bag, lifted aloft, saluting.",
	"And I from thee... —I heard you were round, said Blazes Boylan.",
	"He touched to fair miss Kennedy a rim of his slanted straw.",
	"She smiled on him.",
	"But sister bronze outsmiled her, preening for him her richer hair, a bosom and a rose.",
	"Smart Boylan bespoke potions.",
	"What’s your cry?",
	"Glass of bitter?",
	"Glass of bitter, please, and a sloegin for me.",
	"Wire in yet?",
	"Not yet.",
	"At four she.",
	"Who said four?",
	"Cowley’s red lugs and bulging apple in the door of the sheriff’s office.",
	"Avoid.",
	"Goulding a chance.",
	"What is he doing in the Ormond?",
	"Car waiting.",
	"Wait.",
	"Hello.",
	"Where off to?",
	"Something to eat?",
	"I too was just.",
	"In here.",
	"What, Ormond?",
	"Best value in Dublin.",
	"Is that so?",
	"Diningroom.",
	"Sit tight there.",
	"See, not be seen.",
	"I think I’ll join you.",
	"Come on.",
	"Richie led on.",
	"Bloom followed bag.",
	"Dinner fit for a prince.",
	"O!",
	"O!",
	"jerked Lenehan, gasping at each stretch.",
	"O!",
	"But easily she seized her prey and led it low in triumph.",
	"Why don’t you grow?",
	"asked Blazes Boylan.",
	"), and syrupped with her voice: Fine goods in small parcels.",
	"That is to say she.",
	"Neatly she poured slowsyrupy sloe.",
	"Here’s fortune, Blazes said.",
	"He pitched a broad coin down.",
	"Coin rang.",
	"Hold on, said Lenehan, till I... —Fortune, he wished, lifting his bubbled ale.",
	"Sceptre will win in a canter, he said.",
	"I plunged a bit, said Boylan winking and drinking.",
	"Not on my own, you know.",
	"Fancy of a friend of mine.",
	"Idolores.",
	"The eastern seas.",
	"Clock whirred.",
	"Miss Kennedy passed their way (flower, wonder who gave), bearing away teatray.",
	"Clock clacked.",
	"Miss Douce took Boylan’s coin, struck boldly the cashregister.",
	"It clanged.",
	"Clock clacked.",
	"Fair one of Egypt teased and sorted in the till and hummed and handed coins in change.",
	"Look to the west.",
	"A clack.",
	"For me.",
	"What time is that?",
	"asked Blazes Boylan.",
	"Four?",
	"O’clock.",
	"Lenehan, small eyes ahunger on her humming, bust ahumming, tugged Blazes Boylan’s elbowsleeve.",
	"Let’s hear the time, he said.",
	"The bag of Goulding, Collis, Ward led Bloom by ryebloom flowered tables.",
	"Aimless he chose with agitated aim, bald Pat attending, a table near the door.",
	"Be near.",
	"At four.",
	"Has he forgotten?",
	"Perhaps a trick.",
	"Not come: whet appetite.",
	"I couldn’t do.",
	"Wait, wait.",
	"Pat, waiter, waited.",
	"Sparkling bronze azure eyed Blazure’s skyblue bow and eyes.",
	"Go on, pressed Lenehan.",
	"There’s no-one.",
	"He never heard.",
	"... to Flora’s lips did hie.",
	"High, a high note pealed in the treble clear.",
	"Bronzedouce communing with her rose that sank and rose sought Blazes Boylan’s flower and eyes.",
	"Please, please.",
	"He pleaded over returning phrases of avowal.",
	"I could not leave thee... —Afterwits, miss Douce promised coyly.",
	"No, now, urged Lenehan.",
	"Sonnez la cloche!",
	"O do!",
	"There’s no-one.",
	"She looked.",
	"Quick.",
	"Miss Kenn out of earshot.",
	"Sudden bent.",
	"Two kindling faces watched her bend.",
	"Quavering the chords strayed from the air, found it again, lost chord, and lost and found it, faltering.",
	"Go on!",
	"Do!",
	"Sonnez!",
	"Bending, she nipped a peak of skirt above her knee.",
	"Delayed.",
	"Taunted them still, bending, suspending, with wilful eyes.",
	"Sonnez!",
	"Smack.",
	"She set free sudden in rebound her nipped elastic garter smackwarm against her smackable a woman’s warmhosed thigh.",
	"La cloche!",
	"cried gleeful Lenehan.",
	"Trained by owner.",
	"No sawdust there.",
	"She smilesmirked supercilious (wept!",
	"aren’t men?",
	"), but, lightward gliding, mild she smiled on Boylan.",
	"You’re the essence of vulgarity, she in gliding said.",
	"Boylan, eyed, eyed.",
	"Tossed to fat lips his chalice, drank off his chalice tiny, sucking the last fat violet syrupy drops.",
	"Yes, bronze from anearby.",
	"... Sweetheart, goodbye!",
	"I’m off, said Boylan with impatience.",
	"He slid his chalice brisk away, grasped his change.",
	"Wait a shake, begged Lenehan, drinking quickly.",
	"I wanted to tell you.",
	"Tom Rochford... —Come on to blazes, said Blazes Boylan, going.",
	"Lenehan gulped to go.",
	"Got the horn or what?",
	"he said.",
	"Wait.",
	"I’m coming.",
	"How do you do, Mr Dollard?",
	"Eh?",
	"How do?",
	"How do?",
	"Ben Dollard’s vague bass answered, turning an instant from Father Cowley’s woe.",
	"He won’t give you any trouble, Bob.",
	"Alf Bergan will speak to the long fellow.",
	"We’ll put a barleystraw in that Judas Iscariot’s ear this time.",
	"Sighing Mr Dedalus came through the saloon, a finger soothing an eyelid.",
	"Hoho, we will, Ben Dollard yodled jollily.",
	"Come on, Simon.",
	"Give us a ditty.",
	"We heard the piano.",
	"Bald Pat, bothered waiter, waited for drink orders.",
	"Power for Richie.",
	"And Bloom?",
	"Let me see.",
	"Not make him walk twice.",
	"His corns.",
	"Four now.",
	"How warm this black is.",
	"Course nerves a bit.",
	"Refracts (is it?)",
	"heat.",
	"Let me see.",
	"Cider.",
	"Yes, bottle of cider.",
	"What’s that?",
	"Mr Dedalus said.",
	"I was only vamping, man.",
	"Come on, come on, Ben Dollard called.",
	"Begone dull care.",
	"Come, Bob.",
	"He ambled Dollard, bulky slops, before them (hold that fellow with the: hold him now) into the saloon.",
	"He plumped him Dollard on the stool.",
	"His gouty paws plumped chords.",
	"Plumped, stopped abrupt.",
	"Bald Pat in the doorway met tealess gold returning.",
	"Bothered, he wanted Power and cider.",
	"Bronze by the window, watched, bronze from afar.",
	"Jingle a tinkle jaunted.",
	"Bloom heard a jing, a little sound.",
	"He’s off.",
	"Light sob of breath Bloom sighed on the silent bluehued flowers.",
	"Jingling.",
	"He’s gone.",
	"Jingle.",
	"Hear.",
	"Love and War, Ben, Mr Dedalus said.",
	"God be with old times.",
	"Miss Douce’s brave eyes, unregarded, turned from the crossblind, smitten by sunlight.",
	"Gone.",
	"Pensive (who knows?",
	"), smitten (the smiting light), she lowered the dropblind with a sliding cord.",
	"She drew down pensive (why did he go so quick when I?)",
	"Poor old Goodwin was the pianist that night, Father Cowley reminded them.",
	"There was a slight difference of opinion between himself and the Collard grand.",
	"There was.",
	"A symposium all his own, Mr Dedalus said.",
	"The devil wouldn’t stop him.",
	"He was a crotchety old fellow in the primary stage of drink.",
	"God, do you remember?",
	"Ben bulky Dollard said, turning from the punished keyboard.",
	"And by Japers I had no wedding garment.",
	"They laughed all three.",
	"He had no wed. All trio laughed.",
	"No wedding garment.",
	"Our friend Bloom turned in handy that night, Mr Dedalus said.",
	"Where’s my pipe, by the way?",
	"He wandered back to the bar to the lost chord pipe.",
	"Bald Pat carried two diners’ drinks, Richie and Poldy.",
	"And Father Cowley laughed again.",
	"I saved the situation, Ben, I think.",
	"You did, averred Ben Dollard.",
	"I remember those tight trousers too.",
	"That was a brilliant idea, Bob.",
	"Father Cowley blushed to his brilliant purply lobes.",
	"He saved the situa.",
	"Tight trou.",
	"Brilliant ide.",
	"I knew he was on the rocks, he said.",
	"Do you remember?",
	"We had to search all Holles street to find them till the chap in Keogh’s gave us the number.",
	"Remember?",
	"Ben remembered, his broad visage wondering.",
	"By God, she had some luxurious operacloaks and things there.",
	"Mr Dedalus wandered back, pipe in hand.",
	"Merrion square style.",
	"Balldresses, by God, and court dresses.",
	"He wouldn’t take any money either.",
	"What?",
	"Any God’s quantity of cocked hats and boleros and trunkhose.",
	"What?",
	"Ay, ay, Mr Dedalus nodded.",
	"Mrs Marion Bloom has left off clothes of all descriptions.",
	"Jingle jaunted down the quays.",
	"Blazes sprawled on bounding tyres.",
	"Liver and bacon.",
	"Steak and kidney pie.",
	"Right, sir.",
	"Right, Pat.",
	"Mrs Marion.",
	"Met him pike hoses.",
	"Smell of burn.",
	"Of Paul de Kock.",
	"Nice name he.",
	"What’s this her name was?",
	"A buxom lassy.",
	"Marion... —Tweedy.",
	"Yes.",
	"Is she alive?",
	"And kicking.",
	"She was a daughter of... —Daughter of the regiment.",
	"Yes, begad.",
	"I remember the old drummajor.",
	"Mr Dedalus struck, whizzed, lit, puffed savoury puff after —Irish?",
	"I don’t know, faith.",
	"Is she, Simon?",
	"Puff after stiff, a puff, strong, savoury, crackling.",
	"Buccinator muscle is...",
	"What?...",
	"Bit rusty... O, she is... My Irish Molly, O.",
	"He puffed a pungent plumy blast.",
	"From the rock of Gibraltar... all the way.",
	"They pined in depth of ocean shadow, gold by the beerpull, bronze by maraschino, thoughtful all two.",
	"Mina Kennedy, 4 Lismore terrace, Drumcondra with Idolores, a queen, Dolores, silent.",
	"Pat served, uncovered dishes.",
	"Leopold cut liverslices.",
	"Bloom with Goulding, married in silence, ate.",
	"Dinners fit for princes.",
	"Horn.",
	"Have you the?",
	"Horn.",
	"Have you the?",
	"Haw haw horn.",
	"Over their voices Dollard bassooned attack, booming over bombarding chords: When love absorbs my ardent soul...",
	"Roll of Bensoulbenjamin rolled to the quivery loveshivery roofpanes.",
	"War!",
	"War!",
	"cried Father Cowley.",
	"You’re the warrior.",
	"So I am, Ben Warrior laughed.",
	"I was thinking of your landlord.",
	"Love or money.",
	"He stopped.",
	"He wagged huge beard, huge face over his blunder huge.",
	"In bearded abundant laughter Dollard shook upon the keyboard.",
	"He would.",
	"Not to mention another membrane, Father Cowley added.",
	"Half time, Ben.",
	"Amoroso ma non troppo.",
	"Let me there.",
	"Miss Kennedy served two gentlemen with tankards of cool stout.",
	"She passed a remark.",
	"It was indeed, first gentleman said, beautiful weather.",
	"They drank cool stout.",
	"Did she know where the lord lieutenant was going?",
	"And heard steelhoofs ringhoof ring.",
	"No, she couldn’t say.",
	"But it would be in the paper.",
	"O, she need not trouble.",
	"No trouble.",
	"She waved about her outspread Independent, searching, the lord lieutenant, her pinnacles of hair slowmoving, lord lieuten.",
	"Too much trouble, first gentleman said.",
	"O, not in the least.",
	"Way he looked that.",
	"Lord lieutenant.",
	"Gold by bronze heard iron steel.",
	"............ my ardent soul I care not foror the morrow.",
	"In liver gravy Bloom mashed mashed potatoes.",
	"Love and War someone is.",
	"Ben Dollard’s famous.",
	"Night he ran round to us to borrow a dress suit for that concert.",
	"Trousers tight as a drum on him.",
	"Musical porkers.",
	"Molly did laugh when he went out.",
	"Threw herself back across the bed, screaming, kicking.",
	"With all his belongings on show.",
	"O saints above, I’m drenched!",
	"O, the women in the front row!",
	"O, I never laughed so many!",
	"Well, of course that’s what gives him the base barreltone.",
	"For instance eunuchs.",
	"Wonder who’s playing.",
	"Nice touch.",
	"Must be Cowley.",
	"Musical.",
	"Knows whatever note you play.",
	"Bad breath he has, poor chap.",
	"Stopped.",
	"Miss Douce, engaging, Lydia Douce, bowed to suave solicitor, George Lidwell, gentleman, entering.",
	"Good afternoon.",
	"She gave her moist (a lady’s) hand to his firm clasp.",
	"Afternoon.",
	"Yes, she was back.",
	"To the old dingdong again.",
	"Your friends are inside, Mr Lidwell.",
	"George Lidwell, suave, solicited, held a lydiahand.",
	"Bloom ate liv as said before.",
	"Clean here at least.",
	"That chap in the Burton, gummy with gristle.",
	"No-one here: Goulding and I.",
	"Clean tables, flowers, mitres of napkins.",
	"Pat to and fro.",
	"Bald Pat.",
	"Nothing to do.",
	"Best value in Dub.",
	"Piano again.",
	"Cowley it is.",
	"Way he sits in to it, like one together, mutual understanding.",
	"Tiresome shapers scraping fiddles, eye on the bowend, sawing the cello, remind you of toothache.",
	"Her high long snore.",
	"Night we were in the box.",
	"Trombone under blowing like a grampus, between the acts, other brass chap unscrewing, emptying spittle.",
	"Conductor’s legs too, bagstrousers, jiggedy jiggedy.",
	"Do right to hide them.",
	"Jiggedy jingle jaunty jaunty.",
	"Only the harp.",
	"Lovely.",
	"Gold glowering light.",
	"Girl touched it.",
	"Poop of a lovely.",
	"Gravy’s rather good fit for a.",
	"Golden ship.",
	"Erin.",
	"The harp that once or twice.",
	"Cool hands.",
	"Ben Howth, the rhododendrons.",
	"We are their harps.",
	"I.",
	"He.",
	"Old.",
	"Young.",
	"Ah, I couldn’t, man, Mr Dedalus said, shy, listless.",
	"Strongly.",
	"Go on, blast you!",
	"Ben Dollard growled.",
	"Get it out in bits.",
	"M’appari, Simon, Father Cowley said.",
	"Down stage he strode some paces, grave, tall in affliction, his long arms outheld.",
	"Hoarsely the apple of his throat hoarsed softly.",
	"Softly he sang to a dusty seascape there: A Last Farewell.",
	"A headland, a ship, a sail upon the billows.",
	"Farewell.",
	"A lovely girl, her veil awave upon the wind upon the headland, wind around her.",
	"Go on, Simon.",
	"No, Simon, Father Cowley turned.",
	"Play it in the original.",
	"One flat.",
	"The keys, obedient, rose higher, told, faltered, confessed, confused.",
	"Up stage strode Father Cowley.",
	"Here, Simon, I’ll accompany you, he said.",
	"Get up.",
	"By Graham Lemon’s pineapple rock, by Elvery’s elephant jingly jogged.",
	"Steak, kidney, liver, mashed, at meat fit for princes sat princes Bloom and Goulding.",
	"Princes at meat they raised and drank, Power and cider.",
	"Most beautiful tenor air ever written, Richie said: Sonnambula.",
	"He heard Joe Maas sing that one night.",
	"Ah, what M’Guckin!",
	"Yes.",
	"In his way.",
	"Choirboy style.",
	"Maas was the boy.",
	"Massboy.",
	"A lyrical tenor if you like.",
	"Never forget it.",
	"Never.",
	"Tenderly Bloom over liverless bacon saw the tightened features strain.",
	"Backache he.",
	"Bright’s bright eye.",
	"Next item on the programme.",
	"Paying the piper.",
	"Pills, pounded bread, worth a guinea a box.",
	"Stave it off awhile.",
	"Sings too: Down among the dead men.",
	"Appropriate.",
	"Kidney pie.",
	"Sweets to the.",
	"Not making much hand of it.",
	"Best value in.",
	"Characteristic of him.",
	"Power.",
	"Particular about his drink.",
	"Flaw in the glass, fresh Vartry water.",
	"Fecking matches from counters to save.",
	"Then squander a sovereign in dribs and drabs.",
	"And when he’s wanted not a farthing.",
	"Screwed refusing to pay his fare.",
	"Curious types.",
	"Never would Richie forget that night.",
	"As long as he lived: never.",
	"In the gods of the old Royal with little Peake.",
	"And when the first note.",
	"Speech paused on Richie’s lips.",
	"Coming out with a whopper now.",
	"Rhapsodies about damn all.",
	"Believes his own lies.",
	"Does really.",
	"Wonderful liar.",
	"But want a good memory.",
	"Which air is that?",
	"asked Leopold Bloom.",
	"All is lost now.",
	"Richie cocked his lips apout.",
	"A low incipient note sweet banshee murmured: all.",
	"A thrush.",
	"A throstle.",
	"His breath, birdsweet, good teeth he’s proud of, fluted with plaintive woe.",
	"Is lost.",
	"Rich sound.",
	"Two notes in one there.",
	"Blackbird I heard in the hawthorn valley.",
	"Taking my motives he twined and turned them.",
	"All most too new call is lost in all.",
	"Echo.",
	"How sweet the answer.",
	"How is that done?",
	"All lost now.",
	"Mournful he whistled.",
	"Fall, surrender, lost.",
	"Bloom bent leopold ear, turning a fringe of doyley down under the vase.",
	"Order.",
	"Yes, I remember.",
	"Lovely air.",
	"In sleep she went to him.",
	"Innocence in the moon.",
	"Brave.",
	"Don’t know their danger.",
	"Still hold her back.",
	"Call name.",
	"Touch water.",
	"Jingle jaunty.",
	"Too late.",
	"She longed to go.",
	"That’s why.",
	"Woman.",
	"As easy stop the sea.",
	"Yes: all is lost.",
	"A beautiful air, said Bloom lost Leopold.",
	"I know it well.",
	"Never in all his life had Richie Goulding.",
	"He knows it well too.",
	"Or he feels.",
	"Still harping on his daughter.",
	"Wise child that knows her father, Dedalus said.",
	"Me?",
	"Bloom askance over liverless saw.",
	"Face of the all is lost.",
	"Rollicking Richie once.",
	"Jokes old stale now.",
	"Wagging his ear.",
	"Napkinring in his eye.",
	"Now begging letters he sends his son with.",
	"Crosseyed Walter sir I did sir.",
	"Wouldn’t trouble only I was expecting some money.",
	"Apologise.",
	"Piano again.",
	"Sounds better than last time I heard.",
	"Tuned probably.",
	"Stopped again.",
	"Dollard and Cowley still urged the lingering singer out with it.",
	"With it, Simon.",
	"It, Simon.",
	"Ladies and gentlemen, I am most deeply obliged by your kind solicitations.",
	"It, Simon.",
	"The harping chords of prelude closed.",
	"A chord, longdrawn, expectant, drew a voice away.",
	"When first I saw that form endearing... Richie turned.",
	"Si Dedalus’ voice, he said.",
	"Braintipped, cheek touched with flame, they listened feeling that flow endearing flow over skin limbs human heart soul spine.",
	"The door of the bar.",
	"So.",
	"That will do.",
	"Pat, waiter, waited, waiting to hear, for he was hard of hear by the door.",
	"Sorrow from me seemed to depart.",
	"Good, good to hear: sorrow from them each seemed to from both depart when first they heard.",
	"Love that is singing: love’s old sweet song.",
	"Bloom unwound slowly the elastic band of his packet.",
	"Love’s old sweet sonnez la gold.",
	"Full of hope and all delighted... Tenors get women by the score.",
	"Increase their flow.",
	"Throw flower at his feet.",
	"When will we meet?",
	"My head it simply.",
	"Jingle all delighted.",
	"He can’t sing for tall hats.",
	"Your head it simply swurls.",
	"Perfumed for him.",
	"What perfume does your wife?",
	"I want to know.",
	"Jing.",
	"Stop.",
	"Knock.",
	"Last look at mirror always before she answers the door.",
	"The hall.",
	"There?",
	"How do you?",
	"I do well.",
	"There?",
	"What?",
	"Or?",
	"Phial of cachous, kissing comfits, in her satchel.",
	"Yes?",
	"Hands felt for the opulent.",
	"Alas the voice rose, sighing, changed: loud, full, shining, proud.",
	"But alas, ‘twas idle dreaming... Glorious tone he has still.",
	"Cork air softer also their brogue.",
	"Silly man!",
	"Could have made oceans of money.",
	"Singing wrong words.",
	"Wore out his wife: now sings.",
	"But hard to tell.",
	"Only the two themselves.",
	"If he doesn’t break down.",
	"Keep a trot for the avenue.",
	"His hands and feet sing too.",
	"Drink.",
	"Nerves overstrung.",
	"Must be abstemious to sing.",
	"Jenny Lind soup: stock, sage, raw eggs, half pint of cream.",
	"For creamy dreamy.",
	"Tenderness it welled: slow, swelling, full it throbbed.",
	"That’s the chat.",
	"Ha, give!",
	"Take!",
	"Throb, a throb, a pulsing proud erect.",
	"Words?",
	"Music?",
	"No: it’s what’s behind.",
	"Bloom looped, unlooped, noded, disnoded.",
	"Bloom.",
	"Flood of warm jamjam lickitup secretness flowed to flow in music out, in desire, dark to lick flow invading.",
	"Tipping her tepping her tapping her topping her.",
	"Tup.",
	"Pores to dilate dilating.",
	"Tup.",
	"The joy the feel the warm the.",
	"Tup.",
	"To pour o’er sluices pouring gushes.",
	"Flood, gush, flow, joygush, tupthrob.",
	"Now!",
	"Language of love.",
	"... ray of hope is... Beaming.",
	"Lydia for Lidwell squeak scarcely hear so ladylike the muse unsqueaked a ray of hopk.",
	"Martha it is.",
	"Coincidence.",
	"Just going to write.",
	"Lionel’s song.",
	"Lovely name you have.",
	"Can’t write.",
	"Accept my little pres.",
	"Play on her heartstrings pursestrings too.",
	"She’s a. I called you naughty boy.",
	"Still the name: Martha.",
	"How strange!",
	"Today.",
	"The voice of Lionel returned, weaker but unwearied.",
	"It sang again to Richie Poldy Lydia Lidwell also sang to Pat open mouth ear waiting to wait.",
	"Wish I could see his face, though.",
	"Explain better.",
	"Why the barber in Drago’s always looked my face when I spoke his face in the glass.",
	"Still hear it better here than in the bar though farther.",
	"Each graceful look... First night when first I saw her at Mat Dillon’s in Terenure.",
	"Yellow, black lace she wore.",
	"Musical chairs.",
	"We two the last.",
	"Fate.",
	"After her.",
	"Fate.",
	"Round and round slow.",
	"Quick round.",
	"We two.",
	"All looked.",
	"Halt.",
	"Down she sat.",
	"All ousted looked.",
	"Lips laughing.",
	"Yellow knees.",
	"Charmed my eye... Singing.",
	"Waiting she sang.",
	"I turned her music.",
	"Full voice of perfume of what perfume does your lilactrees.",
	"Bosom I saw, both full, throat warbling.",
	"First I saw.",
	"She thanked me.",
	"Why did she me?",
	"Fate.",
	"Spanishy eyes.",
	"Under a peartree alone patio this hour in old Madrid one side in shadow Dolores shedolores.",
	"At me.",
	"Luring.",
	"Ah, alluring.",
	"Martha!",
	"Ah, Martha!",
	"In cry of lionel loneliness that she should know, must martha feel.",
	"For only her he waited.",
	"Where?",
	"Here there try there here all try where.",
	"Somewhere.",
	"Co-ome, thou lost one!",
	"Co-ome, thou dear one!",
	"Alone.",
	"One love.",
	"One hope.",
	"One comfort me.",
	"Martha, chestnote, return!",
	"Come!",
	"Siopold!",
	"Consumed.",
	"Come.",
	"Well sung.",
	"All clapped.",
	"She ought to.",
	"Come.",
	"To me, to him, to her, you too, me, us.",
	"Bravo!",
	"Clapclap.",
	"Good man, Simon.",
	"Clappyclapclap.",
	"Encore!",
	"Clapclipclap clap.",
	"Sound as a bell.",
	"Bravo, Simon!",
	"Clapclopclap.",
	"Blazes Boylan’s smart tan shoes creaked on the barfloor, said before.",
	"Atrot, in heat, heatseated.",
	"Cloche.",
	"Sonnez la.",
	"Cloche.",
	"Sonnez la.",
	"Slower the mare went up the hill by the Rotunda, Rutland square.",
	"Too slow for Boylan, blazes Boylan, impatience Boylan, joggled the mare.",
	"An afterclang of Cowley’s chords closed, died on the air made richer.",
	"Miss Kennedy smirked, disserving, coral lips, at first, at second.",
	"She did not mind.",
	"Seven days in jail, Ben Dollard said, on bread and water.",
	"Then you’d sing, Simon, like a garden thrush.",
	"Lionel Simon, singer, laughed.",
	"Father Bob Cowley played.",
	"Mina Kennedy served.",
	"Second gentleman paid.",
	"Tom Kernan strutted in.",
	"Lydia, admired, admired.",
	"But Bloom sang dumb.",
	"Admiring.",
	"Richie, admiring, descanted on that man’s glorious voice.",
	"He remembered one night long ago.",
	"Never forget that night.",
	"Si sang ‘Twas rank and fame: in Ned Lambert’s ‘twas.",
	"Brothers-in-law: relations.",
	"We never speak as we pass by.",
	"Rift in the lute I think.",
	"Treats him with scorn.",
	"See.",
	"He admires him all the more.",
	"The night Si sang.",
	"The human voice, two tiny silky chords, wonderful, more than all others.",
	"That voice was a lamentation.",
	"Calmer now.",
	"It’s in the silence after you feel you hear.",
	"Vibrations.",
	"Now silent air.",
	"Bloom ungyved his crisscrossed hands and with slack fingers plucked the slender catgut thong.",
	"He drew and plucked.",
	"It buzz, it twanged.",
	"While big Ben Dollard talked with Simon Dedalus, lighting, who nodded as he smoked, who smoked.",
	"Thou lost one.",
	"All songs on that theme.",
	"Yet more Bloom stretched his string.",
	"Cruel it seems.",
	"Let people get fond of each other: lure them on.",
	"Then tear asunder.",
	"Death.",
	"Explos.",
	"Knock on the head.",
	"Outtohelloutofthat.",
	"Human life.",
	"Dignam.",
	"Ugh, that rat’s tail wriggling!",
	"Five bob I gave.",
	"Corpus paradisum.",
	"Corncrake croaker: belly like a poisoned pup.",
	"Gone.",
	"They sing.",
	"Forgotten.",
	"I too.",
	"And one day she with.",
	"Leave her: get tired.",
	"Suffer then.",
	"Snivel.",
	"Big spanishy eyes goggling at nothing.",
	"Her wavy heavey hair uncombed.",
	"Yet too much happy bores.",
	"He stretched more, more.",
	"Are you not happy in your?",
	"Twang.",
	"It snapped.",
	"Jingle into Dorset street.",
	"Miss Douce withdrew her satiny arm, reproachful, pleased.",
	"Don’t make half so free, said she, till we are better acquainted.",
	"George Lidwell told her really and truly: but she did not believe.",
	"First gentleman told Mina that was so.",
	"She asked him was that so.",
	"And second tankard told her so.",
	"That that was so.",
	"Better write it here.",
	"Quills in the postoffice chewed and twisted.",
	"Bald Pat at a sign drew nigh.",
	"A pen and ink.",
	"He went.",
	"A pad.",
	"He went.",
	"A pad to blot.",
	"He heard, deaf Pat.",
	"Yes, Mr Bloom said, teasing the curling catgut line.",
	"It certainly is.",
	"Few lines will do.",
	"My present.",
	"All that Italian florid music is.",
	"Who is this wrote?",
	"Know the name you know better.",
	"Take out sheet notepaper, envelope: unconcerned.",
	"It’s so characteristic.",
	"Grandest number in the whole opera, Goulding said.",
	"It is, Bloom said.",
	"Numbers it is.",
	"All music when you come to think.",
	"Two multiplied by two divided by half is twice one.",
	"Vibrations: chords those are.",
	"One plus two plus six is seven.",
	"Do anything you like with figures juggling.",
	"Always find out this equal to that.",
	"Symmetry under a cemetery wall.",
	"He doesn’t see my mourning.",
	"Callous: all for his own gut.",
	"Musemathematics.",
	"And you think you’re listening to the etherial.",
	"But suppose you said it like: Martha, seven times nine minus x is thirtyfive thousand.",
	"Fall quite flat.",
	"It’s on account of the sounds it is.",
	"Instance he’s playing now.",
	"Improvising.",
	"Might be what you like, till you hear the words.",
	"Want to listen sharp.",
	"Hard.",
	"Begin all right: then hear chords a bit off: feel lost a bit.",
	"In and out of sacks, over barrels, through wirefences, obstacle race.",
	"Time makes the tune.",
	"Question of mood you’re in.",
	"Still always nice to hear.",
	"Except scales up and down, girls learning.",
	"Two together nextdoor neighbours.",
	"Ought to invent dummy pianos for that.",
	"Blumenlied I bought for her.",
	"The name.",
	"Playing it slow, a girl, night I came home, the girl.",
	"Door of the stables near Cecilia street.",
	"Milly no taste.",
	"Queer because we both, I mean.",
	"Bald deaf Pat brought quite flat pad ink.",
	"Pat set with ink pen quite flat pad.",
	"Pat took plate dish knife fork.",
	"Pat went.",
	"It was the only language Mr Dedalus said to Ben.",
	"He heard them as a boy in Ringabella, Crosshaven, Ringabella, singing their barcaroles.",
	"Queenstown harbour full of Italian ships.",
	"Walking, you know, Ben, in the moonlight with those earthquake hats.",
	"Blending their voices.",
	"God, such music, Ben.",
	"Heard as a boy.",
	"Cross Ringabella haven mooncarole.",
	"Down the edge of his Freeman baton ranged Bloom’s, your other eye, scanning for where did I see that.",
	"Callan, Coleman, Dignam Patrick.",
	"Heigho!",
	"Heigho!",
	"Fawcett.",
	"Aha!",
	"Just I was looking... Hope he’s not looking, cute as a rat.",
	"He held unfurled his Freeman.",
	"Can’t see now.",
	"Remember write Greek ees.",
	"Bloom dipped, Bloo mur: dear sir.",
	"Dear Henry wrote: dear Mady.",
	"Got your lett and flow.",
	"Hell did I put?",
	"Some pock or oth.",
	"It is utterl imposs.",
	"Underline imposs.",
	"To write today.",
	"Bore this.",
	"Bored Bloom tambourined gently with I am just reflecting fingers on flat pad Pat brought.",
	"On.",
	"Know what I mean.",
	"No, change that ee.",
	"Accep my poor litt pres enclos.",
	"Ask her no answ.",
	"Hold on.",
	"Five Dig.",
	"Two about here.",
	"Penny the gulls.",
	"Elijah is com.",
	"Seven Davy Byrne’s.",
	"Is eight about.",
	"Say half a crown.",
	"My poor little pres: p. o. two and six.",
	"Write me a long.",
	"Do you despise?",
	"Jingle, have you the?",
	"So excited.",
	"Why do you call me naught?",
	"You naughty too?",
	"O, Mairy lost the string of her.",
	"Bye for today.",
	"Yes, yes, will tell you.",
	"Want to.",
	"To keep it up.",
	"Call me that other.",
	"Other world she wrote.",
	"My patience are exhaust.",
	"To keep it up.",
	"You must believe.",
	"Believe.",
	"The tank.",
	"It.",
	"Is.",
	"True.",
	"Folly am I writing?",
	"Husbands don’t.",
	"That’s marriage does, their wives.",
	"Because I’m away from.",
	"Suppose.",
	"But how?",
	"She must.",
	"Keep young.",
	"If she found out.",
	"Card in my high grade ha.",
	"No, not tell all.",
	"Useless pain.",
	"If they don’t see.",
	"Woman.",
	"Sauce for the gander.",
	"Eh?",
	"This is the jingle that joggled and jingled.",
	"By Dlugacz’ porkshop bright tubes of Agendath trotted a gallantbuttocked mare.",
	"Answering an ad?",
	"keen Richie’s eyes asked Bloom.",
	"Yes, Mr Bloom said.",
	"Town traveller.",
	"Nothing doing, I expect.",
	"Bloom mur: best references.",
	"But Henry wrote: it will excite me.",
	"You know how.",
	"In haste.",
	"Henry.",
	"Greek ee.",
	"Better add postscript.",
	"What is he playing now?",
	"Improvising.",
	"Intermezzo.",
	"P. S. The rum tum tum.",
	"How will you pun?",
	"You punish me?",
	"Crooked skirt swinging, whack by.",
	"Tell me I want to.",
	"Know.",
	"O.",
	"Course if I didn’t I wouldn’t ask.",
	"La la la ree.",
	"Trails off there sad in minor.",
	"Why minor sad?",
	"Sign H. They like sad tail at end.",
	"P. P. S. La la la ree.",
	"I feel so sad today.",
	"La ree.",
	"So lonely.",
	"Dee.",
	"He blotted quick on pad of Pat.",
	"Envel.",
	"Address.",
	"Just copy out of paper.",
	"Murmured: Messrs Callan, Coleman and Co, limited.",
	"Henry wrote: Miss Martha Clifford c/o P. O. Dolphin’s Barn Lane Dublin.",
	"Blot over the other so he can’t read.",
	"There.",
	"Right.",
	"Idea prize titbit.",
	"Something detective read off blottingpad.",
	"Payment at the rate of guinea per col. Matcham often thinks the laughing witch.",
	"Poor Mrs Purefoy.",
	"U.p.",
	": up.",
	"Too poetical that about the sad.",
	"Music did that.",
	"Music hath charms.",
	"Shakespeare said.",
	"Quotations every day in the year.",
	"To be or not to be.",
	"Wisdom while you wait.",
	"In Gerard’s rosery of Fetter lane he walks, greyedauburn.",
	"One life is all.",
	"One body.",
	"Do.",
	"But do.",
	"Done anyhow.",
	"Postal order, stamp.",
	"Postoffice lower down.",
	"Walk now.",
	"Enough.",
	"Barney Kiernan’s I promised to meet them.",
	"Dislike that job.",
	"House of mourning.",
	"Walk.",
	"Pat!",
	"Doesn’t hear.",
	"Deaf beetle he is.",
	"Car near there now.",
	"Talk.",
	"Talk.",
	"Pat!",
	"Doesn’t.",
	"Settling those napkins.",
	"Lot of ground he must cover in the day.",
	"Paint face behind on him then he’d be two.",
	"Wish they’d sing more.",
	"Keep my mind off.",
	"Bald Pat who is bothered mitred the napkins.",
	"Pat is a waiter hard of his hearing.",
	"Pat is a waiter who waits while you wait.",
	"Hee hee hee hee.",
	"He waits while you wait.",
	"Hee hee.",
	"A waiter is he.",
	"Hee hee hee hee.",
	"He waits while you wait.",
	"While you wait if you wait he will wait while you wait.",
	"Hee hee hee hee.",
	"Hoh.",
	"Wait while you wait.",
	"Douce now.",
	"Douce Lydia.",
	"Bronze and rose.",
	"She had a gorgeous, simply gorgeous, time.",
	"And look at the lovely shell she brought.",
	"Listen!",
	"she bade him.",
	"Under Tom Kernan’s ginhot words the accompanist wove music slow.",
	"Authentic fact.",
	"How Walter Bapty lost his voice.",
	"Well, sir, the husband took him by the throat.",
	"Scoundrel, said he, You’ll sing no more lovesongs.",
	"He did, faith, sir Tom.",
	"Bob Cowley wove.",
	"Tenors get wom.",
	"Cowley lay back.",
	"Ah, now he heard, she holding it to his ear.",
	"Hear!",
	"He heard.",
	"Wonderful.",
	"She held it to her own.",
	"And through the sifted light pale gold in contrast glided.",
	"To hear.",
	"Tap.",
	"Bloom through the bardoor saw a shell held at their ears.",
	"Bronze by a weary gold, anear, afar, they listened.",
	"Her ear too is a shell, the peeping lobe there.",
	"Been to the seaside.",
	"Lovely seaside girls.",
	"Skin tanned raw.",
	"Should have put on coldcream first make it brown.",
	"Buttered toast.",
	"O and that lotion mustn’t forget.",
	"Fever near her mouth.",
	"Your head it simply.",
	"Hair braided over: shell with seaweed.",
	"Why do they hide their ears with seaweed hair?",
	"And Turks the mouth, why?",
	"Her eyes over the sheet.",
	"Yashmak.",
	"Find the way in.",
	"A cave.",
	"No admittance except on business.",
	"The sea they think they hear.",
	"Singing.",
	"A roar.",
	"The blood it is.",
	"Souse in the ear sometimes.",
	"Well, it’s a sea.",
	"Corpuscle islands.",
	"Wonderful really.",
	"So distinct.",
	"Again.",
	"George Lidwell held its murmur, hearing: then laid it by, gently.",
	"What are the wild waves saying?",
	"he asked her, smiled.",
	"Charming, seasmiling and unanswering Lydia on Lidwell smiled.",
	"Tap.",
	"By Larry O’Rourke’s, by Larry, bold Larry O’, Boylan swayed and Boylan turned.",
	"From the forsaken shell miss Mina glided to her tankards waiting.",
	"No, she was not so lonely archly miss Douce’s head let Mr Lidwell know.",
	"Walks in the moonlight by the sea.",
	"No, not alone.",
	"With whom?",
	"She nobly answered: with a gentleman friend.",
	"Bob Cowley’s twinkling fingers in the treble played again.",
	"The landlord has the prior.",
	"A little time.",
	"Long John.",
	"Big Ben.",
	"One: one, one, one, one, one: two, one, three, four.",
	"Sea, wind, leaves, thunder, waters, cows lowing, the cattlemarket, cocks, hens don’t crow, snakes hissss.",
	"There’s music everywhere.",
	"Ruttledge’s door: ee creaking.",
	"No, that’s noise.",
	"Minuet of Don Giovanni he’s playing now.",
	"Court dresses of all descriptions in castle chambers dancing.",
	"Misery.",
	"Peasants outside.",
	"Green starving faces eating dockleaves.",
	"Nice that is.",
	"Look: look, look, look, look, look: you look at us.",
	"That’s joyful I can feel.",
	"Never have written it.",
	"Why?",
	"My joy is other joy.",
	"But both are joys.",
	"Yes, joy it must be.",
	"Mere fact of music shows you are.",
	"Often thought she was in the dumps till she began to lilt.",
	"Then know.",
	"M’Coy valise.",
	"My wife and your wife.",
	"Squealing cat.",
	"Like tearing silk.",
	"Tongue when she talks like the clapper of a bellows.",
	"They can’t manage men’s intervals.",
	"Gap in their voices too.",
	"Fill me.",
	"I’m warm, dark, open.",
	"Molly in quis est homo: Mercadante.",
	"My ear against the wall to hear.",
	"Want a woman who can deliver the goods.",
	"Jog jig jogged stopped.",
	"Dandy tan shoe of dandy Boylan socks skyblue clocks came light to earth.",
	"O, look we are so!",
	"Chamber music.",
	"Could make a kind of pun on that.",
	"It is a kind of music I often thought when she.",
	"Acoustics that is.",
	"Tinkling.",
	"Empty vessels make most noise.",
	"Like those rhapsodies of Liszt’s, Hungarian, gipsyeyed.",
	"Pearls.",
	"Drops.",
	"Rain.",
	"Diddleiddle addleaddle ooddleooddle.",
	"Hissss.",
	"Now.",
	"Maybe now.",
	"Before.",
	"Cockcock.",
	"Tap.",
	"Qui sdegno, Ben, said Father Cowley.",
	"No, Ben, Tom Kernan interfered.",
	"The Croppy Boy.",
	"Our native Doric.",
	"Ay do, Ben, Mr Dedalus said.",
	"Good men and true.",
	"Do, do, they begged in one.",
	"I’ll go.",
	"Here, Pat, return.",
	"Come.",
	"He came, he came, he did not stay.",
	"To me.",
	"How much?",
	"What key?",
	"Six sharps?",
	"F sharp major, Ben Dollard said.",
	"Bob Cowley’s outstretched talons griped the black deepsounding chords.",
	"Must go prince Bloom told Richie prince.",
	"No, Richie said.",
	"Yes, must.",
	"Got money somewhere.",
	"He’s on for a razzle backache spree.",
	"Much?",
	"He seehears lipspeech.",
	"One and nine.",
	"Penny for yourself.",
	"Here.",
	"Give him twopence tip.",
	"Deaf, bothered.",
	"But perhaps he has wife and family waiting, waiting Patty come home.",
	"Hee hee hee hee.",
	"Deaf wait while they wait.",
	"But wait.",
	"But hear.",
	"Chords dark.",
	"Lugugugubrious.",
	"Low.",
	"In a cave of the dark middle earth.",
	"Embedded ore. Lumpmusic.",
	"The priest he sought.",
	"With him would he speak a word.",
	"Tap.",
	"Ben Dollard’s voice.",
	"Base barreltone.",
	"Doing his level best to say it.",
	"Croak of vast manless moonless womoonless marsh.",
	"Other comedown.",
	"Big ships’ chandler’s business he did once.",
	"Remember: rosiny ropes, ships’ lanterns.",
	"Failed to the tune of ten thousand pounds.",
	"Now in the Iveagh home.",
	"Cubicle number so and so.",
	"Number one Bass did that for him.",
	"The priest’s at home.",
	"A false priest’s servant bade him welcome.",
	"Step in.",
	"The holy father.",
	"With bows a traitor servant.",
	"Curlycues of chords.",
	"Ruin them.",
	"Wreck their lives.",
	"Then build them cubicles to end their days in.",
	"Hushaby.",
	"Lullaby.",
	"Die, dog.",
	"Little dog, die.",
	"Decent soul.",
	"Bit addled now.",
	"Thinks he’ll win in Answers, poets’ picture puzzle.",
	"We hand you crisp five pound note.",
	"Bird sitting hatching in a nest.",
	"Lay of the last minstrel he thought it was.",
	"See blank tee what domestic animal?",
	"Tee dash ar most courageous mariner.",
	"Good voice he has still.",
	"No eunuch yet with all his belongings.",
	"Listen.",
	"Bloom listened.",
	"Richie Goulding listened.",
	"And by the door deaf Pat, bald Pat, tipped Pat, listened.",
	"The chords harped slower.",
	"The voice of penance and of grief came slow, embellished, tremulous.",
	"Ben’s contrite beard confessed.",
	"in nomine Domini, in God’s name he knelt.",
	"He beat his hand upon his breast, confessing: mea culpa.",
	"Latin again.",
	"That holds them like birdlime.",
	"Priest with the communion corpus for those women.",
	"Chap in the mortuary, coffin or coffey, corpusnomine.",
	"Wonder where that rat is by now.",
	"Scrape.",
	"Tap.",
	"They listened.",
	"Tankards and miss Kennedy.",
	"George Lidwell, eyelid well expressive, fullbusted satin.",
	"Kernan.",
	"Si.",
	"The sighing voice of sorrow sang.",
	"His sins.",
	"Since Easter he had cursed three times.",
	"You bitch’s bast.",
	"And once at masstime he had gone to play.",
	"Once by the churchyard he had passed and for his mother’s rest he had not prayed.",
	"A boy.",
	"A croppy boy.",
	"Bronze, listening, by the beerpull gazed far away.",
	"Soulfully.",
	"Doesn’t half know I’m.",
	"Molly great dab at seeing anyone looking.",
	"Bronze gazed far sideways.",
	"Mirror there.",
	"Is that best side of her face?",
	"They always know.",
	"Knock at the door.",
	"Last tip to titivate.",
	"Cockcarracarra.",
	"What do they think when they hear music?",
	"Way to catch rattlesnakes.",
	"Night Michael Gunn gave us the box.",
	"Tuning up.",
	"Shah of Persia liked that best.",
	"Remind him of home sweet home.",
	"Wiped his nose in curtain too.",
	"Custom his country perhaps.",
	"That’s music too.",
	"Not as bad as it sounds.",
	"Tootling.",
	"Brasses braying asses through uptrunks.",
	"Doublebasses helpless, gashes in their sides.",
	"Woodwinds mooing cows.",
	"Semigrand open crocodile music hath jaws.",
	"Woodwind like Goodwin’s name.",
	"She looked fine.",
	"Her crocus dress she wore lowcut, belongings on show.",
	"Clove her breath was always in theatre when she bent to ask a question.",
	"Told her what Spinoza says in that book of poor papa’s.",
	"Hypnotised, listening.",
	"Eyes like that.",
	"She bent.",
	"Chap in dresscircle staring down into her with his operaglass for all he was worth.",
	"Beauty of music you must hear twice.",
	"Nature woman half a look.",
	"God made the country man the tune.",
	"Met him pike hoses.",
	"Philosophy.",
	"O rocks!",
	"All gone.",
	"All fallen.",
	"At the siege of Ross his father, at Gorey all his brothers fell.",
	"To Wexford, we are the boys of Wexford, he would.",
	"Last of his name and race.",
	"I too.",
	"Last of my race.",
	"Milly young student.",
	"Well, my fault perhaps.",
	"No son.",
	"Rudy.",
	"Too late now.",
	"Or if not?",
	"If not?",
	"If still?",
	"He bore no hate.",
	"Hate.",
	"Love.",
	"Those are names.",
	"Rudy.",
	"Soon I am old.",
	"Big Ben his voice unfolded.",
	"Great voice Richie Goulding said, a flush struggling in his pale, to Bloom soon old.",
	"But when was young?",
	"Ireland comes now.",
	"My country above the king.",
	"She listens.",
	"Who fears to speak of nineteen four?",
	"Time to be shoving.",
	"Looked enough.",
	"Bless me, father, Dollard the croppy cried.",
	"Bless me and let me go.",
	"Tap.",
	"Bloom looked, unblessed to go.",
	"Got up to kill: on eighteen bob a week.",
	"Fellows shell out the dibs.",
	"Want to keep your weathereye open.",
	"Those girls, those lovely.",
	"By the sad sea waves.",
	"Chorusgirl’s romance.",
	"Letters read out for breach of promise.",
	"From Chickabiddy’s owny Mumpsypum.",
	"Laughter in court.",
	"Henry.",
	"I never signed it.",
	"The lovely name you.",
	"Low sank the music, air and words.",
	"Then hastened.",
	"The false priest rustling soldier from his cassock.",
	"A yeoman captain.",
	"They know it all by heart.",
	"The thrill they itch for.",
	"Yeoman cap.",
	"Tap.",
	"Tap.",
	"Thrilled she listened, bending in sympathy to hear.",
	"Blank face.",
	"Virgin should say: or fingered only.",
	"Write something on it: page.",
	"If not what becomes of them?",
	"Decline, despair.",
	"Keeps them young.",
	"Even admire themselves.",
	"See.",
	"Play on her.",
	"Lip blow.",
	"Body of white woman, a flute alive.",
	"Blow gentle.",
	"Loud.",
	"Three holes, all women.",
	"Goddess I didn’t see.",
	"They want it.",
	"Not too much polite.",
	"That’s why he gets them.",
	"Gold in your pocket, brass in your face.",
	"Say something.",
	"Make her hear.",
	"With look to look.",
	"Songs without words.",
	"Molly, that hurdygurdy boy.",
	"She knew he meant the monkey was sick.",
	"Or because so like the Spanish.",
	"Understand animals too that way.",
	"Solomon did.",
	"Gift of nature.",
	"Ventriloquise.",
	"My lips closed.",
	"Think in my stom.",
	"What?",
	"Will?",
	"You?",
	"I.",
	"Want.",
	"You.",
	"To.",
	"With hoarse rude fury the yeoman cursed, swelling in apoplectic bitch’s bastard.",
	"A good thought, boy, to come.",
	"One hour’s your time to live, your last.",
	"Tap.",
	"Tap.",
	"Thrill now.",
	"Pity they feel.",
	"To wipe away a tear for martyrs that want to, dying to, die.",
	"For all things dying, for all things born.",
	"Poor Mrs Purefoy.",
	"Hope she’s over.",
	"Because their wombs.",
	"A liquid of womb of woman eyeball gazed under a fence of lashes, calmly, hearing.",
	"See real beauty of the eye when she not speaks.",
	"On yonder river.",
	"At each slow satiny heaving bosom’s wave (her heaving embon) red rose rose slowly sank red rose.",
	"Heartbeats: her breath: breath that is life.",
	"And all the tiny tiny fernfoils trembled of maidenhair.",
	"But look.",
	"The bright stars fade.",
	"O rose!",
	"Castile.",
	"The morn.",
	"Ha.",
	"Lidwell.",
	"For him then not for.",
	"Infatuated.",
	"I like that?",
	"See her from here though.",
	"Popped corks, splashes of beerfroth, stacks of empties.",
	"On the smooth jutting beerpull laid Lydia hand, lightly, plumply, leave it to my hands.",
	"All lost in pity for croppy.",
	"With a cock with a carra.",
	"Tap.",
	"Tap.",
	"Tap.",
	"I hold this house.",
	"Amen.",
	"He gnashed in fury.",
	"Traitors swing.",
	"The chords consented.",
	"Very sad thing.",
	"But had to be.",
	"Get out before the end.",
	"Thanks, that was heavenly.",
	"Where’s my hat.",
	"Pass by her.",
	"Can leave that Freeman.",
	"Letter I have.",
	"Suppose she were the?",
	"No.",
	"Walk, walk, walk.",
	"Like Cashel Boylo Connoro Coylo Tisdall Maurice Tisntdall Farrell.",
	"Waaaaaaalk.",
	"Well, I must be.",
	"Are you off?",
	"Yrfmstbyes.",
	"Blmstup.",
	"O’er ryehigh blue.",
	"Ow.",
	"Bloom stood up.",
	"Soap feeling rather sticky behind.",
	"Must have sweated: music.",
	"That lotion, remember.",
	"Well, so long.",
	"High grade.",
	"Card inside.",
	"Yes.",
	"By deaf Pat in the doorway straining ear Bloom passed.",
	"At Geneva barrack that young man died.",
	"At Passage was his body laid.",
	"Dolor!",
	"O, he dolores!",
	"The voice of the mournful chanter called to dolorous prayer.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Pray for him, prayed the bass of Dollard.",
	"You who hear in peace.",
	"Breathe a prayer, drop a tear, good men, good people.",
	"He was the croppy boy.",
	"General chorus off for a swill to wash it down.",
	"Glad I avoided.",
	"Come on, Ben, Simon Dedalus cried.",
	"By God, you’re as good as ever you were.",
	"Better, said Tomgin Kernan.",
	"Most trenchant rendition of that ballad, upon my soul and honour it is.",
	"Lablache, said Father Cowley.",
	"Big Benaben Dollard.",
	"Big Benben.",
	"Big Benben.",
	"Rrr.",
	"You’re looking rubicund, George Lidwell said.",
	"Miss Douce composed her rose to wait.",
	"Ben machree, said Mr Dedalus, clapping Ben’s fat back shoulderblade.",
	"Fit as a fiddle only he has a lot of adipose tissue concealed about his person.",
	"Rrrrrrrsss.",
	"Fat of death, Simon, Ben Dollard growled.",
	"Richie rift in the lute alone sat: Goulding, Collis, Ward.",
	"Uncertainly he waited.",
	"Unpaid Pat too.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Miss Mina Kennedy brought near her lips to ear of tankard one.",
	"Mr Dollard, they murmured low.",
	"Dollard, murmured tankard.",
	"Tank one believed: miss Kenn when she: that doll he was: she doll: the tank.",
	"He murmured that he knew the name.",
	"The name was familiar to him, that is to say.",
	"That was to say he had heard the name of.",
	"Dollard, was it?",
	"Dollard, yes.",
	"Yes, her lips said more loudly, Mr Dollard.",
	"He sang that song lovely, murmured Mina.",
	"Mr Dollard.",
	"And The last rose of summer was a lovely song.",
	"Mina loved that song.",
	"Tankard loved the song that Mina.",
	"‘Tis the last rose of summer dollard left bloom felt wind wound round inside.",
	"Gassy thing that cider: binding too.",
	"Wait.",
	"Postoffice near Reuben J’s one and eightpence too.",
	"Get shut of it.",
	"Dodge round by Greek street.",
	"Wish I hadn’t promised to meet.",
	"Freer in air.",
	"Music.",
	"Gets on your nerves.",
	"Beerpull.",
	"Her hand that rocks the cradle rules the.",
	"Ben Howth.",
	"That rules the world.",
	"Far.",
	"Far.",
	"Far.",
	"Far.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap blind walked tapping by the tap the curbstone tapping, tap by tap.",
	"Cowley, he stuns himself with it: kind of drunkenness.",
	"Better give way only half way the way of a man with a maid.",
	"Instance enthusiasts.",
	"All ears.",
	"Not lose a demisemiquaver.",
	"Eyes shut.",
	"Head nodding in time.",
	"Dotty.",
	"You daren’t budge.",
	"Thinking strictly prohibited.",
	"Always talking shop.",
	"Fiddlefaddle about notes.",
	"All a kind of attempt to talk.",
	"Unpleasant when it stops because you never know exac.",
	"Organ in Gardiner street.",
	"Old Glynn fifty quid a year.",
	"Queer up there in the cockloft, alone, with stops and locks and keys.",
	"Seated all day at the organ.",
	"Maunder on for hours, talking to himself or the other fellow blowing the bellows.",
	"Pwee!",
	"A wee little wind piped eeee.",
	"In Bloom’s little wee.",
	"Was he?",
	"Mr Dedalus said, returning with fetched pipe.",
	"I was with him this morning at poor little Paddy Dignam’s... —Ay, the Lord have mercy on him.",
	"By the bye there’s a tuningfork in there on the...",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap.",
	"The wife has a fine voice.",
	"Or had.",
	"What?",
	"Lidwell asked.",
	"O, that must be the tuner, Lydia said to Simonlionel first I saw, forgot it when he was here.",
	"Blind he was she told George Lidwell second I saw.",
	"And played so exquisitely, treat to hear.",
	"Exquisite contrast: bronzelid, minagold.",
	"Shout!",
	"Ben Dollard shouted, pouring.",
	"Sing out!",
	"‘lldo!",
	"cried Father Cowley.",
	"Rrrrrr.",
	"I feel I want...",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap —Very, Mr Dedalus said, staring hard at a headless sardine.",
	"Under the sandwichbell lay on a bier of bread one last, one lonely, last sardine of summer.",
	"Bloom alone.",
	"Very, he stared.",
	"The lower register, for choice.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Tap.",
	"Bloom went by Barry’s.",
	"Wish I could.",
	"Wait.",
	"That wonderworker if I had.",
	"Twentyfour solicitors in that one house.",
	"Counted them.",
	"Litigation.",
	"Love one another.",
	"Piles of parchment.",
	"Messrs Pick and Pocket have power of attorney.",
	"Goulding, Collis, Ward.",
	"But for example the chap that wallops the big drum.",
	"His vocation: Mickey Rooney’s band.",
	"Wonder how it first struck him.",
	"Sitting at home after pig’s cheek and cabbage nursing it in the armchair.",
	"Rehearsing his band part.",
	"Pom.",
	"Pompedy.",
	"Jolly for the wife.",
	"Asses’ skins.",
	"Welt them through life, then wallop after death.",
	"Pom.",
	"Wallop.",
	"Seems to be what you call yashmak or I mean kismet.",
	"Fate.",
	"Tap.",
	"Tap.",
	"Instruments.",
	"A blade of grass, shell of her hands, then blow.",
	"Even comb and tissuepaper you can knock a tune out of.",
	"Molly in her shift in Lombard street west, hair down.",
	"I suppose each kind of trade made its own, don’t you see?",
	"Hunter with a horn.",
	"Haw.",
	"Have you the?",
	"Cloche.",
	"Sonnez la.",
	"Shepherd his pipe.",
	"Pwee little wee.",
	"Policeman a whistle.",
	"Locks and keys!",
	"Sweep!",
	"Four o’clock’s all’s well!",
	"Sleep!",
	"All is lost now.",
	"Drum?",
	"Pompedy.",
	"Wait.",
	"I know.",
	"Towncrier, bumbailiff.",
	"Long John.",
	"Waken the dead.",
	"Pom.",
	"Dignam.",
	"Poor little nominedomine.",
	"Pom.",
	"It is music.",
	"I mean of course it’s all pom pom pom very much what they call da capo.",
	"Still you can hear.",
	"As we march, we march along, march along.",
	"Pom.",
	"I must really.",
	"Fff.",
	"Now if I did that at a banquet.",
	"Just a question of custom shah of Persia.",
	"Breathe a prayer, drop a tear.",
	"Muffled up.",
	"Wonder who was that chap at the grave in the brown macin.",
	"O, the whore of the lane!",
	"When first he saw that form endearing?",
	"Yes, it is.",
	"I feel so lonely.",
	"Wet night in the lane.",
	"Horn.",
	"Who had the?",
	"Heehaw shesaw.",
	"Off her beat here.",
	"What is she?",
	"Hope she.",
	"Psst!",
	"Any chance of your wash.",
	"Knew Molly.",
	"Had me decked.",
	"Stout lady does be with you in the brown costume.",
	"Put you off your stroke, that.",
	"Appointment we made knowing we’d never, well hardly ever.",
	"Too dear too near to home sweet home.",
	"Sees me, does she?",
	"Looks a fright in the day.",
	"Face like dip.",
	"Damn her.",
	"O, well, she has to live like the rest.",
	"Look in here.",
	"Bargain: six bob.",
	"Might learn to play.",
	"Cheap.",
	"Let her pass.",
	"Course everything is dear if you don’t want it.",
	"That’s what good salesman is.",
	"Make you buy what he wants to sell.",
	"Chap sold me the Swedish razor he shaved me with.",
	"Wanted to charge me for the edge he gave it.",
	"She’s passing now.",
	"Six bob.",
	"Must be the cider or perhaps the burgund.",
	"First Lid, De, Cow, Ker, Doll, a fifth: Lidwell, Si Dedalus, Bob Cowley, Kernan and big Ben Dollard.",
	"Tap.",
	"A youth entered a lonely Ormond hall.",
	"Bloom viewed a gallant pictured hero in Lionel Marks’s window.",
	"Robert Emmet’s last words.",
	"Seven last words.",
	"Of Meyerbeer that is.",
	"True men like you men.",
	"Ay, ay, Ben.",
	"Will lift your glass with us.",
	"They lifted.",
	"Tschink.",
	"Tschunk.",
	"Tip.",
	"An unseeing stripling stood in the door.",
	"He saw not bronze.",
	"He saw not gold.",
	"Nor Ben nor Bob nor Tom nor Si nor George nor tanks nor Richie nor Pat.",
	"Hee hee hee hee.",
	"He did not see.",
	"Seabloom, greaseabloom viewed last words.",
	"Softly.",
	"When my country takes her place among.",
	"Prrprr.",
	"Must be the bur.",
	"Fff!",
	"Oo.",
	"Rrpr.",
	"Nations of the earth.",
	"No-one behind.",
	"She’s passed.",
	"Then and not till then.",
	"Tram kran kran kran.",
	"Good oppor.",
	"Coming.",
	"Krandlkrankran.",
	"I’m sure it’s the burgund.",
	"Yes.",
	"One, two.",
	"Let my epitaph be.",
	"Kraaaaaa.",
	"Written.",
	"I have.",
	"Pprrpffrrppffff.",
	"Done.",
	"Lo, Joe, says I.",
	"How are you blowing?",
	"Did you see that bloody chimneysweep near shove my eye out with his brush?",
	"Soot’s luck, says Joe.",
	"Who’s the old ballocks you were talking to?",
	"Old Troy, says I, was in the force.",
	"What are you doing round those parts?",
	"says Joe.",
	"Circumcised?",
	"says Joe.",
	"Ay, says I.",
	"A bit off the top.",
	"An old plumber named Geraghty.",
	"That the lay you’re on now?",
	"says Joe.",
	"Ay, says I.",
	"How are the mighty fallen!",
	"Collector of bad and doubtful debts.",
	"And he after stuffing himself till he’s fit to burst.",
	"Jesus, I had to laugh at the little jewy getting his shirt out.",
	"He drink me my teas.",
	"He eat me my sugars.",
	"Because he no pay me my moneys?",
	"Are you a strict t.t.?",
	"says Joe.",
	"Not taking anything between drinks, says I.",
	"What about paying our respects to our friend?",
	"says Joe.",
	"Who?",
	"says I.",
	"Sure, he’s out in John of God’s off his head, poor man.",
	"Drinking his own stuff?",
	"says Joe.",
	"Ay, says I. Whisky and water on the brain.",
	"Come around to Barney Kiernan’s, says Joe.",
	"I want to see the citizen.",
	"Barney mavourneen’s be it, says I.",
	"Anything strange or wonderful, Joe?",
	"Not a word, says Joe.",
	"I was up at that meeting in the City Arms.",
	"-What was that, Joe?",
	"says I.",
	"Cattle traders, says Joe, about the foot and mouth disease.",
	"I want to give the citizen the hard word about it.",
	"Decent fellow Joe when he has it but sure like that he never has it.",
	"Jesus, I couldn’t get over that bloody foxy Geraghty, the daylight robber.",
	"For trading without a licence, says he.",
	"In Inisfail the fair there lies a land, the land of holy Michan.",
	"There rises a watchtower beheld of men afar.",
	"There sleep the mighty dead as in life they slept, warriors and princes of high renown.",
	"I dare him, says he, and I doubledare him.",
	"Come out here, Geraghty, you notorious bloody hill and dale robber!",
	"The bloody mongrel let a grouse out of him would give you the creeps.",
	"Be a corporal work of mercy if someone would take the life of that bloody dog.",
	"Stand and deliver, says he.",
	"That’s all right, citizen, says Joe.",
	"Friends here.",
	"Pass, friends, says he.",
	"Then he rubs his hand in his eye and says he: What’s your opinion of the times?",
	"Doing the rapparee and Rory of the hill.",
	"But, begob, Joe was equal to the occasion.",
	"I think the markets are on a rise, says he, sliding his hand down his fork.",
	"And says Joe, sticking his thumb in his pocket: It’s the Russians wish to tyrannise.",
	"Give it a name, citizen, says Joe.",
	"Wine of the country, says he.",
	"What’s yours?",
	"says Joe.",
	"Ditto MacAnaspey, says I.",
	"Three pints, Terry, says Joe.",
	"And how’s the old heart, citizen?",
	"says he.",
	"Never better, a chara, says he.",
	"What Garry?",
	"Are we going to win?",
	"Eh?",
	"Beneath this he wore trews of deerskin, roughly stitched with gut.",
	"O, as true as I’m telling you.",
	"A goodlooking sovereign.",
	"And there’s more where that came from, says he.",
	"Were you robbing the poorbox, Joe?",
	"says I.",
	"Sweat of my brow, says Joe.",
	"‘Twas the prudent member gave me the wheeze.",
	"Who comes through Michan’s land, bedight in sable armour?",
	"O’Bloom, the son of Rory: it is he.",
	"Impervious to fear is Rory’s son: he of the prudent soul.",
	"For the old woman of Prince’s street, says the citizen, the subsidised organ.",
	"The pledgebound party on the floor of the house.",
	"And look at this blasted rag, says he.",
	"Look at this, says he.",
	"The Irish Independent, if you please, founded by Parnell to be the workingman’s friend.",
	"How’s that, eh?",
	"Eh?",
	"Deaths.",
	"Cockburn.",
	"How’s that for a national press, eh, my brown son!",
	"How’s that for Martin Murphy, the Bantry jobber?",
	"Ah, well, says Joe, handing round the boose.",
	"Thanks be to God they had the start of us.",
	"Drink that, citizen.",
	"I will, says he, honourable person.",
	"Health, Joe, says I.",
	"And all down the form.",
	"Ah!",
	"Ow!",
	"Don’t be talking!",
	"I was blue mouldy for the want of that pint.",
	"Declare to God I could hear it hit the pit of my stomach with a click.",
	"Little Alf Bergan popped in round the door and hid behind Barney’s snug, squeezed up with the laughing.",
	"I didn’t know what was up and Alf kept making signs out of the door.",
	"I thought Alf would split.",
	"Look at him, says he.",
	"Breen.",
	"He’s traipsing all round Dublin with a postcard someone sent him with U.P.",
	": up on it to take a li... And he doubled up.",
	"Take a what?",
	"says I.",
	"Libel action, says he, for ten thousand pounds.",
	"O hell!",
	"says I.",
	"Bi i dho husht, says he.",
	"Who?",
	"says Joe.",
	"Breen, says Alf.",
	"O God, I’ve a pain laughing.",
	"U. p: up.",
	"When is long John going to hang that fellow in Mountjoy?",
	"says Joe.",
	"Bergan, says Bob Doran, waking up.",
	"Is that Alf Bergan?",
	"Yes, says Alf.",
	"Hanging?",
	"Wait till I show you.",
	"Here, Terry, give us a pony.",
	"That bloody old fool!",
	"Ten thousand pounds.",
	"You should have seen long John’s eye.",
	"U.P.... And he started laughing.",
	"Who are you laughing at?",
	"says Bob Doran.",
	"Is that Bergan?",
	"Hurry up, Terry boy, says Alf.",
	"What’s that bloody freemason doing, says the citizen, prowling up and down outside?",
	"What’s that?",
	"says Joe.",
	"Here you are, says Alf, chucking out the rhino.",
	"Talking about hanging, I’ll show you something you never saw.",
	"Hangmen’s letters.",
	"Look at here.",
	"So he took a bundle of wisps of letters and envelopes out of his pocket.",
	"Are you codding?",
	"says I.",
	"Honest injun, says Alf.",
	"Read them.",
	"So Joe took up the letters.",
	"Who are you laughing at?",
	"says Bob Doran.",
	"So I saw there was going to be a bit of a dust.",
	"I don’t know, says Alf.",
	"I saw him just now in Capel street with Paddy Dignam.",
	"Only I was running after that... —You what?",
	"says Joe, throwing down the letters.",
	"With who?",
	"With Dignam, says Alf.",
	"Is it Paddy?",
	"says Joe.",
	"Yes, says Alf.",
	"Why?",
	"Don’t you know he’s dead?",
	"says Joe.",
	"Paddy Dignam dead!",
	"says Alf.",
	"Ay, says Joe.",
	"Sure I’m after seeing him not five minutes ago, says Alf, as plain as a pikestaff.",
	"Who’s dead?",
	"says Bob Doran.",
	"You saw his ghost then, says Joe, God between us and harm.",
	"What?",
	"says Alf.",
	"Good Christ, only five...",
	"What?...",
	"And Willy Murray with him, the two of them there near whatdoyoucallhim’s... What?",
	"Dignam dead?",
	"What about Dignam?",
	"says Bob Doran.",
	"Who’s talking about...?",
	"Dead!",
	"says Alf.",
	"He’s no more dead than you are.",
	"Maybe so, says Joe.",
	"They took the liberty of burying him this morning anyhow.",
	"Paddy?",
	"says Alf.",
	"Ay, says Joe.",
	"He paid the debt of nature, God be merciful to him.",
	"Good Christ!",
	"says Alf.",
	"Begob he was what you might call flabbergasted.",
	"Having requested a quart of buttermilk this was brought and evidently afforded relief.",
	"Mind C. K. doesn’t pile it on.",
	"Assurances were given that the matter would be attended to and it was intimated that this had given satisfaction.",
	"He is gone from mortal haunts: O’Dignam, sun of our morning.",
	"Fleet was his foot on the bracken: Patrick of the beamy brow.",
	"Wail, Banba, with your wind: and wail, O ocean, with your whirlwind.",
	"There he is again, says the citizen, staring out.",
	"Who?",
	"says I.",
	"Bloom, says he.",
	"He’s on point duty up and down there for the last ten minutes.",
	"And, begob, I saw his physog do a peep in and then slidder off again.",
	"Little Alf was knocked bawways.",
	"Faith, he was.",
	"Good Christ!",
	"says he.",
	"I could have sworn it was him.",
	"I beg your parsnips, says Alf.",
	"Is that a good Christ, says Bob Doran, to take away poor little Willy Dignam?",
	"Ah, well, says Alf, trying to pass it off.",
	"He’s over all his troubles.",
	"But Bob Doran shouts out of him.",
	"He’s a bloody ruffian, I say, to take away poor little Willy Dignam.",
	"And Bob Doran starts doing the weeps about Paddy Dignam, true as you’re there.",
	"The finest man, says he, snivelling, the finest purest character.",
	"The tear is bloody near your eye.",
	"Talking through his bloody hat.",
	"The noblest, the truest, says he.",
	"And he’s gone, poor little Willy, poor little Paddy Dignam.",
	"And mournful and with a heavy heart he bewept the extinction of that beam of heaven.",
	"Old Garryowen started growling again at Bloom that was skeezing round the door.",
	"Come in, come on, he won’t eat you, says the citizen.",
	"So Bloom slopes in with his cod’s eye on the dog and he asks Terry was Martin Cunningham there.",
	"O, Christ M’Keown, says Joe, reading one of the letters.",
	"Listen to this, will you?",
	"And he starts reading out one.",
	"7 Hunter Street, Liverpool.",
	"To the High Sheriff of Dublin, Dublin.",
	"... Billington executed the awful murderer Toad Smith...",
	"The citizen made a grab at the letter.",
	"H. Rumbold, Master Barber.",
	"And a barbarous bloody barbarian he is too, says the citizen.",
	"And the dirty scrawl of the wretch, says Joe.",
	"Here, says he, take them to hell out of my sight, Alf.",
	"Hello, Bloom, says he, what will you have?",
	"Gob, he’s a prudent member and no mistake.",
	"Give us one of your prime stinkers, Terry, says Joe.",
	"In the dark land they bide, the vengeful knights of the razor.",
	"There’s one thing it hasn’t a deterrent effect on, says Alf.",
	"What’s that?",
	"says Joe.",
	"The poor bugger’s tool that’s being hanged, says Alf.",
	"That so?",
	"says Joe.",
	"God’s truth, says Alf.",
	"I heard that from the head warder that was in Kilmainham when they hanged Joe Brady, the invincible.",
	"Ruling passion strong in death, says Joe, as someone said.",
	"That can be explained by science, says Bloom.",
	"Talking about new Ireland he ought to go and get a new dog so he ought.",
	"Mangy ravenous brute sniffing and sneezing all round the place and scratching his scabs.",
	"So of course Bob Doran starts doing the bloody fool with him: Give us the paw!",
	"Give the paw, doggy!",
	"Good old doggy!",
	"Give the paw here!",
	"Give us the paw!",
	"Near ate the tin and all, hungry bloody mongrel.",
	"And Bloom, of course, with his knockmedown cigar putting on swank with his lardy face.",
	"Phenomenon!",
	"The fat heap he married is a nice old phenomenon with a back on her like a ballalley.",
	"Jesus, I had to laugh at pisser Burke taking them off chewing the fat.",
	"And Bloom with his but don’t you see?",
	"and but on the other hand.",
	"Phenomenon!",
	"The memory of the dead, says the citizen taking up his pintglass and glaring at Bloom.",
	"Ay, ay, says Joe.",
	"You don’t grasp my point, says Bloom.",
	"What I mean is... —Sinn Fein!",
	"says the citizen.",
	"Sinn Fein amhain!",
	"The friends we love are by our side and the foes we hate before us.",
	"The last farewell was affecting in the extreme.",
	"The readywitted ninefooter’s suggestion at once appealed to all and was unanimously accepted.",
	"Constable MacFadden was heartily congratulated by all the F. O. T. E. I., several of whom were bleeding profusely.",
	"It was exactly seventeen o’clock.",
	"The hero folded her willowy form in a loving embrace murmuring fondly Sheila, my own.",
	"That monster audience simply rocked with delight.",
	"But anon they were overcome with grief and clasped their hands for the last time.",
	"Antitreating is about the size of it.",
	"Ireland sober is Ireland free.",
	"I’d train him by kindness, so I would, if he was my dog.",
	"Give him a rousing fine kick now and again where it wouldn’t blind him.",
	"Afraid he’ll bite you?",
	"says the citizen, jeering.",
	"No, says I.",
	"But he might take my leg for a lamppost.",
	"So he calls the old dog over.",
	"What’s on you, Garry?",
	"says he.",
	"Such growling you never heard as they let off between them.",
	"Our greatest living phonetic expert (wild horses shall not drag it from us!)",
	"And Joe asked him would he have another.",
	"I will, says he, a chara, to show there’s no ill feeling.",
	"Gob, he’s not as green as he’s cabbagelooking.",
	"Entertainment for man and beast.",
	"And says Joe: Could you make a hole in another pint?",
	"Could a swim duck?",
	"says I.",
	"Same again, Terry, says Joe.",
	"Are you sure you won’t have anything in the way of liquid refreshment?",
	"says he.",
	"Thank you, no, says Bloom.",
	"Martin asked me to go to the house.",
	"Holy Wars, says Joe, laughing, that’s a good one if old Shylock is landed.",
	"So the wife comes out top dog, what?",
	"Well, that’s a point, says Bloom, for the wife’s admirers.",
	"Whose admirers?",
	"says Joe.",
	"The wife’s advisers, I mean, says Bloom.",
	"Selling bazaar tickets or what do you call it royal Hungarian privileged lottery.",
	"True as you’re there.",
	"O, commend me to an israelite!",
	"Royal and privileged Hungarian robbery.",
	"Choking with bloody foolery.",
	"And shaking Bloom’s hand doing the tragic to tell her that.",
	"Shake hands, brother.",
	"You’re a rogue and I’m another.",
	"Then suffer me to take your hand, said he.",
	"And off with him and out trying to walk straight.",
	"Boosed at five o’clock.",
	"Night he was near being lagged only Paddy Leonard knew the bobby, 14A.",
	"How is your testament?",
	"Have you got an old testament?",
	"Only Paddy was passing there, I tell you what.",
	"Jack Mooney’s sister.",
	"And the old prostitute of a mother procuring rooms to street couples.",
	"Gob, Jack made him toe the line.",
	"Told him if he didn’t patch up the pot, Jesus, he’d kick the shite out of him.",
	"So Terry brought the three pints.",
	"Here, says Joe, doing the honours.",
	"Here, citizen.",
	"Slan leat, says he.",
	"Fortune, Joe, says I.",
	"Good health, citizen.",
	"Gob, he had his mouth half way down the tumbler already.",
	"Want a small fortune to keep him in drinks.",
	"Who is the long fellow running for the mayoralty, Alf?",
	"says Joe.",
	"Friend of yours, says Alf.",
	"Nannan?",
	"says Joe.",
	"The mimber?",
	"I won’t mention any names, says Alf.",
	"I thought so, says Joe.",
	"I saw him up at that meeting now with William Field, M. P., the cattle traders.",
	"Hairy Iopas, says the citizen, that exploded volcano, the darling of all countries and the idol of his own.",
	"Because he was up one time in a knacker’s yard.",
	"Mister Knowall.",
	"Teach your grandmother how to milk ducks.",
	"Couldn’t loosen her farting strings but old cod’s eye was waltzing around her showing her how to do it.",
	"What’s your programme today?",
	"Ay.",
	"Humane methods.",
	"Gob, he’d have a soft hand under a hen.",
	"Ga Ga Gara.",
	"Klook Klook Klook.",
	"Black Liz is our hen.",
	"She lays eggs for us.",
	"When she lays her egg she is so glad.",
	"Gara.",
	"Klook Klook Klook.",
	"Then comes good uncle Leo.",
	"He puts his hand under black Liz and takes her fresh egg.",
	"Ga ga ga ga Gara.",
	"Klook Klook Klook.",
	"Are you sure, says Bloom, the councillor is going?",
	"I wanted to see him, as it happens.",
	"Well, he’s going off by the mailboat, says Joe, tonight.",
	"That’s too bad, says Bloom.",
	"I wanted particularly.",
	"Perhaps only Mr Field is going.",
	"I couldn’t phone.",
	"No.",
	"You’re sure?",
	"Nannan’s going too, says Joe.",
	"What do you think of that, citizen?",
	"The Sluagh na h-Eireann.",
	"Mr Cowe Conacre (Multifarnham.",
	"Nat.",
	"Mr Allfours (Tamoshant.",
	"Con.",
	"): Honourable members are already in possession of the evidence produced before a committee of the whole house.",
	"I feel I cannot usefully add anything to that.",
	"The answer to the honourable member’s question is in the affirmative.",
	"Mr Orelli O’Reilly (Montenotte.",
	"Nat.",
	"Mr Allfours: The answer is in the negative.",
	"(O!",
	"O!)",
	"Mr Allfours: I must have notice of that question.",
	"Mr Staylewit (Buncombe.",
	"Ind.",
	"): Don’t hesitate to shoot.",
	"(Ironical opposition cheers.)",
	"The speaker: Order!",
	"Order!",
	"(The house rises.",
	"Cheers.)",
	"There’s the man, says Joe, that made the Gaelic sports revival.",
	"There he is sitting there.",
	"The man that got away James Stephens.",
	"The champion of all Ireland at putting the sixteen pound shot.",
	"What was your best throw, citizen?",
	"Na bacleis, says the citizen, letting on to be modest.",
	"There was a time I was as good as the next fellow anyhow.",
	"Put it there, citizen, says Joe.",
	"You were and a bloody sight better.",
	"Is that really a fact?",
	"says Alf.",
	"Yes, says Bloom.",
	"That’s well known.",
	"Did you not know that?",
	"Do you see that straw?",
	"That’s a straw.",
	"Declare to my aunt he’d talk about it for an hour so he would and talk steady.",
	"The venerable president of the noble order was in the chair and the attendance was of large dimensions.",
	"The proceedings then terminated.",
	"Amongst the clergy present were the very rev.",
	"William Delany, S. J., L. L. D.; the rt rev.",
	"Gerald Molloy, D. D.; the rev.",
	"P. J. Kavanagh, C. S.",
	"Sp.",
	"; the rev.",
	"T. Waters, C. C.; the rev.",
	"John M. Ivers, P. P.; the rev.",
	"P. J. Cleary, O. S. F.; the rev.",
	"L. J. Hickey, O. P.; the very rev.",
	"Fr.",
	"Nicholas, O. S. F. C.; the very rev.",
	"B. Gorman, O. D. C.; the rev.",
	"T. Maher, S. J.; the very rev.",
	"James Murphy, S. J.; the rev.",
	"John Lavery, V. F.; the very rev.",
	"William Doherty, D. D.; the rev.",
	"Peter Fagan, O. M.; the rev.",
	"T. Brangan, O. S. A.; the rev.",
	"J. Flavin, C. C.; the rev.",
	"M. A. Hackett, C. C.; the rev.",
	"W. Hurley, C. C.; the rt rev.",
	"Mgr M’Manus, V. G.; the rev.",
	"B. R. Slattery, O. M. I.; the very rev.",
	"M. D. Scally, P. P.; the rev.",
	"F. T. Purcell, O. P.; the very rev.",
	"Timothy canon Gorman, P. P.; the rev.",
	"J. Flanagan, C. C. The laity included P. Fay, T. Quirke, etc., etc.",
	"Talking about violent exercise, says Alf, were you at that Keogh-Bennett match?",
	"No, says Joe.",
	"I heard So and So made a cool hundred quid over it, says Alf.",
	"Who?",
	"Blazes?",
	"says Joe.",
	"And says Bloom: What I meant about tennis, for example, is the agility and training the eye.",
	"Ay, Blazes, says Alf.",
	"We know him, says the citizen.",
	"The traitor’s son.",
	"We know what put English gold in his pocket.",
	"True for you, says Joe.",
	"Myler dusted the floor with him, says Alf.",
	"Heenan and Sayers was only a bloody fool to it.",
	"Handed him the father and mother of a beating.",
	"See the little kipper not up to his navel and the big fellow swiping.",
	"The final bout of fireworks was a gruelling for both champions.",
	"The redcoat ducked but the Dubliner lifted him with a left hook, the body punch being a fine one.",
	"The men came to handigrips.",
	"It was a fight to a finish and the best man for it.",
	"The two fought like tigers and excitement ran fever high.",
	"It was a knockout clean and clever.",
	"He knows which side his bread is buttered, says Alf.",
	"I hear he’s running a concert tour now up in the north.",
	"He is, says Joe.",
	"Isn’t he?",
	"Who?",
	"says Bloom.",
	"Ah, yes.",
	"That’s quite true.",
	"Yes, a kind of summer tour, you see.",
	"Just a holiday.",
	"Mrs B. is the bright particular star, isn’t she?",
	"says Joe.",
	"My wife?",
	"says Bloom.",
	"She’s singing, yes.",
	"I think it will be a success too.",
	"He’s an excellent man to organise.",
	"Excellent.",
	"Hoho begob says I to myself says I.",
	"That explains the milk in the cocoanut and absence of hair on the animal’s chest.",
	"Blazes doing the tootle on the flute.",
	"Concert tour.",
	"Old Whatwhat.",
	"I called about the poor and water rate, Mr Boylan.",
	"You what?",
	"The water rate, Mr Boylan.",
	"You whatwhat?",
	"That’s the bucko that’ll organise her, take my tip.",
	"‘Twixt me and you Caddareesh.",
	"Pride of Calpe’s rocky mount, the ravenhaired daughter of Tweedy.",
	"There grew she to peerless beauty where loquat and almond scent the air.",
	"The gardens of Alameda knew her step: the garths of olives knew and bowed.",
	"The chaste spouse of Leopold is she: Marion of the bountiful bosoms.",
	"Hello, Ned.",
	"Hello, Alf.",
	"Hello, Jack.",
	"Hello, Joe.",
	"God save you, says the citizen.",
	"Save you kindly, says J. J. What’ll it be, Ned?",
	"Half one, says Ned.",
	"So J. J. ordered the drinks.",
	"Were you round at the court?",
	"says Joe.",
	"Yes, says J. J. He’ll square that, Ned, says he.",
	"Hope so, says Ned.",
	"Now what were those two at?",
	"J. J. getting him off the grand jury list and the other give him a leg over the stile.",
	"With his name in Stubbs’s.",
	"What’s your name, sir?",
	"Dunne, says he.",
	"Ay, and done says I. Gob, he’ll come home by weeping cross one of those days, I’m thinking.",
	"Did you see that bloody lunatic Breen round there?",
	"says Alf.",
	"U.P.",
	": up.",
	"Yes, says J. J.",
	"Looking for a private detective.",
	"Ay, says Ned.",
	"Ten thousand pounds, says Alf, laughing.",
	"God, I’d give anything to hear him before a judge and jury.",
	"Was it you did it, Alf?",
	"says Joe.",
	"The truth, the whole truth and nothing but the truth, so help you Jimmy Johnson.",
	"Me?",
	"says Alf.",
	"Don’t cast your nasturtiums on my character.",
	"Whatever statement you make, says Joe, will be taken down in evidence against you.",
	"Of course an action would lie, says J. J.",
	"It implies that he is not compos mentis.",
	"U.P.",
	": up.",
	"Compos your eye!",
	"says Alf, laughing.",
	"Do you know that he’s balmy?",
	"Look at his head.",
	"Do you know that some mornings he has to get his hat on with a shoehorn.",
	"Ha ha, Alf, says Joe.",
	"Still, says Bloom, on account of the poor woman, I mean his wife.",
	"Pity about her, says the citizen.",
	"Or any other woman marries a half and half.",
	"How half and half?",
	"says Bloom.",
	"Do you mean he... —Half and half I mean, says the citizen.",
	"A fellow that’s neither fish nor flesh.",
	"Nor good red herring, says Joe.",
	"That what’s I mean, says the citizen.",
	"A pishogue, if you know what that is.",
	"Begob I saw there was trouble coming.",
	"And who was he, tell us?",
	"And moreover, says J. J., a postcard is publication.",
	"It was held to be sufficient evidence of malice in the testcase Sadgrove v. Hole.",
	"In my opinion an action might lie.",
	"Six and eightpence, please.",
	"Who wants your opinion?",
	"Let us drink our pints in peace.",
	"Gob, we won’t be let even do that much itself.",
	"Well, good health, Jack, says Ned.",
	"Good health, Ned, says J. J.",
	"-There he is again, says Joe.",
	"Where?",
	"says Alf.",
	"How did that Canada swindle case go off?",
	"says Joe.",
	"Remanded, says J. J.",
	"What?",
	"Do you see any green in the white of my eye?",
	"Course it was a bloody barney.",
	"What?",
	"Swindled them all, skivvies and badhachs from the county Meath, ay, and his own kidney too.",
	"Who tried the case?",
	"says Joe.",
	"Recorder, says Ned.",
	"Poor old sir Frederick, says Alf, you can cod him up to the two eyes.",
	"Heart as big as a lion, says Ned.",
	"Ay, says Alf.",
	"And he starts taking off the old recorder letting on to cry: A most scandalous thing!",
	"This poor hardworking man!",
	"How many children?",
	"Ten, did you say?",
	"Yes, your worship.",
	"And my wife has the typhoid.",
	"And the wife with typhoid fever!",
	"Scandalous!",
	"Leave the court immediately, sir.",
	"No, sir, I’ll make no order for payment.",
	"How dare you, sir, come up before me and ask me to make an order!",
	"A poor hardworking industrious man!",
	"I dismiss the case.",
	"And to the solemn court of Green street there came sir Frederick the Falconer.",
	"Those are nice things, says the citizen, coming over here to Ireland filling the country with bugs.",
	"And so Joe swore high and holy by this and by that he’d do the devil and all.",
	"Because, you see, says Bloom, for an advertisement you must have repetition.",
	"That’s the whole secret.",
	"Rely on me, says Joe.",
	"Swindling the peasants, says the citizen, and the poor of Ireland.",
	"We want no more strangers in our house.",
	"O, I’m sure that will be all right, Hynes, says Bloom.",
	"It’s just that Keyes, you see.",
	"Consider that done, says Joe.",
	"Very kind of you, says Bloom.",
	"The strangers, says the citizen.",
	"Our own fault.",
	"We let them come in.",
	"We brought them in.",
	"The adulteress and her paramour brought the Saxon robbers here.",
	"Decree nisi, says J. J.",
	"A dishonoured wife, says the citizen, that’s what’s the cause of all our misfortunes.",
	"Give us a squint at her, says I.",
	"And what was it only one of the smutty yankee pictures Terry borrows off of Corny Kelleher.",
	"Secrets for enlarging your private parts.",
	"Misconduct of society belle.",
	"Norman W. Tupper, wealthy Chicago contractor, finds pretty but faithless wife in lap of officer Taylor.",
	"O jakers, Jenny, says Joe, how short your shirt is!",
	"There’s hair, Joe, says I.",
	"Get a queer old tailend of corned beef off of that one, what?",
	"Well, says the citizen, what’s the latest from the scene of action?",
	"What did those tinkers in the city hall at their caucus meeting decide about the Irish language?",
	"It’s on the march, says the citizen.",
	"To hell with the bloody brutal Sassenachs and their patois.",
	"Their syphilisation, you mean, says the citizen.",
	"To hell with them!",
	"The curse of a goodfornothing God light sideways on the bloody thicklugged sons of whores’ gets!",
	"No music and no art and no literature worthy of the name.",
	"Any civilisation they have they stole from us.",
	"Tonguetied sons of bastards’ ghosts.",
	"The European family, says J. J.... —They’re not European, says the citizen.",
	"I was in Europe with Kevin Egan of Paris.",
	"You wouldn’t see a trace of them or their language anywhere in Europe except in a cabinet d’aisance.",
	"And says John Wyse: Full many a flower is born to blush unseen.",
	"And says Lenehan that knows a bit of the lingo: Conspuez les Anglais!",
	"Perfide Albion!",
	"What’s up with you, says I to Lenehan.",
	"You look like a fellow that had lost a bob and found a tanner.",
	"Gold cup, says he.",
	"Who won, Mr Lenehan?",
	"says Terry.",
	"Throwaway, says he, at twenty to one.",
	"A rank outsider.",
	"And the rest nowhere.",
	"And Bass’s mare?",
	"says Terry.",
	"Still running, says he.",
	"We’re all in a cart.",
	"Boylan plunged two quid on my tip Sceptre for himself and a lady friend.",
	"I had half a crown myself, says Terry, on Zinfandel that Mr Flynn gave me.",
	"Lord Howard de Walden’s.",
	"Twenty to one, says Lenehan.",
	"Such is life in an outhouse.",
	"Throwaway, says he.",
	"Takes the biscuit, and talking about bunions.",
	"Frailty, thy name is Sceptre.",
	"Old Mother Hubbard went to the cupboard.",
	"Not there, my child, says he.",
	"Keep your pecker up, says Joe.",
	"She’d have won the money only for the other dog.",
	"And J. J. and the citizen arguing about law and history with Bloom sticking in an odd word.",
	"Raimeis, says the citizen.",
	"There’s no-one as blind as the fellow that won’t see, if you know what that means.",
	"Where are our missing twenty millions of Irish should be here today instead of four, our lost tribes?",
	"And our potteries and textiles, the finest in the whole world!",
	"Read Tacitus and Ptolemy, even Giraldus Cambrensis.",
	"What do the yellowjohns of Anglia owe us for our ruined trade and our ruined hearths?",
	"Larches, firs, all the trees of the conifer family are going fast.",
	"Save the trees of Ireland for the future men of Ireland on the fair hills of Eire, O.",
	"Europe has its eyes on you, says Lenehan.",
	"Mr and Mrs Wyse Conifer Neaulan will spend a quiet honeymoon in the Black Forest.",
	"And our eyes are on Europe, says the citizen.",
	"And will again, says Joe.",
	"And with the help of the holy mother of God we will again, says the citizen, clapping his thigh.",
	"And he took the last swig out of the pint.",
	"Moya.",
	"All wind and piss like a tanyard cat.",
	"Cows in Connacht have long horns.",
	"Hear, hear to that, says John Wyse.",
	"What will you have?",
	"An imperial yeomanry, says Lenehan, to celebrate the occasion.",
	"Half one, Terry, says John Wyse, and a hands up.",
	"Terry!",
	"Are you asleep?",
	"Yes, sir, says Terry.",
	"Small whisky and bottle of Allsop.",
	"Right, sir.",
	"Hanging over the bloody paper with Alf looking for spicy bits instead of attending to the general public.",
	"But what about the fighting navy, says Ned, that keeps our foes at bay?",
	"I’ll tell you what about it, says the citizen.",
	"Hell upon earth it is.",
	"Read the revelations that’s going on in the papers about flogging on the training ships at Portsmouth.",
	"A fellow writes that calls himself Disgusted One.",
	"And says John Wyse: ‘Tis a custom more honoured in the breach than in the observance.",
	"That’s your glorious British navy, says the citizen, that bosses the earth.",
	"That’s the great empire they boast about of drudges and whipped serfs.",
	"On which the sun never rises, says Joe.",
	"And the tragedy of it is, says the citizen, they believe it.",
	"The unfortunate yahoos believe it.",
	"But, says Bloom, isn’t discipline the same everywhere.",
	"I mean wouldn’t it be the same here if you put force against force?",
	"Didn’t I tell you?",
	"We’ll put force against force, says the citizen.",
	"We have our greater Ireland beyond the sea.",
	"They were driven out of house and home in the black 47.",
	"Even the Grand Turk sent us his piastres.",
	"Ay, they drove out the peasants in hordes.",
	"Twenty thousand of them died in the coffinships.",
	"But those that came to the land of the free remember the land of bondage.",
	"Perfectly true, says Bloom.",
	"But my point was... —We are a long time waiting for that day, citizen, says Ned.",
	"Since the poor old woman told us that the French were on the sea and landed at Killala.",
	"Ay, says John Wyse.",
	"We fought for the royal Stuarts that reneged us against the Williamites and they betrayed us.",
	"Remember Limerick and the broken treatystone.",
	"We gave our best blood to France and Spain, the wild geese.",
	"Fontenoy, eh?",
	"But what did we ever get for it?",
	"The French!",
	"says the citizen.",
	"Set of dancing masters!",
	"Do you know what it is?",
	"They were never worth a roasted fart to Ireland.",
	"Aren’t they trying to make an Entente cordiale now at Tay Pay’s dinnerparty with perfidious Albion?",
	"Firebrands of Europe and they always were.",
	"Conspuez les Français, says Lenehan, nobbling his beer.",
	"Well, says J. J.",
	"We have Edward the peacemaker now.",
	"Tell that to a fool, says the citizen.",
	"There’s a bloody sight more pox than pax about that boyo.",
	"Edward Guelph-Wettin!",
	"The earl of Dublin, no less.",
	"They ought to have stuck up all the women he rode himself, says little Alf.",
	"And says J. J.: Considerations of space influenced their lordships’ decision.",
	"Will you try another, citizen?",
	"says Joe.",
	"Yes, sir, says he.",
	"I will.",
	"You?",
	"says Joe.",
	"Beholden to you, Joe, says I.",
	"May your shadow never grow less.",
	"Repeat that dose, says Joe.",
	"Persecution, says he, all the history of the world is full of it.",
	"Perpetuating national hatred among nations.",
	"But do you know what a nation means?",
	"says John Wyse.",
	"Yes, says Bloom.",
	"What is it?",
	"says John Wyse.",
	"A nation?",
	"says Bloom.",
	"A nation is the same people living in the same place.",
	"That covers my case, says Joe.",
	"What is your nation if I may ask?",
	"says the citizen.",
	"Ireland, says Bloom.",
	"I was born here.",
	"Ireland.",
	"After you with the push, Joe, says he, taking out his handkerchief to swab himself dry.",
	"Here you are, citizen, says Joe.",
	"Take that in your right hand and repeat after me the following words.",
	"Show us over the drink, says I.",
	"Which is which?",
	"That’s mine, says Joe, as the devil said to the dead policeman.",
	"And I belong to a race too, says Bloom, that is hated and persecuted.",
	"Also now.",
	"This very moment.",
	"This very instant.",
	"Gob, he near burnt his fingers with the butt of his old cigar.",
	"Robbed, says he.",
	"Plundered.",
	"Insulted.",
	"Persecuted.",
	"Taking what belongs to us by right.",
	"At this very moment, says he, putting up his fist, sold by auction in Morocco like slaves or cattle.",
	"Are you talking about the new Jerusalem?",
	"says the citizen.",
	"I’m talking about injustice, says Bloom.",
	"Right, says John Wyse.",
	"Stand up to it then with force like men.",
	"That’s an almanac picture for you.",
	"Mark for a softnosed bullet.",
	"Old lardyface standing up to the business end of a gun.",
	"Gob, he’d adorn a sweepingbrush, so he would, if he only had a nurse’s apron on him.",
	"And then he collapses all of a sudden, twisting around all the opposite, as limp as a wet rag.",
	"But it’s no use, says he.",
	"Force, hatred, history, all that.",
	"That’s not life for men and women, insult and hatred.",
	"And everybody knows that it’s the very opposite of that that is really life.",
	"What?",
	"says Alf.",
	"Love, says Bloom.",
	"I mean the opposite of hatred.",
	"I must go now, says he to John Wyse.",
	"Just round to the court a moment to see if Martin is there.",
	"If he comes just say I’ll be back in a second.",
	"Just a moment.",
	"Who’s hindering you?",
	"And off he pops like greased lightning.",
	"A new apostle to the gentiles, says the citizen.",
	"Universal love.",
	"Well, says John Wyse.",
	"Isn’t that what we’re told.",
	"Love your neighbour.",
	"That chap?",
	"says the citizen.",
	"Beggar my neighbour is his motto.",
	"Love, moya!",
	"He’s a nice pattern of a Romeo and Juliet.",
	"Love loves to love love.",
	"Nurse loves the new chemist.",
	"Constable 14A loves Mary Kelly.",
	"Gerty MacDowell loves the boy that has the bicycle.",
	"M. B. loves a fair gentleman.",
	"Li Chi Han lovey up kissy Cha Pu Chow.",
	"Jumbo, the elephant, loves Alice, the elephant.",
	"Old Mr Verschoyle with the ear trumpet loves old Mrs Verschoyle with the turnedin eye.",
	"The man in the brown macintosh loves a lady who is dead.",
	"His Majesty the King loves Her Majesty the Queen.",
	"Mrs Norman W. Tupper loves officer Taylor.",
	"You love a certain person.",
	"And this person loves that other person because everybody loves somebody but God loves everybody.",
	"Well, Joe, says I, your very good health and song.",
	"More power, citizen.",
	"Hurrah, there, says Joe.",
	"The blessing of God and Mary and Patrick on you, says the citizen.",
	"And he ups with his pint to wet his whistle.",
	"We know those canters, says he, preaching and picking your pocket.",
	"The bible!",
	"Did you read that skit in the United Irishman today about that Zulu chief that’s visiting England?",
	"What’s that?",
	"says Joe.",
	"Widow woman, says Ned.",
	"I wouldn’t doubt her.",
	"Wonder did he put that bible to the same use as I would.",
	"Same only more so, says Lenehan.",
	"And thereafter in that fruitful land the broadleaved mango flourished exceedingly.",
	"Is that by Griffith?",
	"says John Wyse.",
	"No, says the citizen.",
	"It’s not signed Shanganagh.",
	"It’s only initialled: P. —And a very good initial too, says Joe.",
	"That’s how it’s worked, says the citizen.",
	"Trade follows the flag.",
	"Did you read that report by a man what’s this his name is?",
	"Casement, says the citizen.",
	"He’s an Irishman.",
	"I know where he’s gone, says Lenehan, cracking his fingers.",
	"Who?",
	"says I.",
	"Bloom, says he.",
	"The courthouse is a blind.",
	"He had a few bob on Throwaway and he’s gone to gather in the shekels.",
	"Is it that whiteeyed kaffir?",
	"says the citizen, that never backed a horse in anger in his life?",
	"That’s where he’s gone, says Lenehan.",
	"Bet you what you like he has a hundred shillings to five on.",
	"He’s the only man in Dublin has it.",
	"A dark horse.",
	"He’s a bloody dark horse himself, says Joe.",
	"Mind, Joe, says I.",
	"Show us the entrance out.",
	"There you are, says Terry.",
	"Goodbye Ireland I’m going to Gort.",
	"Ireland my nation says he (hoik!",
	"phthook!)",
	"never be up to those bloody (there’s the last of it) Jerusalem (ah!)",
	"cuckoos.",
	"Robbing Peter to pay Paul.",
	"Gob, that puts the bloody kybosh on it if old sloppy eyes is mucking up the show.",
	"Give us a bloody chance.",
	"God save Ireland from the likes of that bloody mouseabout.",
	"Mr Bloom with his argol bargol.",
	"Loans by post on easy terms.",
	"Any amount of money advanced on note of hand.",
	"Distance no object.",
	"No security.",
	"Gob, he’s like Lanty MacHale’s goat that’d go a piece of the road with every one.",
	"Well, it’s a fact, says John Wyse.",
	"And there’s the man now that’ll tell you all about it, Martin Cunningham.",
	"Our travellers reached the rustic hostelry and alighted from their palfreys.",
	"Ho, varlet!",
	"cried he, who by his mien seemed the leader of the party.",
	"Saucy knave!",
	"To us!",
	"So saying he knocked loudly with his swordhilt upon the open lattice.",
	"Mine host came forth at the summons, girding him with his tabard.",
	"Give you good den, my masters, said he with an obsequious bow.",
	"Bestir thyself, sirrah!",
	"cried he who had knocked.",
	"Look to our steeds.",
	"And for ourselves give us of your best for ifaith we need it.",
	"Lackaday, good masters, said the host, my poor house has but a bare larder.",
	"I know not what to offer your lordships.",
	"How now, fellow?",
	"cried the second of the party, a man of pleasant countenance, So servest thou the king’s messengers, master Taptun?",
	"An instantaneous change overspread the landlord’s visage.",
	"Cry you mercy, gentlemen, he said humbly.",
	"An you be the king’s messengers (God shield His Majesty!)",
	"you shall not want for aught.",
	"The king’s friends (God bless His Majesty!)",
	"shall not go afasting in my house I warrant me.",
	"Then about!",
	"cried the traveller who had not spoken, a lusty trencherman by his aspect.",
	"Hast aught to give us?",
	"Gadzooks!",
	"cried the last speaker.",
	"That likes me well.",
	"Pistachios!",
	"Aha!",
	"cried he of the pleasant countenance.",
	"A poor house and a bare larder, quotha!",
	"‘Tis a merry rogue.",
	"So in comes Martin asking where was Bloom.",
	"Where is he?",
	"says Lenehan.",
	"Defrauding widows and orphans.",
	"Isn’t that a fact, says John Wyse, what I was telling the citizen about Bloom and the Sinn Fein?",
	"That’s so, says Martin.",
	"Or so they allege.",
	"Who made those allegations?",
	"says Alf.",
	"I, says Joe.",
	"I’m the alligator.",
	"And after all, says John Wyse, why can’t a jew love his country like the next fellow?",
	"Why not?",
	"says J. J., when he’s quite sure which country it is.",
	"says Ned.",
	"Or who is he?",
	"No offence, Crofton.",
	"Who is Junius?",
	"says J. J.",
	"We don’t want him, says Crofter the Orangeman or presbyterian.",
	"We know that in the castle.",
	"Isn’t he a cousin of Bloom the dentist?",
	"says Jack Power.",
	"Not at all, says Martin.",
	"Only namesakes.",
	"His name was Virag, the father’s name that poisoned himself.",
	"He changed it by deedpoll, the father did.",
	"That’s the new Messiah for Ireland!",
	"says the citizen.",
	"Island of saints and sages!",
	"Well, they’re still waiting for their redeemer, says Martin.",
	"For that matter so are we.",
	"Yes, says J. J., and every male that’s born they think it may be their Messiah.",
	"Expecting every moment will be his next, says Lenehan.",
	"O, by God, says Ned, you should have seen Bloom before that son of his that died was born.",
	"En ventre sa mère, says J. J.",
	"Do you call that a man?",
	"says the citizen.",
	"I wonder did he ever put it out of sight, says Joe.",
	"Well, there were two children born anyhow, says Jack Power.",
	"And who does he suspect?",
	"says the citizen.",
	"Gob, there’s many a true word spoken in jest.",
	"One of those mixed middlings he is.",
	"Do you know what I’m telling you?",
	"Justifiable homicide, so it would.",
	"Then sloping off with his five quid without putting up a pint of stuff like a man.",
	"Give us your blessing.",
	"Not as much as would blind your eye.",
	"Charity to the neighbour, says Martin.",
	"But where is he?",
	"We can’t wait.",
	"A wolf in sheep’s clothing, says the citizen.",
	"That’s what he is.",
	"Virag from Hungary!",
	"Ahasuerus I call him.",
	"Cursed by God.",
	"Have you time for a brief libation, Martin?",
	"says Ned.",
	"Only one, says Martin.",
	"We must be quick.",
	"J. J. and S. —You, Jack?",
	"Crofton?",
	"Three half ones, Terry.",
	"Well, says Martin, rapping for his glass.",
	"God bless all here is my prayer.",
	"Amen, says the citizen.",
	"And I’m sure He will, says Joe.",
	"And last, beneath a canopy of cloth of gold came the reverend Father O’Flynn attended by Malachi and Patrick.",
	"And entering he blessed the viands and the beverages and the company of all the blessed answered his prayers.",
	"Adiutorium nostrum in nomine Domini.",
	"Qui fecit cœlum et terram.",
	"Dominus vobiscum.",
	"Et cum spiritu tuo.",
	"And so say all of us, says Jack.",
	"Thousand a year, Lambert, says Crofton or Crawford.",
	"Right, says Ned, taking up his John Jameson.",
	"And butter for fish.",
	"I was just round at the courthouse, says he, looking for you.",
	"I hope I’m not... —No, says Martin, we’re ready.",
	"Courthouse my eye and your pockets hanging down with gold and silver.",
	"Mean bloody scut.",
	"Stand us a drink itself.",
	"Devil a sweet fear!",
	"There’s a jew for you!",
	"All for number one.",
	"Cute as a shithouse rat.",
	"Hundred to five.",
	"Don’t tell anyone, says the citizen.",
	"Beg your pardon, says he.",
	"Come on boys, says Martin, seeing it was looking blue.",
	"Come along now.",
	"Don’t tell anyone, says the citizen, letting a bawl out of him.",
	"It’s a secret.",
	"And the bloody dog woke up and let a growl.",
	"Bye bye all, says Martin.",
	"Off with you, says Martin to the jarvey.",
	"Even so did they come and set them, those willing nymphs, the undying sisters.",
	"And they laughed, sporting in a circle of their foam: and the bark clave the waves.",
	"Let me alone, says he.",
	"Jesus, there’s always some bloody clown or other kicking up a bloody murder about bloody nothing.",
	"Gob, it’d turn the porter sour in your guts, so it would.",
	"Your fly is open, mister!",
	"And says he: Mendelssohn was a jew and Karl Marx and Mercadante and Spinoza.",
	"And the Saviour was a jew and his father was a jew.",
	"Your God.",
	"He had no father, says Martin.",
	"That’ll do now.",
	"Drive ahead.",
	"Whose God?",
	"says the citizen.",
	"Well, his uncle was a jew, says he.",
	"Your God was a jew.",
	"Christ was a jew like me.",
	"Gob, the citizen made a plunge back into the shop.",
	"By Jesus, says he, I’ll brain that bloody jewman for using the holy name.",
	"By Jesus, I’ll crucify him so I will.",
	"Give us that biscuitbox here.",
	"Stop!",
	"Stop!",
	"says Joe.",
	"The ceremony which went off with great éclat was characterised by the most affecting cordiality.",
	"Visszontlátásra, kedvés barátom!",
	"Visszontlátásra!",
	"Gone but not forgotten.",
	"And Ned and J. J. paralysed with the laughing.",
	"Bloody wars, says I, I’ll be in for the last gospel.",
	"Hold on, citizen, says Joe.",
	"Stop!",
	"Begob he drew his hand and made a swipe and let fly.",
	"Mercy of God the sun was in his eyes or he’d have left him for dead.",
	"Gob, he near sent it into the county Longford.",
	"The catastrophe was terrific and instantaneous in its effect.",
	"A., B. L., Mus.",
	"You never saw the like of it in all your born puff.",
	"The jarvey saved his life by furious driving as sure as God made Moses.",
	"What?",
	"O, Jesus, he did.",
	"And he let a volley of oaths after him.",
	"Did I kill him, says he, or what?",
	"And he shouting to the bloody dog: After him, Garry!",
	"After him, boy!",
	"Hundred to five!",
	"Jesus, he took the value of it out of him, I promise you.",
	"And there came a voice out of heaven, calling: Elijah!",
	"Elijah!",
	"And He answered with a main cry: Abba!",
	"Adonai!",
	"[ 13 ] The summer evening had begun to fold the world in its mysterious embrace.",
	"Cissy Caffrey bent over to him to tease his fat little plucks and the dainty dimple in his chin.",
	"Now, baby, Cissy Caffrey said.",
	"Say out big, big.",
	"I want a drink of water.",
	"And baby prattled after her: A jink a jink a jawbo.",
	"What a persuasive power that girl had!",
	"None of your spoilt beauties, Flora MacFlimsy sort, was Cissy Caffrey.",
	"And Edy Boardman laughed too at the quaint language of little brother.",
	"But just then there was a slight altercation between Master Tommy and Master Jacky.",
	"Boys will be boys and our two twins were no exception to this golden rule.",
	"the coveted castle too.",
	"Needless to say the cries of discomfited Master Tommy drew the attention of the girl friends.",
	"Come here, Tommy, his sister called imperatively.",
	"At once!",
	"And you, Jacky, for shame to throw poor Tommy in the dirty sand.",
	"Wait till I catch you for that.",
	"And in a sad plight he was too after his misadventure.",
	"Nasty bold Jacky!",
	"she cried.",
	"She put an arm round the little mariner and coaxed winningly: What’s your name?",
	"Butter and cream?",
	"Tell us who is your sweetheart, spoke Edy Boardman.",
	"Is Cissy your sweetheart?",
	"Nao, tearful Tommy said.",
	"Is Edy Boardman your sweetheart?",
	"Cissy queried.",
	"Nao, Tommy said.",
	"I know, Edy Boardman said none too amiably with an arch glance from her shortsighted eyes.",
	"I know who is Tommy’s sweetheart.",
	"Gerty is Tommy’s sweetheart.",
	"Nao, Tommy said on the verge of tears.",
	"But who was Gerty?",
	"No.",
	"Honour where honour is due.",
	"Why have women such eyes of witchery?",
	"Gerty’s were of the bluest Irish blue, set off by lustrous lashes and dark expressive brows.",
	"Time was when those brows were not so silkily seductive.",
	"That would suit Mrs Dignam because she had a button one.",
	"But Gerty’s crowning glory was her wealth of wonderful hair.",
	"It was dark brown with a natural wave in it.",
	"For an instant she was silent with rather sad downcast eyes.",
	"She was about to retort but something checked the words on her tongue.",
	"Inclination prompted her to speak out: dignity told her to be silent.",
	"Yet he was young and perchance he might learn to love her in time.",
	"And yet and yet!",
	"That strained look on her face!",
	"A gnawing sorrow is there all the time.",
	"You are lovely, Gerty, it said.",
	"The paly light of evening falls upon a face infinitely sad and wistful.",
	"Gerty MacDowell yearns in vain.",
	"He was too young to understand.",
	"He would not believe in love, a woman’s birthright.",
	"He called her little one in a strangely husky voice and snatched a half kiss (the first!)",
	"Impetuous fellow!",
	"But waiting, always waiting to be asked and it was leap year too and would soon be over.",
	"It would be like heaven.",
	"For such a one she yearns this balmy summer eve.",
	"The temper of him!",
	"O, he was a man already was little Tommy Caffrey since he was out of pinnies.",
	"You’re not my sister, naughty Tommy said.",
	"It’s my ball.",
	"Anything for a quiet life, laughed Ciss.",
	"I’d like to give him something, she said, so I would, where I won’t say.",
	"On the beeoteetom, laughed Cissy merrily.",
	"But not a pin cared Ciss.",
	"Let him!",
	"she said with a pert toss of her head and a piquant tilt of her nose.",
	"Give it to him too on the same place as quick as I’d look at him.",
	"Madcap Ciss with her golliwog curls.",
	"You had to laugh at her sometimes.",
	"That was just like Cissycums.",
	"There was none to come up to her for fun.",
	"And then there came out upon the air the sound of voices and the pealing anthem of the organ.",
	"How sad to poor Gerty’s ears!",
	"And still the voices sang in supplication to the Virgin most powerful, Virgin most merciful.",
	"Poor father!",
	"No-one would have thought the end was so near.",
	"Now he was laid to rest.",
	"Everyone thought the world of her for her gentle ways.",
	"You could see there was a story behind it.",
	"The colours were done something lovely.",
	"If you fail try again, Edy Boardman said.",
	"Gerty smiled assent and bit her lip.",
	"Pure jealousy of course it was nothing else to draw attention on account of the gentleman opposite looking.",
	"She felt the warm flush, a danger signal always with Gerty MacDowell, surging and flaming into her cheeks.",
	"The twins were now playing again right merrily for the troubles of childhood are but as fleeting summer showers.",
	"Cissy Caffrey played with baby Boardman till he crowed with glee, clapping baby hands in air.",
	"and, my word, didn’t the little chap enjoy that!",
	"And then she told him to say papa.",
	"Say papa, baby.",
	"Haja ja ja haja.",
	"And two great big lovely big tears coursing down his cheeks.",
	"She gazed out towards the distant sea.",
	"And while she gazed her heart went pitapat.",
	"Yes, it was her he was looking at, and there was meaning in his look.",
	"His eyes burned into her as though they would search her through and through, read her very soul.",
	"Wonderful eyes they were, superbly expressive, but could you trust them?",
	"People were so queer.",
	"She would have given worlds to know what it was.",
	"Here was that of which she had so often dreamed.",
	"Even if he was a protestant or methodist she could convert him easily if he truly loved her.",
	"There were wounds that wanted healing with heartbalm.",
	"Refuge of sinners.",
	"Comfortress of the afflicted.",
	"Ora pro nobis.",
	"Little monkeys common as ditchwater.",
	"Jacky!",
	"Tommy!",
	"Not they!",
	"What a great notion they had!",
	"So Cissy said it was the very last time she’d ever bring them out.",
	"Tableau!",
	"That would have been a very charming exposé for a gentleman like that to witness.",
	"because he had eyes in his head to see the difference for himself.",
	"He was eying her as a snake eyes its prey.",
	"And she said to Gerty: A penny for your thoughts.",
	"What?",
	"replied Gerty with a smile reinforced by the whitest of teeth.",
	"I was only wondering was it late.",
	"But Edy wanted to know because they were told to be in early.",
	"Wait, said Cissy, I’ll run ask my uncle Peter over there what’s the time by his conundrum.",
	"Passionate nature though he was Gerty could see that he had enormous control over himself.",
	"His dark eyes fixed themselves on her again drinking in her every contour, literally worshipping at her shrine.",
	"It is for you, Gertrude MacDowell, and you know it.",
	"Gerty winced sharply.",
	"A brief cold blaze shone from her eyes that spoke volumes of scorn immeasurable.",
	"She had loved him better than he knew.",
	"O, responded Gerty, quick as lightning, laughing, and the proud head flashed up.",
	"I can throw my cap at who I like because it’s leap year.",
	"Her words rang out crystalclear, more musical than the cooing of the ringdove, but they cut the silence icily.",
	"O my!",
	"Puddeny pie!",
	"protested Ciss.",
	"He has his bib destroyed.",
	"The slight contretemps claimed her attention but in two twos she set that little matter to rights.",
	"For Gerty had her dreams that no-one knew of.",
	"Art thou real, my ideal?",
	"it was called by Louis J Walsh, Magherafelt, and after there was something about twilight, wilt thou ever?",
	"But it must end, she felt.",
	"If she saw that magic lure in his eyes there would be no holding back for her.",
	"Love laughs at locksmiths.",
	"She would make the great sacrifice.",
	"Her every effort would be to share his thoughts.",
	"Dearer than the whole world would she be to him and gild his days with happiness.",
	"But even if—what then?",
	"Would it make a very great difference?",
	"From everything in the least indelicate her finebred nature instinctively recoiled.",
	"No, no: not that.",
	"Perhaps it was an old flame he was in mourning for from the days beyond recall.",
	"She thought she understood.",
	"She would try to understand him because men were so different.",
	"The old love was waiting, waiting with little white hands stretched out, with blue appealing eyes.",
	"Heart of mine!",
	"Nothing else mattered.",
	"Come what might she would be wild, untrammelled, free.",
	"It’s fireworks, Cissy Caffrey said.",
	"Come on, Gerty, Cissy called.",
	"It’s the bazaar fireworks.",
	"But Gerty was adamant.",
	"She had no intention of being at their beck and call.",
	"If they could run like rossies she could sit so she said she could see from where she was.",
	"The eyes that were fastened upon her set her pulses tingling.",
	"She looked at him a moment, meeting his glance, and a light broke in upon her.",
	"Whitehot passion was in that face, passion silent as the grave, and it had made her his.",
	"His hands and face were working and a tremour went over her.",
	"And then a rocket sprang and bang shot blind blank and O!",
	"then the Roman candle burst and it was like a sigh of O!",
	"and everyone cried O!",
	"O!",
	"they were all greeny dewy stars falling with golden, O so lovely, O, soft, sweet, soft!",
	"Then all melted away dewily in the grey air: all was silent.",
	"Ah!",
	"He was leaning back against the rock behind.",
	"Leopold Bloom (for it is he) stands silent, with bowed head before those young guileless eyes.",
	"What a brute he had been!",
	"At it again?",
	"A fair unsullied soul had called to him and, wretch that he was, how had he answered?",
	"An utter cad he had been!",
	"He of all men!",
	"Should a girl tell?",
	"No, a thousand times no.",
	"Gerty!",
	"We’re going.",
	"Come on.",
	"We can see from farther up.",
	"Gerty had an idea, one of love’s little ruses.",
	"Wonder if he’s too far to.",
	"She rose.",
	"Was it goodbye?",
	"No.",
	"She drew herself up to her full height.",
	"It was darker now and there were stones and bits of wood on the strand and slippy seaweed.",
	"Tight boots?",
	"No.",
	"She’s lame!",
	"O!",
	"Mr Bloom watched her as she limped away.",
	"Poor girl!",
	"That’s why she’s left on the shelf and the others did a sprint.",
	"Thought something was wrong by the cut of her jib.",
	"Jilted beauty.",
	"A defect is ten times worse in a woman.",
	"But makes them polite.",
	"Glad I didn’t know it when she was on show.",
	"Hot little devil all the same.",
	"I wouldn’t mind.",
	"Curiosity like a nun or a negress or a girl with glasses.",
	"That squinty one is delicate.",
	"Near her monthlies, I expect, makes them feel ticklish.",
	"I have such a bad headache today.",
	"Where did I put the letter?",
	"Yes, all right.",
	"All kinds of crazy longings.",
	"Licking pennies.",
	"Girl in Tranquilla convent that nun told me liked to smell rock oil.",
	"Virgins go mad in the end I suppose.",
	"Sister?",
	"How many women in Dublin have it today?",
	"Martha, she.",
	"Something in the air.",
	"That’s the moon.",
	"But then why don’t all women menstruate at the same time with the same moon, I mean?",
	"Depends on the time they were born I suppose.",
	"Or all start scratch then get out of step.",
	"Sometimes Molly and Milly together.",
	"Anyhow I got the best of that.",
	"Damned glad I didn’t do it in the bath this morning over her silly I will punish you letter.",
	"Made up for that tramdriver this morning.",
	"That gouger M’Coy stopping me to say nothing.",
	"And his wife engagement in the country valise, voice like a pickaxe.",
	"Thankful for small mercies.",
	"Cheap too.",
	"Yours for the asking.",
	"Because they want it themselves.",
	"Their natural craving.",
	"Shoals of them every evening poured out of offices.",
	"Reserve better.",
	"Don’t want it they throw it at you.",
	"Catch em alive, O.",
	"Pity they can’t see themselves.",
	"A dream of wellfilled hose.",
	"Where was that?",
	"Ah, yes.",
	"Mutoscope pictures in Capel street: for men only.",
	"Peeping Tom.",
	"Willy’s hat and what the girls did with it.",
	"Do they snapshot those girls or is it all a fake?",
	"Lingerie does it.",
	"Felt for the curves inside her déshabillé.",
	"Excites them also when they’re.",
	"I’m all clean come and dirty me.",
	"And they like dressing one another for the sacrifice.",
	"Milly delighted with Molly’s new blouse.",
	"At first.",
	"Put them all on to take them all off.",
	"Molly.",
	"Why I bought her the violet garters.",
	"Us too: the tie he wore, his lovely socks and turnedup trousers.",
	"He wore a pair of gaiters the night that first we met.",
	"His lovely shirt was shining beneath his what?",
	"of jet.",
	"Say a woman loses a charm with every pin she takes out.",
	"Pinned together.",
	"O, Mairy lost the pin of her.",
	"Dressed up to the nines for somebody.",
	"Fashion part of their charm.",
	"Just changes when you’re on the track of the secret.",
	"Except the east: Mary, Martha: now as then.",
	"No reasonable offer refused.",
	"She wasn’t in a hurry either.",
	"Always off to a fellow when they are.",
	"They never forget an appointment.",
	"Out on spec probably.",
	"They believe in chance because like themselves.",
	"And the others inclined to give her an odd dig.",
	"Barbed wire.",
	"Be sure now and write to me.",
	"And I’ll write to you.",
	"Now won’t you?",
	"Molly and Josie Powell.",
	"Till Mr Right comes along, then meet once in a blue moon.",
	"Tableau!",
	"O, look who it is for the love of God!",
	"How are you at all?",
	"What have you been doing with yourself?",
	"Kiss and delighted to, kiss, to see you.",
	"Picking holes in each other’s appearance.",
	"You’re looking splendid.",
	"Sister souls.",
	"Showing their teeth at one another.",
	"How many have you left?",
	"Wouldn’t lend each other a pinch of salt.",
	"Ah!",
	"Devils they are when that’s coming on them.",
	"Dark devilish appearance.",
	"Molly often told me feel things a ton weight.",
	"Scratch the sole of my foot.",
	"O that way!",
	"O, that’s exquisite!",
	"Feel it myself too.",
	"Good to rest once in a way.",
	"Wonder if it’s bad to go with them then.",
	"Safe in one way.",
	"Turns milk, makes fiddlestrings snap.",
	"Something about withering plants I read in a garden.",
	"Besides they say if the flower withers she wears she’s a flirt.",
	"All are.",
	"Daresay she felt I.",
	"When you feel like that you often meet what you feel.",
	"Liked me or what?",
	"Dress they look at.",
	"Always know a fellow courting: collars and cuffs.",
	"Well cocks and lions do the same and stags.",
	"Same time might prefer a tie undone or something.",
	"Trousers?",
	"Suppose I when I was?",
	"No.",
	"Gently does it.",
	"Dislike rough and tumble.",
	"Kiss in the dark and never tell.",
	"Saw something in me.",
	"Wonder what.",
	"Sooner have me as I am than some poet chap with bearsgrease plastery hair, lovelock over his dexter optic.",
	"To aid gentleman in literary.",
	"Ought to attend to my appearance my age.",
	"Didn’t let her see me in profile.",
	"Still, you never know.",
	"Pretty girls and ugly men marrying.",
	"Beauty and the beast.",
	"Besides I can’t be so if Molly.",
	"Took off her hat to show her hair.",
	"Wide brim.",
	"Hair strong in rut.",
	"Ten bob I got for Molly’s combings when we were on the rocks in Holles street.",
	"Why not?",
	"Suppose he gave her money.",
	"Why not?",
	"All a prejudice.",
	"She’s worth ten, fifteen, more, a pound.",
	"What?",
	"I think so.",
	"All that for nothing.",
	"Bold hand: Mrs Marion.",
	"Did I forget to write address on that letter like the postcard I sent to Flynn?",
	"And the day I went to Drimmie’s without a necktie.",
	"Wrangle with Molly it was put me off.",
	"No, I remember.",
	"Richie Goulding: he’s another.",
	"Weighs on his mind.",
	"Funny my watch stopped at half past four.",
	"Dust.",
	"Shark liver oil they use to clean.",
	"Could do it myself.",
	"Save.",
	"Was that just when he, she?",
	"O, he did.",
	"Into her.",
	"She did.",
	"Done.",
	"Ah!",
	"Mr Bloom with careful hand recomposed his wet shirt.",
	"O Lord, that little limping devil.",
	"Begins to feel cold and clammy.",
	"Aftereffect not pleasant.",
	"Still you have to get rid of it someway.",
	"They don’t care.",
	"Complimented perhaps.",
	"Go home to nicey bread and milky and say night prayers with the kiddies.",
	"Well, aren’t they?",
	"See her as she is spoil all.",
	"Must have the stage setting, the rouge, costume, position, music.",
	"The name too.",
	"Amours of actresses.",
	"Nell Gwynn, Mrs Bracegirdle, Maud Branscombe.",
	"Curtain up.",
	"Moonlight silver effulgence.",
	"Maiden discovered with pensive bosom.",
	"Little sweetheart come and kiss me.",
	"Still, I feel.",
	"The strength it gives a man.",
	"That’s the secret of it.",
	"Good job I let off there behind the wall coming out of Dignam’s.",
	"Cider that was.",
	"Otherwise I couldn’t have.",
	"Makes you want to sing after.",
	"Lacaus esant taratara.",
	"Suppose I spoke to her.",
	"What about?",
	"Bad plan however if you don’t know how to end the conversation.",
	"Ask them a question they ask you another.",
	"Good idea if you’re stuck.",
	"Gain time.",
	"But then you’re in a cart.",
	"Wonderful of course if you say: good evening, and you see she’s on for it: good evening.",
	"O but the dark evening in the Appian way I nearly spoke to Mrs Clinch O thinking she was.",
	"Whew!",
	"Girl in Meath street that night.",
	"All the dirty things I made her say.",
	"All wrong of course.",
	"My arks she called it.",
	"It’s so hard to find one who.",
	"Aho!",
	"If you don’t answer when they solicit must be horrible for them till they harden.",
	"And kissed my hand when I gave her the extra two shillings.",
	"Parrots.",
	"Press the button and the bird will squeak.",
	"Wish she hadn’t called me sir.",
	"O, her mouth in the dark!",
	"And you a married man with a single girl!",
	"That’s what they enjoy.",
	"Taking a man from another woman.",
	"Or even hear of it.",
	"Different with me.",
	"Glad to get away from other chap’s wife.",
	"Eating off his cold plate.",
	"Chap in the Burton today spitting back gumchewed gristle.",
	"French letter still in my pocketbook.",
	"Cause of half the trouble.",
	"But might happen sometime, I don’t think.",
	"Come in, all is prepared.",
	"I dreamt.",
	"What?",
	"Worst is beginning.",
	"How they change the venue when it’s not what they like.",
	"Ask you do you like mushrooms because she once knew a gentleman who.",
	"Or ask you what someone was going to say when he changed his mind and stopped.",
	"Yet if I went the whole hog, say: I want to, something like that.",
	"Because I did.",
	"She too.",
	"Offend her.",
	"Then make it up.",
	"Pretend to want something awfully, then cry off for her sake.",
	"Flatters them.",
	"She must have been thinking of someone else all the time.",
	"What harm?",
	"Must since she came to the use of reason, he, he and he.",
	"First kiss does the trick.",
	"The propitious moment.",
	"Something inside them goes pop.",
	"Mushy like, tell by their eye, on the sly.",
	"First thoughts are best.",
	"Remember that till their dying day.",
	"Molly, lieutenant Mulvey that kissed her under the Moorish wall beside the gardens.",
	"Fifteen she told me.",
	"But her breasts were developed.",
	"Fell asleep then.",
	"After Glencree dinner that was when we drove home.",
	"Featherbed mountain.",
	"Gnashing her teeth in sleep.",
	"Lord mayor had his eye on her too.",
	"Val Dillon.",
	"Apoplectic.",
	"There she is with them down there for the fireworks.",
	"My fireworks.",
	"Up like a rocket, down like a stick.",
	"And the children, twins they must be, waiting for something to happen.",
	"Want to be grownups.",
	"Dressing in mother’s clothes.",
	"Time enough, understand all the ways of the world.",
	"And the dark one with the mop head and the nigger mouth.",
	"I knew she could whistle.",
	"Mouth made for that.",
	"Like Molly.",
	"Why that highclass whore in Jammet’s wore her veil only to her nose.",
	"Would you mind, please, telling me the right time?",
	"I’ll tell you the right time up a dark lane.",
	"Say prunes and prisms forty times every morning, cure for fat lips.",
	"Caressing the little boy too.",
	"Onlookers see most of the game.",
	"Of course they understand birds, animals, babies.",
	"In their line.",
	"Didn’t look back when she was going down the strand.",
	"Wouldn’t give that satisfaction.",
	"Those girls, those girls, those lovely seaside girls.",
	"Fine eyes she had, clear.",
	"It’s the white of the eye brings that out not so much the pupil.",
	"Did she know what I?",
	"Course.",
	"Like a cat sitting beyond a dog’s jump.",
	"Call that innocence?",
	"Poor idiot!",
	"His wife has her work cut out for her.",
	"Never see them sit on a bench marked Wet Paint.",
	"Eyes all over them.",
	"Look under the bed for what’s not there.",
	"Longing to get the fright of their lives.",
	"Sharp as needles they are.",
	"Had, too.",
	"Where do they get that?",
	"Typist going up Roger Greene’s stairs two at a time to show her understandings.",
	"Handed down from father to, mother to daughter, I mean.",
	"Bred in the bone.",
	"Milly for example drying her handkerchief on the mirror to save the ironing.",
	"Best place for an ad to catch a woman’s eye on a mirror.",
	"Clever little minx.",
	"I never told her.",
	"Neat way she carries parcels too.",
	"Attract men, small thing like that.",
	"Holding up her hand, shaking it, to let the blood flow back when it was red.",
	"Who did you learn that from?",
	"Nobody.",
	"Something the nurse taught me.",
	"O, don’t they know!",
	"Three years old she was in front of Molly’s dressingtable, just before we left Lombard street west.",
	"Me have a nice pace.",
	"Mullingar.",
	"Who knows?",
	"Ways of the world.",
	"Young student.",
	"Straight on her pins anyway not like the other.",
	"Still she was game.",
	"Lord, I am wet.",
	"Devil you are.",
	"Swell of her calf.",
	"Transparent stockings, stretched to breaking point.",
	"Not like that frump today.",
	"A. E. Rumpled stockings.",
	"Or the one in Grafton street.",
	"White.",
	"Wow!",
	"Beef to the heel.",
	"A monkey puzzle rocket burst, spluttering in darting crackles.",
	"Zrads and zrads, zrads, zrads.",
	"Will she?",
	"Watch!",
	"Watch!",
	"See!",
	"Looked round.",
	"She smelt an onion.",
	"Darling, I saw, your.",
	"I saw all.",
	"Lord!",
	"Did me good all the same.",
	"Off colour after Kiernan’s, Dignam’s.",
	"For this relief much thanks.",
	"In Hamlet, that is.",
	"Lord!",
	"It was all things combined.",
	"Excitement.",
	"When she leaned back, felt an ache at the butt of my tongue.",
	"Your head it simply swirls.",
	"He’s right.",
	"Might have made a worse fool of myself however.",
	"Instead of talking about nothing.",
	"Then I will tell you all.",
	"Still it was a kind of language between us.",
	"It couldn’t be?",
	"No, Gerty they called her.",
	"Might be false name however like my name and the address Dolphin’s barn a blind.",
	"Her maiden name was Jemina Brown And she lived with her mother in Irishtown.",
	"Place made me think of that I suppose.",
	"All tarred with the same brush.",
	"Wiping pens in their stockings.",
	"But the ball rolled down to her as if it understood.",
	"Every bullet has its billet.",
	"Course I never could throw anything straight at school.",
	"Crooked as a ram’s horn.",
	"No soft job.",
	"Saves them.",
	"Keeps them out of harm’s way.",
	"Nature.",
	"Washing child, washing corpse.",
	"Dignam.",
	"Children’s hands always round them.",
	"Cocoanut skulls, monkeys, not even closed at first, sour milk in their swaddles and tainted curds.",
	"Oughtn’t to have given that child an empty teat to suck.",
	"Fill it up with wind.",
	"Mrs Beaufoy, Purefoy.",
	"Must call to the hospital.",
	"Wonder is nurse Callan there still.",
	"She used to look over some nights when Molly was in the Coffee Palace.",
	"That young doctor O’Hare I noticed her brushing his coat.",
	"And Mrs Breen and Mrs Dignam once like that too, marriageable.",
	"Worst of all at night Mrs Duggan told me in the City Arms.",
	"Husband rolling in drunk, stink of pub off him like a polecat.",
	"Have that in your nose in the dark, whiff of stale boose.",
	"Then ask in the morning: was I drunk last night?",
	"Bad policy however to fault the husband.",
	"Chickens come home to roost.",
	"They stick by one another like glue.",
	"Maybe the women’s fault also.",
	"That’s where Molly can knock spots off them.",
	"It’s the blood of the south.",
	"Moorish.",
	"Also the form, the figure.",
	"Hands felt for the opulent.",
	"Just compare for instance those others.",
	"Wife locked up at home, skeleton in the cupboard.",
	"Allow me to introduce my.",
	"Then they trot you out some kind of a nondescript, wouldn’t know what to call her.",
	"Always see a fellow’s weak point in his wife.",
	"Still there’s destiny in it, falling in love.",
	"Have their own secrets between them.",
	"Chaps that would go to the dogs if some woman didn’t take them in hand.",
	"Then little chits of girls, height of a shilling in coppers, with little hubbies.",
	"As God made them he matched them.",
	"Sometimes children turn out well enough.",
	"Twice nought makes one.",
	"Or old rich chap of seventy and blushing bride.",
	"Marry in May and repent in December.",
	"This wet is very unpleasant.",
	"Stuck.",
	"Well the foreskin is not back.",
	"Better detach.",
	"Ow!",
	"Other hand a sixfooter with a wifey up to his watchpocket.",
	"Long and the short of it.",
	"Big he and little she.",
	"Very strange about my watch.",
	"Wristwatches are always going wrong.",
	"Wonder is there any magnetic influence between the person because that was about the time he.",
	"Yes, I suppose, at once.",
	"Cat’s away, the mice will play.",
	"I remember looking in Pill lane.",
	"Also that now is magnetism.",
	"Back of everything magnetism.",
	"Earth for instance pulling this and being pulled.",
	"That causes movement.",
	"And time, well that’s the time the movement takes.",
	"Then if one thing stopped the whole ghesabo would stop bit by bit.",
	"Because it’s all arranged.",
	"Magnetic needle tells you what’s going on in the sun, the stars.",
	"Little piece of steel iron.",
	"When you hold out the fork.",
	"Come.",
	"Come.",
	"Tip.",
	"Woman and man that is.",
	"Fork and steel.",
	"Molly, he.",
	"Tip.",
	"Have to let fly.",
	"Wonder how is she feeling in that region.",
	"Shame all put on before third person.",
	"More put out about a hole in her stocking.",
	"Molly, her underjaw stuck out, head back, about the farmer in the ridingboots and spurs at the horse show.",
	"And when the painters were in Lombard street west.",
	"Fine voice that fellow had.",
	"How Giuglini began.",
	"Smell that I did.",
	"Like flowers.",
	"It was too.",
	"Violets.",
	"Came from the turpentine probably in the paint.",
	"Make their own use of everything.",
	"Same time doing it scraped her slipper on the floor so they wouldn’t hear.",
	"But lots of them can’t kick the beam, I think.",
	"Keep that thing up for hours.",
	"Kind of a general all round over me and half down my back.",
	"Wait.",
	"Hm.",
	"Hm.",
	"Yes.",
	"That’s her perfume.",
	"Why she waved her hand.",
	"I leave you this to think of me when I’m far away on the pillow.",
	"What is it?",
	"Heliotrope?",
	"No.",
	"Hyacinth?",
	"Hm.",
	"Roses, I think.",
	"She’d like scent of that kind.",
	"Sweet and cheap: soon sour.",
	"Why Molly likes opoponax.",
	"Suits her, with a little jessamine mixed.",
	"Her high notes and her low notes.",
	"At the dance night she met him, dance of the hours.",
	"Heat brought it out.",
	"She was wearing her black and it had the perfume of the time before.",
	"Good conductor, is it?",
	"Or bad?",
	"Light too.",
	"Suppose there’s some connection.",
	"For instance if you go into a cellar where it’s dark.",
	"Mysterious thing too.",
	"Why did I smell it only now?",
	"Took its time in coming like herself, slow but sure.",
	"Suppose it’s ever so many millions of tiny grains blown across.",
	"Yes, it is.",
	"Because those spice islands, Cinghalese this morning, smell them leagues off.",
	"Tell you what it is.",
	"Clings to everything she takes off.",
	"Vamp of her stockings.",
	"Warm shoe.",
	"Stays.",
	"Drawers: little kick, taking them off.",
	"Byby till next time.",
	"Also the cat likes to sniff in her shift on the bed.",
	"Know her smell in a thousand.",
	"Bathwater too.",
	"Reminds me of strawberries and cream.",
	"Wonder where it is really.",
	"There or the armpits or under the neck.",
	"Because you get it out of all holes and corners.",
	"Hyacinth perfume made of oil of ether or something.",
	"Muskrat.",
	"Bag under their tails.",
	"One grain pour off odour for years.",
	"Dogs at each other behind.",
	"Good evening.",
	"Evening.",
	"How do you sniff?",
	"Hm.",
	"Hm.",
	"Very well, thank you.",
	"Animals go by that.",
	"Yes now, look at it that way.",
	"We’re the same.",
	"Some women, instance, warn you off when they have their period.",
	"Come near.",
	"Then get a hogo you could hang your hat on.",
	"Like what?",
	"Potted herrings gone stale or.",
	"Boof!",
	"Please keep off the grass.",
	"Perhaps they get a man smell off us.",
	"What though?",
	"Cigary gloves long John had on his desk the other day.",
	"Breath?",
	"What you eat and drink gives that.",
	"No.",
	"Mansmell, I mean.",
	"Must be connected with that because priests that are supposed to be are different.",
	"Women buzz round it like flies round treacle.",
	"Railed off the altar get on to it at any cost.",
	"The tree of forbidden priest.",
	"O, father, will you?",
	"Let me be the first to.",
	"That diffuses itself all through the body, permeates.",
	"Source of life.",
	"And it’s extremely curious the smell.",
	"Celery sauce.",
	"Let me.",
	"Mr Bloom inserted his nose.",
	"Hm.",
	"Into the.",
	"Hm.",
	"Opening of his waistcoat.",
	"Almonds or.",
	"No.",
	"Lemons it is.",
	"Ah no, that’s the soap.",
	"O by the by that lotion.",
	"I knew there was something on my mind.",
	"Never went back and the soap not paid.",
	"Dislike carrying bottles like that hag this morning.",
	"Hynes might have paid me that three shillings.",
	"I could mention Meagher’s just to remind him.",
	"Still if he works that paragraph.",
	"Two and nine.",
	"Bad opinion of me he’ll have.",
	"Call tomorrow.",
	"How much do I owe you?",
	"Three and nine?",
	"Two and nine, sir.",
	"Ah.",
	"Might stop him giving credit another time.",
	"Lose your customers that way.",
	"Pubs do.",
	"Fellows run up a bill on the slate and then slinking around the back streets into somewhere else.",
	"Here’s this nobleman passed before.",
	"Blown in from the bay.",
	"Just went as far as turn back.",
	"Always at home at dinnertime.",
	"Looks mangled out: had a good tuck in.",
	"Enjoying nature now.",
	"Grace after meals.",
	"After supper walk a mile.",
	"Sure he has a small bank balance somewhere, government sit.",
	"Walk after him now make him awkward like those newsboys me today.",
	"Still you learn something.",
	"See ourselves as others see us.",
	"So long as women don’t mock what matter?",
	"That’s the way to find out.",
	"Ask yourself who is he now.",
	"The Mystery Man on the Beach, prize titbit story by Mr Leopold Bloom.",
	"Payment at the rate of one guinea per column.",
	"And that fellow today at the graveside in the brown macintosh.",
	"Corns on his kismet however.",
	"Healthy perhaps absorb all the.",
	"Whistle brings rain they say.",
	"Must be some somewhere.",
	"Salt in the Ormond damp.",
	"The body feels the atmosphere.",
	"Old Betty’s joints are on the rack.",
	"Mother Shipton’s prophecy that is about ships around they fly in the twinkling.",
	"No.",
	"Signs of rain it is.",
	"The royal reader.",
	"And distant hills seem coming nigh.",
	"Howth.",
	"Bailey light.",
	"Two, four, six, eight, nine.",
	"See.",
	"Has to change or they might think it a house.",
	"Wreckers.",
	"Grace Darling.",
	"People afraid of the dark.",
	"Also glowworms, cyclists: lightingup time.",
	"Jewels diamonds flash better.",
	"Women.",
	"Light is a kind of reassuring.",
	"Not going to hurt you.",
	"Better now of course than long ago.",
	"Country roads.",
	"Run you through the small guts for nothing.",
	"Still two types there are you bob against.",
	"Scowl or smile.",
	"Pardon!",
	"Not at all.",
	"Best time to spray plants too in the shade after the sun.",
	"Some light still.",
	"Red rays are longest.",
	"Roygbiv Vance taught us: red, orange, yellow, green, blue, indigo, violet.",
	"A star I see.",
	"Venus?",
	"Can’t tell yet.",
	"Two.",
	"When three it’s night.",
	"Were those nightclouds there all the time?",
	"Looks like a phantom ship.",
	"No.",
	"Wait.",
	"Trees are they?",
	"An optical illusion.",
	"Mirage.",
	"Land of the setting sun this.",
	"Homerule sun setting in the southeast.",
	"My native land, goodnight.",
	"Dew falling.",
	"Bad for you, dear, to sit on that stone.",
	"Brings on white fluxions.",
	"Never have little baby then less he was big strong fight his way up through.",
	"Might get piles myself.",
	"Sticks too like a summer cold, sore on the mouth.",
	"Cut with grass or paper worst.",
	"Friction of the position.",
	"Like to be that rock she sat on.",
	"O sweet little, you don’t know how nice you looked.",
	"I begin to like them at that age.",
	"Green apples.",
	"Grab at all that offer.",
	"Suppose it’s the only time we cross legs, seated.",
	"Also the library today: those girl graduates.",
	"Happy chairs under them.",
	"But it’s the evening influence.",
	"They feel all that.",
	"Open like flowers, know their hours, sunflowers, Jerusalem artichokes, in ballrooms, chandeliers, avenues under the lamps.",
	"Nightstock in Mat Dillon’s garden where I kissed her shoulder.",
	"Wish I had a full length oilpainting of her then.",
	"June that was too I wooed.",
	"The year returns.",
	"History repeats itself.",
	"Ye crags and peaks I’m with you once again.",
	"Life, love, voyage round your own little world.",
	"And now?",
	"Sad about her lame of course but must be on your guard not to feel too much pity.",
	"They take advantage.",
	"All quiet on Howth now.",
	"The distant hills seem.",
	"Where we.",
	"The rhododendrons.",
	"I am a fool perhaps.",
	"He gets the plums, and I the plumstones.",
	"Where I come in.",
	"All that old hill has seen.",
	"Names change: that’s all.",
	"Lovers: yum yum.",
	"Tired I feel now.",
	"Will I get up?",
	"O wait.",
	"Drained all the manhood out of me, little wretch.",
	"She kissed me.",
	"Never again.",
	"My youth.",
	"Only once it comes.",
	"Or hers.",
	"Take the train there tomorrow.",
	"No.",
	"Returning not the same.",
	"Like kids your second visit to a house.",
	"The new I want.",
	"Nothing new under the sun.",
	"Care of P. O. Dolphin’s Barn.",
	"Are you not happy in your?",
	"Naughty darling.",
	"At Dolphin’s barn charades in Luke Doyle’s house.",
	"Mat Dillon and his bevy of daughters: Tiny, Atty, Floey, Maimy, Louy, Hetty.",
	"Molly too.",
	"Eightyseven that was.",
	"Year before we.",
	"And the old major, partial to his drop of spirits.",
	"Curious she an only child, I an only child.",
	"So it returns.",
	"Think you’re escaping and run into yourself.",
	"Longest way round is the shortest way home.",
	"And just when he and she.",
	"Circus horse walking in a ring.",
	"Rip van Winkle we played.",
	"Rip: tear in Henny Doyle’s overcoat.",
	"Van: breadvan delivering.",
	"Winkle: cockles and periwinkles.",
	"Then I did Rip van Winkle coming back.",
	"She leaned on the sideboard watching.",
	"Moorish eyes.",
	"Twenty years asleep in Sleepy Hollow.",
	"All changed.",
	"Forgotten.",
	"The young are old.",
	"His gun rusty from the dew.",
	"Ba.",
	"What is that flying about?",
	"Swallow?",
	"Bat probably.",
	"Thinks I’m a tree, so blind.",
	"Have birds no smell?",
	"Metempsychosis.",
	"They believed you could be changed into a tree from grief.",
	"Weeping willow.",
	"Ba.",
	"There he goes.",
	"Funny little beggar.",
	"Wonder where he lives.",
	"Belfry up there.",
	"Very likely.",
	"Hanging by his heels in the odour of sanctity.",
	"Bell scared him out, I suppose.",
	"Mass seems to be over.",
	"Could hear them all at it.",
	"Pray for us.",
	"And pray for us.",
	"And pray for us.",
	"Good idea the repetition.",
	"Same thing with ads.",
	"Buy from us.",
	"And buy from us.",
	"Yes, there’s the light in the priest’s house.",
	"Their frugal meal.",
	"Remember about the mistake in the valuation when I was in Thom’s.",
	"Twentyeight it is.",
	"Two houses they have.",
	"Gabriel Conroy’s brother is curate.",
	"Ba.",
	"Again.",
	"Wonder why they come out at night like mice.",
	"They’re a mixed breed.",
	"Birds are like hopping mice.",
	"What frightens them, light or noise?",
	"Better sit still.",
	"Like a little man in a cloak he is with tiny hands.",
	"Weeny bones.",
	"Almost see them shimmering, kind of a bluey white.",
	"Colours depend on the light you see.",
	"Stare the sun for example like the eagle then look at a shoe see a blotch blob yellowish.",
	"Wants to stamp his trademark on everything.",
	"Instance, that cat this morning on the staircase.",
	"Colour of brown turf.",
	"Say you never see them with three colours.",
	"Not true.",
	"That half tabbywhite tortoiseshell in the City Arms with the letter em on her forehead.",
	"Body fifty different colours.",
	"Howth a while ago amethyst.",
	"Glass flashing.",
	"That’s how that wise man what’s his name with the burning glass.",
	"Then the heather goes on fire.",
	"It can’t be tourists’ matches.",
	"What?",
	"Perhaps the sticks dry rub together in the wind and light.",
	"Or broken bottles in the furze act as a burning glass in the sun.",
	"Archimedes.",
	"I have it!",
	"My memory’s not so bad.",
	"Ba.",
	"Who knows what they’re always flying for.",
	"Insects?",
	"That bee last week got into the room playing with his shadow on the ceiling.",
	"Might be the one bit me, come back to see.",
	"Birds too.",
	"Never find out.",
	"Or what they say.",
	"Like our small talk.",
	"And says she and says he.",
	"Nerve they have to fly over the ocean and back.",
	"Lots must be killed in storms, telegraph wires.",
	"Dreadful life sailors have too.",
	"Big brutes of oceangoing steamers floundering along in the dark, lowing out like seacows.",
	"Faugh a ballagh!",
	"Out of that, bloody curse to you!",
	"Married too.",
	"Sometimes away for years at the ends of the earth somewhere.",
	"No ends really because it’s round.",
	"Wife in every port they say.",
	"She has a good job if she minds it till Johnny comes marching home again.",
	"If ever he does.",
	"Smelling the tail end of ports.",
	"How can they like the sea?",
	"Yet they do.",
	"The anchor’s weighed.",
	"Off he sails with a scapular or a medal on him for luck.",
	"Well.",
	"And the tephilim no what’s this they call it poor papa’s father had on his door to touch.",
	"That brought us out of the land of Egypt and into the house of bondage.",
	"Something in all those superstitions because when you go out never know what dangers.",
	"Do fish ever get seasick?",
	"Not my fault, old cockalorum.",
	"They floated, fell: they faded.",
	"The shepherd’s hour: the hour of folding: hour of tryst.",
	"And among the five young trees a hoisted lintstock lit the lamp at Leahy’s terrace.",
	"By screens of lighted windows, by equal gardens a shrill voice went crying, wailing: Evening Telegraph, stop press edition!",
	"Result of the Gold Cup races!",
	"and from the door of Dignam’s house a boy ran out and called.",
	"Twittering the bat flew here, flew there.",
	"Far out over the sands the coming surf crept, grey.",
	"He lay but opened a red eye unsleeping, deep and slowly breathing, slumberous but awake.",
	"And far on Kish bank the anchored lightship twinkled, winked at Mr Bloom.",
	"Life those chaps out there must have, stuck in the same spot.",
	"Irish Lights board.",
	"Penance for their sins.",
	"Coastguards too.",
	"Rocket and breeches buoy and lifeboat.",
	"Day we went out for the pleasure cruise in the Erin’s King, throwing them the sack of old papers.",
	"Bears in the zoo.",
	"Filthy trip.",
	"Drunkards out to shake up their livers.",
	"Puking overboard to feed the herrings.",
	"Nausea.",
	"And the women, fear of God in their faces.",
	"Milly, no sign of funk.",
	"Her blue scarf loose, laughing.",
	"Don’t know what death is at that age.",
	"And then their stomachs clean.",
	"But being lost they fear.",
	"When we hid behind the tree at Crumlin.",
	"I didn’t want to.",
	"Mamma!",
	"Mamma!",
	"Babes in the wood.",
	"Frightening them with masks too.",
	"Throwing them up in the air to catch them.",
	"I’ll murder you.",
	"Is it only half fun?",
	"Or children playing battle.",
	"Whole earnest.",
	"How can people aim guns at each other.",
	"Sometimes they go off.",
	"Poor kids!",
	"Only troubles wildfire and nettlerash.",
	"Calomel purge I got her for that.",
	"After getting better asleep with Molly.",
	"Very same teeth she has.",
	"What do they love?",
	"Another themselves?",
	"But the morning she chased her with the umbrella.",
	"Perhaps so as not to hurt.",
	"I felt her pulse.",
	"Ticking.",
	"Little hand it was: now big.",
	"Dearest Papli.",
	"All that the hand says when you touch.",
	"Loved to count my waistcoat buttons.",
	"Her first stays I remember.",
	"Made me laugh to see.",
	"Little paps to begin with.",
	"Left one is more sensitive, I think.",
	"Mine too.",
	"Nearer the heart?",
	"Padding themselves out if fat is in fashion.",
	"Her growing pains at night, calling, wakening me.",
	"Frightened she was when her nature came on her first.",
	"Poor child!",
	"Strange moment for the mother too.",
	"Brings back her girlhood.",
	"Gibraltar.",
	"Looking from Buena Vista.",
	"O’Hara’s tower.",
	"The seabirds screaming.",
	"Old Barbary ape that gobbled all his family.",
	"Sundown, gunfire for the men to cross the lines.",
	"Looking out over the sea she told me.",
	"Evening like this, but clear, no clouds.",
	"I always thought I’d marry a lord or a rich gentleman coming with a private yacht.",
	"Buenas noches, señorita.",
	"El hombre ama la muchacha hermosa.",
	"Why me?",
	"Because you were so foreign from the others.",
	"Better not stick here all night like a limpet.",
	"This weather makes you dull.",
	"Must be getting on for nine by the light.",
	"Go home.",
	"Too late for Leah, Lily of Killarney.",
	"No.",
	"Might be still up.",
	"Call to the hospital to see.",
	"Hope she’s over.",
	"Long day I’ve had.",
	"Martha, the bath, funeral, house of Keyes, museum with those goddesses, Dedalus’ song.",
	"Then that bawler in Barney Kiernan’s.",
	"Got my own back there.",
	"Drunken ranters what I said about his God made him wince.",
	"Mistake to hit back.",
	"Or?",
	"No.",
	"Ought to go home and laugh at themselves.",
	"Always want to be swilling in company.",
	"Afraid to be alone like a child of two.",
	"Suppose he hit me.",
	"Look at it other way round.",
	"Not so bad then.",
	"Perhaps not to hurt he meant.",
	"Three cheers for Israel.",
	"Three cheers for the sister-in-law he hawked about, three fangs in her mouth.",
	"Same style of beauty.",
	"Particularly nice old party for a cup of tea.",
	"The sister of the wife of the wild man of Borneo has just come to town.",
	"Imagine that in the early morning at close range.",
	"Everyone to his taste as Morris said when he kissed the cow.",
	"But Dignam’s put the boots on it.",
	"Houses of mourning so depressing because you never know.",
	"Anyhow she wants the money.",
	"Must call to those Scottish Widows as I promised.",
	"Strange name.",
	"Takes it for granted we’re going to pop off first.",
	"That widow on Monday was it outside Cramer’s that looked at me.",
	"Buried the poor husband but progressing favourably on the premium.",
	"Her widow’s mite.",
	"Well?",
	"What do you expect her to do?",
	"Must wheedle her way along.",
	"Widower I hate to see.",
	"Looks so forlorn.",
	"Poor man O’Connor wife and five children poisoned by mussels here.",
	"The sewage.",
	"Hopeless.",
	"Some good matronly woman in a porkpie hat to mother him.",
	"Take him in tow, platter face and a large apron.",
	"Ladies’ grey flannelette bloomers, three shillings a pair, astonishing bargain.",
	"Plain and loved, loved for ever, they say.",
	"Ugly: no woman thinks she is.",
	"Love, lie and be handsome for tomorrow we die.",
	"See him sometimes walking about trying to find out who played the trick.",
	"U.P.",
	": up.",
	"Fate that is.",
	"He, not me.",
	"Also a shop often noticed.",
	"Curse seems to dog it.",
	"Dreamt last night?",
	"Wait.",
	"Something confused.",
	"She had red slippers on.",
	"Turkish.",
	"Wore the breeches.",
	"Suppose she does?",
	"Would I like her in pyjamas?",
	"Damned hard to answer.",
	"Nannetti’s gone.",
	"Mailboat.",
	"Near Holyhead by now.",
	"Must nail that ad of Keyes’s.",
	"Work Hynes and Crawford.",
	"Petticoats for Molly.",
	"She has something to put in them.",
	"What’s that?",
	"Might be money.",
	"Mr Bloom stooped and turned over a piece of paper on the strand.",
	"He brought it near his eyes and peered.",
	"Letter?",
	"No.",
	"Can’t read.",
	"Better go.",
	"Better.",
	"I’m tired to move.",
	"Page of an old copybook.",
	"All those holes and pebbles.",
	"Who could count them?",
	"Never know what you find.",
	"Bottle with story of a treasure in it, thrown from a wreck.",
	"Parcels post.",
	"Children always want to throw things in the sea.",
	"Trust?",
	"Bread cast on the waters.",
	"What’s this?",
	"Bit of stick.",
	"O!",
	"Exhausted that female has me.",
	"Not so young now.",
	"Will she come here tomorrow?",
	"Wait for her somewhere for ever.",
	"Must come back.",
	"Murderers do.",
	"Will I?",
	"Mr Bloom with his stick gently vexed the thick sand at his foot.",
	"Write a message for her.",
	"Might remain.",
	"What?",
	"I.",
	"Some flatfoot tramp on it in the morning.",
	"Useless.",
	"Washed away.",
	"Tide comes here.",
	"Saw a pool near her foot.",
	"Bend, see my face there, dark mirror, breathe on it, stirs.",
	"All these rocks with lines and scars and letters.",
	"O, those transparent!",
	"Besides they don’t know.",
	"What is the meaning of that other world.",
	"I called you naughty boy because I do not like.",
	"AM.",
	"A.",
	"No room.",
	"Let it go.",
	"Mr Bloom effaced the letters with his slow boot.",
	"Hopeless thing sand.",
	"Nothing grows in it.",
	"All fades.",
	"No fear of big vessels coming up here.",
	"Except Guinness’s barges.",
	"Round the Kish in eighty days.",
	"Done half by design.",
	"He flung his wooden pen away.",
	"The stick fell in silted sand, stuck.",
	"Now if you were trying to do that for a week on end you couldn’t.",
	"Chance.",
	"We’ll never meet again.",
	"But it was lovely.",
	"Goodbye, dear.",
	"Thanks.",
	"Made me feel so young.",
	"Short snooze now if I had.",
	"Must be near nine.",
	"Liverpool boat long gone.",
	"Not even the smoke.",
	"And she can do the other.",
	"Did too.",
	"And Belfast.",
	"I won’t go.",
	"Race there, race back to Ennis.",
	"Let him.",
	"Just close my eyes a moment.",
	"Won’t sleep, though.",
	"Half dream.",
	"It never comes the same.",
	"Bat again.",
	"No harm in him.",
	"Just a few.",
	"A bat flew.",
	"Here.",
	"There.",
	"Here.",
	"Far in the grey a bell chimed.",
	"Mr Bloom with open mouth, his left boot sanded sideways, leaned, breathed.",
	"Just for a few Cuckoo Cuckoo Cuckoo.",
	"[ 14 ] Deshil Holles Eamus.",
	"Deshil Holles Eamus.",
	"Deshil Holles Eamus.",
	"Send us bright one, light one, Horhorn, quickening and wombfruit.",
	"Send us bright one, light one, Horhorn, quickening and wombfruit.",
	"Send us bright one, light one, Horhorn, quickening and wombfruit.",
	"Hoopsa boyaboy hoopsa!",
	"Hoopsa boyaboy hoopsa!",
	"Hoopsa boyaboy hoopsa!",
	"Before born bliss babe had.",
	"Within womb won he worship.",
	"Whatever in that one case done commodiously done was.",
	"Some man that wayfaring was stood by housedoor at night’s oncoming.",
	"Of Israel’s folk was that man that on earth wandering far had fared.",
	"Stark ruth of man his errand that him lone led till that house.",
	"Of that house A. Horne is lord.",
	"Watchers tway there walk, white sisters in ward sleepless.",
	"Smarts they still, sickness soothing: in twelve moons thrice an hundred.",
	"Truest bedthanes they twain are, for Horne holding wariest ward.",
	"Lo, levin leaping lightens in eyeblink Ireland’s westward welkin.",
	"Full she drad that God the Wreaker all mankind would fordo with water for his evil sins.",
	"Christ’s rood made she on breastbone and him drew that he would rathe infare under her thatch.",
	"That man her will wotting worthful went in Horne’s house.",
	"Loth to irk in Horne’s hall hat holding the seeker stood.",
	"Once her in townhithe meeting he to her bow had not doffed.",
	"Light swift her eyes kindled, bloom of blushes his word winning.",
	"As her eyes then ongot his weeds swart therefor sorrow she feared.",
	"Glad after she was that ere adread was.",
	"Sad was the man that word to hear that him so heavied in bowels ruthful.",
	"All she there told him, ruing death for friend so young, algate sore unwilling God’s rightwiseness to withsay.",
	"He heard her sad words, in held hat sad staring.",
	"So stood they there both awhile in wanhope sorrowing one with other.",
	"Nine twelve bloodflows chiding her childless.",
	"And there came against the place as they stood a young learningknight yclept Dixon.",
	"And full fair cheer and rich was on the board that no wight could devise a fuller ne richer.",
	"And he sat down in that castle with them for to rest him there awhile.",
	"Thanked be Almighty God.",
	"Meseems it dureth overlong.",
	"And the franklin that had drunken said, Expecting each moment to be her next.",
	"Woman’s woe with wonder pondering.",
	"Now let us speak of that fellowship that was there to the intent to be drunken an they might.",
	"Ruth red him, love led on with will to wander, loth to leave.",
	"For they were right witty scholars.",
	"A redress God grant.",
	"To whom young Stephen had these words following: Murmur, sirs, is eke oft among lay folk.",
	"Both babe and parent now glorify their Maker, the one in limbo gloom, the other in purgefire.",
	"For, sirs, he said, our lust is brief.",
	"We are means to those small creatures within us and nature has other ends than we.",
	"Then said Dixon junior to Punch Costello wist he what ends.",
	"That is truth, pardy, said Dixon, and, or I err, a pregnant word.",
	"Leave ye fraction of bread to them that live by bread alone.",
	"Be not afeard neither for any want for this will comfort more than the other will dismay.",
	"See ye here.",
	"They all admired to see the foresaid riches in such dearth of money as was herebefore.",
	"His words were then these as followeth: Know all men, he said, time’s ruins build eternity’s mansions.",
	"What means this?",
	"Mark me now.",
	"This is the postcreation.",
	"Omnis caro ad te veniet.",
	"But here is the matter now.",
	"Entweder transubstantiality oder consubstantiality but in no case subsubstantiality.",
	"And all cried out upon it for a very scurvy word.",
	"A pregnancy without joy, he said, a birth without pangs, a body without blemish, a belly without bigness.",
	"Let the lewd with faith and fervour worship.",
	"With will will we withstand, withsay.",
	"In Horne’s house rest should reign.",
	"Greater love than this, he said, no man hath that a man lay down his wife for his friend.",
	"Go thou and do likewise.",
	"Bring a stranger within thy tower it will go hard but thou wilt have the secondbest bed.",
	"Orate, fratres, pro memetipso.",
	"And all the people shall say, Amen.",
	"Therefore hast thou sinned against my light and hast made me, thy lord, to be the slave of servants.",
	"Return, return, Clan Milly: forget me not, O Milesian.",
	"But thou hast suckled me with a bitter milk: my moon and my sun thou hast quenched for ever.",
	"A black crack of noise in the street here, alack, bawled back.",
	"Loud on left Thor thundered: in anger awful the hammerhurler.",
	"Came now the storm that hist his heart.",
	"But this was only to dye his desperation as cowed he crouched in Horne’s hall.",
	"But was young Boasthard’s fear vanquished by Calmer’s words?",
	"No, for he had in his bosom a spike named Bitterness which could not by words be done away.",
	"And was he then neither calm like the one nor godly like the other?",
	"He was neither as much as he would have liked to be either.",
	"Indeed no for Grace was not there to find that bottle.",
	"Heard?",
	"And would he not accept to die like the rest and pass away?",
	"So Thursday sixteenth June Patk.",
	"Over against the Rt.",
	"Hon.",
	"Mr Justice Fitzgibbon’s door (that is to sit with Mr Healy the lawyer upon the college lands) Mal.",
	"There Leop.",
	"Lynch, a Scots fellow, Will.",
	"Madden, T. Lenehan, very sad about a racer he fancied and Stephen D. Leop.",
	"The other, Costello that is, hearing this talk asked was it poetry or a tale.",
	"I protest I saw them but this day morning going to the Liverpool boats, says he.",
	"I can scarce believe ‘tis so bad, says he.",
	"I question with you there, says he.",
	"More like ‘tis the hoose or the timber tongue.",
	"Come, come, says Mr Vincent, plain dealing.",
	"He’ll find himself on the horns of a dilemma if he meddles with a bull that’s Irish, says he.",
	"I conceive you, says Mr Dixon.",
	"I’ll make that animal smell hell, says he, with the help of that good pizzle my father left me.",
	"In short, he and the bull of Ireland were soon as fast friends as an arse and a shirt.",
	"A man’s a man for a’ that.",
	"Fertiliser and Incubator.",
	"Lambay Island.",
	"Well, let us hear of it, good my friend, said Mr Dixon.",
	"I make no doubt it smacks of wenching.",
	"Come, be seated, both.",
	"‘Tis as cheap sitting as standing.",
	"Money was no object, he said, nor would he take a penny for his pains.",
	"The spry rattle had run on in the same vein of mimicry but for some larum in the antechamber.",
	"Mais bien sûr, noble stranger, said he cheerily, et mille compliments.",
	"That you may and very opportunely.",
	"There wanted nothing but this cup to crown my felicity.",
	"I declare, I was never so touched in all my life.",
	"God, I thank thee, as the Author of my days!",
	"Thrice happy will he be whom so amiable a creature will bless with her favours.",
	"But indeed, sir, I wander from the point.",
	"How mingled and imperfect are all our sublunary joys.",
	"Maledicity!",
	"he exclaimed in anguish.",
	"Would to God that foresight had but remembered me to take my cloak along!",
	"I could weep to think of it.",
	"Then, though it had poured seven showers, we were neither of us a penny the worse.",
	"Tut, tut!",
	"Pooh!",
	"A livre!",
	"cries Monsieur Lynch.",
	"The clumsy things are dear at a sou.",
	"One umbrella, were it no bigger than a fairy mushroom, is worth ten such stopgaps.",
	"No woman of any wit would wear one.",
	"Strike me silly, said Costello, a low fellow who was fuddled.",
	"A monstrous fine bit of cowflesh!",
	"I’ll be sworn she has rendezvoused you.",
	"What, you dog?",
	"Have you a way with them?",
	"Gad’s bud, immensely so, said Mr Lynch.",
	"The bedside manner it is that they use in the Mater hospice.",
	"Demme, does not Doctor O’Gargle chuck the nuns there under the chin.",
	"Drat the man!",
	"Bless me, I’m all of a wibbly wobbly.",
	"Why, you’re as bad as dear little Father Cantekissem, that you are!",
	"May this pot of four half choke me, cried Costello, if she aint in the family way.",
	"I knows a lady what’s got a white swelling quick as I claps eyes on her.",
	"I cannot away with them.",
	"What?",
	"And at an instant the most momentous that can befall a puny child of clay?",
	"Perish the thought!",
	"Having delivered himself of this rebuke he saluted those present on the by and repaired to the door.",
	"I bade him hold himself in readiness for that the event would burst anon.",
	"‘Slife, I’ll be round with you.",
	"Where is now that gratitude which loyalty should have counselled?",
	"Has he forgotten this as he forgets all benefits received?",
	"It ill becomes him to preach that gospel.",
	"Has he not nearer home a seedfield that lies fallow for the want of the ploughshare?",
	"A habit reprehensible at puberty is second nature and an opprobrium in middle life.",
	"His marital breast is the repository of secrets which decorum is reluctant to adduce.",
	"In vain the voice of Mr Canvasser Bloom was heard endeavouring to urge, to mollify, to refrain.",
	"The impression made by his words was immediate but shortlived.",
	"But Malachias’ tale began to freeze them with horror.",
	"He conjured up the scene before them.",
	"The secret panel beside the chimney slid back and in the recess appeared... Haines!",
	"Which of us did not feel his flesh creep!",
	"He had a portfolio full of Celtic literature in one hand, in the other a phial marked Poison.",
	"Surprise, horror, loathing were depicted on all faces while he eyed them with a ghostly grin.",
	"I anticipated some such reception, he began with an eldritch laugh, for which, it seems, history is to blame.",
	"Yes, it is true.",
	"I am the murderer of Samuel Childs.",
	"And how I am punished!",
	"The inferno has no terrors for me.",
	"This is the appearance is on me.",
	"My hell, and Ireland’s, is in this life.",
	"It is what I tried to obliterate my crime.",
	"Distractions, rookshooting, the Erse language (he recited some), laudanum (he raised the phial to his lips), camping out.",
	"In vain!",
	"His spectre stalks me.",
	"Dope is my only hope... Ah!",
	"Destruction!",
	"The black panther!",
	"With a cry he suddenly vanished and the panel slid back.",
	"He was gone.",
	"Tears gushed from the eyes of the dissipated host.",
	"The seer raised his hand to heaven, murmuring: The vendetta of Mananaun!",
	"The sage repeated: Lex talionis.",
	"The sentimentalist is he who would enjoy without incurring the immense debtorship for a thing done.",
	"Malachias, overcome by emotion, ceased.",
	"The mystery was unveiled.",
	"Haines was the third brother.",
	"His real name was Childs.",
	"The black panther was himself the ghost of his own father.",
	"He drank drugs to obliterate.",
	"For this relief much thanks.",
	"The lonely house by the graveyard is uninhabited.",
	"No soul will live there.",
	"The spider pitches her web in the solitude.",
	"The nocturnal rat peers from his hole.",
	"A curse is on it.",
	"It is haunted.",
	"Murderer’s ground.",
	"What is the age of the soul of man?",
	"A score of years are blown away.",
	"He is young Leopold.",
	"There, as in a retrospective arrangement, a mirror within a mirror (hey, presto!",
	"), he beholdeth himself.",
	"a thing now of the past!)",
	"tell me!)",
	"his studied baisemoins.",
	"Now he is himself paternal and these about him might be his sons.",
	"Who can say?",
	"The wise father knows his own child.",
	"He thinks of a drizzling night in Hatch street, hard by the bonded stores there, the first.",
	"Bridie!",
	"Bridie Kelly!",
	"He will never forget the name, ever remember the night: first night, the bridenight.",
	"They are entwined in nethermost darkness, the willer with the willed, and in an instant (fiat!)",
	"light shall flood the world.",
	"Did heart leap to heart?",
	"Nay, fair reader.",
	"In a breath ‘twas done but—hold!",
	"Back!",
	"It must not be!",
	"In terror the poor girl flees away through the murk.",
	"She is the bride of darkness, a daughter of night.",
	"She dare not bear the sunnygolden babe of day.",
	"No, Leopold.",
	"Name and memory solace thee not.",
	"That youthful illusion of thy strength was taken from thee—and in vain.",
	"No son of thy loins is by thee.",
	"There is none now to be for Leopold, what Leopold was for Rudolph.",
	"She follows her mother with ungainly steps, a mare leading her fillyfoal.",
	"They fade, sad phantoms: all is gone.",
	"Agendath is a waste land, a home of screechowls and the sandblind upupa.",
	"Netaim, the golden, is no more.",
	"And on the highway of the clouds they come, muttering thunder of rebellion, the ghosts of beasts.",
	"Huuh!",
	"Hark!",
	"Huuh!",
	"Parallax stalks behind and goads them, the lancinating lightnings of whose brow are scorpions.",
	"Ominous revengeful zodiacal host!",
	"Onward to the dead sea they tramp to drink, unslaked and with horrible gulpings, the salt somnolent inexhaustible flood.",
	"And lo, wonder of metempsychosis, it is she, the everlasting bride, harbinger of the daystar, the bride, ever virgin.",
	"It is she, Martha, thou lost one, Millicent, the young, the dear, the radiant.",
	"Francis was reminding Stephen of years before when they had been at school together in Conmee’s time.",
	"He asked about Glaucon, Alcibiades, Pisistratus.",
	"Where were they now?",
	"Neither knew.",
	"You have spoken of the past and its phantoms, Stephen said.",
	"Why think of them?",
	"Who supposes it?",
	"I, Bous Stephanoumenos, bullockbefriending bard, am lord and giver of their life.",
	"He encircled his gadding hair with a coronal of vineleaves, smiling at Vincent.",
	"All who wish you well hope this for you.",
	"All desire to see you bring forth the work you meditate, to acclaim you Stephaneforos.",
	"I heartily wish you may not fail them.",
	"O no, Vincent Lenehan said, laying a hand on the shoulder near him.",
	"Have no fear.",
	"He could not leave his mother an orphan.",
	"The young man’s face grew dark.",
	"He would have withdrawn from the feast had not the noise of voices allayed the smart.",
	"Madden had lost five drachmas on Sceptre for a whim of the rider’s name: Lenehan as much more.",
	"He told them of the race.",
	"The flag fell and, huuh!",
	"off, scamper, the mare ran out freshly with O. Madden up.",
	"She was leading the field.",
	"All hearts were beating.",
	"Even Phyllis could not contain herself.",
	"She waved her scarf and cried: Huzzah!",
	"Sceptre wins!",
	"All was lost now.",
	"Phyllis was silent: her eyes were sad anemones.",
	"Juno, she cried, I am undone.",
	"A tear fell: one only.",
	"A whacking fine whip, said Lenehan, is W. Lane.",
	"Four winners yesterday and three today.",
	"What rider is like him?",
	"Mount him on the camel or the boisterous buffalo the victory in a hack canter is still his.",
	"But let us bear it as was the ancient wont.",
	"Mercy on the luckless!",
	"Poor Sceptre!",
	"he said with a light sigh.",
	"She is not the filly that she was.",
	"Never, by this hand, shall we behold such another.",
	"By gad, sir, a queen of them.",
	"Do you remember her, Vincent?",
	"I wish you could have seen my queen today, Vincent said.",
	"She is more taking then.",
	"Her posies too!",
	"Mad romp that she is, she had pulled her fill as we reclined together.",
	"And in your ear, my friend, you will not think who met us as we left the field.",
	"Conmee himself!",
	"When Conmee had passed she glanced at her lovely echo in that little mirror she carries.",
	"But he had been kind.",
	"In going by he had blessed us.",
	"The gods too are ever kind, Lenehan said.",
	"If I had poor luck with Bass’s mare perhaps this draught of his may serve me more propensely.",
	"Warily, Malachi whispered, preserve a druid silence.",
	"His soul is far away.",
	"It is as painful perhaps to be awakened from a vision as to be born.",
	"Any object, intensely regarded, may be a gate of access to the incorruptible eon of the gods.",
	"Do you not think it, Stephen?",
	"The debate which ensued was in its scope and progress an epitome of the course of life.",
	"Neither place nor council was lacking in dignity.",
	"The debaters were the keenest in the land, the theme they were engaged on the loftiest and most vital.",
	"A gallant scene in truth it made.",
	"There too, opposite to him, was Lynch whose countenance bore already the stigmata of early depravity and premature wisdom.",
	"Scep.)",
	"contentions would appear to prove him pretty badly addicted runs directly counter to accepted scientific methods.",
	"Science, it cannot be too often repeated, deals with tangible phenomena.",
	"Canv.)",
	"regarding the future determination of sex.",
	"The other problem raised by the same inquirer is scarcely less vital: infant mortality.",
	"Mr M. Mulligan (Hyg.",
	"et Eug.",
	"Doc.)",
	"blames the sanitary conditions in which our greylunged citizens contract adenoids, pulmonary complaints etc.",
	"by inhaling the bacteria which lurk in dust.",
	"Mr J. Crotthers (Disc.",
	"Bacc.)",
	"An ingenious suggestion is that thrown out by Mr V. Lynch (Bacc.",
	"Arith.)",
	"Mr S. Dedalus’ (Div.",
	"Scep.)",
	"remark (or should it be called an interruption?)",
	"In a recent public controversy with Mr L. Bloom (Pubb.",
	"Canv.)",
	"in Midw., F. K. Q. C. P.",
	"I.)",
	"Meanwhile the skill and patience of the physician had brought about a happy accouchement.",
	"It had been a weary weary while both for patient and doctor.",
	"All that surgical skill could do was done and the brave woman had manfully helped.",
	"She had.",
	"She had fought the good fight and now she was very very happy.",
	"With the old shake of her pretty head she recalls those days.",
	"God!",
	"How beautiful now across the mist of years!",
	"And so time wags on: but father Cronion has dealt lightly here.",
	"No, let no sigh break from that bosom, dear gentle Mina.",
	"He knows and will call in His own good time.",
	"You too have fought the good fight and played loyally your man’s part.",
	"Sir, to you my hand.",
	"Well done, thou good and faithful servant!",
	"Mark this farther and remember.",
	"The end comes suddenly.",
	"Enter that antechamber of birth where the studious are assembled and note their faces.",
	"Nothing, as it seems, there of rash or violent.",
	"Burke’s!",
	"A dedale of lusty youth, noble every student there.",
	"They hark him on.",
	"The door!",
	"It is open?",
	"Ha!",
	"Dixon follows giving them sharp language but raps out an oath, he too, and on.",
	"Bloom stays with nurse a thought to send a kind word to happy mother and nurseling up there.",
	"Doctor Diet and Doctor Quiet.",
	"Looks she too not other now?",
	"Ward of watching in Horne’s house has told its tale in that washedout pallor.",
	"The air without is impregnated with raindew moisture, life essence celestial, glistening on Dublin stone there under starshiny coelum.",
	"God’s air, the Allfather’s air, scintillant circumambient cessile air.",
	"Breathe it deep into thee.",
	"By heaven, Theodore Purefoy, thou hast done a doughty deed and no botch!",
	"Thou art, I vow, the remarkablest progenitor barring none in this chaffering allincluding most farraginous chronicle.",
	"Astounding!",
	"In her lay a Godframed Godgiven preformed possibility which thou hast fructified with thy modicum of man’s work.",
	"Cleave to her!",
	"Serve!",
	"Toil on, labour like a very bandog and let scholarment and all Malthusiasts go hang.",
	"Thou art all their daddies, Theodore.",
	"Art drooping under thy load, bemoiled with butcher’s bills at home and ingots (not thine!)",
	"in the countinghouse?",
	"Head up!",
	"For every newbegotten thou shalt gather thy homer of ripe wheat.",
	"See, thy fleece is drenched.",
	"Dost envy Darby Dullman there with his Joan?",
	"A canting jay and a rheumeyed curdog is all their progeny.",
	"Pshaw, I tell thee!",
	"He is a mule, a dead gasteropod, without vim or stamina, not worth a cracked kreutzer.",
	"Copulation without population!",
	"No, say I!",
	"Herod’s slaughter of the innocents were the truer name.",
	"Vegetables, forsooth, and sterile cohabitation!",
	"Give her beefsteaks, red, raw, bleeding!",
	"A truce to threnes and trentals and jeremies and all such congenital defunctive music!",
	"Twenty years of it, regret them not.",
	"With thee it was not as with many that will and would and wait and never—do.",
	"Thou sawest thy America, thy lifetask, and didst charge to cover like the transpontine bison.",
	"How saith Zarathustra?",
	"Deine Kuh Trübsal melkest Du.",
	"Nun Trinkst Du die süsse Milch des Euters.",
	"See!",
	"it displodes for thee in abundance.",
	"Drink, man, an udderful!",
	"Thy cow’s dug was tough, what?",
	"Ay, but her milk is hot and sweet and fattening.",
	"No dollop this but thick rich bonnyclaber.",
	"To her, old patriarch!",
	"Pap!",
	"Per deam Partulam et Pertundam nunc est bibendum!",
	"All off for a buster, armstrong, hollering down the street.",
	"Bonafides.",
	"Where you slep las nigh?",
	"Timothy of the battered naggin.",
	"Like ole Billyo.",
	"Any brollies or gumboots in the fambly?",
	"Where the Henry Nevil’s sawbones and ole clo?",
	"Sorra one o’ me knows.",
	"Hurrah there, Dix!",
	"Forward to the ribbon counter.",
	"Where’s Punch?",
	"All serene.",
	"Jay, look at the drunken minister coming out of the maternity hospal!",
	"Benedicat vos omnipotens Deus, Pater et Filius.",
	"A make, mister.",
	"The Denzille lane boys.",
	"Hell, blast ye!",
	"Scoot.",
	"Righto, Isaacs, shove em out of the bleeding limelight.",
	"Yous join uz, dear sir?",
	"No hentrusion in life.",
	"Lou heap good man.",
	"Allee samee dis bunch.",
	"En avant, mes enfants!",
	"Fire away number one on the gun.",
	"Burke’s!",
	"Burke’s!",
	"Thence they advanced five parasangs.",
	"Slattery’s mounted foot.",
	"Where’s that bleeding awfur?",
	"Parson Steve, apostates’ creed!",
	"No, no, Mulligan!",
	"Abaft there!",
	"Shove ahead.",
	"Keep a watch on the clock.",
	"Chuckingout time.",
	"Mullee!",
	"What’s on you?",
	"Ma mère m’a mariée.",
	"British Beatitudes!",
	"Retamplatan digidi boumboum.",
	"Ayes have it.",
	"To be printed and bound at the Druiddrum press by two designing females.",
	"Calf covers of pissedon green.",
	"Last word in art shades.",
	"Most beautiful book come out of Ireland my time.",
	"Silentium!",
	"Get a spurt on.",
	"Tention.",
	"Proceed to nearest canteen and there annex liquor stores.",
	"March!",
	"Tramp, tramp, tramp, the boys are (attitudes!)",
	"parching.",
	"Beer, beef, business, bibles, bulldogs battleships, buggery and bishops.",
	"Whether on the scaffold high.",
	"Beer, beef, trample the bibles.",
	"When for Irelandear.",
	"Trample the trampellers.",
	"Thunderation!",
	"Keep the durned millingtary step.",
	"We fall.",
	"Bishops boosebox.",
	"Halt!",
	"Heave to.",
	"Rugger.",
	"Scrum in.",
	"No touch kicking.",
	"Wow, my tootsies!",
	"You hurt?",
	"Most amazingly sorry!",
	"Query.",
	"Who’s astanding this here do?",
	"Proud possessor of damnall.",
	"Declare misery.",
	"Bet to the ropes.",
	"Me nantee saltee.",
	"Not a red at me this week gone.",
	"Yours?",
	"Mead of our fathers for the Übermensch.",
	"Dittoh.",
	"Five number ones.",
	"You, sir?",
	"Ginger cordial.",
	"Chase me, the cabby’s caudle.",
	"Stimulate the caloric.",
	"Winding of his ticker.",
	"Stopped short never to go again when the old.",
	"Absinthe for me, savvy?",
	"Caramba!",
	"Have an eggnog or a prairie oyster.",
	"Enemy?",
	"Avuncular’s got my timepiece.",
	"Ten to.",
	"Obligated awful.",
	"Don’t mention it.",
	"Got a pectoral trauma, eh, Dix?",
	"Pos fact.",
	"Got bet be a boomblebee whenever he wus settin sleepin in hes bit garten.",
	"Digs up near the Mater.",
	"Buckled he is.",
	"Know his dona?",
	"Yup, sartin I do.",
	"Full of a dure.",
	"See her in her dishybilly.",
	"Peels off a credit.",
	"Lovey lovekin.",
	"None of your lean kine, not much.",
	"Pull down the blind, love.",
	"Two Ardilauns.",
	"Same here.",
	"Look slippery.",
	"If you fall don’t wait to get up.",
	"Five, seven, nine.",
	"Fine!",
	"Got a prime pair of mincepies, no kid.",
	"And her take me to rests and her anker of rum.",
	"Must be seen to be believed.",
	"Your starving eyes and allbeplastered neck you stole my heart, O gluepot.",
	"Sir?",
	"Spud again the rheumatiz?",
	"All poppycock, you’ll scuse me saying.",
	"For the hoi polloi.",
	"I vear thee beest a gert vool.",
	"Well, doc?",
	"Back fro Lapland?",
	"Your corporosity sagaciating O K?",
	"How’s the squaws and papooses?",
	"Womanbody after going on the straw?",
	"Stand and deliver.",
	"Password.",
	"There’s hair.",
	"Ours the white death and the ruddy birth.",
	"Hi!",
	"Spit in your own eye, boss!",
	"Mummer’s wire.",
	"Cribbed out of Meredith.",
	"Jesified, orchidised, polycimical jesuit!",
	"Aunty mine’s writing Pa Kinch.",
	"Baddybad Stephen lead astray goodygood Malachi.",
	"Hurroo!",
	"Collar the leather, youngun.",
	"Roun wi the nappy.",
	"Here, Jock braw Hielentman’s your barleybree.",
	"Lang may your lum reek and your kailpot boil!",
	"My tipple.",
	"Merci.",
	"Here’s to us.",
	"How’s that?",
	"Leg before wicket.",
	"Don’t stain my brandnew sitinems.",
	"Give’s a shake of peppe, you there.",
	"Catch aholt.",
	"Caraway seed to carry away.",
	"Twig?",
	"Shrieks of silence.",
	"Every cove to his gentry mort.",
	"Venus Pandemos.",
	"Les petites femmes.",
	"Bold bad girl from the town of Mullingar.",
	"Tell her I was axing at her.",
	"Hauding Sara by the wame.",
	"On the road to Malahide.",
	"Me?",
	"If she who seduced me had left but the name.",
	"What do you want for ninepence?",
	"Machree, macruiskeen.",
	"Smutty Moll for a mattress jig.",
	"And a pull all together.",
	"Ex!",
	"Waiting, guvnor?",
	"Most deciduously.",
	"Bet your boots on.",
	"Stunned like, seeing as how no shiners is acoming.",
	"Underconstumble?",
	"He’ve got the chink ad lib.",
	"Seed near free poun on un a spell ago a said war hisn.",
	"Us come right in on your invite, see?",
	"Up to you, matey.",
	"Out with the oof.",
	"Two bar and a wing.",
	"You larn that go off of they there Frenchy bilks?",
	"Won’t wash here for nuts nohow.",
	"Lil chile velly solly.",
	"Ise de cutest colour coon down our side.",
	"Gawds teruth, Chawley.",
	"We are nae fou.",
	"We’re nae tha fou.",
	"Au reservoir, mossoo.",
	"Tanks you.",
	"‘Tis, sure.",
	"What say?",
	"In the speakeasy.",
	"Tight.",
	"I shee you, shir.",
	"Bantam, two days teetee.",
	"Bowsing nowt but claretwine.",
	"Garn!",
	"Have a glint, do.",
	"Gum, I’m jiggered.",
	"And been to barber he have.",
	"Too full for words.",
	"With a railway bloke.",
	"How come you so?",
	"Opera he’d like?",
	"Rose of Castile.",
	"Rows of cast.",
	"Police!",
	"Some H2O for a gent fainted.",
	"Look at Bantam’s flowers.",
	"Gemini.",
	"He’s going to holler.",
	"The colleen bawn.",
	"My colleen bawn.",
	"O, cheese it!",
	"Shut his blurry Dutch oven with a firm hand.",
	"Had the winner today till I tipped him a dead cert.",
	"The ruffin cly the nab of Stephen Hand as give me the jady coppaleen.",
	"He strike a telegramboy paddock wire big bug Bass to the depot.",
	"Shove him a joey and grahamise.",
	"Mare on form hot order.",
	"Guinea to a goosegog.",
	"Tell a cram, that.",
	"Gospeltrue.",
	"Criminal diversion?",
	"I think that yes.",
	"Sure thing.",
	"Land him in chokeechokee if the harman beck copped the game.",
	"Madden back Madden’s a maddening back.",
	"O lust our refuge and our strength.",
	"Decamping.",
	"Must you go?",
	"Off to mammy.",
	"Stand by.",
	"Hide my blushes someone.",
	"All in if he spots me.",
	"Come ahome, our Bantam.",
	"Horryvar, mong vioo.",
	"Dinna forget the cowslips for hersel.",
	"Cornfide.",
	"Wha gev ye thon colt?",
	"Pal to pal.",
	"Jannock.",
	"Of John Thomas, her spouse.",
	"No fake, old man Leo.",
	"S’elp me, honest injun.",
	"Shiver my timbers if I had.",
	"There’s a great big holy friar.",
	"Vyfor you no me tell?",
	"Vel, I ses, if that aint a sheeny nachez, vel, I vil get misha mishinnah.",
	"Through yerd our lord, Amen.",
	"You move a motion?",
	"Steve boy, you’re going it some.",
	"More bluggy drunkables?",
	"Give’s a breather.",
	"Landlord, landlord, have you good wine, staboo?",
	"Hoots, mon, a wee drap to pree.",
	"Cut and come again.",
	"Right.",
	"Boniface!",
	"Absinthe the lot.",
	"Nos omnes biberimus viridum toxicum diabolus capiat posterioria nostria.",
	"Closingtime, gents.",
	"Eh?",
	"Rome boose for the Bloom toff.",
	"I hear you say onions?",
	"Bloo?",
	"Cadges ads.",
	"Photo’s papli, by all that’s gorgeous.",
	"Play low, pardner.",
	"Slide.",
	"Bonsoir la compagnie.",
	"And snares of the poxfiend.",
	"Where’s the buck and Namby Amby?",
	"Skunked?",
	"Leg bail.",
	"Aweel, ye maun e’en gang yer gates.",
	"Checkmate.",
	"King to tower.",
	"Crickey, I’m about sprung.",
	"Tarnally dog gone my shins if this beent the bestest puttiest longbreak yet.",
	"Item, curate, couple of cookies for this child.",
	"Cot’s plood and prandypalls, none!",
	"Not a pite of sheeses?",
	"Thrust syphilis down to hell and with him those other licensed spirits.",
	"Time, gents!",
	"Who wander through the world.",
	"Health all!",
	"À la vôtre!",
	"Golly, whatten tunket’s yon guy in the mackintosh?",
	"Dusty Rhodes.",
	"Peep at his wearables.",
	"By mighty!",
	"What’s he got?",
	"Jubilee mutton.",
	"Bovril, by James.",
	"Wants it real bad.",
	"D’ye ken bare socks?",
	"Seedy cuss in the Richmond?",
	"Rawthere!",
	"Thought he had a deposit of lead in his penis.",
	"Trumpery insanity.",
	"Bartle the Bread we calls him.",
	"That, sir, was once a prosperous cit.",
	"Man all tattered and torn that married a maiden all forlorn.",
	"Slung her hook, she did.",
	"Here see lost love.",
	"Walking Mackintosh of lonely canyon.",
	"Tuck and turn in.",
	"Schedule time.",
	"Nix for the hornies.",
	"Pardon?",
	"Seen him today at a runefal?",
	"Chum o’ yourn passed in his checks?",
	"Ludamassy!",
	"Pore piccaninnies!",
	"Thou’ll no be telling me thot, Pold veg!",
	"Did ums blubble bigsplash crytears cos fren Padney was took off in black bag?",
	"Of all de darkies Massa Pat was verra best.",
	"I never see the like since I was born.",
	"Tiens, tiens, but it is well sad, that, my faith, yes.",
	"O, get, rev on a gradient one in nine.",
	"Live axle drives are souped.",
	"Lay you two to one Jenatzy licks him ruddy well hollow.",
	"Jappies?",
	"High angle fire, inyah!",
	"Sunk by war specials.",
	"Be worse for him, says he, nor any Rooshian.",
	"Time all.",
	"There’s eleven of them.",
	"Get ye gone.",
	"Forward, woozy wobblers!",
	"Night.",
	"Night.",
	"May Allah the Excellent One your soul this night ever tremendously conserve.",
	"Your attention!",
	"We’re nae tha fou.",
	"The Leith police dismisseth us.",
	"The least tholice.",
	"Ware hawks for the chap puking.",
	"Unwell in his abominable regions.",
	"Yooka.",
	"Night.",
	"Mona, my true love.",
	"Yook.",
	"Mona, my own love.",
	"Ook.",
	"Hark!",
	"Shut your obstropolos.",
	"Pflaap!",
	"Pflaap!",
	"Blaze on.",
	"There she goes.",
	"Brigade!",
	"Bout ship.",
	"Mount street way.",
	"Cut up!",
	"Pflaap!",
	"Tally ho.",
	"You not come?",
	"Run, skelter, race.",
	"Pflaaaap!",
	"Lynch!",
	"Hey?",
	"Sign on long o’ me.",
	"Denzille lane this way.",
	"Change here for Bawdyhouse.",
	"We two, she said, will seek the kips where shady Mary is.",
	"Righto, any old time.",
	"Laetabuntur in cubilibus suis.",
	"You coming long?",
	"Whisper, who the sooty hell’s the johnny in the black duds?",
	"Hush!",
	"Pflaap!",
	"Ut implerentur scripturae.",
	"Strike up a ballad.",
	"Then outspake medical Dick to his comrade medical Davy.",
	"Christicle, who’s this excrement yellow gospeller on the Merrion hall?",
	"Elijah is coming!",
	"Washed in the blood of the Lamb.",
	"Come on you winefizzling, ginsizzling, booseguzzling existences!",
	"Come on, you dog-gone, bullnecked, beetlebrowed, hogjowled, peanutbrained, weaseleyed fourflushers, false alarms and excess baggage!",
	"Come on, you triple extract of infamy!",
	"The Deity aint no nickel dime bumshow.",
	"I put it to you that He’s on the square and a corking fine business proposition.",
	"He’s the grandest thing yet and don’t you forget it.",
	"Shout salvation in King Jesus.",
	"You’ll need to rise precious early, you sinner there, if you want to diddle the Almighty God.",
	"Pflaaaap!",
	"Not half.",
	"He’s got a coughmixture with a punch in it for you, my friend, in his back pocket.",
	"Just you try it on.",
	"Rows of grimy houses with gaping doors.",
	"Rare lamps with faint rainbow fans.",
	"Round Rabaiotti’s halted ice gondola stunted men and women squabble.",
	"They grab wafers between which are wedged lumps of coral and copper snow.",
	"Sucking, they scatter slowly.",
	"Children.",
	"The swancomb of the gondola, highreared, forges on through the murk, white and blue under a lighthouse.",
	"Whistles call and answer.)",
	"THE CALLS: Wait, my love, and I’ll be with you.",
	"THE ANSWERS: Round behind the stable.",
	"(A deafmute idiot with goggle eyes, his shapeless mouth dribbling, jerks past, shaken in Saint Vitus’ dance.",
	"A chain of children ‘s hands imprisons him.)",
	"THE CHILDREN: Kithogue!",
	"Salute!",
	"THE IDIOT: (Lifts a palsied left arm and gurgles.)",
	"Grhahute!",
	"THE CHILDREN: Where’s the great light?",
	"THE IDIOT: (Gobbling.)",
	"Ghaghahest.",
	"(They release him.",
	"He jerks on.",
	"A pigmy woman swings on a rope slung between two railings, counting.",
	"On a step a gnome totting among a rubbishtip crouches to shoulder a sack of rags and bones.",
	"A crone standing by with a smoky oillamp rams her last bottle in the maw of his sack.",
	"He heaves his booty, tugs askew his peaked cap and hobbles off mutely.",
	"The crone makes back for her lair, swaying her lamp.",
	"A drunken navvy grips with both hands the railings of an area, lurching heavily.",
	"At a corner two night watch in shouldercapes, their hands upon their staffholsters, loom tall.",
	"A plate crashes: a woman screams: a child wails.",
	"Oaths of a man roar, mutter, cease.",
	"Figures wander, lurk, peer from warrens.",
	"Cissy Caffrey’s voice, still young, sings shrill from a lane.)",
	"Laughter of men from the lane.",
	"A hoarse virago retorts.)",
	"THE VIRAGO: Signs on you, hairy arse.",
	"More power the Cavan girl.",
	"CISSY CAFFREY: More luck to me.",
	"Cavan, Cootehill and Belturbet.",
	"(She sings.)",
	"Stephen Dedalus and Lynch pass through the crowd close to the redcoats.)",
	"PRIVATE COMPTON: (Jerks his finger.)",
	"Way for the parson.",
	"PRIVATE CARR: (Turns and calls.)",
	"What ho, parson!",
	"CISSY CAFFREY: (Her voice soaring higher.)",
	"She has it, she got it, Wherever she put it, The leg of the duck.",
	"(Stephen, flourishing the ashplant in his left hand, chants with joy the introit for paschal time.",
	"Lynch, his jockeycap low on his brow, attends him, a sneer of discontent wrinkling his face.)",
	"STEPHEN: Vidi aquam egredientem de templo a latere dextro.",
	"Alleluia.",
	"(The famished snaggletusks of an elderly bawd protrude from a doorway.)",
	"THE BAWD: (Her voice whispering huskily.)",
	"Sst!",
	"Come here till I tell you.",
	"Maidenhead inside.",
	"Sst!",
	"STEPHEN: (Altius aliquantulum.)",
	"Et omnes ad quos pervenit aqua ista.",
	"THE BAWD: (Spits in their trail her jet of venom.)",
	"Trinity medicals.",
	"Fallopian tube.",
	"All prick and no pence.",
	"(Edy Boardman, sniffling, crouched with Bertha Supple, draws her shawl across her nostrils.)",
	"EDY BOARDMAN: (Bickering.)",
	"Did you, says I. That’s not for you to say, says I.",
	"You never seen me in the mantrap with a married highlander, says I.",
	"The likes of her!",
	"Stag that one is!",
	"Stubborn as a mule!",
	"And her walking with two fellows the one time, Kilbride, the enginedriver, and lancecorporal Oliphant.",
	"STEPHEN: (Triumphaliter.)",
	"Salvi facti sunt.",
	"(He flourishes his ashplant, shivering the lamp image, shattering light over the world.",
	"A liver and white spaniel on the prowl slinks after him, growling.",
	"Lynch scares it with a kick.)",
	"LYNCH: So that?",
	"STEPHEN: (Looks behind.)",
	"LYNCH: Pornosophical philotheology.",
	"Metaphysics in Mecklenburgh street!",
	"STEPHEN: We have shrewridden Shakespeare and henpecked Socrates.",
	"Even the allwisest Stagyrite was bitted, bridled and mounted by a light of love.",
	"LYNCH: Ba!",
	"STEPHEN: Anyway, who wants two gestures to illustrate a loaf and a jug?",
	"This movement illustrates the loaf and jug of bread or wine in Omar.",
	"Hold my stick.",
	"LYNCH: Damn your yellow stick.",
	"Where are we going?",
	"STEPHEN: Lecherous lynx, to la belle dame sans merci, Georgina Johnson, ad deam qui laetificat iuventutem meam.",
	"LYNCH: Which is the jug of bread?",
	"It skills not.",
	"That or the customhouse.",
	"Illustrate thou.",
	"Here take your crutch and walk.",
	"(They pass.",
	"Tommy Caffrey scrambles to a gaslamp and, clasping, climbs in spasms.",
	"From the top spur he slides down.",
	"Jacky Caffrey clasps to climb.",
	"The navvy lurches against the lamp.",
	"The twins scuttle off in the dark.",
	"Shouldering the lamp he staggers away through the crowd with his flaring cresset.",
	"Snakes of river fog creep slowly.",
	"From drains, clefts, cesspools, middens arise on all sides stagnant fumes.",
	"A glow leaps in the south beyond the seaward reaches of the river.",
	"The navvy, staggering forward, cleaves the crowd and lurches towards the tramsiding.",
	"On the farther side under the railway bridge Bloom appears, flushed, panting, cramming bread and chocolate into a sidepocket.",
	"From Gillen’s hairdresser’s window a composite portrait shows him gallant Nelson’s image.",
	"A concave mirror at the side presents to him lovelorn longlost lugubru Booloohoom.",
	"Grave Gladstone sees him level, Bloom for Bloom.",
	"At Antonio Rabaiotti’s door Bloom halts, sweated under the bright arclamp.",
	"He disappears.",
	"In a moment he reappears and hurries on.)",
	"BLOOM: Fish and taters.",
	"N. g. Ah!",
	"(He disappears into Olhausen’s, the porkbutcher’s, under the downcoming rollshutter.",
	"A few moments later he emerges from under the shutter, puffing Poldy, blowing Bloohoom.",
	"He gasps, standing upright.",
	"Then bending to one side he presses a parcel against his ribs and groans.)",
	"BLOOM: Stitch in my side.",
	"Why did I run?",
	"(He takes breath with care and goes forward slowly towards the lampset siding.",
	"The glow leaps again.)",
	"BLOOM: What is that?",
	"A flasher?",
	"Searchlight.",
	"(He stands at Cormack’s corner, watching.)",
	"BLOOM: Aurora borealis or a steel foundry?",
	"Ah, the brigade, of course.",
	"South side anyhow.",
	"Big blaze.",
	"Might be his house.",
	"Beggar’s bush.",
	"We’re safe.",
	"(He hums cheerfully.)",
	"London’s burning, London’s burning!",
	"On fire, on fire!",
	"(He catches sight of the navvy lurching through the crowd at the farther side of Talbot street.)",
	"I’ll miss him.",
	"Run.",
	"Quick.",
	"Better cross here.",
	"(He darts to cross the road.",
	"Urchins shout.)",
	"THE URCHINS: Mind out, mister!",
	"(Two cyclists, with lighted paper lanterns aswing, swim by him, grazing him, their bells rattling.)",
	"THE BELLS: Haltyaltyaltyall.",
	"BLOOM: (Halts erect, stung by a spasm.)",
	"Ow!",
	"(He looks round, darts forward suddenly.",
	"The motorman bangs his footgong.)",
	"THE GONG: Bang Bang Bla Bak Blud Bugg Bloo.",
	"(The brake cracks violently.",
	"Bloom, raising a policeman’s whitegloved hand, blunders stifflegged out of the track.",
	"The motorman, thrown forward, pugnosed, on the guidewheel, yells as he slides past over chains and keys.)",
	"THE MOTORMAN: Hey, shitbreeches, are you doing the hat trick?",
	"(Bloom trickleaps to the curbstone and halts again.",
	"He brushes a mudflake from his cheek with a parcelled hand.)",
	"BLOOM: No thoroughfare.",
	"Close shave that but cured the stitch.",
	"Must take up Sandow’s exercises again.",
	"On the hands down.",
	"Insure against street accident too.",
	"The Providential.",
	"(He feels his trouser pocket.)",
	"Poor mamma’s panacea.",
	"Heel easily catch in track or bootlace in a cog.",
	"Day the wheel of the black Maria peeled off my shoe at Leonard’s corner.",
	"Third time is the charm.",
	"Shoe trick.",
	"Insolent driver.",
	"I ought to report him.",
	"Tension makes them nervous.",
	"Might be the fellow balked me this morning with that horsey woman.",
	"Same style of beauty.",
	"Quick of him all the same.",
	"The stiff walk.",
	"True word spoken in jest.",
	"That awful cramp in Lad lane.",
	"Something poisonous I ate.",
	"Emblem of luck.",
	"Why?",
	"Probably lost cattle.",
	"Mark of the beast.",
	"(He closes his eyes an instant.)",
	"Bit light in the head.",
	"Monthly or effect of the other.",
	"Brainfogfag.",
	"That tired feeling.",
	"Too much for me now.",
	"Ow!",
	"(A sinister figure leans on plaited legs against O’Beirne’s wall, a visage unknown, injected with dark mercury.",
	"From under a wideleaved sombrero the figure regards him with evil eye.)",
	"BLOOM: Buenas noches, señorita Blanca, que calle es esta?",
	"THE FIGURE: (Impassive, raises a signal arm.)",
	"Password.",
	"Sraid Mabbot.",
	"BLOOM: Haha.",
	"Merci.",
	"Esperanto.",
	"Slan leath.",
	"(He mutters.)",
	"Gaelic league spy, sent by that fireeater.",
	"(He steps forward.",
	"A sackshouldered ragman bars his path.",
	"He steps left, ragsackman left.)",
	"BLOOM: I beg.",
	"(He leaps right, sackragman right.)",
	"BLOOM: I beg.",
	"(He swerves, sidles, stepaside, slips past and on.)",
	"BLOOM: Keep to the right, right, right.",
	"If there is a signpost planted by the Touring Club at Stepaside who procured that public boon?",
	"Keep, keep, keep to the right.",
	"Rags and bones at midnight.",
	"A fence more likely.",
	"First place murderer makes for.",
	"Wash off his sins of the world.",
	"(Jacky Caffrey, hunted by Tommy Caffrey, runs full tilt against Bloom.)",
	"BLOOM: O.",
	"(Shocked, on weak hams, he halts.",
	"Tommy and Jacky vanish there, there.",
	"Bloom pats with parcelled hands watch, fobpocket, bookpocket, pursepoke, sweets of sin, potato soap.)",
	"BLOOM: Beware of pickpockets.",
	"Old thieves’ dodge.",
	"Collide.",
	"Then snatch your purse.",
	"(The retriever approaches sniffing, nose to the ground.",
	"A sprawled form sneezes.",
	"Horned spectacles hang down at the wings of the nose.",
	"Yellow poison streaks are on the drawn face.)",
	"RUDOLPH: Second halfcrown waste money today.",
	"I told you not go with drunken goy ever.",
	"So you catch no money.",
	"BLOOM: (Hides the crubeen and trotter behind his back and, crestfallen, feels warm and cold feetmeat.)",
	"Ja, ich weiss, papachi.",
	"RUDOLPH: What you making down this place?",
	"Have you no soul?",
	"(With feeble vulture talons he feels the silent face of Bloom.)",
	"Are you not my son Leopold, the grandson of Leopold?",
	"BLOOM: (With precaution.)",
	"I suppose so, father.",
	"Mosenthal.",
	"All that’s left of him.",
	"RUDOLPH: (Severely.)",
	"One night they bring you home drunk as dog after spend your good money.",
	"What you call them running chaps?",
	"Harriers, father.",
	"Only that once.",
	"RUDOLPH: Once!",
	"Mud head to foot.",
	"Cut your hand open.",
	"Lockjaw.",
	"They make you kaputt, Leopoldleben.",
	"You watch them chaps.",
	"BLOOM: (Weakly.)",
	"They challenged me to a sprint.",
	"It was muddy.",
	"I slipped.",
	"RUDOLPH: (With contempt.)",
	"Goim nachez!",
	"Nice spectacles for your poor mother!",
	"BLOOM: Mamma!",
	"O blessed Redeemer, what have they done to him!",
	"My smelling salts!",
	"(She hauls up a reef of skirt and ransacks the pouch of her striped blay petticoat.",
	"A phial, an Agnus Dei, a shrivelled potato and a celluloid doll fall out.)",
	"Sacred Heart of Mary, where were you at all at all?",
	"(Bloom, mumbling, his eyes downcast, begins to bestow his parcels in his filled pockets but desists, muttering.)",
	"A VOICE: (Sharply.)",
	"Poldy!",
	"BLOOM: Who?",
	"(He ducks and wards off a blow clumsily.)",
	"At your service.",
	"(He looks up.",
	"Beside her mirage of datepalms a handsome woman in Turkish costume stands before him.",
	"Opulent curves fill out her scarlet trousers and jacket, slashed with gold.",
	"A wide yellow cummerbund girdles her.",
	"BLOOM: Molly!",
	"MARION: Welly?",
	"Mrs Marion from this out, my dear man, when you speak to me.",
	"(Satirically.)",
	"Has poor little hubby cold feet waiting so long?",
	"BLOOM: (Shifts from foot to foot.)",
	"No, no.",
	"Not the least little bit.",
	"A coin gleams on her forehead.",
	"On her feet are jewelled toerings.",
	"Her ankles are linked by a slender fetterchain.",
	"Beside her a camel, hooded with a turreting turban, waits.",
	"A silk ladder of innumerable rungs climbs to his bobbing howdah.",
	"He ambles near with disgruntled hindquarters.",
	"Fiercely she slaps his haunch, her goldcurb wristbangles angriling, scolding him in Moorish.)",
	"MARION: Nebrakada!",
	"Femininum!",
	"Bloom stoops his back for leapfrog.)",
	"BLOOM: I can give you...",
	"I mean as your business menagerer... Mrs Marion... if you... MARION: So you notice some change?",
	"(Her hands passing slowly over her trinketed stomacher, a slow friendly mockery in her eyes.)",
	"O Poldy, Poldy, you are a poor old stick in the mud!",
	"Go and see life.",
	"See the wide world.",
	"BLOOM: I was just going back for that lotion whitewax, orangeflower water.",
	"Shop closes early on Thursday.",
	"But the first thing in the morning.",
	"(He pats divers pockets.)",
	"This moving kidney.",
	"Ah!",
	"(He points to the south, then to the east.",
	"A cake of new clean lemon soap arises, diffusing light and perfume.)",
	"THE SOAP: We’re a capital couple are Bloom and I.",
	"He brightens the earth.",
	"I polish the sky.",
	"(The freckled face of Sweny, the druggist, appears in the disc of the soapsun.)",
	"SWENY: Three and a penny, please.",
	"BLOOM: Yes.",
	"For my wife.",
	"Mrs Marion.",
	"Special recipe.",
	"MARION: (Softly.)",
	"Poldy!",
	"BLOOM: Yes, ma’am?",
	"MARION: Ti trema un poco il cuore?",
	"(In disdain she saunters away, plump as a pampered pouter pigeon, humming the duet from Don Giovanni.)",
	"BLOOM: Are you sure about that Voglio?",
	"I mean the pronunciati... (He follows, followed by the sniffing terrier.",
	"The elderly bawd seizes his sleeve, the bristles of her chinmole glittering.)",
	"THE BAWD: Ten shillings a maidenhead.",
	"Fresh thing was never touched.",
	"Fifteen.",
	"There’s no-one in it only her old father that’s dead drunk.",
	"(She points.",
	"In the gap of her dark den furtive, rainbedraggled, Bridie Kelly stands.)",
	"BRIDIE: Hatch street.",
	"Any good in your mind?",
	"(With a squeak she flaps her bat shawl and runs.",
	"A burly rough pursues with booted strides.",
	"He stumbles on the steps, recovers, plunges into gloom.",
	"Weak squeaks of laughter are heard, weaker.)",
	"THE BAWD: (Her wolfeyes shining.)",
	"He’s getting his pleasure.",
	"You won’t get a virgin in the flash houses.",
	"Ten shillings.",
	"Don’t be all night before the polis in plain clothes sees us.",
	"Sixtyseven is a bitch.",
	"(Leering, Gerty Macdowell limps forward.",
	"She draws from behind, ogling, and shows coyly her bloodied clout.)",
	"GERTY: With all my worldly goods I thee and thou.",
	"(She murmurs.)",
	"You did that.",
	"I hate you.",
	"BLOOM: I?",
	"When?",
	"You’re dreaming.",
	"I never saw you.",
	"THE BAWD: Leave the gentleman alone, you cheat.",
	"Writing the gentleman false letters.",
	"Streetwalking and soliciting.",
	"Better for your mother take the strap to you at the bedpost, hussy like you.",
	"GERTY: (To Bloom.)",
	"When you saw all the secrets of my bottom drawer.",
	"(She paws his sleeve, slobbering.)",
	"Dirty married man!",
	"I love you for doing that to me.",
	"(She glides away crookedly.",
	"MRS BREEN: Mr... BLOOM: (Coughs gravely.)",
	"Madam, when we last had this pleasure by letter dated the sixteenth instant... MRS BREEN: Mr Bloom!",
	"You down here in the haunts of sin!",
	"I caught you nicely!",
	"Scamp!",
	"BLOOM: (Hurriedly.)",
	"Not so loud my name.",
	"Whatever do you think of me?",
	"Don’t give me away.",
	"Walls have ears.",
	"How do you do?",
	"It’s ages since I. You’re looking splendid.",
	"Absolutely it.",
	"Seasonable weather we are having this time of year.",
	"Black refracts heat.",
	"Short cut home here.",
	"Interesting quarter.",
	"Rescue of fallen women.",
	"Magdalen asylum.",
	"I am the secretary... MRS BREEN: (Holds up a finger.)",
	"Now, don’t tell a big fib!",
	"I know somebody won’t like that.",
	"O just wait till I see Molly!",
	"(Slily.)",
	"Account for yourself this very sminute or woe betide you!",
	"BLOOM: (Looks behind.)",
	"She often said she’d like to visit.",
	"Slumming.",
	"The exotic, you see.",
	"Negro servants in livery too if she had money.",
	"Othello black brute.",
	"Eugene Stratton.",
	"Even the bones and cornerman at the Livermore christies.",
	"Bohee brothers.",
	"Sweep for that matter.",
	"Each has his banjo slung.",
	"Their paler smaller negroid hands jingle the twingtwang wires.",
	"(They whisk black masks from raw babby faces: then, chuckling, chortling, trumming, twanging, they diddle diddle cakewalk dance away.)",
	"BLOOM: (With a sour tenderish smile.)",
	"A little frivol, shall we, if you are so inclined?",
	"Would you like me perhaps to embrace you just for a fraction of a second?",
	"MRS BREEN: (Screams gaily.)",
	"O, you ruck!",
	"You ought to see yourself!",
	"BLOOM: For old sake’ sake.",
	"I only meant a square party, a mixed marriage mingling of our different little conjugials.",
	"You know I had a soft corner for you.",
	"(Gloomily.)",
	"‘Twas I sent you that valentine of the dear gazelle.",
	"MRS BREEN: Glory Alice, you do look a holy show!",
	"Killing simply.",
	"(She puts out her hand inquisitively.)",
	"What are you hiding behind your back?",
	"Tell us, there’s a dear.",
	"BLOOM: (Seizes her wrist with his free hand.)",
	"Josie Powell that was, prettiest deb in Dublin.",
	"How time flies by!",
	"Subject, what is in this snuffbox?",
	"MRS BREEN: You were the lion of the night with your seriocomic recitation and you looked the part.",
	"You were always a favourite with the ladies.",
	"Ladies and gentlemen, I give you Ireland, home and beauty.",
	"MRS BREEN: The dear dead days beyond recall.",
	"Love’s old sweet song.",
	"BLOOM: (Meaningfully dropping his voice.)",
	"I confess I’m teapot with curiosity to find out whether some person’s something is a little teapot at present.",
	"MRS BREEN: (Gushingly.)",
	"Tremendously teapot!",
	"London’s teapot and I’m simply teapot all over me!",
	"(She rubs sides with him.)",
	"After the parlour mystery games and the crackers from the tree we sat on the staircase ottoman.",
	"Under the mistletoe.",
	"Two is company.",
	"The witching hour of night.",
	"I took the splinter out of this hand, carefully, slowly.",
	"(Tenderly, as he slips on her finger a ruby ring.)",
	"Là ci darem la mano.",
	"Voglio e non.",
	"You’re hot!",
	"You’re scalding!",
	"The left hand nearest the heart.",
	"BLOOM: When you made your present choice they said it was beauty and the beast.",
	"I can never forgive you for that.",
	"(His clenched fist at his brow.)",
	"Think what it means.",
	"All you meant to me then.",
	"(Hoarsely.)",
	"Woman, it’s breaking me!",
	"ALF BERGAN: (Points jeering at the sandwichboards.)",
	"U. p: Up.",
	"MRS BREEN: (To Bloom.)",
	"High jinks below stairs.",
	"(She gives him the glad eye.)",
	"Why didn’t you kiss the spot to make it well?",
	"You wanted to.",
	"BLOOM: (Shocked.)",
	"Molly’s best friend!",
	"Could you?",
	"MRS BREEN: (Her pulpy tongue between her lips, offers a pigeon kiss.)",
	"Hnhn.",
	"The answer is a lemon.",
	"Have you a little present for me there?",
	"BLOOM: (Offhandedly.)",
	"Kosher.",
	"A snack for supper.",
	"The home without potted meat is incomplete.",
	"I was at Leah, Mrs Bandmann Palmer.",
	"Trenchant exponent of Shakespeare.",
	"Unfortunately threw away the programme.",
	"Rattling good place round there for pigs’ feet.",
	"Feel.",
	"He opens it and shows it full of polonies, kippered herrings, Findon haddies and tightpacked pills.)",
	"RICHIE: Best value in Dub.",
	"(Bald Pat, bothered beetle, stands on the curbstone, folding his napkin, waiting to wait.)",
	"PAT: (Advances with a tilted dish of spillspilling gravy.)",
	"Steak and kidney.",
	"Bottle of lager.",
	"Hee hee hee.",
	"Wait till I wait.",
	"RICHIE: Goodgod.",
	"Inev erate inall... (With hanging head he marches doggedly forward.",
	"The navvy, lurching by, gores him with his flaming pronghorn.)",
	"RICHIE: (With a cry of pain, his hand to his back.)",
	"Ah!",
	"Bright’s!",
	"Lights!",
	"BLOOM: (Points to the navvy.)",
	"A spy.",
	"Don’t attract attention.",
	"I hate stupid crowds.",
	"I am not on pleasure bent.",
	"I am in a grave predicament.",
	"MRS BREEN: Humbugging and deluthering as per usual with your cock and bull story.",
	"BLOOM: I want to tell you a little secret about how I came to be here.",
	"But you must never tell.",
	"Not even Molly.",
	"I have a most particular reason.",
	"MRS BREEN: (All agog.)",
	"O, not for worlds.",
	"BLOOM: Let’s walk on.",
	"Shall us?",
	"MRS BREEN: Let’s.",
	"(The bawd makes an unheeded sign.",
	"Bloom walks on with Mrs Breen.",
	"The terrier follows, whining piteously, wagging his tail.)",
	"THE BAWD: Jewman’s melt!",
	"MRS BREEN: (In smart Saxe tailormade, white velours hat and spider veil.)",
	"Leopardstown.",
	"BLOOM: I mean, Leopardstown.",
	"Don’t tell me!",
	"Nice adviser!",
	"MRS BREEN: (Squeezes his arm, simpers.)",
	"Naughty cruel I was!",
	"BLOOM: (Low, secretly, ever more rapidly.)",
	"And Molly was eating a sandwich of spiced beef out of Mrs Joe Gallaher’s lunch basket.",
	"Frankly, though she had her advisers or admirers, I never cared much for her style.",
	"She was... MRS BREEN: Too... BLOOM: Yes.",
	"Yes, yes, yes, yes, yes, yes, yes.",
	"(She fades from his side.",
	"Followed by the whining dog he walks on towards hellsgates.",
	"In an archway a standing woman, bent forward, her feet apart, pisses cowily.",
	"An armless pair of them flop wrestling, growling, in maimed sodden playfight.)",
	"THE GAFFER: (Crouches, his voice twisted in his snout.)",
	"THE LOITERERS: (Guffaw with cleft palates.)",
	"O jays!",
	"(Their paintspeckled hats wag.",
	"Spattered with size and lime of their lodges they frisk limblessly about him.)",
	"BLOOM: Coincidence too.",
	"They think it funny.",
	"Anything but that.",
	"Broad daylight.",
	"Trying to walk.",
	"Lucky no woman.",
	"THE LOITERERS: Jays, that’s a good one.",
	"Glauber salts.",
	"O jays, into the men’s porter.",
	"(Bloom passes.",
	"Cheap whores, singly, coupled, shawled, dishevelled, call from lanes, doors, corners.)",
	"THE WHORES: Are you going far, queer fellow?",
	"How’s your middle leg?",
	"Got a match on you?",
	"Eh, come here till I stiffen it for you.",
	"(He plodges through their sump towards the lighted street beyond.",
	"From a bulge of window curtains a gramophone rears a battered brazen trunk.",
	"In the shadow a shebeenkeeper haggles with the navvy and the two redcoats.)",
	"THE NAVVY: (Belching.)",
	"Where’s the bloody house?",
	"THE SHEBEENKEEPER: Purdon street.",
	"Shilling a bottle of stout.",
	"Respectable woman.",
	"THE NAVVY: (Gripping the two redcoats, staggers forward with them.)",
	"Come on, you British army!",
	"PRIVATE CARR: (Behind his back.)",
	"He aint half balmy.",
	"PRIVATE COMPTON: (Laughs.)",
	"What ho!",
	"PRIVATE CARR: (To the navvy.)",
	"Portobello barracks canteen.",
	"You ask for Carr.",
	"Just Carr.",
	"THE NAVVY: (Shouts.)",
	"We are the boys.",
	"Of Wexford.",
	"PRIVATE COMPTON: Say!",
	"What price the sergeantmajor?",
	"PRIVATE CARR: Bennett?",
	"He’s my pal.",
	"I love old Bennett.",
	"THE NAVVY: (Shouts.)",
	"The galling chain.",
	"And free our native land.",
	"(He staggers forward, dragging them with him.",
	"Bloom stops, at fault.",
	"The dog approaches, his tongue outlolling, panting.)",
	"BLOOM: Wildgoose chase this.",
	"Disorderly houses.",
	"Lord knows where they are gone.",
	"Drunks cover distance double quick.",
	"Nice mixup.",
	"Scene at Westland row.",
	"Then jump in first class with third ticket.",
	"Then too far.",
	"Train with engine behind.",
	"Might have taken me to Malahide or a siding for the night or collision.",
	"Second drink does it.",
	"Once is a dose.",
	"What am I following him for?",
	"Still, he’s the best of that lot.",
	"If I hadn’t heard about Mrs Beaufoy Purefoy I wouldn’t have gone and wouldn’t have met.",
	"Kismet.",
	"He’ll lose that cash.",
	"Relieving office here.",
	"Good biz for cheapjacks, organs.",
	"What do ye lack?",
	"Soon got, soon gone.",
	"Might have lost my life too with that mangongwheeltracktrolleyglarejuggernaut only for presence of mind.",
	"Can’t always save you, though.",
	"If I had passed Truelock’s window that day two minutes later would have been shot.",
	"Absence of body.",
	"Still if bullet only went through my coat get damages for shock, five hundred pounds.",
	"What was he?",
	"Kildare street club toff.",
	"God help his gamekeeper.",
	"(He gazes ahead, reading on the wall a scrawled chalk legend Wet Dream and a phallic design.)",
	"Odd!",
	"Molly drawing on the frosted carriagepane at Kingstown.",
	"What’s that like?",
	"(Gaudy dollwomen loll in the lighted doorways, in window embrasures, smoking birdseye cigarettes.",
	"The odour of the sicksweet weed floats towards him in slow round ovalling wreaths.)",
	"THE WREATHS: Sweet are the sweets.",
	"Sweets of sin.",
	"BLOOM: My spine’s a bit limp.",
	"Go or turn?",
	"And this food?",
	"Eat it and get all pigsticky.",
	"Absurd I am.",
	"Waste of money.",
	"One and eightpence too much.",
	"(The retriever drives a cold snivelling muzzle against his hand, wagging his tail.)",
	"Strange how they take to me.",
	"Even that brute today.",
	"Better speak to him first.",
	"Like women they like rencontres.",
	"Stinks like a polecat.",
	"Chacun son goût.",
	"He might be mad.",
	"Dogdays.",
	"Uncertain in his movements.",
	"Good fellow!",
	"Fido!",
	"Good fellow!",
	"Garryowen!",
	"(The wolfdog sprawls on his back, wriggling obscenely with begging paws, his long black tongue lolling out.)",
	"Influence of his surroundings.",
	"Give and have done with it.",
	"Provided nobody.",
	"He unrolls one parcel and goes to dump the crubeen softly but holds back and feels the trotter.)",
	"Sizeable for threepence.",
	"But then I have it in my left hand.",
	"Calls for more effort.",
	"Why?",
	"Smaller from want of use.",
	"O, let it slide.",
	"Two and six.",
	"(With regret he lets the unrolled crubeen and trotter slide.",
	"The mastiff mauls the bundle clumsily and gluts himself with growling greed, crunching the bones.",
	"Two raincaped watch approach, silent, vigilant.",
	"They murmur together.)",
	"THE WATCH: Bloom.",
	"Of Bloom.",
	"For Bloom.",
	"Bloom.",
	"(Each lays hand on Bloom’s shoulder.)",
	"FIRST WATCH: Caught in the act.",
	"Commit no nuisance.",
	"BLOOM: (Stammers.)",
	"I am doing good to others.",
	"(A covey of gulls, storm petrels, rises hungrily from Liffey slime with Banbury cakes in their beaks.)",
	"THE GULLS: Kaw kave kankury kake.",
	"BLOOM: The friend of man.",
	"Trained by kindness.",
	"(He points.",
	"Bob Doran, toppling from a high barstool, sways over the munching spaniel.)",
	"BOB DORAN: Towser.",
	"Give us the paw.",
	"Give the paw.",
	"(The bulldog growls, his scruff standing, a gobbet of pig’s knuckle between his molars through which rabid scumspittle dribbles.",
	"Bob Doran falls silently into an area.)",
	"SECOND WATCH: Prevention of cruelty to animals.",
	"BLOOM: (Enthusiastically.)",
	"A noble work!",
	"I scolded that tramdriver on Harold’s cross bridge for illusing the poor horse with his harness scab.",
	"Bad French I got for my pains.",
	"Of course it was frosty and the last tram.",
	"All tales of circus life are highly demoralising.",
	"SIGNOR MAFFEI: (With a sinister smile.)",
	"Ladies and gentlemen, my educated greyhound.",
	"It was I broke in the bucking broncho Ajax with my patent spiked saddle for carnivores.",
	"Lash under the belly with a knotted thong.",
	"A redhot crowbar and some liniment rubbing on the burning part produced Fritz of Amsterdam, the thinking hyena.",
	"(He glares.)",
	"I possess the Indian sign.",
	"The glint of my eye does it with these breastsparklers.",
	"(With a bewitching smile.)",
	"I now introduce Mademoiselle Ruby, the pride of the ring.",
	"FIRST WATCH: Come.",
	"Name and address.",
	"BLOOM: I have forgotten for the moment.",
	"Ah, yes!",
	"(He takes off his high grade hat, saluting.)",
	"Dr Bloom, Leopold, dental surgeon.",
	"You have heard of von Blum Pasha.",
	"Umpteen millions.",
	"Donnerwetter!",
	"Owns half Austria.",
	"Egypt.",
	"Cousin.",
	"FIRST WATCH: Proof.",
	"(A card falls from inside the leather headband of Bloom’s hat.)",
	"Allow me.",
	"My club is the Junior Army and Navy.",
	"Solicitors: Messrs John Henry Menton, 27 Bachelor’s Walk.",
	"FIRST WATCH: (Reads.)",
	"Henry Flower.",
	"No fixed abode.",
	"Unlawfully watching and besetting.",
	"SECOND WATCH: An alibi.",
	"You are cautioned.",
	"BLOOM: (Produces from his heartpocket a crumpled yellow flower.)",
	"This is the flower in question.",
	"It was given me by a man I don’t know his name.",
	"(Plausibly.)",
	"You know that old joke, rose of Castile.",
	"Bloom.",
	"The change of name.",
	"Virag.",
	"(He murmurs privately and confidentially.)",
	"We are engaged you see, sergeant.",
	"Lady in the case.",
	"Love entanglement.",
	"(He shoulders the second watch gently.)",
	"Dash it all.",
	"It’s a way we gallants have in the navy.",
	"Uniform that does it.",
	"(He turns gravely to the first watch.)",
	"Still, of course, you do get your Waterloo sometimes.",
	"Drop in some evening and have a glass of old Burgundy.",
	"(To the second watch gaily.)",
	"I’ll introduce you, inspector.",
	"She’s game.",
	"Do it in the shake of a lamb’s tail.",
	"(A dark mercurialised face appears, leading a veiled figure.)",
	"THE DARK MERCURY: The Castle is looking for him.",
	"He was drummed out of the army.",
	"Henry!",
	"Leopold!",
	"Lionel, thou lost one!",
	"Clear my name.",
	"FIRST WATCH: (Sternly.)",
	"Come to the station.",
	"No, no, worshipful master, light of love.",
	"Mistaken identity.",
	"The Lyons mail.",
	"Lesurques and Dubosc.",
	"You remember the Childs fratricide case.",
	"We medical men.",
	"By striking him dead with a hatchet.",
	"I am wrongfully accused.",
	"Better one guilty escape than ninetynine wrongfully condemned.",
	"MARTHA: (Sobbing behind her veil.)",
	"Breach of promise.",
	"My real name is Peggy Griffin.",
	"He wrote to me that he was miserable.",
	"I’ll tell my brother, the Bective rugger fullback, on you, heartless flirt.",
	"BLOOM: (Behind his hand.)",
	"She’s drunk.",
	"The woman is inebriated.",
	"(He murmurs vaguely the pass of Ephraim.)",
	"Shitbroleeth.",
	"SECOND WATCH: (Tears in his eyes, to Bloom.)",
	"You ought to be thoroughly well ashamed of yourself.",
	"BLOOM: Gentlemen of the jury, let me explain.",
	"A pure mare’s nest.",
	"I am a man misunderstood.",
	"I am being made a scapegoat of.",
	"I am a respectable married man, without a stain on my character.",
	"I live in Eccles street.",
	"Got his majority for the heroic defence of Rorke’s Drift.",
	"FIRST WATCH: Regiment.",
	"BLOOM: (Turns to the gallery.)",
	"The royal Dublins, boys, the salt of the earth, known the world over.",
	"I think I see some old comrades in arms up there among you.",
	"A VOICE: Turncoat!",
	"Up the Boers!",
	"Who booed Joe Chamberlain?",
	"BLOOM: (His hand on the shoulder of the first watch.)",
	"My old dad too was a J. P. I’m as staunch a Britisher as you are, sir.",
	"I did all a white man could.",
	"(With quiet feeling.)",
	"Jim Bludso.",
	"Hold her nozzle again the bank.",
	"FIRST WATCH: Profession or trade.",
	"BLOOM: Well, I follow a literary occupation, author-journalist.",
	"I am connected with the British and Irish press.",
	"If you ring up... (Myles Crawford strides out jerkily, a quill between his teeth.",
	"His scarlet beak blazes within the aureole of his straw hat.",
	"MYLES CRAWFORD: (His cock’s wattles wagging.)",
	"Hello, seventyseven eightfour.",
	"Hello.",
	"Freeman’s Urinal and Weekly Arsewipe here.",
	"Paralyse Europe.",
	"You which?",
	"Bluebags?",
	"Who writes?",
	"Is it Bloom?",
	"He carries a large portfolio labelled Matcham’s Masterstrokes.)",
	"BEAUFOY: (Drawls.)",
	"No, you aren’t.",
	"Not by a long shot if I know it.",
	"I don’t see it, that’s all.",
	"No born gentleman, no-one with the most rudimentary promptings of a gentleman would stoop to such particularly loathsome conduct.",
	"One of those, my lord.",
	"A plagiarist.",
	"A soapy sneak masquerading as a literateur.",
	"BLOOM: (Murmurs with hangdog meekness glum.)",
	"You funny ass, you!",
	"You’re too beastly awfully weird for words!",
	"I don’t think you need over excessively disincommodate yourself in that regard.",
	"My literary agent Mr J.",
	"B. Pinker is in attendance.",
	"I presume, my lord, we shall receive the usual witnesses’ fees, shan’t we?",
	"BLOOM: (Indistinctly.)",
	"University of life.",
	"Bad art.",
	"BEAUFOY: (Shouts.)",
	"It’s a damnably foul lie, showing the moral rottenness of the man!",
	"(He extends his portfolio.)",
	"A VOICE FROM THE GALLERY: Moses, Moses, king of the jews, Wiped his arse in the Daily News.",
	"BLOOM: (Bravely.)",
	"Overdrawn.",
	"BEAUFOY: You low cad!",
	"You ought to be ducked in the horsepond, you rotter!",
	"(To the court.)",
	"Why, look at the man’s private life!",
	"Leading a quadruple existence!",
	"Street angel and house devil.",
	"Not fit to be mentioned in mixed society!",
	"The archconspirator of the age!",
	"BLOOM: (To the court.)",
	"And he, a bachelor, how... FIRST WATCH: The King versus Bloom.",
	"Call the woman Driscoll.",
	"THE CRIER: Mary Driscoll, scullerymaid!",
	"(Mary Driscoll, a slipshod servant girl, approaches.",
	"She has a bucket on the crook of her arm and a scouringbrush in her hand.)",
	"SECOND WATCH: Another!",
	"Are you of the unfortunate class?",
	"MARY DRISCOLL: (Indignantly.)",
	"I’m not a bad one.",
	"I bear a respectable character and was four months in my last place.",
	"FIRST WATCH: What do you tax him with?",
	"MARY DRISCOLL: He made a certain suggestion but I thought more of myself as poor as I am.",
	"BLOOM: (In housejacket of ripplecloth, flannel trousers, heelless slippers, unshaven, his hair rumpled: softly.)",
	"I treated you white.",
	"I gave you mementos, smart emerald garters far above your station.",
	"Incautiously I took your part when you were accused of pilfering.",
	"There’s a medium in all things.",
	"Play cricket.",
	"MARY DRISCOLL: (Excitedly.)",
	"As God is looking down on me this night if ever I laid a hand to them oylsters!",
	"FIRST WATCH: The offence complained of?",
	"Did something happen?",
	"He held me and I was discoloured in four places as a result.",
	"And he interfered twict with my clothing.",
	"BLOOM: She counterassaulted.",
	"MARY DRISCOLL: (Scornfully.)",
	"I had more respect for the scouringbrush, so I had.",
	"I remonstrated with him, Your lord, and he remarked: keep it quiet.",
	"(General laughter.)",
	"GEORGE FOTTRELL: (Clerk of the crown and peace, resonantly.)",
	"Order in court!",
	"The accused will now make a bogus statement.",
	"(Bloom, pleading not guilty and holding a fullblown waterlily, begins a long unintelligible speech.",
	"They would hear what counsel had to say in his stirring address to the grand jury.",
	"A sevenmonths’ child, he had been carefully brought up and nurtured by an aged bedridden parent.",
	"He mumbles incoherently.",
	"Reporters complain that they cannot hear.)",
	"LONGHAND AND SHORTHAND: (Without looking up from their notebooks.)",
	"Loosen his boots.",
	"PROFESSOR MACHUGH: (From the presstable, coughs and calls.)",
	"Cough it up, man.",
	"Get it out in bits.",
	"(The crossexamination proceeds re Bloom and the bucket.",
	"A large bucket.",
	"Bloom himself.",
	"Bowel trouble.",
	"In Beaver street.",
	"Gripe, yes.",
	"Quite bad.",
	"A plasterer’s bucket.",
	"By walking stifflegged.",
	"Suffered untold misery.",
	"Deadly agony.",
	"About noon.",
	"Love or burgundy.",
	"Yes, some spinach.",
	"Crucial moment.",
	"He did not look in the bucket.",
	"Nobody.",
	"Rather a mess.",
	"Not completely.",
	"A Titbits back number.)",
	"(Uproar and catcalls.",
	"J. J. O’MOLLOY: (In barrister’s grey wig and stuffgown, speaking with a voice of pained protest.)",
	"This is no place for indecent levity at the expense of an erring mortal disguised in liquor.",
	"We are not in a beargarden nor at an Oxford rag nor is this a travesty of justice.",
	"Prima facie, I put it to you that there was no attempt at carnally knowing.",
	"Intimacy did not occur and the offence complained of by Driscoll, that her virtue was solicited, was not repeated.",
	"I would deal in especial with atavism.",
	"There have been cases of shipwreck and somnambulism in my client’s family.",
	"He himself, my lord, is a physical wreck from cobbler’s weak chest.",
	"His submission is that he is of Mongolian extraction and irresponsible for his actions.",
	"Not all there, in fact.",
	"Him makee velly muchee fine night.",
	"(He begins to lilt simply.)",
	"Li li poo lil chile Blingee pigfoot evly night Payee two shilly... (He is howled down.)",
	"J. J. O’MOLLOY: (Hotly to the populace.)",
	"This is a lonehand fight.",
	"The Mosaic code has superseded the law of the jungle.",
	"The young person was treated by defendant as if she were his very own daughter.",
	"(Bloom takes J. J. O’Molloy’s hand and raises it to his lips.)",
	"When in doubt persecute Bloom.",
	"He wants to go straight.",
	"I regard him as the whitest man I know.",
	"(To Bloom.)",
	"I suggest that you will do the handsome thing.",
	"BLOOM: A penny in the pound.",
	"(The image of the lake of Kinnereth with blurred cattle cropping in silver haze is projected on the wall.",
	"DLUGACZ: (Hoarsely.)",
	"Bleibtreustrasse, Berlin, W. 13.",
	"(J. J. O’Molloy steps on to a low plinth and holds the lapel of his coat with solemnity.",
	"He applies his handkerchief to his mouth and scrutinises the galloping tide of rosepink blood.)",
	"J. J. O’MOLLOY: (Almost voicelessly.)",
	"Excuse me.",
	"I am suffering from a severe chill, have recently come from a sickbed.",
	"A few wellchosen words.",
	"(He assumes the avine head, foxy moustache and proboscidal eloquence of Seymour Bushe.)",
	"(A paper with something written on it is handed into court.)",
	"BLOOM: (In court dress.)",
	"Can give best references.",
	"Messrs Callan, Coleman.",
	"Mr Wisdom Hely J. P. My old chief Joe Cuffe.",
	"Mr V. B. Dillon, ex lord mayor of Dublin.",
	"I have moved in the charmed circle of the highest... Queens of Dublin society.",
	"(Carelessly.)",
	"Arrest him, constable.",
	"I deeply inflamed him, he said.",
	"Also to me.",
	"Yes, I believe it is the same objectionable person.",
	"Subsequently he enclosed a bloom of edelweiss culled on the heights, as he said, in my honour.",
	"MRS YELVERTON BARRY: Shame on him!",
	"(A crowd of sluts and ragamuffins surges forward.)",
	"THE SLUTS AND RAGAMUFFINS: (Screaming.)",
	"Stop thief!",
	"Hurrah there, Bluebeard!",
	"Three cheers for Ikey Mo!",
	"SECOND WATCH: (Produces handcuffs.)",
	"Here are the darbies.",
	"He urged me (Stating that he felt it his mission in life to urge me.)",
	"to defile the marriage bed, to commit adultery at the earliest possible opportunity.",
	"Also me.",
	"I have it still.",
	"He urged me to do likewise, to misbehave, to sin with officers of the garrison.",
	"MRS BELLINGHAM: Me too.",
	"MRS YELVERTON BARRY: Me too.",
	"(Several highly respectable Dublin ladies hold up improper letters received from Bloom.)",
	"THE HONOURABLE MRS MERVYN TALBOYS: (Stamps her jingling spurs in a sudden paroxysm of fury.)",
	"I will, by the God above me.",
	"I’ll scourge the pigeonlivered cur as long as I can stand over him.",
	"I’ll flay him alive.",
	"BLOOM: (His eyes closing, quails expectantly.)",
	"Here?",
	"(He squirms.)",
	"Again!",
	"(He pants cringing.)",
	"I love the danger.",
	"THE HONOURABLE MRS MERVYN TALBOYS: Very much so!",
	"I’ll make it hot for you.",
	"I’ll make you dance Jack Latten for that.",
	"MRS BELLINGHAM: Tan his breech well, the upstart!",
	"Write the stars and stripes on it!",
	"MRS YELVERTON BARRY: Disgraceful!",
	"There’s no excuse for him!",
	"A married man!",
	"BLOOM: All these people.",
	"I meant only the spanking idea.",
	"A warm tingling glow without effusion.",
	"Refined birching to stimulate the circulation.",
	"THE HONOURABLE MRS MERVYN TALBOYS: (Laughs derisively.)",
	"O, did you, my fine fellow?",
	"You have lashed the dormant tigress in my nature into fury.",
	"MRS BELLINGHAM: (Shakes her muff and quizzing-glasses vindictively.)",
	"Make him smart, Hanna dear.",
	"Give him ginger.",
	"Thrash the mongrel within an inch of his life.",
	"The cat-o’-nine-tails.",
	"Geld him.",
	"Vivisect him.",
	"BLOOM: (Shuddering, shrinking, joins his hands: with hangdog mien.)",
	"O cold!",
	"O shivery!",
	"It was your ambrosial beauty.",
	"Forget, forgive.",
	"Kismet.",
	"Let me off this once.",
	"(He offers the other cheek.)",
	"MRS YELVERTON BARRY: (Severely.)",
	"Don’t do so on any account, Mrs Talboys!",
	"He should be soundly trounced!",
	"THE HONOURABLE MRS MERVYN TALBOYS: (Unbuttoning her gauntlet violently.)",
	"I’ll do no such thing.",
	"Pigdog and always was ever since he was pupped!",
	"To dare address me!",
	"I’ll flog him black and blue in the public streets.",
	"I’ll dig my spurs in him up to the rowel.",
	"He is a wellknown cuckold.",
	"(She swishes her huntingcrop savagely in the air.)",
	"Take down his trousers without loss of time.",
	"Come here, sir!",
	"Quick!",
	"Ready?",
	"BLOOM: (Trembling, beginning to obey.)",
	"The weather has been so warm.",
	"(Davy Stephens, ringletted, passes with a bevy of barefoot newsboys.)",
	"DAVY STEPHENS: Messenger of the Sacred Heart and Evening Telegraph with Saint Patrick’s Day supplement.",
	"Containing the new addresses of all the cuckolds in Dublin.",
	"(The very reverend Canon O’Hanlon in cloth of gold cope elevates and exposes a marble timepiece.",
	"Before him Father Conroy and the reverend John Hughes S. J. bend low.)",
	"THE TIMEPIECE: (Unportalling.)",
	"Cuckoo.",
	"Cuckoo.",
	"Cuckoo.",
	"(The brass quoits of a bed are heard to jingle.)",
	"THE QUOITS: Jigjag.",
	"Jigajiga.",
	"Jigjag.",
	"THE NAMELESS ONE: Bareback riding.",
	"Weight for age.",
	"Gob, he organised her.",
	"THE JURORS: (All their heads turned to his voice.)",
	"Really?",
	"THE NAMELESS ONE: (Snarls.)",
	"Arse over tip.",
	"Hundred shillings to five.",
	"THE JURORS: (All their heads lowered in assent.)",
	"Most of us thought as much.",
	"FIRST WATCH: He is a marked man.",
	"Another girl’s plait cut.",
	"Wanted: Jack the Ripper.",
	"A thousand pounds reward.",
	"SECOND WATCH: (Awed, whispers.)",
	"And in black.",
	"A mormon.",
	"Anarchist.",
	"THE CRIER: (Loudly.)",
	"He bears in his arms an umbrella sceptre.",
	"From his forehead arise starkly the Mosaic ramshorns.)",
	"THE RECORDER: I will put an end to this white slave traffic and rid Dublin of this odious pest.",
	"Scandalous!",
	"(He dons the black cap.)",
	"Remove him.",
	"(A black skullcap descends upon his head.)",
	"(The subsheriff Long John Fanning appears, smoking a pungent Henry Clay.)",
	"LONG JOHN FANNING: (Scowls and calls with rich rolling utterance.)",
	"Who’ll hang Judas Iscariot?",
	"A life preserver and a nailstudded bludgeon are stuck in his belt.",
	"He rubs grimly his grappling hands, knobbed with knuckledusters.)",
	"RUMBOLD: (To the recorder with sinister familiarity.)",
	"Hanging Harry, your Majesty, the Mersey terror.",
	"Five guineas a jugular.",
	"Neck or nothing.",
	"(The bells of George’s church toll slowly, loud dark iron.)",
	"THE BELLS: Heigho!",
	"Heigho!",
	"BLOOM: (Desperately.)",
	"Wait.",
	"Stop.",
	"Gulls.",
	"Good heart.",
	"I saw.",
	"Innocence.",
	"Girl in the monkeyhouse.",
	"Zoo.",
	"Lewd chimpanzee.",
	"(Breathlessly.)",
	"Pelvic basin.",
	"Her artless blush unmanned me.",
	"(Overcome with emotion.)",
	"I left the precincts.",
	"(He turns to a figure in the crowd, appealing.)",
	"Hynes, may I speak to you?",
	"You know me.",
	"That three shillings you can keep.",
	"If you want a little more... HYNES: (Coldly.)",
	"You are a perfect stranger.",
	"SECOND WATCH: (Points to the corner.)",
	"The bomb is here.",
	"FIRST WATCH: Infernal machine with a time fuse.",
	"BLOOM: No, no.",
	"Pig’s feet.",
	"I was at a funeral.",
	"FIRST WATCH: (Draws his truncheon.)",
	"Liar!",
	"(The beagle lifts his snout, showing the grey scorbutic face of Paddy Dignam.",
	"He has gnawed all.",
	"He exhales a putrid carcasefed breath.",
	"He grows to human size and shape.",
	"His dachshund coat becomes a brown mortuary habit.",
	"His green eye flashes bloodshot.",
	"Half of one ear, all the nose and both thumbs are ghouleaten.)",
	"PADDY DIGNAM: (In a hollow voice.)",
	"It is true.",
	"It was my funeral.",
	"Doctor Finucane pronounced life extinct when I succumbed to the disease from natural causes.",
	"(He lifts his mutilated ashen face moonwards and bays lugubriously.)",
	"BLOOM: (In triumph.)",
	"You hear?",
	"PADDY DIGNAM: Bloom, I am Paddy Dignam’s spirit.",
	"List, list, O list!",
	"BLOOM: The voice is the voice of Esau.",
	"SECOND WATCH: (Blesses himself.)",
	"How is that possible?",
	"FIRST WATCH: It is not in the penny catechism.",
	"PADDY DIGNAM: By metempsychosis.",
	"Spooks.",
	"A VOICE: O rocks.",
	"PADDY DIGNAM: (Earnestly.)",
	"Now I am defunct, the wall of the heart hypertrophied.",
	"Hard lines.",
	"The poor wife was awfully cut up.",
	"How is she bearing it?",
	"Keep her off that bottle of sherry.",
	"(He looks round him.)",
	"A lamp.",
	"I must satisfy an animal need.",
	"That buttermilk didn’t agree with me.",
	"(The portly figure of John O’Connell, caretaker, stands forth, holding a bunch of keys tied with crape.",
	"FATHER COFFEY: (Yawns, then chants with a hoarse croak.)",
	"Namine.",
	"Jacobs.",
	"Vobiscuits.",
	"Amen.",
	"JOHN O’CONNELL: (Foghorns stormily through his megaphone.)",
	"Dignam, Patrick T, deceased.",
	"PADDY DIGNAM: (With pricked up ears, winces.)",
	"Overtones.",
	"(He wriggles forward and places an ear to the ground.)",
	"My master’s voice!",
	"JOHN O’CONNELL: Burial docket letter number U. P. eightyfive thousand.",
	"Field seventeen.",
	"House of Keys.",
	"Plot, one hundred and one.",
	"(Paddy Dignam listens with visible effort, thinking, his tail stiffpointed, his ears cocked.)",
	"PADDY DIGNAM: Pray for the repose of his soul.",
	"(He worms down through a coalhole, his brown habit trailing its tether over rattling pebbles.",
	"After him toddles an obese grandfather rat on fungus turtle paws under a grey carapace.",
	"Dignam’s voice, muffled, is heard baying under ground: Dignam’s dead and gone below.",
	"Tom Rochford, robinredbreasted, in cap and breeches, jumps from his twocolumned machine.)",
	"TOM ROCHFORD: (A hand to his breastbone, bows.)",
	"Reuben J.",
	"A florin I find him.",
	"(He fixes the manhole with a resolute stare.)",
	"My turn now on.",
	"Follow me up to Carlow.",
	"(He executes a daredevil salmon leap in the air and is engulfed in the coalhole.",
	"Two discs on the columns wobble, eyes of nought.",
	"All recedes.",
	"Bloom plodges forward again through the sump.",
	"Kisses chirp amid the rifts of fog.",
	"A piano sounds.",
	"He stands before a lighted house, listening.",
	"The kisses, winging from their bowers, fly about him, twittering, warbling, cooing.)",
	"THE KISSES: (Warbling.)",
	"Leo!",
	"(Twittering.)",
	"Icky licky micky sticky for Leo!",
	"(Cooing.)",
	"Coo coocoo!",
	"Yummyyum, Womwom!",
	"(Warbling.)",
	"Big comebig!",
	"Pirouette!",
	"Leopopold!",
	"(Twittering.)",
	"Leeolee!",
	"(Warbling.)",
	"O Leo!",
	"(They rustle, flutter upon his garments, alight, bright giddy flecks, silvery sequins.)",
	"BLOOM: A man’s touch.",
	"Sad music.",
	"Church music.",
	"Perhaps here.",
	"ZOE: Are you looking for someone?",
	"He’s inside with his friend.",
	"BLOOM: Is this Mrs Mack’s?",
	"ZOE: No, eightyone.",
	"Mrs Cohen’s.",
	"You might go farther and fare worse.",
	"Mother Slipperslapper.",
	"(Familiarly.)",
	"Working overtime but her luck’s turned today.",
	"(Suspiciously.)",
	"You’re not his father, are you?",
	"BLOOM: Not I!",
	"ZOE: You both in black.",
	"Has little mousey any tickles tonight?",
	"(His skin, alert, feels her fingertips approach.",
	"A hand glides over his left thigh.)",
	"ZOE: How’s the nuts?",
	"BLOOM: Off side.",
	"Curiously they are on the right.",
	"Heavier, I suppose.",
	"One in a million my tailor, Mesias, says.",
	"ZOE: (In sudden alarm.)",
	"You’ve a hard chancre.",
	"BLOOM: Not likely.",
	"ZOE: I feel it.",
	"(Her hand slides into his left trouser pocket and brings out a hard black shrivelled potato.",
	"She regards it and Bloom with dumb moist lips.)",
	"BLOOM: A talisman.",
	"Heirloom.",
	"ZOE: For Zoe?",
	"For keeps?",
	"For being so nice, eh?",
	"(She puts the potato greedily into a pocket then links his arm, cuddling him with supple warmth.",
	"He smiles uneasily.",
	"Slowly, note by note, oriental music is played.",
	"He gazes in the tawny crystal of her eyes, ringed with kohol.",
	"His smile softens.)",
	"ZOE: You’ll know me the next time.",
	"BLOOM: (Forlornly.)",
	"I never loved a dear gazelle but it was sure to... (Gazelles are leaping, feeding on the mountains.",
	"Near are lakes.",
	"Round their shores file shadows black of cedargroves.",
	"Aroma rises, a strong hairgrowth of resin.",
	"It burns, the orient, a sky of sapphire, cleft by the bronze flight of eagles.",
	"Under it lies the womancity, nude, white, still, cool, in luxury.",
	"A fountain murmurs among damask roses.",
	"Mammoth roses murmur of scarlet winegrapes.",
	"A wine of shame, lust, blood exudes, strangely murmuring.)",
	"ZOE: (Murmuring singsong with the music, her odalisk lips lusciously smeared with salve of swinefat and rosewater.)",
	"Schorach ani wenowach, benoith Hierushaloim.",
	"BLOOM: (Fascinated.)",
	"I thought you were of good stock by your accent.",
	"ZOE: And you know what thought did?",
	"(She bites his ear gently with little goldstopped teeth, sending on him a cloying breath of stale garlic.",
	"The roses draw apart, disclose a sepulchre of the gold of kings and their mouldering bones.)",
	"BLOOM: (Draws back, mechanically caressing her right bub with a flat awkward hand.)",
	"Are you a Dublin girl?",
	"ZOE: (Catches a stray hair deftly and twists it to her coil.)",
	"No bloody fear.",
	"I’m English.",
	"Have you a swaggerroot?",
	"BLOOM: (As before.)",
	"Rarely smoke, dear.",
	"Cigar now and then.",
	"Childish device.",
	"(Lewdly.)",
	"The mouth can be better engaged than with a cylinder of rank weed.",
	"ZOE: Go on.",
	"Make a stump speech out of it.",
	"BLOOM: (In workman’s corduroy overalls, black gansy with red floating tie and apache cap.)",
	"Mankind is incorrigible.",
	"Suicide.",
	"Lies.",
	"All our habits.",
	"Why, look at our public life!",
	"(Midnight chimes from distant steeples.)",
	"THE CHIMES: Turn again, Leopold!",
	"Lord mayor of Dublin!",
	"BLOOM: (In alderman’s gown and chain.)",
	"That’s the music of the future.",
	"That’s my programme.",
	"Cui bono?",
	"(The aurora borealis of the torchlight procession leaps.)",
	"THE TORCHBEARERS: Hooray!",
	"(Several wellknown burgesses, city magnates and freemen of the city shake hands with Bloom and congratulate him.",
	"They nod vigorously in agreement.)",
	"LATE LORD MAYOR HARRINGTON: (In scarlet robe with mace, gold mayoral chain and large white silk scarf.)",
	"That alderman sir Leo Bloom’s speech be printed at the expense of the ratepayers.",
	"COUNCILLOR LORCAN SHERLOCK: Carried unanimously.",
	"BLOOM: (Impassionedly.)",
	"These flying Dutchmen or lying Dutchmen as they recline in their upholstered poop, casting dice, what reck they?",
	"Machines is their cry, their chimera, their panacea.",
	"But their reign is rover for rever and ever and ev... (Prolonged applause.",
	"Venetian masts, maypoles and festal arches spring up.",
	"A streamer bearing the legends Cead Mile Failte and Mah Ttob Melek Israel spans the street.",
	"All the windows are thronged with sightseers, chiefly ladies.",
	"The pillar of the cloud appears.",
	"A fife and drum band is heard in the distance playing the Kol Nidre.",
	"The beaters approach with imperial eagles hoisted, trailing banners and waving oriental palms.",
	"The chryselephantine papal standard rises high, surrounded by pennons of the civic flag.",
	"Four buglers on foot blow a sennet.",
	"Beefeaters reply, winding clarions of welcome.",
	"He is seated on a milkwhite horse with long flowing crimson tail, richly caparisoned, with golden headstall.",
	"Wild excitement.",
	"The ladies from their balconies throw down rosepetals.",
	"The air is perfumed with essences.",
	"The men cheer.",
	"Bloom’s boys run amid the bystanders with branches of hawthorn and wrenbushes.)",
	"A BLACKSMITH: (Murmurs.)",
	"For the honour of God!",
	"And is that Bloom?",
	"He scarcely looks thirtyone.",
	"A PAVIOR AND FLAGGER: That’s the famous Bloom now, the world’s greatest reformer.",
	"Hats off!",
	"(All uncover their heads.",
	"Women whisper eagerly.)",
	"A MILLIONAIRESS: (Richly.)",
	"Isn’t he simply wonderful?",
	"A NOBLEWOMAN: (Nobly.)",
	"All that man has seen!",
	"A FEMINIST: (Masculinely.)",
	"And done!",
	"A BELLHANGER: A classic face!",
	"He has the forehead of a thinker.",
	"(Bloom’s weather.",
	"A sunburst appears in the northwest.)",
	"God save Leopold the First!",
	"ALL: God save Leopold the First!",
	"BLOOM: (In dalmatic and purple mantle, to the bishop of Down and Connor, with dignity.)",
	"Thanks, somewhat eminent sir.",
	"WILLIAM, ARCHBISHOP OF ARMAGH: (In purple stock and shovel hat.)",
	"BLOOM: (Placing his right hand on his testicles, swears.)",
	"So may the Creator deal with me.",
	"All this I promise to do.",
	"MICHAEL, ARCHBISHOP OF ARMAGH: (Pours a cruse of hairoil over Bloom’s head.)",
	"Gaudium magnum annuntio vobis.",
	"Habemus carneficem.",
	"Leopold, Patrick, Andrew, David, George, be thou anointed!",
	"(Bloom assumes a mantle of cloth of gold and puts on a ruby ring.",
	"He ascends and stands on the stone of destiny.",
	"The representative peers put on at the same time their twentyeight crowns.",
	"Joybells ring in Christ church, Saint Patrick’s, George’s and gay Malahide.",
	"Mirus bazaar fireworks go up from all sides with symbolical phallopyrotechnic designs.",
	"The peers do homage, one by one, approaching and genuflecting.)",
	"THE PEERS: I do become your liege man of life and limb to earthly worship.",
	"(Bloom holds up his right hand on which sparkles the Koh-i-Noor diamond.",
	"His palfrey neighs.",
	"Immediate silence.",
	"Wireless intercontinental and interplanetary transmitters are set for reception of message.)",
	"BLOOM: My subjects!",
	"(The former morganatic spouse of Bloom is hastily removed in the Black Maria.",
	"An outburst of cheering.)",
	"JOHN HOWARD PARNELL: (Raises the royal standard.)",
	"Illustrious Bloom!",
	"Successor to my famous brother!",
	"BLOOM: (Embraces John Howard Parnell.)",
	"(The freedom of the city is presented to him embodied in a charter.",
	"The keys of Dublin, crossed on a crimson cushion, are given to him.",
	"He shows all that he is wearing green socks.)",
	"TOM KERNAN: You deserve it, your honour.",
	"BLOOM: On this day twenty years ago we overcame the hereditary enemy at Ladysmith.",
	"Our howitzers and camel swivel guns played on his lines with telling effect.",
	"Half a league onward!",
	"They charge!",
	"All is lost now!",
	"Do we yield?",
	"No!",
	"We drive them headlong!",
	"Lo!",
	"We charge!",
	"THE CHAPEL OF FREEMAN TYPESETTERS: Hear!",
	"Hear!",
	"JOHN WYSE NOLAN: There’s the man that got away James Stephens.",
	"A BLUECOAT SCHOOLBOY: Bravo!",
	"AN OLD RESIDENT: You’re a credit to your country, sir, that’s what you are.",
	"AN APPLEWOMAN: He’s a man like Ireland wants.",
	"BLOOM: My beloved subjects, a new era is about to dawn.",
	"I, Bloom, tell you verily it is even now at hand.",
	"In the course of its extension several buildings and monuments are demolished.",
	"Government offices are temporarily transferred to railway sheds.",
	"Numerous houses are razed to the ground.",
	"The inhabitants are lodged in barrels and boxes, all marked in red with the letters: L. B.",
	"Several paupers fall from a ladder.",
	"A part of the walls of Dublin, crowded with loyal sightseers, collapses.)",
	"THE SIGHTSEERS: (Dying.)",
	"Morituri te salutant.",
	"(They die.)",
	"(A man in a brown macintosh springs up through a trapdoor.",
	"He points an elongated finger at Bloom.)",
	"THE MAN IN THE MACINTOSH: Don’t you believe a word he says.",
	"That man is Leopold M’Intosh, the notorious fireraiser.",
	"His real name is Higgins.",
	"BLOOM: Shoot him!",
	"Dog of a christian!",
	"So much for M’Intosh!",
	"(A cannonshot.",
	"The man in the macintosh disappears.",
	"Bloom with his sceptre strikes down poppies.",
	"The instantaneous deaths of many powerful enemies, graziers, members of parliament, members of standing committees, are reported.",
	"A general rush and scramble.",
	"Women press forward to touch the hem of Bloom’s robe.",
	"A magnesium flashlight photograph is taken.",
	"Babes and sucklings are held up.)",
	"THE WOMEN: Little father!",
	"Little father!",
	"THE BABES AND SUCKLINGS: Clap clap hands till Poldy comes home, Cakes in his pocket for Leo alone.",
	"(Bloom, bending down, pokes Baby Boardman gently in the stomach.)",
	"BABY BOARDMAN: (Hiccups, curdled milk flowing from his mouth.)",
	"Hajajaja.",
	"BLOOM: (Shaking hands with a blind stripling.)",
	"My more than Brother!",
	"(Placing his arms round the shoulders of an old couple.)",
	"Dear old friends!",
	"(He plays pussy fourcorners with ragged boys and girls.)",
	"Peep!",
	"Bopeep!",
	"(He wheels twins in a perambulator.)",
	"Ticktacktwo wouldyousetashoe?",
	"(He performs juggler’s tricks, draws red, orange, yellow, green, blue, indigo and violet silk handkerchiefs from his mouth.)",
	"Roygbiv.",
	"32 feet per second.",
	"(He consoles a widow.)",
	"Absence makes the heart grow younger.",
	"(He dances the Highland fling with grotesque antics.)",
	"Leg it, ye devils!",
	"(He kisses the bedsores of a palsied veteran.)",
	"Honourable wounds!",
	"(He trips up a fat policeman.)",
	"U. p: up.",
	"U. p: up.",
	"(He whispers in the ear of a blushing waitress and laughs kindly.)",
	"Ah, naughty, naughty!",
	"(He eats a raw turnip offered him by Maurice Butterly, farmer.)",
	"Fine!",
	"Splendid!",
	"(He refuses to accept three shillings offered him by Joseph Hynes, journalist.)",
	"My dear fellow, not at all!",
	"(He gives his coat to a beggar.)",
	"Please accept.",
	"(He takes part in a stomach race with elderly male and female cripples.)",
	"Come on, boys!",
	"Wriggle it, girls!",
	"THE CITIZEN: (Choked with emotion, brushes aside a tear in his emerald muffler.)",
	"May the good God bless him!",
	"(The rams’ horns sound for silence.",
	"The standard of Zion is hoisted.)",
	"BLOOM: (Uncloaks impressively, revealing obesity, unrolls a paper and reads solemnly.)",
	"Aleph Beth Ghimel Daleth Hagadah Tephilim Kosher Yom Kippur Hanukah Roschaschana Beni Brith Bar Mitzvah Mazzoth Askenazim Meshuggah Talith.",
	"(An official translation is read by Jimmy Henry, assistant town clerk.)",
	"JIMMY HENRY: The Court of Conscience is now open.",
	"His Most Catholic Majesty will now administer open air justice.",
	"Free medical and legal advice, solution of doubles and other problems.",
	"All cordially invited.",
	"Given at this our loyal city of Dublin in the year 1 of the Paradisiacal Era.",
	"PADDY LEONARD: What am I to do about my rates and taxes?",
	"BLOOM: Pay them, my friend.",
	"PADDY LEONARD: Thank you.",
	"NOSEY FLYNN: Can I raise a mortgage on my fire insurance?",
	"BLOOM: (Obdurately.)",
	"J. J. O’MOLLOY: A Daniel did I say?",
	"Nay!",
	"A Peter O’Brien!",
	"NOSEY FLYNN: Where do I draw the five pounds?",
	"PISSER BURKE: For bladder trouble?",
	"BLOOM: Acid.",
	"nit.",
	"hydrochlor.",
	"dil., 20 minims Tinct.",
	"nux vom., 5 minims Extr.",
	"taraxel.",
	"lig., 30 minims.",
	"Aq.",
	"dis.",
	"ter in die.",
	"CHRIS CALLINAN: What is the parallax of the subsolar ecliptic of Aldebaran?",
	"BLOOM: Pleased to hear from you, Chris.",
	"K. 11.",
	"JOE HYNES: Why aren’t you in uniform?",
	"BEN DOLLARD: Pansies?",
	"BLOOM: Embellish (beautify) suburban gardens.",
	"BEN DOLLARD: When twins arrive?",
	"BLOOM: Father (pater, dad) starts thinking.",
	"LARRY O’ROURKE: An eightday licence for my new premises.",
	"You remember me, sir Leo, when you were in number seven.",
	"I’m sending around a dozen of stout for the missus.",
	"BLOOM: (Coldly.)",
	"You have the advantage of me.",
	"Lady Bloom accepts no presents.",
	"CROFTON: This is indeed a festivity.",
	"BLOOM: (Solemnly.)",
	"You call it a festivity.",
	"I call it a sacrament.",
	"ALEXANDER KEYES: When will we have our own house of keys?",
	"BLOOM: I stand for the reform of municipal morals and the plain ten commandments.",
	"New worlds for old.",
	"Union of all, jew, moslem and gentile.",
	"Three acres and a cow for all children of nature.",
	"Saloon motor hearses.",
	"Compulsory manual labour for all.",
	"All parks open to the public day and night.",
	"Electric dishscrubbers.",
	"Tuberculosis, lunacy, war and mendicancy must now cease.",
	"General amnesty, weekly carnival with masked licence, bonuses for all, esperanto the universal language with universal brotherhood.",
	"No more patriotism of barspongers and dropsical impostors.",
	"Free money, free rent, free love and a free lay church in a free lay state.",
	"O’MADDEN BURKE: Free fox in a free henroost.",
	"DAVY BYRNE: (Yawning.)",
	"Iiiiiiiiiaaaaaaach!",
	"BLOOM: Mixed races and mixed marriage.",
	"LENEHAN: What about mixed bathing?",
	"(Bloom explains to those near him his schemes for social regeneration.",
	"All agree with him.",
	"FATHER FARLEY: He is an episcopalian, an agnostic, an anythingarian seeking to overthrow our holy faith.",
	"MRS RIORDAN: (Tears up her will.)",
	"I’m disappointed in you!",
	"You bad man!",
	"MOTHER GROGAN: (Removes her boot to throw it at Bloom.)",
	"You beast!",
	"You abominable person!",
	"NOSEY FLYNN: Give us a tune, Bloom.",
	"One of the old sweet songs.",
	"BLOOM: (With rollicking humour.)",
	"I vowed that I never would leave her, She turned out a cruel deceiver.",
	"With my tooraloom tooraloom tooraloom tooraloom.",
	"HOPPY HOLOHAN: Good old Bloom!",
	"There’s nobody like him after all.",
	"PADDY LEONARD: Stage Irishman!",
	"BLOOM: What railway opera is like a tramline in Gibraltar?",
	"The Rows of Casteele.",
	"(Laughter.)",
	"LENEHAN: Plagiarist!",
	"Down with Bloom!",
	"THE VEILED SIBYL: (Enthusiastically.)",
	"I’m a Bloomite and I glory in it.",
	"I believe in him in spite of all.",
	"I’d give my life for him, the funniest man on earth.",
	"BLOOM: (Winks at the bystanders.)",
	"I bet she’s a bonny lassie.",
	"THEODORE PUREFOY: (In fishingcap and oilskin jacket.)",
	"He employs a mechanical device to frustrate the sacred ends of nature.",
	"THE VEILED SIBYL: (Stabs herself.)",
	"My hero god!",
	"(She dies.)",
	"ALEXANDER J DOWIE: (Violently.)",
	"Fellowchristians and antiBloomites, the man called Bloom is from the roots of hell, a disgrace to christian men.",
	"This vile hypocrite, bronzed with infamy, is the white bull mentioned in the Apocalypse.",
	"A worshipper of the Scarlet Woman, intrigue is the very breath of his nostrils.",
	"The stake faggots and the caldron of boiling oil are for him.",
	"Caliban!",
	"THE MOB: Lynch him!",
	"Roast him!",
	"He’s as bad as Parnell was.",
	"Mr Fox!",
	"(Mother Grogan throws her boot at Bloom.",
	"BLOOM: (Excitedly.)",
	"This is midsummer madness, some ghastly joke again.",
	"By heaven, I am guiltless as the unsunned snow!",
	"It was my brother Henry.",
	"He is my double.",
	"He lives in number 2 Dolphin’s Barn.",
	"Slander, the viper, has wrongfully accused me.",
	"Fellowcountrymen, sgenl inn ban bata coisde gan capall.",
	"I call on my old friend, Dr Malachi Mulligan, sex specialist, to give medical testimony on my behalf.",
	"DR MULLIGAN: (In motor jerkin, green motorgoggles on his brow.)",
	"Dr Bloom is bisexually abnormal.",
	"He has recently escaped from Dr Eustace’s private asylum for demented gentlemen.",
	"Born out of bedlock hereditary epilepsy is present, the consequence of unbridled lust.",
	"Traces of elephantiasis have been discovered among his ascendants.",
	"There are marked symptoms of chronic exhibitionism.",
	"Ambidexterity is also latent.",
	"He is prematurely bald from selfabuse, perversely idealistic in consequence, a reformed rake, and has metal teeth.",
	"(Bloom holds his high grade hat over his genital organs.)",
	"DR MADDEN: Hypsospadia is also marked.",
	"DR CROTTHERS: I have examined the patient’s urine.",
	"It is albuminoid.",
	"Salivation is insufficient, the patellar reflex intermittent.",
	"DR PUNCH COSTELLO: The fetor judaicus is most perceptible.",
	"DR DIXON: (Reads a bill of health.)",
	"Professor Bloom is a finished example of the new womanly man.",
	"His moral nature is simple and lovable.",
	"Many have found him a dear man, a dear person.",
	"He is a rather quaint fellow on the whole, coy though not feebleminded in the medical sense.",
	"He wears a hairshirt of pure Irish manufacture winter and summer and scourges himself every Saturday.",
	"He was, I understand, at one time a firstclass misdemeanant in Glencree reformatory.",
	"Another report states that he was a very posthumous child.",
	"He is about to have a baby.",
	"(General commotion and compassion.",
	"Women faint.",
	"A wealthy American makes a street collection for Bloom.",
	"BLOOM: O, I so want to be a mother.",
	"MRS THORNTON: (In nursetender’s gown.)",
	"Embrace me tight, dear.",
	"You’ll be soon over it.",
	"Tight, dear.",
	"(Bloom embraces her tightly and bears eight male yellow and white children.",
	"They appear on a redcarpeted staircase adorned with expensive plants.",
	"Each has his name printed in legible letters on his shirtfront: Nasodoro, Goldfinger, Chrysostomos, Maindorée, Silversmile, Silberselber, Vifargent, Panargyros.",
	"A VOICE: Bloom, are you the Messiah ben Joseph or ben David?",
	"BLOOM: (Darkly.)",
	"You have said it.",
	"BROTHER BUZZ: Then perform a miracle like Father Charles.",
	"BANTAM LYONS: Prophesy who will win the Saint Leger.",
	"Leopoldi autem generatio.",
	"A DEADHAND: (Writes on the wall.)",
	"Bloom is a cod.",
	"CRAB: (In bushranger’s kit.)",
	"What did you do in the cattlecreep behind Kilbarrack?",
	"A FEMALE INFANT: (Shakes a rattle.)",
	"And under Ballybough bridge?",
	"A HOLLYBUSH: And in the devil’s glen?",
	"BLOOM: (Blushes furiously all over from frons to nates, three tears falling from his left eye.)",
	"Spare my past.",
	"THE IRISH EVICTED TENANTS: (In bodycoats, kneebreeches, with Donnybrook fair shillelaghs.)",
	"Sjambok him!",
	"(Bloom with asses’ ears seats himself in the pillory with crossed arms, his feet protruding.",
	"He whistles Don Giovanni, a cenar teco.",
	"Artane orphans, joining hands, caper round him.",
	"Girls of the Prison Gate Mission, joining hands, caper round in the opposite direction.)",
	"THE ARTANE ORPHANS: You hig, you hog, you dirty dog!",
	"You think the ladies love you!",
	"HORNBLOWER: (In ephod and huntingcap, announces.)",
	"(All the people cast soft pantomime stones at Bloom.",
	"Many bonafide travellers and ownerless dogs come near him and defile him.",
	"Mastiansky and Citron approach in gaberdines, wearing long earlocks.",
	"They wag their beards at Bloom.)",
	"MASTIANSKY AND CITRON: Belial!",
	"Laemlein of Istria, the false Messiah!",
	"Abulafia!",
	"Recant!",
	"(George R Mesias, Bloom’s tailor, appears, a tailor’s goose under his arm, presenting a bill.)",
	"MESIAS: To alteration one pair trousers eleven shillings.",
	"BLOOM: (Rubs his hands cheerfully.)",
	"Just like old times.",
	"Poor Bloom!",
	"REUBEN J: (Whispers hoarsely.)",
	"The squeak is out.",
	"A split is gone for the flatties.",
	"Nip the first rattler.",
	"THE FIRE BRIGADE: Pflaap!",
	"BROTHER BUZZ: (Invests Bloom in a yellow habit with embroidery of painted flames and high pointed hat.",
	"He places a bag of gunpowder round his neck and hands him over to the civil power, saying.)",
	"Forgive him his trespasses.",
	"(Lieutenant Myers of the Dublin Fire Brigade by general request sets fire to Bloom.",
	"Lamentations.)",
	"THE CITIZEN: Thank heaven!",
	"BLOOM: (In a seamless garment marked I. H. S. stands upright amid phoenix flames.)",
	"Weep not for me, O daughters of Erin.",
	"(He exhibits to Dublin reporters traces of burning.",
	"Bloom becomes mute, shrunken, carbonised.)",
	"ZOE: Talk away till you’re black in the face.",
	"(With a tear in his eye.)",
	"All insanity.",
	"Patriotism, sorrow for the dead, music, future of the race.",
	"To be or not to be.",
	"Life’s dream is o’er.",
	"End it peacefully.",
	"They can live on.",
	"(He gazes far away mournfully.)",
	"I am ruined.",
	"A few pastilles of aconite.",
	"The blinds drawn.",
	"A letter.",
	"Then lie back to rest.",
	"(He breathes softly.)",
	"No more.",
	"I have lived.",
	"Fare.",
	"Farewell.",
	"ZOE: (Stiffly, her finger in her neckfillet.)",
	"Honest?",
	"Till the next time.",
	"(She sneers.)",
	"Suppose you got up the wrong side of the bed or came too quick with your best girl.",
	"O, I can read your thoughts!",
	"BLOOM: (Bitterly.)",
	"Man and woman, love, what is it?",
	"A cork and bottle.",
	"I’m sick of it.",
	"Let everything rip.",
	"ZOE: (In sudden sulks.)",
	"I hate a rotter that’s insincere.",
	"Give a bleeding whore a chance.",
	"BLOOM: (Repentantly.)",
	"I am very disagreeable.",
	"You are a necessary evil.",
	"Where are you from?",
	"London?",
	"ZOE: (Glibly.)",
	"Hog’s Norton where the pigs plays the organs.",
	"I’m Yorkshire born.",
	"(She holds his hand which is feeling for her nipple.)",
	"I say, Tommy Tittlemouse.",
	"Stop that and begin worse.",
	"Have you cash for a short time?",
	"Ten shillings?",
	"BLOOM: (Smiles, nods slowly.)",
	"More, houri, more.",
	"ZOE: And more’s mother?",
	"(She pats him offhandedly with velvet paws.)",
	"Are you coming into the musicroom to see our new pianola?",
	"Come and I’ll peel off.",
	"Somebody would be dreadfully jealous if she knew.",
	"The greeneyed monster.",
	"(Earnestly.)",
	"You know how difficult it is.",
	"I needn’t tell you.",
	"ZOE: (Flattered.)",
	"What the eye can’t see the heart can’t grieve for.",
	"(She pats him.)",
	"Come.",
	"BLOOM: Laughing witch!",
	"The hand that rocks the cradle.",
	"ZOE: Babby!",
	"One two tlee: tlee tlwo tlone.",
	"THE BUCKLES: Love me.",
	"Love me not.",
	"Love me.",
	"ZOE: Silent means consent.",
	"Hot hands cold gizzard.",
	"(He hesitates amid scents, music, temptations.",
	"Good!",
	"(Zoe and Bloom reach the doorway where two sister whores are seated.",
	"They examine him curiously from under their pencilled brows and smile to his hasty bow.",
	"He trips awkwardly.)",
	"ZOE: (Her lucky hand instantly saving him.)",
	"Hoopsa!",
	"Don’t fall upstairs.",
	"BLOOM: The just man falls seven times.",
	"(He stands aside at the threshold.)",
	"After you is good manners.",
	"ZOE: Ladies first, gentlemen after.",
	"(She crosses the threshold.",
	"He hesitates.",
	"She turns and, holding out her hands, draws him over.",
	"He hops.",
	"On the antlered rack of the hall hang a man ‘s hat and waterproof.",
	"Bloom uncovers himself but, seeing them, frowns, then smiles, preoccupied.",
	"A door on the return landing is flung open.",
	"A shade of mauve tissuepaper dims the light of the chandelier.",
	"Round and round a moth flies, colliding, escaping.",
	"The floor is covered with an oilcloth mosaic of jade and azure and cinnabar rhomboids.",
	"The walls are tapestried with a paper of yewfronds and clear glades.",
	"In the grate is spread a screen of peacock feathers.",
	"Lynch squats crosslegged on the hearthrug of matted hair, his cap back to the front.",
	"With a wand he beats time slowly.",
	"A tag of her corsetlace hangs slightly below her jacket.",
	"Lynch indicates mockingly the couple at the piano.)",
	"KITTY: (Coughs behind her hand.)",
	"She’s a bit imbecillic.",
	"(She signs with a waggling forefinger.)",
	"Blemblem.",
	"(Lynch lifts up her skirt and white petticoat with the wand.",
	"She settles them down quickly.)",
	"Respect yourself.",
	"(She hiccups, then bends quickly her sailor hat under which her hair glows, red with henna.)",
	"O, excuse!",
	"ZOE: More limelight, Charley.",
	"(She goes to the chandelier and turns the gas full cock.)",
	"KITTY: (Peers at the gasjet.)",
	"What ails it tonight?",
	"LYNCH: (Deeply.)",
	"Enter a ghost and hobgoblins.",
	"ZOE: Clap on the back for Zoe.",
	"(The wand in Lynch’s hand flashes: a brass poker.",
	"Stephen stands at the pianola on which sprawl his hat and ashplant.",
	"With two fingers he repeats once more the series of empty fifths.",
	"A heavy stye droops over her sleepy eyelid.)",
	"KITTY: (Hiccups again with a kick of her horsed foot.)",
	"O, excuse!",
	"ZOE: (Promptly.)",
	"Your boy’s thinking of you.",
	"Tie a knot on your shift.",
	"(Kitty Ricketts bends her head.",
	"Her boa uncoils, slides, glides over her shoulder, back, arm, chair to the ground.",
	"Lynch lifts the curled catterpillar on his wand.",
	"She snakes her neck, nestling.",
	"Stephen glances behind at the squatted figure with its cap back to the front.)",
	"STEPHEN: As a matter of fact it is of no importance whether Benedetto Marcello found it or made it.",
	"The rite is the poet’s rest.",
	"It may be an old hymn to Demeter or also illustrate Cœla enarrant gloriam Domini.",
	"Mais nom de nom, that is another pair of trousers.",
	"Jetez la gourme.",
	"Faut que jeunesse se passe.",
	"(He stops, points at Lynch’s cap, smiles, laughs.)",
	"Which side is your knowledge bump?",
	"THE CAP: (With saturnine spleen.)",
	"Bah!",
	"It is because it is.",
	"Woman’s reason.",
	"Jewgreek is greekjew.",
	"Extremes meet.",
	"Death is the highest form of life.",
	"Bah!",
	"STEPHEN: You remember fairly accurately all my errors, boasts, mistakes.",
	"How long shall I continue to close my eyes to disloyalty?",
	"Whetstone!",
	"THE CAP: Bah!",
	"STEPHEN: Here’s another for you.",
	"(He frowns.)",
	"The reason is because the fundamental and the dominant are separated by the greatest possible interval which...",
	"THE CAP: Which?",
	"Finish.",
	"You can’t.",
	"STEPHEN: (With an effort.)",
	"Interval which.",
	"Is the greatest possible ellipse.",
	"Consistent with.",
	"The ultimate return.",
	"The octave.",
	"Which.",
	"THE CAP: Which?",
	"(Outside the gramophone begins to blare The Holy City.)",
	"STEPHEN: (Abruptly.)",
	"Wait a moment.",
	"Wait a second.",
	"Damn that fellow’s noise in the street.",
	"Self which it itself was ineluctably preconditioned to become.",
	"Ecco!",
	"LYNCH: (With a mocking whinny of laughter grins at Bloom and Zoe Higgins.)",
	"What a learned speech, eh?",
	"ZOE: (Briskly.)",
	"God help your head, he knows more than you have forgotten.",
	"(With obese stupidity Florry Talbot regards Stephen.)",
	"FLORRY: They say the last day is coming this summer.",
	"KITTY: No!",
	"ZOE: (Explodes in laughter.)",
	"Great unjust God!",
	"FLORRY: (Offended.)",
	"Well, it was in the papers about Antichrist.",
	"O, my foot’s tickling.",
	"(Ragged barefoot newsboys, jogging a wagtail kite, patter past, yelling.)",
	"THE NEWSBOYS: Stop press edition.",
	"Result of the rockinghorse races.",
	"Sea serpent in the royal canal.",
	"Safe arrival of Antichrist.",
	"(Stephen turns and sees Bloom.)",
	"STEPHEN: A time, times and half a time.",
	"(Reuben J Antichrist, wandering jew, a clutching hand open on his spine, stumps forward.",
	"Across his loins is slung a pilgrim’s wallet from which protrude promissory notes and dishonoured bills.",
	"ALL: What?",
	"Il vient!",
	"C’est moi!",
	"L’homme qui rit!",
	"L’homme primigène!",
	"(He whirls round and round with dervish howls.)",
	"Sieurs et dames, faites vos jeux!",
	"(He crouches juggling.",
	"Tiny roulette planets fly from his hands.)",
	"Les jeux sont faits!",
	"(The planets rush together, uttering crepitant cracks.)",
	"Rien va plus!",
	"(The planets, buoyant balloons, sail swollen up and away.",
	"He springs off into vacuum.)",
	"FLORRY: (Sinking into torpor, crossing herself secretly.)",
	"The end of the world!",
	"(A female tepid effluvium leaks out from her.",
	"Nebulous obscurity occupies space.",
	"Through the drifting fog without the gramophone blares over coughs and feetshuffling.)",
	"THE GRAMOPHONE: Jerusalem!",
	"Open your gates and sing Hosanna... (A rocket rushes up the sky and bursts.",
	"A white star falls from it, proclaiming the consummation of all things and second coming of Elijah.",
	"THE END OF THE WORLD: (With a Scotch accent.)",
	"Wha’ll dance the keel row, the keel row, the keel row?",
	"(Over the possing drift and choking breathcoughs, Elijah’s voice, harsh as a corncrake’s, jars on high.",
	"He thumps the parapet.)",
	"ELIJAH: No yapping, if you please, in this booth.",
	"Jake Crane, Creole Sue, Dove Campbell, Abe Kirschner, do your coughing with your mouths shut.",
	"Say, I am operating all this trunk line.",
	"Boys, do it now.",
	"God’s time is 12.25.",
	"Tell mother you’ll be there.",
	"Rush your order and you play a slick ace.",
	"Join on right here.",
	"Book through to eternity junction, the nonstop run.",
	"Just one word more.",
	"Are you a god or a doggone clod?",
	"If the second advent came to Coney Island are we ready?",
	"Have we cold feet about the cosmos?",
	"No.",
	"Be on the side of the angels.",
	"Be a prism.",
	"You have that something within, the higher self.",
	"You can rub shoulders with a Jesus, a Gautama, an Ingersoll.",
	"Are you all in this vibration?",
	"I say you are.",
	"You once nobble that, congregation, and a buck joyride to heaven becomes a back number.",
	"You got me?",
	"It’s a lifebrightener, sure.",
	"The hottest stuff ever was.",
	"It’s the whole pie with jam in.",
	"It’s just the cutest snappiest line out.",
	"It is immense, supersumptuous.",
	"It restores.",
	"It vibrates.",
	"I know and I am some vibrator.",
	"Joking apart and, getting down to bedrock, A. J. Christ Dowie and the harmonial philosophy, have you got that?",
	"O. K. Seventyseven west sixtyninth street.",
	"Got me?",
	"That’s it.",
	"You call me up by sunphone any old time.",
	"Bumboosers, save your stamps.",
	"(He shouts.)",
	"Now then our glory song.",
	"All join heartily in the singing.",
	"Encore!",
	"(He sings.)",
	"Jeru...",
	"THE GRAMOPHONE: (Drowning his voice.)",
	"Whorusalaminyourhighhohhhh... (The disc rasps gratingly against the needle.)",
	"THE THREE WHORES: (Covering their ears, squawk.)",
	"Ahhkkk!",
	"ELIJAH: (In rolledup shirtsleeves, black in the face, shouts at the top of his voice, his arms uplifted.)",
	"Big Brother up there, Mr President, you hear what I done just been saying to you.",
	"Certainly, I sort of believe strong in you, Mr President.",
	"I certainly am thinking now Miss Higgins and Miss Ricketts got religion way inside them.",
	"Mr President, you come long and help me save our sisters dear.",
	"(He winks at his audience.)",
	"Our Mr President, he twig the whole lot and he aint saying nothing.",
	"KITTY-KATE: I forgot myself.",
	"In a weak moment I erred and did what I did on Constitution hill.",
	"I was confirmed by the bishop and enrolled in the brown scapular.",
	"My mother’s sister married a Montmorency.",
	"It was a working plumber was my ruination when I was pure.",
	"ZOE-FANNY: I let him larrup it into me for the fun of it.",
	"FLORRY-TERESA: It was in consequence of a portwine beverage on top of Hennessy’s three star.",
	"I was guilty with Whelan when he slipped into the bed.",
	"STEPHEN: In the beginning was the word, in the end the world without end.",
	"Blessed be the eight beatitudes.",
	"THE BEATITUDES: (Incoherently.)",
	"Beer beef battledog buybull businum barnum buggerum bishop.",
	"LYSTER: (In quakergrey kneebreeches and broadbrimmed hat, says discreetly.)",
	"He is our friend.",
	"I need not mention names.",
	"Seek thou the light.",
	"(He corantos by.",
	"Best enters in hairdresser’s attire, shinily laundered, his locks in curlpapers.",
	"He leads John Eglinton who wears a mandarin’s kimono of Nankeen yellow, lizardlettered, and a high pagoda hat.)",
	"I was just beautifying him, don’t you know.",
	"A thing of beauty, don’t you know, Yeats says, or I mean, Keats says.",
	"JOHN EGLINTON: (Produces a greencapped dark lantern and flashes it towards a corner: with carping accent.)",
	"Esthetics and cosmetics are for the boudoir.",
	"I am out for truth.",
	"Plain truth for a plain man.",
	"Tanderagee wants the facts and means to get them.",
	"He rises slowly.",
	"A cold seawind blows from his druid mouth.",
	"About his head writhe eels and elvers.",
	"He is encrusted with weeds and shells.",
	"His right hand holds a bicycle pump.",
	"His left hand grasps a huge crayfish by its two talons.)",
	"MANANAUN MACLIR: (With a voice of waves.)",
	"Aum!",
	"Hek!",
	"Wal!",
	"Ak!",
	"Lub!",
	"Mor!",
	"Ma!",
	"White yoghin of the gods.",
	"Occult pimander of Hermes Trismegistos.",
	"(With a voice of whistling seawind.)",
	"Punarjanam patsypunjaub!",
	"I won’t have my leg pulled.",
	"It has been said by one: beware the left, the cult of Shakti.",
	"(With a cry of stormbirds.)",
	"Shakti Shiva, darkhidden Father!",
	"(He smites with his bicycle pump the crayfish in his left hand.",
	"On its cooperative dial glow the twelve signs of the zodiac.",
	"He wails with the vehemence of the ocean.)",
	"Aum!",
	"Baum!",
	"Pyjaum!",
	"I am the light of the homestead!",
	"I am the dreamery creamery butter.",
	"(A skeleton judashand strangles the light.",
	"The green light wanes to mauve.",
	"The gasjet wails whistling.)",
	"THE GASJET: Pooah!",
	"Pfuiiiiiii!",
	"(Zoe runs to the chandelier and, crooking her leg, adjusts the mantle.)",
	"ZOE: Who has a fag as I’m here?",
	"LYNCH: (Tossing a cigarette on to the table.)",
	"Here.",
	"ZOE: (Her head perched aside in mock pride.)",
	"Is that the way to hand the pot to a lady?",
	"Lynch with his poker lifts boldly a side of her slip.",
	"Bare from her garters up her flesh appears under the sapphire a nixie’s green.",
	"She puffs calmly at her cigarette.)",
	"Can you see the beautyspot of my behind?",
	"LYNCH: I’m not looking ZOE: (Makes sheep’s eyes.)",
	"No?",
	"You wouldn’t do a less thing.",
	"Would you suck a lemon?",
	"Blue fluid again flows over her flesh.",
	"Bloom stands, smiling desirously, twirling his thumbs.",
	"Kitty Ricketts licks her middle finger with her spittle and, gazing in the mirror, smooths both eyebrows.",
	"He is sausaged into several overcoats and wears a brown macintosh under which he holds a roll of parchment.",
	"In his left eye flashes the monocle of Cashel Boyle O’Connor Fitzmaurice Tisdall Farrell.",
	"On his head is perched an Egyptian pshent.",
	"Two quills project over his ears.)",
	"VIRAG: (Heels together, bows.)",
	"My name is Virag Lipoti, of Szombathely.",
	"(He coughs thoughtfully, drily.)",
	"Promiscuous nakedness is much in evidence hereabouts, eh?",
	"The injection mark on the thigh I hope you perceived?",
	"Good.",
	"BLOOM: Granpapachi.",
	"Backbone in front, so to say.",
	"In a word.",
	"Hippogriff.",
	"Am I right?",
	"BLOOM: She is rather lean.",
	"VIRAG: (Not unpleasantly.)",
	"Absolutely!",
	"A new purchase at some monster sale for which a gull has been mulcted.",
	"Meretricious finery to deceive the eye.",
	"Observe the attention to details of dustspecks.",
	"Never put on you tomorrow what you can wear today.",
	"Parallax!",
	"(With a nervous twitch of his head.)",
	"Did you hear my brain go snap?",
	"Pollysyllabax!",
	"BLOOM: (An elbow resting in a hand, a forefinger against his cheek.)",
	"She seems sad.",
	"VIRAG: (Cynically, his weasel teeth bared yellow, draws down his left eye with a finger and barks hoarsely.)",
	"Hoax!",
	"Beware of the flapper and bogus mournful.",
	"Lily of the alley.",
	"All possess bachelor’s button discovered by Rualdus Columbus.",
	"Tumble her.",
	"Columble her.",
	"Chameleon.",
	"(More genially.)",
	"Well then, permit me to draw your attention to item number three.",
	"There is plenty of her visible to the naked eye.",
	"Observe the mass of oxygenated vegetable matter on her skull.",
	"What ho, she bumps!",
	"The ugly duckling of the party, longcasted and deep in keel.",
	"BLOOM: (Regretfully.)",
	"When you come out without your gun.",
	"VIRAG: We can do you all brands, mild, medium and strong.",
	"Pay your money, take your choice.",
	"How happy could you be with either... BLOOM: With...?",
	"VIRAG: (His tongue upcurling.)",
	"Lyum!",
	"Look.",
	"Her beam is broad.",
	"She is coated with quite a considerable layer of fat.",
	"Such fleshy parts are the product of careful nurture.",
	"When coopfattened their livers reach an elephantine size.",
	"That suits your book, eh?",
	"Fleshhotpots of Egypt to hanker after.",
	"Wallow in it.",
	"Lycopodium.",
	"(His throat twitches.)",
	"Slapbang!",
	"There he goes again.",
	"BLOOM: The stye I dislike.",
	"VIRAG: (Arches his eyebrows.)",
	"Contact with a goldring, they say.",
	"Argumentum ad feminam, as we said in old Rome and ancient Greece in the consulship of Diplodocus and Ichthyosauros.",
	"For the rest Eve’s sovereign remedy.",
	"Not for sale.",
	"Hire only.",
	"Huguenot.",
	"(He twitches.)",
	"It is a funny sound.",
	"(He coughs encouragingly.)",
	"But possibly it is only a wart.",
	"I presume you shall have remembered what I will have taught you on that head?",
	"Wheatenmeal with honey and nutmeg.",
	"BLOOM: (Reflecting.)",
	"Wheatenmeal with lycopodium and syllabax.",
	"This searching ordeal.",
	"It has been an unusually fatiguing day, a chapter of accidents.",
	"Wait.",
	"I mean, wartsblood spreads warts, you said... VIRAG: (Severely, his nose hardhumped, his side eye winking.)",
	"Stop twirling your thumbs and have a good old thunk.",
	"See, you have forgotten.",
	"Exercise your mnemotechnic.",
	"La causa è santa.",
	"Tara.",
	"Tara.",
	"(Aside.)",
	"He will surely remember.",
	"BLOOM: Rosemary also did I understand you to say or willpower over parasitic tissues.",
	"Then nay no I have an inkling.",
	"The touch of a deadhand cures.",
	"Mnemo?",
	"VIRAG: (Excitedly.)",
	"I say so.",
	"I say so.",
	"E’en so.",
	"Technic.",
	"(He taps his parchmentroll energetically.)",
	"This book tells you how to act with all descriptive particulars.",
	"Consult index for agitated fear of aconite, melancholy of muriatic, priapic pulsatilla.",
	"Virag is going to talk about amputation.",
	"Our old friend caustic.",
	"They must be starved.",
	"Snip off with horsehair under the denned neck.",
	"(With a dry snigger.)",
	"Pomegranate!",
	"From the sublime to the ridiculous is but a step.",
	"Pyjamas, let us say?",
	"Or stockingette gussetted knickers, closed?",
	"Or, put we the case, those complicated combinations, camiknickers?",
	"(He crows derisively.)",
	"Keekeereekee!",
	"(Bloom surveys uncertainly the three whores then gazes at the veiled mauve light, hearing the everflying moth.)",
	"BLOOM: I wanted then to have now concluded.",
	"Nightdress was never.",
	"Hence this.",
	"But tomorrow is a new day will be.",
	"Past was is today.",
	"What now is will then morrow as now was be past yester.",
	"VIRAG: (Prompts in a pig’s whisper.)",
	"Pretty Poll!",
	"(His yellow parrotbeak gabbles nasally.)",
	"One tablespoonful of honey will attract friend Bruin more than half a dozen barrels of first choice malt vinegar.",
	"Bear’s buzz bothers bees.",
	"But of this apart.",
	"At another time we may resume.",
	"We were very pleased, we others.",
	"(He coughs and, bending his brow, rubs his nose thoughtfully with a scooping hand.)",
	"You shall find that these night insects follow the light.",
	"An illusion for remember their complex unadjustable eye.",
	"Some, to example, there are again whose movements are automatic.",
	"Perceive.",
	"That is his appropriate sun.",
	"Nightbird nightsun nighttown.",
	"Chase me, Charley!",
	"(He blows into Bloom’s ear.)",
	"Buzz!",
	"Splendid!",
	"Spanish fly in his fly or mustard plaster on his dibble.",
	"(He gobbles gluttonously with turkey wattles.)",
	"Bubbly jock!",
	"Bubbly jock!",
	"Where are we?",
	"Open Sesame!",
	"Cometh forth!",
	"(He unrolls his parchment rapidly and reads, his glowworm’s nose running backwards over the letters which he claws.)",
	"Stay, good friend.",
	"I bring thee thy answer.",
	"Redbank oysters will shortly be upon us.",
	"I’m the best o’cook.",
	"Though they stink yet they sting.",
	"(He wags his head with cackling raillery.)",
	"Jocular.",
	"With my eyeglass in my ocular.",
	"(He sneezes.)",
	"Amen!",
	"BLOOM: (Absently.)",
	"Ocularly woman’s bivalve case is worse.",
	"Always open sesame.",
	"The cloven sex.",
	"Why they fear vermin, creeping things.",
	"Yet Eve and the serpent contradicts.",
	"Not a historical fact.",
	"Obvious analogy to my idea.",
	"Serpents too are gluttons for woman’s milk.",
	"Wind their way through miles of omnivorous forest to sucksucculent her breast dry.",
	"Like those bubblyjocular Roman matrons one reads of in Elephantuliasis.",
	"VIRAG: (His mouth projected in hard wrinkles, eyes stonily forlornly closed, psalms in outlandish monotone.)",
	"I beg your pardon.",
	"Ah?",
	"So.",
	"(He repeats.)",
	"Spontaneously to seek out the saurian’s lair in order to entrust their teats to his avid suction.",
	"Ant milks aphis.",
	"(Profoundly.)",
	"Instinct rules the world.",
	"In life.",
	"In death.",
	"Who’s moth moth?",
	"Who’s dear Gerald?",
	"Dear Ger, that you?",
	"O dear, he is Gerald.",
	"O, I much fear he shall be most badly burned.",
	"Will some pleashe pershon not now impediment so catastrophics mit agitation of firstclass tablenumpkin?",
	"(He mews.)",
	"Puss puss puss puss!",
	"(He sighs, draws back and stares sideways down with dropping underjaw.)",
	"Well, well.",
	"He doth rest anon.",
	"(He snaps his jaws suddenly on the air.)",
	"THE MOTH: I’m a tiny tiny thing Ever flying in the spring Round and round a ringaring.",
	"Long ago I was a king Now I do this kind of thing On the wing, on the wing!",
	"Bing!",
	"(He rushes against the mauve shade, flapping noisily.)",
	"Pretty pretty pretty pretty pretty pretty petticoats.",
	"(From left upper entrance with two gliding steps Henry Flower comes forward to left front centre.",
	"He wears a dark mantle and drooping plumed sombrero.",
	"He wears dark velvet hose and silverbuckled pumps.",
	"He has the romantic Saviour’s face with flowing locks, thin beard and moustache.",
	"His spindlelegs and sparrow feet are those of the tenor Mario, prince of Candia.",
	"He settles down his goffered ruffs and moistens his lips with a passage of his amorous tongue.)",
	"HENRY: (In a low dulcet voice, touching the strings of his guitar.)",
	"There is a flower that bloometh.",
	"(Virag truculent, his jowl set, stares at the lamp.",
	"Grave Bloom regards Zoe’s neck.",
	"Henry gallant turns with pendant dewlap to the piano.)",
	"STEPHEN: (To himself.)",
	"Play with your eyes shut.",
	"Imitate pa.",
	"Filling my belly with husks of swine.",
	"Too much of this.",
	"I will arise and go to my.",
	"Expect this is the.",
	"Steve, thou art in a parlous way.",
	"Must visit old Deasy or telegraph.",
	"Our interview of this morning has left on me a deep impression.",
	"Though our ages.",
	"Will write fully tomorrow.",
	"I’m partially drunk, by the way.",
	"(He touches the keys again.)",
	"Minor chord comes now.",
	"Yes.",
	"Not much however.",
	"(Almidano Artifoni holds out a batonroll of music with vigorous moustachework.)",
	"ARTIFONI: Ci rifletta.",
	"Lei rovina tutto.",
	"FLORRY: Sing us something.",
	"Love’s old sweet song.",
	"STEPHEN: No voice.",
	"I am a most finished artist.",
	"Lynch, did I show you the letter about the lute?",
	"FLORRY: (Smirking.)",
	"The bird that can sing and won’t sing.",
	"(The Siamese twins, Philip Drunk and Philip Sober, two Oxford dons with lawnmowers, appear in the window embrasure.",
	"Both are masked with Matthew Arnold’s face.)",
	"PHILIP SOBER: Take a fool’s advice.",
	"All is not well.",
	"Work it out with the buttend of a pencil, like a good young idiot.",
	"Three pounds twelve you got, two notes, one sovereign, two crowns, if youth but knew.",
	"Mooney’s en ville, Mooney’s sur mer, the Moira, Larchet’s, Holles street hospital, Burke’s.",
	"Eh?",
	"I am watching you.",
	"PHILIP DRUNK: (Impatiently.)",
	"Ah, bosh, man.",
	"Go to hell!",
	"I paid my way.",
	"If I could only find out about octaves.",
	"Reduplication of personality.",
	"Who was it told me his name?",
	"(His lawnmower begins to purr.)",
	"Aha, yes.",
	"Zoe mou sas agapo.",
	"Have a notion I was here before.",
	"When was it not Atkinson his card I have somewhere.",
	"Mac Somebody.",
	"Unmack I have it.",
	"He told me about, hold on, Swinburne, was it, no?",
	"FLORRY: And the song?",
	"STEPHEN: Spirit is willing but the flesh is weak.",
	"FLORRY: Are you out of Maynooth?",
	"You’re like someone I knew once.",
	"STEPHEN: Out of it now.",
	"(To himself.)",
	"Clever.",
	"PHILIP DRUNK AND PHILIP SOBER: (Their lawnmowers purring with a rigadoon of grasshalms.)",
	"Clever ever.",
	"Out of it out of it.",
	"By the bye have you the book, the thing, the ashplant?",
	"Yes, there it, yes.",
	"Cleverever outofitnow.",
	"Keep in condition.",
	"Do like us.",
	"You needn’t try to hide, I says to him.",
	"I know you’ve a Roman collar.",
	"VIRAG: Perfectly logical from his standpoint.",
	"Fall of man.",
	"(Harshly, his pupils waxing.)",
	"To hell with the pope!",
	"Nothing new under the sun.",
	"I am the Virag who disclosed the Sex Secrets of Monks and Maidens.",
	"Why I left the church of Rome.",
	"Read the Priest, the Woman and the Confessional.",
	"Penrose.",
	"Flipperty Jippert.",
	"(He wriggles.)",
	"Woman, undoing with sweet pudor her belt of rushrope, offers her allmoist yoni to man’s lingam.",
	"Short time after man presents woman with pieces of jungle meat.",
	"Woman shows joy and covers herself with featherskins.",
	"Man loves her yoni fiercely with big lingam, the stiff one.",
	"(He cries.)",
	"Coactus volui.",
	"Then giddy woman will run about.",
	"Strong man grapses woman’s wrist.",
	"Woman squeals, bites, spucks.",
	"Man, now fierce angry, strikes woman’s fat yadgana.",
	"(He chases his tail.)",
	"Piffpaff!",
	"Popo!",
	"(He stops, sneezes.)",
	"Pchp!",
	"(He worries his butt.)",
	"Prrrrrht!",
	"LYNCH: I hope you gave the good father a penance.",
	"Nine glorias for shooting a bishop.",
	"ZOE: (Spouts walrus smoke through her nostrils.)",
	"He couldn’t get a connection.",
	"Only, you know, sensation.",
	"A dry rush.",
	"BLOOM: Poor man!",
	"ZOE: (Lightly.)",
	"Only for what happened him.",
	"BLOOM: How?",
	"VIRAG: (A diabolic rictus of black luminosity contracting his visage, cranes his scraggy neck forward.",
	"He lifts a mooncalf nozzle and howls.)",
	"Verfluchte Goim!",
	"He had a father, forty fathers.",
	"He never existed.",
	"Pig God!",
	"He had two left feet.",
	"He was Judas Iacchia, a Libyan eunuch, the pope’s bastard.",
	"A son of a whore.",
	"Apocalypse.",
	"PHILIP DRUNK: (Gravely.)",
	"Qui vous a mis dans cette fichue position, Philippe?",
	"PHILIP SOBER: (Gaily.)",
	"C’était le sacré pigeon, Philippe.",
	"(Kitty unpins her hat and sets it down calmly, patting her henna hair.",
	"And a prettier, a daintier head of winsome curls was never seen on a whore’s shoulders.",
	"Lynch puts on her hat.",
	"She whips it off.)",
	"LYNCH: (Laughs.)",
	"And to such delights has Metchnikoff inoculated anthropoid apes.",
	"FLORRY: (Nods.)",
	"Locomotor ataxy.",
	"ZOE: (Gaily.)",
	"O, my dictionary.",
	"LYNCH: Three wise virgins.",
	"VIRAG: (Agueshaken, profuse yellow spawn foaming over his bony epileptic lips.)",
	"She sold lovephiltres, whitewax, orangeflower.",
	"Panther, the Roman centurion, polluted her with his genitories.",
	"(He sticks out a flickering phosphorescent scorpion tongue, his hand on his fork.)",
	"Messiah!",
	"He burst her tympanum.",
	"(With gibbering baboon’s cries he jerks his hips in the cynical spasm.)",
	"Hik!",
	"Hek!",
	"Hak!",
	"Hok!",
	"Huk!",
	"Kok!",
	"Kuk!",
	"BEN DOLLARD: (Nakkering castanet bones in his huge padded paws, yodels jovially in base barreltone.)",
	"When love absorbs my ardent soul.",
	"THE VIRGINS: (Gushingly.)",
	"Big Ben!",
	"Ben my Chree!",
	"A VOICE: Hold that fellow with the bad breeches.",
	"BEN DOLLARD: (Smites his thigh in abundant laughter.)",
	"Hold him now.",
	"HENRY: (Caressing on his breast a severed female head, murmurs.)",
	"Thine heart, mine love.",
	"(He plucks his lutestrings.)",
	"When first I saw... VIRAG: (Sloughing his skins, his multitudinous plumage moulting.)",
	"Rats!",
	"(He yawns, showing a coalblack throat, and closes his jaws by an upward push of his parchmentroll.)",
	"After having said which I took my departure.",
	"Farewell.",
	"Fare thee well.",
	"Dreck!",
	"(Henry Flower combs his moustache and beard rapidly with a pocketcomb and gives a cow’s lick to his hair.",
	"Steered by his rapier, he glides to the door, his wild harp slung behind him.",
	"THE FLYBILL: K. 11.",
	"Post No Bills.",
	"Strictly confidential.",
	"Dr Hy Franks.",
	"HENRY: All is lost now.",
	"(Virag unscrews his head in a trice and holds it under his arm.)",
	"VIRAG’S HEAD: Quack!",
	"(Exeunt severally.)",
	"STEPHEN: (Over his shoulder to Zoe.)",
	"You would have preferred the fighting parson who founded the protestant error.",
	"But beware Antisthenes, the dog sage, and the last end of Arius Heresiarchus.",
	"The agony in the closet.",
	"LYNCH: All one and the same God to her.",
	"STEPHEN: (Devoutly.)",
	"And sovereign Lord of all things.",
	"FLORRY: (To Stephen.)",
	"I’m sure you’re a spoiled priest.",
	"Or a monk.",
	"LYNCH: He is.",
	"A cardinal’s son.",
	"STEPHEN: Cardinal sin.",
	"Monks of the screw.",
	"Seven dwarf simian acolytes, also in red, cardinal sins, uphold his train, peeping under it.",
	"He wears a battered silk hat sideways on his head.",
	"His thumbs are stuck in his armpits and his palms outspread.",
	"Round his neck hangs a rosary of corks ending on his breast in a corkscrew cross.",
	"(He looks at all for a moment, his right eye closed tight, his left cheek puffed out.",
	"(A multitude of midges swarms white over his robe.",
	"He scratches himself with crossed arms at his ribs, grimacing, and exclaims:) I’m suffering the agony of the damned.",
	"By the hoky fiddle, thanks be to Jesus those funny little chaps are not unanimous.",
	"If they were they’d walk me off the face of the bloody globe.",
	"The dwarf acolytes, giggling, peeping, nudging, ogling, Easterkissing, zigzag behind him.",
	"(The trick doorhandle turns.)",
	"THE DOORHANDLE: Theeee!",
	"ZOE: The devil is in that door.",
	"(A male form passes down the creaking staircase and is heard taking the waterproof and hat from the rack.",
	"ZOE: (Sniffs his hair briskly.)",
	"Hmmm!",
	"Thank your mother for the rabbits.",
	"I’m very fond of what I like.",
	"BLOOM: (Hearing a male voice in talk with the whores on the doorstep, pricks his ears.)",
	"If it were he?",
	"After?",
	"Or because not?",
	"Or the double event?",
	"ZOE: (Tears open the silverfoil.)",
	"Fingers was made before forks.",
	"(She breaks off and nibbles a piece, gives a piece to Kitty Ricketts and then turns kittenishly to Lynch.)",
	"No objection to French lozenges?",
	"(He nods.",
	"She taunts him.)",
	"Have it now or wait till you get it?",
	"(He opens his mouth, his head cocked.",
	"She whirls the prize in left circle.",
	"His head follows.",
	"She whirls it back in right circle.",
	"He eyes her.)",
	"Catch!",
	"(She tosses a piece.",
	"With an adroit snap he catches it and bites it through with a crack.)",
	"KITTY: (Chewing.)",
	"The engineer I was with at the bazaar does have lovely ones.",
	"Full of the best liqueurs.",
	"And the viceroy was there with his lady.",
	"The gas we had on the Toft’s hobbyhorses.",
	"I’m giddy still.",
	"Go, go, go, I conjure you, whoever you are!",
	"(A male cough and tread are heard passing through the mist outside.",
	"Bloom’s features relax.",
	"He places a hand in his waistcoat, posing calmly.",
	"Zoe offers him chocolate.)",
	"BLOOM: (Solemnly.)",
	"Thanks.",
	"ZOE: Do as you’re bid.",
	"Here!",
	"(A firm heelclacking tread is heard on the stairs.)",
	"BLOOM: (Takes the chocolate.)",
	"Aphrodisiac?",
	"Tansy and pennyroyal.",
	"But I bought it.",
	"Vanilla calms or?",
	"Mnemo.",
	"Confused light confuses memory.",
	"Red influences lupus.",
	"Colours affect women’s characters, any they have.",
	"This black makes me sad.",
	"Eat and be merry for tomorrow.",
	"(He eats.)",
	"Influence taste too, mauve.",
	"But it is so long since I.",
	"Seems new.",
	"Aphro.",
	"That priest.",
	"Must come.",
	"Better late than never.",
	"Try truffles at Andrews.",
	"(The door opens.",
	"Bella Cohen, a massive whoremistress, enters.",
	"On her left hand are wedding and keeper rings.",
	"Her eyes are deeply carboned.",
	"She has a sprouting moustache.",
	"Her olive face is heavy, slightly sweated and fullnosed with orangetainted nostrils.",
	"She has large pendant beryl eardrops.)",
	"BELLA: My word!",
	"I’m all of a mucksweat.",
	"(She glances round her at the couples.",
	"Then her eyes rest on Bloom with hard insistence.",
	"Her large fan winnows wind towards her heated faceneck and embonpoint.",
	"Her falcon eyes glitter.)",
	"THE FAN: (Flirting quickly, then slowly.)",
	"Married, I see.",
	"BLOOM: Yes.",
	"Partly, I have mislaid...",
	"THE FAN: (Half opening, then closing.)",
	"And the missus is master.",
	"Petticoat government.",
	"BLOOM: (Looks down with a sheepish grin.)",
	"That is so.",
	"THE FAN: (Folding together, rests against her left eardrop.)",
	"Have you forgotten me?",
	"BLOOM: Nes.",
	"Yo.",
	"THE FAN: (Folded akimbo against her waist.)",
	"Is me her was you dreamed before?",
	"Was then she him you us since knew?",
	"Am all them and the same now we?",
	"(Bella approaches, gently tapping with the fan.)",
	"BLOOM: (Wincing.)",
	"Powerful being.",
	"In my eyes read that slumber which women love.",
	"THE FAN: (Tapping.)",
	"We have met.",
	"You are mine.",
	"It is fate.",
	"BLOOM: (Cowed.)",
	"Exuberant female.",
	"Enormously I desiderate your domination.",
	"I am exhausted, abandoned, no more young.",
	"I have felt this instant a twinge of sciatica in my left glutear muscle.",
	"It runs in our family.",
	"Poor dear papa, a widower, was a regular barometer from it.",
	"He believed in animal heat.",
	"A skin of tabby lined his winter waistcoat.",
	"Near the end, remembering king David and the Sunamite, he shared his bed with Athos, faithful after death.",
	"A dog’s spittle as you probably... (He winces.)",
	"Ah!",
	"RICHIE GOULDING: (Bagweighted, passes the door.)",
	"Mocking is catch.",
	"Best value in Dub.",
	"Fit for a prince’s.",
	"Liver and kidney.",
	"THE FAN: (Tapping.)",
	"All things end.",
	"Be mine.",
	"Now.",
	"BLOOM: (Undecided.)",
	"All now?",
	"I should not have parted with my talisman.",
	"Rain, exposure at dewfall on the searocks, a peccadillo at my time of life.",
	"Every phenomenon has a natural cause.",
	"THE FAN: (Points downwards slowly.)",
	"You may.",
	"BLOOM: (Looks downwards and perceives her unfastened bootlace.)",
	"We are observed.",
	"THE FAN: (Points downwards quickly.)",
	"You must.",
	"BLOOM: (With desire, with reluctance.)",
	"I can make a true black knot.",
	"Learned when I served my time and worked the mail order line for Kellett’s.",
	"Experienced hand.",
	"Every knot says a lot.",
	"Let me.",
	"In courtesy.",
	"I knelt once before today.",
	"Ah!",
	"Bloom, stifflegged, aging, bends over her hoof and with gentle fingers draws out and in her laces.)",
	"BLOOM: (Murmurs lovingly.)",
	"THE HOOF: Smell my hot goathide.",
	"Feel my royal weight.",
	"BLOOM: (Crosslacing.)",
	"Too tight?",
	"THE HOOF: If you bungle, Handy Andy, I’ll kick your football for you.",
	"BLOOM: Not to lace the wrong eyelet as I did the night of the bazaar dance.",
	"Bad luck.",
	"Hook in wrong tache of her... person you mentioned.",
	"That night she met... Now!",
	"(He knots the lace.",
	"Bella places her foot on the floor.",
	"Bloom raises his head.",
	"Her heavy face, her eyes strike him in midbrow.",
	"His eyes grow dull, darker and pouched, his nose thickens.)",
	"BLOOM: (Mumbles.)",
	"Awaiting your further orders we remain, gentlemen,... BELLO: (With a hard basilisk stare, in a baritone voice.)",
	"Hound of dishonour!",
	"BLOOM: (Infatuated.)",
	"Empress!",
	"BELLO: (His heavy cheekchops sagging.)",
	"Adorer of the adulterous rump!",
	"BLOOM: (Plaintively.)",
	"Hugeness!",
	"BELLO: Dungdevourer!",
	"BLOOM: (With sinews semiflexed.)",
	"Magmagnificence!",
	"BELLO: Down!",
	"(He taps her on the shoulder with his fan.)",
	"Incline feet forward!",
	"Slide left foot one pace back!",
	"You will fall.",
	"You are falling.",
	"On the hands down!",
	"BLOOM: (Her eyes upturned in the sign of admiration, closing, yaps.)",
	"Truffles!",
	"Footstool!",
	"Feel my entire weight.",
	"Bow, bondslave, before the throne of your despot’s glorious heels so glistening in their proud erectness.",
	"BLOOM: (Enthralled, bleats.)",
	"I promise never to disobey.",
	"BELLO: (Laughs loudly.)",
	"Holy smoke!",
	"You little know what’s in store for you.",
	"I’m the Tartar to settle your little lot and break you in!",
	"I’ll bet Kentucky cocktails all round I shame it out of you, old son.",
	"Cheek me, I dare you.",
	"If you do tremble in anticipation of heel discipline to be inflicted in gym costume.",
	"(Bloom creeps under the sofa and peers out through the fringe.)",
	"ZOE: (Widening her slip to screen her.)",
	"She’s not here.",
	"BLOOM: (Closing her eyes.)",
	"She’s not here.",
	"FLORRY: (Hiding her with her gown.)",
	"She didn’t mean it, Mr Bello.",
	"She’ll be good, sir.",
	"KITTY: Don’t be too hard on her, Mr Bello.",
	"Sure you won’t, ma’amsir.",
	"BELLO: (Coaxingly.)",
	"Come, ducky dear, I want a word with you, darling, just to administer correction.",
	"Just a little heart to heart talk, sweety.",
	"(Bloom puts out her timid head.)",
	"There’s a good girly now.",
	"(Bello grabs her hair violently and drags her forward.)",
	"I only want to correct you for your own good on a soft safe spot.",
	"How’s that tender behind?",
	"O, ever so gently, pet.",
	"Begin to get ready.",
	"BLOOM: (Fainting.)",
	"Don’t tear my... BELLO: (Savagely.)",
	"You’re in for it this time!",
	"I’ll make you remember me for the balance of your natural life.",
	"(His forehead veins swollen, his face congested.)",
	"(He belches.)",
	"And suck my thumping good Stock Exchange cigar while I read the Licensed Victualler’s Gazette.",
	"It will hurt you.",
	"(He twists her arm.",
	"Bloom squeals, turning turtle.)",
	"BLOOM: Don’t be cruel, nurse!",
	"Don’t!",
	"BELLO: (Twisting.)",
	"Another!",
	"BLOOM: (Screams.)",
	"O, it’s hell itself!",
	"Every nerve in my body aches like mad!",
	"BELLO: (Shouts.)",
	"Good, by the rumping jumping general!",
	"That’s the best bit of news I heard these six weeks.",
	"Here, don’t keep me waiting, damn you!",
	"(He slaps her face.)",
	"BLOOM: (Whimpers.)",
	"You’re after hitting me.",
	"I’ll tell... BELLO: Hold him down, girls, till I squat on him.",
	"ZOE: Yes.",
	"Walk on him!",
	"I will.",
	"FLORRY: I will.",
	"Don’t be greedy.",
	"KITTY: No, me.",
	"Lend him to me.",
	"MRS KEOGH: (Ferociously.)",
	"Can I help?",
	"(They hold and pinion Bloom.)",
	"BELLO: (Squats with a grunt on Bloom’s upturned face, puffing cigarsmoke, nursing a fat leg.)",
	"Curse me for a fool that didn’t buy that lot Craig and Gardner told me about.",
	"Just my infernal luck, curse it.",
	"And that Goddamned outsider Throwaway at twenty to one.",
	"(He quenches his cigar angrily on Bloom’s ear.)",
	"Where’s that Goddamned cursed ashtray?",
	"BLOOM: (Goaded, buttocksmothered.)",
	"O!",
	"O!",
	"Monsters!",
	"Cruel one!",
	"BELLO: Ask for that every ten minutes.",
	"Beg.",
	"Pray for it as you never prayed before.",
	"(He thrusts out a figged fist and foul cigar.)",
	"Here, kiss that.",
	"Both.",
	"Kiss.",
	"(He throws a leg astride and, pressing with horseman’s knees, calls in a hard voice.)",
	"Gee up!",
	"A cockhorse to Banbury cross.",
	"I’ll ride him for the Eclipse stakes.",
	"(He bends sideways and squeezes his mount’s testicles roughly, shouting.)",
	"Ho!",
	"Off we pop!",
	"I’ll nurse you in proper fashion.",
	"(He horserides cockhorse, leaping in the, in the saddle.)",
	"FLORRY: (Pulls at Bello.)",
	"Let me on him now.",
	"You had enough.",
	"I asked before you.",
	"ZOE: (Pulling at Florry.)",
	"Me.",
	"Me.",
	"Are you not finished with him yet, suckeress?",
	"BLOOM: (Stifling.)",
	"Can’t.",
	"BELLO: Well, I’m not.",
	"Wait.",
	"(He holds in his breath.)",
	"Curse it.",
	"Here.",
	"This bung’s about burst.",
	"(He uncorks himself behind: then, contorting his features, farts loudly.)",
	"Take that!",
	"(He recorks himself.)",
	"Yes, by Jingo, sixteen three quarters.",
	"BLOOM: (A sweat breaking out over him.)",
	"Not man.",
	"(He sniffs.)",
	"Woman.",
	"BELLO: (Stands up.)",
	"No more blow hot and cold.",
	"What you longed for has come to pass.",
	"Henceforth you are unmanned and mine in earnest, a thing under the yoke.",
	"Now for your punishment frock.",
	"You will shed your male garments, you understand, Ruby Cohen?",
	"and don the shot silk luxuriously rustling over head and shoulders.",
	"And quickly too!",
	"BLOOM: (Shrinks.)",
	"Silk, mistress said!",
	"O crinkly!",
	"scrapy!",
	"Must I tiptouch it with my nails?",
	"BELLO: (Points to his whores.)",
	"As they are now so will you be, wigged, singed, perfumesprayed, ricepowdered, with smoothshaven armpits.",
	"Tape measurements will be taken next your skin.",
	"Alice will feel the pullpull.",
	"I tried her things on only twice, a small prank, in Holles street.",
	"When we were hard up I washed them to save the laundry bill.",
	"My own shirts I turned.",
	"It was the purest thrift.",
	"BELLO: (Jeers.)",
	"Little jobs that make mother pleased, eh?",
	"Ho!",
	"ho!",
	"I have to laugh!",
	"BLOOM: Miriam.",
	"Black.",
	"Demimondaine.",
	"BELLO: (Guffaws.)",
	"Christ Almighty it’s too tickling, this!",
	"(He guffaws again.)",
	"Christ, wouldn’t it make a Siamese cat laugh?",
	"BLOOM: (Her hands and features working.)",
	"It was dear Gerald.",
	"He got that kink, fascinated by sister’s stays.",
	"Now dearest Gerald uses pinky greasepaint and gilds his eyelids.",
	"Cult of the beautiful.",
	"BELLO: (With wicked glee.)",
	"Beautiful!",
	"Give us a breather!",
	"When you took your seat with womanish care, lifting your billowy flounces, on the smoothworn throne.",
	"BLOOM: Science.",
	"To compare the various joys we each enjoy.",
	"(Earnestly.)",
	"And really it’s better the position... because often I used to wet... BELLO: (Sternly.)",
	"No insubordination!",
	"The sawdust is there in the corner for you.",
	"I gave you strict instructions, didn’t I?",
	"Do it standing, sir!",
	"I’ll teach you to behave like a jinkleman!",
	"If I catch a trace on your swaddles.",
	"Aha!",
	"By the ass of the Dorans you’ll find I’m a martinet.",
	"The sins of your past are rising against you.",
	"Many.",
	"Hundreds.",
	"THE SINS OF THE PAST: (In a medley of voices.)",
	"In five public conveniences he wrote pencilled messages offering his nuptial partner to all strongmembered males.",
	"BELLO: (Whistles loudly.)",
	"Say!",
	"What was the most revolting piece of obscenity in all your career of crime?",
	"Go the whole hog.",
	"Puke it out!",
	"Be candid for once.",
	"(Mute inhuman faces throng forward, leering, vanishing, gibbering, Booloohoom.",
	"Our mutual faith.",
	"Pleasants street.",
	"I only thought the half of the...",
	"I swear on my sacred oath... BELLO: (Peremptorily.)",
	"Answer.",
	"Repugnant wretch!",
	"I insist on knowing.",
	"Where?",
	"How?",
	"What time?",
	"With how many?",
	"I give you just three seconds.",
	"One!",
	"Two!",
	"Thr... BLOOM: (Docile, gurgles.)",
	"I rererepugnosed in rerererepugnant... BELLO: (Imperiously.)",
	"O, get out, you skunk!",
	"Hold your tongue!",
	"Speak when you’re spoken to.",
	"BLOOM: (Bows.)",
	"Master!",
	"Mistress!",
	"Mantamer!",
	"(He lifts his arms.",
	"His bangle bracelets fall.)",
	"BELLO: (Satirically.)",
	"Won’t that be nice?",
	"(He places a ruby ring on her finger.)",
	"And there now!",
	"With this ring I thee own.",
	"Say, thank you, mistress.",
	"BLOOM: Thank you, mistress.",
	"Ay, and rinse the seven of them well, mind, or lap it up like champagne.",
	"Drink me piping hot.",
	"Hop!",
	"You’ll be taught the error of your ways.",
	"At night your wellcreamed braceletted hands will wear fortythreebutton gloves newpowdered with talc and having delicately scented fingertips.",
	"For such favours knights of old laid down their lives.",
	"(He chuckles.)",
	"First I’ll have a go at you myself.",
	"Swell the bust.",
	"Smile.",
	"Droop shoulders.",
	"What offers?",
	"(He points.)",
	"For that lot.",
	"Trained by owner to fetch and carry, basket in mouth.",
	"(He bares his arm and plunges it elbowdeep in Bloom’s vulva.)",
	"There’s fine depth for you!",
	"What, boys?",
	"That give you a hardon?",
	"(He shoves his arm in a bidder’s face.)",
	"Here wet the deck and wipe it round!",
	"A BIDDER: A florin.",
	"(Dillon’s lacquey rings his handbell.)",
	"THE LACQUEY: Barang!",
	"A VOICE: One and eightpence too much.",
	"CHARLES ALBERTA MARSH: Must be virgin.",
	"Good breath.",
	"Clean.",
	"BELLO: (Gives a rap with his gavel.)",
	"Two bar.",
	"Rockbottom figure and cheap at the price.",
	"Fourteen hands high.",
	"Touch and examine shis points.",
	"Handle hrim.",
	"This downy skin, these soft muscles, this tender flesh.",
	"If I had only my gold piercer here!",
	"And quite easy to milk.",
	"Three newlaid gallons a day.",
	"A pure stockgetter, due to lay within the hour.",
	"His sire’s milk record was a thousand gallons of whole milk in forty weeks.",
	"Whoa, my jewel!",
	"Beg up!",
	"Whoa!",
	"(He brands his initial C on Bloom’s croup.)",
	"So!",
	"Warranted Cohen!",
	"What advance on two bob, gentlemen?",
	"A DARKVISAGED MAN: (In disguised accent.)",
	"Hoondert punt sterlink.",
	"VOICES: (Subdued.)",
	"For the Caliph.",
	"Haroun Al Raschid.",
	"BELLO: (Gaily.)",
	"Right.",
	"Let them all come.",
	"Bring all your powers of fascination to bear on them.",
	"Pander to their Gomorrahan vices.",
	"BLOOM: (Bends his blushing face into his armpit and simpers with forefinger in mouth.)",
	"O, I know what you’re hinting at now!",
	"BELLO: What else are you good for, an impotent thing like you?",
	"(He stoops and, peering, pokes with his fan rudely under the fat suet folds of Bloom’s haunches.)",
	"Up!",
	"Up!",
	"Manx cat!",
	"What have we here?",
	"Where’s your curly teapot gone to or who docked it on you, cockyolly?",
	"Sing, birdy, sing.",
	"It’s as limp as a boy of six’s doing his pooly behind a cart.",
	"Buy a bucket or sell your pump.",
	"(Loudly.)",
	"Can you do a man’s job?",
	"BLOOM: Eccles street... BELLO: (Sarcastically.)",
	"I wouldn’t hurt your feelings for the world but there’s a man of brawn in possession there.",
	"The tables are turned, my gay young fellow!",
	"He is something like a fullgrown outdoor man.",
	"Well for you, you muff, if you had that weapon with knobs and lumps and warts all over it.",
	"He shot his bolt, I can tell you!",
	"Foot to foot, knee to knee, belly to belly, bubs to breast!",
	"He’s no eunuch.",
	"A shock of red hair he has sticking out of him behind like a furzebush!",
	"Wait for nine months, my lad!",
	"Holy ginger, it’s kicking and coughing up and down in her guts already!",
	"That makes you wild, don’t it?",
	"Touches the spot?",
	"(He spits in contempt.)",
	"Spittoon!",
	"BLOOM: I was indecently treated, I...",
	"Inform the police.",
	"Hundred pounds.",
	"Unmentionable.",
	"I... BELLO: Would if you could, lame duck.",
	"A downpour we want not your drizzle.",
	"BLOOM: To drive me mad!",
	"Moll!",
	"I forgot!",
	"Forgive!",
	"Moll... We...",
	"Still... BELLO: (Ruthlessly.)",
	"Return and see.",
	"(Old Sleepy Hollow calls over the wold.)",
	"SLEEPY HOLLOW: Rip van Wink!",
	"Rip van Winkle!",
	"I see her!",
	"It’s she!",
	"The first night at Mat Dillon’s!",
	"But that dress, the green!",
	"And her hair is dyed gold and he... BELLO: (Laughs mockingly.)",
	"That’s your daughter, you owl, with a Mullingar student.",
	"MILLY: My!",
	"It’s Papli!",
	"But, O Papli, how old you’ve grown!",
	"BELLO: Changed, eh?",
	"Our whatnot, our writingtable where we never wrote, aunt Hegarty’s armchair, our classic reprints of old masters.",
	"A man and his menfriends are living there in clover.",
	"The Cuckoos’ Rest!",
	"Why not?",
	"Blameless dames with parcels of groceries.",
	"Turn about.",
	"Sauce for the goose, my gander O. BLOOM: They...",
	"I... BELLO: (Cuttingly.)",
	"Their heelmarks will stamp the Brusselette carpet you bought at Wren’s auction.",
	"They will violate the secrets of your bottom drawer.",
	"Pages will be torn from your handbook of astronomy to make them pipespills.",
	"And they will spit in your ten shilling brass fender from Hampton Leedom’s.",
	"BLOOM: Ten and six.",
	"The act of low scoundrels.",
	"Let me go.",
	"I will return.",
	"I will prove... A VOICE: Swear!",
	"(Bloom clenches his fists and crawls forward, a bowieknife between his teeth.)",
	"BELLO: As a paying guest or a kept man?",
	"Too late.",
	"You have made your secondbest bed and others must lie in it.",
	"Your epitaph is written.",
	"You are down and out and don’t you forget it, old bean.",
	"BLOOM: Justice!",
	"All Ireland versus one!",
	"Has nobody...?",
	"(He bites his thumb.)",
	"BELLO: Die and be damned to you if you have any sense of decency or grace about you.",
	"I can give you a rare old wine that’ll send you skipping to hell and back.",
	"Sign a will and leave us any coin you have!",
	"If you have none see you damn well get it, steal it, rob it!",
	"(He explodes in a loud phlegmy laugh.)",
	"We’ll manure you, Mr Flower!",
	"(He pipes scoffingly.)",
	"Byby, Poldy!",
	"Byby, Papli!",
	"BLOOM: (Clasps his head.)",
	"My willpower!",
	"Memory!",
	"I have sinned!",
	"I have suff... (He weeps tearlessly.)",
	"BELLO: (Sneers.)",
	"Crybabby!",
	"Crocodile tears!",
	"(Bloom, broken, closely veiled for the sacrifice, sobs, his face to the earth.",
	"The passing bell is heard.",
	"Darkshawled figures of the circumcised, in sackcloth and ashes, stand by the wailing wall.",
	"With swaying arms they wail in pneuma over the recreant Bloom.)",
	"THE CIRCUMCISED: (In dark guttural chant as they cast dead sea fruit upon him, no flowers.)",
	"Shema Israel Adonai Elohenu Adonai Echad.",
	"VOICES: (Sighing.)",
	"So he’s gone.",
	"Ah yes.",
	"Yes, indeed.",
	"Bloom?",
	"Never heard of him.",
	"No?",
	"Queer kind of chap.",
	"There’s the widow.",
	"That so?",
	"Ah, yes.",
	"(From the suttee pyre the flame of gum camphire ascends.",
	"The pall of incense smoke screens and disperses.",
	"THE YEWS: (Their leaves whispering.)",
	"Sister.",
	"Our sister.",
	"Ssh!",
	"THE NYMPH: (Softly.)",
	"Mortal!",
	"(Kindly.)",
	"Nay, dost not weepest!",
	"BLOOM: (Crawls jellily forward under the boughs, streaked by sunlight, with dignity.)",
	"This position.",
	"I felt it was expected of me.",
	"Force of habit.",
	"THE NYMPH: Mortal!",
	"I was hidden in cheap pink paper that smelt of rock oil.",
	"Useful hints to the married.",
	"BLOOM: (Lifts a turtle head towards her lap.)",
	"We have met before.",
	"On another star.",
	"THE NYMPH: (Sadly.)",
	"Rubber goods.",
	"Neverrip brand as supplied to the aristocracy.",
	"Corsets for men.",
	"I cure fits or money refunded.",
	"Unsolicited testimonials for Professor Waldmann’s wonderful chest exuber.",
	"My bust developed four inches in three weeks, reports Mrs Gus Rublin with photo.",
	"BLOOM: You mean Photo Bits?",
	"THE NYMPH: I do.",
	"You bore me away, framed me in oak and tinsel, set me above your marriage couch.",
	"Unseen, one summer eve, you kissed me in four places.",
	"And with loving pencil you shaded my eyes, my bosom and my shame.",
	"BLOOM: (Humbly kisses her long hair.)",
	"THE NYMPH: During dark nights I heard your praise.",
	"BLOOM: (Quickly.)",
	"Yes, yes.",
	"You mean that I... Sleep reveals the worst side of everyone, children perhaps excepted.",
	"I know I fell out of bed or rather was pushed.",
	"Steel wine is said to cure snoring.",
	"For the rest there is that English invention, pamphlet of which I received some days ago, incorrectly addressed.",
	"It claims to afford a noiseless, inoffensive vent.",
	"(He sighs.)",
	"‘Twas ever thus.",
	"Frailty, thy name is marriage.",
	"THE NYMPH: (Her fingers in her ears.)",
	"And words.",
	"They are not in my dictionary.",
	"BLOOM: You understood them?",
	"THE YEWS: Ssh!",
	"THE NYMPH: (Covers her face with her hands.)",
	"What have I not seen in that chamber?",
	"What must my eyes look down on?",
	"BLOOM: (Apologetically.)",
	"I know.",
	"Soiled personal linen, wrong side up with care.",
	"The quoits are loose.",
	"From Gibraltar by long sea long ago.",
	"THE NYMPH: (Bends her head.)",
	"Worse, worse!",
	"BLOOM: (Reflects precautiously.)",
	"That antiquated commode.",
	"It wasn’t her weight.",
	"She scaled just eleven stone nine.",
	"She put on nine pounds after weaning.",
	"It was a crack and want of glue.",
	"Eh?",
	"And that absurd orangekeyed utensil which has only one handle.",
	"(The sound of a waterfall is heard in bright cascade.)",
	"THE WATERFALL: Poulaphouca Poulaphouca Poulaphouca Poulaphouca.",
	"THE YEWS: (Mingling their boughs.)",
	"Listen.",
	"Whisper.",
	"She is right, our sister.",
	"We grew by Poulaphouca waterfall.",
	"We gave shade on languorous summer days.",
	"JOHN WYSE NOLAN: (In the background, in Irish National Forester’s uniform, doffs his plumed hat.)",
	"Prosper!",
	"Give shade on languorous days, trees of Ireland!",
	"THE YEWS: (Murmuring.)",
	"Who came to Poulaphouca with the High School excursion?",
	"Who left his nutquesting classmates to seek our shade?",
	"BLOOM: (Scared.)",
	"High School of Poula?",
	"Mnemo?",
	"Not in full possession of faculties.",
	"Concussion.",
	"Run over by tram.",
	"THE ECHO: Sham!",
	"I was in my teens, a growing boy.",
	"And then the heat.",
	"There were sunspots that summer.",
	"End of school.",
	"And tipsycake.",
	"Halcyon days.",
	"THE HALCYON DAYS: Mackerel!",
	"Live us again.",
	"Hurray!",
	"(They cheer.)",
	"BLOOM: (Hobbledehoy, warmgloved, mammamufflered, starred with spent snowballs, struggles to rise.)",
	"Again!",
	"I feel sixteen!",
	"What a lark!",
	"Let’s ring all the bells in Montague street.",
	"(He cheers feebly.)",
	"Hurray for the High School!",
	"THE ECHO: Fool!",
	"THE YEWS: (Rustling.)",
	"She is right, our sister.",
	"Whisper.",
	"(Whispered kisses are heard in all the wood.",
	"Faces of hamadryads peep out from the boles and among the leaves and break, blossoming into bloom.)",
	"Who profaned our silent shade?",
	"THE NYMPH: (Coyly, through parting fingers.)",
	"There?",
	"In the open air?",
	"THE YEWS: (Sweeping downward.)",
	"Sister, yes.",
	"And on our virgin sward.",
	"THE WATERFALL: Poulaphouca Poulaphouca Phoucaphouca Phoucaphouca.",
	"THE NYMPH: (With wide fingers.)",
	"O, infamy!",
	"BLOOM: I was precocious.",
	"Youth.",
	"The fauna.",
	"I sacrificed to the god of the forest.",
	"The flowers that bloom in the spring.",
	"It was pairing time.",
	"Capillary attraction is a natural phenomenon.",
	"She rolled downhill at Rialto bridge to tempt me with her flow of animal spirits.",
	"She climbed their crooked tree and I... A saint couldn’t resist it.",
	"The demon possessed me.",
	"Besides, who saw?",
	"(Staggering Bob, a whitepolled calf, thrusts a ruminating head with humid nostrils through the foliage.)",
	"STAGGERING BOB: (Large teardrops rolling from his prominent eyes, snivels.)",
	"Me.",
	"Me see.",
	"BLOOM: Simply satisfying a need I... (With pathos.)",
	"No girl would when I went girling.",
	"Too ugly.",
	"They wouldn’t play... (High on Ben Howth through rhododendrons a nannygoat passes, plumpuddered, buttytailed, dropping currants.)",
	"THE NANNYGOAT: (Bleats.)",
	"Megeggaggegg!",
	"Nannannanny!",
	"BLOOM: (Hatless, flushed, covered with burrs of thistledown and gorsespine.)",
	"Regularly engaged.",
	"Circumstances alter cases.",
	"(He gazes intently downwards on the water.)",
	"Thirtytwo head over heels per second.",
	"Press nightmare.",
	"Giddy Elijah.",
	"Fall from cliff.",
	"Sad end of government printer’s clerk.",
	"THE DUMMYMUMMY: Bbbbblllllblblblblobschbg!",
	"COUNCILLOR NANNETTI: (Alone on deck, in dark alpaca, yellowkitefaced, his hand in his waistcoat opening, declaims.)",
	"I have... BLOOM: Done.",
	"Prff!",
	"THE NYMPH: (Loftily.)",
	"We immortals, as you saw today, have not such a place and no hair there either.",
	"We are stonecold and pure.",
	"We eat electric light.",
	"(She arches her body in lascivious crispation, placing her forefinger in her mouth.)",
	"Spoke to me.",
	"Heard from behind.",
	"How then could you...?",
	"BLOOM: (Pawing the heather abjectly.)",
	"O, I have been a perfect pig.",
	"Enemas too I have administered.",
	"One third of a pint of quassia to which add a tablespoonful of rocksalt.",
	"Up the fundament.",
	"With Hamilton Long’s syringe, the ladies’ friend.",
	"THE NYMPH: In my presence.",
	"The powderpuff.",
	"(She blushes and makes a knee.)",
	"And the rest!",
	"BLOOM: (Dejected.)",
	"Yes.",
	"Peccavi!",
	"I have paid homage on that living altar where the back changes name.",
	"(With sudden fervour.)",
	"For why should the dainty scented jewelled hand, the hand that rules...?",
	"(Figures wind serpenting in slow woodland pattern around the treestems, cooeeing.)",
	"THE VOICE OF KITTY: (In the thicket.)",
	"Show us one of them cushions.",
	"THE VOICE OF FLORRY: Here.",
	"(A grouse wings clumsily through the underwood.)",
	"THE VOICE OF LYNCH: (In the thicket.)",
	"Whew!",
	"Piping hot!",
	"THE VOICE OF ZOE: (From the thicket.)",
	"Came from a hot place.",
	"Hot!",
	"Hot!",
	"Ware Sitting Bull!",
	"BLOOM: It overpowers me.",
	"The warm impress of her warm form.",
	"So womanly, full.",
	"It fills me full.",
	"THE WATERFALL: Phillaphulla Poulaphouca Poulaphouca Poulaphouca.",
	"THE YEWS: Ssh!",
	"Sister, speak!",
	"THE NYMPH: (Eyeless, in nun’s white habit, coif and hugewinged wimple, softly, with remote eyes.)",
	"Tranquilla convent.",
	"Sister Agatha.",
	"Mount Carmel.",
	"The apparitions of Knock and Lourdes.",
	"No more desire.",
	"(She reclines her head, sighing.)",
	"Only the ethereal.",
	"Where dreamy creamy gull waves o’er the waters dull.",
	"(Bloom half rises.",
	"His back trouserbutton snaps.)",
	"THE BUTTON: Bip!",
	"(Two sluts of the Coombe dance rainily by, shawled, yelling flatly.)",
	"BLOOM: (Coldly.)",
	"You have broken the spell.",
	"The last straw.",
	"If there were only ethereal where would you all be, postulants and novices?",
	"Shy but willing like an ass pissing.",
	"THE YEWS: (Their silverfoil of leaves precipitating, their skinny arms aging and swaying.)",
	"Deciduously!",
	"THE NYMPH: (Her features hardening, gropes in the folds of her habit.)",
	"Sacrilege!",
	"To attempt my virtue!",
	"(A large moist stain appears on her robe.)",
	"Sully my innocence!",
	"You are not fit to touch the garment of a pure woman.",
	"(She clutches again in her robe.)",
	"Wait.",
	"Satan, you’ll sing no more lovesongs.",
	"Amen.",
	"Amen.",
	"Amen.",
	"Amen.",
	"(She draws a poniard and, clad in the sheathmail of an elected knight of nine, strikes at his loins.)",
	"Nekum!",
	"BLOOM: (Starts up, seizes her hand.)",
	"Hoy!",
	"Nebrakada!",
	"Cat o’ nine lives!",
	"Fair play, madam.",
	"No pruningknife.",
	"The fox and the grapes, is it?",
	"What do you lack with your barbed wire?",
	"Crucifix not thick enough?",
	"(He clutches her veil.)",
	"Poli...!",
	"BLOOM: (Calls after her.)",
	"As if you didn’t get it on the double yourselves.",
	"No jerks and multiple mucosities all over you.",
	"I tried it.",
	"Your strength our weakness.",
	"What’s our studfee?",
	"What will you pay on the nail?",
	"You fee mendancers on the Riviera, I read.",
	"(The fleeing nymph raises a keen.)",
	"Eh?",
	"I have sixteen years of black slave labour behind me.",
	"And would a jury give me five shillings alimony tomorrow, eh?",
	"Fool someone else, not me.",
	"(He sniffs.)",
	"Rut.",
	"Onions.",
	"Stale.",
	"Sulphur.",
	"Grease.",
	"(The figure of Bella Cohen stands before him.)",
	"BELLA: You’ll know me the next time.",
	"BLOOM: (Composed, regards her.)",
	"Passée.",
	"Mutton dressed as lamb.",
	"Long in the tooth and superfluous hair.",
	"A raw onion the last thing at night would benefit your complexion.",
	"And take some double chin drill.",
	"Your eyes are as vapid as the glasseyes of your stuffed fox.",
	"They have the dimensions of your other features, that’s all.",
	"I’m not a triple screw propeller.",
	"BELLA: (Contemptuously.)",
	"You’re not game, in fact.",
	"(Her sowcunt barks.)",
	"Fbhracht!",
	"BLOOM: (Contemptuously.)",
	"Clean your nailless middle finger first, your bully’s cold spunk is dripping from your cockscomb.",
	"Take a handful of hay and wipe yourself.",
	"BELLA: I know you, canvasser!",
	"Dead cod!",
	"BLOOM: I saw him, kipkeeper!",
	"Pox and gleet vendor!",
	"BELLA: (Turns to the piano.)",
	"Which of you was playing the dead march from Saul?",
	"ZOE: Me.",
	"Mind your cornflowers.",
	"(She darts to the piano and bangs chords on it with crossed arms.)",
	"The cat’s ramble through the slag.",
	"(She glances back.)",
	"Eh?",
	"Who’s making love to my sweeties?",
	"(She darts back to the table.)",
	"What’s yours is mine and what’s mine is my own.",
	"(Kitty, disconcerted, coats her teeth with the silver paper.",
	"Bloom approaches Zoe.)",
	"BLOOM: (Gently.)",
	"Give me back that potato, will you?",
	"ZOE: Forfeits, a fine thing and a superfine thing.",
	"BLOOM: (With feeling.)",
	"It is nothing, but still, a relic of poor mamma.",
	"BLOOM: There is a memory attached to it.",
	"I should like to have it.",
	"STEPHEN: To have or not to have that is the question.",
	"ZOE: Here.",
	"Those that hides knows where to find.",
	"BELLA: (Frowns.)",
	"Here.",
	"This isn’t a musical peepshow.",
	"And don’t you smash that piano.",
	"Who’s paying here?",
	"(She goes to the pianola.",
	"Stephen fumbles in his pocket and, taking out a banknote by its corner, hands it to her.)",
	"STEPHEN: (With exaggerated politeness.)",
	"This silken purse I made out of the sow’s ear of the public.",
	"Madam, excuse me.",
	"If you allow me.",
	"(He indicates vaguely Lynch and Bloom.)",
	"We are all in the same sweepstake, Kinch and Lynch.",
	"Dans ce bordel où tenons nostre état.",
	"LYNCH: (Calls from the hearth.)",
	"Dedalus!",
	"Give her your blessing for me.",
	"STEPHEN: (Hands Bella a coin.)",
	"Gold.",
	"She has it.",
	"BELLA: (Looks at the money, then at Stephen, then at Zoe, Florry and Kitty.)",
	"Do you want three girls?",
	"It’s ten shillings here.",
	"STEPHEN: (Delightedly.)",
	"A hundred thousand apologies.",
	"(He fumbles again and takes out and hands her two crowns.)",
	"Permit, brevi manu, my sight is somewhat troubled.",
	"(Bella goes to the table to count the money while Stephen talks to himself in monosyllables.",
	"Zoe bends over the table.",
	"Kitty leans over Zoe’s neck.",
	"Lynch gets up, rights his cap and, clasping Kitty’s waist, adds his head to the group.)",
	"FLORRY: (Strives heavily to rise.)",
	"Ow!",
	"My foot’s asleep.",
	"(She limps over to the table.",
	"Bloom approaches.)",
	"BELLA, ZOE, KITTY, LYNCH, BLOOM: (Chattering and squabbling.)",
	"The gentleman... ten shillings... paying for the three... allow me a moment... this gentleman pays separate... who’s touching it?...",
	"ow!",
	"... mind who you’re pinching... are you staying the night or a short time?...",
	"who did?...",
	"you’re a liar, excuse me... the gentleman paid down like a gentleman... drink... it’s long after eleven.",
	"STEPHEN: (At the pianola, making a gesture of abhorrence.)",
	"No bottles!",
	"What, eleven?",
	"A riddle!",
	"ZOE: (Lifting up her pettigown and folding a half sovereign into the top of her stocking.)",
	"Hard earned on the flat of my back.",
	"LYNCH: (Lifting Kitty from the table.)",
	"Come!",
	"KITTY: Wait.",
	"(She clutches the two crowns.)",
	"FLORRY: And me?",
	"LYNCH: Hoopla!",
	"(He lifts her, carries her and bumps her down on the sofa.)",
	"STEPHEN: The fox crew, the cocks flew, The bells in heaven Were striking eleven.",
	"‘Tis time for her poor soul To get out of heaven.",
	"BLOOM: (Quietly lays a half sovereign on the table between Bella and Florry.)",
	"So.",
	"Allow me.",
	"(He takes up the poundnote.)",
	"Three times ten.",
	"We’re square.",
	"BELLA: (Admiringly.)",
	"You’re such a slyboots, old cocky.",
	"I could kiss you.",
	"ZOE: (Points.)",
	"Him?",
	"Deep as a drawwell.",
	"(Lynch bends Kitty back over the sofa and kisses her.",
	"Bloom goes with the poundnote to Stephen.)",
	"BLOOM: This is yours.",
	"STEPHEN: How is that?",
	"Le distrait or absentminded beggar.",
	"(He fumbles again in his pocket and draws out a handful of coins.",
	"An object falls.)",
	"That fell.",
	"BLOOM: (Stooping, picks up and hands a box of matches.)",
	"This.",
	"STEPHEN: Lucifer.",
	"Thanks.",
	"BLOOM: (Quietly.)",
	"You had better hand over that cash to me to take care of.",
	"Why pay more?",
	"STEPHEN: (Hands him all his coins.)",
	"Be just before you are generous.",
	"BLOOM: I will but is it wise?",
	"(He counts.)",
	"One, seven, eleven, and five.",
	"Six.",
	"Eleven.",
	"I don’t answer for what you may have lost.",
	"STEPHEN: Why striking eleven?",
	"Proparoxyton.",
	"Moment before the next Lessing says.",
	"Thirsty fox.",
	"(He laughs loudly.)",
	"Burying his grandmother.",
	"Probably he killed her.",
	"BLOOM: That is one pound six and eleven.",
	"One pound seven, say.",
	"STEPHEN: Doesn’t matter a rambling damn.",
	"BLOOM: No, but... STEPHEN: (Comes to the table.)",
	"Cigarette, please.",
	"(Lynch tosses a cigarette from the sofa to the table.)",
	"And so Georgina Johnson is dead and married.",
	"(A cigarette appears on the table.",
	"Stephen looks at it.)",
	"Wonder.",
	"Parlour magic.",
	"Married.",
	"Hm.",
	"(He strikes a match and proceeds to light the cigarette with enigmatic melancholy.)",
	"LYNCH: (Watching him.)",
	"You would have a better chance of lighting it if you held the match nearer.",
	"STEPHEN: (Brings the match near his eye.)",
	"Lynx eye.",
	"Must get glasses.",
	"Broke them yesterday.",
	"Sixteen years ago.",
	"Distance.",
	"The eye sees all flat.",
	"(He draws the match away.",
	"It goes out.)",
	"Brain thinks.",
	"Near: far.",
	"Ineluctable modality of the visible.",
	"(He frowns mysteriously.)",
	"Hm.",
	"Sphinx.",
	"The beast that has two backs at midnight.",
	"Married.",
	"ZOE: It was a commercial traveller married her and took her away with him.",
	"FLORRY: (Nods.)",
	"Mr Lambe from London.",
	"STEPHEN: Lamb of London, who takest away the sins of our world.",
	"LYNCH: (Embracing Kitty on the sofa, chants deeply.)",
	"Dona nobis pacem.",
	"(The cigarette slips from Stephen’s fingers.",
	"Bloom picks it up and throws it in the grate.)",
	"BLOOM: Don’t smoke.",
	"You ought to eat.",
	"Cursed dog I met.",
	"(To Zoe.)",
	"You have nothing?",
	"ZOE: Is he hungry?",
	"Hangende Hunger, Fragende Frau, Macht uns alle kaputt.",
	"ZOE: (Tragically.)",
	"Hamlet, I am thy father’s gimlet!",
	"(She takes his hand.)",
	"Blue eyes beauty I’ll read your hand.",
	"(She points to his forehead.)",
	"No wit, no wrinkles.",
	"(She counts.)",
	"Two, three, Mars, that’s courage.",
	"(Stephen shakes his head.)",
	"No kid.",
	"LYNCH: Sheet lightning courage.",
	"The youth who could not shiver and shake.",
	"(To Zoe.)",
	"Who taught you palmistry?",
	"ZOE: (Turns.)",
	"Ask my ballocks that I haven’t got.",
	"(To Stephen.)",
	"I see it in your face.",
	"The eye, like that.",
	"(She frowns with lowered head.)",
	"LYNCH: (Laughing, slaps Kitty behind twice.)",
	"Like that.",
	"Pandybat.",
	"FATHER DOLAN: Any boy want flogging?",
	"Broke his glasses?",
	"Lazy idle little schemer.",
	"See it in your eye.",
	"(Mild, benign, rectorial, reproving, the head of Don John Conmee rises from the pianola coffin.)",
	"DON JOHN CONMEE: Now, Father Dolan!",
	"Now.",
	"I’m sure that Stephen is a very good little boy!",
	"ZOE: (Examining Stephen’s palm.)",
	"Woman’s hand.",
	"STEPHEN: (Murmurs.)",
	"Continue.",
	"Lie.",
	"Hold me.",
	"Caress.",
	"I never could read His handwriting except His criminal thumbprint on the haddock.",
	"ZOE: What day were you born?",
	"STEPHEN: Thursday.",
	"Today.",
	"ZOE: Thursday’s child has far to go.",
	"(She traces lines on his hand.)",
	"Line of fate.",
	"Influential friends.",
	"FLORRY: (Pointing.)",
	"Imagination.",
	"ZOE: Mount of the moon.",
	"You’ll meet with a... (She peers at his hands abruptly.)",
	"I won’t tell you what’s not good for you.",
	"Or do you want to know?",
	"BLOOM: (Detaches her fingers and offers his palm.)",
	"More harm than good.",
	"Here.",
	"Read mine.",
	"BELLA: Show.",
	"(She turns up Bloom’s hand.)",
	"I thought so.",
	"Knobby knuckles for the women.",
	"ZOE: (Peering at Bloom’s palm.)",
	"Gridiron.",
	"Travels beyond the sea and marry money.",
	"BLOOM: Wrong.",
	"ZOE: (Quickly.)",
	"O, I see.",
	"Short little finger.",
	"Henpecked husband.",
	"That wrong?",
	"(Black Liz, a huge rooster hatching in a chalked circle, rises, stretches her wings and clucks.)",
	"BLACK LIZ: Gara.",
	"Klook.",
	"Klook.",
	"Klook.",
	"(She sidles from her newlaid egg and waddles off.)",
	"BLOOM: (Points to his hand.)",
	"That weal there is an accident.",
	"Fell and cut it twentytwo years ago.",
	"I was sixteen.",
	"ZOE: I see, says the blind man.",
	"Tell us news.",
	"STEPHEN: See?",
	"Moves to one great goal.",
	"I am twentytwo.",
	"Sixteen years ago he was twentytwo too.",
	"Sixteen years ago I twentytwo tumbled.",
	"Twentytwo years ago he sixteen fell off his hobbyhorse.",
	"(He winces.)",
	"Hurt my hand somewhere.",
	"Must see a dentist.",
	"Money?",
	"(Zoe whispers to Florry.",
	"They giggle.",
	"Bloom releases his hand and writes idly on the table in backhand, pencilling slow curves.)",
	"FLORRY: What?",
	"Blazes Boylan and Lenehan sprawl swaying on the sideseats.",
	"The Ormond boots crouches behind on the axle.",
	"Sadly over the crossblind Lydia Douce and Mina Kennedy gaze.)",
	"THE BOOTS: (Jogging, mocks them with thumb and wriggling wormfingers.)",
	"Haw haw have you the horn?",
	"(Bronze by gold they whisper.)",
	"ZOE: (To Florry.)",
	"Whisper.",
	"(They whisper again.)",
	"Lenehan in yachtsman’s cap and white shoes officiously detaches a long hair from Blazes Boylan’s coat shoulder.)",
	"LENEHAN: Ho!",
	"What do I here behold?",
	"Were you brushing the cobwebs off a few quims?",
	"BOYLAN: (Sated, smiles.)",
	"Plucking a turkey.",
	"LENEHAN: A good night’s work.",
	"BOYLAN: (Holding up four thick bluntungulated fingers, winks.)",
	"Blazes Kate!",
	"Up to sample or your money back.",
	"(He holds out a forefinger.)",
	"Smell that.",
	"LENEHAN: (Smells gleefully.)",
	"Ah!",
	"Lobster and mayonnaise.",
	"Ah!",
	"ZOE AND FLORRY: (Laugh together.)",
	"Ha ha ha ha.",
	"BOYLAN: (Jumps surely from the car and calls loudly for all to hear.)",
	"Hello, Bloom!",
	"Mrs Bloom dressed yet?",
	"BLOOM: (In flunkey’s prune plush coat and kneebreeches, buff stockings and powdered wig.)",
	"I’m afraid not, sir.",
	"The last articles... BOYLAN: (Tosses him sixpence.)",
	"Here, to buy yourself a gin and splash.",
	"(He hangs his hat smartly on a peg of Bloom’s antlered head.)",
	"Show me in.",
	"I have a little private business with your wife, you understand?",
	"BLOOM: Thank you, sir.",
	"Yes, sir.",
	"Madam Tweedy is in her bath, sir.",
	"MARION: He ought to feel himself highly honoured.",
	"(She plops splashing out of the water.)",
	"Raoul darling, come and dry me.",
	"I’m in my pelt.",
	"Only my new hat and a carriage sponge.",
	"BOYLAN: (A merry twinkle in his eye.)",
	"Topping!",
	"BELLA: What?",
	"What is it?",
	"(Zoe whispers to her.)",
	"MARION: Let him look, the pishogue!",
	"Pimp!",
	"And scourge himself!",
	"BOYLAN: (Clasps himself.)",
	"Here, I can’t hold this little lot much longer.",
	"(He strides off on stiff cavalry legs.)",
	"BELLA: (Laughing.)",
	"Ho ho ho ho.",
	"BOYLAN: (To Bloom, over his shoulder.)",
	"BLOOM: Thank you, sir.",
	"I will, sir.",
	"May I bring two men chums to witness the deed and take a snapshot?",
	"(He holds out an ointment jar.)",
	"Vaseline, sir?",
	"Orangeflower...?",
	"Lukewarm water...?",
	"KITTY: (From the sofa.)",
	"Tell us, Florry.",
	"Tell us.",
	"What... (Florry whispers to her.",
	"Whispering lovewords murmur, liplapping loudly, poppysmic plopslop.)",
	"MINA KENNEDY: (Her eyes upturned.)",
	"O, it must be like the scent of geraniums and lovely peaches!",
	"O, he simply idolises every bit of her!",
	"Stuck together!",
	"Covered with kisses!",
	"LYDIA DOUCE: (Her mouth opening.)",
	"Yumyum.",
	"O, he’s carrying her round the room doing it!",
	"Ride a cockhorse.",
	"You could hear them in Paris and New York.",
	"Like mouthfuls of strawberries and cream.",
	"KITTY: (Laughing.)",
	"Hee hee hee.",
	"BOYLAN’S VOICE: (Sweetly, hoarsely, in the pit of his stomach.)",
	"Ah!",
	"Godblazeqrukbrukarchkrasht!",
	"MARION’S VOICE: (Hoarsely, sweetly, rising to her throat.)",
	"O!",
	"Weeshwashtkissinapooisthnapoohuck?",
	"BLOOM: (His eyes wildly dilated, clasps himself.)",
	"Show!",
	"Hide!",
	"Show!",
	"Plough her!",
	"More!",
	"Shoot!",
	"BELLA, ZOE, FLORRY, KITTY: Ho ho!",
	"Ha ha!",
	"Hee hee!",
	"LYNCH: (Points.)",
	"The mirror up to nature.",
	"(He laughs.)",
	"Hu hu hu hu hu!",
	"(Stephen and Bloom gaze in the mirror.",
	"SHAKESPEARE: (In dignified ventriloquy.)",
	"‘Tis the loud laugh bespeaks the vacant mind.",
	"(To Bloom.)",
	"Thou thoughtest as how thou wastest invisible.",
	"Gaze.",
	"(He crows with a black capon’s laugh.)",
	"Iagogo!",
	"How my Oldfellow chokit his Thursdaymornun.",
	"Iagogogo!",
	"BLOOM: (Smiles yellowly at the three whores.)",
	"When will I hear the joke?",
	"ZOE: Before you’re twice married and once a widower.",
	"BLOOM: Lapses are condoned.",
	"Beneath her skirt appear her late husband’s everyday trousers and turnedup boots, large eights.",
	"She cuffs them on, her streamers flaunting aloft.)",
	"FREDDY: Ah, ma, you’re dragging me along!",
	"SUSY: Mamma, the beeftea is fizzing over!",
	"SHAKESPEARE: (With paralytic rage.)",
	"Weda seca whokilla farst.",
	"(The face of Martin Cunningham, bearded, refeatures Shakespeare’s beardless face.",
	"The marquee umbrella sways drunkenly, the children run aside.",
	"Under the umbrella appears Mrs Cunningham in Merry Widow hat and kimono gown.",
	"She glides sidling and bowing, twirling japanesily.)",
	"MRS CUNNINGHAM: (Sings.)",
	"And they call me the jewel of Asia!",
	"MARTIN CUNNINGHAM: (Gazes on her, impassive.)",
	"Immense!",
	"Most bloody awful demirep!",
	"STEPHEN: Et exaltabuntur cornua iusti.",
	"Queens lay with prize bulls.",
	"Remember Pasiphae for whose lust my grandoldgrossfather made the first confessionbox.",
	"Forget not Madam Grissel Steevens nor the suine scions of the house of Lambert.",
	"And Noah was drunk with wine.",
	"And his ark was open.",
	"BELLA: None of that here.",
	"Come to the wrong shop.",
	"LYNCH: Let him alone.",
	"He’s back from Paris.",
	"ZOE: (Runs to stephen and links him.)",
	"O go on!",
	"Give us some parleyvoo.",
	"LYNCH: (Pommelling on the sofa.)",
	"Rmm Rmm Rmm Rrrrrrmmmmm.",
	"STEPHEN: (Gabbles with marionette jerks.)",
	"Perfectly shocking terrific of religion’s things mockery seen in universal world.",
	"(He clacks his tongue loudly.)",
	"Ho, là là!",
	"Ce pif qu’il a!",
	"LYNCH: Vive le vampire!",
	"THE WHORES: Bravo!",
	"Parleyvoo!",
	"STEPHEN: (Grimacing with head back, laughs loudly, clapping himself.)",
	"Great success of laughing.",
	"Angels much prostitutes like and holy apostles big damn ruffians.",
	"Demimondaines nicely handsome sparkling of diamonds very amiable costumed.",
	"Or do you are fond better what belongs they moderns pleasure turpitude of old mans?",
	"(He points about him with grotesque gestures which Lynch and the whores reply to.)",
	"Caoutchouc statue woman reversible or lifesize tompeeptom of virgins nudities very lesbic the kiss five ten times.",
	"BELLA: (Clapping her belly sinks back on the sofa, with a shout of laughter.)",
	"An omelette on the... Ho!",
	"ho!",
	"ho!",
	"ho!...",
	"omelette on the... STEPHEN: (Mincingly.)",
	"I love you, sir darling.",
	"Speak you englishman tongue for double entente cordiale.",
	"O yes, mon loup.",
	"How much cost?",
	"Waterloo.",
	"Watercloset.",
	"(He ceases suddenly and holds up a forefinger.)",
	"BELLA: (Laughing.)",
	"Omelette...",
	"THE WHORES: (Laughing.)",
	"Encore!",
	"Encore!",
	"STEPHEN: Mark me.",
	"I dreamt of a watermelon.",
	"ZOE: Go abroad and love a foreign lady.",
	"LYNCH: Across the world for a wife.",
	"FLORRY: Dreams goes by contraries.",
	"STEPHEN: (Extends his arms.)",
	"It was here.",
	"Street of harlots.",
	"In Serpentine avenue Beelzebub showed me her, a fubsy widow.",
	"Where’s the red carpet spread?",
	"BLOOM: (Approaching Stephen.)",
	"Look... STEPHEN: No, I flew.",
	"My foes beneath me.",
	"And ever shall be.",
	"World without end.",
	"(He cries.)",
	"Pater!",
	"Free!",
	"BLOOM: I say, look... STEPHEN: Break my spirit, will he?",
	"O merde alors!",
	"(He cries, his vulture talons sharpened.)",
	"Hola!",
	"Hillyho!",
	"(Simon Dedalus’ voice hilloes in answer, somewhat sleepy but ready.)",
	"SIMON: That’s all right.",
	"(He swoops uncertainly through the air, wheeling, uttering cries of heartening, on strong ponderous buzzard wings.)",
	"Ho, boy!",
	"Are you going to win?",
	"Hoop!",
	"Pschatt!",
	"Stable with those halfcastes.",
	"Wouldn’t let them within the bawl of an ass.",
	"Head up!",
	"Keep our flag flying!",
	"An eagle gules volant in a field argent displayed.",
	"Ulster king at arms!",
	"Haihoop!",
	"(He makes the beagle’s call, giving tongue.)",
	"Bulbul!",
	"Burblblburblbl!",
	"Hai, boy!",
	"(The fronds and spaces of the wallpaper file rapidly across country.",
	"The pack of staghounds follows, nose to the ground, sniffing their quarry, beaglebaying, burblbrbling to be blooded.",
	"Ward Union huntsmen and huntswomen live with them, hot for a kill.",
	"The crowd bawls of dicers, crown and anchor players, thimbleriggers, broadsmen.",
	"Crows and touts, hoarse bookies in high wizard hats clamour deafeningly.)",
	"THE CROWD: Card of the races.",
	"Racing card!",
	"Ten to one the field!",
	"Tommy on the clay here!",
	"Tommy on the clay!",
	"Ten to one bar one!",
	"Ten to one bar one!",
	"Try your luck on Spinning Jenny!",
	"Ten to one bar one!",
	"Sell the monkey, boys!",
	"Sell the monkey!",
	"I’ll give ten to one!",
	"Ten to one bar one!",
	"(A dark horse, riderless, bolts like a phantom past the winningpost, his mane moonfoaming, his eyeballs stars.",
	"The field follows, a bunch of bucking mounts.",
	"Dwarfs ride them, rustyarmoured, leaping, leaping in their, in their saddles.",
	"His nag on spavined whitegaitered feet jogs along the rocky road.)",
	"THE ORANGE LODGES: (Jeering.)",
	"Get down and push, mister.",
	"Last lap!",
	"You’ll be home the night!",
	"Per vias rectas!",
	"THE GREEN LODGES: Soft day, sir John!",
	"Soft day, your honour!",
	"(Private Carr, Private Compton and Cissy Caffrey pass beneath the windows, singing in discord.)",
	"STEPHEN: Hark!",
	"Our friend noise in the street.",
	"ZOE: (Holds up her hand.)",
	"Stop!",
	"PRIVATE CARR, PRIVATE COMPTON AND CISSY CAFFREY: Yet I’ve a sort of a Yorkshire relish for... ZOE: That’s me.",
	"(She claps her hands.)",
	"Dance!",
	"Dance!",
	"(She runs to the pianola.)",
	"Who has twopence?",
	"BLOOM: Who’ll...?",
	"LYNCH: (Handing her coins.)",
	"Here.",
	"STEPHEN: (Cracking his fingers impatiently.)",
	"Quick!",
	"Quick!",
	"Where’s my augur’s rod?",
	"(He runs to the piano and takes his ashplant, beating his foot in tripudium.)",
	"ZOE: (Turns the drumhandle.)",
	"There.",
	"(She drops two pennies in the slot.",
	"Gold, pink and violet lights start forth.",
	"The drum turns purring in low hesitation waltz.",
	"ZOE: (Twirls round herself, heeltapping.)",
	"Dance.",
	"Anybody here for there?",
	"Who’ll dance?",
	"Clear the table.",
	"(The pianola with changing lights plays in waltz time the prelude of My Girl’s a Yorkshire Girl.",
	"Stephen throws his ashplant on the table and seizes Zoe round the waist.",
	"Florry and Bella push the table towards the fireplace.",
	"Stephen, arming Zoe with exaggerated grace, begins to waltz her round the room.",
	"Bloom stands aside.",
	"Her sleeve falling from gracing arms, reveals a white fleshflower of vaccination.",
	"Between the curtains Professor Maginni inserts a leg on the toepoint of which spins a silk hat.",
	"With a deft kick he sends it spinning to his crown and jauntyhatted skates in.",
	"In his buttonhole is an immense dahlia.",
	"He twirls in reversed directions a clouded cane, then wedges it tight in his oxter.",
	"He places a hand lightly on his breastbone, bows, and fondles his flower and buttons.)",
	"MAGINNI: The poetry of motion, art of calisthenics.",
	"No connection with Madam Legget Byrne’s or Levenston’s.",
	"Fancy dress balls arranged.",
	"Deportment.",
	"The Katty Lanner step.",
	"So.",
	"Watch me!",
	"My terpsichorean abilities.",
	"(He minuets forward three paces on tripping bee’s feet.)",
	"Tout le monde en avant!",
	"Révérence!",
	"Tout le monde en place!",
	"(The prelude ceases.",
	"Professor Goodwin, beating vague arms shrivels, sinks, his live cape falling about the stool.",
	"The air in firmer waltz time sounds.",
	"Stephen and Zoe circle freely.",
	"The lights change, glow, fade gold rosy violet.)",
	"Nimbly they dance, twirling their skipping ropes.",
	"The hours of noon follow in amber gold.",
	"Laughing, linked, high haircombs flashing, they catch the sun in mocking mirrors, lifting their arms.)",
	"MAGINNI: (Clipclaps glovesilent hands.)",
	"Carré!",
	"Avant deux!",
	"Breathe evenly!",
	"Balance!",
	"(The morning and noon hours waltz in their places, turning, advancing to each other, shaping their curves, bowing visavis.",
	"Cavaliers behind them arch and suspend their arms, with hands descending to, touching, rising from their shoulders.)",
	"HOURS: You may touch my.",
	"CAVALIERS: May I touch your?",
	"HOURS: O, but lightly!",
	"CAVALIERS: O, so lightly!",
	"THE PIANOLA: My little shy little lass has a waist.",
	"(Zoe and Stephen turn boldly with looser swing.",
	"The twilight hours advance from long landshadows, dispersed, lagging, languideyed, their cheeks delicate with cipria and false faint bloom.",
	"They are in grey gauze with dark bat sleeves that flutter in the land breeze.)",
	"MAGINNI: Avant huit!",
	"Traversé!",
	"Salut!",
	"Cours de mains!",
	"Croisé!",
	"(The night hours, one by one, steal to the last place.",
	"Morning, noon and twilight hours retreat before them.",
	"They are masked, with daggered hair and bracelets of dull bells.",
	"Weary they curchycurchy under veils.)",
	"THE BRACELETS: Heigho!",
	"Heigho!",
	"ZOE: (Twirling, her hand to her brow.)",
	"O!",
	"MAGINNI: Les tiroirs!",
	"Chaîne de dames!",
	"La corbeille!",
	"Dos à dos!",
	"(Arabesquing wearily they weave a pattern on the floor, weaving, unweaving, curtseying, twirling, simply swirling.)",
	"ZOE: I’m giddy!",
	"(She frees herself, droops on a chair.",
	"Stephen seizes Florry and turns with her.)",
	"MAGINNI: Boulangère!",
	"Les ronds!",
	"Les ponts!",
	"Chevaux de bois!",
	"Escargots!",
	"(Twining, receding, with interchanging hands the night hours link each each with arching arms in a mosaic of movements.",
	"Stephen and Florry turn cumbrously.)",
	"MAGINNI: Dansez avec vos dames!",
	"Changez de dames!",
	"Donnez le petit bouquet à votre dame!",
	"Remerciez!",
	"THE PIANOLA: Best, best of all, Baraabum!",
	"KITTY: (Jumps up.)",
	"O, they played that on the hobbyhorses at the Mirus bazaar!",
	"(She runs to Stephen.",
	"He leaves Florry brusquely and seizes Kitty.",
	"A screaming bittern’s harsh high whistle shrieks.",
	"Groangrousegurgling Toft’s cumbersome whirligig turns slowly the room right roundabout the room.)",
	"THE PIANOLA: My girl’s a Yorkshire girl.",
	"ZOE: Yorkshire through and through.",
	"Come on all!",
	"(She seizes Florry and waltzes her.)",
	"STEPHEN: Pas seul!",
	"(He wheels Kitty into Lynch’s arms, snatches up his ashplant from the table and takes the floor.",
	"All wheel whirl waltz twirl.",
	"Bloombella Kittylynch Florryzoe jujuby women.",
	"Stephen with hat ashplant frogsplits in middle highkicks with skykicking mouth shut hand clasp part under thigh.",
	"THE PIANOLA: Though she’s a factory lass And wears no fancy clothes.",
	"(Closeclutched swift swifter with glareblareflare scudding they scootlootshoot lumbering by.",
	"Baraabum!)",
	"TUTTI: Encore!",
	"Bis!",
	"Bravo!",
	"Encore!",
	"SIMON: Think of your mother’s people!",
	"STEPHEN: Dance of death.",
	"Baraabum!",
	"On nags hogs bellhorses Gadarene swine Corny in coffin.",
	"Steel shark stone onehandled Nelson two trickies Frauenzimmer plumstained from pram falling bawling.",
	"Gum he’s a champion.",
	"Fuseblue peer from barrel rev.",
	"evensong Love on hackney jaunt Blazes blind coddoubled bicyclers Dilly with snowcake no fancy clothes.",
	"Baraabum!)",
	"(The couples fall aside.",
	"Stephen whirls giddily.",
	"Room whirls back.",
	"Eyes closed he totters.",
	"Red rails fly spacewards.",
	"Stars all around suns turn roundabout.",
	"Bright midges dance on walls.",
	"He stops dead.)",
	"STEPHEN: Ho!",
	"Her hair is scant and lank.",
	"She fixes her bluecircled hollow eyesockets on Stephen and opens her toothless mouth uttering a silent word.",
	"A choir of virgins and confessors sing voicelessly.)",
	"BUCK MULLIGAN: She’s beastly dead.",
	"The pity of it!",
	"Mulligan meets the afflicted mother.",
	"(He upturns his eyes.)",
	"Mercurial Malachi!",
	"THE MOTHER: (With the subtle smile of death’s madness.)",
	"I was once the beautiful May Goulding.",
	"I am dead.",
	"STEPHEN: (Horrorstruck.)",
	"Lemur, who are you?",
	"No.",
	"What bogeyman’s trick is this?",
	"BUCK MULLIGAN: (Shakes his curling capbell.)",
	"The mockery of it!",
	"Kinch dogsbody killed her bitchbody.",
	"She kicked the bucket.",
	"(Tears of molten butter fall from his eyes on to the scone.)",
	"Our great sweet mother!",
	"Epi oinopa ponton.",
	"THE MOTHER: (Comes nearer, breathing upon him softly her breath of wetted ashes.)",
	"All must go through it, Stephen.",
	"More women than men in the world.",
	"You too.",
	"Time will come.",
	"STEPHEN: (Choking with fright, remorse and horror.)",
	"They say I killed you, mother.",
	"He offended your memory.",
	"Cancer did it, not I. Destiny.",
	"THE MOTHER: (A green rill of bile trickling from a side of her mouth.)",
	"You sang that song to me.",
	"Love’s bitter mystery.",
	"STEPHEN: (Eagerly.)",
	"Tell me the word, mother, if you know now.",
	"The word known to all men.",
	"THE MOTHER: Who saved you the night you jumped into the train at Dalkey with Paddy Lee?",
	"Who had pity for you when you were sad among the strangers?",
	"Prayer is allpowerful.",
	"Prayer for the suffering souls in the Ursuline manual and forty days’ indulgence.",
	"Repent, Stephen.",
	"STEPHEN: The ghoul!",
	"Hyena!",
	"THE MOTHER: I pray for you in my other world.",
	"Get Dilly to make you that boiled rice every night after your brainwork.",
	"Years and years I loved you, O, my son, my firstborn, when you lay in my womb.",
	"ZOE: (Fanning herself with the grate fan.)",
	"I’m melting!",
	"FLORRY: (Points to Stephen.)",
	"Look!",
	"He’s white.",
	"BLOOM: (Goes to the window to open it more.)",
	"Giddy.",
	"THE MOTHER: (With smouldering eyes.)",
	"Repent!",
	"O, the fire of hell!",
	"STEPHEN: (Panting.)",
	"His noncorrosive sublimate!",
	"The corpsechewer!",
	"Raw head and bloody bones.",
	"THE MOTHER: (Her face drawing near and nearer, sending out an ashen breath.)",
	"Beware!",
	"(She raises her blackened withered right arm slowly towards Stephen’s breast with outstretched finger.)",
	"Beware God’s hand!",
	"(A green crab with malignant red eyes sticks deep its grinning claws in Stephen’s heart.)",
	"STEPHEN: (Strangled with rage.)",
	"Shite!",
	"(His features grow drawn grey and old.)",
	"BLOOM: (At the window.)",
	"What?",
	"STEPHEN: Ah non, par exemple!",
	"The intellectual imagination!",
	"With me all or not at all.",
	"Non serviam!",
	"FLORRY: Give him some cold water.",
	"Wait.",
	"(She rushes out.)",
	"THE MOTHER: (Wrings her hands slowly, moaning desperately.)",
	"O Sacred Heart of Jesus, have mercy on him!",
	"Save him from hell, O Divine Sacred Heart!",
	"STEPHEN: No!",
	"No!",
	"No!",
	"Break my spirit, all of you, if you can!",
	"I’ll bring you all to heel!",
	"THE MOTHER: (In the agony of her deathrattle.)",
	"Have mercy on Stephen, Lord, for my sake!",
	"Inexpressible was my anguish when expiring with love, grief and agony on Mount Calvary.",
	"STEPHEN: Nothung!",
	"(He lifts his ashplant high with both hands and smashes the chandelier.",
	"Time’s livid final flame leaps and, in the following darkness, ruin of all space, shattered glass and toppling masonry.)",
	"THE GASJET: Pwfungg!",
	"BLOOM: Stop!",
	"LYNCH: (Rushes forward and seizes Stephen’s hand.)",
	"Here!",
	"Hold on!",
	"Don’t run amok!",
	"BELLA: Police!",
	"BELLA: (Screams.)",
	"After him!",
	"(The two whores rush to the halldoor.",
	"Lynch and Kitty and Zoe stampede from the room.",
	"They talk excitedly.",
	"Bloom follows, returns.)",
	"THE WHORES: (Jammed in the doorway, pointing.)",
	"Down there.",
	"ZOE: (Pointing.)",
	"There.",
	"There’s something up.",
	"BELLA: Who pays for the lamp?",
	"(She seizes Bloom’s coattail.)",
	"Here, you were with him.",
	"The lamp’s broken.",
	"BLOOM: (Rushes to the hall, rushes back.)",
	"What lamp, woman?",
	"A WHORE: He tore his coat.",
	"BELLA: (Her eyes hard with anger and cupidity, points.)",
	"Who’s to pay for that?",
	"Ten shillings.",
	"You’re a witness.",
	"BLOOM: (Snatches up Stephen’s ashplant.)",
	"Me?",
	"Ten shillings?",
	"Haven’t you lifted enough off him?",
	"Didn’t he...?",
	"BELLA: (Loudly.)",
	"Here, none of your tall talk.",
	"This isn’t a brothel.",
	"A ten shilling house.",
	"BLOOM: (His head under the lamp, pulls the chain.",
	"Pulling, the gasjet lights up a crushed mauve purple shade.",
	"He raises the ashplant.)",
	"Only the chimney’s broken.",
	"Here is all he... BELLA: (Shrinks back and screams.)",
	"Jesus!",
	"Don’t!",
	"BLOOM: (Warding off a blow.)",
	"To show you how he hit the paper.",
	"There’s not sixpenceworth of damage done.",
	"Ten shillings!",
	"FLORRY: (With a glass of water, enters.)",
	"Where is he?",
	"BELLA: Do you want me to call the police?",
	"BLOOM: O, I know.",
	"Bulldog on the premises.",
	"But he’s a Trinity student.",
	"Patrons of your establishment.",
	"Gentlemen that pay the rent.",
	"(He makes a masonic sign.)",
	"Know what I mean?",
	"Nephew of the vicechancellor.",
	"You don’t want a scandal.",
	"BELLA: (Angrily.)",
	"Trinity.",
	"Coming down here ragging after the boatraces and paying nothing.",
	"Are you my commander here or?",
	"Where is he?",
	"I’ll charge him!",
	"Disgrace him, I will!",
	"(_She shouts_.)",
	"Zoe!",
	"Zoe!",
	"BLOOM: (Urgently.)",
	"And if it were your own son in Oxford?",
	"(Warningly.)",
	"I know.",
	"BELLA: (Almost speechless.)",
	"Who are.",
	"Incog!",
	"ZOE: (In the doorway.)",
	"There’s a row on.",
	"BLOOM: What?",
	"Where?",
	"(He throws a shilling on the table and starts.)",
	"That’s for the chimney.",
	"Where?",
	"I need mountain air.",
	"(He hurries out through the hall.",
	"The whores point.",
	"Florry follows, spilling water from her tilted tumbler.",
	"On the doorstep all the whores clustered talk volubly, pointing to the right where the fog has cleared off.",
	"From the left arrives a jingling hackney car.",
	"It slows to in front of the house.",
	"Bloom at the halldoor perceives Corny Kelleher who is about to dismount from the car with two silent lechers.",
	"He averts his face.",
	"Bella from within the hall urges on her whores.",
	"They blow ickylickysticky yumyum kisses.",
	"Corny Kelleher replies with a ghastly lewd smile.",
	"The silent lechers turn to pay the jarvey.",
	"Zoe and Kitty still point right.",
	"Bloom, parting them swiftly, draws his caliph’s hood and poncho and hurries down the steps with sideways face.",
	"The ashplant marks his stride.",
	"He walks, runs, zigzags, gallops, lugs laid back.",
	"He is pelted with gravel, cabbagestumps, biscuitboxes, eggs, potatoes, dead codfish, woman’s slipperslappers.",
	"THE HUE AND CRY: (Helterskelterpelterwelter.)",
	"He’s Bloom!",
	"Stop Bloom!",
	"Stopabloom!",
	"Stopperrobber!",
	"Hi!",
	"Hi!",
	"Stophim on the corner!",
	"hi!",
	"row and wrangle round the whowhat brawlaltogether.)",
	"STEPHEN: (With elaborate gestures, breathing deeply and slowly.)",
	"You are my guests.",
	"Uninvited.",
	"By virtue of the fifth of George and seventh of Edward.",
	"History to blame.",
	"Fabled by mothers of memory.",
	"PRIVATE CARR: (To Cissy Caffrey.)",
	"Was he insulting you?",
	"STEPHEN: Addressed her in vocative feminine.",
	"Probably neuter.",
	"Ungenitive.",
	"VOICES: No, he didn’t.",
	"I seen him.",
	"The girl there.",
	"He was in Mrs Cohen’s.",
	"What’s up?",
	"Soldier and civilian.",
	"But I’m faithful to the man that’s treating me though I’m only a shilling whore.",
	"STEPHEN: (Catches sight of Lynch’s and Kitty’s heads.)",
	"Hail, Sisyphus.",
	"(He points to himself and the others.)",
	"Poetic.",
	"Uropoetic.",
	"VOICES: Shes faithfultheman.",
	"CISSY CAFFREY: Yes, to go with him.",
	"And me with a soldier friend.",
	"PRIVATE COMPTON: He doesn’t half want a thick ear, the blighter.",
	"Biff him one, Harry.",
	"PRIVATE CARR: (To Cissy.)",
	"Was he insulting you while me and him was having a piss?",
	"LORD TENNYSON: (Gentleman poet in Union Jack blazer and cricket flannels, bareheaded, flowingbearded.)",
	"Theirs not to reason why.",
	"PRIVATE COMPTON: Biff him, Harry.",
	"STEPHEN: (To Private Compton.)",
	"I don’t know your name but you are quite right.",
	"Doctor Swift says one man in armour will beat ten men in their shirts.",
	"Shirt is synechdoche.",
	"Part for the whole.",
	"CISSY CAFFREY: (To the crowd.)",
	"No, I was with the privates.",
	"STEPHEN: (Amiably.)",
	"Why not?",
	"The bold soldier boy.",
	"In my opinion every lady for example...",
	"PRIVATE CARR: (His cap awry, advances to Stephen.)",
	"Say, how would it be, governor, if I was to bash in your jaw?",
	"STEPHEN: (Looks up to the sky.)",
	"How?",
	"Very unpleasant.",
	"Noble art of selfpretence.",
	"Personally, I detest action.",
	"(He waves his hand.)",
	"Hand hurts me slightly.",
	"Enfin ce sont vos oignons.",
	"(To Cissy Caffrey.)",
	"Some trouble is on here.",
	"What is it precisely?",
	"DOLLY GRAY: (From her balcony waves her handkerchief, giving the sign of the heroine of Jericho.)",
	"Rahab.",
	"Cook’s son, goodbye.",
	"Safe home to Dolly.",
	"Dream of the girl you left behind and she will dream of you.",
	"(The soldiers turn their swimming eyes.)",
	"BLOOM: (Elbowing through the crowd, plucks Stephen’s sleeve vigorously.)",
	"Come now, professor, that carman is waiting.",
	"STEPHEN: (Turns.)",
	"Eh?",
	"(He disengages himself.)",
	"Why should I not speak to him or to any human being who walks upright upon this oblate orange?",
	"(He points his finger.)",
	"I’m not afraid of what I can talk to if I see his eye.",
	"Retaining the perpendicular.",
	"(He staggers a pace back.)",
	"BLOOM: (Propping him.)",
	"Retain your own.",
	"STEPHEN: (Laughs emptily.)",
	"My centre of gravity is displaced.",
	"I have forgotten the trick.",
	"Let us sit down somewhere and discuss.",
	"(He taps his brow.)",
	"But in here it is I must kill the priest and the king.",
	"BIDDY THE CLAP: Did you hear what the professor said?",
	"He’s a professor out of the college.",
	"CUNTY KATE: I did.",
	"I heard that.",
	"BIDDY THE CLAP: He expresses himself with such marked refinement of phraseology.",
	"CUNTY KATE: Indeed, yes.",
	"And at the same time with such apposite trenchancy.",
	"PRIVATE CARR: (Pulls himself free and comes forward.)",
	"What’s that you’re saying about my king?",
	"(Edward the Seventh appears in an archway.",
	"He sucks a red jujube.",
	"He is robed as a grand elect perfect and sublime mason with trowel and apron, marked made in Germany.",
	"In his left hand he holds a plasterer’s bucket on which is printed Défense d’uriner.",
	"A roar of welcome greets him.)",
	"EDWARD THE SEVENTH: (Slowly, solemnly but indistinctly.)",
	"Peace, perfect peace.",
	"For identification, bucket in my hand.",
	"Cheerio, boys.",
	"(He turns to his subjects.)",
	"Mahak makar a bak.",
	"(He shakes hands with Private Carr, Private Compton, Stephen, Bloom and Lynch.",
	"General applause.",
	"Edward the Seventh lifts his bucket graciously in acknowledgment.)",
	"PRIVATE CARR: (To Stephen.)",
	"Say it again.",
	"STEPHEN: (Nervous, friendly, pulls himself up.)",
	"I understand your point of view though I have no king myself for the moment.",
	"This is the age of patent medicines.",
	"A discussion is difficult down here.",
	"But this is the point.",
	"You die for your country.",
	"Suppose.",
	"(He places his arm on Private Carr’s sleeve.)",
	"Not that I wish it for you.",
	"But I say: Let my country die for me.",
	"Up to the present it has done so.",
	"I didn’t want it to die.",
	"Damn death.",
	"Long live life!",
	"My methods are new and are causing surprise.",
	"To make the blind see I throw dust in their eyes.",
	"STEPHEN: Kings and unicorns!",
	"(He falls back a pace.)",
	"Come somewhere and we’ll... What was that girl saying?...",
	"PRIVATE COMPTON: Eh, Harry, give him a kick in the knackers.",
	"Stick one into Jerry.",
	"BLOOM: (To the privates, softly.)",
	"He doesn’t know what he’s saying.",
	"Taken a little more than is good for him.",
	"Absinthe.",
	"Greeneyed monster.",
	"I know him.",
	"He’s a gentleman, a poet.",
	"It’s all right.",
	"STEPHEN: (Nods, smiling and laughing.)",
	"Gentleman, patriot, scholar and judge of impostors.",
	"PRIVATE CARR: I don’t give a bugger who he is.",
	"PRIVATE COMPTON: We don’t give a bugger who he is.",
	"STEPHEN: I seem to annoy them.",
	"Green rag to a bull.",
	"(Kevin Egan of Paris in black Spanish tasselled shirt and peep-o’-day boy’s hat signs to Stephen.)",
	"KEVIN EGAN: H’lo!",
	"Bonjour!",
	"The vieille ogresse with the dents jaunes.",
	"(Patrice Egan peeps from behind, his rabbitface nibbling a quince leaf.)",
	"PATRICE: Socialiste!",
	"Werf those eykes to footboden, big grand porcos of johnyellows todos covered of gravy!",
	"BLOOM: (To Stephen.)",
	"Come home.",
	"You’ll get into trouble.",
	"STEPHEN: (Swaying.)",
	"I don’t avoid it.",
	"He provokes my intelligence.",
	"BIDDY THE CLAP: One immediately observes that he is of patrician lineage.",
	"THE VIRAGO: Green above the red, says he.",
	"Wolfe Tone.",
	"THE BAWD: The red’s as good as the green.",
	"And better.",
	"Up the soldiers!",
	"Up King Edward!",
	"A ROUGH: (Laughs.)",
	"Ay!",
	"Hands up to De Wet.",
	"THE CITIZEN: (With a huge emerald muffler and shillelagh, calls.)",
	"THE CROPPY BOY: (The ropenoose round his neck, gripes in his issuing bowels with both hands.)",
	"I bear no hate to a living thing, But I love my country beyond the king.",
	"RUMBOLD, DEMON BARBER: (Accompanied by two blackmasked assistants, advances with gladstone bag which he opens.)",
	"Ladies and gents, cleaver purchased by Mrs Pearcy to slay Mogg.",
	"Phial containing arsenic retrieved from body of Miss Barron which sent Seddon to the gallows.",
	"(He jerks the rope.",
	"The assistants leap at the victim’s legs and drag him downward, grunting: the croppy boy’s tongue protrudes violently.)",
	"THE CROPPY BOY: Horhot ho hray hor hother’s hest.",
	"(He gives up the ghost.",
	"A violent erection of the hanged sends gouts of sperm spouting through his deathclothes on to the cobblestones.",
	"RUMBOLD: I’m near it myself.",
	"(He undoes the noose.)",
	"Rope which hanged the awful rebel.",
	"Ten shillings a time.",
	"As applied to Her Royal Highness.",
	"My painful duty has now been done.",
	"God save the king!",
	"EDWARD THE SEVENTH: (Dances slowly, solemnly, rattling his bucket, and sings with soft contentment.)",
	"On coronation day, on coronation day, O, won’t we have a merry time, Drinking whisky, beer and wine!",
	"PRIVATE CARR: Here.",
	"What are you saying about my king?",
	"STEPHEN: (Throws up his hands.)",
	"O, this is too monotonous!",
	"Nothing.",
	"He wants my money and my life, though want must be his master, for some brutish empire of his.",
	"Money I haven’t.",
	"(He searches his pockets vaguely.)",
	"Gave it to someone.",
	"PRIVATE CARR: Who wants your bleeding money?",
	"STEPHEN: (Tries to move off.)",
	"Will someone tell me where I am least likely to meet these necessary evils?",
	"Ça se voit aussi à Paris.",
	"Not that I...",
	"But, by Saint Patrick...!",
	"(The women’s heads coalesce.",
	"STEPHEN: Aha!",
	"I know you, gammer!",
	"Hamlet, revenge!",
	"The old sow that eats her farrow!",
	"OLD GUMMY GRANNY: (Rocking to and fro.)",
	"Ireland’s sweetheart, the king of Spain’s daughter, alanna.",
	"Strangers in my house, bad manners to them!",
	"(She keens with banshee woe.)",
	"Ochone!",
	"Ochone!",
	"Silk of the kine!",
	"(She wails.)",
	"You met with poor old Ireland and how does she stand?",
	"STEPHEN: How do I stand you?",
	"The hat trick!",
	"Where’s the third person of the Blessed Trinity?",
	"Soggarth Aroon?",
	"The reverend Carrion Crow.",
	"CISSY CAFFREY: (Shrill.)",
	"Stop them from fighting!",
	"A ROUGH: Our men retreated.",
	"PRIVATE CARR: (Tugging at his belt.)",
	"I’ll wring the neck of any fucker says a word against my fucking king.",
	"BLOOM: (Terrified.)",
	"He said nothing.",
	"Not a word.",
	"A pure misunderstanding.",
	"THE CITIZEN: Erin go bragh!",
	"(Major Tweedy and the Citizen exhibit to each other medals, decorations, trophies of war, wounds.",
	"Both salute with fierce hostility.)",
	"PRIVATE COMPTON: Go it, Harry.",
	"Do him one in the eye.",
	"He’s a proboer.",
	"STEPHEN: Did I?",
	"When?",
	"BLOOM: (To the redcoats.)",
	"We fought for you in South Africa, Irish missile troops.",
	"Isn’t that history?",
	"Royal Dublin Fusiliers.",
	"Honoured by our monarch.",
	"THE NAVVY: (Staggering past.)",
	"O, yes!",
	"O God, yes!",
	"O, make the kwawr a krowawr!",
	"O!",
	"Bo!",
	"(Casqued halberdiers in armour thrust forward a pentice of gutted spearpoints.",
	"He gives the pilgrim warrior’s sign of the knights templars.)",
	"MAJOR TWEEDY: (Growls gruffly.)",
	"Rorke’s Drift!",
	"Up, guards, and at them!",
	"Mahar shalal hashbaz.",
	"PRIVATE CARR: I’ll do him in.",
	"PRIVATE COMPTON: (Waves the crowd back.)",
	"Fair play, here.",
	"Make a bleeding butcher’s shop of the bugger.",
	"(Massed bands blare Garryowen and God save the King.)",
	"CISSY CAFFREY: They’re going to fight.",
	"For me!",
	"CUNTY KATE: The brave and the fair.",
	"BIDDY THE CLAP: Methinks yon sable knight will joust it with the best.",
	"CUNTY KATE: (Blushing deeply.)",
	"Nay, madam.",
	"The gules doublet and merry saint George for me!",
	"STEPHEN: The harlot’s cry from street to street Shall weave Old Ireland’s windingsheet.",
	"PRIVATE CARR: (Loosening his belt, shouts.)",
	"I’ll wring the neck of any fucking bastard says a word against my bleeding fucking king.",
	"BLOOM: (Shakes Cissy Caffrey’s shoulders.)",
	"Speak, you!",
	"Are you struck dumb?",
	"You are the link between nations and generations.",
	"Speak, woman, sacred lifegiver!",
	"CISSY CAFFREY: (Alarmed, seizes Private Carr’s sleeve.)",
	"Amn’t I with you?",
	"Amn’t I your girl?",
	"Cissy’s your girl.",
	"(She cries.)",
	"Police!",
	"STEPHEN: (Ecstatically, to Cissy Caffrey.)",
	"White thy fambles, red thy gan And thy quarrons dainty is.",
	"VOICES: Police!",
	"DISTANT VOICES: Dublin’s burning!",
	"Dublin’s burning!",
	"On fire, on fire!",
	"(Brimstone fires spring up.",
	"Dense clouds roll past.",
	"Heavy Gatling guns boom.",
	"Pandemonium.",
	"Troops deploy.",
	"Gallop of hoofs.",
	"Artillery.",
	"Hoarse commands.",
	"Bells clang.",
	"Backers shout.",
	"Drunkards bawl.",
	"Whores screech.",
	"Foghorns hoot.",
	"Cries of valour.",
	"Shrieks of dying.",
	"Pikes clash on cuirasses.",
	"Thieves rob the slain.",
	"The midnight sun is darkened.",
	"The earth trembles.",
	"A chasm opens with a noiseless yawn.",
	"He is followed by a race of runners and leapers.",
	"In wild attitudes they spring from the brink.",
	"Their bodies plunge.",
	"Factory lasses with fancy clothes toss redhot Yorkshire baraabombs.",
	"Society ladies lift their skirts above their heads to protect themselves.",
	"Laughing witches in red cutty sarks ride through the air on broomsticks.",
	"Quakerlyster plasters blisters.",
	"It rains dragons’ teeth.",
	"Armed heroes spring up from furrows.",
	"On an eminence, the centre of the earth, rises the fieldaltar of Saint Barbara.",
	"Black candles rise from its gospel and epistle horns.",
	"From the high barbacans of the tower two shafts of light fall on the smokepalled altarstone.",
	"On the altarstone Mrs Mina Purefoy, goddess of unreason, lies, naked, fettered, a chalice resting on her swollen belly.",
	"FATHER MALACHI O’FLYNN: Introibo ad altare diaboli.",
	"THE REVEREND MR HAINES LOVE: To the devil which hath made glad my young days.",
	"FATHER MALACHI O’FLYNN: (Takes from the chalice and elevates a blooddripping host.)",
	"Corpus meum.",
	"My body.",
	"THE VOICE OF ALL THE DAMNED: Htengier Tnetopinmo Dog Drol eht rof, Aiulella!",
	"(From on high the voice of Adonai calls.)",
	"ADONAI: Dooooooooooog!",
	"THE VOICE OF ALL THE BLESSED: Alleluia, for the Lord God Omnipotent reigneth!",
	"(From on high the voice of Adonai calls.)",
	"ADONAI: Goooooooooood!",
	"PRIVATE CARR: (With ferocious articulation.)",
	"I’ll do him in, so help me fucking Christ!",
	"I’ll wring the bastard fucker’s bleeding blasted fucking windpipe!",
	"(The retriever, nosing on the fringe of the crowd, barks noisily.)",
	"OLD GUMMY GRANNY: (Thrusts a dagger towards Stephen’s hand.)",
	"Remove him, acushla.",
	"At 8.35 a.m. you will be in heaven and Ireland will be free.",
	"(She prays.)",
	"O good God, take him!",
	"BLOOM: (Runs to Lynch.)",
	"Can’t you get him away?",
	"LYNCH: He likes dialectic, the universal language.",
	"Kitty!",
	"(To Bloom.)",
	"Get him away, you.",
	"He won’t listen to me.",
	"(He drags Kitty away.)",
	"STEPHEN: (Points.)",
	"Exit Judas.",
	"Et laqueo se suspendit.",
	"BLOOM: (Runs to Stephen.)",
	"Come along with me now before worse happens.",
	"Here’s your stick.",
	"STEPHEN: Stick, no.",
	"Reason.",
	"This feast of pure reason.",
	"CISSY CAFFREY: (Pulling Private Carr.)",
	"Come on, you’re boosed.",
	"He insulted me but I forgive him.",
	"(Shouting in his ear.)",
	"I forgive him for insulting me.",
	"BLOOM: (Over Stephen’s shoulder.)",
	"Yes, go.",
	"You see he’s incapable.",
	"PRIVATE CARR: (Breaks loose.)",
	"I’ll insult him.",
	"(He rushes towards Stephen, fist outstretched, and strikes him in the face.",
	"Stephen totters, collapses, falls, stunned.",
	"He lies prone, his face to the sky, his hat rolling to the wall.",
	"Bloom follows and picks it up.)",
	"MAJOR TWEEDY: (Loudly.)",
	"Carbine in bucket!",
	"Cease fire!",
	"Salute!",
	"THE RETRIEVER: (Barking furiously.)",
	"Ute ute ute ute ute ute ute ute.",
	"THE CROWD: Let him up!",
	"Don’t strike him when he’s down!",
	"Air!",
	"Who?",
	"The soldier hit him.",
	"He’s a professor.",
	"Is he hurted?",
	"Don’t manhandle him!",
	"He’s fainted!",
	"A HAG: What call had the redcoat to strike the gentleman and he under the influence.",
	"Let them go and fight the Boers!",
	"THE BAWD: Listen to who’s talking!",
	"Hasn’t the soldier a right to go with his girl?",
	"He gave him the coward’s blow.",
	"(They grab at each other’s hair, claw at each other and spit.)",
	"THE RETRIEVER: (Barking.)",
	"Wow wow wow.",
	"BLOOM: (Shoves them back, loudly.)",
	"Get back, stand back!",
	"PRIVATE COMPTON: (Tugging his comrade.)",
	"Here.",
	"Bugger off, Harry.",
	"Here’s the cops!",
	"(Two raincaped watch, tall, stand in the group.)",
	"FIRST WATCH: What’s wrong here?",
	"PRIVATE COMPTON: We were with this lady.",
	"And he insulted us.",
	"And assaulted my chum.",
	"(The retriever barks.)",
	"Who owns the bleeding tyke?",
	"CISSY CAFFREY: (With expectation.)",
	"Is he bleeding!",
	"A MAN: (Rising from his knees.)",
	"No.",
	"Gone off.",
	"He’ll come to all right.",
	"BLOOM: (Glances sharply at the man.)",
	"Leave him to me.",
	"I can easily... SECOND WATCH: Who are you?",
	"Do you know him?",
	"PRIVATE CARR: (Lurches towards the watch.)",
	"He insulted my lady friend.",
	"BLOOM: (Angrily.)",
	"You hit him without provocation.",
	"I’m a witness.",
	"Constable, take his regimental number.",
	"SECOND WATCH: I don’t want your instructions in the discharge of my duty.",
	"PRIVATE COMPTON: (Pulling his comrade.)",
	"Here, bugger off Harry.",
	"Or Bennett’ll shove you in the lockup.",
	"PRIVATE CARR: (Staggering as he is pulled away.)",
	"God fuck old Bennett.",
	"He’s a whitearsed bugger.",
	"I don’t give a shit for him.",
	"FIRST WATCH: (Takes out his notebook.)",
	"What’s his name?",
	"BLOOM: (Peering over the crowd.)",
	"I just see a car there.",
	"If you give me a hand a second, sergeant... FIRST WATCH: Name and address.",
	"(Corny Kelleher, weepers round his hat, a death wreath in his hand, appears among the bystanders.)",
	"BLOOM: (Quickly.)",
	"O, the very man!",
	"(He whispers.)",
	"Simon Dedalus’ son.",
	"A bit sprung.",
	"Get those policemen to move those loafers back.",
	"SECOND WATCH: Night, Mr Kelleher.",
	"CORNY KELLEHER: (To the watch, with drawling eye.)",
	"That’s all right.",
	"I know him.",
	"Won a bit on the races.",
	"Gold cup.",
	"Throwaway.",
	"(He laughs.)",
	"Twenty to one.",
	"Do you follow me?",
	"FIRST WATCH: (Turns to the crowd.)",
	"Here, what are you all gaping at?",
	"Move on out of that.",
	"(The crowd disperses slowly, muttering, down the lane.)",
	"CORNY KELLEHER: Leave it to me, sergeant.",
	"That’ll be all right.",
	"(He laughs, shaking his head.)",
	"We were often as bad ourselves, ay or worse.",
	"What?",
	"Eh, what?",
	"FIRST WATCH: (Laughs.)",
	"I suppose so.",
	"CORNY KELLEHER: (Nudges the second watch.)",
	"Come and wipe your name off the slate.",
	"(He lilts, wagging his head.)",
	"With my tooraloom tooraloom tooraloom tooraloom.",
	"What, eh, do you follow me?",
	"SECOND WATCH: (Genially.)",
	"Ah, sure we were too.",
	"CORNY KELLEHER: (Winking.)",
	"Boys will be boys.",
	"I’ve a car round there.",
	"SECOND WATCH: All right, Mr Kelleher.",
	"Good night.",
	"CORNY KELLEHER: I’ll see to that.",
	"BLOOM: (Shakes hands with both of the watch in turn.)",
	"Thank you very much, gentlemen.",
	"Thank you.",
	"(He mumbles confidentially.)",
	"We don’t want any scandal, you understand.",
	"Father is a wellknown highly respected citizen.",
	"Just a little wild oats, you understand.",
	"FIRST WATCH: O. I understand, sir.",
	"SECOND WATCH: That’s all right, sir.",
	"FIRST WATCH: It was only in case of corporal injuries I’d have to report it at the station.",
	"BLOOM: (Nods rapidly.)",
	"Naturally.",
	"Quite right.",
	"Only your bounden duty.",
	"SECOND WATCH: It’s our duty.",
	"CORNY KELLEHER: Good night, men.",
	"THE WATCH: (Saluting together.)",
	"Night, gentlemen.",
	"(They move off with slow heavy tread.)",
	"BLOOM: (Blows.)",
	"Providential you came on the scene.",
	"You have a car?...",
	"CORNY KELLEHER: (Laughs, pointing his thumb over his right shoulder to the car brought up against the scaffolding.)",
	"Two commercials that were standing fizz in Jammet’s.",
	"Like princes, faith.",
	"One of them lost two quid on the race.",
	"Drowning his grief.",
	"And were on for a go with the jolly girls.",
	"So I landed them up on Behan’s car and down to nighttown.",
	"BLOOM: I was just going home by Gardiner street when I happened to... CORNY KELLEHER: (Laughs.)",
	"Sure they wanted me to join in with the mots.",
	"No, by God, says I.",
	"Not for old stagers like myself and yourself.",
	"(He laughs again and leers with lacklustre eye.)",
	"Thanks be to God we have it in the house, what, eh, do you follow me?",
	"Hah, hah, hah!",
	"BLOOM: (Tries to laugh.)",
	"He, he, he!",
	"Yes.",
	"THE HORSE: Hohohohohohoh!",
	"Hohohohome!",
	"(He laughs.)",
	"Sober hearsedrivers a speciality.",
	"Will I give him a lift home?",
	"Where does he hang out?",
	"Somewhere in Cabra, what?",
	"BLOOM: No, in Sandycove, I believe, from what he let drop.",
	"(Stephen, prone, breathes to the stars.",
	"Corny Kelleher, asquint, drawls at the horse.",
	"Bloom, in gloom, looms down.)",
	"CORNY KELLEHER: (Scratches his nape.)",
	"Sandycove!",
	"(He bends down and calls to Stephen.)",
	"Eh!",
	"(He calls again.)",
	"Eh!",
	"He’s covered with shavings anyhow.",
	"Take care they didn’t lift anything off him.",
	"BLOOM: No, no, no.",
	"I have his money and his hat here and stick.",
	"CORNY KELLEHER: Ah, well, he’ll get over it.",
	"No bones broken.",
	"Well, I’ll shove along.",
	"(He laughs.)",
	"I’ve a rendezvous in the morning.",
	"Burying the dead.",
	"Safe home!",
	"THE HORSE: (Neighs.)",
	"Hohohohohome.",
	"BLOOM: Good night.",
	"The horse harness jingles.)",
	"CORNY KELLEHER: (From the car, standing.)",
	"Night.",
	"BLOOM: Night.",
	"(The jarvey chucks the reins and raises his whip encouragingly.",
	"The car and horse back slowly, awkwardly, and turn.",
	"Corny Kelleher on the sideseat sways his head to and fro in sign of mirth at Bloom’s plight.",
	"The jarvey joins in the mute pantomimic merriment nodding from the farther seat.",
	"Bloom shakes his head in mute mirthful reply.",
	"With a slow nod Bloom conveys his gratitude as that is exactly what Stephen needs.",
	"The car jingles tooraloom round the corner of the tooraloom lane.",
	"Corny Kelleher again reassuralooms with his hand.",
	"Bloom with his hand assuralooms Corny Kelleher that he is reassuraloomtay.",
	"The tinkling hoofs and jingling harness grow fainter with their tooralooloo looloo lay.",
	"Bloom, holding in his hand Stephen’s hat, festooned with shavings, and ashplant, stands irresolute.",
	"Then he bends to him and shakes him by the shoulder.)",
	"BLOOM: Eh!",
	"Ho!",
	"(There is no answer; he bends again.)",
	"Mr Dedalus!",
	"(There is no answer.)",
	"The name if you call.",
	"Somnambulist.",
	"(He bends again and, hesitating, brings his mouth near the face of the prostrate form.)",
	"Stephen!",
	"(There is no answer.",
	"He calls again.)",
	"Stephen!",
	"STEPHEN: (Groans.)",
	"Who?",
	"Black panther.",
	"Vampire.",
	"(He sighs and stretches himself, then murmurs thickly with prolonged vowels.)",
	"Who... drive... Fergus now And pierce... wood’s woven shade?...",
	"(He turns on his left side, sighing, doubling himself together.)",
	"BLOOM: Poetry.",
	"Well educated.",
	"Pity.",
	"(He bends again and undoes the buttons of Stephen’s waistcoat.)",
	"To breathe.",
	"(He brushes the woodshavings from Stephen’s clothes with light hand and fingers.)",
	"One pound seven.",
	"Not hurt anyhow.",
	"(He listens.)",
	"What?",
	"STEPHEN: (Murmurs.)",
	"... shadows... the woods ... white breast... dim sea.",
	"(He stretches out his arms, sighs again and curls his body.",
	"Bloom, holding the hat and ashplant, stands erect.",
	"A dog barks in the distance.",
	"Bloom tightens and loosens his grip on the ashplant.",
	"He looks down on Stephen’s face and form.)",
	"BLOOM: (Communes with the night.)",
	"Face reminds me of his poor mother.",
	"In the shady wood.",
	"The deep white breast.",
	"Ferguson, I think I caught.",
	"A girl.",
	"Some girl.",
	"Best thing could happen him.",
	"(He murmurs.)...",
	"swear that I will always hail, ever conceal, never reveal, any part or parts, art or arts... (He murmurs.)...",
	"He reads from right to left inaudibly, smiling, kissing the page.)",
	"BLOOM: (Wonderstruck, calls inaudibly.)",
	"Rudy!",
	"RUDY: (Gazes, unseeing, into Bloom’s eyes and goes on reading, kissing, smiling.",
	"He has a delicate mauve face.",
	"On his suit he has diamond and ruby buttons.",
	"In his free left hand he holds a slim ivory cane with a violet bowknot.",
	"A white lambkin peeps out of his waistcoat pocket.)",
	"But how to get there was the rub.",
	"And that one was Judas, Stephen said, who up to then had said nothing whatsoever of any kind.",
	"To avoid a meeting he drew nearer to the pillars of the railway bridge.",
	"Someone saluted you, Mr Bloom said.",
	"A figure of middle height on the prowl evidently under the arches saluted again, calling: Night!",
	"Stephen of course started rather dizzily and stopped to return the compliment.",
	"Lord John Corley some called him and his genealogy came about in this wise.",
	"Taking Stephen on one side he had the customary doleful ditty to tell.",
	"Not as much as a farthing to purchase a night’s lodgings.",
	"His friends had all deserted him.",
	"Anyhow he was all in.",
	"I wouldn’t ask you only, pursued he, on my solemn oath and God knows I’m on the rocks.",
	"Mr Garrett Deasy.",
	"Try it.",
	"You may mention my name.",
	"Ah, God, Corley replied, sure I couldn’t teach in a school, man.",
	"I was never one of your bright ones, he added with a half laugh.",
	"I got stuck twice in the junior at the christian brothers.",
	"I have no place to sleep myself, Stephen informed him.",
	"He was starving too though he hadn’t said a word about it.",
	"Whereas.",
	"A few broken biscuits were all the result of his investigation.",
	"He was altogether too fagged out to institute a thorough search though he tried to recollect.",
	"About biscuits he dimly remembered.",
	"Who now exactly gave them he wondered or where was or did he buy.",
	"Those are halfcrowns, man, Corley corrected him.",
	"And so in point of fact they turned out to be.",
	"Stephen anyhow lent him one of them.",
	"Thanks, Corley answered, you’re a gentleman.",
	"I’ll pay you back one time.",
	"Who’s that with you?",
	"I saw him a few times in the Bleeding Horse in Camden street with Boylan, the billsticker.",
	"You might put in a good word for us to get me taken on there.",
	"God, you’ve to book ahead, man, you’d think it was for the Carl Rosa.",
	"I don’t give a shite anyway so long as I get a job, even as a crossing sweeper.",
	"Pretty thick that was certainly.",
	"Alluding to the encounter he said, laughingly, Stephen, that is: He is down on his luck.",
	"Now you mention it his face was familiar to me.",
	"Half a crown, Stephen responded.",
	"I daresay he needs it to sleep somewhere.",
	"Needs!",
	"Everyone according to his needs or everyone according to his deeds.",
	"But, talking about things in general, where, added he with a smile, will you sleep yourself?",
	"Walking to Sandycove is out of the question.",
	"And even supposing you did you won’t get in after what occurred at Westland Row station.",
	"Simply fag out there for nothing.",
	"To seek misfortune, was Stephen’s answer.",
	"Where does he live at present?",
	"I gathered in the course of conversation that he had moved.",
	"I believe he is in Dublin somewhere, Stephen answered unconcernedly.",
	"Why?",
	"He takes great pride, quite legitimate, out of you.",
	"Of course you didn’t notice as much as I did.",
	"Puttana madonna, che ci dia i quattrini!",
	"Ho ragione?",
	"Culo rotto!",
	"Intendiamoci.",
	"Mezzo sovrano più... —Dice lui, però!",
	"Mezzo.",
	"Farabutto!",
	"Mortacci sui!",
	"Ma ascolta!",
	"Accordingly his first act was with characteristic sangfroid to order these commodities quietly.",
	"I mean for singing purposes.",
	"Why do you not write your poetry in that language?",
	"Bella Poetria!",
	"It is so melodious and full.",
	"Belladonna.",
	"Voglio.",
	"They were haggling over money.",
	"Is that so?",
	"Mr Bloom asked.",
	"Sounds are impostures, Stephen said after a pause of some little time, like names.",
	"Cicero, Podmore, Napoleon, Mr Goodbody.",
	"Jesus, Mr Doyle.",
	"Shakespeares were as common as Murphies.",
	"What’s in a name?",
	"Yes, to be sure, Mr Bloom unaffectedly concurred.",
	"Of course.",
	"Our name was changed too, he added, pushing the socalled roll across.",
	"You know Simon Dedalus?",
	"he asked at length.",
	"I’ve heard of him, Stephen said.",
	"Mr Bloom was all at sea for a moment, seeing the others evidently eavesdropping too.",
	"He’s Irish, the seaman bold affirmed, staring still in much the same way and nodding.",
	"All Irish.",
	"All too Irish, Stephen rejoined.",
	"The lefthand dead shot.",
	"Bottles out there, say.",
	"Fifty yards measured.",
	"Eggs on the bottles.",
	"Cocks his gun over his shoulder.",
	"Aims.",
	"He turned his body half round, shut up his right eye completely.",
	"Pom!",
	"he then shouted once.",
	"The entire audience waited, anticipating an additional detonation, there being still a further egg.",
	"Pom!",
	"he shouted twice.",
	"Beg pardon, the sailor said.",
	"Long ago?",
	"Mr Bloom pursued without flinching a hairsbreadth.",
	"He toured the wide world with Hengler’s Royal Circus.",
	"I seen him do that in Stockholm.",
	"Curious coincidence, Mr Bloom confided to Stephen unobtrusively.",
	"Murphy’s my name, the sailor continued.",
	"D. B. Murphy of Carrigaloe.",
	"Know where that is?",
	"Queenstown harbour, Stephen replied.",
	"That’s right, the sailor said.",
	"Fort Camden and Fort Carlisle.",
	"That’s where I hails from.",
	"I belongs there.",
	"That’s where I hails from.",
	"My little woman’s down there.",
	"She’s waiting for me, I know.",
	"For England, home and beauty.",
	"She’s my own true wife I haven’t seen for seven years now, sailing about.",
	"Across the world for a wife.",
	"Never about the runaway wife coming back, however much devoted to the absentee.",
	"The face at the window!",
	"You little expected me but I’ve come to stay and make a fresh start.",
	"There she sits, a grasswidow, at the selfsame fireside.",
	"Believes me dead, rocked in the cradle of the deep.",
	"No chair for father.",
	"Broo!",
	"The wind!",
	"Her brandnew arrival is on her knee, post mortem child.",
	"With a high ro!",
	"and a randy ro!",
	"and my galloping tearing tandy, O!",
	"Bow to the inevitable.",
	"Grin and bear it.",
	"I remain with much love your brokenhearted husband D B Murphy.",
	"Thank you, the sailor said.",
	"The threemaster Rosevean from Bridgwater with bricks.",
	"I shipped to get over.",
	"Paid off this afternoon.",
	"There’s my discharge.",
	"See?",
	"D. B. Murphy.",
	"A.",
	"You must have seen a fair share of the world, the keeper remarked, leaning on the counter.",
	"Why, the sailor answered upon reflection upon it, I’ve circumnavigated a bit since I first joined on.",
	"I was in the Red Sea.",
	"I was in China and North America and South America.",
	"We was chased by pirates one voyage.",
	"I seen icebergs plenty, growlers.",
	"I seen Russia.",
	"Gospodi pomilyou.",
	"That’s how the Russians prays.",
	"You seen queer sights, don’t be talking, put in a jarvey.",
	"Why, the sailor said, shifting his partially chewed plug.",
	"I seen queer things too, ups and downs.",
	"I seen a crocodile bite the fluke of an anchor same as I chew that quid.",
	"He took out of his mouth the pulpy quid and, lodging it between his teeth, bit ferociously: Khaan!",
	"Like that.",
	"And I seen maneaters in Peru that eats corpses and the livers of horses.",
	"Look here.",
	"Here they are.",
	"A friend of mine sent me.",
	"The printed matter on it stated: Choza de Indios.",
	"Beni, Bolivia.",
	"Chews coca all day, the communicative tarpaulin added.",
	"Stomachs like breadgraters.",
	"Cuts off their diddies when they can’t bear no more children.",
	"See them sitting there stark ballocknaked eating a dead horse’s liver raw.",
	"His postcard proved a centre of attraction for Messrs the greenhorns for several minutes if not more.",
	"Know how to keep them off?",
	"he inquired generally.",
	"Nobody volunteering a statement he winked, saying: Glass.",
	"That boggles ‘em.",
	"Glass.",
	"Mr Bloom, without evincing surprise, unostentatiously turned over the card to peruse the partially obliterated address and postmark.",
	"It ran as follows: Tarjeta Postal, Señor A Boudin, Galeria Becche, Santiago, Chile.",
	"There was no message evidently, as he took particular notice.",
	"But who?",
	"That was the rub.",
	"Brown, Robinson and Co.",
	"He turned back the other side of the card, picture, and passed it along to Stephen.",
	"One was a ship, another was a house, another was a flower.",
	"Cooks rats in your soup, he appetisingly added, the chinks does.",
	"Possibly perceiving an expression of dubiosity on their faces the globetrotter went on, adhering to his adventures.",
	"And I seen a man killed in Trieste by an Italian chap.",
	"Knife in his back.",
	"Knife like that.",
	"In a knockingshop it was count of a tryon between two smugglers.",
	"Fellow hid behind a door, come up behind him.",
	"Like that.",
	"Prepare to meet your God, says he.",
	"Chuk!",
	"It went into his back up to the butt.",
	"That’s a good bit of steel, repeated he, examining his formidable stiletto.",
	"Funny, very!",
	"There ensued a somewhat lengthy pause.",
	"Mr Bloom, so far as he was personally concerned, was just pondering in pensive mood.",
	"Ay, boss, the sailor broke in.",
	"Give us back them papers.",
	"The request being complied with he clawed them up with a scrape.",
	"Have you seen the rock of Gibraltar?",
	"Mr Bloom inquired.",
	"The sailor grimaced, chewing, in a way that might be read as yes, ay or no.",
	"What year would that be about?",
	"Mr B interrogated.",
	"Can you recall the boats?",
	"Salt junk all the time.",
	"Tired seemingly, he ceased.",
	"And it left him wondering why.",
	"And the odds were twenty to nil there was really no secret about it at all.",
	"Them are his trousers I’ve on me and he gave me an oilskin and that jackknife.",
	"I’m game for that job, shaving and brushup.",
	"I hate roaming about.",
	"What age is he?",
	"Why, the sailor answered with a slow puzzled utterance, my son, Danny?",
	"He’d be about eighteen now, way I figure it.",
	"There was lice in that bunk in Bridgwater, he remarked, sure as nuts.",
	"I must get a wash tomorrow or next day.",
	"It’s them black lads I objects to.",
	"I hate those buggers.",
	"Suck your blood dry, they does.",
	"Tattoo, the exhibitor explained.",
	"That was done when we were Iying becalmed off Odessa in the Black Sea under Captain Dalton.",
	"Fellow, the name of Antonio, done that.",
	"There he is himself, a Greek.",
	"Did it hurt much doing it?",
	"one asked the sailor.",
	"That worthy, however, was busily engaged in collecting round the.",
	"Someway in his.",
	"Squeezing or.",
	"See here, he said, showing Antonio.",
	"There he is cursing the mate.",
	"Ay, ay, sighed the sailor, looking down on his manly chest.",
	"He’s gone too.",
	"Ate by sharks after.",
	"Ay, ay.",
	"He let go of the skin so that the profile resumed the normal expression of before.",
	"Neat bit of work, one longshoreman said.",
	"And what’s the number for?",
	"loafer number two queried.",
	"Eaten alive?",
	"a third asked the sailor.",
	"Ate.",
	"A Greek he was.",
	"and begged the chance of his washing.",
	"Also why washing which seemed rather vague than not, your washing.",
	"The gunboat, the keeper said.",
	"Unfortunate creature!",
	"Of course I suppose some man is ultimately responsible for her condition.",
	"Fear not them that sell the body but have not power to buy the soul.",
	"She is a bad merchant.",
	"She buys dear and sells cheap.",
	"You as a good catholic, he observed, talking of body and soul, believe in the soul.",
	"Otherwise we would never have such inventions as X rays, for instance.",
	"Do you?",
	"I shouldn’t think that is the proper word.",
	"Has been?",
	"the more experienced of the two objected, sticking to his original point with a smile of unbelief.",
	"I’m not so sure about that.",
	"Can’t you drink that coffee, by the way?",
	"Let me stir it.",
	"And take a piece of that bun.",
	"It’s like one of our skipper’s bricks disguised.",
	"Still no-one can give what he hasn’t got.",
	"Try a bit.",
	"Couldn’t, Stephen contrived to get out, his mental organs for the moment refusing to dictate further.",
	"Have a shot at it now, he ventured to say of the coffee after being stirred.",
	"You ought to eat more solid food.",
	"You would feel a different man.",
	"Liquids I can eat, Stephen said.",
	"But O, oblige me by taking away that knife.",
	"I can’t look at the point of it.",
	"It reminds me of Roman history.",
	"Our mutual friend’s stories are like himself, Mr Bloom apropos of knives remarked to his confidante sotto voce.",
	"Do you think they are genuine?",
	"He could spin those yarns for hours on end all night long and lie like old boots.",
	"Look at him.",
	"Mind you, I’m not saying that it’s all a pure invention, he resumed.",
	"Analogous scenes are occasionally, if not often, met with.",
	"Giants, though that is rather a far cry, you see once in a way, Marcella the midget queen.",
	"There’s an example again of simple souls.",
	"It comes from the great heat, climate generally.",
	"My wife is, so to speak, Spanish, half that is.",
	"Point of fact she could actually claim Spanish nationality if she wanted, having been born in (technically) Spain, i.e.",
	"Gibraltar.",
	"She has the Spanish type.",
	"Quite dark, regular brunette, black.",
	"I for one certainly believe climate accounts for character.",
	"That’s why I asked you if you wrote your poetry in Italian.",
	"The temperaments at the door, Stephen interposed with, were very passionate about ten shillings.",
	"Roberto ruba roba sua.",
	"Quite so, Mr Bloom dittoed.",
	"It’s in the blood, Mr Bloom acceded at once.",
	"All are washed in the blood of the sun.",
	"The splendid proportions of hips, bosom.",
	"You simply don’t knock against those kind of women here.",
	"An exception here and there.",
	"Handsome yes, pretty in a way you find but what I’m talking about is the female form.",
	"Shipahoy of course had his own say to say.",
	"No aid was given.",
	"Her master, the Mona’s, said he was afraid his collision bulkhead would give way.",
	"She had no water, it appears, in her hold.",
	"At this stage an incident happened.",
	"It having become necessary for him to unfurl a reef the sailor vacated his seat.",
	"A hoof scooped anyway for new foothold after sleep and harness jingled.",
	"A Palgrave Murphy boat was put off the ways at Alexandra basin, the only launch that year.",
	"Right enough the harbours were there only no ships ever called.",
	"There were wrecks and wreckers, the keeper said, who was evidently au fait.",
	"Am I right, skipper?",
	"he queried of the sailor, now returning after his private potation and the rest of his exertions.",
	"O, Johnny Lever!",
	"Johnny Lever, O!",
	"Their conversation accordingly became general and all agreed that that was a fact.",
	"Where would you find anywhere the like of Irish bacon?",
	"There would be a fall and the greatest fall in history.",
	"The Germans and the Japs were going to have their little lookin, he affirmed.",
	"The Boers were the beginning of the end.",
	"Ireland, Parnell said, could not spare a single one of her sons.",
	"Silence all round marked the termination of his finale.",
	"The impervious navigator heard these lurid tidings, undismayed.",
	"Who’s the best troops in the army?",
	"the grizzled old veteran irately interrogated.",
	"And the best jumpers and racers?",
	"And the best admirals and generals we’ve got?",
	"Tell me that.",
	"The Irish, for choice, retorted the cabby like Campbell, facial blemishes apart.",
	"That’s right, the old tarpaulin corroborated.",
	"The Irish catholic peasant.",
	"He’s the backbone of our empire.",
	"You know Jem Mullins?",
	"And now, why?",
	"And as for the lessee or keeper, who probably wasn’t the other person at all, he (B.)",
	"Quite apart from that he disliked those careers of wrongdoing and crime on principle.",
	"He ought to have either died naturally or on the scaffold high.",
	"Like actresses, always farewell positively last performance then come up smiling again.",
	"So similarly he had a very shrewd suspicion that Mr Johnny Lever got rid of some £.",
	"He took umbrage at something or other, that muchinjured but on the whole eventempered person declared, I let slip.",
	"He called me a jew and in a heated fashion offensively.",
	"That was one for him.",
	"A soft answer turns away wrath.",
	"He hadn’t a word to say for himself as everyone saw.",
	"Am I not right?",
	"Of course, Mr B. proceeded to stipulate, you must look at both sides of the question.",
	"But with a little goodwill all round.",
	"It’s all very fine to boast of mutual superiority but what about mutual equality.",
	"I resent violence and intolerance in any shape or form.",
	"It never reaches anything or stops anything.",
	"A revolution must come on the due instalments plan.",
	"Memorable bloody bridge battle and seven minutes’ war, Stephen assented, between Skinner’s alley and Ormond market.",
	"Yes, Mr Bloom thoroughly agreed, entirely endorsing the remark, that was overwhelmingly right.",
	"And the whole world was full of that sort of thing.",
	"You just took the words out of my mouth, he said.",
	"They accuse, remarked he audibly.",
	"Not a vestige of truth in it, I can safely say.",
	"Why?",
	"Because they are imbued with the proper spirit.",
	"They are practical and are proved to be so.",
	"But in the economic, not touching religion, domain the priest spells poverty.",
	"Spain again, you saw in the war, compared with goahead America.",
	"Turks.",
	"It’s in the dogma.",
	"That’s the juggle on which the p.p.‘s raise the wind on false pretences.",
	"At least that’s my idea for what it’s worth.",
	"I call that patriotism.",
	"Ubi patria, as we learned a smattering of in our classical days in Alma Mater, vita bene.",
	"Where you can live well, the sense is, if you work.",
	"Count me out, he managed to remark, meaning work.",
	"The eyes were surprised at this observation because as he, the person who owned them pro tem.",
	"observed or rather his voice speaking did, all must work, have to, together.",
	"I mean, of course, the other hastened to affirm, work in the widest possible sense.",
	"Also literary labour not merely for the kudos of the thing.",
	"Writing for the newspapers which is the readiest channel nowadays.",
	"That’s work too.",
	"Important work.",
	"What?",
	"You both belong to Ireland, the brain and the brawn.",
	"Each is equally important.",
	"I would go a step farther, Mr Bloom insinuated.",
	"But I suspect, Stephen interrupted, that Ireland must be important because it belongs to me.",
	"What belongs, queried Mr Bloom bending, fancying he was perhaps under some misapprehension.",
	"Excuse me.",
	"Unfortunately, I didn’t catch the latter portion.",
	"What was it you...?",
	"Let us change the subject.",
	"The rebuke of some kind was clearer than the other part.",
	"Sheer force of natural genius, that.",
	"With brains, sir.",
	"Intellectual stimulation, as such, was, he felt, from time to time a firstrate tonic for the mind.",
	"coalminers, divers, scavengers etc., were very much under the microscope lately.",
	"My Experiences, let us say, in a Cabman’s Shelter.",
	"Great battle, Tokio.",
	"Lovemaking in Irish, £ 200 damages.",
	"Gordon Bennett.",
	"Emigration Swindle.",
	"Letter from His Grace.",
	"William &#10016;.",
	"Ascot meeting, the Gold Cup.",
	"Victory of outsider Throwaway recalls Derby of ‘92 when Capt.",
	"Marshall’s dark horse Sir Hugo captured the blue ribband at long odds.",
	"New York disaster.",
	"Thousand lives lost.",
	"Foot and Mouth.",
	"Funeral of the late Mr Patrick Dignam.",
	"Or a change of address anyway.",
	"The mourners included: Patk.",
	"Dignam (son), Bernard Corrigan (brother-in-law), Jno.",
	"A., Edw.",
	"J. Lambert, Cornelius T. Kelleher, Joseph M’C Hynes, L. Boom, CP M’Coy,—M’Intosh and several others.",
	"A. engaged in stifling another yawn, half nervousness, not forgetting the usual crop of nonsensical howlers of misprints.",
	"Is that first epistle to the Hebrews, he asked as soon as his bottom jaw would let him, in?",
	"Text: open thy mouth and put thy foot in it.",
	"It is.",
	"There.",
	"Value 1000 sovs with 3000 sovs in specie added.",
	"For entire colts and fillies.",
	"Mr F. Alexander’s Throwaway, b. h. by Rightaway-Thrale, 5 yrs, 9 st 4 lbs (W. Lane) 1.",
	"Lord Howard de Walden’s Zinfandel (M. Cannon) 2.",
	"Mr W. Bass’s Sceptre 3.",
	"Betting 5 to 4 on Zinfandel, 20 to 1 Throwaway (off).",
	"Sceptre a shade heavier.",
	"Throwaway and Zinfandel stood close.",
	"Winner trained by Braime so that Lenehan’s version of the business was all pure buncombe.",
	"Secured the verdict cleverly by a length.",
	"1000 sovs with 3000 in specie.",
	"Different ways of bringing off a coup.",
	"Lovemaking damages.",
	"Though that halfbaked Lyons ran off at a tangent in his impetuosity to get left.",
	"Guesswork it reduced itself to eventually.",
	"There was every indication they would arrive at that, he, Bloom, said.",
	"Who?",
	"the other, whose hand by the way was hurt, said.",
	"One morning you would open the paper, the cabman affirmed, and read: Return of Parnell.",
	"He bet them what they liked.",
	"A Dublin fusilier was in that shelter one night and said he saw him in South Africa.",
	"Pride it was killed him.",
	"Dead he wasn’t.",
	"Simply absconded somewhere.",
	"The coffin they brought over was full of stones.",
	"He changed his name to De Wet, the Boer general.",
	"He made a mistake to fight the priests.",
	"And so forth and so on.",
	"Something evidently riled them in his death.",
	"And the identical same with murderers.",
	"You had to come back.",
	"That haunting sense kind of drew you.",
	"To show the understudy in the title rôle how to.",
	"Still as regards return.",
	"You were a lucky dog if they didn’t set the terrier at you directly you got back.",
	"Then a lot of shillyshally usually followed, Tom for and Dick and Harry against.",
	"That bitch, that English whore, did for him, the shebeen proprietor commented.",
	"She put the first nail in his coffin.",
	"Fine lump of a woman all the same, the soi-disant townclerk Henry Campbell remarked, and plenty of her.",
	"She loosened many a man’s thighs.",
	"I seen her picture in a barber’s.",
	"The husband was a captain or an officer.",
	"Ay, Skin-the-Goat amusingly added, he was and a cottonball one.",
	"This gratuitous contribution of a humorous character occasioned a fair amount of laughter among his entourage.",
	"The eternal question of the life connubial, needless to say, cropped up.",
	"Can real love, supposing there happens to be another chap in the case, exist between married folk?",
	"Poser.",
	"Looking back now in a retrospective kind of arrangement all seemed a kind of dream.",
	"Just bears out what I was saying, he, with glowing bosom said to Stephen, about blood and the sun.",
	"And, if I don’t greatly mistake she was Spanish too.",
	"Was she?",
	"Bloom ejaculated, surprised though not astonished by any means, I never heard that rumour before.",
	"Possible, especially there, it was as she lived there.",
	"So, Spain.",
	"Mrs Bloom, my wife the prima donna Madam Marion Tweedy, Bloom indicated.",
	"Taken a few years since.",
	"In or about ninety six.",
	"Very like her then.",
	"Marble could give the original, shoulders, back, all the symmetry, all the rest.",
	"Yes, puritanisme, it does though, Saint Joseph’s sovereign thievery alors (Bandez!)",
	"Figne toi trop.",
	"Whereas no photo could because it simply wasn’t art in a word.",
	"But it was scarcely professional etiquette so.",
	"Suppose she was gone when he?",
	"And why not?",
	"At what o’clock did you dine?",
	"he questioned of the slim form and tired though unwrinkled face.",
	"Some time yesterday, Stephen said.",
	"Yesterday!",
	"exclaimed Bloom till he remembered it was already tomorrow Friday.",
	"Ah, you mean it’s after twelve!",
	"The day before yesterday, Stephen said, improving on himself.",
	"Literally astounded at this piece of intelligence Bloom reflected.",
	"His initial impression was he was a shade standoffish or not over effusive but it grew on him someway.",
	"The most vulnerable point too of tender Achilles.",
	"Your god was a jew.",
	"Because mostly they appeared to imagine he came from Carrick-on-Shannon or somewhereabouts in the county Sligo.",
	"My diggings are quite close in the vicinity.",
	"You can’t drink that stuff.",
	"Do you like cocoa?",
	"Wait.",
	"I’ll just pay this lot.",
	"An opening was all was wanted.",
	"Silence with a yawn or two accompanied this thrilling announcement.",
	"To which absorbing piece of intelligence echo answered why.",
	"Give us a squint at that literature, grandfather, the ancient mariner put in, manifesting some natural impatience.",
	"And welcome, answered the elderly party thus addressed.",
	"Are you bad in the eyes?",
	"the sympathetic personage like the townclerk queried.",
	"Sand in the Red Sea done that.",
	"One time I could read a book in the dark, manner of speaking.",
	"The Arabian Nights Entertainment was my favourite and Red as a Rose is She.",
	"Come, he counselled to close the séance.",
	"Stephen, who confessed to still feeling poorly and fagged out, paused at the, for a moment, the door.",
	"One thing I never understood, he said to be original on the spur of the moment.",
	"Why they put tables upside down at night, I mean chairs upside down, on the tables in cafés.",
	"The night air was certainly now a treat to breathe though Stephen was a bit weak on his pins.",
	"It will (the air) do you good, Bloom said, meaning also the walk, in a moment.",
	"The only thing is to walk then you’ll feel a different man.",
	"Come.",
	"It’s not far.",
	"Lean on me.",
	"Accordingly he passed his left arm in Stephen’s right and led him on accordingly.",
	"Anyhow they passed the sentrybox with stones, brazier etc.",
	"Beware of the steamroller.",
	"They thereupon stopped.",
	"He was just a big nervous foolish noodly kind of a horse, without a second care in the world.",
	"Nine tenths of them all could be caged or trained, nothing beyond the art of man barring the bees.",
	"What’s this I was saying?",
	"Ah, yes!",
	"These opening bars he sang and translated extempore.",
	"Bloom, nodding, said he perfectly understood and begged him to go on by all means which he did.",
	"A.",
	"The horse was just then.",
	"Slowly three times, one after another, from a full crupper he mired.",
	"And humanely his driver waited till he (or she) had ended, patient in his scythed car.",
	"Und alle Schiffe brücken.",
	"[ 17 ] What parallel courses did Bloom and Stephen follow returning?",
	"Of what did the duumvirate deliberate during their itinerary?",
	"Did Bloom discover common factors of similarity between their respective like and unlike reactions to experience?",
	"Both were sensitive to artistic impressions, musical in preference to plastic or pictorial.",
	"Both preferred a continental to an insular manner of life, a cisatlantic to a transatlantic place of residence.",
	"Both admitted the alternately stimulating and obtunding influence of heterosexual magnetism.",
	"Were their views on some points divergent?",
	"Was there one point on which their views were equal and negative?",
	"The influence of gaslight or electric light on the growth of adjoining paraheliotropic trees.",
	"Had Bloom discussed similar subjects during nocturnal perambulations in the past?",
	"As in what ways?",
	"What act did Bloom make on their arrival at their destination?",
	"Was it there?",
	"It was in the corresponding pocket of the trousers which he had worn on the day but one preceding.",
	"Why was he doubly irritated?",
	"Because he had forgotten and because he remembered that he had reminded himself twice not to forget.",
	"What were then the alternatives before the, premeditatedly (respectively) and inadvertently, keyless couple?",
	"To enter or not to enter.",
	"To knock or not to knock.",
	"Bloom’s decision?",
	"A stratagem.",
	"Did he fall?",
	"Did he rise uninjured by concussion?",
	"What discrete succession of images did Stephen meanwhile perceive?",
	"Did the man reappear elsewhere?",
	"The halldoor turned gradually on its hinges.",
	"In the open space of the doorway the man reappeared without his hat, with his candle.",
	"Did Stephen obey his sign?",
	"What did Bloom do?",
	"Of what similar apparitions did Stephen think?",
	"What did Bloom see on the range?",
	"On the right (smaller) hob a blue enamelled saucepan: on the left (larger) hob a black iron kettle.",
	"What did Bloom do at the range?",
	"Did it flow?",
	"Yes.",
	"What in water did Bloom, waterlover, drawer of water, watercarrier, returning to the range, admire?",
	"Having set the halffilled kettle on the now burning coals, why did he return to the stillflowing tap?",
	"What reason did Stephen give for declining Bloom’s offer?",
	"The incompatibility of aquacity with the erratic originality of genius.",
	"What additional didactic counsels did he similarly repress?",
	"Which seemed to the host to be the predominant qualities of his guest?",
	"Confidence in himself, an equal and opposite power of abandonment and recuperation.",
	"What concomitant phenomenon took place in the vessel of liquid by the agency of fire?",
	"The phenomenon of ebullition.",
	"What announced the accomplishment of this rise in temperature?",
	"A double falciform ejection of water vapour from under the kettlelid at both sides simultaneously.",
	"For what personal purpose could Bloom have applied the water so boiled?",
	"To shave himself.",
	"What advantages attended shaving by night?",
	"Why did absence of light disturb him less than presence of noise?",
	"Because of the surety of the sense of touch in his firm full masculine feminine passive active hand.",
	"What quality did it (his hand) possess but with what counteracting influence?",
	"What lay under exposure on the lower, middle and upper shelves of the kitchen dresser, opened by Bloom?",
	"On the upper shelf a battery of jamjars (empty) of various sizes and proveniences.",
	"What attracted his attention lying on the apron of the dresser?",
	"Four polygonal fragments of two lacerated scarlet betting tickets, numbered 8 87, 88 6.",
	"What reminiscences temporarily corrugated his brow?",
	"Where had previous intimations of the result, effected or projected, been received by him?",
	"What qualifying considerations allayed his perturbations?",
	"His mood?",
	"He had not risked, he did not expect, he had not been disappointed, he was satisfied.",
	"What satisfied him?",
	"To have sustained no positive loss.",
	"To have brought a positive gain to others.",
	"Light to the gentiles.",
	"How did Bloom prepare a collation for a gentile?",
	"What supererogatory marks of special hospitality did the host show his guest?",
	"Was the guest conscious of and did he acknowledge these marks of hospitality?",
	"Who drank more quickly?",
	"What cerebration accompanied his frequentative act?",
	"Had he found their solution?",
	"An ambition to squint At my verses in print Makes me hope that for these you’ll find room.",
	"If you so condescend?",
	"Then please place at the end The name of yours truly, L. Bloom.",
	"Did he find four separating forces between his temporary guest and him?",
	"Name, age, race, creed.",
	"What anagrams had he made on his name in youth?",
	"Poets oft have sung in rhyme Of music sweet their praise divine.",
	"Let them hymn it nine times nine.",
	"Dearer far than song or wine.",
	"You are mine.",
	"The world is mine.",
	"What relation existed between their ages?",
	"16 years before in 1888 when Bloom was of Stephen’s present age Stephen was 6.",
	"16 years after in 1920 when Stephen would be of Bloom’s present age Bloom would be 54.",
	"What events might nullify these calculations?",
	"How many previous encounters proved their preexisting acquaintance?",
	"Two.",
	"Did Bloom accept the invitation to dinner given then by the son and afterwards seconded by the father?",
	"Very gratefully, with grateful appreciation, with sincere appreciative gratitude, in appreciatively grateful sincerity of regret, he declined.",
	"Did their conversation on the subject of these reminiscences reveal a third connecting link between them?",
	"Had he performed any special corporal work of mercy for her?",
	"Why could he then support that his vigil with the greater equanimity?",
	"What distinct different memories had each of her now eight years deceased?",
	"Had any special agility been his in earlier youth?",
	"Did either openly allude to their racial difference?",
	"Neither.",
	"What, the enclosures of reticence removed, were their respective parentages?",
	"Had Bloom and Stephen been baptised, and where and by whom, cleric or layman?",
	"Stephen (once) by the reverend Charles Malone C. C., alone, in the church of the Three Patrons, Rathgar.",
	"Did they find their educational careers similar?",
	"Substituting Stephen for Bloom Stoom would have passed successively through a dame’s school and the high school.",
	"Why did Bloom refrain from stating that he had frequented the university of life?",
	"What two temperaments did they individually represent?",
	"The scientific.",
	"The artistic.",
	"What proofs did Bloom adduce to prove that his tendency was towards applied, rather than towards pure, science?",
	"Were these inventions principally intended for an improved scheme of kindergarten?",
	"Yes, rendering obsolete popguns, elastic airbladders, games of hazard, catapults.",
	"What also stimulated him in his cogitations?",
	"Such as?",
	"K. 11.",
	"Kino’s 11/- Trousers.",
	"House of Keys.",
	"Alexander J. Keyes.",
	"Such as not?",
	"Look at this long candle.",
	"Address: Barclay and Cook, 18 Talbot street.",
	"Bacilikil (Insect Powder).",
	"Veribest (Boot Blacking).",
	"Uwantit (Combined pocket twoblade penknife with corkscrew, nailfile and pipecleaner).",
	"Such as never?",
	"What is home without Plumtree’s Potted Meat?",
	"Incomplete.",
	"With it an abode of bliss.",
	"The name on the label is Plumtree.",
	"A plumtree in a meatpot, registered trade mark.",
	"Beware of imitations.",
	"Peatmot.",
	"Trumplee.",
	"Moutpat.",
	"Plamtroo.",
	"What suggested scene was then constructed by Stephen?",
	"Solitary hotel in mountain pass.",
	"Autumn.",
	"Twilight.",
	"Fire lit.",
	"In dark corner young man seated.",
	"Young woman enters.",
	"Restless.",
	"Solitary.",
	"She sits.",
	"She goes to window.",
	"She stands.",
	"She sits.",
	"Twilight.",
	"She thinks.",
	"On solitary hotel paper she writes.",
	"She thinks.",
	"She writes.",
	"She sighs.",
	"Wheels and hoofs.",
	"She hurries out.",
	"He comes from his dark corner.",
	"He seizes solitary paper.",
	"He holds it towards fire.",
	"Twilight.",
	"He reads.",
	"Solitary.",
	"What?",
	"In sloping, upright and backhands: Queen’s Hotel, Queen’s Hotel, Queen’s Hotel.",
	"Queen’s Ho... What suggested scene was then reconstructed by Bloom?",
	"Did he attribute this homonymity to information or coincidence or intuition?",
	"Coincidence.",
	"Did he depict the scene verbally for his guest to see?",
	"Which domestic problem as much as, if not more than, any other frequently engaged his mind?",
	"What to do with our wives.",
	"What had been his hypothetical singular solutions?",
	"What instances of deficient mental development in his wife inclined him in favour of the lastmentioned (ninth) solution?",
	"She understood little of political complications, internal, or balance of power, external.",
	"In calculating the addenda of bills she frequently had recourse to digital aid.",
	"The false apparent parallelism of all perpendicular arms of all balances, proved true by construction.",
	"The counterbalance of her proficiency of judgment regarding one person, proved true by experiment.",
	"How had he attempted to remedy this state of comparative ignorance?",
	"Variously.",
	"With what success had he attempted direct instruction?",
	"What system had proved more effective?",
	"Indirect suggestion implicating selfinterest.",
	"Example?",
	"Accepting the analogy implied in his guest’s parable which examples of postexilic eminence did he adduce?",
	"That the seeker mentioned had been a pupil of a rabbinical philosopher, name uncertain.",
	"Were other anapocryphal illustrious sons of the law and children of a selected or rejected race mentioned?",
	"Felix Bartholdy Mendelssohn (composer), Baruch Spinoza (philosopher), Mendoza (pugilist), Ferdinand Lassalle (reformer, duellist).",
	"By Bloom: Kifeloch, harimon rakatejch m’baad l’zamatejch (thy temple amid thy hair is as a slice of pomegranate).",
	"How was a glyphic comparison of the phonic symbols of both languages made in substantiation of the oral comparison?",
	"By juxtaposition.",
	"Was the knowledge possessed by both of each of these languages, the extinct and the revived, theoretical or practical?",
	"Theoretical, being confined to certain grammatical rules of accidence and syntax and practically excluding vocabulary.",
	"What points of contact existed between these languages and between the peoples who spoke them?",
	"What anthem did Bloom chant partially in anticipation of that multiple, ethnically irreducible consummation?",
	"Kolod balejwaw pnimah Nefesch, jehudi, homijah.",
	"Why was the chant arrested at the conclusion of this first distich?",
	"In consequence of defective mnemotechnic.",
	"How did the chanter compensate for this deficiency?",
	"By a periphrastic version of the general text.",
	"In what common study did their mutual reflections merge?",
	"Did the guest comply with his host’s request?",
	"Doubly, by appending his signature in Irish and Roman characters.",
	"What was Stephen’s auditive sensation?",
	"He heard in a profound ancient male unfamiliar melody the accumulation of the past.",
	"What was Bloom’s visual sensation?",
	"He saw in a quick young male familiar form the predestination of a future.",
	"What were Stephen’s and Bloom’s quasisimultaneous volitional quasisensations of concealed identities?",
	"Auditively, Bloom’s: The traditional accent of the ecstasy of catastrophe.",
	"What future careers had been possible for Bloom in the past and with what exemplars?",
	"Did the host encourage his guest to chant in a modulated voice a strange legend on an allied theme?",
	"Recite the first (major) part of this chanted legend.",
	"Little Harry Hughes and his schoolfellows all Went out for to play ball.",
	"And the very first ball little Harry Hughes played He drove it o’er the jew’s garden wall.",
	"And the very second ball little Harry Hughes played He broke the jew’s windows all.",
	"How did the son of Rudolph receive this first part?",
	"With unmixed feeling.",
	"Smiling, a jew, he heard with pleasure and saw the unbroken kitchen window.",
	"Recite the second part (minor) of the legend.",
	"Then out there came the jew’s daughter And she all dressed in green.",
	"She took a penknife out of her pocket And cut off his little head.",
	"And now he’ll play his ball no more For he lies among the dead.",
	"How did the father of Millicent receive this second part?",
	"With mixed feelings.",
	"Unsmiling, he heard and saw with wonder a jew’s daughter, all dressed in green.",
	"Condense Stephen’s commentary.",
	"One of all, the least of all, is the victim predestined.",
	"Once by inadvertence twice by design he challenges his destiny.",
	"It leads him to a strange habitation, to a secret infidel apartment, and there, implacable, immolates him, consenting.",
	"Why was the host (victim predestined) sad?",
	"Why was the host (reluctant, unresisting) still?",
	"In accordance with the law of the conservation of energy.",
	"Why was the host (secret infidel) silent?",
	"From which (if any) of these mental or physical disorders was he not totally immune?",
	"Had this latter or any cognate phenomenon declared itself in any member of his family?",
	"What other infantile memories had he of her?",
	"15 June 1889.",
	"A querulous newborn female infant crying to cause and lessen congestion.",
	"What endemic characteristics were present?",
	"What memories had he of her adolescence?",
	"She relegated her hoop and skippingrope to a recess.",
	"Did that first division, portending a second division, afflict him?",
	"Less than he had imagined, more than he had hoped.",
	"What second departure was contemporaneously perceived by him similarly, if differently?",
	"A temporary departure of his cat.",
	"Why similarly, why differently?",
	"Differently, because of different possible returns to the inhabitants or to the habitation.",
	"In other respects were their differences similar?",
	"In passivity, in economy, in the instinct of tradition, in unexpectedness.",
	"As?",
	"Inasmuch as leaning she sustained her blond hair for him to ribbon it for her (cf neckarching cat).",
	"Hence, in passivity, in economy, in the instinct of tradition, in unexpectedness, their differences were similar.",
	"In what manners did she reciprocate?",
	"What proposal did Bloom, diambulist, father of Milly, somnambulist, make to Stephen, noctambulist?",
	"What various advantages would or might have resulted from a prolongation of such an extemporisation?",
	"For the guest: security of domicile and seclusion of study.",
	"For the host: rejuvenation of intelligence, vicarious satisfaction.",
	"For the hostess: disintegration of obsession, acquisition of correct Italian pronunciation.",
	"Because the way to daughter led through mother, the way to mother through daughter.",
	"To what inconsequent polysyllabic question of his host did the guest return a monosyllabic negative answer?",
	"If he had known the late Mrs Emily Sinico, accidentally killed at Sydney Parade railway station, 14 October 1903.",
	"What inchoate corollary statement was consequently suppressed by the host?",
	"Was the proposal of asylum accepted?",
	"Promptly, inexplicably, with amicability, gratefully it was declined.",
	"What exchange of money took place between host and guest?",
	"What counterproposals were alternately advanced, accepted, modified, declined, restated in other terms, reaccepted, ratified, reconfirmed?",
	"To inaugurate a prearranged course of Italian instruction, place the residence of the instructed.",
	"To inaugurate a course of vocal instruction, place the residence of the instructress.",
	"What rendered problematic for Bloom the realisation of these mutually selfexcluding propositions?",
	"Was the clown Bloom’s son?",
	"No.",
	"Had Bloom’s coin returned?",
	"Never.",
	"Why would a recurrent frustration the more depress him?",
	"He believed then that human life was infinitely perfectible, eliminating these conditions?",
	"Why did he desist from speculation?",
	"Did Stephen participate in his dejection?",
	"Was this affirmation apprehended by Bloom?",
	"Not verbally.",
	"Substantially.",
	"What comforted his misapprehension?",
	"The 113th, modus peregrinus: In exitu Israël de Egypto: domus Jacob de populo barbaro.",
	"What did each do at the door of egress?",
	"Bloom set the candlestick on the floor.",
	"Stephen put the hat on his head.",
	"For what creature was the door of egress a door of ingress?",
	"For a cat.",
	"The heaventree of stars hung with humid nightblue fruit.",
	"With what meditations did Bloom accompany his demonstration to his companion of various constellations?",
	"Were there obverse meditations of involution increasingly less vast?",
	"Why did he not elaborate these calculations to a more precise result?",
	"Of a different order of difficulty.",
	"And the problem of possible redemption?",
	"The minor was proved by the major.",
	"Which various features of the constellations were in turn considered?",
	"His (Bloom’s) logical conclusion, having weighed the matter and allowing for possible error?",
	"That it was not a heaventree, not a heavengrot, not a heavenbeast, not a heavenman.",
	"Was he more convinced of the esthetic value of the spectacle?",
	"Did he then accept as an article of belief the theory of astrological influences upon sublunary disasters?",
	"What special affinities appeared to him to exist between the moon and woman?",
	"What visible luminous sign attracted Bloom’s, who attracted Stephen’s, gaze?",
	"With indirect and direct verbal allusions or affirmations: with subdued affection and admiration: with description: with impediment: with suggestion.",
	"Both then were silent?",
	"Silent, each contemplating the other in both mirrors of the reciprocal flesh of theirhisnothis fellowfaces.",
	"Were they indefinitely inactive?",
	"Similarly?",
	"What different problems presented themselves to each concerning the invisible audible collateral organ of the other?",
	"To Bloom: the problems of irritability, tumescence, rigidity, reactivity, dimension, sanitariness, pilosity.",
	"What celestial sign was by both simultaneously observed?",
	"How did the centripetal remainer afford egress to the centrifugal departer?",
	"How did they take leave, one of the other, in separation?",
	"What sound accompanied the union of their tangent, the disunion of their (respectively) centrifugal and centripetal hands?",
	"What echoes of that sound were by both and each heard?",
	"By Stephen: Liliata rutilantium.",
	"Turma circumdet.",
	"Iubilantium te virginum.",
	"Chorus excipiat.",
	"By Bloom: Heigho, heigho, Heigho, heigho.",
	"Alone, what did Bloom hear?",
	"Alone, what did Bloom feel?",
	"Of what did bellchime and handtouch and footstep and lonechill remind him?",
	"What prospect of what phenomena inclined him to remain?",
	"The disparition of three final stars, the diffusion of daybreak, the apparition of a new solar disk.",
	"Had he ever been a spectator of those phenomena?",
	"He remembered the initial paraphenomena?",
	"Did he remain?",
	"With deep inspiration he returned, retraversing the garden, reentering the passage, reclosing the door.",
	"What suddenly arrested his ingress?",
	"Describe the alterations effected in the disposition of the articles of furniture.",
	"Describe them.",
	"What significances attached to these two chairs?",
	"Significances of similitude, of posture, of symbolism, of circumstantial evidence, of testimonial supermanence.",
	"What occupied the position originally occupied by the sideboard?",
	"With what sensations did Bloom contemplate in rotation these objects?",
	"His next proceeding?",
	"What followed this operation?",
	"What homothetic objects, other than the candlestick, stood on the mantelpiece?",
	"What interchanges of looks took place between these three objects and Bloom?",
	"What composite asymmetrical image in the mirror then attracted his attention?",
	"The image of a solitary (ipsorelative) mutable (aliorelative) man.",
	"Why solitary (ipsorelative)?",
	"Brothers and sisters had he none.",
	"Yet that man’s father was his grandfather’s son.",
	"Why mutable (aliorelative)?",
	"From infancy to maturity he had resembled his maternal procreatrix.",
	"From maturity to senility he would increasingly resemble his paternal procreator.",
	"What final visual impression was communicated to him by the mirror?",
	"Catalogue these books.",
	"Thom’s Dublin Post Office Directory, 1886.",
	"Denis Florence M’Carthy’s Poetical Works (copper beechleaf bookmark at p. 5).",
	"Shakespeare’s Works (dark crimson morocco, goldtooled).",
	"The Useful Ready Reckoner (brown cloth).",
	"The Secret History of the Court of Charles II (red cloth, tooled binding).",
	"The Child’s Guide (blue cloth).",
	"The Beauties of Killarney (wrappers).",
	"When We Were Boys by William O’Brien M. P. (green cloth, slightly faded, envelope bookmark at p. 217).",
	"Thoughts from Spinoza (maroon leather).",
	"The Story of the Heavens by Sir Robert Ball (blue cloth).",
	"Ellis’s Three Trips to Madagascar (brown cloth, title obliterated).",
	"Voyages in China by “Viator” (recovered with brown paper, red ink title).",
	"Philosophy of the Talmud (sewn pamphlet).",
	"Lockhart’s Life of Napoleon (cover wanting, marginal annotations, minimising victories, aggrandising defeats of the protagonist).",
	"Soll und Haben by Gustav Freytag (black boards, Gothic characters, cigarette coupon bookmark at p. 24).",
	"The Hidden Life of Christ (black boards).",
	"In the Track of the Sun (yellow cloth, titlepage missing, recurrent title intestation).",
	"Physical Strength and How to Obtain It by Eugen Sandow (red cloth).",
	"Short but yet Plain Elements of Geometry written in French by F. Ignat.",
	"What reflections occupied his mind during the process of reversion of the inverted volumes?",
	"Which volume was the largest in bulk?",
	"Hozier’s History of the Russo-Turkish War.",
	"What among other data did the second volume of the work in question contain?",
	"The name of a decisive battle (forgotten), frequently remembered by a decisive officer, major Brian Cooper Tweedy (remembered).",
	"Why, firstly and secondly, did he not consult the work in question?",
	"What caused him consolation in his sitting posture?",
	"What caused him irritation in his sitting posture?",
	"How was the irritation allayed?",
	"He unbraced successively each of six minus one braced trouser buttons, arranged in pairs, of which one incomplete.",
	"What involuntary actions followed?",
	"Compile the budget for 16 June 1904.",
	"Debit £.",
	"s. d. Cash in hand 0—4—9 Commission recd.",
	"Freeman’s Journal 1—7—6 Loan (Stephen Dedalus) 1—7—0 ————— 2—19—3 Did the process of divestiture continue?",
	"Why with satisfaction?",
	"In what ultimate ambition had all concurrent and consecutive ambitions now coalesced?",
	"What additional attractions might the grounds contain?",
	"As?",
	"What improvements might be subsequently introduced?",
	"What facilities of transit were desirable?",
	"When citybound frequent connection by train or tram from their respective intermediate station or terminal.",
	"What might be the name of this erigible or erected residence?",
	"Bloom Cottage.",
	"Saint Leopold’s.",
	"Flowerville.",
	"Could Bloom of 7 Eccles street foresee Bloom of Flowerville?",
	"What syllabus of intellectual pursuits was simultaneously possible?",
	"Snapshot photography, comparative study of religions, folklore relative to various amatory and superstitious practices, contemplation of the celestial constellations.",
	"What lighter recreations?",
	"Might he become a gentleman farmer of field produce and live stock?",
	"What would be his civic functions and social status among the county families and landed gentry?",
	"What course of action did he outline for himself in such capacity?",
	"Prove that he had loved rectitude from his earliest youth.",
	"B.)",
	"How much and how did he propose to pay for this country residence?",
	"What rapid but insecure means to opulence might facilitate immediate purchase?",
	"A prepared scheme based on a study of the laws of probability to break the bank at Monte Carlo.",
	"A solution of the secular problem of the quadrature of the circle, government premium £ 1,000,000 sterling.",
	"Was vast wealth acquirable through industrial channels?",
	"Were there schemes of wider scope?",
	"A scheme for the use of dogvans and goatvans for the delivery of early morning milk.",
	"A scheme for the repristination of passenger and goods traffics over Irish waterways, when freed from weedbeds.",
	"Positing what protasis would the contraction for such several schemes become a natural and necessary apodosis?",
	"What eventuality would render him independent of such wealth?",
	"His justifications?",
	"As a physicist he had learned that of the 70 years of complete human life at least 2/7, viz.",
	"20 years are passed in sleep.",
	"As a physiologist he believed in the artificial placation of malignant agencies chiefly operative during somnolence.",
	"What did he fear?",
	"What were habitually his final meditations?",
	"What did the first drawer unlocked contain?",
	"P. O. Westland Row, addresser, Martha Clifford, c/o.",
	"UU.",
	"OX/W.",
	"OKS.",
	"MH/Y.",
	"Quote the textual terms in which the prospectus claimed advantages for this thaumaturgic remedy.",
	"Recommend it to your lady and gentlemen friends, lasts a lifetime.",
	"Insert long round end.",
	"Wonderworker.",
	"Were there testimonials?",
	"Numerous.",
	"From clergyman, British naval officer, wellknown author, city man, hospital nurse, lady, mother of five, absentminded beggar.",
	"How did absentminded beggar’s concluding testimonial conclude?",
	"What a pity the government did not supply our men with wonderworkers during the South African campaign!",
	"What a relief it would have been!",
	"What object did Bloom add to this collection of objects?",
	"A 4th typewritten letter received by Henry Flower (let H. F. be L.",
	"B.)",
	"from Martha Clifford (find M. C.).",
	"What pleasant reflection accompanied this action?",
	"What possibility suggested itself?",
	"What did the 2nd drawer contain?",
	"Quote the textual terms of this notice.",
	"What other objects relative to Rudolph Bloom (born Virag) were in the 2nd drawer?",
	"What fractions of phrases did the lecture of those five whole words evoke?",
	"Why did Bloom experience a sentiment of remorse?",
	"Because in immature impatience he had treated with disrespect certain beliefs and practices.",
	"As?",
	"How did these beliefs and practices now appear to him?",
	"Not more rational than they had then appeared, not less rational than other beliefs and practices now appeared.",
	"What first reminiscence had he of Rudolph Bloom (deceased)?",
	"Had time equally but differently obliterated the memory of these migrations in narrator and listener?",
	"What idiosyncracies of the narrator were concomitant products of amnesia?",
	"Occasionally he ate without having previously removed his hat.",
	"Occasionally he drank voraciously the juice of gooseberry fool from an inclined plate.",
	"What two phenomena of senescence were more frequent?",
	"The myopic digital calculation of coins, eructation consequent upon repletion.",
	"What object offered partial consolation for these reminiscences?",
	"The endowment policy, the bank passbook, the certificate of the possession of scrip.",
	"Nadir of misery: the aged impotent disfranchised ratesupported moribund lunatic pauper.",
	"With which attendant indignities?",
	"By what could such a situation be precluded?",
	"By decease (change of state): by departure (change of place).",
	"Which preferably?",
	"The latter, by the line of least resistance.",
	"What considerations rendered departure not entirely undesirable?",
	"Constant cohabitation impeding mutual toleration of personal defects.",
	"The habit of independent purchase increasingly cultivated.",
	"The necessity to counteract by impermanent sojourn the permanence of arrest.",
	"What considerations rendered departure not irrational?",
	"What considerations rendered departure desirable?",
	"In Ireland?",
	"Abroad?",
	"Under what guidance, following what signs?",
	"What public advertisement would divulge the occultation of the departed?",
	"Above sum will be paid for information leading to his discovery.",
	"What universal binomial denominations would be his as entity and nonentity?",
	"Assumed by any or known to none.",
	"Everyman or Noman.",
	"What tributes his?",
	"Honour and gifts of strangers, the friends of Everyman.",
	"A nymph immortal, beauty, the bride of Noman.",
	"Would the departed never nowhere nohow reappear?",
	"Somewhere imperceptibly he would hear and somehow reluctantly, suncompelled, obey the summons of recall.",
	"What would render such return irrational?",
	"What play of forces, inducing inertia, rendered departure undesirable?",
	"What advantages were possessed by an occupied, as distinct from an unoccupied bed?",
	"What past consecutive causes, before rising preapprehended, of accumulated fatigue did Bloom, before rising, silently recapitulate?",
	"What selfinvolved enigma did Bloom risen, going, gathering multicoloured multiform multitudinous garments, voluntarily apprehending, not comprehend?",
	"Who was M’Intosh?",
	"Where was Moses when the candle went out?",
	"What impression of an absent face did Bloom, arrested, silently recall?",
	"What recurrent impressions of the same were possible by hypothesis?",
	"What miscellaneous effects of female personal wearing apparel were perceived by him?",
	"What impersonal objects were perceived?",
	"Bloom’s acts?",
	"How?",
	"What did his limbs, when gradually extended, encounter?",
	"If he had smiled why would he have smiled?",
	"What preceding series?",
	"What were his reflections concerning the last member of this series and late occupant of the bed?",
	"Reflections on his vigour (a bounder), corporal proportion (a billsticker), commercial ability (a bester), impressionability (a boaster).",
	"Why for the observer impressionability in addition to vigour, corporal proportion and commercial ability?",
	"With what antagonistic sentiments were his subsequent reflections affected?",
	"Envy, jealousy, abnegation, equanimity.",
	"Envy?",
	"Jealousy?",
	"Because a nature full and volatile in its free state, was alternately the agent and reagent of attraction.",
	"Because the controlled contemplation of the fluctuation of attraction produced, if desired, a fluctuation of pleasure.",
	"Abnegation?",
	"Equanimity?",
	"As more than inevitable, irreparable.",
	"Why more abnegation than jealousy, less envy than equanimity?",
	"What retribution, if any?",
	"Assassination, never, as two wrongs did not make one right.",
	"Duel by combat, no.",
	"Divorce, not now.",
	"Exposure by mechanical artifice (automatic bed) or individual testimony (concealed ocular witnesses), not yet.",
	"Suit for damages by legal influence or simulation of assault with evidence of injuries sustained (selfinflicted), not impossibly.",
	"Hushmoney by moral influence, possibly.",
	"By what reflections did he, a conscious reactor against the void of incertitude, justify to himself his sentiments?",
	"In what final satisfaction did these antagonistic sentiments and reflections, reduced to their simplest forms, converge?",
	"The visible signs of antesatisfaction?",
	"An approximate erection: a solicitous adversion: a gradual elevation: a tentative revelation: a silent contemplation.",
	"Then?",
	"The visible signs of postsatisfaction?",
	"A silent contemplation: a tentative velation: a gradual abasement: a solicitous aversion: a proximate erection.",
	"What followed this silent action?",
	"Somnolent invocation, less somnolent recognition, incipient excitation, catechetical interrogation.",
	"With what modifications did the narrator reply to this interrogation?",
	"Was the narration otherwise unaltered by modifications?",
	"Absolutely.",
	"Which event or person emerged as the salient point of his narration?",
	"Stephen Dedalus, professor and author.",
	"How?",
	"What moved visibly above the listener’s and the narrator’s invisible thoughts?",
	"In what directions did listener and narrator lie?",
	"In what state of rest or motion?",
	"At rest relatively to themselves and to each other.",
	"In what posture?",
	"Womb?",
	"Weary?",
	"He rests.",
	"He has travelled.",
	"With?",
	"When?",
	"Where?",
	"Trieste-Zurich-Paris 1914-1921"
];


//////////////////
// WEBPACK FOOTER
// ./src/ulysses.json
// module id = 99
// module chunks = 0